(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('focus-within-polyfill'), require('react-dom')) :
	typeof define === 'function' && define.amd ? define(['exports', 'react', 'focus-within-polyfill', 'react-dom'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['@gaiads/telia-react-component-library'] = {}, global.React, null, global.ReactDOM));
}(this, (function (exports, React, focusWithinPolyfill, ReactDOM) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
	var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function getAugmentedNamespace(n) {
		if (n.__esModule) return n;
		var a = Object.defineProperty({}, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	function createCommonjsModule(fn) {
	  var module = { exports: {} };
		return fn(module, module.exports), module.exports;
	}

	function commonjsRequire (target) {
		throw new Error('Could not dynamically require "' + target + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
	}

	var check = function (it) {
	  return it && it.Math == Math && it;
	}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


	var global$1 = // eslint-disable-next-line es/no-global-this -- safe
	check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
	check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
	function () {
	  return this;
	}() || Function('return this')();

	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var bind = FunctionPrototype.bind;
	var call = FunctionPrototype.call; // eslint-disable-next-line es/no-reflect -- safe

	var functionApply = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});

	var FunctionPrototype$1 = Function.prototype;
	var bind$1 = FunctionPrototype$1.bind;
	var call$1 = FunctionPrototype$1.call;
	var callBind = bind$1 && bind$1.bind(call$1);
	var functionUncurryThis = bind$1 ? function (fn) {
	  return fn && callBind(call$1, fn);
	} : function (fn) {
	  return fn && function () {
	    return call$1.apply(fn, arguments);
	  };
	};

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	var isCallable = function (argument) {
	  return typeof argument == 'function';
	};

	var fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	// Detect IE8's incomplete defineProperty implementation


	var descriptors = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, {
	    get: function () {
	      return 7;
	    }
	  })[1] != 7;
	});

	var call$2 = Function.prototype.call;
	var functionCall = call$2.bind ? call$2.bind(call$2) : function () {
	  return call$2.apply(call$2, arguments);
	};

	var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

	var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
	  1: 2
	}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

	var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;

	var objectPropertyIsEnumerable = {
		f: f
	};

	var createPropertyDescriptor = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var toString = functionUncurryThis({}.toString);
	var stringSlice = functionUncurryThis(''.slice);

	var classofRaw = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};

	var Object$1 = global$1.Object;
	var split = functionUncurryThis(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

	var indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !Object$1('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classofRaw(it) == 'String' ? split(it, '') : Object$1(it);
	} : Object$1;

	var TypeError$1 = global$1.TypeError; // `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible

	var requireObjectCoercible = function (it) {
	  if (it == undefined) throw TypeError$1("Can't call method on " + it);
	  return it;
	};

	// toObject with fallback for non-array-like ES3 strings




	var toIndexedObject = function (it) {
	  return indexedObject(requireObjectCoercible(it));
	};

	var isObject = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};

	var path = {};

	var aFunction = function (variable) {
	  return isCallable(variable) ? variable : undefined;
	};

	var getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global$1[namespace]) : path[namespace] && path[namespace][method] || global$1[namespace] && global$1[namespace][method];
	};

	var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

	var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

	var process = global$1.process;
	var Deno = global$1.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;

	if (v8) {
	  match = v8.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us

	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	} // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0


	if (!version && engineUserAgent) {
	  match = engineUserAgent.match(/Edge\/(\d+)/);

	  if (!match || match[1] >= 74) {
	    match = engineUserAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}

	var engineV8Version = version;

	/* eslint-disable es/no-symbol -- required for testing */

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing


	var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

	  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	  !Symbol.sham && engineV8Version && engineV8Version < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */

	var useSymbolAsUid = nativeSymbol && !Symbol.sham && typeof Symbol.iterator == 'symbol';

	var Object$2 = global$1.Object;
	var isSymbol = useSymbolAsUid ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, Object$2(it));
	};

	var String$1 = global$1.String;

	var tryToString = function (argument) {
	  try {
	    return String$1(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};

	var TypeError$2 = global$1.TypeError; // `Assert: IsCallable(argument) is true`

	var aCallable = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw TypeError$2(tryToString(argument) + ' is not a function');
	};

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod


	var getMethod = function (V, P) {
	  var func = V[P];
	  return func == null ? undefined : aCallable(func);
	};

	var TypeError$3 = global$1.TypeError; // `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive

	var ordinaryToPrimitive = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  throw TypeError$3("Can't convert object to primitive value");
	};

	var isPure = true;

	// eslint-disable-next-line es/no-object-defineproperty -- safe


	var defineProperty = Object.defineProperty;

	var setGlobal = function (key, value) {
	  try {
	    defineProperty(global$1, key, {
	      value: value,
	      configurable: true,
	      writable: true
	    });
	  } catch (error) {
	    global$1[key] = value;
	  }

	  return value;
	};

	var SHARED = '__core-js_shared__';
	var store = global$1[SHARED] || setGlobal(SHARED, {});
	var sharedStore = store;

	var shared = createCommonjsModule(function (module) {
	(module.exports = function (key, value) {
	  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.19.1',
	  mode:  'pure' ,
	  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
	});
	});

	var Object$3 = global$1.Object; // `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject

	var toObject = function (argument) {
	  return Object$3(requireObjectCoercible(argument));
	};

	var hasOwnProperty = functionUncurryThis({}.hasOwnProperty); // `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty

	var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};

	var id = 0;
	var postfix = Math.random();
	var toString$1 = functionUncurryThis(1.0.toString);

	var uid = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
	};

	var WellKnownSymbolsStore = shared('wks');
	var Symbol$1 = global$1.Symbol;
	var symbolFor = Symbol$1 && Symbol$1['for'];
	var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

	var wellKnownSymbol = function (name) {
	  if (!hasOwnProperty_1(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
	    var description = 'Symbol.' + name;

	    if (nativeSymbol && hasOwnProperty_1(Symbol$1, name)) {
	      WellKnownSymbolsStore[name] = Symbol$1[name];
	    } else if (useSymbolAsUid && symbolFor) {
	      WellKnownSymbolsStore[name] = symbolFor(description);
	    } else {
	      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
	    }
	  }

	  return WellKnownSymbolsStore[name];
	};

	var TypeError$4 = global$1.TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive'); // `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive

	var toPrimitive = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;

	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = functionCall(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw TypeError$4("Can't convert object to primitive value");
	  }

	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey


	var toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};

	var document$1 = global$1.document; // typeof document.createElement is 'object' in old IE

	var EXISTS = isObject(document$1) && isObject(document$1.createElement);

	var documentCreateElement = function (it) {
	  return EXISTS ? document$1.createElement(it) : {};
	};

	// Thank's IE8 for his funny defineProperty


	var ie8DomDefine = !descriptors && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
	  return Object.defineProperty(documentCreateElement('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a != 7;
	});

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe


	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

	var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (ie8DomDefine) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) {
	    /* empty */
	  }
	  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
	};

	var objectGetOwnPropertyDescriptor = {
		f: f$1
	};

	var replacement = /#|\.prototype\./;

	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
	};

	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};

	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	var isForced_1 = isForced;

	var bind$2 = functionUncurryThis(functionUncurryThis.bind); // optional / simple context binding

	var functionBindContext = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : bind$2 ? bind$2(fn, that) : function
	    /* ...args */
	  () {
	    return fn.apply(that, arguments);
	  };
	};

	var String$2 = global$1.String;
	var TypeError$5 = global$1.TypeError; // `Assert: Type(argument) is Object`

	var anObject = function (argument) {
	  if (isObject(argument)) return argument;
	  throw TypeError$5(String$2(argument) + ' is not an object');
	};

	var TypeError$6 = global$1.TypeError; // eslint-disable-next-line es/no-object-defineproperty -- safe

	var $defineProperty = Object.defineProperty; // `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty

	var f$2 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (ie8DomDefine) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) {
	    /* empty */
	  }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError$6('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var objectDefineProperty = {
		f: f$2
	};

	var createNonEnumerableProperty = descriptors ? function (object, key, value) {
	  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;











	var wrapConstructor = function (NativeConstructor) {
	  var Wrapper = function (a, b, c) {
	    if (this instanceof Wrapper) {
	      switch (arguments.length) {
	        case 0:
	          return new NativeConstructor();

	        case 1:
	          return new NativeConstructor(a);

	        case 2:
	          return new NativeConstructor(a, b);
	      }

	      return new NativeConstructor(a, b, c);
	    }

	    return functionApply(NativeConstructor, this, arguments);
	  };

	  Wrapper.prototype = NativeConstructor.prototype;
	  return Wrapper;
	};
	/*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	  options.name        - the .name of the function if it does not match the key
	*/


	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var PROTO = options.proto;
	  var nativeSource = GLOBAL ? global$1 : STATIC ? global$1[TARGET] : (global$1[TARGET] || {}).prototype;
	  var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
	  var targetPrototype = target.prototype;
	  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
	  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

	  for (key in source) {
	    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contains in native

	    USE_NATIVE = !FORCED && nativeSource && hasOwnProperty_1(nativeSource, key);
	    targetProperty = target[key];
	    if (USE_NATIVE) if (options.noTargetGet) {
	      descriptor = getOwnPropertyDescriptor$1(nativeSource, key);
	      nativeProperty = descriptor && descriptor.value;
	    } else nativeProperty = nativeSource[key]; // export native or implementation

	    sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
	    if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue; // bind timers to global for call from export context

	    if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global$1); // wrap global constructors for prevent changs in this version
	    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty); // make static versions for prototype methods
	    else if (PROTO && isCallable(sourceProperty)) resultProperty = functionUncurryThis(sourceProperty); // default case
	    else resultProperty = sourceProperty; // add a flag to not completely full polyfills

	    if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) {
	      createNonEnumerableProperty(resultProperty, 'sham', true);
	    }

	    createNonEnumerableProperty(target, key, resultProperty);

	    if (PROTO) {
	      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';

	      if (!hasOwnProperty_1(path, VIRTUAL_PROTOTYPE)) {
	        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
	      } // export virtual prototype methods


	      createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty); // export real prototype methods

	      if (options.real && targetPrototype && !targetPrototype[key]) {
	        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
	      }
	    }
	  }
	};

	var ceil = Math.ceil;
	var floor = Math.floor; // `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity

	var toIntegerOrInfinity = function (argument) {
	  var number = +argument; // eslint-disable-next-line no-self-compare -- safe

	  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
	};

	var max = Math.max;
	var min = Math.min; // Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

	var toAbsoluteIndex = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};

	var min$1 = Math.min; // `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength

	var toLength = function (argument) {
	  return argument > 0 ? min$1(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike


	var lengthOfArrayLike = function (obj) {
	  return toLength(obj.length);
	};

	// `Array.prototype.{ indexOf, includes }` methods implementation


	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value; // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check

	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

	      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};

	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};

	var hiddenKeys = {};

	var indexOf = arrayIncludes.indexOf;



	var push = functionUncurryThis([].push);

	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;

	  for (key in O) !hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key); // Don't enum bug & hidden keys


	  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
	    ~indexOf(result, key) || push(result, key);
	  }

	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe


	var objectKeys = Object.keys || function keys(O) {
	  return objectKeysInternal(O, enumBugKeys);
	};

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	var f$3 = Object.getOwnPropertySymbols;

	var objectGetOwnPropertySymbols = {
		f: f$3
	};

	// eslint-disable-next-line es/no-object-assign -- safe


	var $assign = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

	var defineProperty$1 = Object.defineProperty;
	var concat = functionUncurryThis([].concat); // `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign

	var objectAssign = !$assign || fails(function () {
	  // should have correct order of operations (Edge bug)
	  if (descriptors && $assign({
	    b: 1
	  }, $assign(defineProperty$1({}, 'a', {
	    enumerable: true,
	    get: function () {
	      defineProperty$1(this, 'b', {
	        value: 3,
	        enumerable: false
	      });
	    }
	  }), {
	    b: 2
	  })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

	  var A = {};
	  var B = {}; // eslint-disable-next-line es/no-symbol -- safe

	  var symbol = Symbol();
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) {
	    B[chr] = chr;
	  });
	  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
	}) ? function assign(target, source) {
	  // eslint-disable-line no-unused-vars -- required for `.length`
	  var T = toObject(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
	  var propertyIsEnumerable = objectPropertyIsEnumerable.f;

	  while (argumentsLength > index) {
	    var S = indexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;

	    while (length > j) {
	      key = keys[j++];
	      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
	    }
	  }

	  return T;
	} : $assign;

	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	// eslint-disable-next-line es/no-object-assign -- required for testing


	_export({
	  target: 'Object',
	  stat: true,
	  forced: Object.assign !== objectAssign
	}, {
	  assign: objectAssign
	});

	var assign = path.Object.assign;

	var assign$1 = assign;

	var assign$2 = assign$1;

	var assign$3 = assign$2;

	var _extends_1 = createCommonjsModule(function (module) {
	function _extends() {
	  module.exports = _extends = assign$3 || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  return _extends.apply(this, arguments);
	}

	module.exports = _extends;
	});

	var arrayMethodIsStrict = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
	    method.call(null, argument || function () {
	      throw 1;
	    }, 1);
	  });
	};

	/* eslint-disable es/no-array-prototype-indexof -- required for testing */





	var $IndexOf = arrayIncludes.indexOf;



	var un$IndexOf = functionUncurryThis([].indexOf);
	var NEGATIVE_ZERO = !!un$IndexOf && 1 / un$IndexOf([1], 1, -0) < 0;
	var STRICT_METHOD = arrayMethodIsStrict('indexOf'); // `Array.prototype.indexOf` method
	// https://tc39.es/ecma262/#sec-array.prototype.indexof

	_export({
	  target: 'Array',
	  proto: true,
	  forced: NEGATIVE_ZERO || !STRICT_METHOD
	}, {
	  indexOf: function indexOf(searchElement
	  /* , fromIndex = 0 */
	  ) {
	    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
	    return NEGATIVE_ZERO // convert -0 to +0
	    ? un$IndexOf(this, searchElement, fromIndex) || 0 : $IndexOf(this, searchElement, fromIndex);
	  }
	});

	var entryVirtual = function (CONSTRUCTOR) {
	  return path[CONSTRUCTOR + 'Prototype'];
	};

	var indexOf$1 = entryVirtual('Array').indexOf;

	var ArrayPrototype = Array.prototype;

	var indexOf$2 = function (it) {
	  var own = it.indexOf;
	  return it === ArrayPrototype || objectIsPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.indexOf ? indexOf$1 : own;
	};

	var indexOf$3 = indexOf$2;

	var indexOf$4 = indexOf$3;

	var indexOf$5 = indexOf$4;

	var FAILS_ON_PRIMITIVES = fails(function () {
	  objectKeys(1);
	}); // `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys

	_export({
	  target: 'Object',
	  stat: true,
	  forced: FAILS_ON_PRIMITIVES
	}, {
	  keys: function keys(it) {
	    return objectKeys(toObject(it));
	  }
	});

	var keys = path.Object.keys;

	var keys$1 = keys;

	var keys$2 = keys$1;

	var keys$3 = keys$2;

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};

	  var sourceKeys = keys$3(source);

	  var key, i;

	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (indexOf$5(excluded).call(excluded, key) >= 0) continue;
	    target[key] = source[key];
	  }

	  return target;
	}

	var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/

	var classnames = createCommonjsModule(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if ( module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
	});

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var b = "function" === typeof Symbol && Symbol.for,
	    c = b ? Symbol.for("react.element") : 60103,
	    d = b ? Symbol.for("react.portal") : 60106,
	    e = b ? Symbol.for("react.fragment") : 60107,
	    f$4 = b ? Symbol.for("react.strict_mode") : 60108,
	    g = b ? Symbol.for("react.profiler") : 60114,
	    h = b ? Symbol.for("react.provider") : 60109,
	    k = b ? Symbol.for("react.context") : 60110,
	    l = b ? Symbol.for("react.async_mode") : 60111,
	    m = b ? Symbol.for("react.concurrent_mode") : 60111,
	    n = b ? Symbol.for("react.forward_ref") : 60112,
	    p = b ? Symbol.for("react.suspense") : 60113,
	    q = b ? Symbol.for("react.suspense_list") : 60120,
	    r = b ? Symbol.for("react.memo") : 60115,
	    t = b ? Symbol.for("react.lazy") : 60116,
	    v = b ? Symbol.for("react.block") : 60121,
	    w = b ? Symbol.for("react.fundamental") : 60117,
	    x = b ? Symbol.for("react.responder") : 60118,
	    y = b ? Symbol.for("react.scope") : 60119;

	function z(a) {
	  if ("object" === typeof a && null !== a) {
	    var u = a.$$typeof;

	    switch (u) {
	      case c:
	        switch (a = a.type, a) {
	          case l:
	          case m:
	          case e:
	          case g:
	          case f$4:
	          case p:
	            return a;

	          default:
	            switch (a = a && a.$$typeof, a) {
	              case k:
	              case n:
	              case t:
	              case r:
	              case h:
	                return a;

	              default:
	                return u;
	            }

	        }

	      case d:
	        return u;
	    }
	  }
	}

	function A(a) {
	  return z(a) === m;
	}

	var AsyncMode = l;
	var ConcurrentMode = m;
	var ContextConsumer = k;
	var ContextProvider = h;
	var Element$1 = c;
	var ForwardRef = n;
	var Fragment = e;
	var Lazy = t;
	var Memo = r;
	var Portal = d;
	var Profiler = g;
	var StrictMode = f$4;
	var Suspense = p;

	var isAsyncMode = function (a) {
	  return A(a) || z(a) === l;
	};

	var isConcurrentMode = A;

	var isContextConsumer = function (a) {
	  return z(a) === k;
	};

	var isContextProvider = function (a) {
	  return z(a) === h;
	};

	var isElement = function (a) {
	  return "object" === typeof a && null !== a && a.$$typeof === c;
	};

	var isForwardRef = function (a) {
	  return z(a) === n;
	};

	var isFragment = function (a) {
	  return z(a) === e;
	};

	var isLazy = function (a) {
	  return z(a) === t;
	};

	var isMemo = function (a) {
	  return z(a) === r;
	};

	var isPortal = function (a) {
	  return z(a) === d;
	};

	var isProfiler = function (a) {
	  return z(a) === g;
	};

	var isStrictMode = function (a) {
	  return z(a) === f$4;
	};

	var isSuspense = function (a) {
	  return z(a) === p;
	};

	var isValidElementType = function (a) {
	  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f$4 || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
	};

	var typeOf = z;

	var reactIs_production_min = {
		AsyncMode: AsyncMode,
		ConcurrentMode: ConcurrentMode,
		ContextConsumer: ContextConsumer,
		ContextProvider: ContextProvider,
		Element: Element$1,
		ForwardRef: ForwardRef,
		Fragment: Fragment,
		Lazy: Lazy,
		Memo: Memo,
		Portal: Portal,
		Profiler: Profiler,
		StrictMode: StrictMode,
		Suspense: Suspense,
		isAsyncMode: isAsyncMode,
		isConcurrentMode: isConcurrentMode,
		isContextConsumer: isContextConsumer,
		isContextProvider: isContextProvider,
		isElement: isElement,
		isForwardRef: isForwardRef,
		isFragment: isFragment,
		isLazy: isLazy,
		isMemo: isMemo,
		isPortal: isPortal,
		isProfiler: isProfiler,
		isStrictMode: isStrictMode,
		isSuspense: isSuspense,
		isValidElementType: isValidElementType,
		typeOf: typeOf
	};

	/** @license React v16.13.1
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var reactIs_development = createCommonjsModule(function (module, exports) {
	});

	var reactIs = createCommonjsModule(function (module) {

	{
	  module.exports = reactIs_production_min;
	}
	});

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */

	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject$1(val) {
	  if (val === null || val === undefined) {
	    throw new TypeError('Object.assign cannot be called with null or undefined');
	  }

	  return Object(val);
	}

	function shouldUseNative() {
	  try {
	    if (!Object.assign) {
	      return false;
	    } // Detect buggy property enumeration order in older V8 versions.
	    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


	    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

	    test1[5] = 'de';

	    if (Object.getOwnPropertyNames(test1)[0] === '5') {
	      return false;
	    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


	    var test2 = {};

	    for (var i = 0; i < 10; i++) {
	      test2['_' + String.fromCharCode(i)] = i;
	    }

	    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
	      return test2[n];
	    });

	    if (order2.join('') !== '0123456789') {
	      return false;
	    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


	    var test3 = {};
	    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
	      test3[letter] = letter;
	    });

	    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
	      return false;
	    }

	    return true;
	  } catch (err) {
	    // We don't expect any of the above to throw, but better to be safe.
	    return false;
	  }
	}

	var objectAssign$1 = shouldUseNative() ? Object.assign : function (target, source) {
	  var from;
	  var to = toObject$1(target);
	  var symbols;

	  for (var s = 1; s < arguments.length; s++) {
	    from = Object(arguments[s]);

	    for (var key in from) {
	      if (hasOwnProperty$1.call(from, key)) {
	        to[key] = from[key];
	      }
	    }

	    if (getOwnPropertySymbols) {
	      symbols = getOwnPropertySymbols(from);

	      for (var i = 0; i < symbols.length; i++) {
	        if (propIsEnumerable.call(from, symbols[i])) {
	          to[symbols[i]] = from[symbols[i]];
	        }
	      }
	    }
	  }

	  return to;
	};

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */









	var has = Function.call.bind(Object.prototype.hasOwnProperty);

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */



	function emptyFunction() {}

	function emptyFunctionWithReset() {}

	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	var factoryWithThrowingShims = function () {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }

	    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	    err.name = 'Invariant Violation';
	    throw err;
	  }
	  shim.isRequired = shim;

	  function getShim() {
	    return shim;
	  }
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	  ReactPropTypes.PropTypes = ReactPropTypes;
	  return ReactPropTypes;
	};

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var propTypes = createCommonjsModule(function (module) {
	{
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});

	/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/

	var classnames$1 = createCommonjsModule(function (module) {
	/* global define */
	(function () {

	  var hasOwn = {}.hasOwnProperty;

	  function classNames() {
	    var classes = [];

	    for (var i = 0; i < arguments.length; i++) {
	      var arg = arguments[i];
	      if (!arg) continue;
	      var argType = typeof arg;

	      if (argType === 'string' || argType === 'number') {
	        classes.push(arg);
	      } else if (Array.isArray(arg)) {
	        if (arg.length) {
	          var inner = classNames.apply(null, arg);

	          if (inner) {
	            classes.push(inner);
	          }
	        }
	      } else if (argType === 'object') {
	        if (arg.toString === Object.prototype.toString) {
	          for (var key in arg) {
	            if (hasOwn.call(arg, key) && arg[key]) {
	              classes.push(key);
	            }
	          }
	        } else {
	          classes.push(arg.toString());
	        }
	      }
	    }

	    return classes.join(' ');
	  }

	  if ( module.exports) {
	    classNames.default = classNames;
	    module.exports = classNames;
	  } else {
	    window.classNames = classNames;
	  }
	})();
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2 = _interopRequireDefault(React__default['default']);



	var _propTypes2 = _interopRequireDefault(propTypes);



	var _classnames2 = _interopRequireDefault(classnames$1);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var ANIMATION_STATE_CLASSES = {
	  animating: 'rah-animating',
	  animatingUp: 'rah-animating--up',
	  animatingDown: 'rah-animating--down',
	  animatingToHeightZero: 'rah-animating--to-height-zero',
	  animatingToHeightAuto: 'rah-animating--to-height-auto',
	  animatingToHeightSpecific: 'rah-animating--to-height-specific',
	  static: 'rah-static',
	  staticHeightZero: 'rah-static--height-zero',
	  staticHeightAuto: 'rah-static--height-auto',
	  staticHeightSpecific: 'rah-static--height-specific'
	};
	var PROPS_TO_OMIT = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'children', 'contentClassName', 'delay', 'duration', 'easing', 'height', 'onAnimationEnd', 'onAnimationStart'];

	function omit(obj) {
	  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keys[_key - 1] = arguments[_key];
	  }

	  if (!keys.length) {
	    return obj;
	  }

	  var res = {};
	  var objectKeys = Object.keys(obj);

	  for (var i = 0; i < objectKeys.length; i++) {
	    var key = objectKeys[i];

	    if (keys.indexOf(key) === -1) {
	      res[key] = obj[key];
	    }
	  }

	  return res;
	} // Start animation helper using nested requestAnimationFrames


	function startAnimationHelper(callback) {
	  var requestAnimationFrameIDs = [];
	  requestAnimationFrameIDs[0] = requestAnimationFrame(function () {
	    requestAnimationFrameIDs[1] = requestAnimationFrame(function () {
	      callback();
	    });
	  });
	  return requestAnimationFrameIDs;
	}

	function cancelAnimationFrames(requestAnimationFrameIDs) {
	  requestAnimationFrameIDs.forEach(function (id) {
	    return cancelAnimationFrame(id);
	  });
	}

	function isNumber(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}

	function isPercentage(height) {
	  // Percentage height
	  return typeof height === 'string' && height.search('%') === height.length - 1 && isNumber(height.substr(0, height.length - 1));
	}

	function runCallback(callback, params) {
	  if (callback && typeof callback === 'function') {
	    callback(params);
	  }
	}

	var AnimateHeight = function (_React$Component) {
	  _inherits(AnimateHeight, _React$Component);

	  function AnimateHeight(props) {
	    _classCallCheck(this, AnimateHeight);

	    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

	    _this.animationFrameIDs = [];
	    var height = 'auto';
	    var overflow = 'visible';

	    if (isNumber(props.height)) {
	      // If value is string "0" make sure we convert it to number 0
	      height = props.height < 0 || props.height === '0' ? 0 : props.height;
	      overflow = 'hidden';
	    } else if (isPercentage(props.height)) {
	      // If value is string "0%" make sure we convert it to number 0
	      height = props.height === '0%' ? 0 : props.height;
	      overflow = 'hidden';
	    }

	    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

	    var animationStateClasses = _this.getStaticStateClasses(height);

	    _this.state = {
	      animationStateClasses: animationStateClasses,
	      height: height,
	      overflow: overflow,
	      shouldUseTransitions: false
	    };
	    return _this;
	  }

	  _createClass(AnimateHeight, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var height = this.state.height; // Hide content if height is 0 (to prevent tabbing into it)
	      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
	      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

	      if (this.contentElement && this.contentElement.style) {
	        this.hideContent(height);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;

	      var _props = this.props,
	          delay = _props.delay,
	          duration = _props.duration,
	          height = _props.height,
	          onAnimationEnd = _props.onAnimationEnd,
	          onAnimationStart = _props.onAnimationStart; // Check if 'height' prop has changed

	      if (this.contentElement && height !== prevProps.height) {
	        var _cx; // Remove display: none from the content div
	        // if it was hidden to prevent tabbing into it


	        this.showContent(prevState.height); // Cache content height

	        this.contentElement.style.overflow = 'hidden';
	        var contentHeight = this.contentElement.offsetHeight;
	        this.contentElement.style.overflow = ''; // set total animation time

	        var totalDuration = duration + delay;
	        var newHeight = null;
	        var timeoutState = {
	          height: null,
	          // it will be always set to either 'auto' or specific number
	          overflow: 'hidden'
	        };
	        var isCurrentHeightAuto = prevState.height === 'auto';

	        if (isNumber(height)) {
	          // If value is string "0" make sure we convert it to number 0
	          newHeight = height < 0 || height === '0' ? 0 : height;
	          timeoutState.height = newHeight;
	        } else if (isPercentage(height)) {
	          // If value is string "0%" make sure we convert it to number 0
	          newHeight = height === '0%' ? 0 : height;
	          timeoutState.height = newHeight;
	        } else {
	          // If not, animate to content height
	          // and then reset to auto
	          newHeight = contentHeight; // TODO solve contentHeight = 0

	          timeoutState.height = 'auto';
	          timeoutState.overflow = null;
	        }

	        if (isCurrentHeightAuto) {
	          // This is the height to be animated to
	          timeoutState.height = newHeight; // If previous height was 'auto'
	          // set starting height explicitly to be able to use transition

	          newHeight = contentHeight;
	        } // Animation classes


	        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx)); // Animation classes to be put after animation is complete

	        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height); // Set starting height and animating classes
	        // We are safe to call set state as it will not trigger infinite loop
	        // because of the "height !== prevProps.height" check

	        this.setState({
	          // eslint-disable-line react/no-did-update-set-state
	          animationStateClasses: animationStateClasses,
	          height: newHeight,
	          overflow: 'hidden',
	          // When animating from 'auto' we first need to set fixed height
	          // that change should be animated
	          shouldUseTransitions: !isCurrentHeightAuto
	        }); // Clear timeouts

	        clearTimeout(this.timeoutID);
	        clearTimeout(this.animationClassesTimeoutID);

	        if (isCurrentHeightAuto) {
	          // When animating from 'auto' we use a short timeout to start animation
	          // after setting fixed height above
	          timeoutState.shouldUseTransitions = true;
	          cancelAnimationFrames(this.animationFrameIDs);
	          this.animationFrameIDs = startAnimationHelper(function () {
	            _this2.setState(timeoutState); // ANIMATION STARTS, run a callback if it exists


	            runCallback(onAnimationStart, {
	              newHeight: timeoutState.height
	            });
	          }); // Set static classes and remove transitions when animation ends

	          this.animationClassesTimeoutID = setTimeout(function () {
	            _this2.setState({
	              animationStateClasses: timeoutAnimationStateClasses,
	              shouldUseTransitions: false
	            }); // ANIMATION ENDS
	            // Hide content if height is 0 (to prevent tabbing into it)


	            _this2.hideContent(timeoutState.height); // Run a callback if it exists


	            runCallback(onAnimationEnd, {
	              newHeight: timeoutState.height
	            });
	          }, totalDuration);
	        } else {
	          // ANIMATION STARTS, run a callback if it exists
	          runCallback(onAnimationStart, {
	            newHeight: newHeight
	          }); // Set end height, classes and remove transitions when animation is complete

	          this.timeoutID = setTimeout(function () {
	            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
	            timeoutState.shouldUseTransitions = false;

	            _this2.setState(timeoutState); // ANIMATION ENDS
	            // If height is auto, don't hide the content
	            // (case when element is empty, therefore height is 0)


	            if (height !== 'auto') {
	              // Hide content if height is 0 (to prevent tabbing into it)
	              _this2.hideContent(newHeight); // TODO solve newHeight = 0

	            } // Run a callback if it exists


	            runCallback(onAnimationEnd, {
	              newHeight: newHeight
	            });
	          }, totalDuration);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      cancelAnimationFrames(this.animationFrameIDs);
	      clearTimeout(this.timeoutID);
	      clearTimeout(this.animationClassesTimeoutID);
	      this.timeoutID = null;
	      this.animationClassesTimeoutID = null;
	      this.animationStateClasses = null;
	    }
	  }, {
	    key: 'showContent',
	    value: function showContent(height) {
	      if (height === 0) {
	        this.contentElement.style.display = '';
	      }
	    }
	  }, {
	    key: 'hideContent',
	    value: function hideContent(newHeight) {
	      if (newHeight === 0) {
	        this.contentElement.style.display = 'none';
	      }
	    }
	  }, {
	    key: 'getStaticStateClasses',
	    value: function getStaticStateClasses(height) {
	      var _cx2;

	      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx3,
	          _this3 = this;

	      var _props2 = this.props,
	          animateOpacity = _props2.animateOpacity,
	          applyInlineTransitions = _props2.applyInlineTransitions,
	          children = _props2.children,
	          className = _props2.className,
	          contentClassName = _props2.contentClassName,
	          delay = _props2.delay,
	          duration = _props2.duration,
	          easing = _props2.easing,
	          id = _props2.id,
	          style = _props2.style;
	      var _state = this.state,
	          height = _state.height,
	          overflow = _state.overflow,
	          animationStateClasses = _state.animationStateClasses,
	          shouldUseTransitions = _state.shouldUseTransitions;

	      var componentStyle = _extends({}, style, {
	        height: height,
	        overflow: overflow || style.overflow
	      });

	      if (shouldUseTransitions && applyInlineTransitions) {
	        componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms'; // Include transition passed through styles

	        if (style.transition) {
	          componentStyle.transition = style.transition + ', ' + componentStyle.transition;
	        } // Add webkit vendor prefix still used by opera, blackberry...


	        componentStyle.WebkitTransition = componentStyle.transition;
	      }

	      var contentStyle = {};

	      if (animateOpacity) {
	        contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms'; // Add webkit vendor prefix still used by opera, blackberry...

	        contentStyle.WebkitTransition = contentStyle.transition;

	        if (height === 0) {
	          contentStyle.opacity = 0;
	        }
	      }

	      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3)); // Check if user passed aria-hidden prop

	      var hasAriaHiddenProp = typeof this.props['aria-hidden'] !== 'undefined';
	      var ariaHidden = hasAriaHiddenProp ? this.props['aria-hidden'] : height === 0;
	      return _react2.default.createElement('div', _extends({}, omit.apply(undefined, [this.props].concat(PROPS_TO_OMIT)), {
	        'aria-hidden': ariaHidden,
	        className: componentClasses,
	        id: id,
	        style: componentStyle
	      }), _react2.default.createElement('div', {
	        className: contentClassName,
	        style: contentStyle,
	        ref: function ref(el) {
	          return _this3.contentElement = el;
	        }
	      }, children));
	    }
	  }]);

	  return AnimateHeight;
	}(_react2.default.Component);

	var heightPropType = function heightPropType(props, propName, componentName) {
	  var value = props[propName];

	  if (typeof value === 'number' && value >= 0 || isPercentage(value) || value === 'auto') {
	    return null;
	  }

	  return new TypeError('value "' + value + '" of type "' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '" is invalid type for ' + propName + ' in ' + componentName + '. ' + 'It needs to be a positive number, string "auto" or percentage string (e.g. "15%").');
	};

	AnimateHeight.propTypes = {
	  'aria-hidden': _propTypes2.default.bool,
	  animateOpacity: _propTypes2.default.bool,
	  animationStateClasses: _propTypes2.default.object,
	  applyInlineTransitions: _propTypes2.default.bool,
	  children: _propTypes2.default.any.isRequired,
	  className: _propTypes2.default.string,
	  contentClassName: _propTypes2.default.string,
	  delay: _propTypes2.default.number,
	  duration: _propTypes2.default.number,
	  easing: _propTypes2.default.string,
	  height: heightPropType,
	  id: _propTypes2.default.string,
	  onAnimationEnd: _propTypes2.default.func,
	  onAnimationStart: _propTypes2.default.func,
	  style: _propTypes2.default.object
	};
	AnimateHeight.defaultProps = {
	  animateOpacity: false,
	  animationStateClasses: ANIMATION_STATE_CLASSES,
	  applyInlineTransitions: true,
	  duration: 250,
	  delay: 0,
	  easing: 'ease',
	  style: {}
	};
	var _default = AnimateHeight;

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty


	_export({
	  target: 'Object',
	  stat: true,
	  forced: !descriptors,
	  sham: !descriptors
	}, {
	  defineProperty: objectDefineProperty.f
	});

	var defineProperty_1 = createCommonjsModule(function (module) {
	var Object = path.Object;

	var defineProperty = module.exports = function defineProperty(it, key, desc) {
	  return Object.defineProperty(it, key, desc);
	};

	if (Object.defineProperty.sham) defineProperty.sham = true;
	});

	var defineProperty$2 = defineProperty_1;

	var defineProperty$3 = defineProperty$2;

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe


	var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;

	  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);

	  return O;
	};

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties


	_export({
	  target: 'Object',
	  stat: true,
	  forced: !descriptors,
	  sham: !descriptors
	}, {
	  defineProperties: objectDefineProperties
	});

	var defineProperties_1 = createCommonjsModule(function (module) {
	var Object = path.Object;

	var defineProperties = module.exports = function defineProperties(T, D) {
	  return Object.defineProperties(T, D);
	};

	if (Object.defineProperties.sham) defineProperties.sham = true;
	});

	var defineProperties = defineProperties_1;

	var defineProperties$1 = defineProperties;

	var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe

	var f$5 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return objectKeysInternal(O, hiddenKeys$1);
	};

	var objectGetOwnPropertyNames = {
		f: f$5
	};

	var concat$1 = functionUncurryThis([].concat); // all object keys, includes non-enumerable and symbols

	var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = objectGetOwnPropertyNames.f(anObject(it));
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
	  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
	};

	var createProperty = function (object, key, value) {
	  var propertyKey = toPropertyKey(key);
	  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
	};

	// `Object.getOwnPropertyDescriptors` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors


	_export({
	  target: 'Object',
	  stat: true,
	  sham: !descriptors
	}, {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIndexedObject(object);
	    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var index = 0;
	    var key, descriptor;

	    while (keys.length > index) {
	      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
	      if (descriptor !== undefined) createProperty(result, key, descriptor);
	    }

	    return result;
	  }
	});

	var getOwnPropertyDescriptors = path.Object.getOwnPropertyDescriptors;

	var getOwnPropertyDescriptors$1 = getOwnPropertyDescriptors;

	var getOwnPropertyDescriptors$2 = getOwnPropertyDescriptors$1;

	var iterators = {};

	var functionToString = functionUncurryThis(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

	if (!isCallable(sharedStore.inspectSource)) {
	  sharedStore.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}

	var inspectSource = sharedStore.inspectSource;

	var WeakMap$1 = global$1.WeakMap;
	var nativeWeakMap = isCallable(WeakMap$1) && /native code/.test(inspectSource(WeakMap$1));

	var keys$4 = shared('keys');

	var sharedKey = function (key) {
	  return keys$4[key] || (keys$4[key] = uid(key));
	};

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError$7 = global$1.TypeError;
	var WeakMap$2 = global$1.WeakMap;
	var set, get, has$1;

	var enforce = function (it) {
	  return has$1(it) ? get(it) : set(it, {});
	};

	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;

	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError$7('Incompatible receiver, ' + TYPE + ' required');
	    }

	    return state;
	  };
	};

	if (nativeWeakMap || sharedStore.state) {
	  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$2());
	  var wmget = functionUncurryThis(store$1.get);
	  var wmhas = functionUncurryThis(store$1.has);
	  var wmset = functionUncurryThis(store$1.set);

	  set = function (it, metadata) {
	    if (wmhas(store$1, it)) throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    wmset(store$1, it, metadata);
	    return metadata;
	  };

	  get = function (it) {
	    return wmget(store$1, it) || {};
	  };

	  has$1 = function (it) {
	    return wmhas(store$1, it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;

	  set = function (it, metadata) {
	    if (hasOwnProperty_1(it, STATE)) throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };

	  get = function (it) {
	    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
	  };

	  has$1 = function (it) {
	    return hasOwnProperty_1(it, STATE);
	  };
	}

	var internalState = {
	  set: set,
	  get: get,
	  has: has$1,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var FunctionPrototype$2 = Function.prototype; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

	var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
	var EXISTS$1 = hasOwnProperty_1(FunctionPrototype$2, 'name'); // additional protection from minified / mangled / dropped function names

	var PROPER = EXISTS$1 && function something() {
	  /* empty */
	}.name === 'something';

	var CONFIGURABLE = EXISTS$1 && (!descriptors || descriptors && getDescriptor(FunctionPrototype$2, 'name').configurable);
	var functionName = {
	  EXISTS: EXISTS$1,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};

	var html = getBuiltIn('document', 'documentElement');

	/* global ActiveXObject -- old IE, WSH */

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');

	var EmptyConstructor = function () {
	  /* empty */
	};

	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak

	  return temp;
	}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	}; // Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug


	var activeXDocument;

	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) {
	    /* ignore */
	  }

	  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH

	  var length = enumBugKeys.length;

	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];

	  return NullProtoObject();
	};

	hiddenKeys[IE_PROTO] = true; // `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create

	var objectCreate = Object.create || function create(O, Properties) {
	  var result;

	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();

	  return Properties === undefined ? result : objectDefineProperties(result, Properties);
	};

	var correctPrototypeGetter = !fails(function () {
	  function F() {
	    /* empty */
	  }

	  F.prototype.constructor = null; // eslint-disable-next-line es/no-object-getprototypeof -- required for testing

	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});

	var IE_PROTO$1 = sharedKey('IE_PROTO');
	var Object$4 = global$1.Object;
	var ObjectPrototype = Object$4.prototype; // `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof

	var objectGetPrototypeOf = correctPrototypeGetter ? Object$4.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
	  var constructor = object.constructor;

	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  }

	  return object instanceof Object$4 ? ObjectPrototype : null;
	};

	var redefine = function (target, key, value, options) {
	  if (options && options.enumerable) target[key] = value;else createNonEnumerableProperty(target, key, value);
	};

	var ITERATOR = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false; // `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object

	var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
	/* eslint-disable es/no-array-prototype-keys -- safe */

	if ([].keys) {
	  arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
	    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
	  }
	}

	var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
	  var test = {}; // FF44- legacy iterators case

	  return IteratorPrototype[ITERATOR].call(test) !== test;
	});
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};else IteratorPrototype = objectCreate(IteratorPrototype); // `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

	if (!isCallable(IteratorPrototype[ITERATOR])) {
	  redefine(IteratorPrototype, ITERATOR, function () {
	    return this;
	  });
	}

	var iteratorsCore = {
	  IteratorPrototype: IteratorPrototype,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};
	test[TO_STRING_TAG] = 'z';
	var toStringTagSupport = String(test) === '[object z]';

	var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
	var Object$5 = global$1.Object; // ES3 wrong here

	var CORRECT_ARGUMENTS = classofRaw(function () {
	  return arguments;
	}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) {
	    /* empty */
	  }
	}; // getting tag from ES6+ `Object.prototype.toString`


	var classof = toStringTagSupport ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
	  : typeof (tag = tryGet(O = Object$5(it), TO_STRING_TAG$1)) == 'string' ? tag // builtinTag case
	  : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
	  : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};

	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring


	var objectToString = toStringTagSupport ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};

	var defineProperty$4 = objectDefineProperty.f;









	var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

	var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
	  if (it) {
	    var target = STATIC ? it : it.prototype;

	    if (!hasOwnProperty_1(target, TO_STRING_TAG$2)) {
	      defineProperty$4(target, TO_STRING_TAG$2, {
	        configurable: true,
	        value: TAG
	      });
	    }

	    if (SET_METHOD && !toStringTagSupport) {
	      createNonEnumerableProperty(target, 'toString', objectToString);
	    }
	  }
	};

	var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;









	var returnThis = function () {
	  return this;
	};

	var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
	    next: createPropertyDescriptor(1, next)
	  });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};

	var String$3 = global$1.String;
	var TypeError$8 = global$1.TypeError;

	var aPossiblePrototype = function (argument) {
	  if (typeof argument == 'object' || isCallable(argument)) return argument;
	  throw TypeError$8("Can't set " + String$3(argument) + ' as a prototype');
	};

	/* eslint-disable no-proto -- safe */

	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe


	var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;

	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    setter = functionUncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) {
	    /* empty */
	  }

	  return function setPrototypeOf(O, proto) {
	    anObject(O);
	    aPossiblePrototype(proto);
	    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);

	var PROPER_FUNCTION_NAME = functionName.PROPER;
	var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
	var ITERATOR$1 = wellKnownSymbol('iterator');
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';

	var returnThis$1 = function () {
	  return this;
	};

	var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);

	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];

	    switch (KIND) {
	      case KEYS:
	        return function keys() {
	          return new IteratorConstructor(this, KIND);
	        };

	      case VALUES:
	        return function values() {
	          return new IteratorConstructor(this, KIND);
	        };

	      case ENTRIES:
	        return function entries() {
	          return new IteratorConstructor(this, KIND);
	        };
	    }

	    return function () {
	      return new IteratorConstructor(this);
	    };
	  };

	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR$1] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY; // fix native

	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));

	    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {


	      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      iterators[TO_STRING_TAG] = returnThis$1;
	    }
	  } // fix Array.prototype.{ values, @@iterator }.name in V8 / FF


	  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    {
	      INCORRECT_VALUES_NAME = true;

	      defaultIterator = function values() {
	        return functionCall(nativeIterator, this);
	      };
	    }
	  } // export additional methods


	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        redefine(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else _export({
	      target: NAME,
	      proto: true,
	      forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME
	    }, methods);
	  } // define iterator


	  if (( FORCED) && IterablePrototype[ITERATOR$1] !== defaultIterator) {
	    redefine(IterablePrototype, ITERATOR$1, defaultIterator, {
	      name: DEFAULT
	    });
	  }

	  iterators[NAME] = defaultIterator;
	  return methods;
	};

	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState = internalState.set;
	var getInternalState = internalState.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
	// https://tc39.es/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.es/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.es/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.es/ecma262/#sec-createarrayiterator

	var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
	  setInternalState(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject(iterated),
	    // target
	    index: 0,
	    // next index
	    kind: kind // kind

	  }); // `%ArrayIteratorPrototype%.next` method
	  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState(this);
	  var target = state.target;
	  var kind = state.kind;
	  var index = state.index++;

	  if (!target || index >= target.length) {
	    state.target = undefined;
	    return {
	      value: undefined,
	      done: true
	    };
	  }

	  if (kind == 'keys') return {
	    value: index,
	    done: false
	  };
	  if (kind == 'values') return {
	    value: target[index],
	    done: false
	  };
	  return {
	    value: [index, target[index]],
	    done: false
	  };
	}, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.es/ecma262/#sec-createmappedargumentsobject

	iterators.Arguments = iterators.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	var domIterables = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};

	var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');

	for (var COLLECTION_NAME in domIterables) {
	  var Collection = global$1[COLLECTION_NAME];
	  var CollectionPrototype = Collection && Collection.prototype;

	  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG$3) {
	    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
	  }

	  iterators[COLLECTION_NAME] = iterators.Array;
	}

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe


	var isArray = Array.isArray || function isArray(argument) {
	  return classofRaw(argument) == 'Array';
	};

	var noop = function () {
	  /* empty */
	};

	var empty = [];
	var construct = getBuiltIn('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec = functionUncurryThis(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

	var isConstructorModern = function (argument) {
	  if (!isCallable(argument)) return false;

	  try {
	    construct(noop, empty, argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};

	var isConstructorLegacy = function (argument) {
	  if (!isCallable(argument)) return false;

	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction':
	      return false;
	    // we can't check .prototype since constructors produced by .bind haven't it
	  }

	  return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
	}; // `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor


	var isConstructor = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
	    called = true;
	  }) || called;
	}) ? isConstructorLegacy : isConstructorModern;

	var SPECIES = wellKnownSymbol('species');
	var Array$1 = global$1.Array; // a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate

	var arraySpeciesConstructor = function (originalArray) {
	  var C;

	  if (isArray(originalArray)) {
	    C = originalArray.constructor; // cross-realm fallback

	    if (isConstructor(C) && (C === Array$1 || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  }

	  return C === undefined ? Array$1 : C;
	};

	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate


	var arraySpeciesCreate = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};

	var push$1 = functionUncurryThis([].push); // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation

	var createMethod$1 = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_REJECT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject($this);
	    var self = indexedObject(O);
	    var boundFunction = functionBindContext(callbackfn, that);
	    var length = lengthOfArrayLike(self);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;

	    for (; length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);

	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3:
	            return true;
	          // some

	          case 5:
	            return value;
	          // find

	          case 6:
	            return index;
	          // findIndex

	          case 2:
	            push$1(target, value);
	          // filter
	        } else switch (TYPE) {
	          case 4:
	            return false;
	          // every

	          case 7:
	            push$1(target, value);
	          // filterReject
	        }
	      }
	    }

	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	var arrayIteration = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod$1(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod$1(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod$1(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod$1(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod$1(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod$1(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod$1(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod$1(7)
	};

	var $forEach = arrayIteration.forEach;



	var STRICT_METHOD$1 = arrayMethodIsStrict('forEach'); // `Array.prototype.forEach` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.foreach

	var arrayForEach = !STRICT_METHOD$1 ? function forEach(callbackfn
	/* , thisArg */
	) {
	  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined); // eslint-disable-next-line es/no-array-prototype-foreach -- safe
	} : [].forEach;

	// `Array.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe


	_export({
	  target: 'Array',
	  proto: true,
	  forced: [].forEach != arrayForEach
	}, {
	  forEach: arrayForEach
	});

	var forEach = entryVirtual('Array').forEach;

	var forEach$1 = forEach;

	var ArrayPrototype$1 = Array.prototype;
	var DOMIterables = {
	  DOMTokenList: true,
	  NodeList: true
	};

	var forEach$2 = function (it) {
	  var own = it.forEach;
	  return it === ArrayPrototype$1 || objectIsPrototypeOf(ArrayPrototype$1, it) && own === ArrayPrototype$1.forEach || hasOwnProperty_1(DOMIterables, classof(it)) ? forEach$1 : own;
	};

	var forEach$3 = forEach$2;

	var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;



	var FAILS_ON_PRIMITIVES$1 = fails(function () {
	  nativeGetOwnPropertyDescriptor(1);
	});
	var FORCED = !descriptors || FAILS_ON_PRIMITIVES$1; // `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

	_export({
	  target: 'Object',
	  stat: true,
	  forced: FORCED,
	  sham: !descriptors
	}, {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
	    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
	  }
	});

	var getOwnPropertyDescriptor_1 = createCommonjsModule(function (module) {
	var Object = path.Object;

	var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
	  return Object.getOwnPropertyDescriptor(it, key);
	};

	if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;
	});

	var getOwnPropertyDescriptor$2 = getOwnPropertyDescriptor_1;

	var getOwnPropertyDescriptor$3 = getOwnPropertyDescriptor$2;

	var SPECIES$1 = wellKnownSymbol('species');

	var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return engineV8Version >= 51 || !fails(function () {
	    var array = [];
	    var constructor = array.constructor = {};

	    constructor[SPECIES$1] = function () {
	      return {
	        foo: 1
	      };
	    };

	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};

	var $filter = arrayIteration.filter;



	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter'); // `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species

	_export({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT
	}, {
	  filter: function filter(callbackfn
	  /* , thisArg */
	  ) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var filter = entryVirtual('Array').filter;

	var ArrayPrototype$2 = Array.prototype;

	var filter$1 = function (it) {
	  var own = it.filter;
	  return it === ArrayPrototype$2 || objectIsPrototypeOf(ArrayPrototype$2, it) && own === ArrayPrototype$2.filter ? filter : own;
	};

	var filter$2 = filter$1;

	var filter$3 = filter$2;

	var String$4 = global$1.String;

	var toString$2 = function (argument) {
	  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
	  return String$4(argument);
	};

	var arraySlice = functionUncurryThis([].slice);

	/* eslint-disable es/no-object-getownpropertynames -- safe */

	var $getOwnPropertyNames = objectGetOwnPropertyNames.f;



	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return $getOwnPropertyNames(it);
	  } catch (error) {
	    return arraySlice(windowNames);
	  }
	}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


	var f$6 = function getOwnPropertyNames(it) {
	  return windowNames && classofRaw(it) == 'Window' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
	};

	var objectGetOwnPropertyNamesExternal = {
		f: f$6
	};

	var f$7 = wellKnownSymbol;

	var wellKnownSymbolWrapped = {
		f: f$7
	};

	var defineProperty$5 = objectDefineProperty.f;

	var defineWellKnownSymbol = function (NAME) {
	  var Symbol = path.Symbol || (path.Symbol = {});
	  if (!hasOwnProperty_1(Symbol, NAME)) defineProperty$5(Symbol, NAME, {
	    value: wellKnownSymbolWrapped.f(NAME)
	  });
	};

	var $forEach$1 = arrayIteration.forEach;

	var HIDDEN = sharedKey('hidden');
	var SYMBOL = 'Symbol';
	var PROTOTYPE$1 = 'prototype';
	var TO_PRIMITIVE$1 = wellKnownSymbol('toPrimitive');
	var setInternalState$1 = internalState.set;
	var getInternalState$1 = internalState.getterFor(SYMBOL);
	var ObjectPrototype$1 = Object[PROTOTYPE$1];
	var $Symbol = global$1.Symbol;
	var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE$1];
	var TypeError$9 = global$1.TypeError;
	var QObject = global$1.QObject;
	var $stringify = getBuiltIn('JSON', 'stringify');
	var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
	var nativeDefineProperty = objectDefineProperty.f;
	var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
	var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
	var push$2 = functionUncurryThis([].push);
	var AllSymbols = shared('symbols');
	var ObjectPrototypeSymbols = shared('op-symbols');
	var StringToSymbolRegistry = shared('string-to-symbol-registry');
	var SymbolToStringRegistry = shared('symbol-to-string-registry');
	var WellKnownSymbolsStore$1 = shared('wks'); // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

	var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

	var setSymbolDescriptor = descriptors && fails(function () {
	  return objectCreate(nativeDefineProperty({}, 'a', {
	    get: function () {
	      return nativeDefineProperty(this, 'a', {
	        value: 7
	      }).a;
	    }
	  })).a != 7;
	}) ? function (O, P, Attributes) {
	  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype$1, P);
	  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
	  nativeDefineProperty(O, P, Attributes);

	  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
	    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
	  }
	} : nativeDefineProperty;

	var wrap = function (tag, description) {
	  var symbol = AllSymbols[tag] = objectCreate(SymbolPrototype);
	  setInternalState$1(symbol, {
	    type: SYMBOL,
	    tag: tag,
	    description: description
	  });
	  if (!descriptors) symbol.description = description;
	  return symbol;
	};

	var $defineProperty$1 = function defineProperty(O, P, Attributes) {
	  if (O === ObjectPrototype$1) $defineProperty$1(ObjectPrototypeSymbols, P, Attributes);
	  anObject(O);
	  var key = toPropertyKey(P);
	  anObject(Attributes);

	  if (hasOwnProperty_1(AllSymbols, key)) {
	    if (!Attributes.enumerable) {
	      if (!hasOwnProperty_1(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
	      O[HIDDEN][key] = true;
	    } else {
	      if (hasOwnProperty_1(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
	      Attributes = objectCreate(Attributes, {
	        enumerable: createPropertyDescriptor(0, false)
	      });
	    }

	    return setSymbolDescriptor(O, key, Attributes);
	  }

	  return nativeDefineProperty(O, key, Attributes);
	};

	var $defineProperties = function defineProperties(O, Properties) {
	  anObject(O);
	  var properties = toIndexedObject(Properties);
	  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
	  $forEach$1(keys, function (key) {
	    if (!descriptors || functionCall($propertyIsEnumerable$1, properties, key)) $defineProperty$1(O, key, properties[key]);
	  });
	  return O;
	};

	var $create = function create(O, Properties) {
	  return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
	};

	var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
	  var P = toPropertyKey(V);
	  var enumerable = functionCall(nativePropertyIsEnumerable, this, P);
	  if (this === ObjectPrototype$1 && hasOwnProperty_1(AllSymbols, P) && !hasOwnProperty_1(ObjectPrototypeSymbols, P)) return false;
	  return enumerable || !hasOwnProperty_1(this, P) || !hasOwnProperty_1(AllSymbols, P) || hasOwnProperty_1(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
	};

	var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(O, P) {
	  var it = toIndexedObject(O);
	  var key = toPropertyKey(P);
	  if (it === ObjectPrototype$1 && hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(ObjectPrototypeSymbols, key)) return;
	  var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);

	  if (descriptor && hasOwnProperty_1(AllSymbols, key) && !(hasOwnProperty_1(it, HIDDEN) && it[HIDDEN][key])) {
	    descriptor.enumerable = true;
	  }

	  return descriptor;
	};

	var $getOwnPropertyNames$1 = function getOwnPropertyNames(O) {
	  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
	  var result = [];
	  $forEach$1(names, function (key) {
	    if (!hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(hiddenKeys, key)) push$2(result, key);
	  });
	  return result;
	};

	var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
	  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
	  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
	  var result = [];
	  $forEach$1(names, function (key) {
	    if (hasOwnProperty_1(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwnProperty_1(ObjectPrototype$1, key))) {
	      push$2(result, AllSymbols[key]);
	    }
	  });
	  return result;
	}; // `Symbol` constructor
	// https://tc39.es/ecma262/#sec-symbol-constructor


	if (!nativeSymbol) {
	  $Symbol = function Symbol() {
	    if (objectIsPrototypeOf(SymbolPrototype, this)) throw TypeError$9('Symbol is not a constructor');
	    var description = !arguments.length || arguments[0] === undefined ? undefined : toString$2(arguments[0]);
	    var tag = uid(description);

	    var setter = function (value) {
	      if (this === ObjectPrototype$1) functionCall(setter, ObjectPrototypeSymbols, value);
	      if (hasOwnProperty_1(this, HIDDEN) && hasOwnProperty_1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
	    };

	    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, {
	      configurable: true,
	      set: setter
	    });
	    return wrap(tag, description);
	  };

	  SymbolPrototype = $Symbol[PROTOTYPE$1];
	  redefine(SymbolPrototype, 'toString', function toString() {
	    return getInternalState$1(this).tag;
	  });
	  redefine($Symbol, 'withoutSetter', function (description) {
	    return wrap(uid(description), description);
	  });
	  objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
	  objectDefineProperty.f = $defineProperty$1;
	  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$1;
	  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames$1;
	  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

	  wellKnownSymbolWrapped.f = function (name) {
	    return wrap(wellKnownSymbol(name), name);
	  };

	  if (descriptors) {
	    // https://github.com/tc39/proposal-Symbol-description
	    nativeDefineProperty(SymbolPrototype, 'description', {
	      configurable: true,
	      get: function description() {
	        return getInternalState$1(this).description;
	      }
	    });
	  }
	}

	_export({
	  global: true,
	  wrap: true,
	  forced: !nativeSymbol,
	  sham: !nativeSymbol
	}, {
	  Symbol: $Symbol
	});
	$forEach$1(objectKeys(WellKnownSymbolsStore$1), function (name) {
	  defineWellKnownSymbol(name);
	});
	_export({
	  target: SYMBOL,
	  stat: true,
	  forced: !nativeSymbol
	}, {
	  // `Symbol.for` method
	  // https://tc39.es/ecma262/#sec-symbol.for
	  'for': function (key) {
	    var string = toString$2(key);
	    if (hasOwnProperty_1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
	    var symbol = $Symbol(string);
	    StringToSymbolRegistry[string] = symbol;
	    SymbolToStringRegistry[symbol] = string;
	    return symbol;
	  },
	  // `Symbol.keyFor` method
	  // https://tc39.es/ecma262/#sec-symbol.keyfor
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError$9(sym + ' is not a symbol');
	    if (hasOwnProperty_1(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
	  },
	  useSetter: function () {
	    USE_SETTER = true;
	  },
	  useSimple: function () {
	    USE_SETTER = false;
	  }
	});
	_export({
	  target: 'Object',
	  stat: true,
	  forced: !nativeSymbol,
	  sham: !descriptors
	}, {
	  // `Object.create` method
	  // https://tc39.es/ecma262/#sec-object.create
	  create: $create,
	  // `Object.defineProperty` method
	  // https://tc39.es/ecma262/#sec-object.defineproperty
	  defineProperty: $defineProperty$1,
	  // `Object.defineProperties` method
	  // https://tc39.es/ecma262/#sec-object.defineproperties
	  defineProperties: $defineProperties,
	  // `Object.getOwnPropertyDescriptor` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1
	});
	_export({
	  target: 'Object',
	  stat: true,
	  forced: !nativeSymbol
	}, {
	  // `Object.getOwnPropertyNames` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertynames
	  getOwnPropertyNames: $getOwnPropertyNames$1,
	  // `Object.getOwnPropertySymbols` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
	  getOwnPropertySymbols: $getOwnPropertySymbols
	}); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443

	_export({
	  target: 'Object',
	  stat: true,
	  forced: fails(function () {
	    objectGetOwnPropertySymbols.f(1);
	  })
	}, {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return objectGetOwnPropertySymbols.f(toObject(it));
	  }
	}); // `JSON.stringify` method behavior with symbols
	// https://tc39.es/ecma262/#sec-json.stringify

	if ($stringify) {
	  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
	    var symbol = $Symbol(); // MS Edge converts symbol values to JSON as {}

	    return $stringify([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
	    || $stringify({
	      a: symbol
	    }) != '{}' // V8 throws on boxed symbols
	    || $stringify(Object(symbol)) != '{}';
	  });
	  _export({
	    target: 'JSON',
	    stat: true,
	    forced: FORCED_JSON_STRINGIFY
	  }, {
	    // eslint-disable-next-line no-unused-vars -- required for `.length`
	    stringify: function stringify(it, replacer, space) {
	      var args = arraySlice(arguments);
	      var $replacer = replacer;
	      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

	      if (!isArray(replacer)) replacer = function (key, value) {
	        if (isCallable($replacer)) value = functionCall($replacer, this, key, value);
	        if (!isSymbol(value)) return value;
	      };
	      args[1] = replacer;
	      return functionApply($stringify, null, args);
	    }
	  });
	} // `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive


	if (!SymbolPrototype[TO_PRIMITIVE$1]) {
	  var valueOf = SymbolPrototype.valueOf; // eslint-disable-next-line no-unused-vars -- required for .length

	  redefine(SymbolPrototype, TO_PRIMITIVE$1, function (hint) {
	    // TODO: improve hint logic
	    return functionCall(valueOf, this);
	  });
	} // `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag


	setToStringTag($Symbol, SYMBOL);
	hiddenKeys[HIDDEN] = true;

	var getOwnPropertySymbols$1 = path.Object.getOwnPropertySymbols;

	var getOwnPropertySymbols$2 = getOwnPropertySymbols$1;

	var getOwnPropertySymbols$3 = getOwnPropertySymbols$2;

	var keys$5 = keys$1;

	var defineProperty$6 = defineProperty$2;

	var defineProperty$7 = defineProperty$6;

	function _defineProperty$1(obj, key, value) {
	  if (key in obj) {
	    defineProperty$7(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var defineProperty$8 = _defineProperty$1;

	/** Used to map aliases to their real names. */

	var _mapping = createCommonjsModule(function (module, exports) {
	exports.aliasToReal = {

	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',

	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',

	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};

	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};

	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};

	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};

	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};

	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};

	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};

	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};

	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};

	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());

	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};

	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};

	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};
	});

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	var placeholder = {};

	/** Built-in value reference. */
	var push$3 = Array.prototype.push;

	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}

	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}

	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);

	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}

	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}

	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);

	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);

	    if (array) {
	      push$3.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push$3.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}

	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}

	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var isLib = typeof name == 'function',
	      isObj = name === Object(name);

	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});

	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };

	  var defaultHolder = isLib ? func : placeholder,
	      forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      pristine = isLib ? func.runInContext() : undefined;

	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isError': util.isError,
	    'isFunction': util.isFunction,
	    'isWeakMap': util.isWeakMap,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };

	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isError = helpers.isError,
	      isFunction = helpers.isFunction,
	      isWeakMap = helpers.isWeakMap,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;

	  var aryMethodKeys = keys(_mapping.aryMethod);

	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;

	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });

	        mixin(func, Object(source));

	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = _mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && _mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }

	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }

	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !_mapping.skipFixed[name])) {
	      var data = _mapping.methodSpread[name],
	          start = data && data.start;

	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }

	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !_mapping.skipRearg[name]))
	      ? rearg(func, _mapping.methodRearg[name] || _mapping.aryRearg[n])
	      : func;
	  }

	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);

	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;

	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];

	      if (value != null &&
	          !(isFunction(value) || isError(value) || isWeakMap(value))) {
	        nested[key] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }

	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }

	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = _mapping.aliasToReal[name] || name,
	        methodName = _mapping.remap[realName] || realName,
	        oldOptions = options;

	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);

	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }

	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }

	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }

	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }

	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func, placeholder) {
	    var result,
	        realName = _mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];

	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (_mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (_mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (_mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(_mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = _mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;

	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });

	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    result.placeholder = func.placeholder = placeholder;

	    return result;
	  }

	  /*--------------------------------------------------------------------------*/

	  if (!isObj) {
	    return wrap(name, func, defaultHolder);
	  }
	  var _ = func;

	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(_mapping.aryMethod[aryKey], function(key) {
	      var func = _[_mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func, _)]);
	      }
	    });
	  });

	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });

	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });

	  _.convert = convertLib;
	  _.placeholder = _;

	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(_mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });

	  return _;
	}

	var _baseConvert = baseConvert;

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}

	var identity_1 = identity;

	/** Detect free variable `global` from Node.js. */

	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	var _freeGlobal = freeGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = _freeGlobal || freeSelf || Function('return this')();

	var _root = root;

	/** Built-in value references. */
	var Symbol$2 = _root.Symbol;

	var _Symbol = Symbol$2;

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Built-in value references. */
	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty$2.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	var _getRawTag = getRawTag;

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$1.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString$1(value) {
	  return nativeObjectToString$1.call(value);
	}

	var _objectToString = objectToString$1;

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag$1 && symToStringTag$1 in Object(value))
	    ? _getRawTag(value)
	    : _objectToString(value);
	}

	var _baseGetTag = baseGetTag;

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject$1(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	var isObject_1 = isObject$1;

	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject_1(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = _baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	var isFunction_1 = isFunction;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = _root['__core-js_shared__'];

	var _coreJsData = coreJsData;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	var _isMasked = isMasked;

	/** Used for built-in method references. */
	var funcProto = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	var _toSource = toSource;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto$1 = Function.prototype,
	    objectProto$2 = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString$1.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject_1(value) || _isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(_toSource(value));
	}

	var _baseIsNative = baseIsNative;

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	var _getValue = getValue;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = _getValue(object, key);
	  return _baseIsNative(value) ? value : undefined;
	}

	var _getNative = getNative;

	/* Built-in method references that are verified to be native. */
	var WeakMap$3 = _getNative(_root, 'WeakMap');

	var _WeakMap = WeakMap$3;

	/** Used to store function metadata. */
	var metaMap = _WeakMap && new _WeakMap;

	var _metaMap = metaMap;

	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !_metaMap ? identity_1 : function(func, data) {
	  _metaMap.set(func, data);
	  return func;
	};

	var _baseSetData = baseSetData;

	/** Built-in value references. */
	var objectCreate$1 = Object.create;

	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject_1(proto)) {
	      return {};
	    }
	    if (objectCreate$1) {
	      return objectCreate$1(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());

	var _baseCreate = baseCreate;

	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = _baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);

	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject_1(result) ? result : thisBinding;
	  };
	}

	var _createCtor = createCtor;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;

	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = _createCtor(func);

	  function wrapper() {
	    var fn = (this && this !== _root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}

	var _createBind = createBind;

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply$1(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}

	var _apply = apply$1;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;

	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;

	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}

	var _composeArgs = composeArgs;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax$1 = Math.max;

	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax$1(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;

	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}

	var _composeArgsRight = composeArgsRight;

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;

	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}

	var _countHolders = countHolders;

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}

	var _baseLodash = baseLodash;

	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;

	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}

	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = _baseCreate(_baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;

	var _LazyWrapper = LazyWrapper;

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop$1() {
	  // No operation performed.
	}

	var noop_1 = noop$1;

	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !_metaMap ? noop_1 : function(func) {
	  return _metaMap.get(func);
	};

	var _getData = getData;

	/** Used to lookup unminified function names. */
	var realNames = {};

	var _realNames = realNames;

	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$4 = objectProto$3.hasOwnProperty;

	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = _realNames[result],
	      length = hasOwnProperty$4.call(_realNames, result) ? array.length : 0;

	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}

	var _getFuncName = getFuncName;

	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}

	LodashWrapper.prototype = _baseCreate(_baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;

	var _LodashWrapper = LodashWrapper;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray$1 = Array.isArray;

	var isArray_1 = isArray$1;

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	var isObjectLike_1 = isObjectLike;

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	var _copyArray = copyArray;

	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof _LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new _LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = _copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}

	var _wrapperClone = wrapperClone;

	/** Used for built-in method references. */
	var objectProto$4 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$5 = objectProto$4.hasOwnProperty;

	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike_1(value) && !isArray_1(value) && !(value instanceof _LazyWrapper)) {
	    if (value instanceof _LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty$5.call(value, '__wrapped__')) {
	      return _wrapperClone(value);
	    }
	  }
	  return new _LodashWrapper(value);
	}

	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = _baseLodash.prototype;
	lodash.prototype.constructor = lodash;

	var wrapperLodash = lodash;

	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = _getFuncName(func),
	      other = wrapperLodash[funcName];

	  if (typeof other != 'function' || !(funcName in _LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = _getData(other);
	  return !!data && func === data[0];
	}

	var _isLaziable = isLaziable;

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;

	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;

	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);

	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}

	var _shortOut = shortOut;

	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = _shortOut(_baseSetData);

	var _setData = setData;

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;

	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}

	var _getWrapDetails = getWrapDetails;

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}

	var _insertWrapDetails = insertWrapDetails;

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}

	var constant_1 = constant;

	var defineProperty$9 = (function() {
	  try {
	    var func = _getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());

	var _defineProperty$2 = defineProperty$9;

	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !_defineProperty$2 ? identity_1 : function(func, string) {
	  return _defineProperty$2(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant_1(string),
	    'writable': true
	  });
	};

	var _baseSetToString = baseSetToString;

	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = _shortOut(_baseSetToString);

	var _setToString = setToString;

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	var _arrayEach = arrayEach;

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);

	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}

	var _baseFindIndex = baseFindIndex;

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}

	var _baseIsNaN = baseIsNaN;

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;

	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}

	var _strictIndexOf = strictIndexOf;

	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? _strictIndexOf(array, value, fromIndex)
	    : _baseFindIndex(array, _baseIsNaN, fromIndex);
	}

	var _baseIndexOf = baseIndexOf;

	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes$1(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && _baseIndexOf(array, value, 0) > -1;
	}

	var _arrayIncludes = arrayIncludes$1;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG$1 = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;

	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG$1],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];

	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  _arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !_arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}

	var _updateWrapDetails = updateWrapDetails;

	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return _setToString(wrapper, _insertWrapDetails(source, _updateWrapDetails(_getWrapDetails(source), bitmask)));
	}

	var _setWrapToString = setWrapToString;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG$2 = 1,
	    WRAP_BIND_KEY_FLAG$1 = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG$1 = 8,
	    WRAP_PARTIAL_FLAG$1 = 32,
	    WRAP_PARTIAL_RIGHT_FLAG$1 = 64;

	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG$1,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;

	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG$1 : WRAP_PARTIAL_RIGHT_FLAG$1);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG$1 : WRAP_PARTIAL_FLAG$1);

	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG$2 | WRAP_BIND_KEY_FLAG$1);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];

	  var result = wrapFunc.apply(undefined, newData);
	  if (_isLaziable(func)) {
	    _setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return _setWrapToString(result, func, bitmask);
	}

	var _createRecurry = createRecurry;

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}

	var _getHolder = getHolder;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	var _isIndex = isIndex;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;

	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = _copyArray(array);

	  while (length--) {
	    var index = indexes[length];
	    array[length] = _isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}

	var _reorder = reorder;

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';

	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}

	var _replaceHolders = replaceHolders;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG$3 = 1,
	    WRAP_BIND_KEY_FLAG$2 = 2,
	    WRAP_CURRY_FLAG$2 = 8,
	    WRAP_CURRY_RIGHT_FLAG$1 = 16,
	    WRAP_ARY_FLAG$1 = 128,
	    WRAP_FLIP_FLAG$1 = 512;

	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG$1,
	      isBind = bitmask & WRAP_BIND_FLAG$3,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG$2,
	      isCurried = bitmask & (WRAP_CURRY_FLAG$2 | WRAP_CURRY_RIGHT_FLAG$1),
	      isFlip = bitmask & WRAP_FLIP_FLAG$1,
	      Ctor = isBindKey ? undefined : _createCtor(func);

	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;

	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = _getHolder(wrapper),
	          holdersCount = _countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = _composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = _composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = _replaceHolders(args, placeholder);
	      return _createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;

	    length = args.length;
	    if (argPos) {
	      args = _reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== _root && this instanceof wrapper) {
	      fn = Ctor || _createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}

	var _createHybrid = createHybrid;

	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = _createCtor(func);

	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = _getHolder(wrapper);

	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : _replaceHolders(args, placeholder);

	    length -= holders.length;
	    if (length < arity) {
	      return _createRecurry(
	        func, bitmask, _createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== _root && this instanceof wrapper) ? Ctor : func;
	    return _apply(fn, this, args);
	  }
	  return wrapper;
	}

	var _createCurry = createCurry;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG$4 = 1;

	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG$4,
	      Ctor = _createCtor(func);

	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== _root && this instanceof wrapper) ? Ctor : func;

	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return _apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}

	var _createPartial = createPartial;

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER$1 = '__lodash_placeholder__';

	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG$5 = 1,
	    WRAP_BIND_KEY_FLAG$3 = 2,
	    WRAP_CURRY_BOUND_FLAG$1 = 4,
	    WRAP_CURRY_FLAG$3 = 8,
	    WRAP_ARY_FLAG$2 = 128,
	    WRAP_REARG_FLAG$1 = 256;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin$1 = Math.min;

	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG$5 | WRAP_BIND_KEY_FLAG$3 | WRAP_ARY_FLAG$2);

	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG$2) && (bitmask == WRAP_CURRY_FLAG$3)) ||
	    ((srcBitmask == WRAP_ARY_FLAG$2) && (bitmask == WRAP_REARG_FLAG$1) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG$2 | WRAP_REARG_FLAG$1)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG$3));

	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG$5) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG$5 ? 0 : WRAP_CURRY_BOUND_FLAG$1;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? _composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? _replaceHolders(data[3], PLACEHOLDER$1) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? _composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? _replaceHolders(data[5], PLACEHOLDER$1) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG$2) {
	    data[8] = data[8] == null ? source[8] : nativeMin$1(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;

	  return data;
	}

	var _mergeData = mergeData;

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol$1(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
	}

	var isSymbol_1 = isSymbol$1;

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol_1(value)) {
	    return NAN;
	  }
	  if (isObject_1(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject_1(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	var toNumber_1 = toNumber;

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;

	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber_1(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}

	var toFinite_1 = toFinite;

	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite_1(value),
	      remainder = result % 1;

	  return result === result ? (remainder ? result - remainder : result) : 0;
	}

	var toInteger_1 = toInteger;

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG$6 = 1,
	    WRAP_BIND_KEY_FLAG$4 = 2,
	    WRAP_CURRY_FLAG$4 = 8,
	    WRAP_CURRY_RIGHT_FLAG$2 = 16,
	    WRAP_PARTIAL_FLAG$2 = 32,
	    WRAP_PARTIAL_RIGHT_FLAG$2 = 64;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax$2 = Math.max;

	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG$4;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG$2 | WRAP_PARTIAL_RIGHT_FLAG$2);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax$2(toInteger_1(ary), 0);
	  arity = arity === undefined ? arity : toInteger_1(arity);
	  length -= holders ? holders.length : 0;

	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG$2) {
	    var partialsRight = partials,
	        holdersRight = holders;

	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : _getData(func);

	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];

	  if (data) {
	    _mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax$2(newData[9] - length, 0);

	  if (!arity && bitmask & (WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2)) {
	    bitmask &= ~(WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG$6) {
	    var result = _createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG$4 || bitmask == WRAP_CURRY_RIGHT_FLAG$2) {
	    result = _createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG$2 || bitmask == (WRAP_BIND_FLAG$6 | WRAP_PARTIAL_FLAG$2)) && !holders.length) {
	    result = _createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = _createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? _baseSetData : _setData;
	  return _setWrapToString(setter(result, newData), func, bitmask);
	}

	var _createWrap = createWrap;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_ARY_FLAG$3 = 128;

	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return _createWrap(func, WRAP_ARY_FLAG$3, undefined, undefined, undefined, undefined, n);
	}

	var ary_1 = ary;

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && _defineProperty$2) {
	    _defineProperty$2(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	var _baseAssignValue = baseAssignValue;

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	var eq_1 = eq;

	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$6 = objectProto$5.hasOwnProperty;

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    _baseAssignValue(object, key, value);
	  }
	}

	var _assignValue = assignValue;

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;

	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      _baseAssignValue(object, key, newValue);
	    } else {
	      _assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}

	var _copyObject = copyObject;

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	var _baseTimes = baseTimes;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
	}

	var _baseIsArguments = baseIsArguments;

	/** Used for built-in method references. */
	var objectProto$6 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$7 = objectProto$6.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
	  return isObjectLike_1(value) && hasOwnProperty$7.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	var isArguments_1 = isArguments;

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	var stubFalse_1 = stubFalse;

	var isBuffer_1 = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports =  exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? _root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse_1;

	module.exports = isBuffer;
	});

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
	}

	var isLength_1 = isLength;

	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag$1 = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike_1(value) &&
	    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
	}

	var _baseIsTypedArray = baseIsTypedArray;

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	var _baseUnary = baseUnary;

	var _nodeUtil = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports =  exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && _freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil;
	});

	/* Node.js helper references. */
	var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

	var isTypedArray_1 = isTypedArray;

	/** Used for built-in method references. */
	var objectProto$7 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$8 = objectProto$7.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray_1(value),
	      isArg = !isArr && isArguments_1(value),
	      isBuff = !isArr && !isArg && isBuffer_1(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? _baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$8.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           _isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _arrayLikeKeys = arrayLikeKeys;

	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

	  return value === proto;
	}

	var _isPrototype = isPrototype;

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	var _overArg = overArg;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = _overArg(Object.keys, Object);

	var _nativeKeys = nativeKeys;

	/** Used for built-in method references. */
	var objectProto$9 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$9 = objectProto$9.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!_isPrototype(object)) {
	    return _nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$9.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _baseKeys = baseKeys;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength_1(value.length) && !isFunction_1(value);
	}

	var isArrayLike_1 = isArrayLike;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys$6(object) {
	  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
	}

	var keys_1 = keys$6;

	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && _copyObject(source, keys_1(source), object);
	}

	var _baseAssign = baseAssign;

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	var _listCacheClear = listCacheClear;

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq_1(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	var _assocIndexOf = assocIndexOf;

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;

	/** Built-in value references. */
	var splice = arrayProto.splice;

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	var _listCacheDelete = listCacheDelete;

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	var _listCacheGet = listCacheGet;

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return _assocIndexOf(this.__data__, key) > -1;
	}

	var _listCacheHas = listCacheHas;

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	var _listCacheSet = listCacheSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = _listCacheClear;
	ListCache.prototype['delete'] = _listCacheDelete;
	ListCache.prototype.get = _listCacheGet;
	ListCache.prototype.has = _listCacheHas;
	ListCache.prototype.set = _listCacheSet;

	var _ListCache = ListCache;

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new _ListCache;
	  this.size = 0;
	}

	var _stackClear = stackClear;

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	var _stackDelete = stackDelete;

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	var _stackGet = stackGet;

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	var _stackHas = stackHas;

	/* Built-in method references that are verified to be native. */
	var Map$1 = _getNative(_root, 'Map');

	var _Map = Map$1;

	/* Built-in method references that are verified to be native. */
	var nativeCreate = _getNative(Object, 'create');

	var _nativeCreate = nativeCreate;

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
	  this.size = 0;
	}

	var _hashClear = hashClear;

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _hashDelete = hashDelete;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used for built-in method references. */
	var objectProto$a = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$a = objectProto$a.hasOwnProperty;

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (_nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty$a.call(data, key) ? data[key] : undefined;
	}

	var _hashGet = hashGet;

	/** Used for built-in method references. */
	var objectProto$b = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$b = objectProto$b.hasOwnProperty;

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$b.call(data, key);
	}

	var _hashHas = hashHas;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
	  return this;
	}

	var _hashSet = hashSet;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = _hashClear;
	Hash.prototype['delete'] = _hashDelete;
	Hash.prototype.get = _hashGet;
	Hash.prototype.has = _hashHas;
	Hash.prototype.set = _hashSet;

	var _Hash = Hash;

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new _Hash,
	    'map': new (_Map || _ListCache),
	    'string': new _Hash
	  };
	}

	var _mapCacheClear = mapCacheClear;

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	var _isKeyable = isKeyable;

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return _isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	var _getMapData = getMapData;

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = _getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _mapCacheDelete = mapCacheDelete;

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return _getMapData(this, key).get(key);
	}

	var _mapCacheGet = mapCacheGet;

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return _getMapData(this, key).has(key);
	}

	var _mapCacheHas = mapCacheHas;

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = _getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	var _mapCacheSet = mapCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = _mapCacheClear;
	MapCache.prototype['delete'] = _mapCacheDelete;
	MapCache.prototype.get = _mapCacheGet;
	MapCache.prototype.has = _mapCacheHas;
	MapCache.prototype.set = _mapCacheSet;

	var _MapCache = MapCache;

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof _ListCache) {
	    var pairs = data.__data__;
	    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new _MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	var _stackSet = stackSet;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new _ListCache(entries);
	  this.size = data.size;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = _stackClear;
	Stack.prototype['delete'] = _stackDelete;
	Stack.prototype.get = _stackGet;
	Stack.prototype.has = _stackHas;
	Stack.prototype.set = _stackSet;

	var _Stack = Stack;

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _nativeKeysIn = nativeKeysIn;

	/** Used for built-in method references. */
	var objectProto$c = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$c = objectProto$c.hasOwnProperty;

	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject_1(object)) {
	    return _nativeKeysIn(object);
	  }
	  var isProto = _isPrototype(object),
	      result = [];

	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty$c.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _baseKeysIn = baseKeysIn;

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
	}

	var keysIn_1 = keysIn;

	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && _copyObject(source, keysIn_1(source), object);
	}

	var _baseAssignIn = baseAssignIn;

	var _cloneBuffer = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports =  exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? _root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer;
	});

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	var _arrayFilter = arrayFilter;

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	var stubArray_1 = stubArray;

	/** Used for built-in method references. */
	var objectProto$d = Object.prototype;

	/** Built-in value references. */
	var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable$1.call(object, symbol);
	  });
	};

	var _getSymbols = getSymbols;

	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return _copyObject(source, _getSymbols(source), object);
	}

	var _copySymbols = copySymbols;

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	var _arrayPush = arrayPush;

	/** Built-in value references. */
	var getPrototype = _overArg(Object.getPrototypeOf, Object);

	var _getPrototype = getPrototype;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
	  var result = [];
	  while (object) {
	    _arrayPush(result, _getSymbols(object));
	    object = _getPrototype(object);
	  }
	  return result;
	};

	var _getSymbolsIn = getSymbolsIn;

	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return _copyObject(source, _getSymbolsIn(source), object);
	}

	var _copySymbolsIn = copySymbolsIn;

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
	}

	var _baseGetAllKeys = baseGetAllKeys;

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return _baseGetAllKeys(object, keys_1, _getSymbols);
	}

	var _getAllKeys = getAllKeys;

	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
	}

	var _getAllKeysIn = getAllKeysIn;

	/* Built-in method references that are verified to be native. */
	var DataView = _getNative(_root, 'DataView');

	var _DataView = DataView;

	/* Built-in method references that are verified to be native. */
	var Promise$1 = _getNative(_root, 'Promise');

	var _Promise = Promise$1;

	/* Built-in method references that are verified to be native. */
	var Set = _getNative(_root, 'Set');

	var _Set = Set;

	/** `Object#toString` result references. */
	var mapTag$1 = '[object Map]',
	    objectTag$1 = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag$1 = '[object Set]',
	    weakMapTag$1 = '[object WeakMap]';

	var dataViewTag$1 = '[object DataView]';

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = _toSource(_DataView),
	    mapCtorString = _toSource(_Map),
	    promiseCtorString = _toSource(_Promise),
	    setCtorString = _toSource(_Set),
	    weakMapCtorString = _toSource(_WeakMap);

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = _baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
	    (_Map && getTag(new _Map) != mapTag$1) ||
	    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
	    (_Set && getTag(new _Set) != setTag$1) ||
	    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
	  getTag = function(value) {
	    var result = _baseGetTag(value),
	        Ctor = result == objectTag$1 ? value.constructor : undefined,
	        ctorString = Ctor ? _toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag$1;
	        case mapCtorString: return mapTag$1;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag$1;
	        case weakMapCtorString: return weakMapTag$1;
	      }
	    }
	    return result;
	  };
	}

	var _getTag = getTag;

	/** Used for built-in method references. */
	var objectProto$e = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$d = objectProto$e.hasOwnProperty;

	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);

	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty$d.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}

	var _initCloneArray = initCloneArray;

	/** Built-in value references. */
	var Uint8Array = _root.Uint8Array;

	var _Uint8Array = Uint8Array;

	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
	  return result;
	}

	var _cloneArrayBuffer = cloneArrayBuffer;

	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}

	var _cloneDataView = cloneDataView;

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;

	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}

	var _cloneRegExp = cloneRegExp;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = _Symbol ? _Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}

	var _cloneSymbol = cloneSymbol;

	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}

	var _cloneTypedArray = cloneTypedArray;

	/** `Object#toString` result references. */
	var boolTag$1 = '[object Boolean]',
	    dateTag$1 = '[object Date]',
	    mapTag$2 = '[object Map]',
	    numberTag$1 = '[object Number]',
	    regexpTag$1 = '[object RegExp]',
	    setTag$2 = '[object Set]',
	    stringTag$1 = '[object String]',
	    symbolTag$1 = '[object Symbol]';

	var arrayBufferTag$1 = '[object ArrayBuffer]',
	    dataViewTag$2 = '[object DataView]',
	    float32Tag$1 = '[object Float32Array]',
	    float64Tag$1 = '[object Float64Array]',
	    int8Tag$1 = '[object Int8Array]',
	    int16Tag$1 = '[object Int16Array]',
	    int32Tag$1 = '[object Int32Array]',
	    uint8Tag$1 = '[object Uint8Array]',
	    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
	    uint16Tag$1 = '[object Uint16Array]',
	    uint32Tag$1 = '[object Uint32Array]';

	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag$1:
	      return _cloneArrayBuffer(object);

	    case boolTag$1:
	    case dateTag$1:
	      return new Ctor(+object);

	    case dataViewTag$2:
	      return _cloneDataView(object, isDeep);

	    case float32Tag$1: case float64Tag$1:
	    case int8Tag$1: case int16Tag$1: case int32Tag$1:
	    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
	      return _cloneTypedArray(object, isDeep);

	    case mapTag$2:
	      return new Ctor;

	    case numberTag$1:
	    case stringTag$1:
	      return new Ctor(object);

	    case regexpTag$1:
	      return _cloneRegExp(object);

	    case setTag$2:
	      return new Ctor;

	    case symbolTag$1:
	      return _cloneSymbol(object);
	  }
	}

	var _initCloneByTag = initCloneByTag;

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !_isPrototype(object))
	    ? _baseCreate(_getPrototype(object))
	    : {};
	}

	var _initCloneObject = initCloneObject;

	/** `Object#toString` result references. */
	var mapTag$3 = '[object Map]';

	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
	}

	var _baseIsMap = baseIsMap;

	/* Node.js helper references. */
	var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

	var isMap_1 = isMap;

	/** `Object#toString` result references. */
	var setTag$3 = '[object Set]';

	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike_1(value) && _getTag(value) == setTag$3;
	}

	var _baseIsSet = baseIsSet;

	/* Node.js helper references. */
	var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

	var isSet_1 = isSet;

	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;

	/** `Object#toString` result references. */
	var argsTag$2 = '[object Arguments]',
	    arrayTag$1 = '[object Array]',
	    boolTag$2 = '[object Boolean]',
	    dateTag$2 = '[object Date]',
	    errorTag$1 = '[object Error]',
	    funcTag$2 = '[object Function]',
	    genTag$1 = '[object GeneratorFunction]',
	    mapTag$4 = '[object Map]',
	    numberTag$2 = '[object Number]',
	    objectTag$2 = '[object Object]',
	    regexpTag$2 = '[object RegExp]',
	    setTag$4 = '[object Set]',
	    stringTag$2 = '[object String]',
	    symbolTag$2 = '[object Symbol]',
	    weakMapTag$2 = '[object WeakMap]';

	var arrayBufferTag$2 = '[object ArrayBuffer]',
	    dataViewTag$3 = '[object DataView]',
	    float32Tag$2 = '[object Float32Array]',
	    float64Tag$2 = '[object Float64Array]',
	    int8Tag$2 = '[object Int8Array]',
	    int16Tag$2 = '[object Int16Array]',
	    int32Tag$2 = '[object Int32Array]',
	    uint8Tag$2 = '[object Uint8Array]',
	    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
	    uint16Tag$2 = '[object Uint16Array]',
	    uint32Tag$2 = '[object Uint32Array]';

	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
	cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
	cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
	cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
	cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
	cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
	cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
	cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
	cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] =
	cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
	cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
	cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
	cloneableTags[weakMapTag$2] = false;

	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;

	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject_1(value)) {
	    return value;
	  }
	  var isArr = isArray_1(value);
	  if (isArr) {
	    result = _initCloneArray(value);
	    if (!isDeep) {
	      return _copyArray(value, result);
	    }
	  } else {
	    var tag = _getTag(value),
	        isFunc = tag == funcTag$2 || tag == genTag$1;

	    if (isBuffer_1(value)) {
	      return _cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? _copySymbolsIn(value, _baseAssignIn(result, value))
	          : _copySymbols(value, _baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = _initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new _Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);

	  if (isSet_1(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap_1(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }

	  var keysFunc = isFull
	    ? (isFlat ? _getAllKeysIn : _getAllKeys)
	    : (isFlat ? keysIn_1 : keys_1);

	  var props = isArr ? undefined : keysFunc(value);
	  _arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}

	var _baseClone = baseClone;

	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG$1 = 4;

	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return _baseClone(value, CLONE_SYMBOLS_FLAG$1);
	}

	var clone_1 = clone;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG$5 = 8;

	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = _createWrap(func, WRAP_CURRY_FLAG$5, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}

	// Assign default placeholders.
	curry.placeholder = {};

	var curry_1 = curry;

	/** `Object#toString` result references. */
	var objectTag$3 = '[object Object]';

	/** Used for built-in method references. */
	var funcProto$2 = Function.prototype,
	    objectProto$f = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$2 = funcProto$2.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$e = objectProto$f.hasOwnProperty;

	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString$2.call(Object);

	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
	    return false;
	  }
	  var proto = _getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty$e.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString$2.call(Ctor) == objectCtorString;
	}

	var isPlainObject_1 = isPlainObject;

	/** `Object#toString` result references. */
	var domExcTag = '[object DOMException]',
	    errorTag$2 = '[object Error]';

	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike_1(value)) {
	    return false;
	  }
	  var tag = _baseGetTag(value);
	  return tag == errorTag$2 || tag == domExcTag ||
	    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject_1(value));
	}

	var isError_1 = isError;

	/** `Object#toString` result references. */
	var weakMapTag$3 = '[object WeakMap]';

	/**
	 * Checks if `value` is classified as a `WeakMap` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	 * @example
	 *
	 * _.isWeakMap(new WeakMap);
	 * // => true
	 *
	 * _.isWeakMap(new Map);
	 * // => false
	 */
	function isWeakMap(value) {
	  return isObjectLike_1(value) && _getTag(value) == weakMapTag$3;
	}

	var isWeakMap_1 = isWeakMap;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED$2);
	  return this;
	}

	var _setCacheAdd = setCacheAdd;

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	var _setCacheHas = setCacheHas;

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new _MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}

	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
	SetCache.prototype.has = _setCacheHas;

	var _SetCache = SetCache;

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	var _arraySome = arraySome;

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	var _cacheHas = cacheHas;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!_arraySome(other, function(othValue, othIndex) {
	            if (!_cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	var _equalArrays = equalArrays;

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	var _mapToArray = mapToArray;

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	var _setToArray = setToArray;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$1 = 1,
	    COMPARE_UNORDERED_FLAG$1 = 2;

	/** `Object#toString` result references. */
	var boolTag$3 = '[object Boolean]',
	    dateTag$3 = '[object Date]',
	    errorTag$3 = '[object Error]',
	    mapTag$5 = '[object Map]',
	    numberTag$3 = '[object Number]',
	    regexpTag$3 = '[object RegExp]',
	    setTag$5 = '[object Set]',
	    stringTag$3 = '[object String]',
	    symbolTag$3 = '[object Symbol]';

	var arrayBufferTag$3 = '[object ArrayBuffer]',
	    dataViewTag$4 = '[object DataView]';

	/** Used to convert symbols to primitives and strings. */
	var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
	    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag$4:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag$3:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
	        return false;
	      }
	      return true;

	    case boolTag$3:
	    case dateTag$3:
	    case numberTag$3:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq_1(+object, +other);

	    case errorTag$3:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag$3:
	    case stringTag$3:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag$5:
	      var convert = _mapToArray;

	    case setTag$5:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
	      convert || (convert = _setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG$1;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag$3:
	      if (symbolValueOf$1) {
	        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
	      }
	  }
	  return false;
	}

	var _equalByTag = equalByTag;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$2 = 1;

	/** Used for built-in method references. */
	var objectProto$g = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$f = objectProto$g.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
	      objProps = _getAllKeys(object),
	      objLength = objProps.length,
	      othProps = _getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty$f.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	var _equalObjects = equalObjects;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$3 = 1;

	/** `Object#toString` result references. */
	var argsTag$3 = '[object Arguments]',
	    arrayTag$2 = '[object Array]',
	    objectTag$4 = '[object Object]';

	/** Used for built-in method references. */
	var objectProto$h = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$g = objectProto$h.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray_1(object),
	      othIsArr = isArray_1(other),
	      objTag = objIsArr ? arrayTag$2 : _getTag(object),
	      othTag = othIsArr ? arrayTag$2 : _getTag(other);

	  objTag = objTag == argsTag$3 ? objectTag$4 : objTag;
	  othTag = othTag == argsTag$3 ? objectTag$4 : othTag;

	  var objIsObj = objTag == objectTag$4,
	      othIsObj = othTag == objectTag$4,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer_1(object)) {
	    if (!isBuffer_1(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new _Stack);
	    return (objIsArr || isTypedArray_1(object))
	      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
	    var objIsWrapped = objIsObj && hasOwnProperty$g.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty$g.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new _Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new _Stack);
	  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	var _baseIsEqualDeep = baseIsEqualDeep;

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
	    return value !== value && other !== other;
	  }
	  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	var _baseIsEqual = baseIsEqual;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$4 = 1,
	    COMPARE_UNORDERED_FLAG$2 = 2;

	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;

	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];

	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new _Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}

	var _baseIsMatch = baseIsMatch;

	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject_1(value);
	}

	var _isStrictComparable = isStrictComparable;

	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys_1(object),
	      length = result.length;

	  while (length--) {
	    var key = result[length],
	        value = object[key];

	    result[length] = [key, value, _isStrictComparable(value)];
	  }
	  return result;
	}

	var _getMatchData = getMatchData;

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}

	var _matchesStrictComparable = matchesStrictComparable;

	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = _getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || _baseIsMatch(object, source, matchData);
	  };
	}

	var _baseMatches = baseMatches;

	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;

	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray_1(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol_1(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}

	var _isKey = isKey;

	/** Error message constants. */
	var FUNC_ERROR_TEXT$1 = 'Expected a function';

	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT$1);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || _MapCache);
	  return memoized;
	}

	// Expose `MapCache`.
	memoize.Cache = _MapCache;

	var memoize_1 = memoize;

	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;

	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize_1(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });

	  var cache = result.cache;
	  return result;
	}

	var _memoizeCapped = memoizeCapped;

	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;

	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = _memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});

	var _stringToPath = stringToPath;

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}

	var _arrayMap = arrayMap;

	/** Used as references for various `Number` constants. */
	var INFINITY$1 = 1 / 0;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
	    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray_1(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return _arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol_1(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	}

	var _baseToString = baseToString;

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString$3(value) {
	  return value == null ? '' : _baseToString(value);
	}

	var toString_1 = toString$3;

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray_1(value)) {
	    return value;
	  }
	  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
	}

	var _castPath = castPath;

	/** Used as references for various `Number` constants. */
	var INFINITY$2 = 1 / 0;

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol_1(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
	}

	var _toKey = toKey;

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = _castPath(path, object);

	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[_toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}

	var _baseGet = baseGet;

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get$1(object, path, defaultValue) {
	  var result = object == null ? undefined : _baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}

	var get_1 = get$1;

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}

	var _baseHasIn = baseHasIn;

	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = _castPath(path, object);

	  var index = -1,
	      length = path.length,
	      result = false;

	  while (++index < length) {
	    var key = _toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength_1(length) && _isIndex(key, length) &&
	    (isArray_1(object) || isArguments_1(object));
	}

	var _hasPath = hasPath;

	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && _hasPath(object, path, _baseHasIn);
	}

	var hasIn_1 = hasIn;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$5 = 1,
	    COMPARE_UNORDERED_FLAG$3 = 2;

	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (_isKey(path) && _isStrictComparable(srcValue)) {
	    return _matchesStrictComparable(_toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get_1(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn_1(object, path)
	      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
	  };
	}

	var _baseMatchesProperty = baseMatchesProperty;

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	var _baseProperty = baseProperty;

	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return _baseGet(object, path);
	  };
	}

	var _basePropertyDeep = basePropertyDeep;

	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
	}

	var property_1 = property;

	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity_1;
	  }
	  if (typeof value == 'object') {
	    return isArray_1(value)
	      ? _baseMatchesProperty(value[0], value[1])
	      : _baseMatches(value);
	  }
	  return property_1(value);
	}

	var _baseIteratee = baseIteratee;

	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG$1 = 1;

	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return _baseIteratee(typeof func == 'function' ? func : _baseClone(func, CLONE_DEEP_FLAG$1));
	}

	var iteratee_1 = iteratee;

	/** Built-in value references. */
	var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray_1(value) || isArguments_1(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}

	var _isFlattenable = isFlattenable;

	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;

	  predicate || (predicate = _isFlattenable);
	  result || (result = []);

	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        _arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}

	var _baseFlatten = baseFlatten;

	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? _baseFlatten(array, 1) : [];
	}

	var flatten_1 = flatten;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax$3 = Math.max;

	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax$3(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax$3(args.length - start, 0),
	        array = Array(length);

	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return _apply(func, this, otherArgs);
	  };
	}

	var _overRest = overRest;

	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return _setToString(_overRest(func, undefined, flatten_1), func + '');
	}

	var _flatRest = flatRest;

	/** Used to compose bitmasks for function metadata. */
	var WRAP_REARG_FLAG$2 = 256;

	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = _flatRest(function(func, indexes) {
	  return _createWrap(func, WRAP_REARG_FLAG$2, undefined, undefined, undefined, indexes);
	});

	var rearg_1 = rearg;

	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray_1(value)) {
	    return _arrayMap(value, _toKey);
	  }
	  return isSymbol_1(value) ? [value] : _copyArray(_stringToPath(toString_1(value)));
	}

	var toPath_1 = toPath;

	var _util = {
	  'ary': ary_1,
	  'assign': _baseAssign,
	  'clone': clone_1,
	  'curry': curry_1,
	  'forEach': _arrayEach,
	  'isArray': isArray_1,
	  'isError': isError_1,
	  'isFunction': isFunction_1,
	  'isWeakMap': isWeakMap_1,
	  'iteratee': iteratee_1,
	  'keys': _baseKeys,
	  'rearg': rearg_1,
	  'toInteger': toInteger_1,
	  'toPath': toPath_1
	};

	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return _baseConvert(_util, name, func, options);
	}

	var convert_1 = convert;

	/** `Object#toString` result references. */
	var stringTag$4 = '[object String]';

	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$4);
	}

	var isString_1 = isString;

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return _arrayMap(props, function(key) {
	    return object[key];
	  });
	}

	var _baseValues = baseValues;

	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : _baseValues(object, keys_1(object));
	}

	var values_1 = values;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax$4 = Math.max;

	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike_1(collection) ? collection : values_1(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger_1(fromIndex) : 0;

	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax$4(length + fromIndex, 0);
	  }
	  return isString_1(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && _baseIndexOf(collection, value, fromIndex) > -1);
	}

	var includes_1 = includes;

	var func = convert_1('includes', includes_1);

	func.placeholder = placeholder;
	var includes$1 = func;

	var contains = includes$1;

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;

	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;

	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}

	var _baseSlice = baseSlice;

	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : _baseSlice(array, start, end);
	}

	var _castSlice = castSlice;

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';

	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';

	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}

	var _hasUnicode = hasUnicode;

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}

	var _asciiToArray = asciiToArray;

	/** Used to compose unicode character classes. */
	var rsAstralRange$1 = '\\ud800-\\udfff',
	    rsComboMarksRange$1 = '\\u0300-\\u036f',
	    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
	    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
	    rsVarRange$1 = '\\ufe0e\\ufe0f';

	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange$1 + ']',
	    rsCombo = '[' + rsComboRange$1 + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange$1 + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ$1 = '\\u200d';

	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange$1 + ']?',
	    rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}

	var _unicodeToArray = unicodeToArray;

	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return _hasUnicode(string)
	    ? _unicodeToArray(string)
	    : _asciiToArray(string);
	}

	var _stringToArray = stringToArray;

	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString_1(string);

	    var strSymbols = _hasUnicode(string)
	      ? _stringToArray(string)
	      : undefined;

	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);

	    var trailing = strSymbols
	      ? _castSlice(strSymbols, 1).join('')
	      : string.slice(1);

	    return chr[methodName]() + trailing;
	  };
	}

	var _createCaseFirst = createCaseFirst;

	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = _createCaseFirst('toUpperCase');

	var upperFirst_1 = upperFirst;

	var _falseOptions = {
	  'cap': false,
	  'curry': false,
	  'fixed': false,
	  'immutable': false,
	  'rearg': false
	};

	var func$1 = convert_1('upperFirst', upperFirst_1, _falseOptions);

	func$1.placeholder = placeholder;
	var upperFirst$1 = func$1;

	function getResponsiveClasses(_ref) {
	  var styles = _ref.styles,
	      prefix = _ref.prefix,
	      _ref$selector = _ref.selector;
	  _ref$selector = _ref$selector === void 0 ? {} : _ref$selector;
	  var thinnerThan = _ref$selector.thinnerThan,
	      widerThan = _ref$selector.widerThan,
	      at = _ref$selector.at;
	  var classes = [];

	  if (thinnerThan) {
	    classes.push(styles[prefix + "thinnerThan" + upperFirst$1(thinnerThan)]);
	  }

	  if (widerThan) {
	    classes.push(styles[prefix + "widerThan" + upperFirst$1(widerThan)]);
	  }

	  if (at) {
	    classes.push(styles[prefix + "at" + upperFirst$1(at)]);
	  }

	  return classes;
	}

	var styles = {"flex":"telia-react-flex","flex__occupyVerticalSpace":"telia-react-flex__occupyVerticalSpace","flex__centeredVertically":"telia-react-flex__centeredVertically","flex__centeredHorizontally":"telia-react-flex__centeredHorizontally","flex__alignTop":"telia-react-flex__alignTop","flex__alignBottom":"telia-react-flex__alignBottom","flex__alignBaseline":"telia-react-flex__alignBaseline","flex__alignRight":"telia-react-flex__alignRight","flex__spaceBetween":"telia-react-flex__spaceBetween","flex__wrapContent":"telia-react-flex__wrapContent","flex__stretchToSameHeight":"telia-react-flex__stretchToSameHeight","flex__reverseDirection":"telia-react-flex__reverseDirection","flex__directionColumn":"telia-react-flex__directionColumn","flex__pileVerticallyToXxxsScreen":"telia-react-flex__pileVerticallyToXxxsScreen","flex__pileVerticallyToXxsScreen":"telia-react-flex__pileVerticallyToXxsScreen","flex__pileVerticallyToXsScreen":"telia-react-flex__pileVerticallyToXsScreen","flex__pileVerticallyToSmScreen":"telia-react-flex__pileVerticallyToSmScreen","flex__pileVerticallyToMdScreen":"telia-react-flex__pileVerticallyToMdScreen","flex__pileVerticallyToLgScreen":"telia-react-flex__pileVerticallyToLgScreen","flex__pileVerticallyToXlgScreen":"telia-react-flex__pileVerticallyToXlgScreen","flex_flexItem":"telia-react-flex_flexItem"};

	var colors = {"color__white":"telia-react-color__white","color__whiteHoverable":"telia-react-color__whiteHoverable","color_background__white":"telia-react-color_background__white","color_background__whiteHoverable":"telia-react-color_background__whiteHoverable","color__black":"telia-react-color__black","color__blackHoverable":"telia-react-color__blackHoverable","color_background__black":"telia-react-color_background__black","color_background__blackHoverable":"telia-react-color_background__blackHoverable","color__overlay":"telia-react-color__overlay","color__overlayHoverable":"telia-react-color__overlayHoverable","color_background__overlay":"telia-react-color_background__overlay","color_background__overlayHoverable":"telia-react-color_background__overlayHoverable","color__purple100":"telia-react-color__purple100","color__purple100Hoverable":"telia-react-color__purple100Hoverable","color_background__purple100":"telia-react-color_background__purple100","color_background__purple100Hoverable":"telia-react-color_background__purple100Hoverable","color__purple200":"telia-react-color__purple200","color__purple200Hoverable":"telia-react-color__purple200Hoverable","color_background__purple200":"telia-react-color_background__purple200","color_background__purple200Hoverable":"telia-react-color_background__purple200Hoverable","color__purple300":"telia-react-color__purple300","color__purple300Hoverable":"telia-react-color__purple300Hoverable","color_background__purple300":"telia-react-color_background__purple300","color_background__purple300Hoverable":"telia-react-color_background__purple300Hoverable","color__purple400":"telia-react-color__purple400","color__purple400Hoverable":"telia-react-color__purple400Hoverable","color_background__purple400":"telia-react-color_background__purple400","color_background__purple400Hoverable":"telia-react-color_background__purple400Hoverable","color__purple500":"telia-react-color__purple500","color__purple500Hoverable":"telia-react-color__purple500Hoverable","color_background__purple500":"telia-react-color_background__purple500","color_background__purple500Hoverable":"telia-react-color_background__purple500Hoverable","color__purple600":"telia-react-color__purple600","color__purple600Hoverable":"telia-react-color__purple600Hoverable","color_background__purple600":"telia-react-color_background__purple600","color_background__purple600Hoverable":"telia-react-color_background__purple600Hoverable","color__purple700":"telia-react-color__purple700","color__purple700Hoverable":"telia-react-color__purple700Hoverable","color_background__purple700":"telia-react-color_background__purple700","color_background__purple700Hoverable":"telia-react-color_background__purple700Hoverable","color__purple800":"telia-react-color__purple800","color__purple800Hoverable":"telia-react-color__purple800Hoverable","color_background__purple800":"telia-react-color_background__purple800","color_background__purple800Hoverable":"telia-react-color_background__purple800Hoverable","color__purple900":"telia-react-color__purple900","color__purple900Hoverable":"telia-react-color__purple900Hoverable","color_background__purple900":"telia-react-color_background__purple900","color_background__purple900Hoverable":"telia-react-color_background__purple900Hoverable","color__gray100":"telia-react-color__gray100","color__gray100Hoverable":"telia-react-color__gray100Hoverable","color_background__gray100":"telia-react-color_background__gray100","color_background__gray100Hoverable":"telia-react-color_background__gray100Hoverable","color__gray200":"telia-react-color__gray200","color__gray200Hoverable":"telia-react-color__gray200Hoverable","color_background__gray200":"telia-react-color_background__gray200","color_background__gray200Hoverable":"telia-react-color_background__gray200Hoverable","color__gray300":"telia-react-color__gray300","color__gray300Hoverable":"telia-react-color__gray300Hoverable","color_background__gray300":"telia-react-color_background__gray300","color_background__gray300Hoverable":"telia-react-color_background__gray300Hoverable","color__gray400":"telia-react-color__gray400","color__gray400Hoverable":"telia-react-color__gray400Hoverable","color_background__gray400":"telia-react-color_background__gray400","color_background__gray400Hoverable":"telia-react-color_background__gray400Hoverable","color__gray500":"telia-react-color__gray500","color__gray500Hoverable":"telia-react-color__gray500Hoverable","color_background__gray500":"telia-react-color_background__gray500","color_background__gray500Hoverable":"telia-react-color_background__gray500Hoverable","color__gray600":"telia-react-color__gray600","color__gray600Hoverable":"telia-react-color__gray600Hoverable","color_background__gray600":"telia-react-color_background__gray600","color_background__gray600Hoverable":"telia-react-color_background__gray600Hoverable","color__gray700":"telia-react-color__gray700","color__gray700Hoverable":"telia-react-color__gray700Hoverable","color_background__gray700":"telia-react-color_background__gray700","color_background__gray700Hoverable":"telia-react-color_background__gray700Hoverable","color__gray800":"telia-react-color__gray800","color__gray800Hoverable":"telia-react-color__gray800Hoverable","color_background__gray800":"telia-react-color_background__gray800","color_background__gray800Hoverable":"telia-react-color_background__gray800Hoverable","color__gray900":"telia-react-color__gray900","color__gray900Hoverable":"telia-react-color__gray900Hoverable","color_background__gray900":"telia-react-color_background__gray900","color_background__gray900Hoverable":"telia-react-color_background__gray900Hoverable","color__red100":"telia-react-color__red100","color__red100Hoverable":"telia-react-color__red100Hoverable","color_background__red100":"telia-react-color_background__red100","color_background__red100Hoverable":"telia-react-color_background__red100Hoverable","color__red200":"telia-react-color__red200","color__red200Hoverable":"telia-react-color__red200Hoverable","color_background__red200":"telia-react-color_background__red200","color_background__red200Hoverable":"telia-react-color_background__red200Hoverable","color__red300":"telia-react-color__red300","color__red300Hoverable":"telia-react-color__red300Hoverable","color_background__red300":"telia-react-color_background__red300","color_background__red300Hoverable":"telia-react-color_background__red300Hoverable","color__red400":"telia-react-color__red400","color__red400Hoverable":"telia-react-color__red400Hoverable","color_background__red400":"telia-react-color_background__red400","color_background__red400Hoverable":"telia-react-color_background__red400Hoverable","color__red500":"telia-react-color__red500","color__red500Hoverable":"telia-react-color__red500Hoverable","color_background__red500":"telia-react-color_background__red500","color_background__red500Hoverable":"telia-react-color_background__red500Hoverable","color__red600":"telia-react-color__red600","color__red600Hoverable":"telia-react-color__red600Hoverable","color_background__red600":"telia-react-color_background__red600","color_background__red600Hoverable":"telia-react-color_background__red600Hoverable","color__red700":"telia-react-color__red700","color__red700Hoverable":"telia-react-color__red700Hoverable","color_background__red700":"telia-react-color_background__red700","color_background__red700Hoverable":"telia-react-color_background__red700Hoverable","color__red800":"telia-react-color__red800","color__red800Hoverable":"telia-react-color__red800Hoverable","color_background__red800":"telia-react-color_background__red800","color_background__red800Hoverable":"telia-react-color_background__red800Hoverable","color__red900":"telia-react-color__red900","color__red900Hoverable":"telia-react-color__red900Hoverable","color_background__red900":"telia-react-color_background__red900","color_background__red900Hoverable":"telia-react-color_background__red900Hoverable","color__green100":"telia-react-color__green100","color__green100Hoverable":"telia-react-color__green100Hoverable","color_background__green100":"telia-react-color_background__green100","color_background__green100Hoverable":"telia-react-color_background__green100Hoverable","color__green200":"telia-react-color__green200","color__green200Hoverable":"telia-react-color__green200Hoverable","color_background__green200":"telia-react-color_background__green200","color_background__green200Hoverable":"telia-react-color_background__green200Hoverable","color__green300":"telia-react-color__green300","color__green300Hoverable":"telia-react-color__green300Hoverable","color_background__green300":"telia-react-color_background__green300","color_background__green300Hoverable":"telia-react-color_background__green300Hoverable","color__green400":"telia-react-color__green400","color__green400Hoverable":"telia-react-color__green400Hoverable","color_background__green400":"telia-react-color_background__green400","color_background__green400Hoverable":"telia-react-color_background__green400Hoverable","color__green500":"telia-react-color__green500","color__green500Hoverable":"telia-react-color__green500Hoverable","color_background__green500":"telia-react-color_background__green500","color_background__green500Hoverable":"telia-react-color_background__green500Hoverable","color__green600":"telia-react-color__green600","color__green600Hoverable":"telia-react-color__green600Hoverable","color_background__green600":"telia-react-color_background__green600","color_background__green600Hoverable":"telia-react-color_background__green600Hoverable","color__green700":"telia-react-color__green700","color__green700Hoverable":"telia-react-color__green700Hoverable","color_background__green700":"telia-react-color_background__green700","color_background__green700Hoverable":"telia-react-color_background__green700Hoverable","color__green800":"telia-react-color__green800","color__green800Hoverable":"telia-react-color__green800Hoverable","color_background__green800":"telia-react-color_background__green800","color_background__green800Hoverable":"telia-react-color_background__green800Hoverable","color__green900":"telia-react-color__green900","color__green900Hoverable":"telia-react-color__green900Hoverable","color_background__green900":"telia-react-color_background__green900","color_background__green900Hoverable":"telia-react-color_background__green900Hoverable","color__blue100":"telia-react-color__blue100","color__blue100Hoverable":"telia-react-color__blue100Hoverable","color_background__blue100":"telia-react-color_background__blue100","color_background__blue100Hoverable":"telia-react-color_background__blue100Hoverable","color__blue200":"telia-react-color__blue200","color__blue200Hoverable":"telia-react-color__blue200Hoverable","color_background__blue200":"telia-react-color_background__blue200","color_background__blue200Hoverable":"telia-react-color_background__blue200Hoverable","color__blue300":"telia-react-color__blue300","color__blue300Hoverable":"telia-react-color__blue300Hoverable","color_background__blue300":"telia-react-color_background__blue300","color_background__blue300Hoverable":"telia-react-color_background__blue300Hoverable","color__blue400":"telia-react-color__blue400","color__blue400Hoverable":"telia-react-color__blue400Hoverable","color_background__blue400":"telia-react-color_background__blue400","color_background__blue400Hoverable":"telia-react-color_background__blue400Hoverable","color__blue500":"telia-react-color__blue500","color__blue500Hoverable":"telia-react-color__blue500Hoverable","color_background__blue500":"telia-react-color_background__blue500","color_background__blue500Hoverable":"telia-react-color_background__blue500Hoverable","color__blue600":"telia-react-color__blue600","color__blue600Hoverable":"telia-react-color__blue600Hoverable","color_background__blue600":"telia-react-color_background__blue600","color_background__blue600Hoverable":"telia-react-color_background__blue600Hoverable","color__blue700":"telia-react-color__blue700","color__blue700Hoverable":"telia-react-color__blue700Hoverable","color_background__blue700":"telia-react-color_background__blue700","color_background__blue700Hoverable":"telia-react-color_background__blue700Hoverable","color__blue800":"telia-react-color__blue800","color__blue800Hoverable":"telia-react-color__blue800Hoverable","color_background__blue800":"telia-react-color_background__blue800","color_background__blue800Hoverable":"telia-react-color_background__blue800Hoverable","color__blue900":"telia-react-color__blue900","color__blue900Hoverable":"telia-react-color__blue900Hoverable","color_background__blue900":"telia-react-color_background__blue900","color_background__blue900Hoverable":"telia-react-color_background__blue900Hoverable","color__orange100":"telia-react-color__orange100","color__orange100Hoverable":"telia-react-color__orange100Hoverable","color_background__orange100":"telia-react-color_background__orange100","color_background__orange100Hoverable":"telia-react-color_background__orange100Hoverable","color__orange200":"telia-react-color__orange200","color__orange200Hoverable":"telia-react-color__orange200Hoverable","color_background__orange200":"telia-react-color_background__orange200","color_background__orange200Hoverable":"telia-react-color_background__orange200Hoverable","color__orange300":"telia-react-color__orange300","color__orange300Hoverable":"telia-react-color__orange300Hoverable","color_background__orange300":"telia-react-color_background__orange300","color_background__orange300Hoverable":"telia-react-color_background__orange300Hoverable","color__orange400":"telia-react-color__orange400","color__orange400Hoverable":"telia-react-color__orange400Hoverable","color_background__orange400":"telia-react-color_background__orange400","color_background__orange400Hoverable":"telia-react-color_background__orange400Hoverable","color__orange500":"telia-react-color__orange500","color__orange500Hoverable":"telia-react-color__orange500Hoverable","color_background__orange500":"telia-react-color_background__orange500","color_background__orange500Hoverable":"telia-react-color_background__orange500Hoverable","color__orange600":"telia-react-color__orange600","color__orange600Hoverable":"telia-react-color__orange600Hoverable","color_background__orange600":"telia-react-color_background__orange600","color_background__orange600Hoverable":"telia-react-color_background__orange600Hoverable","color__orange700":"telia-react-color__orange700","color__orange700Hoverable":"telia-react-color__orange700Hoverable","color_background__orange700":"telia-react-color_background__orange700","color_background__orange700Hoverable":"telia-react-color_background__orange700Hoverable","color__orange800":"telia-react-color__orange800","color__orange800Hoverable":"telia-react-color__orange800Hoverable","color_background__orange800":"telia-react-color_background__orange800","color_background__orange800Hoverable":"telia-react-color_background__orange800Hoverable","color__orange900":"telia-react-color__orange900","color__orange900Hoverable":"telia-react-color__orange900Hoverable","color_background__orange900":"telia-react-color_background__orange900","color_background__orange900Hoverable":"telia-react-color_background__orange900Hoverable","color__inherit":"telia-react-color__inherit","color__transparent":"telia-react-color__transparent","color__inheritHoverable":"telia-react-color__inheritHoverable","color_background__transparent":"telia-react-color_background__transparent"};

	var styles$1 = {"element":"telia-react-element","element__hidden":"telia-react-element__hidden","element__hideOverflow":"telia-react-element__hideOverflow","element__showOverflow":"telia-react-element__showOverflow","element__forceWrap":"telia-react-element__forceWrap","element__inlineBlock":"telia-react-element__inlineBlock","element__block":"telia-react-element__block","element__alignSelfCenter":"telia-react-element__alignSelfCenter","element__boxShadow__zero":"telia-react-element__boxShadow__zero","element__boxShadow__sm":"telia-react-element__boxShadow__sm","element__boxShadow__md":"telia-react-element__boxShadow__md","element__boxShadow__lg":"telia-react-element__boxShadow__lg","element_boxShadowHoverable__zero":"telia-react-element_boxShadowHoverable__zero","element_boxShadowHoverable__sm":"telia-react-element_boxShadowHoverable__sm","element_boxShadowHoverable__md":"telia-react-element_boxShadowHoverable__md","element_boxShadowHoverable__lg":"telia-react-element_boxShadowHoverable__lg","element__occupyVerticalSpace":"telia-react-element__occupyVerticalSpace","element__occupyHorizontalSpace":"telia-react-element__occupyHorizontalSpace","element__alignTextToCenter":"telia-react-element__alignTextToCenter","element__alignTextToRight":"telia-react-element__alignTextToRight","element__clickableAppearance":"telia-react-element__clickableAppearance","element__alignSelfToBottom":"telia-react-element__alignSelfToBottom","element__fontWeight__normal":"telia-react-element__fontWeight__normal","element__fontWeight__medium":"telia-react-element__fontWeight__medium","element__fontWeight__bold":"telia-react-element__fontWeight__bold","element_borderRadius__topLeftZero":"telia-react-element_borderRadius__topLeftZero","element_borderRadius__topLeftXs":"telia-react-element_borderRadius__topLeftXs","element_borderRadius__topLeftSm":"telia-react-element_borderRadius__topLeftSm","element_borderRadius__topLeftMd":"telia-react-element_borderRadius__topLeftMd","element_borderRadius__topLeftLg":"telia-react-element_borderRadius__topLeftLg","element_borderRadius__topLeftRounded":"telia-react-element_borderRadius__topLeftRounded","element_borderRadius__topRightZero":"telia-react-element_borderRadius__topRightZero","element_borderRadius__topRightXs":"telia-react-element_borderRadius__topRightXs","element_borderRadius__topRightSm":"telia-react-element_borderRadius__topRightSm","element_borderRadius__topRightMd":"telia-react-element_borderRadius__topRightMd","element_borderRadius__topRightLg":"telia-react-element_borderRadius__topRightLg","element_borderRadius__topRightRounded":"telia-react-element_borderRadius__topRightRounded","element_borderRadius__bottomRightZero":"telia-react-element_borderRadius__bottomRightZero","element_borderRadius__bottomRightXs":"telia-react-element_borderRadius__bottomRightXs","element_borderRadius__bottomRightSm":"telia-react-element_borderRadius__bottomRightSm","element_borderRadius__bottomRightMd":"telia-react-element_borderRadius__bottomRightMd","element_borderRadius__bottomRightLg":"telia-react-element_borderRadius__bottomRightLg","element_borderRadius__bottomRightRounded":"telia-react-element_borderRadius__bottomRightRounded","element_borderRadius__bottomLeftZero":"telia-react-element_borderRadius__bottomLeftZero","element_borderRadius__bottomLeftXs":"telia-react-element_borderRadius__bottomLeftXs","element_borderRadius__bottomLeftSm":"telia-react-element_borderRadius__bottomLeftSm","element_borderRadius__bottomLeftMd":"telia-react-element_borderRadius__bottomLeftMd","element_borderRadius__bottomLeftLg":"telia-react-element_borderRadius__bottomLeftLg","element_borderRadius__bottomLeftRounded":"telia-react-element_borderRadius__bottomLeftRounded"};

	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return _setToString(_overRest(func, start, identity_1), func + '');
	}

	var _baseRest = baseRest;

	/**
	 * Creates a function like `_.over`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over iteratees.
	 * @returns {Function} Returns the new over function.
	 */
	function createOver(arrayFunc) {
	  return _flatRest(function(iteratees) {
	    iteratees = _arrayMap(iteratees, _baseUnary(_baseIteratee));
	    return _baseRest(function(args) {
	      var thisArg = this;
	      return arrayFunc(iteratees, function(iteratee) {
	        return _apply(iteratee, thisArg, args);
	      });
	    });
	  });
	}

	var _createOver = createOver;

	/**
	 * Creates a function that checks if **any** of the `predicates` return
	 * truthy when invoked with the arguments it receives.
	 *
	 * Following shorthands are possible for providing predicates.
	 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [predicates=[_.identity]]
	 *  The predicates to check.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.overSome([Boolean, isFinite]);
	 *
	 * func('1');
	 * // => true
	 *
	 * func(null);
	 * // => true
	 *
	 * func(NaN);
	 * // => false
	 *
	 * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	 * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	 */
	var overSome = _createOver(_arraySome);

	var overSome_1 = overSome;

	var func$2 = convert_1('overSome', overSome_1);

	func$2.placeholder = placeholder;
	var overSome$1 = func$2;

	var getOptions = function getOptions(input) {
	  var defaultSize = 'sm';

	  if (input === true) {
	    return {
	      left: true,
	      right: true,
	      top: true,
	      bottom: true,
	      size: defaultSize
	    };
	  } else {
	    var _input$left, _input$right, _input$top, _input$bottom, _input$size;

	    var defaultDirectionValue = !(input.left || input.right || input.top || input.bottom);
	    return {
	      left: (_input$left = input.left) != null ? _input$left : defaultDirectionValue,
	      right: (_input$right = input.right) != null ? _input$right : defaultDirectionValue,
	      top: (_input$top = input.top) != null ? _input$top : defaultDirectionValue,
	      bottom: (_input$bottom = input.bottom) != null ? _input$bottom : defaultDirectionValue,
	      size: (_input$size = input.size) != null ? _input$size : defaultSize
	    };
	  }
	};

	var getBorderRadiusClasses = (function (input) {
	  var _ref;

	  var options = getOptions(input);
	  var radiusSize = upperFirst$1(options.size);
	  return _ref = {}, _ref[styles$1["element_borderRadius__topLeft" + radiusSize]] = hasTopLeftRadius(options), _ref[styles$1["element_borderRadius__topRight" + radiusSize]] = hasTopRightRadius(options), _ref[styles$1["element_borderRadius__bottomRight" + radiusSize]] = hasBottomRightRadius(options), _ref[styles$1["element_borderRadius__bottomLeft" + radiusSize]] = hasBottomLeftRadius(options), _ref;
	});
	var hasTopLeftRadius = overSome$1([function (_ref2) {
	  var left = _ref2.left,
	      right = _ref2.right,
	      top = _ref2.top;
	  return top && !left && !right;
	}, function (_ref3) {
	  var left = _ref3.left,
	      top = _ref3.top,
	      bottom = _ref3.bottom;
	  return !top && left && !bottom;
	}, function (_ref4) {
	  var left = _ref4.left,
	      top = _ref4.top;
	  return top && left;
	}]);
	var hasTopRightRadius = overSome$1([function (_ref5) {
	  var left = _ref5.left,
	      right = _ref5.right,
	      top = _ref5.top;
	  return top && !right && !left;
	}, function (_ref6) {
	  var right = _ref6.right,
	      top = _ref6.top,
	      bottom = _ref6.bottom;
	  return !top && right && !bottom;
	}, function (_ref7) {
	  var right = _ref7.right,
	      top = _ref7.top;
	  return top && right;
	}]);
	var hasBottomLeftRadius = overSome$1([function (_ref8) {
	  var left = _ref8.left,
	      right = _ref8.right,
	      bottom = _ref8.bottom;
	  return bottom && !left && !right;
	}, function (_ref9) {
	  var left = _ref9.left,
	      top = _ref9.top,
	      bottom = _ref9.bottom;
	  return !bottom && left && !top;
	}, function (_ref10) {
	  var left = _ref10.left,
	      bottom = _ref10.bottom;
	  return bottom && left;
	}]);
	var hasBottomRightRadius = overSome$1([function (_ref11) {
	  var left = _ref11.left,
	      right = _ref11.right,
	      bottom = _ref11.bottom;
	  return bottom && !right && !left;
	}, function (_ref12) {
	  var right = _ref12.right,
	      top = _ref12.top,
	      bottom = _ref12.bottom;
	  return !bottom && right && !top;
	}, function (_ref13) {
	  var right = _ref13.right,
	      bottom = _ref13.bottom;
	  return bottom && right;
	}]);

	var styles$2 = {"margin__sizeZeroLeft":"telia-react-margin__sizeZeroLeft","margin__sizeZeroRight":"telia-react-margin__sizeZeroRight","margin__sizeZeroTop":"telia-react-margin__sizeZeroTop","margin__sizeZeroBottom":"telia-react-margin__sizeZeroBottom","margin__sizeXxxsLeft":"telia-react-margin__sizeXxxsLeft","margin__sizeXxxsRight":"telia-react-margin__sizeXxxsRight","margin__sizeXxxsTop":"telia-react-margin__sizeXxxsTop","margin__sizeXxxsBottom":"telia-react-margin__sizeXxxsBottom","margin__sizeXxsLeft":"telia-react-margin__sizeXxsLeft","margin__sizeXxsRight":"telia-react-margin__sizeXxsRight","margin__sizeXxsTop":"telia-react-margin__sizeXxsTop","margin__sizeXxsBottom":"telia-react-margin__sizeXxsBottom","margin__sizeXsLeft":"telia-react-margin__sizeXsLeft","margin__sizeXsRight":"telia-react-margin__sizeXsRight","margin__sizeXsTop":"telia-react-margin__sizeXsTop","margin__sizeXsBottom":"telia-react-margin__sizeXsBottom","margin__sizeSmLeft":"telia-react-margin__sizeSmLeft","margin__sizeSmRight":"telia-react-margin__sizeSmRight","margin__sizeSmTop":"telia-react-margin__sizeSmTop","margin__sizeSmBottom":"telia-react-margin__sizeSmBottom","margin__sizeMdLeft":"telia-react-margin__sizeMdLeft","margin__sizeMdRight":"telia-react-margin__sizeMdRight","margin__sizeMdTop":"telia-react-margin__sizeMdTop","margin__sizeMdBottom":"telia-react-margin__sizeMdBottom","margin__sizeLgLeft":"telia-react-margin__sizeLgLeft","margin__sizeLgRight":"telia-react-margin__sizeLgRight","margin__sizeLgTop":"telia-react-margin__sizeLgTop","margin__sizeLgBottom":"telia-react-margin__sizeLgBottom","margin__sizeXlgLeft":"telia-react-margin__sizeXlgLeft","margin__sizeXlgRight":"telia-react-margin__sizeXlgRight","margin__sizeXlgTop":"telia-react-margin__sizeXlgTop","margin__sizeXlgBottom":"telia-react-margin__sizeXlgBottom","margin__sizeXxlgLeft":"telia-react-margin__sizeXxlgLeft","margin__sizeXxlgRight":"telia-react-margin__sizeXxlgRight","margin__sizeXxlgTop":"telia-react-margin__sizeXxlgTop","margin__sizeXxlgBottom":"telia-react-margin__sizeXxlgBottom","margin__lastChildSizeZeroBottom":"telia-react-margin__lastChildSizeZeroBottom"};

	var getMarginClasses = (function (_ref) {
	  var size = _ref.size,
	      _ref$vertical = _ref.vertical,
	      vertical = _ref$vertical === void 0 ? size : _ref$vertical,
	      _ref$horizontal = _ref.horizontal,
	      horizontal = _ref$horizontal === void 0 ? size : _ref$horizontal,
	      _ref$left = _ref.left,
	      left = _ref$left === void 0 ? horizontal : _ref$left,
	      _ref$right = _ref.right,
	      right = _ref$right === void 0 ? horizontal : _ref$right,
	      _ref$top = _ref.top,
	      top = _ref$top === void 0 ? vertical : _ref$top,
	      _ref$bottom = _ref.bottom,
	      bottom = _ref$bottom === void 0 ? vertical : _ref$bottom,
	      lastChild = _ref.lastChild;
	  var classes = [];
	  if (left) classes.push(styles$2["margin__size" + upperFirst$1(left) + "Left"]);
	  if (right) classes.push(styles$2["margin__size" + upperFirst$1(right) + "Right"]);
	  if (top) classes.push(styles$2["margin__size" + upperFirst$1(top) + "Top"]);
	  if (bottom) classes.push(styles$2["margin__size" + upperFirst$1(bottom) + "Bottom"]);
	  if ((lastChild == null ? void 0 : lastChild.bottom) === false) classes.push(styles$2["margin__lastChildSizeZeroBottom"]);
	  return classes;
	});

	var styles$3 = {"padding__sizeZeroLeft":"telia-react-padding__sizeZeroLeft","padding__sizeZeroRight":"telia-react-padding__sizeZeroRight","padding__sizeZeroTop":"telia-react-padding__sizeZeroTop","padding__sizeZeroBottom":"telia-react-padding__sizeZeroBottom","padding__sizeXxxsLeft":"telia-react-padding__sizeXxxsLeft","padding__sizeXxxsRight":"telia-react-padding__sizeXxxsRight","padding__sizeXxxsTop":"telia-react-padding__sizeXxxsTop","padding__sizeXxxsBottom":"telia-react-padding__sizeXxxsBottom","padding__sizeXxsLeft":"telia-react-padding__sizeXxsLeft","padding__sizeXxsRight":"telia-react-padding__sizeXxsRight","padding__sizeXxsTop":"telia-react-padding__sizeXxsTop","padding__sizeXxsBottom":"telia-react-padding__sizeXxsBottom","padding__sizeXsLeft":"telia-react-padding__sizeXsLeft","padding__sizeXsRight":"telia-react-padding__sizeXsRight","padding__sizeXsTop":"telia-react-padding__sizeXsTop","padding__sizeXsBottom":"telia-react-padding__sizeXsBottom","padding__sizeSmLeft":"telia-react-padding__sizeSmLeft","padding__sizeSmRight":"telia-react-padding__sizeSmRight","padding__sizeSmTop":"telia-react-padding__sizeSmTop","padding__sizeSmBottom":"telia-react-padding__sizeSmBottom","padding__sizeMdLeft":"telia-react-padding__sizeMdLeft","padding__sizeMdRight":"telia-react-padding__sizeMdRight","padding__sizeMdTop":"telia-react-padding__sizeMdTop","padding__sizeMdBottom":"telia-react-padding__sizeMdBottom","padding__sizeLgLeft":"telia-react-padding__sizeLgLeft","padding__sizeLgRight":"telia-react-padding__sizeLgRight","padding__sizeLgTop":"telia-react-padding__sizeLgTop","padding__sizeLgBottom":"telia-react-padding__sizeLgBottom","padding__sizeXlgLeft":"telia-react-padding__sizeXlgLeft","padding__sizeXlgRight":"telia-react-padding__sizeXlgRight","padding__sizeXlgTop":"telia-react-padding__sizeXlgTop","padding__sizeXlgBottom":"telia-react-padding__sizeXlgBottom","padding__sizeXxlgLeft":"telia-react-padding__sizeXxlgLeft","padding__sizeXxlgRight":"telia-react-padding__sizeXxlgRight","padding__sizeXxlgTop":"telia-react-padding__sizeXxlgTop","padding__sizeXxlgBottom":"telia-react-padding__sizeXxlgBottom"};

	var getPaddingClasses = (function (_ref) {
	  var size = _ref.size,
	      _ref$vertical = _ref.vertical,
	      vertical = _ref$vertical === void 0 ? size : _ref$vertical,
	      _ref$horizontal = _ref.horizontal,
	      horizontal = _ref$horizontal === void 0 ? size : _ref$horizontal,
	      _ref$left = _ref.left,
	      left = _ref$left === void 0 ? horizontal : _ref$left,
	      _ref$right = _ref.right,
	      right = _ref$right === void 0 ? horizontal : _ref$right,
	      _ref$top = _ref.top,
	      top = _ref$top === void 0 ? vertical : _ref$top,
	      _ref$bottom = _ref.bottom,
	      bottom = _ref$bottom === void 0 ? vertical : _ref$bottom;
	  var classes = [];
	  if (left) classes.push(styles$3["padding__size" + upperFirst$1(left) + "Left"]);
	  if (right) classes.push(styles$3["padding__size" + upperFirst$1(right) + "Right"]);
	  if (top) classes.push(styles$3["padding__size" + upperFirst$1(top) + "Top"]);
	  if (bottom) classes.push(styles$3["padding__size" + upperFirst$1(bottom) + "Bottom"]);
	  return classes;
	});

	var hiddenStyles = {"hidden":"telia-react-hidden","hidden__thinnerThanXxs":"telia-react-hidden__thinnerThanXxs","hidden__thinnerThanXs":"telia-react-hidden__thinnerThanXs","hidden__thinnerThanSm":"telia-react-hidden__thinnerThanSm","hidden__thinnerThanMd":"telia-react-hidden__thinnerThanMd","hidden__thinnerThanLg":"telia-react-hidden__thinnerThanLg","hidden__thinnerThanXlg":"telia-react-hidden__thinnerThanXlg","hidden__thinnerThanXxlg":"telia-react-hidden__thinnerThanXxlg","hidden__widerThanXxxs":"telia-react-hidden__widerThanXxxs","hidden__widerThanXxs":"telia-react-hidden__widerThanXxs","hidden__widerThanXs":"telia-react-hidden__widerThanXs","hidden__widerThanSm":"telia-react-hidden__widerThanSm","hidden__widerThanMd":"telia-react-hidden__widerThanMd","hidden__widerThanLg":"telia-react-hidden__widerThanLg","hidden__widerThanXlg":"telia-react-hidden__widerThanXlg","hidden__atXxxs":"telia-react-hidden__atXxxs","hidden__atXxs":"telia-react-hidden__atXxs","hidden__atXs":"telia-react-hidden__atXs","hidden__atSm":"telia-react-hidden__atSm","hidden__atMd":"telia-react-hidden__atMd","hidden__atLg":"telia-react-hidden__atLg","hidden__atXlg":"telia-react-hidden__atXlg","visuallyHidden":"telia-react-visuallyHidden"};

	var _excluded = ["className", "tagName", "children", "margin", "padding", "color", "hoverColor", "backgroundColor", "backgroundHoverColor", "inlineBlock", "block", "shown", "hidden", "flexItem", "boxShadow", "hoverBoxShadow", "responsiveHidden", "occupyVerticalSpace", "occupyHorizontalSpace", "forceWrap", "style", "refElement", "hideOverflow", "showOverflow", "alignTextToCenter", "alignTextToRight", "clickableAppearance", "borderRadius", "fontWeight"];

	function ownKeys$1(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$1(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$1(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }
	function Element$2(_ref) {
	  var _classNameParameters$;

	  var className = _ref.className,
	      tagName = _ref.tagName,
	      children = _ref.children,
	      margin = _ref.margin,
	      padding = _ref.padding,
	      color = _ref.color,
	      hoverColor = _ref.hoverColor,
	      backgroundColor = _ref.backgroundColor,
	      backgroundHoverColor = _ref.backgroundHoverColor,
	      inlineBlock = _ref.inlineBlock,
	      block = _ref.block,
	      shown = _ref.shown,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === void 0 ? shown === undefined ? undefined : !shown : _ref$hidden,
	      flexItem = _ref.flexItem,
	      boxShadow = _ref.boxShadow,
	      hoverBoxShadow = _ref.hoverBoxShadow,
	      responsiveHidden = _ref.responsiveHidden,
	      occupyVerticalSpace = _ref.occupyVerticalSpace,
	      occupyHorizontalSpace = _ref.occupyHorizontalSpace,
	      forceWrap = _ref.forceWrap,
	      _ref$style = _ref.style,
	      explicitStyles = _ref$style === void 0 ? {} : _ref$style,
	      refElement = _ref.refElement,
	      hideOverflow = _ref.hideOverflow,
	      showOverflow = _ref.showOverflow,
	      alignTextToCenter = _ref.alignTextToCenter,
	      alignTextToRight = _ref.alignTextToRight,
	      clickableAppearance = _ref.clickableAppearance,
	      borderRadius = _ref.borderRadius,
	      fontWeight = _ref.fontWeight,
	      props = objectWithoutPropertiesLoose(_ref, _excluded);

	  var classNameParameters = [styles$1.element];
	  if (margin === false || margin === null) margin = {
	    size: 'zero'
	  };
	  if (margin) classNameParameters.push.apply(classNameParameters, getMarginClasses(margin));
	  if (padding) classNameParameters.push.apply(classNameParameters, getPaddingClasses(padding));
	  if (borderRadius) classNameParameters.push(getBorderRadiusClasses(borderRadius));
	  if (color) classNameParameters.push(colors["color__" + color]);
	  if (hoverColor) classNameParameters.push(colors["color__" + hoverColor + "Hoverable"]);
	  if (block) classNameParameters.push(styles$1.element__block);
	  if (inlineBlock) classNameParameters.push(styles$1.element__inlineBlock);
	  if (backgroundColor) classNameParameters.push(colors["color_background__" + backgroundColor]);
	  if (backgroundHoverColor) classNameParameters.push(colors["color_background__" + backgroundHoverColor + "Hoverable"]);
	  if (className) classNameParameters.push(className);
	  if (hidden !== undefined) classNameParameters.push((_classNameParameters$ = {}, _classNameParameters$[styles$1.element__hidden] = hidden, _classNameParameters$['hidden-e2e-test'] = hidden, _classNameParameters$['shown-e2e-test'] = !hidden, _classNameParameters$));
	  if (flexItem) classNameParameters.push(styles.flex_flexItem);
	  if (boxShadow) classNameParameters.push(styles$1["element__boxShadow__" + boxShadow]);
	  if (hoverBoxShadow) classNameParameters.push(styles$1["element_boxShadowHoverable__" + hoverBoxShadow]);
	  if (alignTextToCenter) classNameParameters.push(styles$1.element__alignTextToCenter);
	  if (alignTextToRight) classNameParameters.push(styles$1.element__alignTextToRight);

	  if (responsiveHidden) {
	    classNameParameters.push.apply(classNameParameters, getResponsiveClasses({
	      styles: hiddenStyles,
	      prefix: 'hidden__',
	      selector: responsiveHidden
	    }));
	  }

	  if (occupyVerticalSpace) classNameParameters.push(styles$1.element__occupyVerticalSpace);
	  if (occupyHorizontalSpace) classNameParameters.push(styles$1.element__occupyHorizontalSpace);
	  if (forceWrap) classNameParameters.push(styles$1.element__forceWrap);
	  if (hideOverflow) classNameParameters.push(styles$1.element__hideOverflow);
	  if (showOverflow) classNameParameters.push(styles$1.element__showOverflow);
	  if (clickableAppearance) classNameParameters.push(styles$1.element__clickableAppearance);

	  if (flexItem && flexItem !== true && flexItem.alignSelfTo) {
	    classNameParameters.push(styles$1["element__alignSelfTo" + upperFirst$1(flexItem.alignSelfTo)]);
	  }

	  if (fontWeight) {
	    classNameParameters.push(styles$1["element__fontWeight__" + fontWeight]);
	  }

	  var classNames = classnames(classNameParameters);

	  if (contains('undefined', classNames)) {
	    throw new Error("Undefined class name encountered in Element \"" + tagName + "\": \"" + classNames + "\"");
	  }

	  var style = _objectSpread(_objectSpread({}, flexItem && flexItem !== true && flexItem.sizeMultiplier && {
	    flexGrow: flexItem.sizeMultiplier
	  }), explicitStyles);

	  return /*#__PURE__*/React.createElement(tagName, _objectSpread(_objectSpread({
	    className: classNames,
	    ref: refElement
	  }, keys$5(style).length > 0 && {
	    style: style
	  }), props), children);
	}
	var supportedColors = ['inherit', 'transparent', 'overlay', 'white', 'black', 'purple100', 'purple200', 'purple300', 'purple400', 'purple500', 'purple600', 'purple700', 'purple800', 'purple900', 'gray100', 'gray200', 'gray300', 'gray400', 'gray500', 'gray600', 'gray700', 'gray800', 'gray900', 'red100', 'red200', 'red300', 'red400', 'red500', 'red600', 'red700', 'red800', 'red900', 'blue100', 'blue200', 'blue300', 'blue400', 'blue500', 'blue600', 'blue700', 'blue800', 'blue900', 'orange100', 'orange200', 'orange300', 'orange400', 'orange500', 'orange600', 'orange700', 'orange800', 'orange900', 'green100', 'green200', 'green300', 'green400', 'green500', 'green600', 'green700', 'green800', 'green900'];
	var supportedFontWeights = ['normal', 'medium', 'bold'];
	var supportedSizes = ['zero', 'xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xlg', 'xxlg'];
	var responsiveSupportedSizes = ['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xlg'];

	var _excluded$1 = ["children"];

	var Div = function Div(_ref) {
	  var children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "div"
	  }, props), children);
	};

	var _excluded$2 = ["className", "children", "centered", "centeredVertically", "centeredHorizontally", "alignTop", "alignBottom", "alignBaseline", "alignRight", "spaceBetween", "wrapContent", "pileVerticallyTo", "occupyVerticalSpace", "stretchToSameHeight", "reverseDirection", "directionColumn", "tagName"];

	function Flex(_ref) {
	  var _ref2;

	  var className = _ref.className,
	      children = _ref.children,
	      centered = _ref.centered,
	      _ref$centeredVertical = _ref.centeredVertically,
	      centeredVertically = _ref$centeredVertical === void 0 ? centered : _ref$centeredVertical,
	      _ref$centeredHorizont = _ref.centeredHorizontally,
	      centeredHorizontally = _ref$centeredHorizont === void 0 ? centered : _ref$centeredHorizont,
	      alignTop = _ref.alignTop,
	      alignBottom = _ref.alignBottom,
	      alignBaseline = _ref.alignBaseline,
	      alignRight = _ref.alignRight,
	      spaceBetween = _ref.spaceBetween,
	      wrapContent = _ref.wrapContent,
	      pileVerticallyTo = _ref.pileVerticallyTo,
	      _ref$occupyVerticalSp = _ref.occupyVerticalSpace,
	      occupyVerticalSpace = _ref$occupyVerticalSp === void 0 ? true : _ref$occupyVerticalSp,
	      stretchToSameHeight = _ref.stretchToSameHeight,
	      reverseDirection = _ref.reverseDirection,
	      directionColumn = _ref.directionColumn,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$2);

	  var classNames = [styles.flex, (_ref2 = {}, _ref2[styles.flex__centeredVertically] = centeredVertically, _ref2[styles.flex__centeredHorizontally] = centeredHorizontally, _ref2[styles.flex__alignTop] = alignTop, _ref2[styles.flex__alignBottom] = alignBottom, _ref2[styles.flex__alignBaseline] = alignBaseline, _ref2[styles.flex__alignRight] = alignRight, _ref2[styles.flex__spaceBetween] = spaceBetween, _ref2[styles.flex__wrapContent] = wrapContent, _ref2[styles.flex__stretchToSameHeight] = stretchToSameHeight, _ref2[styles.flex__pileVerticallyToXxxsScreen] = pileVerticallyTo === 'xxxs', _ref2[styles.flex__pileVerticallyToXxsScreen] = pileVerticallyTo === 'xxs', _ref2[styles.flex__pileVerticallyToXsScreen] = pileVerticallyTo === 'xs', _ref2[styles.flex__pileVerticallyToSmScreen] = pileVerticallyTo === 'sm', _ref2[styles.flex__pileVerticallyToMdScreen] = pileVerticallyTo === 'md', _ref2[styles.flex__pileVerticallyToLgScreen] = pileVerticallyTo === 'lg', _ref2[styles.flex__pileVerticallyToXlgScreen] = pileVerticallyTo === 'xlg', _ref2[styles.flex__occupyVerticalSpace] = occupyVerticalSpace, _ref2[styles.flex__reverseDirection] = reverseDirection, _ref2[styles.flex__directionColumn] = directionColumn, _ref2), className];
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: tagName,
	    className: classNames
	  }, props), children);
	}

	var fails$1 = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	// Detect IE8's incomplete defineProperty implementation
	var descriptors$1 = !fails$1(function () {
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
	});

	var check$1 = function (it) {
	  return it && it.Math == Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global$2 =
	  // eslint-disable-next-line no-undef
	  check$1(typeof globalThis == 'object' && globalThis) ||
	  check$1(typeof window == 'object' && window) ||
	  check$1(typeof self == 'object' && self) ||
	  check$1(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  // eslint-disable-next-line no-new-func
	  (function () { return this; })() || Function('return this')();

	var isObject$2 = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var document$2 = global$2.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS$2 = isObject$2(document$2) && isObject$2(document$2.createElement);

	var documentCreateElement$1 = function (it) {
	  return EXISTS$2 ? document$2.createElement(it) : {};
	};

	// Thank's IE8 for his funny defineProperty
	var ie8DomDefine$1 = !descriptors$1 && !fails$1(function () {
	  return Object.defineProperty(documentCreateElement$1('div'), 'a', {
	    get: function () { return 7; }
	  }).a != 7;
	});

	var anObject$1 = function (it) {
	  if (!isObject$2(it)) {
	    throw TypeError(String(it) + ' is not an object');
	  } return it;
	};

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var toPrimitive$1 = function (input, PREFERRED_STRING) {
	  if (!isObject$2(input)) return input;
	  var fn, val;
	  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$2(val = fn.call(input))) return val;
	  if (typeof (fn = input.valueOf) == 'function' && !isObject$2(val = fn.call(input))) return val;
	  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$2(val = fn.call(input))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

	var nativeDefineProperty$1 = Object.defineProperty;

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	var f$8 = descriptors$1 ? nativeDefineProperty$1 : function defineProperty(O, P, Attributes) {
	  anObject$1(O);
	  P = toPrimitive$1(P, true);
	  anObject$1(Attributes);
	  if (ie8DomDefine$1) try {
	    return nativeDefineProperty$1(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var objectDefineProperty$1 = {
		f: f$8
	};

	var defineProperty$a = objectDefineProperty$1.f;

	var FunctionPrototype$3 = Function.prototype;
	var FunctionPrototypeToString = FunctionPrototype$3.toString;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';

	// Function instances `.name` property
	// https://tc39.es/ecma262/#sec-function-instances-name
	if (descriptors$1 && !(NAME in FunctionPrototype$3)) {
	  defineProperty$a(FunctionPrototype$3, NAME, {
	    configurable: true,
	    get: function () {
	      try {
	        return FunctionPrototypeToString.call(this).match(nameRE)[1];
	      } catch (error) {
	        return '';
	      }
	    }
	  });
	}

	var styles$4 = {"icon":"telia-react-icon","icon__sizeXlg":"telia-react-icon__sizeXlg","icon__sizeLg":"telia-react-icon__sizeLg","icon__sizeMd":"telia-react-icon__sizeMd","icon__sizeSm":"telia-react-icon__sizeSm","icon__sizeXs":"telia-react-icon__sizeXs","icon_svg":"telia-react-icon_svg"};

	var _path;

	function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

	function Svg4G(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
	    d: "M27.446 40.384c1.158 0 2.316-1.89 2.316-3.74 0-.822-.439-1.233-1.317-1.233h-2.276V18.685c0-.863-.48-1.315-1.398-1.315h-1.477c-1.438 0-3.075.822-3.754 1.85L8.36 36.11c-.24.37-.36.698-.36 1.027 0 .863 1.438 3.247 2.755 3.247h10.462v3.287c0 .863 1.318 2.96 2.476 2.96 1.238 0 2.476-1.974 2.476-3.987v-2.26h1.277zM14.15 35.41l7.068-11.096v11.096H14.15zM50.61 39.973c-1.398.863-2.995 1.274-4.792 1.274-1.598 0-3.035-.37-4.313-1.151-2.556-1.52-4.193-4.48-4.193-8.137 0-5.302 3.714-9.123 8.945-9.123 1.597 0 2.795.328 4.672 1.274.36.205.679.287.958.287.36 0 .759-.205 1.118-.575.759-.74 1.358-2.096 1.358-3.452 0-.576-.2-.986-.6-1.233C51.569 17.699 49.053 17 46.298 17c-2.556 0-4.952.657-7.188 1.931-4.472 2.63-7.547 7.603-7.547 13.316 0 2.589.6 5.013 1.757 7.233C35.635 43.959 40.107 47 45.38 47a13.66 13.66 0 004.272-.657C52.406 45.52 56 43.877 56 39.15v-7.192c0-.945-.48-1.397-1.477-1.397H49.53c-1.877 0-3.753 1.315-3.753 2.506 0 .658 1.278 3.042 2.595 3.042h2.236v3.863z"
	  })));
	}

	var _path$1;

	function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

	function Svg5G(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
	    d: "M24.652 22.959c1.265 0 2.571-2.014 2.571-3.986 0-.904-.49-1.357-1.47-1.357h-12.61c-1.796 0-3.674 1.233-3.715 2.425l-.53 11.753c0 .412.204.905.612 1.48.572.945 1.184 1.397 1.877 1.397.164 0 .49-.123.98-.328 1.673-.864 3.796-1.48 5.428-1.48 2.98 0 5.143 1.767 5.143 4.356 0 2.507-2.163 4.48-4.939 4.48-2.122 0-3.591-.781-5.02-2.713-.245-.37-.653-.575-1.265-.575C9.918 38.411 8 39.685 8 40.836c0 .246.122.616.327 1.11C9.959 45.026 13.632 47 17.837 47c1.877 0 3.631-.411 5.223-1.274 3.225-1.644 5.428-4.808 5.428-8.466 0-1.644-.408-3.164-1.224-4.52-1.633-2.754-4.816-4.562-8.612-4.562-1.428 0-3.224.37-4.652.904l.285-6.123h10.367zM50.49 39.973c-1.428.863-3.06 1.274-4.898 1.274-1.632 0-3.101-.37-4.407-1.151-2.612-1.52-4.286-4.48-4.286-8.137 0-5.302 3.796-9.123 9.142-9.123 1.633 0 2.857.328 4.776 1.274.367.205.694.287.98.287.367 0 .775-.205 1.142-.575.775-.74 1.388-2.096 1.388-3.452 0-.576-.204-.986-.613-1.233C51.47 17.699 48.898 17 46.082 17c-2.612 0-5.06.657-7.346 1.931-4.571 2.63-7.714 7.603-7.714 13.316 0 2.589.612 5.013 1.796 7.233C35.185 43.959 39.756 47 45.144 47c1.51 0 2.938-.206 4.367-.657C52.327 45.52 56 43.877 56 39.15v-7.192c0-.945-.49-1.397-1.51-1.397h-5.102c-1.918 0-3.836 1.315-3.836 2.506 0 .658 1.306 3.042 2.653 3.042h2.285v3.863z"
	  })));
	}

	var _path$2;

	function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

	function SvgAdd(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
	    d: "M32 6a26 26 0 1026 26A26.029 26.029 0 0032 6zm0 48a22 22 0 1122-22 22.025 22.025 0 01-22 22zm14-22a2 2 0 01-2 2H34v10a2 2 0 01-4 0V34H20a2 2 0 010-4h10V20a2 2 0 014 0v10h10a2 2 0 012 2z"
	  })));
	}

	var _path$3, _path2;

	function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

	function SvgAddressBook(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M26.355 25.972a7.7 7.7 0 1114.759 3.08c.75.351 1.465.813 2.097 1.356C44.73 31.713 46 33.697 46 36.183v.602A5.215 5.215 0 0140.785 42h-13.57A5.215 5.215 0 0122 36.785v-.602c0-2.515 1.338-4.498 2.858-5.785a9.574 9.574 0 012.13-1.362 7.673 7.673 0 01-.633-3.064zm7.7-3.7a3.7 3.7 0 100 7.4 3.7 3.7 0 000-7.4zM40.785 38c.67 0 1.215-.544 1.215-1.215v-.602c0-1.038-.524-1.991-1.397-2.742-.752-.646-1.598-.998-2.22-1.1a7.664 7.664 0 01-4.328 1.331 7.664 7.664 0 01-4.343-1.34c-.573.086-1.46.434-2.27 1.12-.909.769-1.442 1.722-1.442 2.73v.602c0 .672.544 1.216 1.215 1.216h13.57z"
	  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M13 8a4 4 0 014-4h29a8 8 0 018 8v40a8 8 0 01-8 8H17a4 4 0 01-4-4v-7h-1a2 2 0 110-4h1v-6h-1a2 2 0 110-4h1v-6h-1a2 2 0 110-4h1v-6h-1a2 2 0 110-4h1V8zm4 41h1a2 2 0 100-4h-1v-6h1a2 2 0 100-4h-1v-6h1a2 2 0 100-4h-1v-6h1a2 2 0 100-4h-1V8h29a4 4 0 014 4v40a4 4 0 01-4 4H17v-7z"
	  })));
	}

	var _path$4;

	function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

	function SvgAiRobot(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$5({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M54.76 30.973v-6.22a8.303 8.303 0 00-8.293-8.293h-2.073v-4.722a4.147 4.147 0 10-4.147 0v4.722H23.66v-4.722a4.147 4.147 0 10-4.147 0v4.722H17.44a8.303 8.303 0 00-8.293 8.293v6.22a4.147 4.147 0 000 8.294v12.44A8.303 8.303 0 0017.44 60h29.027a8.303 8.303 0 008.293-8.293v-12.44a4.147 4.147 0 100-8.294zm-4.146 20.733a4.151 4.151 0 01-4.147 4.147H17.44a4.151 4.151 0 01-4.147-4.147V24.753a4.151 4.151 0 014.147-4.147h29.027a4.151 4.151 0 014.147 4.147v26.953zM29.88 33.046a6.22 6.22 0 10-6.22 6.22 6.227 6.227 0 006.22-6.22zm-8.293 0a2.073 2.073 0 114.147 0 2.073 2.073 0 01-4.147 0zm18.66-6.22a6.22 6.22 0 106.22 6.22 6.227 6.227 0 00-6.22-6.22zm0 8.294a2.073 2.073 0 110-4.147 2.073 2.073 0 010 4.147zm3.787 9.2c.645.946.4 2.236-.546 2.88-2.304 1.57-6.4 2.433-11.534 2.433s-9.23-.863-11.534-2.432a2.074 2.074 0 012.334-3.428c.59.402 2.998 1.714 9.2 1.714 6.201 0 8.609-1.312 9.2-1.714a2.076 2.076 0 012.88.546z"
	  })));
	}

	var _path$5;

	function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

	function SvgAirplay(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$6({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
	    d: "M60 20v24a8.01 8.01 0 01-8 8h-4a2 2 0 010-4h4a4.005 4.005 0 004-4V20a4.005 4.005 0 00-4-4H12a4.004 4.004 0 00-4 4v24a4.004 4.004 0 004 4h4a2 2 0 010 4h-4a8.01 8.01 0 01-8-8V20a8.01 8.01 0 018-8h40a8.01 8.01 0 018 8zM41.784 49.88A4 4 0 0138.392 56H25.608a4 4 0 01-3.392-6.12l6.391-10.226a4 4 0 016.786 0l6.391 10.227zM38.392 52L32 41.773 25.608 52h12.784z"
	  })));
	}

	var _path$6;

	function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

	function SvgAlarmOff(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$7({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
	    d: "M47.1 39.449l6.257 5.24c-2.628-5.26-3.608-10.35-3.568-17.88 0-6.941-5.547-12.491-11.994-15.062a6.002 6.002 0 00-2.242-6.623 5.994 5.994 0 00-6.99 0 6.002 6.002 0 00-2.241 6.624 22.367 22.367 0 00-6.997 4.37l3.009 2.59a19.595 19.595 0 016.436-3.62c.59-.204 1.191-.378 1.8-.52a38.732 38.732 0 01-.59-4 3.421 3.421 0 010-.41 1.552 1.552 0 010-.2 2 2 0 113.997 0c.005.066.005.133 0 .2.009.136.009.273 0 .41a38.732 38.732 0 01-.59 4c.61.142 1.21.316 1.8.52 5.167 1.72 10.564 5.97 10.564 11.72a49.288 49.288 0 001.35 12.641zM11.189 52h38.37l-4.768-4H13.468c3.508-6.38 4.787-12.201 4.787-21.142 0-.357.02-.714.06-1.07l-3.438-2.88a13.01 13.01 0 00-.62 3.95c0 9.07-1.42 14.601-5.417 21.142a2.591 2.591 0 000 2.62A2.678 2.678 0 0011.189 52zM32.017 60a22.07 22.07 0 01-10.215-2.51 2 2 0 011.86-3.49 18.072 18.072 0 008.355 2 17.833 17.833 0 008.356-2 1.998 1.998 0 012.968 1.843 2 2 0 01-1.11 1.696A22.068 22.068 0 0132.018 60zM59.384 55.27l.15-.17a2 2 0 00-.24-2.81l-3.768-3.16L48.239 43 20.944 20.127l-2.999-2.56-10.624-8.92a2.026 2.026 0 00-2.854.265 2.028 2.028 0 00.265 2.855l14.183 11.87L52.667 52l4.048 3.35c.78.659 1.93.624 2.669-.08z"
	  })));
	}

	var _path$7, _path2$1;

	function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

	function SvgAlarm(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$8({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M54.72 47.989c-4.004-6.547-5.425-12.082-5.425-21.16 0-6.947-5.556-12.502-12.012-15.075a6.006 6.006 0 10-11.49 0C19.335 14.327 13.78 19.882 13.78 26.83c0 9.078-1.421 14.613-5.425 21.16a2.592 2.592 0 000 2.622 2.682 2.682 0 002.322 1.381h41.72a2.683 2.683 0 002.352-1.381 2.593 2.593 0 00-.03-2.622zm-41.73 0c3.514-6.386 4.795-12.212 4.795-21.16 0-5.756 5.405-10.01 10.58-11.731a18.179 18.179 0 011.802-.52 38.744 38.744 0 01-.591-4.005 3.469 3.469 0 010-.41 1.591 1.591 0 010-.2 2.002 2.002 0 014.004 0c.004.067.004.133 0 .2.008.137.008.274 0 .41a38.717 38.717 0 01-.59 4.004c.608.143 1.21.316 1.8.52 5.176 1.752 10.58 6.006 10.58 11.732 0 8.948 1.282 14.774 4.795 21.16H12.99z"
	  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
	    d: "M21.308 57.487A22.11 22.11 0 0031.538 60a22.11 22.11 0 0010.23-2.462 2.002 2.002 0 10-1.862-3.544 17.866 17.866 0 01-8.368 2.002c-2.91.015-5.78-.672-8.368-2.002a2.002 2.002 0 00-1.862 3.493z"
	  })));
	}

	var _path$8;

	function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

	function SvgAlertFilled(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$9({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M60 32c0 15.464-12.536 28-28 28-15.457-.017-27.983-12.543-28-28C4 16.536 16.536 4 32 4s28 12.536 28 28zM34.228 46.042a2.809 2.809 0 00-.568-1.346c-.558-.818-1.096-1.227-1.615-1.227-.402.018-.782.19-1.062.48a3.61 3.61 0 00-.867 1.3 4.417 4.417 0 00-.344 1.72c0 .758.418 1.137 1.256 1.137.776 0 1.536-.229 2.183-.658.678-.44 1.017-.908 1.017-1.406zM29.35 20.68v17.922c.001 1.033.493 1.55 1.476 1.55.93 0 1.838-.318 2.61-.912.81-.608 1.216-1.246 1.216-1.914V19.404a3.613 3.613 0 00-.638-1.779c-.663-1.154-1.328-1.731-1.993-1.731a1.75 1.75 0 00-1.216.638 4.998 4.998 0 00-1.037 1.778 6.828 6.828 0 00-.418 2.37z"
	  })));
	}

	var _path$9, _path2$2;

	function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

	function SvgAlert(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$a({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32c.017 15.457 12.543 27.983 28 28zm0-51.692c13.085 0 23.692 10.607 23.692 23.692S45.085 55.692 32 55.692 8.308 45.085 8.308 32C8.322 18.921 18.92 8.322 32 8.308z"
	  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
	    d: "M29.35 38.603V20.681a6.828 6.828 0 01.417-2.371c.227-.673.581-1.28 1.037-1.778a1.75 1.75 0 011.216-.638c.665 0 1.33.577 1.993 1.731.36.509.583 1.128.638 1.78v17.922c0 .668-.406 1.306-1.217 1.914-.77.594-1.68.911-2.609.911-.983 0-1.475-.516-1.476-1.549zM33.66 44.696c.305.39.501.855.568 1.346 0 .498-.339.966-1.017 1.406a3.947 3.947 0 01-2.183.658c-.838 0-1.256-.379-1.256-1.137a4.417 4.417 0 01.344-1.72 3.61 3.61 0 01.867-1.3c.28-.29.66-.462 1.062-.48.518 0 1.057.41 1.615 1.227z"
	  })));
	}

	var _path$a;

	function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

	function SvgArrowDown(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$b({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M12.662 32.513a2 2 0 012.704.026l.12.123L30 48.788 30 10a2 2 0 011.85-1.995L32 8a2 2 0 011.995 1.85L34 10v38.789l14.513-16.127a2 2 0 012.692-.259l.133.11a2 2 0 01.259 2.692l-.11.133-18.008 20.008-.141.14-.075.065-.085.065-.129.087-.206.111-.166.069-.19.057-.192.038-.131.015-.165.007-.162-.007-.166-.02-.105-.02-.167-.045-.15-.054-.154-.07-.144-.08-.164-.114-.133-.111-.168-.172-17.973-19.97a2 2 0 01.15-2.824z"
	  })));
	}

	var _path$b;

	function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

	function SvgArrowLeft(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$c({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.487 12.662a2 2 0 01-.026 2.704l-.123.12L15.212 30 54 30a2 2 0 011.995 1.85L56 32a2 2 0 01-1.85 1.995L54 34H15.211l16.127 14.513a2 2 0 01.259 2.692l-.11.133a2 2 0 01-2.692.259l-.133-.11L8.654 33.479l-.14-.141-.065-.075-.065-.085-.087-.129-.111-.206-.068-.166-.058-.19-.038-.192-.015-.131L8 31.999l.007-.162.02-.166.02-.105.045-.167.054-.15.07-.154.08-.144.114-.164.111-.133.172-.168 19.97-17.973a2 2 0 012.824.15z"
	  })));
	}

	var _path$c;

	function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

	function SvgArrowRight(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$d({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32.513 51.338a2 2 0 01.026-2.704l.123-.12L48.788 34 10 34a2 2 0 01-1.995-1.85L8 32a2 2 0 011.85-1.994L10 30h38.789L32.662 15.487a2 2 0 01-.259-2.692l.11-.133a2 2 0 012.692-.259l.133.11 20.008 18.008.14.141.065.075.065.085.087.129.111.206.069.166.057.19.038.192.015.131.007.165-.007.162-.02.166-.02.105-.045.167-.054.15-.07.154-.08.144-.114.164-.111.133-.172.168-19.97 17.973a2 2 0 01-2.824-.15z"
	  })));
	}

	var _path$d;

	function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

	function SvgArrowSubdirectory(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$e({
	    viewBox: "0 0 24 24",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M19.279 13.279l-4.5 4.5a.75.75 0 01-1.058-1.058L16.94 13.5H7.5a3 3 0 01-3-3V6.75a.75.75 0 011.5 0v3.75A1.5 1.5 0 007.5 12h9.439L13.72 8.779A.75.75 0 0114.78 7.72l4.5 4.5a.75.75 0 010 1.058z"
	  })));
	}

	var _path$e;

	function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

	function SvgArrowUp(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$f({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.338 31.487a2 2 0 01-2.704-.026l-.12-.123L34 15.212 34 54a2 2 0 01-1.85 1.995L32 56a2 2 0 01-1.994-1.85L30 54V15.211L15.487 31.338a2 2 0 01-2.692.259l-.133-.11a2 2 0 01-.259-2.692l.11-.133L30.521 8.654l.141-.14.075-.065.085-.065.129-.087.206-.111.166-.068.19-.058.192-.038.131-.015.165-.007.162.007.166.02.105.02.167.045.15.054.154.07.144.08.164.114.133.111.168.172 17.973 19.97a2 2 0 01-.15 2.824z"
	  })));
	}

	var _path$f;

	function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

	function SvgAttachment(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$g({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56.772 26.488l-9.35 9.407-11.084 10.982-5.992 6.037c-6.086 5.917-15.797 5.85-21.799-.153-6.003-6.003-6.07-15.713-.153-21.8l17.893-17.893a2.31 2.31 0 113.254 3.278l-17.893 17.87c-4.274 4.277-4.271 11.21.006 15.484 4.277 4.274 11.21 4.271 15.484-.006l6.106-6.095 20.343-20.354a6.9 6.9 0 00-4.945-11.787 6.9 6.9 0 00-4.876 2.013l-3.6 3.6v.068l-16.73 16.663-2.048 2.093a2.875 2.875 0 000 4.06 2.944 2.944 0 004.071 0l18.71-18.756a2.301 2.301 0 113.254 3.254L28.725 43.15a7.475 7.475 0 11-10.568-10.568l22.355-22.355c4.512-4.358 11.684-4.296 16.12.14 4.436 4.436 4.498 11.608.14 16.12z"
	  })));
	}

	var _path$g;

	function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

	function SvgB2BCustomer(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$h({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M21.414 17C22.72 12.383 26.964 9 32 9c5.035 0 9.28 3.383 10.586 8H52a8 8 0 018 8v22a8 8 0 01-8 8H12a8 8 0 01-8-8V25a8 8 0 018-8h9.414zm4.26 0a7 7 0 0112.652 0H25.674zM56 25a4 4 0 00-4-4H12a4 4 0 00-4 4v4a4 4 0 004 4h12v-.5a4 4 0 014-4h7a4 4 0 014 4v.5h13a4 4 0 004-4v-4zM12 37h12.03A4 4 0 0028 40.5h7a4 4 0 003.97-3.5H52c1.457 0 2.823-.39 4-1.07V47a4 4 0 01-4 4H12a4 4 0 01-4-4V35.93A7.963 7.963 0 0012 37zm16-4.5v4h7v-4h-7z"
	  })));
	}

	var _path$h;

	function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

	function SvgBag(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$i({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
	    d: "M55.33 49.191l-3.15-29.615A3.992 3.992 0 0048.201 16H44a12 12 0 00-24 0h-4.202a3.993 3.993 0 00-3.978 3.576l-3.15 29.628A8 8 0 0016.63 58h30.74a8 8 0 007.959-8.809zM32 8a8.01 8.01 0 018 8H24a8.01 8.01 0 018-8zm18.337 44.685A3.956 3.956 0 0147.37 54H16.63a3.998 3.998 0 01-3.98-4.385L15.8 20H20v8a2 2 0 004 0v-8h16v8a2 2 0 004 0v-8h4.202l3.148 29.602a3.955 3.955 0 01-1.013 3.083z"
	  })));
	}

	var _path$i;

	function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

	function SvgBarChart(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$j({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58 52h-6V12a4.004 4.004 0 00-4-4h-8a4.004 4.004 0 00-4 4v12h-8a4.004 4.004 0 00-4 4v4h-8a4.004 4.004 0 00-4 4v16H6a2 2 0 100 4h52a2 2 0 100-4zm-42 0V36h8v16h-8zm12 0V28h8v24h-8zm12 0V12h8v40h-8z"
	  })));
	}

	var _path$j;

	function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

	function SvgBasketball(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$k({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.905 51.669c10.832-10.944 10.788-28.584-.101-39.473-10.889-10.889-28.529-10.934-39.473-.1-.043.036-.09.065-.13.105-.04.04-.07.087-.106.13-10.833 10.944-10.788 28.584.101 39.473 10.889 10.889 28.529 10.934 39.473.1.043-.036.09-.065.13-.105.04-.04.07-.087.106-.13zm-21.99 3.926a23.583 23.583 0 01-13.067-5.398L32 35.046l4.554 4.554a27.91 27.91 0 00-6.639 15.995zm9.685-12.95l7.552 7.552a23.585 23.585 0 01-12.91 5.386A23.619 23.619 0 0139.6 42.645zm3.046-3.045a23.62 23.62 0 0112.937-5.358 23.584 23.584 0 01-5.386 12.91L42.646 39.6zm12.949-9.684a27.91 27.91 0 00-15.996 6.638L35.045 32l15.152-15.152a23.583 23.583 0 015.398 13.068zM13.803 16.848l7.466 7.467a23.623 23.623 0 01-12.845 5.35 23.587 23.587 0 015.379-12.817zm3.045-3.045a23.586 23.586 0 0112.816-5.379 23.622 23.622 0 01-5.35 12.845l-7.466-7.466zm17.144-5.405a23.582 23.582 0 0113.16 5.405L32 28.954l-4.64-4.639a27.913 27.913 0 006.632-15.917zM8.398 33.992a27.911 27.911 0 0015.917-6.631L28.955 32 13.803 47.15a23.582 23.582 0 01-5.405-13.159z"
	  })));
	}

	var _path$k;

	function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

	function SvgBattery(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$l({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M27.414 24.586A2 2 0 0026 24H15.818A3.674 3.674 0 0012 27.5v9a3.674 3.674 0 003.818 3.5H38a2 2 0 001.414-3.414l-12-12zM16 35.994V28h9.172l7.998 7.998L16 35.995zM56 22h-.253A8.015 8.015 0 0048 16H12a8.01 8.01 0 00-8 8v16a8.01 8.01 0 008 8h36a8.015 8.015 0 007.747-6H56c2.243 0 4-2.05 4-4.666V26.666C60 24.05 58.243 22 56 22zm0 15.334c.008.233-.052.465-.17.666H52v2a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V24a4.004 4.004 0 014-4h36a4.004 4.004 0 014 4v2h3.83c.118.201.178.433.17.666v10.668z"
	  })));
	}

	var _path$l;

	function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

	function SvgBloodPressure(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$m({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M55.826 34.275l-20.494 21.25a4.297 4.297 0 01-3.108 1.327h-.008a4.298 4.298 0 01-3.107-1.317L8.329 34.12a14.98 14.98 0 01-1.779-2.063 2.166 2.166 0 011.801-3.37h9.495l3.734-7.47a2.167 2.167 0 013.876 0l6.729 13.459 2.395-4.792a2.167 2.167 0 011.938-1.197h6.5a2.167 2.167 0 010 4.333h-5.161l-3.734 7.47a2.167 2.167 0 01-3.877 0L23.518 27.03l-2.395 4.791a2.167 2.167 0 01-1.939 1.198h-5.883l18.917 19.498 20.489-21.25c4.407-4.642 4.396-11.926-.025-16.553a10.927 10.927 0 00-7.894-3.38h-.017a10.929 10.929 0 00-7.9 3.404l-3.15 3.266c-.408.422-.97.661-1.557.662h-.003a2.166 2.166 0 01-1.555-.658l-3.159-3.256a10.928 10.928 0 00-7.894-3.38h-.016a10.93 10.93 0 00-7.901 3.404 11.907 11.907 0 00-3.244 9.411 2.167 2.167 0 01-4.314.409 16.24 16.24 0 014.439-12.829A15.226 15.226 0 0119.53 7.038h.023a15.227 15.227 0 0111.004 4.696l1.6 1.649 1.594-1.654A15.226 15.226 0 0144.764 7h.024a15.227 15.227 0 0111.004 4.696c6.03 6.313 6.045 16.248.034 22.579z"
	  })));
	}

	var _path$m;

	function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

	function SvgBroadband(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$n({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M33.833 32.423v23.834a2.167 2.167 0 11-4.333 0V32.422a2.167 2.167 0 114.333 0zm7.661-20.66a2.166 2.166 0 10-3.064 3.064 6.501 6.501 0 010 9.192 2.166 2.166 0 103.064 3.064c4.23-4.23 4.23-11.09 0-15.32zm6.128-6.129A2.167 2.167 0 1044.558 8.7a15.165 15.165 0 010 21.448 2.167 2.167 0 003.064 3.065 19.5 19.5 0 000-27.578zm-15.955 10.54a3.25 3.25 0 100 6.499 3.25 3.25 0 000-6.5zm-6.764-4.412a2.167 2.167 0 00-3.064 0c-4.23 4.231-4.23 11.09 0 15.321a2.167 2.167 0 103.064-3.064 6.502 6.502 0 010-9.192 2.166 2.166 0 000-3.065zm-10.57 7.661A15.063 15.063 0 0118.776 8.7a2.167 2.167 0 00-3.064-3.064 19.5 19.5 0 000 27.577 2.167 2.167 0 003.064-3.065 15.063 15.063 0 01-4.443-10.724z"
	  })));
	}

	var _path$n, _path2$3, _path3;

	function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

	function SvgBrokenPhone(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$o({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
	    d: "M33.56 7.914l3.77 1.277a3.77 3.77 0 012.353 4.777l-3.75 11.218a1.995 1.995 0 001.247 2.523c.206.07.421.108.638.11a1.994 1.994 0 001.885-1.356l3.81-11.209a7.75 7.75 0 00-4.857-9.833l-3.81-1.276a1.995 1.995 0 10-1.286 3.77zM29.342 52.242a1.925 1.925 0 11-3.85 0 1.925 1.925 0 013.85 0z"
	  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M38.856 34.012c0-1.102.893-1.995 1.994-1.995a1.995 1.995 0 012.014 1.995v18.24A7.758 7.758 0 0135.117 60H19.759A7.769 7.769 0 0112 52.252V14.845a7.768 7.768 0 017.739-7.758h7.04a1.994 1.994 0 010 3.989h-7.04a3.77 3.77 0 00-3.75 3.77v29.647h22.867V34.012zm-19.117 21.94h15.357v.059a3.76 3.76 0 003.83-3.76v-3.77H15.988v3.77a3.76 3.76 0 003.75 3.7zM45.108 25.116c.33-.003.655-.085.947-.239l4.837-2.662a1.995 1.995 0 10-1.915-3.5l-4.856 2.662a1.994 1.994 0 00.997 3.74h-.01zm-.04 0h-.01.05-.04z"
	  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
	    d: "M45.736 27.031l4.668 1.357v-.02a1.994 1.994 0 01-.549 3.919 2.085 2.085 0 01-.548-.08l-4.668-1.336a1.996 1.996 0 111.097-3.84z"
	  })));
	}

	var _path$o;

	function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

	function SvgBulb(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$p({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59.999 32a2 2 0 01-2 2h-4a2 2 0 010-4h4a2 2 0 012 2zM51.798 12.2a2 2 0 00-2.828 0l-2.828 2.828a2 2 0 102.828 2.828l2.828-2.828a2 2 0 000-2.828zM31.999 12a2 2 0 002-2V6a2 2 0 10-4 0v4a2 2 0 002 2zm-14.142 5.857a1.999 1.999 0 000-2.828l-2.828-2.828a2 2 0 10-2.828 2.828l2.828 2.828a1.999 1.999 0 002.828 0zM10 30H6a2 2 0 100 4h4a2 2 0 000-4zm37.999 2a15.968 15.968 0 01-5.53 12.075c-.347.314-.63.695-.831 1.119l-1.639 3.278v3.3a8.123 8.123 0 01-7.009 8.166A8.002 8.002 0 0124 52v-3.527l-1.642-3.284a3.583 3.583 0 00-.83-1.118A15.99 15.99 0 1147.998 32zm-12 18h-8v2a4.002 4.002 0 004.51 3.968A4.175 4.175 0 0036 51.77V50zm8-18a12 12 0 10-19.853 9.046 7.547 7.547 0 011.79 2.352l1.3 2.601h9.527l1.297-2.595a7.54 7.54 0 011.792-2.353 11.973 11.973 0 004.147-9.052z"
	  })));
	}

	var _path$p, _path2$4;

	function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

	function SvgBusinessContinuity(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M36 27.014a2 2 0 00-2 2v6h-6a2 2 0 00-2 2v4h-6a2 2 0 00-2 2v10h-1a2 2 0 100 4h30a2 2 0 000-4h-1v-24a2 2 0 00-2-2h-8zm-6 26h4v-14h-4v14zm-8 0h4v-8h-4v8zm20 0h-4v-22h4v22zM53.9 48.763a2 2 0 01-.781-2.718 22.919 22.919 0 002.75-8.84 22.958 22.958 0 00-.53-7.72 2 2 0 013.887-.944c.701 2.89.934 5.942.622 9.061a26.92 26.92 0 01-3.23 10.38 2 2 0 01-2.718.781z"
	  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
	    d: "M9 33c0-12.703 10.297-23 23-23 7.47 0 14.11 3.56 18.313 9.082H43.5a2 2 0 000 4h10.076a3 3 0 002.99-2.74l.926-10.655a2 2 0 00-3.984-.347l-.575 6.605C47.983 9.878 40.446 6 32 6 17.088 6 5 18.088 5 33c0 4.92 1.318 9.54 3.622 13.516a2 2 0 103.461-2.005A22.886 22.886 0 019 33z"
	  })));
	}

	var _path$q, _path2$5;

	function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

	function SvgBusinessIntelligence(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$r({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46.553 24h-1.2a10.09 10.09 0 00-1.46-3.51l1.07-1.08a2 2 0 00-2.82-2.82l-1.08 1.07a10.09 10.09 0 00-3.51-1.46V15a2 2 0 10-4 0v1.2a10.09 10.09 0 00-3.51 1.46l-1.08-1.07a2 2 0 00-2.82 2.82l1.07 1.08a10.09 10.09 0 00-1.46 3.51h-1.2a2 2 0 100 4h1.2a10.09 10.09 0 001.46 3.51l-1.07 1.08a2 2 0 102.82 2.82l1.08-1.07a10.09 10.09 0 003.51 1.46V37a2 2 0 104 0v-1.2a10.09 10.09 0 003.51-1.46l1.08 1.07a2 2 0 002.82-2.82l-1.07-1.08a10.09 10.09 0 001.46-3.51h1.2a2 2 0 100-4zm-11 8a6 6 0 110-12 6 6 0 010 12z"
	  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M34.553 4c-12.404-.007-22.58 9.823-23 22.22l-4.54 5.12a4 4 0 003 6.66h1.54v8a4 4 0 004 4h6a4 4 0 014 4v2a4 4 0 004 4h16a4 4 0 004-4V44.91a24.08 24.08 0 008-17.91c0-12.703-10.298-23-23-23zm12.4 37.9a4 4 0 00-1.4 3V56h-16v-2a8 8 0 00-8-8h-6V34h-5.55l5.55-6.24V27c0-10.493 8.506-19 19-19 10.493 0 19 8.507 19 19a20.27 20.27 0 01-6.6 14.9z"
	  })));
	}

	var _path$r, _path2$6;

	function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

	function SvgCalendar(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$s({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58 51.385V16.923c-.003-2.378-1.941-4.305-4.333-4.308h-4.334V8.308C49.331 5.93 47.393 4.003 45 4h-4.333c-2.392.003-4.33 1.93-4.334 4.308v4.307h-8.666V8.308C27.664 5.93 25.725 4.003 23.333 4H19c-2.392.003-4.33 1.93-4.333 4.308v4.307h-4.334c-2.392.003-4.33 1.93-4.333 4.308v34.462c.005 4.756 3.882 8.61 8.667 8.615h34.666c4.785-.005 8.662-3.86 8.667-8.615zM45 16.923h-4.333V8.308H45v8.615zm-21.667 0H19V8.308h4.333v8.615zm26 0h4.334v8.062H10.333v-8.062h4.334c.002 2.378 1.941 4.305 4.333 4.308h4.333c2.393-.003 4.331-1.93 4.334-4.308h8.666c.003 2.378 1.942 4.305 4.334 4.308H45c2.392-.003 4.33-1.93 4.333-4.308zm-39 12.062v22.4c.003 2.378 1.942 4.305 4.334 4.307h34.666c2.392-.002 4.331-1.93 4.334-4.307v-22.4H10.333z"
	  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
	    d: "M14.695 35.307c0-1.105.9-2 2.012-2h4.671c1.111 0 2.012.895 2.012 2v1.402c0 1.105-.9 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2v-1.402zM27.737 35.307c0-1.105.901-2 2.012-2h4.671c1.112 0 2.012.895 2.012 2v1.402c0 1.105-.9 2-2.012 2h-4.67a2.006 2.006 0 01-2.013-2v-1.402zM40.78 35.307c0-1.105.9-2 2.012-2h4.67c1.112 0 2.013.895 2.013 2v1.402c0 1.105-.901 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2v-1.402zM14.695 46.111c0-1.104.9-2 2.012-2h4.671c1.111 0 2.012.896 2.012 2v1.403c0 1.104-.9 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2V46.11zM27.737 46.111c0-1.104.901-2 2.012-2h4.671c1.112 0 2.012.896 2.012 2v1.403c0 1.104-.9 2-2.012 2h-4.67a2.006 2.006 0 01-2.013-2V46.11zM40.78 46.111c0-1.104.9-2 2.012-2h4.67c1.112 0 2.013.896 2.013 2v1.403c0 1.104-.901 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2V46.11z"
	  })));
	}

	var _path$s;

	function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

	function SvgCamera(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$t({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.385 16.923h-4.909L43.848 9.04C42.812 5.931 40.554 4 37.957 4H26.043c-2.597 0-4.855 1.931-5.891 5.04l-2.628 7.883h-4.909A8.625 8.625 0 004 25.54v25.846A8.625 8.625 0 0012.615 60h38.77A8.625 8.625 0 0060 51.385V25.539a8.625 8.625 0 00-8.615-8.616zm-27.147-6.52c.459-1.376 1.255-2.095 1.805-2.095h11.913c.55 0 1.347.72 1.805 2.094l2.174 6.521h-19.87l2.173-6.52zm31.454 40.982a4.312 4.312 0 01-4.307 4.307h-38.77a4.312 4.312 0 01-4.307-4.307V25.539a4.312 4.312 0 014.307-4.308h38.77a4.312 4.312 0 014.307 4.307v25.847zM32 25.539c-7.137 0-12.923 5.785-12.923 12.922 0 7.138 5.786 12.924 12.923 12.924 7.137 0 12.923-5.786 12.923-12.923-.008-7.134-5.79-12.916-12.923-12.924zm0 21.538a8.615 8.615 0 118.615-8.615A8.625 8.625 0 0132 47.077z"
	  })));
	}

	var _path$t;

	function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

	function SvgCardView(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$u({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M12 8h40a4 4 0 014 4v14a4 4 0 01-4 4H12a4 4 0 01-4-4V12a4 4 0 014-4zm14 18h26V12H26v14zm-4 0V12H12v14h10zM12 34h40a4 4 0 014 4v14a4 4 0 01-4 4H12a4 4 0 01-4-4V38a4 4 0 014-4zm0 4h10v14H12V38zm40 14H26V38h26v14z"
	  })));
	}

	var _path$u;

	function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

	function SvgCare(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$v({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M57.402 36.22a8.615 8.615 0 00-2.685-1.881A17.017 17.017 0 0042.78 23.532a13.727 13.727 0 10-24.874.007A16.91 16.91 0 005 39.94v4.223a8.457 8.457 0 008.447 8.447h23.186l6.216 6.426a3.163 3.163 0 004.55-.001l10.003-10.341a9.042 9.042 0 000-12.472zM30.342 8.262a9.503 9.503 0 11-9.503 9.503 9.513 9.513 0 019.502-9.503zm-21.118 35.9v-4.223a12.686 12.686 0 0111.305-12.594 13.683 13.683 0 0019.619.007 12.78 12.78 0 019.68 6.384 8.49 8.49 0 00-4.684 2.486l-.02.02-.02-.02a8.483 8.483 0 00-12.259 0 9.04 9.04 0 00-.269 12.164H13.447a4.228 4.228 0 01-4.223-4.223zm45.142 1.595l-9.242 9.556-9.243-9.556a4.785 4.785 0 010-6.598 4.26 4.26 0 016.188 0l1.537 1.589a2.175 2.175 0 003.035 0l1.538-1.59a4.26 4.26 0 016.187 0 4.784 4.784 0 010 6.599z"
	  })));
	}

	var _path$v;

	function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

	function SvgCart(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$w({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M49.438 42a5.99 5.99 0 005.821-4.544l4.622-18.486A4 4 0 0056 14H17.24l-.957-4.784A4.01 4.01 0 0012.36 6H6a2 2 0 100 4h6.361l7.295 36.478A5.999 5.999 0 1027.65 54h14.7a6 6 0 100-4h-14.7a6.019 6.019 0 00-3.961-3.755l-.85-4.245h26.6zM56 18l-4.622 18.486A1.996 1.996 0 0149.438 38H22.04l-4-20H56zM22 54a2 2 0 01-.003-4l.001.001h.003a2 2 0 110 4zm26-4a2 2 0 110 4 2 2 0 010-4z"
	  })));
	}

	var _path$w;

	function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

	function SvgCast(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$x({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
	    d: "M60 20v24a8.01 8.01 0 01-8 8H30a2 2 0 010-4h22a4.005 4.005 0 004-4V20a4.005 4.005 0 00-4-4H12a4.004 4.004 0 00-4 4v6a2 2 0 01-4 0v-6a8.01 8.01 0 018-8h40a8.01 8.01 0 018 8zM6 48a2 2 0 100 4 2 2 0 000-4zm.889-16H6a2 2 0 100 4h.889A13.114 13.114 0 0120 49.111V50a2 2 0 004 0v-.889A17.12 17.12 0 006.889 32zm-.09 8H6a2 2 0 100 4h.8a5.206 5.206 0 015.2 5.2v.8a2 2 0 004 0v-.8A9.21 9.21 0 006.8 40z"
	  })));
	}

	var _path$x, _path2$7, _path3$1, _path4, _path5;

	function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

	function SvgChatRobot(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M16.5 44a.5.5 0 100 1 .5.5 0 000-1zm-2.5.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM25.5 44a.5.5 0 100 1 .5.5 0 000-1zm-2.5.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"
	  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M28 32.83a3.001 3.001 0 10-2 0V34H16v-1.17a3.001 3.001 0 10-2 0v1.232A8.001 8.001 0 007 42v1a3 3 0 100 6v3a8 8 0 008 8h12a8 8 0 008-8v-3a3 3 0 100-6v-1a8.001 8.001 0 00-7-7.938v-1.233zM15 38a4 4 0 00-4 4v10a4 4 0 004 4h12a4 4 0 004-4V42a4 4 0 00-4-4H15z"
	  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M16 49a1 1 0 00-1 1.019c.003.056.009.174.015.233a4.452 4.452 0 00.796 2.08C16.656 53.513 18.237 54.5 21 54.5s4.344-.986 5.189-2.169a4.452 4.452 0 00.796-2.08A5.519 5.519 0 0027 50a1 1 0 00-1-1H16zm1.12 2.112s-.084-.075-.12-.112h8a1.836 1.836 0 01-.12.112l-.084.073c-.48.42-1.502 1.315-3.796 1.315-2.294 0-3.317-.895-3.796-1.315l-.084-.073z"
	  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
	    d: "M39 16a2 2 0 11-4 0 2 2 0 014 0zM46 16a2 2 0 11-4 0 2 2 0 014 0zM53 16a2 2 0 11-4 0 2 2 0 014 0z"
	  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M35 4a8 8 0 00-8 8v7a8 8 0 008 8h1v4a2 2 0 003.302 1.519L45.74 27H52a8 8 0 008-8v-7a8 8 0 00-8-8H35zm17 19h-6c-1 0-2 0-3 1l-3 2.5V25a2 2 0 00-2-2h-3a4 4 0 01-4-4v-7a4 4 0 014-4h17a4 4 0 014 4v7a4 4 0 01-4 4z"
	  })));
	}

	var _path$y;

	function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

	function SvgChat(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 7H24a8.01 8.01 0 00-8 8v8h-4a8.01 8.01 0 00-8 8v12a8.01 8.01 0 008 8h7.17l5.709 5.708A3 3 0 0030 54.586V51h9.999a8.01 8.01 0 008-8v-8H52a8.01 8.01 0 008-8V15a8.01 8.01 0 00-8-8zm-8.001 36a4.004 4.004 0 01-4 4H26v5.172L20.826 47H12a4.004 4.004 0 01-4-4V31a4.004 4.004 0 014-4h4a8.01 8.01 0 008 8h6v3.586a2.999 2.999 0 005.121 2.122L40.83 35H44v8zM56 27a4.004 4.004 0 01-4 4H39.173L34 36.172V31H24a4.004 4.004 0 01-4-4V15a4.004 4.004 0 014-4h28a4.004 4.004 0 014 4v12z"
	  })));
	}

	var _path$z;

	function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

	function SvgCheckCircleFilled(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$A({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm12.561 20.58L31.638 43.963a2.15 2.15 0 01-3.315.328l-8.615-8.615a2.154 2.154 0 013.046-3.046l6.758 6.757L40.977 22.19a2.154 2.154 0 113.584 2.39z"
	  })));
	}

	var _path$A;

	function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

	function SvgCheckCircle(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$B({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm0 51.692C18.915 55.692 8.307 45.085 8.307 32S18.915 8.308 32 8.308 55.692 18.915 55.692 32C55.677 45.079 45.078 55.678 32 55.692zM44.56 24.58L31.638 43.964a2.151 2.151 0 01-3.315.328l-8.615-8.615a2.154 2.154 0 013.045-3.046l6.759 6.757L40.977 22.19a2.154 2.154 0 113.584 2.39z"
	  })));
	}

	var _path$B;

	function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

	function SvgCheckmark(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$C({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M57.544 13.497L28.717 50.56a4.337 4.337 0 01-3.42 1.673 4.334 4.334 0 01-3.064-1.27L6.635 35.366a2.166 2.166 0 013.063-3.063L25.297 47.9l28.826-37.063a2.167 2.167 0 113.42 2.66z"
	  })));
	}

	var _path$C;

	function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

	function SvgChevronDown(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$D({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M53.032 24.865l-19.5 19.5a2.166 2.166 0 01-3.064 0l-19.5-19.5a2.167 2.167 0 013.064-3.063L32 39.77 49.968 21.8a2.167 2.167 0 013.064 3.064z"
	  })));
	}

	var _path$D;

	function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

	function SvgChevronLeft(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$E({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M42.116 49.89a2.166 2.166 0 11-2.899 3.22l-21.666-19.5a2.166 2.166 0 010-3.22l21.666-19.5a2.167 2.167 0 012.9 3.22L22.238 32l19.877 17.89z"
	  })));
	}

	var _path$E;

	function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

	function SvgChevronRight(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$F({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M47.166 32c0 .615-.26 1.2-.717 1.61l-21.667 19.5a2.166 2.166 0 01-2.898-3.22L41.76 32 21.884 14.11a2.166 2.166 0 112.898-3.22l21.667 19.5c.457.41.718.996.717 1.61z"
	  })));
	}

	var _path$F;

	function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

	function SvgChevronUp(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$G({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M53.032 42.199a2.166 2.166 0 01-3.064 0L32 24.23 14.032 42.198a2.167 2.167 0 01-3.064-3.064l19.5-19.5a2.166 2.166 0 013.064 0l19.5 19.5a2.166 2.166 0 010 3.064z"
	  })));
	}

	var _path$G;

	function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

	function SvgChild1(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$H({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M60 55.64c-.18-.24-2-2.74-2-12.54v-5a7.72 7.72 0 000-7.53v-1.49A24.2 24.2 0 0045.57 7.21a23.25 23.25 0 00-24 .61 12.82 12.82 0 00-8.87 4.09c-5.42 5.77-5.33 15.34-5.26 17.2 0 .495.022.988.043 1.476.015.32.029.637.037.954a7.63 7.63 0 000 5.69v5.89c0 9.8-1.78 12.3-2 12.54a2 2 0 00-.67 1.79A2 2 0 006.14 59c.26.09 2.7.87 8.1.87a33.27 33.27 0 0012.85-2.8 20 20 0 0011.47.1 33.18 33.18 0 0012.63 2.7c5.39 0 7.83-.78 8.09-.87a2 2 0 00.66-3.4l.06.04zm-5-21.26a3.77 3.77 0 01-1 2.55 3.711 3.711 0 01-1 .8l-.22.1v-6.91c.075.02.148.047.22.08.377.206.715.477 1 .8a3.81 3.81 0 011 2.58zM22.19 11.8a8.91 8.91 0 00-6.57 2.84c-3.09 3.36-4.07 8.94-4.19 12.68.384-.181.782-.332 1.19-.45l.38-.11V25a2 2 0 011.85-2c2.55-.17 5.16-2.17 8.21-6.27a2 2 0 012.94-.3 35.83 35.83 0 0024.64 9.38H51a2 2 0 011.46.58c.084.084.158.178.22.28l.69.2c.214.058.424.128.63.21a20.18 20.18 0 00-10.38-16.29 19.34 19.34 0 00-20.24.69l-.11.07a2.32 2.32 0 01-.53.25h-.55zM11.53 32.41A3.67 3.67 0 0113 31a.559.559 0 01.17-.09v6.91l-.17-.07a3.7 3.7 0 01-1.48-1.4 3.82 3.82 0 01-.55-2 3.73 3.73 0 01.56-1.94zM9.9 55.69a38.98 38.98 0 004.34.22A26.55 26.55 0 0022 54.7a20 20 0 01-8.58-12.58l-.81-.23a7.182 7.182 0 01-1.17-.44v1.65c0 6.46-.71 10.3-1.54 12.59zM33.8 54H33c-.46 0-.91-.02-1.35-.06C23.367 53.239 17 46.312 17 38V26.68c3.27-.88 5.89-3.35 8-5.88a40.169 40.169 0 0024 9V38c.01 8.533-6.678 15.573-15.2 16zm10.02.83c2.398.72 4.886 1.09 7.39 1.1v-.02a38.898 38.898 0 004.33-.22C54.72 53.4 54 49.56 54 43.1v-1.44a5.3 5.3 0 01-.67.23l-.76.21a20 20 0 01-8.75 12.73zM29.7 37a2.05 2.05 0 01-.8.17 2 2 0 01-1.83-1.2 2.06 2.06 0 00-1.85-.8 2.1 2.1 0 00-1.86.8 2 2 0 11-3.66-1.6 5.92 5.92 0 015.52-3.2 5.84 5.84 0 015.51 3.2A2 2 0 0129.7 37zm10.12 9.57a7.8 7.8 0 01-13.64 0 2.011 2.011 0 113.49-2 3.8 3.8 0 006.65 0 2 2 0 013.5 1.94v.06zm5.08-9.4a2 2 0 001.83-2.8 5.84 5.84 0 00-5.51-3.2 5.92 5.92 0 00-5.52 3.2 2 2 0 003.66 1.6 2.1 2.1 0 011.86-.8 2.06 2.06 0 011.85.8 2 2 0 001.83 1.2z"
	  })));
	}

	var _path$H;

	function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

	function SvgChild2(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$I({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 27.78l.33.09v.02a7.82 7.82 0 010 15l-.76.21a20 20 0 01-39.14 0l-.81-.23a7.82 7.82 0 010-15l.44-.12c-2.8-5.51-2.19-11.14 1.81-15.62 5.94-6.68 17.83-9.02 26.68-5.3a13.16 13.16 0 0110.54 5.76c2.47 3.76 2.8 8.76.91 13.76v1.43zM9.956 35.375A3.81 3.81 0 0012 38.75V32a3.81 3.81 0 00-2.042 3.375zM48 39c0 8.837-7.163 16-16 16-8.836 0-16-7.163-16-16v-8.22a40.169 40.169 0 0024-9c2.08 2.53 4.7 5 8 5.88V39zm-6.07-21.3c2.47 3.35 4.65 5.29 6.74 6a10.69 10.69 0 00-.98-8.96 9.15 9.15 0 00-7.64-4h-.06c-.131 0-.262-.017-.39-.05l-.36-.12c-7.38-3.25-17.44-1.39-22.38 4.17-2.15 2.44-4.03 6.49-.78 12a35.77 35.77 0 0022.91-9.34 2 2 0 012.94.3zM52 32a3.82 3.82 0 010 6.7V32zm-33.3 3.33c-.145.29-.215.604-.212.917a2 2 0 003.873.723 2.1 2.1 0 011.86-.8 2.06 2.06 0 011.85.8 2 2 0 001.83 1.2 1.998 1.998 0 001.971-1.682c.067-.378.026-.78-.141-1.158a5.84 5.84 0 00-5.51-3.2 5.92 5.92 0 00-5.52 3.2zm20.12 12.24a7.8 7.8 0 01-13.64 0 2.011 2.011 0 013.49-2 3.8 3.8 0 006.65 0 2.001 2.001 0 013.5 1.94v.06zm6.91-12.24a5.84 5.84 0 00-5.51-3.2 5.92 5.92 0 00-4.962 2.36 5.932 5.932 0 00-.557.88 2 2 0 003.486 1.885c.075-.098.143-.204.2-.318a2.1 2.1 0 011.833-.767 2.06 2.06 0 011.85.8 2 2 0 001.83 1.2 1.998 1.998 0 001.971-1.682c.068-.378.027-.78-.14-1.158z"
	  })));
	}

	var _path$I, _path2$8;

	function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

	function SvgCloseCircle(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$J({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24zm0 4c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28z"
	  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
	    d: "M25.277 22.695a2 2 0 10-2.9 2.755l6.864 7.225-6.764 7.12a2 2 0 002.9 2.755L32 35.58l6.622 6.97a2 2 0 102.9-2.755l-6.764-7.12 6.864-7.225a2 2 0 10-2.9-2.755L32 29.771l-6.723-7.076z"
	  })));
	}

	var _path$J;

	function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

	function SvgClose(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$K({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.365 48.301a2.167 2.167 0 11-3.064 3.064L32.5 35.564 16.698 51.365a2.167 2.167 0 11-3.063-3.064L29.436 32.5 13.635 16.698a2.166 2.166 0 113.063-3.063L32.5 29.436 48.3 13.635a2.166 2.166 0 113.064 3.063L35.564 32.5 51.365 48.3z"
	  })));
	}

	var _path$K;

	function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

	function SvgCloud(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$L({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.832 30.169A10.017 10.017 0 0042 22c-.436 0-.872.029-1.304.087a14.005 14.005 0 00-26.574 4.06A12 12 0 0016 50h34a10 10 0 001.832-19.831zM50 46H16a8 8 0 110-16h2v-2a10.001 10.001 0 0119.547-2.985l.608 1.951 1.938-.65A5.988 5.988 0 0148 32v2h2a6 6 0 010 12z"
	  })));
	}

	var _path$L;

	function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

	function SvgCoffee(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$M({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M49.519 41.333a7.26 7.26 0 001.448-14.373 10.783 10.783 0 00-1.344-.142l-1.142-.001v-.002a4.152 4.152 0 00-4.148-4.148h-31.11a4.152 4.152 0 00-4.149 4.148v8.296a18.678 18.678 0 004.755 12.445H10.11A3.115 3.115 0 007 50.666v1.038A8.306 8.306 0 0015.296 60H42.26a8.306 8.306 0 008.297-8.296v-1.037a3.115 3.115 0 00-3.111-3.111h-3.718a18.712 18.712 0 003.683-6.223h2.109zm-.046-10.37c.224.008.448.029.67.062a3.112 3.112 0 01-.624 6.16h-1.162c.08-.688.122-1.38.125-2.074v-4.148h.991zM42.26 55.852H15.296a4.152 4.152 0 01-4.148-4.148h35.26a4.152 4.152 0 01-4.149 4.148zm-21.985-8.296a14.532 14.532 0 01-7.052-12.445v-8.296h31.111v8.296a14.532 14.532 0 01-7.052 12.445H20.275zm.993-35.867a2.077 2.077 0 000-2.933L20.052 7.54a2.074 2.074 0 112.933-2.933L24.2 5.823a6.227 6.227 0 010 8.798l-.357.357a2.074 2.074 0 00-.327 2.508 2.075 2.075 0 01-3.585 2.089 6.227 6.227 0 01.98-7.53l.356-.357zm10.371 0a2.076 2.076 0 000-2.933L30.423 7.54a2.074 2.074 0 112.933-2.933l1.215 1.216a6.227 6.227 0 010 8.798l-.356.357a2.074 2.074 0 00-.329 2.507 2.074 2.074 0 11-3.585 2.087 6.225 6.225 0 01.98-7.527l.357-.357z"
	  })));
	}

	var _path$M;

	function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

	function SvgConnectedBuilding(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$N({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46.34 25.745a4.15 4.15 0 00-5.866 0l-7.437 7.437V15.375a4.152 4.152 0 00-4.148-4.148H8.149A4.152 4.152 0 004 15.375v39.407a4.152 4.152 0 004.148 4.148h45.63a4.152 4.152 0 004.148-4.148V39.048a4.12 4.12 0 00-1.215-2.933l-10.37-10.37zM20.593 54.782h-4.149v-4.148h4.149v4.148zm8.296 0H24.74V48.56a2.074 2.074 0 00-2.074-2.074H14.37a2.074 2.074 0 00-2.074 2.074v6.222H8.148V15.375l20.74-.003v39.41zm24.889 0H33.037V39.048l10.37-10.37 10.37 10.37v15.734zM24.74 40.264a2.074 2.074 0 01-2.074 2.074H14.37a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.928 2.074 2.074zm0-8.297a2.074 2.074 0 01-2.074 2.074H14.37a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.929 2.074 2.074zm0-8.296a2.074 2.074 0 01-2.074 2.074H14.37a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.928 2.074 2.074zM39.259 38.19h8.297a2.074 2.074 0 110 4.148h-8.297a2.074 2.074 0 110-4.148zm10.37 10.37a2.074 2.074 0 01-2.073 2.074h-8.297a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.928 2.074 2.074zm8.888-29.123a2.07 2.07 0 01-2.58-1.397c-1.97-6.582-8.897-10.328-15.484-8.372a2.074 2.074 0 11-1.185-3.976c8.784-2.609 18.021 2.387 20.646 11.165a2.074 2.074 0 01-1.397 2.58zm-18.784-3.014a2.074 2.074 0 011.261-2.649 8.302 8.302 0 0110.591 5.058 2.074 2.074 0 11-3.911 1.381 4.154 4.154 0 00-5.292-2.53 2.074 2.074 0 01-2.649-1.26z"
	  })));
	}

	var _path$N;

	function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

	function SvgConnected(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$O({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8 32C8 18.745 18.745 8 32 8s24 10.745 24 24c0 12.581-9.68 22.902-22 23.918V47h1.948a6.277 6.277 0 004.165-1.58A5.609 5.609 0 0042 41.222V31a2 2 0 100-4h-4v-6a2 2 0 10-4 0v6h-5v-6a2 2 0 10-4 0v6h-4a2 2 0 100 4v10.086A5.914 5.914 0 0026.914 47H30v11a2 2 0 002 2c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32c0 10.805 6.121 20.178 15.076 24.845a2 2 0 001.848-3.547C13.24 49.292 8 41.257 8 32zm17-1v10.086A1.914 1.914 0 0026.914 43h9.034c.557 0 1.094-.204 1.51-.573.345-.306.542-.744.542-1.204V31H25z"
	  })));
	}

	var _path$O;

	function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

	function SvgConversation(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$P({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52.223 44.09a8.296 8.296 0 10-15.631 0 10.403 10.403 0 00-4.629 3.492 10.403 10.403 0 00-4.629-3.492 8.296 8.296 0 10-15.631 0A10.378 10.378 0 005 53.778 6.229 6.229 0 0011.222 60h16.593a6.19 6.19 0 004.148-1.598A6.19 6.19 0 0036.111 60h16.593a6.229 6.229 0 006.222-6.222 10.378 10.378 0 00-6.703-9.688zm-7.816-6.905a4.148 4.148 0 110 8.297 4.148 4.148 0 010-8.297zm-24.888 0a4.148 4.148 0 110 8.297 4.148 4.148 0 010-8.297zm8.296 18.667H11.222a2.076 2.076 0 01-2.074-2.074 6.23 6.23 0 015.03-6.105 8.265 8.265 0 0010.68 0 6.23 6.23 0 015.03 6.105 2.076 2.076 0 01-2.073 2.074zm24.889 0H36.11a2.076 2.076 0 01-2.074-2.074 6.23 6.23 0 015.03-6.105 8.265 8.265 0 0010.68 0 6.23 6.23 0 015.03 6.105 2.076 2.076 0 01-2.073 2.074zm0-47.704H37.822A6.227 6.227 0 0031.963 4h-20.74A6.229 6.229 0 005 10.222v8.296a6.23 6.23 0 006.222 6.223h5.363l5.92 5.918a3.11 3.11 0 005.31-2.2v-3.718h8.296v3.718a3.11 3.11 0 005.31 2.2l5.92-5.918h5.363a6.23 6.23 0 006.222-6.223V14.37a6.229 6.229 0 00-6.222-6.222zM23.667 20.593v5.363l-5.363-5.363h-7.082a2.076 2.076 0 01-2.074-2.075v-8.296a2.076 2.076 0 012.074-2.074h20.741c.553 0 1.082.221 1.47.614a6.224 6.224 0 00-3.544 5.608v4.149c.001.707.124 1.408.363 2.074h-6.585zm31.11-2.075a2.076 2.076 0 01-2.073 2.075h-7.082l-5.363 5.363v-5.363h-4.148a2.076 2.076 0 01-2.074-2.075V14.37a2.076 2.076 0 012.074-2.074h16.593a2.077 2.077 0 012.074 2.074v4.149z"
	  })));
	}

	var _path$P, _path2$9;

	function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

	function SvgCopy(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$Q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
	    d: "M49.333 58H25.5c-.575 0-1.126-.21-1.532-.586A1.925 1.925 0 0123.333 56V26c0-2.122.913-4.157 2.539-5.657C27.497 18.843 29.702 18 32 18h23.833c.575 0 1.126.21 1.532.586.407.375.635.884.635 1.414v30c0 2.122-.913 4.157-2.538 5.657-1.626 1.5-3.83 2.343-6.129 2.343zm-21.666-4h21.666c1.15 0 2.252-.421 3.064-1.172.813-.75 1.27-1.767 1.27-2.828V22H32c-1.15 0-2.252.421-3.064 1.172-.813.75-1.27 1.767-1.27 2.828v28z"
	  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
	    d: "M16.833 48H8.167c-.575 0-1.126-.21-1.532-.586A1.925 1.925 0 016 46V14c0-2.122.913-4.157 2.538-5.657C10.164 6.843 12.368 6 14.667 6H38.5c.575 0 1.126.21 1.532.586.407.375.635.884.635 1.414v4c0 .53-.228 1.04-.635 1.414A2.261 2.261 0 0138.5 14c-.574 0-1.126-.21-1.532-.586A1.925 1.925 0 0136.333 12v-2H14.668c-1.15 0-2.252.421-3.064 1.172-.813.75-1.27 1.767-1.27 2.828v30h6.5c.575 0 1.126.21 1.533.586.406.375.634.884.634 1.414 0 .53-.228 1.04-.634 1.414a2.262 2.262 0 01-1.533.586z"
	  })));
	}

	var _path$Q, _path2$a;

	function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

	function SvgCoreRouter(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$R({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
	    d: "M38.642 18.243l-7.07-7.071-7.072 7.07a2 2 0 002.828 2.83l2.465-2.465V26a2 2 0 004 0v-6.95l2.02 2.021a2 2 0 102.83-2.828zM43.242 24.586l-7.07 7.07 7.07 7.072a2 2 0 002.829-2.829l-2.464-2.464H51a2 2 0 100-4h-6.95l2.02-2.021a2 2 0 00-2.828-2.828zM38.642 45.757l-7.07 7.071-7.072-7.07a2 2 0 012.828-2.83l2.465 2.465V38a2 2 0 014 0v6.95l2.02-2.021a2 2 0 112.83 2.828zM20.758 24.586l7.07 7.07-7.07 7.072a2 2 0 01-2.829-2.829l2.464-2.464H13a2 2 0 110-4h6.95l-2.02-2.021a2 2 0 012.828-2.828z"
	  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zM4 32C4 16.536 16.536 4 32 4s28 12.536 28 28-12.536 28-28 28S4 47.464 4 32z"
	  })));
	}

	var _path$R, _path2$b;

	function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

	function SvgCreditCard(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$S({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M12 13a8 8 0 00-8 8v22a8 8 0 008 8h40a8 8 0 008-8V21a8 8 0 00-8-8H12zm-4 8a4 4 0 014-4h40a4 4 0 014 4v2H8v-2zm0 6v16a4 4 0 004 4h40a4 4 0 004-4V27H8z"
	  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M12 34a2 2 0 012-2h18a2 2 0 110 4H14a2 2 0 01-2-2z"
	  })));
	}

	var _path$S;

	function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

	function SvgCustomerDialogue(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$T({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 16a2 2 0 01-2 2H36a2 2 0 110-4h14a2 2 0 012 2zm-8 4h-8a2 2 0 100 4h8a2 2 0 100-4zm16-6v10a8.01 8.01 0 01-8 8h-1.172l-5.707 5.707A3 3 0 0140 35.586V32h-4a11.924 11.924 0 01-1.984 6.594A14.02 14.02 0 0144 52a6.007 6.007 0 01-6 6H10a6.007 6.007 0 01-6-6 14.02 14.02 0 019.985-13.406A11.956 11.956 0 0126 20.18V14a8.01 8.01 0 018-8h18a8.01 8.01 0 018 8zM16 32a8 8 0 108-8 8.01 8.01 0 00-8 8zm14.572 10.029a11.94 11.94 0 01-13.143 0A10.004 10.004 0 008 51.999a2.003 2.003 0 002 2h28a2.003 2.003 0 002-2 10.004 10.004 0 00-9.428-9.97zM56 14a4.004 4.004 0 00-4-4H34a4.004 4.004 0 00-4 4v7.623A12.046 12.046 0 0135.3 28H44v5.172L49.172 28H52a4.004 4.004 0 004-4V14z"
	  })));
	}

	var _path$T, _path2$c, _path3$2;

	function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

	function SvgDaasDevice(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$U({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
	    d: "M33 52a2 2 0 11-4 0 2 2 0 014 0z"
	  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M23 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V37a2 2 0 10-4 0v7H19V12a4 4 0 014-4h16a4 4 0 014 4v3.5a2 2 0 104 0V12a8 8 0 00-8-8H23zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H19z"
	  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M48.367 20.572a2 2 0 01.173 2.823L36.279 37.258a2 2 0 01-2.936.065l-6.641-6.866a2 2 0 112.875-2.78l5.138 5.311 10.828-12.243a2 2 0 012.824-.173z"
	  })));
	}

	var _path$U, _path2$d;

	function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

	function SvgDataTransfer(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$V({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
	    d: "M13.373 10a1.994 1.994 0 00-1.518.68l-7.27 7.27a2 2 0 102.83 2.828l4.307-4.308V34a2 2 0 104 0V17.193l3.586 3.585a2 2 0 002.828-2.828l-7.27-7.27a1.994 1.994 0 00-1.493-.68zM28.722 29.53l-4.308-4.308a2 2 0 10-2.828 2.828l7.269 7.27a1.994 1.994 0 001.518.68 1.993 1.993 0 001.493-.68l7.27-7.27a2 2 0 10-2.828-2.828l-3.586 3.585V12a2 2 0 00-4 0v17.53zM45.74 47a2 2 0 104 0 2 2 0 00-4 0z"
	  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56 11a4 4 0 014 4v36a4 4 0 01-4 4H40a4 4 0 01-4-4V35.692a2 2 0 114 0v3.616h15.461c.187 0 .368.025.539.073V15H40v4.23a2 2 0 01-4 0V15a4 4 0 014-4h16zm0 32.234a2.002 2.002 0 01-.539.074H40V51h16v-7.766z"
	  })));
	}

	var _path$V;

	function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

	function SvgDelete(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$W({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52.63 22.667v29.037A8.306 8.306 0 0144.333 60H19.444a8.306 8.306 0 01-8.296-8.296V22.667a2.074 2.074 0 114.148 0v29.037a4.153 4.153 0 004.148 4.148h24.89a4.153 4.153 0 004.147-4.148V22.667a2.074 2.074 0 114.149 0zm4.148-8.297a2.074 2.074 0 01-2.074 2.074H9.074a2.074 2.074 0 110-4.148h10.37V8.148A4.153 4.153 0 0123.593 4h16.592a4.153 4.153 0 014.148 4.148v4.148h10.37c1.146 0 2.075.929 2.075 2.074zm-33.185-2.074h16.592V8.148H23.593v4.148zm4.148 35.26V26.815a2.074 2.074 0 10-4.148 0v20.74a2.074 2.074 0 004.148 0zm12.444 0V26.815a2.074 2.074 0 10-4.148 0v20.74a2.074 2.074 0 004.148 0z"
	  })));
	}

	var _path$W;

	function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

	function SvgDelivery(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$X({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M20.584 27.415l-4-4A2 2 0 0115.998 22v-6a2 2 0 014 0v5l.115.287 3.3 3.3a2 2 0 11-2.829 2.828zM60 37.817v8.184a4.004 4.004 0 01-4 4h-2.295a6.995 6.995 0 01-13.418-.029 1.967 1.967 0 01-.288.03H27.704a6.995 6.995 0 01-13.418-.03 1.966 1.966 0 01-.287.03h-2.134a3.939 3.939 0 01-3.867-4V31.78A13.988 13.988 0 1129.472 14h10.527a4.004 4.004 0 014 4v4h4.93a3.991 3.991 0 013.328 1.782l6.4 9.598A7.972 7.972 0 0160 37.817zm-42.002-5.816c5.523 0 10-4.478 10-10 0-5.524-4.477-10-10-10s-10 4.476-10 10c.006 5.52 4.48 9.993 10 10zm6 16a3 3 0 10-6 0 3 3 0 006 0zm16.001-30h-8.59A13.97 13.97 0 0112 34.63V46h2c.095.003.192.013.287.03A6.995 6.995 0 0127.704 46h12.295v-28zm10 30a3 3 0 10-6 0 3 3 0 006 0zm6-10.184c.001-.79-.233-1.562-.671-2.218L48.929 26h-4.93v15.685a6.976 6.976 0 019.706 4.315h2.294v-8.184z"
	  })));
	}

	var _path$X;

	function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

	function SvgDesktop(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$Y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
	    d: "M52 12H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm4 28a4.005 4.005 0 01-4 4H12a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.005 4.005 0 014 4v20zM44 52a2 2 0 01-2 2H22a2 2 0 010-4h20a2 2 0 012 2z"
	  })));
	}

	var _path$Y;

	function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

	function SvgDevices(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$Z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M50 4H30a8.01 8.01 0 00-8 8v4h-8a8.01 8.01 0 00-8 8v28a8.01 8.01 0 008 8h10a8.007 8.007 0 007.737-6H50a8.01 8.01 0 008-8V12a8.01 8.01 0 00-8-8zM30 8h20a4.004 4.004 0 014 4v26H32V24a8.007 8.007 0 00-6-7.737V12a4.004 4.004 0 014-4zM14 20h10a4.004 4.004 0 014 4v20H10V24a4.004 4.004 0 014-4zm10 36H14a4.004 4.004 0 01-4-4v-4h18v4a4.004 4.004 0 01-4 4zm30-10a4.004 4.004 0 01-4 4H32v-8h22v4zm-16 0a2 2 0 114 0 2 2 0 01-4 0zm-17 6a2 2 0 11-4 0 2 2 0 014 0z"
	  })));
	}

	var _path$Z;

	function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

	function SvgDislike(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$_({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M9.175 41.578h8.351a4.147 4.147 0 002.942-1.228c6.027 2.112 11.372 8.068 13.287 15.002a6.288 6.288 0 005.39 4.604 6.123 6.123 0 006.167-3.253c.226-.423.428-.858.607-1.302a12.242 12.242 0 00.16-8.448l-2.637-7.462h9.575a6.27 6.27 0 006.263-6.264V31.14a6.265 6.265 0 00-2.895-5.279 6.22 6.22 0 00.807-3.072v-2.088a6.273 6.273 0 00-4.616-6.042 6.237 6.237 0 00.44-2.308v-2.088A6.27 6.27 0 0046.755 4H20.658a2.07 2.07 0 00-.522.074A2.07 2.07 0 0019.614 4H7.088A2.088 2.088 0 005 6.088v31.315a4.18 4.18 0 004.175 4.175zm39.666-31.315v2.088a2.09 2.09 0 01-2.087 2.087 2.088 2.088 0 000 4.176h4.175a2.09 2.09 0 012.088 2.087v2.088a2.09 2.09 0 01-2.088 2.088 2.088 2.088 0 000 4.175h2.088a2.09 2.09 0 012.087 2.088v2.087a2.09 2.09 0 01-2.087 2.088H40.49c-.131 0-.261.014-.39.04-.046.008-.09.023-.135.035-.057.015-.114.024-.17.044-.02.007-.035.018-.053.025-.072.03-.143.062-.211.1-.055.028-.11.055-.161.087-.058.039-.114.08-.168.125-.052.041-.105.08-.153.126s-.09.098-.134.148c-.043.051-.088.1-.126.154-.04.056-.072.117-.107.177-.031.056-.065.11-.091.169-.029.062-.049.127-.07.192-.023.064-.045.127-.06.194-.015.06-.022.122-.03.184-.012.076-.02.153-.023.23 0 .02-.006.038-.006.058 0 .044.01.086.013.13.005.149.03.297.075.44.012.041.016.083.031.125l3.608 10.21a8.04 8.04 0 01-.084 5.532 9.086 9.086 0 01-.417.895 1.992 1.992 0 01-2.024 1.07 2.097 2.097 0 01-1.825-1.564c-2.278-8.248-8.751-15.351-16.079-17.876V8.175h25.053a2.09 2.09 0 012.087 2.088zM9.175 8.176h8.351v29.171c0 .02-.006.037-.006.056H9.175V8.176z"
	  })));
	}

	var _path$_;

	function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

	function SvgDoc(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$$({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M50.828 16L40 5.172A3.973 3.973 0 0037.172 4H20a8.01 8.01 0 00-8 8v44a4.004 4.004 0 004 4h28a8.01 8.01 0 008-8V18.828A3.972 3.972 0 0050.828 16zm-5.656 0H40v-5.172L45.172 16zM44 56H16V12a4.004 4.004 0 014-4h16v8a4.004 4.004 0 004 4h8v32a4.004 4.004 0 01-4 4zm-2-20a2 2 0 01-2 2H24a2 2 0 110-4h16a2 2 0 012 2zm0-10a2 2 0 01-2 2H24a2 2 0 110-4h16a2 2 0 012 2zm0 20a2 2 0 01-2 2H24a2 2 0 110-4h16a2 2 0 012 2z"
	  })));
	}

	var _path$$;

	function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

	function SvgDocumentDoc(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$10({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
	    d: "M52.223 53.549a2 2 0 10-3.846-1.099c-.426 1.491-.985 2.28-1.623 2.74-.655.474-1.68.81-3.454.81h-27v-3a2 2 0 10-4 0v3a4 4 0 004 4h27.046c2.208-.006 4.166-.423 5.75-1.567 1.612-1.164 2.553-2.875 3.127-4.884zM13.075 44c1.725 0 3.225-.375 4.55-1.1 2.625-1.45 4.2-4.25 4.2-7.925 0-1.525-.35-2.95-1.05-4.225-1.425-2.575-4.15-4.25-7.45-4.25H9.5c-1.225 0-2.5.825-2.5 1.625V42c0 .475.85 2 1.725 2h4.35zm-2.6-14.1H13.5c2.825 0 4.75 2.075 4.75 5.175 0 3.475-1.85 5.525-4.975 5.525h-2.8V29.9zM32.433 44.375c1.55 0 3-.4 4.375-1.175 2.7-1.575 4.575-4.55 4.575-7.95a8.948 8.948 0 00-1.15-4.45c-1.525-2.775-4.475-4.675-7.8-4.675-1.55 0-3 .4-4.35 1.175-2.725 1.575-4.6 4.55-4.6 7.95 0 1.575.375 3.075 1.15 4.45 1.525 2.775 4.475 4.675 7.8 4.675zm0-3.55c-.925 0-1.8-.25-2.6-.725a5.6 5.6 0 01-2.75-4.85c0-.975.225-1.875.7-2.725.9-1.7 2.65-2.85 4.65-2.85.925 0 1.8.225 2.625.7 1.6.95 2.725 2.775 2.725 4.875 0 .975-.225 1.875-.675 2.725-.925 1.7-2.675 2.85-4.675 2.85zM56.44 42.85c.574-.5.974-1.425.974-2.3 0-.575-.3-.875-.9-.875-.35 0-.8.125-1.375.375-1.075.475-2.15.725-3.25.725-.95 0-1.825-.225-2.6-.7-1.575-.9-2.6-2.675-2.6-4.8 0-1.025.225-1.95.675-2.8.875-1.675 2.6-2.75 4.7-2.75.95 0 1.925.25 2.95.775.225.125.425.175.6.175.775 0 1.575-1.275 1.575-2.5 0-.35-.125-.6-.375-.75-1.375-.875-2.95-1.3-4.675-1.3-1.575 0-3.075.4-4.45 1.2a9.329 9.329 0 00-4.65 8.1c0 1.575.375 3.05 1.1 4.4 1.45 2.725 4.225 4.55 7.5 4.55 1.775 0 3.725-.625 4.8-1.525zM51.714 16.586L40.3 5.172A3.974 3.974 0 0037.472 4H20.3a8.009 8.009 0 00-8 8v6a2 2 0 104 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2 2 0 001.414-3.414zM40.3 10.828L45.472 16H40.3v-5.172z"
	  })));
	}

	var _path$10, _path2$e, _path3$3;

	function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

	function SvgDocumentEdit(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$11({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M48.116 27.037a4 4 0 015.657.007l4.235 4.245A4 4 0 0158 36.946L45.685 49.23a4 4 0 01-2.044 1.092l-5.303 1.054c-2.8.557-5.265-1.915-4.702-4.713l1.068-5.3a4 4 0 011.097-2.042l12.315-12.284zm7.06 7.077L50.94 29.87 38.625 42.153l-1.067 5.3 5.302-1.055 12.316-12.284z"
	  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8 12a8 8 0 018-8h28a4 4 0 014 4v15a2 2 0 11-4 0V8H16a4 4 0 00-4 4v44h27.801a4 4 0 003.406-1.903l.09-.146a2 2 0 113.406 2.098l-.09.146A8 8 0 0139.801 60H12a4 4 0 01-4-4V12z"
	  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M16 20a2 2 0 012-2h20a2 2 0 110 4H18a2 2 0 01-2-2zM16 28a2 2 0 012-2h20a2 2 0 110 4H18a2 2 0 01-2-2zM16 36a2 2 0 012-2h12a2 2 0 110 4H18a2 2 0 01-2-2z"
	  })));
	}

	var _path$11;

	function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

	function SvgDocumentPdf(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$12({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
	    d: "M12.387 39.02v3.864a3.784 3.784 0 01-.616 2.1 1.692 1.692 0 01-1.344.953c-.486 0-.971-.364-1.456-1.092a2.664 2.664 0 01-.477-1.145V27.988a1.574 1.574 0 01.883-1.246 3.452 3.452 0 011.918-.574h4.592a6.73 6.73 0 013.416.854 5.911 5.911 0 012.282 2.31 6.714 6.714 0 01.8 3.276 5.61 5.61 0 01-.6 2.548 6.916 6.916 0 01-1.567 2.072 7.156 7.156 0 01-2.114 1.33 6.25 6.25 0 01-2.353.462h-3.364zm3.387-3.64a2.764 2.764 0 002.017-.8 2.658 2.658 0 00.812-1.974 2.699 2.699 0 00-.8-2.016 2.781 2.781 0 00-2.03-.784h-3.386v5.574h3.387zm10.92 10.388c-.485 0-.97-.364-1.456-1.092a2.5 2.5 0 01-.476-1.149V27.988a1.575 1.575 0 01.883-1.246 3.448 3.448 0 011.918-.574h4.283c1.74-.03 3.455.42 4.957 1.3a9.094 9.094 0 013.374 3.458 9.632 9.632 0 011.19 4.732 11.092 11.092 0 01-1.247 5.376 8.59 8.59 0 01-3.458 3.514 10.391 10.391 0 01-5.1 1.218l-4.868.002zm5.1-3.808a5.231 5.231 0 004.1-1.638 6.576 6.576 0 001.47-4.551 5.958 5.958 0 00-1.47-4.2 4.992 4.992 0 00-3.85-1.6h-3.39V41.96h3.14zm16.292-4.145v5.069a3.777 3.777 0 01-.616 2.1 1.69 1.69 0 01-1.344.953c-.484 0-.97-.364-1.456-1.092a2.507 2.507 0 01-.476-1.148V27.988a1.573 1.573 0 01.882-1.246 3.456 3.456 0 011.918-.574h9.044c.692 0 1.037.327 1.036.98 0 .499-.1.993-.294 1.452-.16.413-.408.786-.728 1.092-.225.234-.53.374-.854.392h-7.112v4.088h6.188c.654 0 .98.308.98.924a3.367 3.367 0 01-.546 1.876 1.51 1.51 0 01-1.218.839l-5.404.004zM44 60H16a4 4 0 01-4-4v-3a2 2 0 014 0v3h28a3.981 3.981 0 003.937-3.332 1.999 1.999 0 012.305-1.641 2 2 0 011.641 2.305A7.973 7.973 0 0144 60zm7.414-43.414L40 5.172A3.972 3.972 0 0037.172 4H20a8.009 8.009 0 00-8 8v6a2 2 0 004 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2 2 0 001.414-3.414zM40 10.828L45.172 16H40v-5.172z"
	  })));
	}

	var _path$12;

	function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

	function SvgDocumentPpt(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$13({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
	    d: "M51.923 53.55a2 2 0 10-3.846-1.099c-.426 1.491-.985 2.28-1.623 2.74-.65.47-1.665.804-3.412.81L43 56H16v-3a2 2 0 10-4 0v3a4 4 0 004 4h27c2.227 0 4.2-.414 5.796-1.566 1.611-1.164 2.553-2.875 3.127-4.884zM16.483 39.011c1.653 0 3.306-.667 4.64-1.856 1.334-1.189 2.233-2.929 2.233-4.785 0-1.247-.261-2.378-.812-3.393-1.102-2-3.248-3.277-5.916-3.277h-4.756c-1.421 0-2.9.957-2.9 1.885v16.27c0 .492.986 2.32 2 2.32 1.016 0 2.03-1.567 2.03-3.162v-4.002h3.48zm-3.48-9.54h3.509c1.71 0 2.929 1.188 2.929 2.9 0 1.623-1.276 2.87-2.93 2.87h-3.508v-5.77zM33.333 39.011c1.653 0 3.306-.667 4.64-1.856 1.334-1.189 2.233-2.929 2.233-4.785 0-1.247-.26-2.378-.812-3.393-1.102-2-3.248-3.277-5.916-3.277h-4.756c-1.42 0-2.9.957-2.9 1.885v16.27c0 .492.986 2.32 2.001 2.32s2.03-1.567 2.03-3.162v-4.002h3.48zm-3.48-9.54h3.51c1.71 0 2.928 1.188 2.928 2.9 0 1.623-1.276 2.87-2.929 2.87h-3.509v-5.77zM47.023 43.854c0 .551.986 2.32 2 2.32 1.016 0 2.03-1.566 2.03-3.16V29.904h3.858c1.015 0 2.03-1.566 2.03-3.16 0-.697-.377-1.045-1.131-1.045H43.949c-1.421 0-2.9.957-2.9 1.885 0 .551.986 2.32 2 2.32h3.974v13.95zM51.414 16.586L40 5.172A3.974 3.974 0 0037.172 4H20a8.009 8.009 0 00-8 8v6a2 2 0 104 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2 2 0 001.414-3.414zM40 10.828L45.172 16H40v-5.172z"
	  })));
	}

	var _circle;

	function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

	function SvgDot(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$14({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
	    cx: 32,
	    cy: 32,
	    r: 28
	  })));
	}

	var _path$13;

	function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

	function SvgDownload(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$15({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M60 29.692v19.385a8.625 8.625 0 01-8.615 8.615h-38.77A8.625 8.625 0 014 49.077V29.692a2.154 2.154 0 014.308 0v19.385a4.313 4.313 0 004.307 4.308h38.77a4.313 4.313 0 004.307-4.308V29.692a2.154 2.154 0 014.308 0zM29.716 43.377a3.233 3.233 0 004.568 0l12.162-12.162A2.154 2.154 0 0043.4 28.17l-9.246 9.247V8.154a2.154 2.154 0 10-4.308 0v29.262L20.6 28.17a2.154 2.154 0 10-3.046 3.045l12.162 12.162z"
	  })));
	}

	var _path$14;

	function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

	function SvgDslHub(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$16({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
	    d: "M48 8H16a8.01 8.01 0 00-8 8v32a8.01 8.01 0 008 8h32a8.01 8.01 0 008-8V16a8.01 8.01 0 00-8-8zm4 40a4.004 4.004 0 01-4 4H16a4.004 4.004 0 01-4-4V16a4.004 4.004 0 014-4h32a4.004 4.004 0 014 4v32zm-8-32H20a4.004 4.004 0 00-4 4v16a4.004 4.004 0 004 4h2v4a4.004 4.004 0 004 4h12a4.004 4.004 0 004-4v-4h2a4.004 4.004 0 004-4V20a4.004 4.004 0 00-4-4zm0 20h-2a4.004 4.004 0 00-4 4v4H26v-4a4.004 4.004 0 00-4-4h-2V20h6v4a2 2 0 004 0v-4h4v4a2 2 0 004 0v-4h6v16z"
	  })));
	}

	var _path$15;

	function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

	function SvgEdit(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$17({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.12 12.88c-4.3-4.29-8.58-5.56-10.92-3.22L12.07 37.8l-.16.15a2.258 2.258 0 00-.28.35c-1.54 2.22-2.55 9.29-3.12 15a2 2 0 002 2.2h.2c5.71-.57 12.78-1.58 15-3.12.126-.082.243-.176.35-.28l28.28-28.29c2.34-2.35 1.07-6.63-3.22-10.93zM12.76 51.24a71.593 71.593 0 011.69-9.62 35.94 35.94 0 017.93 7.93 71.593 71.593 0 01-9.62 1.69zM51.51 21l-26 26a32.818 32.818 0 00-3.93-4.56A32.111 32.111 0 0017 38.51l26-26c.45-.17 2.61.51 5.3 3.2 2.69 2.69 3.36 4.85 3.21 5.29z"
	  })));
	}

	var _path$16;

	function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

	function SvgEducation(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$18({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M17 4a8 8 0 00-8 8v40a8 8 0 008 8h36.5a2 2 0 100-4h-36a4 4 0 010-8h36a2 2 0 002-2V8a4 4 0 00-4-4H17zm34.5 40V8h-29v36h29zm-33-36H17a4 4 0 00-4 4v33.385A7.962 7.962 0 0117.5 44h1V8z"
	  })));
	}

	var _path$17, _path2$f, _path3$4;

	function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

	function SvgEfficiency(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$19({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M25.207 19a2 2 0 012 2v5.392l-1.413.434c-2.02.62-3.828 1.73-5.284 3.195l-1.158 1.164-1.336-.888-3.354-1.852-2.253 4.07 3.281 1.812 1.693.441-.346 1.835a12.774 12.774 0 00.09 5.176l.505 2.235-2.083.18-3.209 1.773 2.253 4.07 3.179-1.756 1.186-1.848 1.755 1.689a12.715 12.715 0 005.081 2.995l1.413.434V56h4.66v-4.45l1.413-.433a12.707 12.707 0 004.81-2.741l1.059-.962 4.259 2.353 2.253-4.07-4.109-2.27.356-1.48c.228-.953.35-1.949.35-2.976 0-.868-.087-1.715-.252-2.531l-.291-1.438 4.841-2.675a2 2 0 111.934 3.502l-2.334 1.29a16.845 16.845 0 01-.068 4.244l2.333 1.29a3.056 3.056 0 011.197 4.155l-3.167 5.72a3.059 3.059 0 01-4.155 1.194l-2.635-1.455a16.703 16.703 0 01-3.794 2.17v2.506A3.058 3.058 0 0132.808 60h-6.542a3.058 3.058 0 01-3.059-3.057v-2.507a16.711 16.711 0 01-4.037-2.358l-3.466 1.915a3.059 3.059 0 01-4.155-1.196L8.383 47.08a3.056 3.056 0 011.197-4.157l3.366-1.86a16.842 16.842 0 01-.052-3.71l-3.245-1.793a3.056 3.056 0 01-1.197-4.156l3.166-5.719a3.06 3.06 0 014.156-1.195l3.03 1.674a16.721 16.721 0 014.403-2.657V21a2 2 0 012-2z"
	  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M30 35a4 4 0 100 8 4 4 0 000-8zm-8 4a8 8 0 1116 0 8 8 0 01-16 0zM42.5 8a9.5 9.5 0 100 19 9.5 9.5 0 000-19zM29 17.5C29 10.044 35.045 4 42.5 4 49.956 4 56 10.044 56 17.5S49.956 31 42.5 31C35.045 31 29 24.956 29 17.5z"
	  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M43 10a2 2 0 012 2v6.828l-3.585 3.586a2 2 0 11-2.829-2.828L41 17.172V12a2 2 0 012-2z"
	  })));
	}

	var _path$18;

	function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

	function SvgEmail(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1a({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 12H12a8.01 8.01 0 00-8 8v24a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm0 4c.346.005.69.055 1.023.15L39.172 30H24.828l-13.85-13.85A3.95 3.95 0 0112 16h40zm4 28a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V20a3.95 3.95 0 01.15-1.023L22 32.828A3.973 3.973 0 0024.828 34h14.344A3.973 3.973 0 0042 32.828l13.85-13.85c.095.332.145.676.15 1.022v24z"
	  })));
	}

	var _path$19;

	function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

	function SvgEndUser(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1b({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M45.613 30.407a16 16 0 10-27.226 0A18.03 18.03 0 004 48.043v2a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8v-2a18.03 18.03 0 00-14.387-17.636zM32 10.043c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12s-12-5.373-12-12c.007-6.625 5.376-11.993 12-12zm24 40a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4v-2c.012-7.523 5.964-13.692 13.481-13.974a15.908 15.908 0 0021.038 0c7.517.282 13.47 6.451 13.481 13.974v2z"
	  })));
	}

	var _path$1a;

	function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

	function SvgEntertainment(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1c({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
	    d: "M45.133 32.59l-14 3.11A3.975 3.975 0 0028 39.606v7.343A8.823 8.823 0 0024 46c-4.411 0-8 3.14-8 7 0 3.859 3.589 7 8 7s8-3.141 8-7a6.155 6.155 0 00-.037-.636c.024-.12.036-.242.037-.364V39.605l14-3.111v8.454A8.823 8.823 0 0042 44c-4.411 0-8 3.14-8 7 0 3.859 3.589 7 8 7s8-3.141 8-7a6.155 6.155 0 00-.037-.636c.024-.12.036-.242.037-.364V36.494a4 4 0 00-4.867-3.905zM24 56c-2.168 0-4-1.373-4-3 0-1.626 1.832-3 4-3s4 1.374 4 3c0 1.627-1.832 3-4 3zm18-2c-2.168 0-4-1.373-4-3 0-1.626 1.832-3 4-3s4 1.374 4 3c0 1.627-1.832 3-4 3zm14-30H26.198l28.234-5.646a4 4 0 003.136-4.707l-1.137-5.691a4 4 0 00-4.707-3.139L7.216 13.718A4.009 4.009 0 004 17.64V50a4.004 4.004 0 004 4h4a2 2 0 000-4H8V28h48v22h-2a2 2 0 000 4h2a4.004 4.004 0 004-4V28a4.004 4.004 0 00-4-4zM45.94 10.486a1.99 1.99 0 00.056-.445l6.512-1.302 1.139 5.693-9.15 1.83 1.443-5.776zm-12 2c.003-.012.003-.023.005-.035l7.769-1.553-1.558 6.232-7.765 1.553 1.55-6.197zm-17.88 9.03a1.987 1.987 0 00-.056.444L8 23.561v-5.92l9.503-1.901-1.443 5.775zm5.784-6.645l7.765-1.553-1.55 6.197c-.002.012-.002.024-.005.035l-7.768 1.554 1.558-6.233z"
	  })));
	}

	var _path$1b;

	function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

	function SvgEnvironment(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1d({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
	    d: "M51.999 8h-20a24.093 24.093 0 00-17.491 7.566 23.982 23.982 0 00-.703 32.075A17.256 17.256 0 009.999 58a2 2 0 004 0 13.06 13.06 0 012.67-7.533A23.864 23.864 0 0032.019 56a23.771 23.771 0 0016.413-6.509A24.094 24.094 0 0056 32V12a4.004 4.004 0 00-4-4zm0 24a19.998 19.998 0 01-32.656 15.484L22.827 44h13.172a2 2 0 000-4h-9.172l6-6h9.172a2 2 0 000-4h-5.172l6.586-6.586a2 2 0 10-2.828-2.828l-6.586 6.586V22a2 2 0 00-4 0v9.172l-6 6V28a2 2 0 00-4 0v13.172l-3.484 3.484A19.997 19.997 0 0131.999 12h20v20z"
	  })));
	}

	var _path$1c;

	function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

	function SvgErrorFilled(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1e({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.262 43.884L38.858 11.547a7.998 7.998 0 00-13.718-.001L5.736 43.884A8 8 0 0012.596 56h38.806a8 8 0 006.86-12.116zm-28.263-6.907v-11.82a4 4 0 01.316-1.564 3.23 3.23 0 01.782-1.172c.242-.25.57-.4.917-.421.502 0 1.003.38 1.504 1.142.272.335.44.743.481 1.173v11.82c0 .44-.306.862-.918 1.263-.582.392-1.267.6-1.968.601-.742 0-1.113-.34-1.114-1.022zm4.242 6.947a2.825 2.825 0 00-.572-1.354c-.561-.823-1.103-1.234-1.625-1.234a1.587 1.587 0 00-1.068.482 3.63 3.63 0 00-.872 1.309 4.446 4.446 0 00-.347 1.73c0 .762.422 1.143 1.264 1.143.781 0 1.545-.23 2.196-.662.683-.442 1.024-.914 1.024-1.414z"
	  })));
	}

	var _path$1d;

	function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

	function SvgError(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1f({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M38.858 11.547l19.404 32.337A8 8 0 0151.402 56H12.596a8 8 0 01-6.86-12.116L25.14 11.546a7.998 7.998 0 0113.718 0zM51.403 52a3.955 3.955 0 003.48-2.03c.72-1.25.701-2.795-.05-4.028L35.43 13.605a3.999 3.999 0 00-6.86-.002L9.166 45.944A4 4 0 0012.596 52h38.806zM30 36.977v-11.82a4 4 0 01.316-1.564 3.23 3.23 0 01.782-1.172c.242-.25.57-.4.917-.421.502 0 1.003.38 1.504 1.142.272.335.44.743.481 1.173v11.82c0 .44-.306.862-.918 1.263-.582.392-1.267.6-1.968.601-.742 0-1.113-.34-1.114-1.022zm4.242 6.947a2.825 2.825 0 00-.572-1.354c-.561-.823-1.103-1.234-1.625-1.234a1.587 1.587 0 00-1.068.482 3.63 3.63 0 00-.872 1.309 4.446 4.446 0 00-.347 1.73c0 .762.422 1.143 1.264 1.143.781 0 1.545-.23 2.196-.662.683-.442 1.024-.914 1.024-1.414z"
	  })));
	}

	var _path$1e;

	function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

	function SvgEsimSimcard(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1g({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
	    d: "M46 6H18a8.01 8.01 0 00-8 8v36a8.01 8.01 0 008 8h28a8.01 8.01 0 008-8V14a8.01 8.01 0 00-8-8zm4 44a4.005 4.005 0 01-4 4h-4v-2a2 2 0 00-4 0v2h-4v-2a2 2 0 00-4 0v2h-4v-2a2 2 0 00-4 0v2h-4a4.005 4.005 0 01-4-4V14a4.005 4.005 0 014-4h4v2a2 2 0 004 0v-2h4v2a2 2 0 004 0v-2h4v2a2 2 0 004 0v-2h4a4.005 4.005 0 014 4v36zm-8-32H28.028a3.972 3.972 0 00-2.828 1.172L19.172 25.2A3.972 3.972 0 0018 28.028V42a4.005 4.005 0 004 4h20a4.005 4.005 0 004-4V22a4.005 4.005 0 00-4-4zm0 24H22V28.028L28.028 22H42v20z"
	  })));
	}

	var _path$1f;

	function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

	function SvgEuro(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1h({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M28.207 39.889c2.206 5.013 5.909 7.518 11.104 7.518 1.516 0 3.631-.402 6.345-1.207 1.655-.493 2.873-.74 3.655-.74 1.609 0 2.413.716 2.413 2.148a8.018 8.018 0 01-.862 3.66c-.575 1.14-1.344 2.002-2.31 2.584-1.103.625-2.552 1.14-4.345 1.542A25.317 25.317 0 0138.62 56c-5.102 0-9.482-1.421-13.138-4.263-3.655-2.842-6.218-6.791-7.689-11.848h-2.689c-.322 0-.655-.121-1-.368-.346-.246-.793-.683-1.346-1.309-.505-.627-.758-1.254-.758-1.879 0-.673.482-1.31 1.449-1.914.964-.604 1.975-.906 3.033-.906h.414c-.045-.269-.07-.917-.07-1.947 0-1.164.025-1.901.07-2.215h-.827c-.322 0-.656-.123-1-.37-.345-.244-.793-.681-1.345-1.308-.506-.625-.76-1.252-.76-1.88 0-.67.485-1.308 1.45-1.912.966-.605 1.977-.906 3.035-.906h.964c1.794-4.923 4.61-8.816 8.45-11.68C30.702 8.433 35.01 7 39.792 7c4.047 0 7.77 1.051 11.171 3.153.692.448 1.036 1.052 1.036 1.813a7.286 7.286 0 01-.656 3.054c-.435.962-.964 1.724-1.586 2.282-.62.56-1.251.839-1.896.839-.369 0-.804-.134-1.31-.402-2.574-1.432-4.92-2.148-7.034-2.148-4.92 0-8.622 2.461-11.105 7.384h16.691c1.15 0 1.723.515 1.723 1.544 0 1.164-.334 2.258-1 3.288-.667 1.03-1.367 1.544-2.103 1.544H26.551c-.044.314-.069 1.051-.069 2.215 0 1.03.025 1.678.07 1.947h16.137c1.151 0 1.724.514 1.724 1.544 0 1.163-.333 2.26-1 3.29-.666 1.03-1.366 1.542-2.102 1.542H28.207z"
	  })));
	}

	var _path$1g;

	function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

	function SvgExcel(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1i({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
	    d: "M16.8 38.376l-4.508 6.5c-.503.71-1.008 1.064-1.511 1.064-.505 0-1.038-.4-1.6-1.2a2.613 2.613 0 01-.534-1.288 1.15 1.15 0 01.252-.7l5.574-7.42-4.788-6.252a2.489 2.489 0 01-.585-1.316c0-.429.29-.829.867-1.2a3.448 3.448 0 011.9-.56 1.155 1.155 0 01.981.448l4.312 5.908 3.416-5.012a3.034 3.034 0 011.218-.952A3.858 3.858 0 0123.46 26c.8 0 1.2.364 1.2 1.092a4.533 4.533 0 01-.979 2.744l-4.172 5.6 5.209 6.748c.162.208.25.464.252.728.008.74-.2 1.465-.6 2.088a1.66 1.66 0 01-1.33.938 1.492 1.492 0 01-1.175-.7L16.8 38.376zm12.652 7.392c-.485 0-.97-.364-1.456-1.092a2.499 2.499 0 01-.476-1.149V27.82a1.57 1.57 0 01.883-1.246A3.452 3.452 0 0130.32 26c.727 0 1.091.336 1.091 1.008v14.84h7.28c.692 0 1.038.327 1.038.98 0 .5-.1.995-.294 1.456-.161.413-.41.785-.73 1.092-.225.233-.529.373-.853.392h-8.4zM55.13 40.28a5.213 5.213 0 01-.953 3.066 6.3 6.3 0 01-2.534 2.1 8.064 8.064 0 01-3.457.742 8.668 8.668 0 01-2.843-.49 9.508 9.508 0 01-2.505-1.288 5.781 5.781 0 01-1.652-1.778 1.905 1.905 0 01-.337-.9 1.42 1.42 0 01.8-1.133 3.154 3.154 0 011.75-.518 1.044 1.044 0 01.813.308 6.449 6.449 0 001.89 1.526 4.66 4.66 0 002.087.462 3.849 3.849 0 002.2-.561 1.739 1.739 0 00.826-1.511 2.042 2.042 0 00-.84-1.652 11.802 11.802 0 00-3.053-1.484 12.17 12.17 0 01-4.423-2.492 4.918 4.918 0 01-.365-6.258 6.3 6.3 0 012.493-1.974 8.025 8.025 0 013.36-.7c.935 0 1.864.142 2.758.42.872.264 1.698.66 2.45 1.176a.918.918 0 01.42.812 3.33 3.33 0 01-.532 1.834 1.47 1.47 0 01-1.176.826 1.451 1.451 0 01-.7-.252 6.738 6.738 0 00-3.36-1.092 3.706 3.706 0 00-1.974.476 1.415 1.415 0 00-.77 1.232c-.012.34.097.672.307.938.34.347.744.623 1.19.812.588.29 1.573.696 2.954 1.217a9.365 9.365 0 013.934 2.479 5.453 5.453 0 011.242 3.657zM44 60H16a4 4 0 01-4-4v-3a2 2 0 014 0v3h28a3.98 3.98 0 003.937-3.332 2 2 0 113.945.664A7.973 7.973 0 0144 60zm7.413-43.414L40.001 5.172A3.974 3.974 0 0037.172 4H20a8.01 8.01 0 00-8 8v6a2 2 0 104 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2 2 0 001.414-3.414zm-11.413-5.758L45.172 16H40v-5.172z"
	  })));
	}

	var _path$1h, _path2$g;

	function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

	function SvgExternal(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1j({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
	    d: "M59.914 23.848V7.909A3.93 3.93 0 0055.994 4H40.055a2.154 2.154 0 000 4.308h12.407L29.846 30.923a2.154 2.154 0 000 3.048c.393.39.922.614 1.476.624a2.154 2.154 0 001.529-.624l22.755-22.766v12.643a2.154 2.154 0 004.308 0z"
	  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
	    d: "M12.217 60H47.4a8.228 8.228 0 008.217-8.174V38.462a2.154 2.154 0 00-4.308 0v13.321a3.92 3.92 0 01-3.909 3.91H12.217a3.92 3.92 0 01-3.91-3.867v-35.27a3.909 3.909 0 013.91-3.94h13.321a2.154 2.154 0 100-4.308H12.217A8.217 8.217 0 004 16.557v35.27A8.228 8.228 0 0012.217 60z"
	  })));
	}

	var _path$1i;

	function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

	function SvgFaceId(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1k({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M20 10c-5.523 0-10 4.477-10 10v2a2 2 0 11-4 0v-2c0-7.732 6.268-14 14-14h2a2 2 0 110 4h-2zm20-2a2 2 0 012-2h2c7.732 0 14 6.268 14 14v2a2 2 0 11-4 0v-2c0-5.523-4.477-10-10-10h-2a2 2 0 01-2-2zM23.519 27c-1.074 0-1.485.402-1.73.893a2 2 0 11-3.579-1.786C19.163 24.197 21 23 23.52 23c2.713 0 4.31 1.578 5.168 2.926a2 2 0 01-3.374 2.148c-.218-.343-.458-.606-.723-.782-.243-.16-.57-.292-1.071-.292zm17 0c-1.074 0-1.485.402-1.73.893a2 2 0 11-3.578-1.786c.952-1.91 2.788-3.107 5.308-3.107 2.713 0 4.31 1.578 5.168 2.926a2 2 0 01-3.374 2.148c-.218-.343-.458-.606-.723-.782-.243-.16-.57-.292-1.071-.292zM21.57 37.602a2 2 0 012.828-.032C25.95 39.087 27.912 41 32 41c3.645 0 6.095-1.957 7.602-3.43a2 2 0 112.796 2.86C40.632 42.157 37.217 45 32 45c-5.724 0-8.671-2.881-10.393-4.565l-.005-.005a2 2 0 01-.032-2.828zM8 40a2 2 0 012 2v2c0 5.523 4.477 10 10 10h2a2 2 0 110 4h-2c-7.732 0-14-6.268-14-14v-2a2 2 0 012-2zm48 0a2 2 0 012 2v2c0 7.732-6.268 14-14 14h-2a2 2 0 110-4h2c5.523 0 10-4.477 10-10v-2a2 2 0 012-2z"
	  })));
	}

	var _path$1j;

	function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

	function SvgFacebook(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1l({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M36.2 60H24.73V32H19v-9.654h5.73v-5.79C24.73 8.681 27.961 4 37.153 4h7.662v9.654H40.03c-3.578 0-3.82 1.356-3.82 3.864l-.01 4.828h8.673L43.861 32h-7.65v28h-.012z"
	  })));
	}

	var _path$1k;

	function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

	function SvgFiber(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1m({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
	    d: "M44 28h-2V12a2 2 0 00-4 0v16h-4V6a2 2 0 10-4 0v22h-4V12a2 2 0 00-4 0v16h-2a4.005 4.005 0 00-4 4v24a4.005 4.005 0 004 4h24a4.005 4.005 0 004-4V32a4.005 4.005 0 00-4-4zM20 56V32h24l.003 24H20z"
	  })));
	}

	var _path$1l;

	function _extends$1n() { _extends$1n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

	function SvgFilm(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1n({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56 28.667H26.331l30.13-6.55a2.166 2.166 0 001.663-2.542L55.958 8.74a2.166 2.166 0 00-2.605-1.687l-35.265 8.015-.129-.052-.035.089-12.238 2.781A2.167 2.167 0 004 20v32.5a4.338 4.338 0 004.333 4.333H56a4.338 4.338 0 004.333-4.333V33A4.338 4.338 0 0056 28.667zm-17.227-7.139l-7.248 1.576 2.924-7.31 7.26-1.65-2.888 7.218c-.022.055-.03.11-.047.166zm-12.359 2.687l-8.177 1.777 2.866-7.165 8.212-1.866-2.9 7.254zm27.044-5.88l-9.592 2.086 2.977-7.444 5.302-1.205 1.313 6.564zM8.333 21.73l7.636-1.735-2.844 7.109-4.792 1.041V21.73zm0 30.77V33H56l.003 19.5H8.333z"
	  })));
	}

	var _path$1m;

	function _extends$1o() { _extends$1o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

	function SvgFilter(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1o({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M57.846 41H46.793a8.603 8.603 0 00-16.663 0H6.154a2.154 2.154 0 100 4.308H30.13a8.603 8.603 0 0016.663 0h11.053a2.154 2.154 0 000-4.308zm-19.384 6.462a4.308 4.308 0 110-8.616 4.308 4.308 0 010 8.616zM6.154 23.769h11.053a8.603 8.603 0 0016.663 0h23.976a2.154 2.154 0 000-4.307H33.87a8.603 8.603 0 00-16.663 0H6.154a2.154 2.154 0 000 4.307zm19.384-6.461a4.308 4.308 0 110 8.615 4.308 4.308 0 010-8.615z"
	  })));
	}

	var _path$1n, _path2$h, _path3$5, _path4$1, _path5$1;

	function _extends$1p() { _extends$1p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

	function SvgFingerprint(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1p({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32.352 8.036c-3.668 0-7.07.893-10.02 2.438a1.973 1.973 0 01-2.677-.867 2.033 2.033 0 01.854-2.72C24.015 5.052 28.041 4 32.352 4 46.752 4 57 15.883 57 30.234c0 1.39-.08 2.832-.157 3.912a71.075 71.075 0 01-.107 1.327l-.05.523c-.115 1.108-1.094 1.912-2.185 1.794-1.092-.117-1.883-1.11-1.768-2.219m0 0v-.005l.003-.022.01-.09.032-.35c.028-.304.064-.737.101-1.25.074-1.034.146-2.367.146-3.62 0-12.398-8.73-22.198-20.673-22.198m-14.93 3.178a2.04 2.04 0 01-.124 2.85c-4.074 3.79-6.054 8.773-5.816 14.573.046 1.113-.806 2.053-1.903 2.1-1.096.046-2.022-.819-2.068-1.932-.285-6.934 2.124-13.087 7.102-17.717a1.966 1.966 0 012.808.126z"
	  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M21.673 20.52c-2.023 2.794-2.748 6.256-2.748 8.705 0 5.524-4.52 9.705-10.157 9.069-1.09-.123-1.877-1.121-1.756-2.229.122-1.107 1.104-1.906 2.195-1.783 3.307.373 5.743-1.963 5.743-5.057 0-3.1.887-7.458 3.52-11.096 2.706-3.736 7.152-6.562 13.87-6.562 5.936 0 10.084 2.275 12.954 5.772a2.04 2.04 0 01-.255 2.842 1.967 1.967 0 01-2.799-.259c-2.099-2.557-5.12-4.319-9.9-4.319-5.46 0-8.714 2.22-10.667 4.917zm24.89 1.765a1.98 1.98 0 012.548 1.202c.777 2.156.91 4.073.865 5.967-.017.754-.064 1.53-.111 2.3l-.03.514a50.247 50.247 0 00-.106 3.011c0 1.614.123 3.039.423 4.121.308 1.113.7 1.508.963 1.642.64.325 1.306.417 1.844.417a4.376 4.376 0 00.763-.067l.016-.003c1.059-.258 2.126.398 2.39 1.473.267 1.08-.38 2.176-1.445 2.447l-.543.103c-.294.043-.7.083-1.181.083-.954 0-2.274-.16-3.622-.843-1.724-.876-2.574-2.581-3.012-4.159-.445-1.607-.57-3.462-.57-5.214 0-1.195.054-2.274.111-3.251l.033-.551c.047-.765.088-1.449.104-2.12.038-1.602-.078-2.968-.624-4.484-.378-1.046.152-2.205 1.183-2.588z"
	  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32.352 22.666c-3.459 0-5.963 2.712-5.963 5.55 0 1.114-.89 2.018-1.987 2.018-1.098 0-1.987-.904-1.987-2.018 0-5.234 4.452-9.585 9.937-9.585 4.762 0 9.937 3.75 9.937 10.09 0 9.116-3.192 16.658-8.97 23.057a1.966 1.966 0 01-2.807.124 2.04 2.04 0 01-.122-2.852c5.154-5.708 7.924-12.293 7.924-20.33 0-3.75-3.022-6.053-5.962-6.053zm-8.23 9.72c1.024.4 1.535 1.568 1.141 2.608-2.791 7.37-8.434 10.489-14.144 10.875-1.095.074-2.042-.767-2.115-1.88-.073-1.111.756-2.073 1.85-2.147 4.334-.293 8.522-2.548 10.7-8.296a1.978 1.978 0 012.568-1.16zm4.223 20.976a2.037 2.037 0 01-.603 2.788c-3.557 2.311-6.968 3.114-9.021 3.598-.293.07-.559.132-.793.191-1.065.27-2.144-.387-2.41-1.468s.381-2.177 1.446-2.447c.28-.072.58-.143.894-.218 2.057-.49 4.799-1.144 7.742-3.056a1.97 1.97 0 012.745.612z"
	  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32.456 26.705c1.096.059 1.938 1.009 1.88 2.122v.007l-.012.183c-.008.112-.021.272-.041.476-.04.407-.105.993-.214 1.733a52.718 52.718 0 01-1.292 6.103c-1.465 5.393-7.602 14.99-19.117 16.103-1.093.106-2.063-.708-2.167-1.818-.104-1.11.697-2.094 1.79-2.2 9.352-.904 14.477-8.797 15.662-13.158.639-2.351.996-4.288 1.193-5.626.098-.669.156-1.187.19-1.53a16.773 16.773 0 00.038-.47v-.015c.059-1.113.994-1.968 2.09-1.91zM44.408 45.473c1.04.352 1.604 1.495 1.256 2.552-1.138 3.468-3.898 7.338-7.686 10.085a1.968 1.968 0 01-2.772-.469 2.038 2.038 0 01.462-2.815c3.168-2.298 5.377-5.49 6.226-8.077a1.98 1.98 0 012.514-1.276z"
	  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M42.89 45.582a1.973 1.973 0 012.667.903c.66 1.339 1.82 2.078 3.284 2.488 1.507.422 3.114.432 4.378.432 1.098 0 1.988.904 1.988 2.018 0 1.114-.89 2.018-1.988 2.018h-.059c-1.228 0-3.314 0-5.376-.577-1.451-.407-2.987-1.127-4.239-2.394a8.28 8.28 0 01-1.544-2.18 2.033 2.033 0 01.89-2.708z"
	  })));
	}

	var _path$1o;

	function _extends$1q() { _extends$1q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

	function SvgFocus(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4a2 2 0 012 2v4.09c10.554.95 18.96 9.356 19.91 19.91H58a2 2 0 110 4h-4.09C52.96 44.554 44.554 52.96 34 53.91V58a2 2 0 11-4 0v-4.09C19.446 52.96 11.04 44.554 10.09 34H6a2 2 0 110-4h4.09c.95-10.554 9.356-18.96 19.91-19.91V6a2 2 0 012-2zm2 45.89V45a2 2 0 10-4 0v4.89c-8.343-.922-14.968-7.547-15.89-15.89H19a2 2 0 100-4h-4.89c.922-8.343 7.547-14.968 15.89-15.89V19a2 2 0 104 0v-4.89c8.343.922 14.968 7.547 15.89 15.89H45a2 2 0 100 4h4.89c-.922 8.343-7.547 14.968-15.89 15.89z"
	  })));
	}

	var _path$1p, _path2$i;

	function _extends$1r() { _extends$1r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

	function SvgFolderCopy(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1r({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M12 8a8 8 0 00-8 8v21a8.001 8.001 0 007 7.938V49a8 8 0 008 8h33a8 8 0 008-8V31a8.001 8.001 0 00-7-7.938V20a8 8 0 00-8-8H32.624a6.12 6.12 0 00-5.742-4H12zm17 6.118c0-1.17-.948-2.118-2.118-2.118H12a4 4 0 00-4 4v21a4.002 4.002 0 003 3.874V27a8 8 0 018-8h14.294a6.708 6.708 0 016.138 4H49v-3a4 4 0 00-4-4H29v-1.882zM33.294 23A2.706 2.706 0 0136 25.706V27h16a4 4 0 014 4v18a4 4 0 01-4 4H19a4 4 0 01-4-4V27a4 4 0 014-4h14.294z"
	  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M20 35a2 2 0 012-2h27a2 2 0 110 4H22a2 2 0 01-2-2z"
	  })));
	}

	var _path$1q;

	function _extends$1s() { _extends$1s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

	function SvgFolderNew(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1s({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M48 30.088c1.105 0 2 .855 2 1.909v7.635h8c1.105 0 2 .855 2 1.909s-.895 1.909-2 1.909h-8v7.635c0 1.054-.895 1.909-2 1.909s-2-.855-2-1.909V43.45h-8c-1.105 0-2-.855-2-1.909s.895-1.909 2-1.909h8v-7.635c0-1.054.895-1.909 2-1.909zm8-7.635c0-2.045-1.684-3.714-3.8-3.813l-.2-.005H32v-1.909c0-1.054-.895-1.908-2-1.908H10c-1.054 0-1.918.778-1.995 1.766L8 16.726V43.45c0 2.044 1.684 3.713 3.8 3.813l.2.004h34-10c1.105 0 2 .855 2 1.91 0 1.053-.895 1.908-2 1.908h-2l-.046-.002L12 51.085c-4.335 0-7.865-3.29-7.996-7.397L4 43.45V16.726c0-3.09 2.566-5.61 5.775-5.722L10 11h20c2.462-.001 4.665 1.431 5.574 3.598l.086.22H52c4.335 0 7.864 3.29 7.996 7.397l.004.238v7.635c0 1.054-.895 1.909-2 1.909s-2-.855-2-1.909v-7.635zm-8 1.909c1.105 0 2 .854 2 1.909 0 1.054-.895 1.908-2 1.908H16c-1.105 0-2-.854-2-1.909 0-1.054.895-1.908 2-1.908h32z"
	  })));
	}

	var _path$1r;

	function _extends$1t() { _extends$1t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

	function SvgFolder(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1t({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 15H35.657A6.01 6.01 0 0030 11H10a6.007 6.007 0 00-6 6v28a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V23a8.01 8.01 0 00-8-8zm4 30a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V17a2.002 2.002 0 012-2h20a2.002 2.002 0 012 2v2h20a4.004 4.004 0 014 4v22zm-6-18a2 2 0 01-2 2H16a2 2 0 110-4h32a2 2 0 012 2z"
	  })));
	}

	var _path$1s, _path2$j, _path3$6;

	function _extends$1u() { _extends$1u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

	function SvgFood(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1u({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M45 59.53a6.67 6.67 0 01-6.66-6.66v-.1L39.22 37a5.2 5.2 0 01-2-1.39 7.8 7.8 0 01-1.62-5.4V14.45a8.32 8.32 0 012.5-6.16c4-3.9 11.32-3.83 11.63-3.82a2 2 0 012 2v46.4A6.67 6.67 0 0145 59.53zm-2.66-6.61a2.66 2.66 0 005.32-.05V8.58c-2.15.25-5.14.93-6.81 2.57a4.41 4.41 0 00-1.32 3.3v15.86c.005.06.005.12 0 .18a3.94 3.94 0 00.65 2.51 1.48 1.48 0 001.17.44 2 2 0 011.95 2.1l-.96 17.38z"
	  })), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
	    d: "M27.11 32l1.07 20.49a6.64 6.64 0 01-6.45 6.64h-.4a6.65 6.65 0 01-6.46-6.64v-.11L16 32c-3.83-1.16-4.12-4.55-3.95-7.15l.56-18.4a2 2 0 114 .12L16 25c-.19 3 .38 3.17 2.22 3.34l1.92.18-1.27 24a2.66 2.66 0 005.31 0l-1.26-24 1.91-.18c1.85-.17 2.42-.37 2.23-3.27L26.5 6.53a2 2 0 114-.12l.56 18.47c.16 2.54-.12 5.92-3.95 7.12z"
	  })), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
	    d: "M21.53 25.19a2 2 0 01-2-2V6.47a2 2 0 114 0v16.72a2 2 0 01-2 2z"
	  })));
	}

	var _path$1t, _path2$k, _path3$7;

	function _extends$1v() { _extends$1v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

	function SvgFraud(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1v({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
	    d: "M39.383 12.13a1.47 1.47 0 01-.51 0c.17.024.341.024.51 0z"
	  })), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M50.614 29.4c1.47-2.69 1.84-6.82 1.19-12.82v-.23c-1.22-5.2-5.88-8.41-12-8.27a20.07 20.07 0 00-22.72 1.69c-4.37 3.66-8.36 9.91-3.81 19.38a7.2 7.2 0 00-3.94 6.43 7 7 0 004.51 6.53c4.93 10.82 10.51 16.41 17 17 .58.08 1.169.08 1.75 0 6.49-.62 12.06-6.21 17-17a7 7 0 004.49-6.53 7.14 7.14 0 00-3.47-6.18zm-31.07-16.51a16.05 16.05 0 0118.64-1.07l.26.14a1.566 1.566 0 00.93.13c4.37-.26 7.61 1.68 8.45 5.06a26.193 26.193 0 01-.15 8.7 35.16 35.16 0 00-2.5-2.62c-2.12-2.07-4.51-4.43-5.38-7.11v-.06a.856.856 0 00-.09-.22 1.304 1.304 0 00-.08-.17 1.82 1.82 0 00-.54-.59 1.004 1.004 0 00-.26-.16 1.802 1.802 0 00-.55-.19.762.762 0 00-.26 0c-.12-.02-.241-.02-.36 0h-.19a.817.817 0 00-.15 0l-.2.08-.19.1a1.53 1.53 0 00-.41.31.35.35 0 00-.1.11 1.521 1.521 0 00-.28.4c-1 2-2.89 2.76-8.56 3.49-5.93.86-9.62 2.61-11.67 5.73-1.63-4.75-.4-8.68 3.64-12.06zm8.54 10.36c-6.17.89-8.54 2.58-9.54 5.25h-.01a97 97 0 0026.15.08c-.428-.584-1.058-1.22-1.627-1.793-.23-.231-.45-.453-.644-.657a32 32 0 01-5-5.78c-2.33 1.84-5.54 2.41-9.33 2.9zm16 9.4c-1 4.2-2.68 6.44-4.9 6.66-2 .13-3.53-1.87-4.71-5.94 3.206-.087 6.41-.327 9.61-.72zm-19.05 6.67c1.82 0 3.33-1.94 4.47-5.94h.02c-3.18-.06-6.36-.28-9.59-.66 1.01 4.16 2.67 6.37 4.94 6.6h.16zm22.61-.8a2 2 0 00-1.37 1.14c-4.46 10.07-9.36 15.3-14.58 15.54-5.2-.23-10.11-5.46-14.61-15.54a2 2 0 00-1.37-1.14 3 3 0 01-2.42-3 3.4 3.4 0 012.44-3.18c1.39 6.83 4.33 10.5 8.79 10.94h.5c3.47 0 5.61-2.45 7-5.18 1.35 2.73 3.51 5.18 7 5.18h.51c4.34-.43 7.25-4 8.67-10.68a3.23 3.23 0 011.88 2.98 3 3 0 01-2.42 2.94h-.02z"
	  })), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
	    d: "M32.084 59.21c.169.002.337-.022.5-.07a6.353 6.353 0 01-.87.07h.37zM31.714 59.2h-.38a1.678 1.678 0 01-.5-.07c.29.043.585.067.88.07z"
	  })));
	}

	var _path$1u;

	function _extends$1w() { _extends$1w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

	function SvgGames(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1w({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M26 41.998a2 2 0 01-2 2h-2v2a2 2 0 01-4 0v-2h-2a2 2 0 010-4h2v-2a2 2 0 014 0v2h2a2 2 0 012 2zm22-4a2 2 0 100 4 2 2 0 000-4zm-6 4a2 2 0 100 4 2 2 0 000-4zm17.981-.77a15.994 15.994 0 01-25.643 13.517 3.979 3.979 0 00-2.405-.747h-.223a3.44 3.44 0 00-2.048.747A15.997 15.997 0 014.02 41.228c.508-8.639 7.724-15.349 16.377-15.229H32v-2a8.009 8.009 0 018-8 4.004 4.004 0 004-4V8a2 2 0 014 0v4a8.009 8.009 0 01-8 8 4.004 4.004 0 00-4 4v2h7.604c8.653-.12 15.868 6.59 16.377 15.229zm-3.996.188c-.41-6.504-5.865-11.534-12.381-11.417H20.396c-6.516-.117-11.971 4.913-12.382 11.417A11.994 11.994 0 0027.242 51.56a7.366 7.366 0 014.468-1.562h.223a7.996 7.996 0 014.824 1.562 11.996 11.996 0 0019.228-10.144z"
	  })));
	}

	var _path$1v;

	function _extends$1x() { _extends$1x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

	function SvgGettingStarted(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1x({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.893 17.643a6.051 6.051 0 106.05 6.05 6.058 6.058 0 00-6.05-6.05zm0 8.068a2.017 2.017 0 110-4.034 2.017 2.017 0 010 4.034zm2.017 24.204v8.068a2.017 2.017 0 01-4.034 0v-8.068a2.017 2.017 0 014.034 0zm6.05 0v4.034a2.017 2.017 0 01-4.033 0v-4.034a2.017 2.017 0 014.034 0zm-12.101 0v4.034a2.017 2.017 0 01-4.034 0v-4.034a2.017 2.017 0 014.034 0zm25.814-11.553a17.703 17.703 0 00-7.28-10.227C46.428 15.426 37.77 7.47 34.34 4.832a4.014 4.014 0 00-4.893 0c-3.429 2.64-12.088 10.594-12.053 23.303a17.702 17.702 0 00-7.28 10.228 4.058 4.058 0 001.03 3.772 4.001 4.001 0 003.684 1.148l5.88-1.176c.239.522.48 1.044.748 1.576a4 4 0 003.596 2.198h13.684a4 4 0 003.596-2.198c.268-.532.509-1.054.748-1.576l5.88 1.176a4 4 0 003.683-1.148 4.059 4.059 0 001.031-3.773zm-39.635.93a12.921 12.921 0 013.78-6.308 34.179 34.179 0 001.361 5.304l-5.141 1.004zm24.697 2.555l-13.679.018C15.42 22.779 27.864 11.14 31.88 8.029c4.042 3.11 16.48 14.744 6.859 33.82l-.003-.002zm5.867-3.549a34.182 34.182 0 001.365-5.313 12.937 12.937 0 013.783 6.343l-5.148-1.03z"
	  })));
	}

	var _path$1w;

	function _extends$1y() { _extends$1y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

	function SvgGif(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
	    d: "M25.322 34.768h-1.568c-.467 0-.924-.336-1.372-1.008a2.448 2.448 0 01-.447-1.064 1.484 1.484 0 01.825-1.162 3.21 3.21 0 011.806-.546h3.5c.691 0 1.037.317 1.037.952v4.9a4.213 4.213 0 01-1.876 3.7 8.875 8.875 0 01-2.577 1.218c-.974.29-1.984.436-3 .434a9.182 9.182 0 01-5.011-1.415 9.7 9.7 0 01-3.458-3.695 10.323 10.323 0 01-1.219-4.942 10.007 10.007 0 011.471-5.32 10.467 10.467 0 013.821-3.738 10.082 10.082 0 015.04-1.33 9.665 9.665 0 015.24 1.448.9.9 0 01.42.84c0 .463-.095.92-.28 1.344A3.125 3.125 0 0127 26.41c-.202.224-.483.36-.784.378a1.557 1.557 0 01-.672-.2c-.547-.276-1.12-.5-1.708-.672a6.04 6.04 0 00-1.567-.2 6.13 6.13 0 00-4.508 1.75A6.022 6.022 0 0016 31.94a6.75 6.75 0 00.8 3.318 5.7 5.7 0 002.142 2.225c.919.53 1.964.8 3.024.785 1.178.02 2.34-.28 3.36-.869l-.004-2.631zm6.72-10.948a1.573 1.573 0 01.882-1.246A3.455 3.455 0 0134.842 22c.728 0 1.092.336 1.092 1.008v15.876a3.777 3.777 0 01-.616 2.1 1.69 1.69 0 01-1.343.953c-.487 0-.972-.364-1.457-1.092a2.495 2.495 0 01-.476-1.148V23.82zm11.592 9.995v5.069a3.777 3.777 0 01-.616 2.1 1.69 1.69 0 01-1.344.953c-.486 0-.971-.364-1.456-1.092a2.495 2.495 0 01-.476-1.148V23.988a1.573 1.573 0 01.882-1.246 3.455 3.455 0 011.918-.574h9.044c.69 0 1.035.327 1.036.98 0 .5-.1.995-.294 1.456-.16.414-.408.789-.728 1.096a1.29 1.29 0 01-.854.392h-7.112v4.088h6.188c.653 0 .98.308.98.924a3.367 3.367 0 01-.546 1.876 1.509 1.509 0 01-1.218.839l-5.404-.004zM4 20a2 2 0 01-2-2v-4a8.009 8.009 0 018-8h4a2 2 0 010 4h-4a4 4 0 00-4 4v4a2 2 0 01-2 2zm56 0a2 2 0 01-2-2v-4a4 4 0 00-4-4h-4a2 2 0 010-4h4a8.009 8.009 0 018 8v4a2 2 0 01-2 2zm-6 38h-4a2 2 0 010-4h4a4 4 0 004-4v-4a2 2 0 014 0v4a8.009 8.009 0 01-8 8zm-40 0h-4a8.009 8.009 0 01-8-8v-4a2 2 0 014 0v4a4 4 0 004 4h4a2 2 0 010 4z"
	  })));
	}

	var _path$1x;

	function _extends$1z() { _extends$1z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

	function SvgGraph(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58 55.833C58 57.03 57.03 58 55.833 58H14.667A8.677 8.677 0 016 49.333V8.167a2.167 2.167 0 114.333 0v41.166a4.338 4.338 0 004.334 4.334h41.166c1.197 0 2.167.97 2.167 2.166zM16.833 40.667a2.16 2.16 0 001.532-.635l8.218-8.218 5.603 5.603a4.336 4.336 0 006.128 0L51.5 24.23v5.603a2.167 2.167 0 104.333 0v-8.666a4.338 4.338 0 00-4.333-4.334h-8.667a2.167 2.167 0 000 4.334h5.603L35.25 34.353l-5.603-5.603a4.435 4.435 0 00-6.128 0l-8.218 8.218a2.167 2.167 0 001.532 3.699z"
	  })));
	}

	var _path$1y;

	function _extends$1A() { _extends$1A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

	function SvgGridView(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1A({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M10 8h18a2 2 0 012 2v18a2 2 0 01-2 2H10a2 2 0 01-2-2V10a2 2 0 012-2zm2 4v14h14V12H12zM10 34h18a2 2 0 012 2v18a2 2 0 01-2 2H10a2 2 0 01-2-2V36a2 2 0 012-2zm2 4v14h14V38H12zM54 8H36a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V10a2 2 0 00-2-2zM38 26V12h14v14H38zM36 34h18a2 2 0 012 2v18a2 2 0 01-2 2H36a2 2 0 01-2-2V36a2 2 0 012-2zm2 4v14h14V38H38z"
	  })));
	}

	var _path$1z;

	function _extends$1B() { _extends$1B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

	function SvgHandshake(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1B({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M50.931 40.829c-.538.5-1.29.779-1.974.905a5.145 5.145 0 01-1.65 2.967 5.148 5.148 0 01-3.136 1.303 4.513 4.513 0 01-1.477 2.492 4.788 4.788 0 01-3.858 1.116l-.602.4a8.001 8.001 0 01-7.276.822c-4.56 1.027-9.14-.466-11.111-1.243-1.083-.426-1.954-1.127-2.63-1.9L12 41.729a3.981 3.981 0 01-1.999.535H8a4 4 0 01-4-4V19.162a4 4 0 014-4h2c1.056 0 2.017.41 2.732 1.078 1.626-.101 2.56-.54 3.34-1.008.25-.15.488-.306.76-.484l.007-.005c.259-.17.554-.363.864-.546.644-.382 1.409-.756 2.37-.966.72-.157 1.642-.152 2.433-.115.851.039 1.785.128 2.635.227a71.878 71.878 0 012.667.364l2.496-1.22a2.01 2.01 0 01.197-.083c1.7-.617 3.727-.444 5.594-.038 1.932.419 4.016 1.162 6.012 2.005 2.955 1.249 5.85 2.774 7.977 3.97A4.001 4.001 0 0154 15.162h2a4 4 0 014 4v19.1a4 4 0 01-4 4h-2a3.992 3.992 0 01-3.069-1.433zm-.95-17.93l.019.011v13.353c0 .389-.848 1.323-1.978 1.53a5.312 5.312 0 00-.157-.202 600.264 600.264 0 00-6.949-8.324c-1.656-1.942-3.54-3.929-5-5.42a153.189 153.189 0 00-2.476-2.474l-.014-.013a2.002 2.002 0 00-2.348-.373l-5.656 2.776a1.607 1.607 0 01-1.645-2.749l3.877-2.78 4.293-2.097c.63-.197 1.713-.207 3.3.138 1.593.345 3.423.987 5.303 1.78 3.754 1.586 7.46 3.677 9.431 4.844zM14 37.95l.005-.004 6.223 7.112c.35.4.718.667 1.085.812a19.81 19.81 0 004.212 1.144l-2.764-2.181a2 2 0 112.479-3.14l6.08 4.8a4 4 0 003.61.698l-7.653-6.707a2 2 0 012.636-3.009l9.12 7.994a.792.792 0 001.256-.897 6.348 6.348 0 01-.053-.051L31.95 36.33a2 2 0 112.811-2.845l8.287 8.19c.438.434 1.137.451 1.596.041a1.149 1.149 0 00.13-1.587 594.369 594.369 0 00-6.9-8.266c-1.573-1.842-3.386-3.756-4.817-5.22a151.564 151.564 0 00-1.448-1.46l-4.425 2.17a5.607 5.607 0 01-5.738-9.589l.908-.651-.031-.002c-.78-.036-1.237-.007-1.396.028-.405.089-.762.248-1.186.5-.222.131-.445.277-.717.455l-.02.013c-.257.168-.555.363-.876.556A10.53 10.53 0 0114 20.13v17.82zM8 19.162v19.1h2v-19.1H8zm46 0v19.1h2v-19.1h-2z"
	  })));
	}

	var _path$1A;

	function _extends$1C() { _extends$1C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

	function SvgHeadphones(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1C({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M54 33.263V31c0-12.15-9.85-22-22-22s-22 9.85-22 22v2.263A8.007 8.007 0 004 41v6a8.01 8.01 0 008 8h2a4.004 4.004 0 004-4V37a4.004 4.004 0 00-4-4v-2c0-9.941 8.059-18 18-18s18 8.059 18 18v2a4.004 4.004 0 00-4 4v14a4.004 4.004 0 004 4h2a8.01 8.01 0 008-8v-6a8.007 8.007 0 00-6-7.737zM14.003 51H12a4.004 4.004 0 01-4-4v-6a4.004 4.004 0 014-4h2l.003 14zM56 47a4.004 4.004 0 01-4 4h-2l-.003-14H52a4.004 4.004 0 014 4v6z"
	  })));
	}

	var _path$1B;

	function _extends$1D() { _extends$1D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

	function SvgHeartFilled(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1D({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M53.82 12.35a14.08 14.08 0 00-20.35 0L32 13.87l-1.47-1.52a14.08 14.08 0 00-20.35 0c-5.562 5.833-5.562 15.006 0 20.84l19 19.59a4 4 0 005.74 0l19-19.59c5.534-5.86 5.49-15.034-.1-20.84z"
	  })));
	}

	var _path$1C;

	function _extends$1E() { _extends$1E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

	function SvgHeart(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1E({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M55.792 11.713a15.241 15.241 0 00-22.04 0l-1.598 1.65-1.598-1.65a15.241 15.241 0 00-22.04 0c-6.021 6.321-6.021 16.257 0 22.578l20.527 21.22a4.322 4.322 0 006.223 0l20.526-21.22c6.021-6.321 6.021-16.257 0-22.578zm-3.115 19.565l-20.52 21.22-20.526-21.22c-4.415-4.634-4.415-11.918 0-16.552a10.908 10.908 0 0115.811 0l3.155 3.26a2.232 2.232 0 003.115 0l3.154-3.26a10.908 10.908 0 0115.811 0c4.415 4.634 4.415 11.918 0 16.552z"
	  })));
	}

	var _path$1D;

	function _extends$1F() { _extends$1F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

	function SvgHelp(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1F({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32.115 40.765l7.141-7.626.694-.756c4.937-5.44 6.586-8.794 6.586-12.972 0-2.288-.555-4.438-1.733-6.31C42.515 9.357 38.147 7 32.669 7c-5.762 0-11.392 2.983-14.75 7.782l-.226.33c-.485.693-.693 1.317-.693 1.803 0 1.178 2.01 4.922 4.23 4.922.415 0 .831-.138 1.247-.416.347-.277.902-.832 1.664-1.664 2.982-3.328 4.992-4.576 7.696-4.576 3.12 0 5.408 2.08 5.408 4.854 0 2.426-1.317 4.714-4.437 8.112l-6.725 7.141c-.486.624-.763 1.179-.763 1.733 0 .555.347 1.456 1.04 2.635 1.04 1.595 2.15 2.427 3.328 2.427.763 0 1.525-.416 2.427-1.318zM30.38 56.99c-2.704 0-5.269-4.506-5.269-6.24 0-2.426 3.952-4.992 7.765-4.992 2.011 0 3.051.902 3.051 2.774 0 2.842-1.317 5.754-2.981 7.28-.832.762-1.664 1.178-2.566 1.178z"
	  })));
	}

	var _path$1E, _path2$l;

	function _extends$1G() { _extends$1G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

	function SvgHelppi(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1G({
	    viewBox: "0 0 48 48",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M9.75 8.25a3 3 0 00-3 3v25.5a3 3 0 003 3h25.5a3 3 0 003-3V26.727a1.5 1.5 0 113 0V36.75a6 6 0 01-6 6H9.75a6 6 0 01-6-6v-25.5a6 6 0 016-6h20.267a1.5 1.5 0 110 3H9.75z"
	  })), _path2$l || (_path2$l = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M43.136 8.708a1.5 1.5 0 01.064 2.12L25.952 29.157a3 3 0 01-4.413-.047l-8.195-9.087a1.5 1.5 0 012.228-2.01l8.195 9.088L41.015 8.772a1.5 1.5 0 012.12-.064z"
	  })));
	}

	var _path$1F;

	function _extends$1H() { _extends$1H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

	function SvgHomeCare(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1H({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
	    d: "M46.002 46a2 2 0 01-2 2v2a8 8 0 01-16 0v-6c-4.411 0-8-3.252-8-7.25V26a2 2 0 012-2h4a2 2 0 010 4h-2v8.75c0 1.792 1.794 3.25 4 3.25h4c2.206 0 4-1.458 4-3.25V28h-2a2 2 0 110-4h4a2 2 0 012 2v10.75c0 3.998-3.589 7.25-8 7.25v6a4 4 0 108 0v-2a2 2 0 110-4h4a2 2 0 012 2zm12.066-16.828L36.244 7.35a6 6 0 00-8.484 0L5.937 29.172a4 4 0 002.828 6.829h1.237v18a4.004 4.004 0 004 4h10a2 2 0 000-4h-10V32H8.765l21.823-21.824a2.05 2.05 0 012.828 0L55.24 32.001h-5.238v22h-2a2 2 0 100 4h2a4.004 4.004 0 004-4V36h1.237a4 4 0 002.829-6.829z"
	  })));
	}

	var _path$1G;

	function _extends$1I() { _extends$1I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

	function SvgHomeInstallation(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1I({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M34.587 5.14a3.987 3.987 0 00-5.614.03l-23.8 23.85c-2.508 2.512-.728 6.802 2.822 6.802h2.456v20.191A3.987 3.987 0 0014.438 60h5.838a1.993 1.993 0 000-3.987h-5.838V31.835H7.995l23.8-23.848L56.12 31.835H49.75v24.178H38.075a3.987 3.987 0 01-3.987-3.987v-2.99h1.855a5.383 5.383 0 003.653-1.443 5.232 5.232 0 001.66-3.844v-8.89a1.924 1.924 0 00-.006-3.848h-3.206v-4.97a1.924 1.924 0 10-3.848 0v4.97h-4.088v-4.97a1.924 1.924 0 10-3.847 0v4.97h-3.207a1.924 1.924 0 00-.007 3.848v8.768c0 1.547.636 3.02 1.748 4.047a5.08 5.08 0 003.448 1.362H30.1v2.99A7.974 7.974 0 0038.075 60H49.75a3.987 3.987 0 003.987-3.987v-20.19h2.382c3.57 0 5.34-4.334 2.79-6.834L34.588 5.14zm2.95 29.719h-10.77v8.768c0 .44.18.859.496 1.15.27.25.619.387.98.387h7.7c.437 0 .858-.166 1.185-.467.26-.24.409-.586.409-.948v-8.89z"
	  })));
	}

	var _path$1H;

	function _extends$1J() { _extends$1J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

	function SvgHome(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1J({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.795 29.24L36.361 6.808a6.167 6.167 0 00-8.722 0L5.205 29.24a4.112 4.112 0 002.907 7.02h3.328v18.503a4.116 4.116 0 004.112 4.112h32.896a4.116 4.116 0 004.112-4.112V36.26h3.328a4.112 4.112 0 002.907-7.02zm-10.347 2.908v22.616H15.552V32.148h-7.44L30.546 9.714a2.104 2.104 0 012.908 0l22.434 22.434h-7.44zm-18.504 8.224v6.168a4.116 4.116 0 004.112 4.112h6.168a4.116 4.116 0 004.112-4.112v-6.168a4.116 4.116 0 00-4.112-4.112h-6.168a4.116 4.116 0 00-4.112 4.112zm4.112 0h6.168l.003 6.168h-6.171v-6.168z"
	  })));
	}

	var _path$1I;

	function _extends$1K() { _extends$1K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

	function SvgImage(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1K({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.5 8.167h-39a8.677 8.677 0 00-8.667 8.667v30.333a8.677 8.677 0 008.667 8.667h39a8.677 8.677 0 008.666-8.667V16.834A8.677 8.677 0 0051.5 8.167zm4.333 39A4.338 4.338 0 0151.5 51.5h-39a4.338 4.338 0 01-4.334-4.333V16.834A4.338 4.338 0 0112.5 12.5h39a4.338 4.338 0 014.333 4.334v30.333zM20.083 32a7.583 7.583 0 10-7.583-7.583A7.592 7.592 0 0020.083 32zm0-10.833a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm32.948 13.635a2.166 2.166 0 11-3.063 3.063l-7.135-7.134-13.635 13.634a2.166 2.166 0 01-3.064 0l-4.968-4.968-7.135 7.135a2.166 2.166 0 11-3.063-3.064l7.134-7.135a4.336 4.336 0 016.128 0l3.436 3.437L39.77 27.667a4.336 4.336 0 016.128 0l7.134 7.135z"
	  })));
	}

	var _path$1J;

	function _extends$1L() { _extends$1L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

	function SvgIndustry(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1L({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
	    d: "M54 4a4 4 0 014 4v46a4 4 0 01-4 4H8a4 4 0 01-4-4V32.872a4 4 0 011.278-2.931l10-9.286A4 4 0 0122 23.586v3.827l7.278-6.758a4 4 0 012.49-1.062l.232-.007a4 4 0 014 4v3.827l7.278-6.758a4 4 0 012.49-1.062l.232-.007V8a4 4 0 014-4h4zm0 4h-4v15.586c0 2.667-4 2.667-4 0l-10.64 9.88C34.082 34.654 32 33.746 32 32v-8.414l-10.64 9.88C20.082 34.654 18 33.746 18 32v-8.414L8 32.872V54h46V8zM20 45a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm-24-8a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4z"
	  })));
	}

	var _path$1K;

	function _extends$1M() { _extends$1M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

	function SvgInfinite(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1M({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M47.284 40.87c-1.146 0-3.785-.634-8.583-4.888A57.423 57.423 0 0134.66 32a57.375 57.375 0 014.003-3.95c4.82-4.28 7.47-4.92 8.62-4.92 5.077 0 9.208 3.98 9.208 8.87 0 4.892-4.13 8.872-9.208 8.872zm-22.207-4.888c-4.798 4.254-7.437 4.889-8.583 4.889-5.078 0-9.208-3.98-9.208-8.871 0-4.892 4.13-8.871 9.208-8.871 1.146 0 3.785.635 8.583 4.888A57.433 57.433 0 0129.116 32a57.433 57.433 0 01-4.039 3.982zM47.284 19c-3.155 0-7.032 2.024-11.525 6.014a60.68 60.68 0 00-3.87 3.78 60.68 60.68 0 00-3.87-3.78C23.525 21.024 19.648 19 16.492 19 9.053 19 3 24.832 3 32s6.053 13 13.493 13c3.155 0 7.033-2.024 11.525-6.014a60.682 60.682 0 003.87-3.78 60.682 60.682 0 003.871 3.78C40.252 42.976 44.13 45 47.285 45c7.44 0 13.493-5.832 13.493-13s-6.053-13-13.493-13z"
	  })));
	}

	var _path$1L;

	function _extends$1N() { _extends$1N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

	function SvgInfoFilled(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1N({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.982 16.543 47.457 4.017 32 4zm2.154 22.64v17.034c0 .579-.115 1.151-.34 1.684a3.482 3.482 0 01-.842 1.263c-.261.27-.614.431-.989.453-.54 0-1.08-.41-1.62-1.23a2.372 2.372 0 01-.517-1.263V27.546c0-.474.33-.927.988-1.36a3.8 3.8 0 012.12-.646c.799 0 1.199.366 1.2 1.1zm.26-8.486a4.786 4.786 0 01-.373 1.863 3.91 3.91 0 01-.939 1.41 1.71 1.71 0 01-1.151.52c-.562 0-1.145-.444-1.75-1.33a3.043 3.043 0 01-.615-1.458c0-.54.367-1.047 1.102-1.523a4.277 4.277 0 012.365-.713c.907 0 1.36.41 1.36 1.232z"
	  })));
	}

	var _path$1M;

	function _extends$1O() { _extends$1O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

	function SvgInfo(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1O({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.982 16.543 47.457 4.017 32 4zm0 51.692C18.915 55.692 8.307 45.085 8.307 32S18.915 8.308 32 8.308 55.692 18.915 55.692 32C55.677 45.079 45.078 55.678 32 55.692zm2.154-29.052v17.034c0 .579-.115 1.151-.34 1.684a3.482 3.482 0 01-.842 1.263c-.261.27-.614.431-.989.453-.54 0-1.08-.41-1.62-1.23a2.372 2.372 0 01-.517-1.263V27.546c0-.474.33-.927.988-1.36a3.8 3.8 0 012.12-.646c.799 0 1.199.366 1.2 1.1zm.26-8.486a4.786 4.786 0 01-.373 1.863 3.91 3.91 0 01-.939 1.41 1.71 1.71 0 01-1.151.52c-.562 0-1.145-.444-1.75-1.33a3.043 3.043 0 01-.615-1.458c0-.54.367-1.047 1.102-1.523a4.277 4.277 0 012.365-.713c.907 0 1.36.41 1.36 1.232z"
	  })));
	}

	var _path$1N, _path2$m, _path3$8;

	function _extends$1P() { _extends$1P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

	function SvgInstagram(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1P({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M17.621 32c0-7.94 6.438-14.378 14.379-14.378A14.378 14.378 0 0146.378 32c0 7.941-6.437 14.378-14.378 14.378S17.62 39.941 17.62 32zM32 41.334a9.334 9.334 0 110-18.668 9.334 9.334 0 010 18.668z"
	  })), _path2$m || (_path2$m = /*#__PURE__*/React.createElement("path", {
	    d: "M50.306 17.054a3.36 3.36 0 11-6.72 0 3.36 3.36 0 016.72 0z"
	  })), _path3$8 || (_path3$8 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4c-7.604 0-8.56.032-11.544.169s-5.016.61-6.8 1.301a13.725 13.725 0 00-4.96 3.23 13.725 13.725 0 00-3.23 4.96c-.688 1.78-1.161 3.815-1.297 6.796C4.033 23.436 4 24.396 4 32c0 7.604.032 8.56.169 11.544s.61 5.016 1.301 6.8a13.726 13.726 0 003.23 4.96 13.725 13.725 0 004.96 3.23c1.78.692 3.817 1.165 6.8 1.301 2.983.136 3.936.165 11.54.165 7.604 0 8.56-.032 11.544-.169s5.016-.61 6.8-1.301a14.32 14.32 0 008.186-8.19c.692-1.78 1.166-3.816 1.302-6.8.136-2.982.168-3.936.168-11.54 0-7.604-.032-8.56-.169-11.544s-.61-5.016-1.301-6.8a13.725 13.725 0 00-3.23-4.96 13.725 13.725 0 00-4.96-3.23c-1.78-.688-3.815-1.161-6.796-1.297C40.564 4.033 39.604 4 32 4zm0 5.045c7.476 0 8.361.029 11.314.16 2.73.125 4.213.58 5.2.964 1.307.508 2.24 1.114 3.22 2.094.979.98 1.586 1.913 2.094 3.22.383.986.839 2.469.964 5.2.134 2.952.16 3.84.16 11.314s-.029 8.361-.16 11.314c-.125 2.73-.581 4.213-.964 5.2-.508 1.307-1.115 2.24-2.095 3.22-.98.978-1.912 1.586-3.219 2.094-.986.383-2.47.839-5.2.964-2.952.134-3.84.16-11.314.16-7.475 0-8.363-.03-11.315-.16-2.73-.125-4.212-.581-5.2-.964-1.307-.508-2.24-1.115-3.219-2.095-.979-.98-1.586-1.91-2.094-3.216-.383-.987-.84-2.47-.964-5.2-.135-2.953-.16-3.84-.16-11.315 0-7.474.029-8.361.16-11.314.125-2.73.58-4.213.964-5.2.508-1.307 1.114-2.24 2.094-3.22.98-.979 1.913-1.586 3.22-2.094.986-.383 2.469-.84 5.2-.964 2.952-.134 3.84-.16 11.314-.16v-.002z"
	  })));
	}

	var _path$1O;

	function _extends$1Q() { _extends$1Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

	function SvgInternet(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59.999 32C59.981 16.587 47.523 4.08 32.11 4.003h-.024c-.03 0-.058-.003-.087-.003l-.083.002h-.03C16.446 4.066 3.97 16.617 4 32.058 4.03 47.498 16.556 59.999 31.998 60H32c15.456-.018 27.982-12.544 27.999-28zm-6.844 10.647a49.45 49.45 0 00-8.83-2.843c.398-2.582.598-5.191.597-7.804 0-2.612-.199-5.22-.597-7.802a49.464 49.464 0 008.832-2.84 23.609 23.609 0 01-.002 21.289zM31.999 55.372c-3.136-2.033-5.695-6.49-7.188-12.108a52.508 52.508 0 0114.375 0C37.694 48.882 35.134 53.338 32 55.371zm0-16.91c-2.7.003-5.395.195-8.068.574-.73-4.662-.73-9.41 0-14.072 2.673.379 5.369.571 8.068.575h.007a57.906 57.906 0 008.06-.574c.363 2.328.546 4.68.548 7.035a45.884 45.884 0 01-.548 7.036A57.885 57.885 0 0032 38.462zm0-29.834c3.135 2.034 5.695 6.491 7.188 12.11-2.38.325-4.78.49-7.181.493h-.007a53.749 53.749 0 01-7.188-.495C26.304 15.118 28.863 10.661 32 8.628zm18.846 9.036a45.422 45.422 0 01-7.376 2.311A31.363 31.363 0 0038.704 9.28a23.766 23.766 0 0112.14 8.384zM25.295 9.28a31.362 31.362 0 00-4.766 10.694 45.377 45.377 0 01-7.374-2.312 23.766 23.766 0 0112.14-8.382zM10.842 21.354a49.392 49.392 0 008.83 2.842 51.291 51.291 0 000 15.608 49.441 49.441 0 00-8.83 2.842 23.61 23.61 0 010-21.292zm2.312 24.984a45.442 45.442 0 017.374-2.312 31.364 31.364 0 004.765 10.694 23.765 23.765 0 01-12.14-8.382zm25.55 8.382a31.362 31.362 0 004.764-10.694c2.52.56 4.987 1.333 7.375 2.312a23.765 23.765 0 01-12.14 8.382z"
	  })));
	}

	var _path$1P;

	function _extends$1R() { _extends$1R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

	function SvgInvoice(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1R({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M48 4H20a8.01 8.01 0 00-8 8v44a4.004 4.004 0 004 4h28a8.01 8.01 0 008-8V8a4.004 4.004 0 00-4-4zm0 48a4.004 4.004 0 01-4 4l-28 .002V12a4.004 4.004 0 014-4h28v44zM22 40a2 2 0 012-2h16a2 2 0 110 4H24a2 2 0 01-2-2zm0-8a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm20 16a2 2 0 01-2 2h-4a2 2 0 110-4h4a2 2 0 012 2zm-3.41-14.59a1.965 1.965 0 01-.55-1.8c.023-.13.06-.258.11-.38a2.32 2.32 0 01.19-.34c.07-.111.153-.212.25-.3a1.993 1.993 0 011.8-.55c.13.023.257.06.38.11a2.145 2.145 0 011.08 1.08c.05.122.087.25.11.38a1.965 1.965 0 01-.55 1.8c-.088.097-.19.18-.3.25a2.188 2.188 0 01-.34.19 2.71 2.71 0 01-.38.11 1.965 1.965 0 01-1.8-.55zM22 24a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm16.04.39a1.918 1.918 0 010-.78c.021-.13.058-.258.11-.38a2.32 2.32 0 01.19-.34c.072-.112.155-.216.25-.31a2.015 2.015 0 011.8-.54c.129.027.256.064.38.11.12.05.234.113.34.19a1.778 1.778 0 01.55.55c.073.108.136.221.19.34.15.367.189.77.11 1.16-.023.13-.06.258-.11.38a2.315 2.315 0 01-.19.34c-.07.11-.153.212-.25.3a1.98 1.98 0 01-2.82 0 1.446 1.446 0 01-.25-.3 2.32 2.32 0 01-.19-.34 1.797 1.797 0 01-.11-.38zM22 16a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm16.04.39a1.918 1.918 0 010-.78 1.8 1.8 0 01.11-.38 2.32 2.32 0 01.19-.34c.07-.111.153-.212.25-.3a1.993 1.993 0 011.8-.55c.129.027.256.064.38.11a2.146 2.146 0 011.08 1.08c.05.122.087.25.11.38.053.257.053.523 0 .78-.023.13-.06.258-.11.38a2.309 2.309 0 01-.44.65c-.091.09-.192.171-.3.24-.106.077-.22.14-.34.19-.123.05-.25.087-.38.11a1.998 1.998 0 01-1.8-.54 1.828 1.828 0 01-.25-.31 2.324 2.324 0 01-.19-.34 1.803 1.803 0 01-.11-.38z"
	  })));
	}

	var _path$1Q;

	function _extends$1S() { _extends$1S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

	function SvgJobSearch(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1S({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
	    d: "M57.585 48.758l-6.794-6.794a24.032 24.032 0 10-8.828 8.828l6.622 6.622a6.25 6.25 0 008.828 0l.172-.172a6 6 0 000-8.484zM10 30a20 20 0 1120 20 20.022 20.022 0 01-20-20zm44.758 24.414l-.172.172a2.244 2.244 0 01-3.172 0l-6.112-6.112a24.213 24.213 0 003.172-3.172l6.284 6.284a2.002 2.002 0 010 2.828zM37.536 26.658a8 8 0 10-15.073 0A10.008 10.008 0 0015.999 36a6.006 6.006 0 006 6h16a6.006 6.006 0 006-6 10.008 10.008 0 00-6.463-9.342zM29.999 20a4 4 0 110 8 4 4 0 010-8zm8 18H22a2.003 2.003 0 01-2-2 6.008 6.008 0 014.851-5.887 7.97 7.97 0 0010.299 0A6.007 6.007 0 0139.999 36a2.002 2.002 0 01-2 2z"
	  })));
	}

	var _path$1R, _path2$n, _path3$9;

	function _extends$1T() { _extends$1T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

	function SvgKontantkort(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1T({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
	    d: "M14.56 32.53v3.12a2.11 2.11 0 01-.35 1.2 1 1 0 01-.76.54c-.28 0-.56-.21-.83-.62a1.451 1.451 0 01-.27-.66v-9a.89.89 0 01.5-.71 1.94 1.94 0 011.09-.4c.42 0 .62.2.62.58v3.56l3.88-3.59a1.83 1.83 0 01.64-.4c.231-.097.48-.148.73-.15.43 0 .64.2.64.58a2.358 2.358 0 01-.18.89 1.999 1.999 0 01-.51.73l-3.33 3.08 4.1 4a.52.52 0 01.14.4c.005.398-.102.79-.31 1.13a.85.85 0 01-.69.51A1 1 0 0119 37l-4.44-4.47z"
	  })), _path2$n || (_path2$n = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M25.59 33.32h-1.42v2.33a2.19 2.19 0 01-.35 1.2 1 1 0 01-.77.54c-.28 0-.55-.21-.83-.62a1.54 1.54 0 01-.27-.66v-8.94a.89.89 0 01.5-.71 2 2 0 011.09-.33H26a3.91 3.91 0 012 .48 3.33 3.33 0 011.29 1.29 3.61 3.61 0 01.46 1.83 3.17 3.17 0 01-.5 1.7 4 4 0 01-1.4 1.33l1.85 2.64a.66.66 0 01.13.4 2 2 0 01-.33 1.09c-.22.33-.45.5-.69.5a.92.92 0 01-.7-.48l-2.52-3.59zm.32-2a1.61 1.61 0 001.14-.45 1.42 1.42 0 00.47-1.08 1.45 1.45 0 00-.46-1.11 1.6 1.6 0 00-1.15-.44h-1.74v3.08h1.74z"
	  })), _path3$9 || (_path3$9 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M10 12h44a6 6 0 016 6v28a6 6 0 01-6 6H10a6 6 0 01-6-6V18a6 6 0 016-6zm46 6a2 2 0 00-2-2H10a2 2 0 00-2 2v28a2 2 0 002 2h44a2 2 0 002-2V18z"
	  })));
	}

	var _path$1S;

	function _extends$1U() { _extends$1U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

	function SvgLaptop(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1U({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59.558 46.79l-2.45-4.9V15.186A4.189 4.189 0 0052.924 11H11.076a4.189 4.189 0 00-4.185 4.185V41.89l-2.45 4.9a4.185 4.185 0 003.743 6.056h47.63a4.185 4.185 0 003.743-6.056zM11.077 15.186h41.847v25.108H11.077V15.185zM8.185 48.662l2.092-4.184h43.445l2.092 4.184H8.184z"
	  })));
	}

	var _path$1T, _path2$o, _path3$a;

	function _extends$1V() { _extends$1V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

	function SvgLatePayment(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1V({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1T || (_path$1T = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M10 5a6 6 0 00-6 6v18a6 6 0 006 6h16a2 2 0 100-4H10a2 2 0 01-2-2V18.556h36.444V22a2 2 0 004 0V11a6 6 0 00-6-6H10zm34.444 9.556V11a2 2 0 00-2-2H10a2 2 0 00-2 2v3.556h36.444z"
	  })), _path2$o || (_path2$o = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M44.5 31C38.149 31 33 36.149 33 42.5S38.149 54 44.5 54 56 48.851 56 42.5 50.851 31 44.5 31zM29 42.5C29 33.94 35.94 27 44.5 27 53.06 27 60 33.94 60 42.5 60 51.06 53.06 58 44.5 58 35.94 58 29 51.06 29 42.5z"
	  })), _path3$a || (_path3$a = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M44.5 34.714a2 2 0 012 2v7.175a2 2 0 01-.47 1.29l-2.894 3.431a2 2 0 01-3.058-2.578l2.422-2.873v-6.445a2 2 0 012-2z"
	  })));
	}

	var _path$1U;

	function _extends$1W() { _extends$1W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

	function SvgLetter(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1W({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1U || (_path$1U = /*#__PURE__*/React.createElement("path", {
	    d: "M46 26a2 2 0 01-2 2H24a2 2 0 010-4h20a2 2 0 012 2zm-22-8h20a2 2 0 000-4H24a2 2 0 000 4zm20 16H24a2 2 0 000 4h20a2 2 0 000-4zM54 8v44a8.01 8.01 0 01-8 8H14a8.01 8.01 0 01-8-8v-2a4.004 4.004 0 014-4h4V12a8.01 8.01 0 018-8h28a4.004 4.004 0 014 4zM14 56h25.083A7.94 7.94 0 0138 52v-2H10v2a4.004 4.004 0 004 4zM50 8H22a4.004 4.004 0 00-4 4v34h20a4.004 4.004 0 014 4v2a4 4 0 108 0V8z"
	  })));
	}

	var _path$1V;

	function _extends$1X() { _extends$1X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

	function SvgLike(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1X({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1V || (_path$1V = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M55.104 22.422h-8.35a4.147 4.147 0 00-2.942 1.228c-6.027-2.112-11.372-8.068-13.288-15.002a6.288 6.288 0 00-5.39-4.604 6.123 6.123 0 00-6.166 3.253c-.226.423-.428.858-.608 1.302a12.241 12.241 0 00-.16 8.448l2.637 7.462h-9.574A6.27 6.27 0 005 30.773v2.087a6.264 6.264 0 002.895 5.279 6.22 6.22 0 00-.807 3.072v2.088a6.273 6.273 0 004.615 6.042 6.24 6.24 0 00-.44 2.308v2.088A6.27 6.27 0 0017.526 60h26.096c.176-.002.352-.027.522-.074.17.047.346.072.522.074h12.526a2.088 2.088 0 002.088-2.088V26.597a4.18 4.18 0 00-4.176-4.175zM15.438 53.737v-2.088a2.09 2.09 0 012.088-2.087 2.088 2.088 0 000-4.176h-4.175a2.09 2.09 0 01-2.088-2.087V41.21a2.09 2.09 0 012.088-2.088 2.088 2.088 0 000-4.175h-2.088a2.09 2.09 0 01-2.088-2.088v-2.087a2.09 2.09 0 012.088-2.088h12.526c.13 0 .26-.014.389-.04.047-.008.09-.023.136-.035.057-.015.114-.024.17-.044.019-.007.034-.018.052-.025.073-.03.143-.062.212-.1.054-.028.11-.054.161-.087.058-.039.114-.08.167-.125.052-.041.106-.08.154-.126s.09-.098.133-.149c.044-.05.089-.099.127-.153.04-.056.072-.117.106-.177.032-.056.066-.11.092-.169.028-.062.048-.127.07-.192.022-.064.045-.128.06-.194.014-.06.021-.122.03-.184.012-.076.02-.153.023-.23 0-.02.006-.038.006-.058 0-.044-.01-.086-.013-.13a1.607 1.607 0 00-.076-.44c-.012-.041-.016-.083-.03-.125l-3.608-10.21a8.04 8.04 0 01.084-5.532 9.07 9.07 0 01.416-.895 1.992 1.992 0 012.024-1.07A2.097 2.097 0 0126.5 9.758c2.277 8.247 8.75 15.351 16.078 17.876v28.19H17.526a2.09 2.09 0 01-2.088-2.088zm39.666 2.087h-8.35V26.654c0-.02.005-.037.005-.056h8.345v29.227z"
	  })));
	}

	var _path$1W;

	function _extends$1Y() { _extends$1Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

	function SvgLink(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1W || (_path$1W = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M37.383 27.972c4.572 4.583 4.572 12.001 0 16.584L25.368 56.57c-4.583 4.572-12.001 4.572-16.584 0L7.43 55.216c-4.572-4.583-4.572-12.001 0-16.584l8.14-8.14a2.132 2.132 0 013.014 3.015l-8.14 8.14a7.471 7.471 0 000 10.554l1.356 1.355a7.473 7.473 0 0010.554 0l12.015-12.015a7.471 7.471 0 000-10.554l-1.743-1.744a2.132 2.132 0 113.014-3.014l1.744 1.743zM56.571 8.784L55.216 7.43c-4.583-4.572-12.001-4.572-16.584 0L26.617 19.444c-4.572 4.583-4.572 12.001 0 16.584l1.744 1.743a2.132 2.132 0 103.014-3.014l-1.743-1.744a7.471 7.471 0 010-10.554l12.015-12.015a7.473 7.473 0 0110.554 0l1.355 1.355a7.471 7.471 0 010 10.554l-8.14 8.14a2.132 2.132 0 003.015 3.014l8.14-8.14c4.572-4.582 4.572-12 0-16.583z"
	  })));
	}

	var _path$1X;

	function _extends$1Z() { _extends$1Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

	function SvgLinkedin(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1X || (_path$1X = /*#__PURE__*/React.createElement("path", {
	    d: "M10.73 4C7.011 4 4 7.021 4 10.738c0 3.721 3.011 6.742 6.73 6.742 3.712 0 6.726-3.02 6.726-6.742C17.456 7.02 14.442 4 10.73 4zM46.078 21.664c-5.645 0-9.431 3.1-10.98 6.04h-.154v-5.109H23.809V60h11.599V41.495c0-4.878.924-9.605 6.964-9.605 5.95 0 6.032 5.58 6.032 9.92V60h11.594V39.481c0-10.071-2.17-17.817-13.92-17.817zM16.533 60H4.927V22.593h11.606V60z"
	  })));
	}

	var _path$1Y;

	function _extends$1_() { _extends$1_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

	function SvgListView(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1_({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/React.createElement("path", {
	    d: "M10.99 15a3 3 0 10.01 0h-.01zM8 32a3 3 0 116.001.001A3 3 0 018 32zM8 46a3 3 0 116.001.001A3 3 0 018 46zM20.037 30h33.926c1.12 0 2.037.895 2.037 2s-.912 2-2.037 2H20.037C18.912 34 18 33.104 18 32c0-1.105.912-2 2.037-2zM20.035 44C18.91 44 18 44.896 18 46.001c0 1.105.911 1.998 2.035 1.999h33.927C55.087 48 56 47.105 56 46.001S55.09 44 53.965 44h-33.93zM54.111 19.995H20.184a2.103 2.103 0 01-.295 0c-1.122-.08-1.965-1.038-1.883-2.14.081-1.102 1.057-1.93 2.178-1.85H54.11c1.008.072 1.81.86 1.884 1.85.081 1.102-.762 2.06-1.884 2.14z"
	  })));
	}

	var _path$1Z;

	function _extends$1$() { _extends$1$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

	function SvgLockClosed(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$1$({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46.333 24.74h-.01l-.034-7.119-.005-.136C45.736 9.885 39.41 4 31.793 4 24.172 4 17.849 9.885 17.3 17.485l-.038 7.257A8.305 8.305 0 009 33.037v18.667A8.306 8.306 0 0017.296 60h29.037a8.306 8.306 0 008.297-8.296V33.037a8.306 8.306 0 00-8.297-8.296zM31.815 8.149a10.38 10.38 0 0110.325 9.565l.035 7.028H21.41l.034-7.028a10.422 10.422 0 0110.37-9.565zM50.48 51.704a4.152 4.152 0 01-4.148 4.148H17.296a4.152 4.152 0 01-4.148-4.148V33.037a4.152 4.152 0 014.148-4.148h29.037a4.152 4.152 0 014.148 4.148v18.667zM33.89 41.334v6.222a2.074 2.074 0 01-4.148 0v-6.223a2.074 2.074 0 114.148 0z"
	  })));
	}

	var _path$1_;

	function _extends$20() { _extends$20 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

	function SvgLockOpen(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$20({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46.33 24.744H23.52a10.364 10.364 0 1117.263-11.403 2.074 2.074 0 003.59-2.08c-3.893-6.747-12.42-9.217-19.315-5.594-6.896 3.622-9.702 12.043-6.356 19.077h-1.407A8.305 8.305 0 009 33.04v18.665A8.305 8.305 0 0017.296 60H46.33a8.305 8.305 0 008.295-8.295V33.04a8.305 8.305 0 00-8.295-8.296zm4.148 26.96a4.152 4.152 0 01-4.148 4.148H17.296a4.152 4.152 0 01-4.148-4.147V33.04a4.152 4.152 0 014.148-4.148H46.33a4.152 4.152 0 014.148 4.148v18.665zM33.886 41.336v6.222a2.074 2.074 0 11-4.147 0v-6.222a2.074 2.074 0 014.147 0z"
	  })));
	}

	var _path$1$;

	function _extends$21() { _extends$21 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

	function SvgLogin(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$21({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M37.602 34.167H8.168a2.167 2.167 0 010-4.334h29.435l-9.3-9.301a2.167 2.167 0 013.063-3.064l12.999 12.999c.101.101.192.213.272.332.034.051.057.107.087.16.085.131.146.276.178.429.02.063.043.123.056.188.056.28.056.568 0 .848-.013.065-.037.125-.056.188a1.269 1.269 0 01-.178.428c-.03.054-.053.11-.087.161-.08.12-.17.23-.272.332L31.365 46.532a2.167 2.167 0 01-3.064-3.064l9.302-9.301zM49.334 6h-26a2.167 2.167 0 000 4.333h26a4.338 4.338 0 014.334 4.334v34.666a4.338 4.338 0 01-4.334 4.334h-26a2.167 2.167 0 100 4.333h26A8.677 8.677 0 0058 49.333V14.667A8.677 8.677 0 0049.333 6z"
	  })));
	}

	var _path$20;

	function _extends$22() { _extends$22 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

	function SvgLogout(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$22({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.53 33.533L45.533 46.532a2.166 2.166 0 11-3.064-3.064l9.301-9.302H22.333a2.167 2.167 0 110-4.333H51.77l-9.3-9.301a2.167 2.167 0 013.063-3.064L58.53 30.467c.1.101.192.212.271.332.035.051.058.107.087.16.086.131.146.276.18.429.018.063.042.123.055.188.056.28.056.568 0 .848-.013.065-.037.125-.056.188a1.27 1.27 0 01-.179.428c-.03.054-.053.11-.087.16-.08.12-.17.232-.271.333zM33.168 53.667h-19.5a4.338 4.338 0 01-4.334-4.334V14.667a4.338 4.338 0 014.334-4.334h19.5a2.167 2.167 0 100-4.333h-19.5A8.677 8.677 0 005 14.667v34.666A8.677 8.677 0 0013.667 58h19.5a2.167 2.167 0 100-4.333z"
	  })));
	}

	var _path$21;

	function _extends$23() { _extends$23 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

	function SvgMap(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$23({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.916 14.458c-5.776 0-10.458 4.682-10.458 10.458 0 5.775 4.682 10.457 10.458 10.457 5.775 0 10.457-4.682 10.457-10.457-.006-5.773-4.685-10.452-10.457-10.458zm0 16.732a6.275 6.275 0 116.274-6.274 6.281 6.281 0 01-6.274 6.274zm0-27.19C20.369 4.013 11.013 13.37 11 24.916c0 13.06 14.254 29.391 18.625 34.087a3.141 3.141 0 002.29.997h.003a3.141 3.141 0 002.29-.999c4.37-4.694 18.623-21.025 18.623-34.085C52.818 13.37 43.461 4.013 31.915 4zm0 51.312c-4.11-4.54-16.733-19.387-16.733-30.396 0-9.242 7.491-16.733 16.733-16.733 9.24 0 16.732 7.491 16.732 16.733 0 11.009-12.624 25.857-16.733 30.396z"
	  })));
	}

	var _path$22, _path2$p, _path3$b;

	function _extends$24() { _extends$24 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

	function SvgMediaContent(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$24({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M20 4a8 8 0 00-8 8v2a2 2 0 104 0v-2a4 4 0 014-4h17v8a4 4 0 004 4h7v3a2 2 0 104 0v-4.724a4 4 0 00-1.046-2.697L41.572 5.303A4 4 0 0038.618 4H20zm25.922 12L41 10.609V16h4.922z"
	  })), _path2$p || (_path2$p = /*#__PURE__*/React.createElement("path", {
	    d: "M52 41.5a2 2 0 10-4 0V52a4 4 0 01-4 4H16V46a2 2 0 10-4 0v10a4 4 0 004 4h28a8 8 0 008-8V41.5z"
	  })), _path3$b || (_path3$b = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M19.5 38a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0 4C26.404 42 32 36.404 32 29.5S26.404 17 19.5 17 7 22.596 7 29.5 12.596 42 19.5 42zM44.097 24.207a2 2 0 00-2.912.379A1.994 1.994 0 0040.6 26v14.053c-1.486-.803-3.265-1.195-5.135-1.024-4.675.426-8.153 4.203-7.767 8.437.386 4.234 4.489 7.322 9.164 6.896 4.675-.426 8.152-4.204 7.766-8.438a7.084 7.084 0 00-.068-.526c.026-.129.04-.262.04-.398V29.833l5.863 4.886a2 2 0 102.56-3.073l-8.926-7.439zm-7.598 26.171c2.855-.26 4.298-2.42 4.146-4.091-.153-1.672-1.962-3.535-4.817-3.275-2.856.26-4.299 2.42-4.146 4.091.152 1.672 1.961 3.535 4.817 3.275z"
	  })));
	}

	var _path$23;

	function _extends$25() { _extends$25 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

	function SvgMegaphone(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$25({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M38.372 10.275a2.99 2.99 0 00-3.115.227l-9.291 6.636A9.944 9.944 0 0120.154 19H12a8.01 8.01 0 00-8 8v4a8.014 8.014 0 006.398 7.839l2.927 11.708a5.88 5.88 0 0011.41-2.854l-2.094-8.376a9.96 9.96 0 013.326 1.546l9.288 6.634A3 3 0 0040 45.057V12.943a2.987 2.987 0 00-1.628-2.668zm-17.86 40.001a1.88 1.88 0 01-3.306-.7L14.562 39h3.876l2.416 9.664a1.867 1.867 0 01-.342 1.612zM36 43.113l-7.708-5.504A13.916 13.916 0 0020.154 35H12a4.004 4.004 0 01-4-4v-4a4.004 4.004 0 014-4h8.154a13.917 13.917 0 008.137-2.607L36 14.887v28.227zM52 29a20.636 20.636 0 01-4.48 13.3 2 2 0 01-3.04-2.6A16.604 16.604 0 0048 29a16.604 16.604 0 00-3.52-10.7 2 2 0 013.04-2.6A20.636 20.636 0 0152 29zm8 0c0 7.455-2.362 14.49-6.48 19.3a2 2 0 01-3.04-2.6C53.989 41.601 56 35.515 56 29c0-6.515-2.012-12.601-5.52-16.7a2 2 0 013.04-2.6C57.638 14.51 60 21.544 60 29z"
	  })));
	}

	var _path$24;

	function _extends$26() { _extends$26 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

	function SvgMenu(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$26({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M10.334 16.834c0-1.197.97-2.167 2.166-2.167h39a2.167 2.167 0 110 4.333h-39a2.167 2.167 0 01-2.166-2.166zM51.5 45h-39a2.167 2.167 0 100 4.334h39a2.167 2.167 0 000-4.334zm0-15.166h-39a2.167 2.167 0 100 4.333h39a2.167 2.167 0 000-4.333z"
	  })));
	}

	var _path$25;

	function _extends$27() { _extends$27 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

	function SvgMicrophone(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$27({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32.131 46c6.624-.008 11.993-5.376 12-12V16c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v18c.008 6.624 5.376 11.992 12 12zm0-38a8.01 8.01 0 018 8v18a8 8 0 11-16 0v-4h6a2 2 0 100-4h-6v-4h6a2 2 0 000-4h-6v-2a8.01 8.01 0 018-8zm17.92 34.89a19.874 19.874 0 01-15.92 11V58a2 2 0 01-4 0v-4.11a19.874 19.874 0 01-15.92-11 2 2 0 113.583-1.78 16.007 16.007 0 0028.675 0 2 2 0 113.582 1.78z"
	  })));
	}

	var _path$26;

	function _extends$28() { _extends$28 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

	function SvgMinus(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$28({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.5 30h-39a2.167 2.167 0 100 4.333h39a2.167 2.167 0 100-4.333z"
	  })));
	}

	var _path$27;

	function _extends$29() { _extends$29 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

	function SvgMms(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$29({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M50.07 10H13.93a9.75 9.75 0 00-9.73 9.74v16.78a9.76 9.76 0 009.73 9.74h9.61V52a2 2 0 001.24 1.85 2 2 0 002.22-.44l4.93-4.92 2.22-2.23h16c2.13 0 4.2-.703 5.89-2a9.999 9.999 0 002.62-3 9.67 9.67 0 001.22-4.72v-16.8A9.75 9.75 0 0050.07 10zM33.28 42.26a2 2 0 00-.92.23c-.178.09-.34.208-.48.35l-4.34 4.33v-2.91a2 2 0 00-2-2H13.93a5.73 5.73 0 01-5.72-5.44l10.22-10.23a2 2 0 012.84 0l10.25 10.25L37 42.26h-3.72zm9.31 0h7.48a5.68 5.68 0 003.01-.86l-8.81-8.81a2 2 0 00-2.84 0l-4.25 4.26 5.41 5.41zm13.21-5.74a5.528 5.528 0 01-.26 1.69l-8.45-8.45a6 6 0 00-8.49 0L34.35 34 24.09 23.76a6 6 0 00-8.49 0l-7.4 7.41V19.74A5.74 5.74 0 0113.93 14h36.14a5.75 5.75 0 015.73 5.74v16.78zm-7.95-15.03a2 2 0 11-4 0 2 2 0 014 0z"
	  })));
	}

	var _path$28;

	function _extends$2a() { _extends$2a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

	function SvgMoisture(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2a({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M22 36a10 10 0 01-10-10c0-4.669 6.623-14.56 8.227-16.956l.123-.184L22 6.48l1.65 2.38.123.184C25.377 11.439 32 21.33 32 26a10 10 0 01-10 10zm0-22.38c-2.88 4.49-6 10.2-6 12.38a6 6 0 1012 0c0-2.18-3.12-7.89-6-12.38zM30 60a8 8 0 01-8-8c0-3.75 5.29-11.6 6.35-13.14L30 36.48l1.65 2.38C32.71 40.4 38 48.25 38 52a8 8 0 01-8 8zm0-16.36c-2.13 3.41-4 7-4 8.36a4 4 0 108 0c0-1.33-1.87-4.95-4-8.36zM38.343 37.657A8 8 0 0052 32.001c0-3.75-5.29-11.6-6.35-13.14L44 16.48l-1.65 2.38C41.29 20.4 36 28.25 36 32a8 8 0 002.343 5.656zM40 32.001c0-1.36 1.87-4.95 4-8.36 2.13 3.41 4 7.03 4 8.36a4 4 0 11-8 0z"
	  })));
	}

	var _path$29, _path2$q;

	function _extends$2b() { _extends$2b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

	function SvgMoneyBack(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2b({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M47.293 52.244c-3.488.467-5.17 1.628-7.131 2.981-1.003.692-2.08 1.435-3.507 2.161-.06.03-.12.057-.181.08-6.74 2.627-14.927 1.572-19.987-1.802a1.99 1.99 0 01-.21-.161L5.774 46.279a5.214 5.214 0 016.021-8.447l7.507 4.278a5.628 5.628 0 013.888-2.542l9.297-1.447c.076-.054.16-.115.254-.18.41-.29.986-.682 1.655-1.1 1.29-.805 3.108-1.822 4.793-2.271 2.176-.58 4.855-.403 6.797-.154.4.05.78.107 1.132.163A4 4 0 0151.096 31h5a4 4 0 014 4v16a4 4 0 01-4 4h-5a4.002 4.002 0 01-3.803-2.756zm-.197-13.61a32.594 32.594 0 00-1.618-.25c-1.866-.24-3.883-.315-5.26.051-1.074.286-2.468 1.028-3.703 1.8a32.36 32.36 0 00-1.892 1.278l-.108.08-.025.019-.005.003c-.264.2-.574.332-.901.383l-9.78 1.522a1.634 1.634 0 00.378 3.243l8.939-.696a2 2 0 11.31 3.988l-8.938.696a5.636 5.636 0 01-5.955-4.472l-8.723-4.972a1.214 1.214 0 00-1.402 1.966l10.4 9.133c3.932 2.558 10.619 3.472 16.115 1.37.779-.405 1.539-.927 2.36-1.49 2.26-1.552 4.98-3.42 9.808-4.04v-9.613zm4 11.462V51h5V35h-5V50.096zM25.096 9c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm-14 10c0-7.732 6.268-14 14-14s14 6.268 14 14-6.268 14-14 14-14-6.268-14-14z"
	  })), _path2$q || (_path2$q = /*#__PURE__*/React.createElement("path", {
	    d: "M26.596 21.5c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.68c-.02-.08-.02-.28-.02-.58 0-.34 0-.56.02-.66h4.98c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.84c.72-1.46 1.8-2.2 3.22-2.2.62 0 1.3.22 2.04.64.14.08.28.12.38.12.18 0 .38-.08.56-.26.36-.32.64-.94.64-1.58 0-.22-.1-.4-.3-.54-.98-.62-2.06-.94-3.24-.94-2.78 0-5.16 1.82-6.2 4.76h-.28c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.24c-.02.1-.02.32-.02.66 0 .3 0 .5.02.58h-.12c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.78c.86 3.02 3.08 4.8 6.04 4.8 1.12 0 2.24-.26 2.88-.64.56-.34.92-1.08.92-1.86 0-.42-.24-.64-.7-.64-.22 0-.58.08-1.06.22-.78.24-1.4.36-1.84.36-1.5 0-2.58-.74-3.22-2.24h3.8z"
	  })));
	}

	var _path$2a;

	function _extends$2c() { _extends$2c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

	function SvgMoneyEuro(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2c({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M60 25.001a20.977 20.977 0 00-38.884-10.949c-.034.018-.07.03-.103.05a21.017 21.017 0 00-6.961 6.981A20.998 20.998 0 0025 60a21.1 21.1 0 0017.952-10.114 21.003 21.003 0 007.01-7.009A20.984 20.984 0 0060 25.001zm-35 31a17.014 17.014 0 01-13.787-26.963c-.14.982-.21 1.972-.212 2.963.014 11.592 9.408 20.986 21 21a20.687 20.687 0 002.91-.212A17.033 17.033 0 0125 56zm7-7a17.013 17.013 0 01-13.76-27 20.844 20.844 0 0023.764 23.76A16.899 16.899 0 0132 49zm7-7c-9.388 0-17-7.611-17-17 0-9.388 7.612-17 17-17 9.389 0 17 7.612 17 17-.01 9.384-7.616 16.99-17 17zm-3.604-21h7.64c.537 0 .79.252.79.725 0 1.105-.759 2.275-1.422 2.275h-7.825a8.15 8.15 0 00-.032 1.064c-.013.313-.002.625.032.936h7.355c.538 0 .79.252.79.725 0 1.105-.759 2.275-1.42 2.275h-6a5.205 5.205 0 005.083 3.534c.99-.052 1.968-.243 2.905-.568a7.068 7.068 0 011.673-.347c.728 0 1.106.347 1.106 1.01a3.448 3.448 0 01-1.453 2.936 9.671 9.671 0 01-4.545 1.01c-4.673 0-8.177-2.81-9.534-7.575h-1.231a.68.68 0 01-.442-.19 2.312 2.312 0 01-.98-1.483c0-.633 1.075-1.327 2.051-1.327h.28a6.194 6.194 0 01-.031-.936 8.15 8.15 0 01.031-1.064h-.47a.68.68 0 01-.443-.19 2.311 2.311 0 01-.98-1.483c0-.633 1.072-1.327 2.052-1.327h.442c1.643-4.64 5.398-7.514 9.786-7.514a9.385 9.385 0 015.116 1.483c.295.184.474.507.473.854a3.49 3.49 0 01-1.01 2.493 1.27 1.27 0 01-.885.412 1.308 1.308 0 01-.599-.19 6.65 6.65 0 00-3.22-1.01c-2.242 0-3.947 1.166-5.083 3.472z"
	  })));
	}

	var _path$2b, _path2$r, _path3$c;

	function _extends$2d() { _extends$2d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

	function SvgMoneyKrone(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2d({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
	    d: "M37.54 32.12c-.26 0-.56-.16-.86-.5l-5.54-5.6v3.92c0 1.1-.7 2.18-1.4 2.18s-1.38-1.22-1.38-1.6V19.18c0-.64 1.02-1.3 2-1.3.52 0 .78.24.78.72v4.46l4.86-4.5c.46-.42 1.1-.68 1.72-.68.54 0 .8.24.8.72 0 .74-.32 1.56-.86 2.04l-4.18 3.86 5.14 5.06c.12.12.18.28.18.5 0 1.04-.62 2.06-1.26 2.06z"
	  })), _path2$r || (_path2$r = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M49 32.12c-.3 0-.58-.2-.88-.6l-3.16-4.5h-1.78v2.92c0 1.1-.7 2.18-1.4 2.18s-1.38-1.26-1.38-1.6V19.3c0-.64 1.02-1.3 2-1.3h3.04c1.84 0 3.32.86 4.08 2.22.38.68.56 1.44.56 2.3 0 1.5-.88 2.92-2.38 3.8l2.42 3.3c.1.16.16.32.16.5 0 .98-.66 2-1.28 2zM43.18 20.6h2.18c1.18 0 2.02.82 2.02 1.94 0 1.06-.9 1.92-2.02 1.92h-2.18V20.6z"
	  })), _path3$c || (_path3$c = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M60 25a21 21 0 00-38.89-10.95h-.1a21 21 0 00-7 7A21 21 0 0025 60a21.09 21.09 0 0018-10.11 21 21 0 007-7A21 21 0 0060 25zM25 56a17 17 0 01-13.79-27 22.301 22.301 0 00-.21 3c0 11.598 9.402 21 21 21a21.678 21.678 0 002.91-.21A17.06 17.06 0 0125 56zM16.84 39.72A17 17 0 0032 49a16.9 16.9 0 0010-3.24A20.84 20.84 0 0118.24 22a17 17 0 00-1.399 17.72zM39 42c-9.389 0-17-7.611-17-17S29.61 8 39 8s17 7.611 17 17a17 17 0 01-17 17z"
	  })));
	}

	var _path$2c;

	function _extends$2e() { _extends$2e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

	function SvgMoreHorizontal(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2e({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M18 36a4 4 0 110-8 4 4 0 010 8zm10-4a4 4 0 108 0 4 4 0 00-8 0zm18 4a4 4 0 110-8 4 4 0 010 8z"
	  })));
	}

	var _path$2d;

	function _extends$2f() { _extends$2f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

	function SvgMoreVertical(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2f({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M28 18a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0z"
	  })));
	}

	var _path$2e;

	function _extends$2g() { _extends$2g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

	function SvgMusic(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2g({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52.491 10.872a3.986 3.986 0 00-3.391-.768l-22 5.077a3.981 3.981 0 00-3.1 3.897V38.84a9.755 9.755 0 00-5-1.353c-4.963 0-9 3.59-9 8 0 4.412 4.037 8 9 8s9-3.588 9-8V19.08l22-5.078v18.84a9.754 9.754 0 00-5-1.354c-4.963 0-9 3.59-9 8 0 4.412 4.037 8 9 8s9-3.588 9-8V14.001a3.977 3.977 0 00-1.509-3.129zM19 49.488c-2.757 0-5-1.794-5-4s2.243-4 5-4 5 1.794 5 4-2.243 4-5 4zm21-10c0 2.206 2.243 4 5 4s5-1.794 5-4-2.243-4-5-4-5 1.794-5 4z"
	  })));
	}

	var _path$2f;

	function _extends$2h() { _extends$2h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

	function SvgMute(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2h({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.428 11.676l1.749-2.137a2.167 2.167 0 10-3.354-2.744l-13.49 16.487v-9.885a4.333 4.333 0 00-7.397-3.064L18.103 21.167h-3.436A8.677 8.677 0 006 29.833v4.334a8.677 8.677 0 008.667 8.666h3.436l1.228 1.23-8.508 10.398a2.167 2.167 0 103.354 2.745l8.234-10.064 6.525 6.525a4.333 4.333 0 007.397-3.064V30.125l6.276-7.67A19.239 19.239 0 0145 32c.118 4.19-1.23 8.29-3.813 11.59a2.167 2.167 0 003.293 2.82A22.356 22.356 0 0049.333 32a23.054 23.054 0 00-3.832-13.079l3.11-3.803A28.806 28.806 0 0153.668 32c0 7.059-2.18 13.652-5.98 18.09a2.167 2.167 0 003.293 2.82C55.44 47.696 58 40.075 58 32c0-7.79-2.4-15.134-6.572-20.324zM19.898 38.5h-5.231a4.338 4.338 0 01-4.334-4.333v-4.334a4.338 4.338 0 014.334-4.333h5.23L32 13.397v15.181l-9.911 12.114-2.192-2.192zM32 50.603l-6.832-6.831L32 35.422v15.181z"
	  })));
	}

	var _path$2g;

	function _extends$2i() { _extends$2i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

	function SvgNetwork(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2i({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M53.95 39.964a5.95 5.95 0 00-3.159.909l-6.35-5.08c2.254-4.03 1.977-9-.712-12.754l4.17-4.17a8.02 8.02 0 10-2.825-2.826l-4.17 4.17a11.92 11.92 0 00-14.726.668l-10.57-8.809a6.014 6.014 0 10-2.559 3.07l10.572 8.809a11.774 11.774 0 00-1.435 8.182l-3.611 1.313a7.984 7.984 0 101.37 3.755l3.61-1.313a12.037 12.037 0 006.502 5.406l-1.127 6.759a5.99 5.99 0 103.942.655l1.125-6.747a11.925 11.925 0 007.94-3.054l6.356 5.085a5.99 5.99 0 105.656-4.028zM11.99 41.962a3.996 3.996 0 110-7.992 3.996 3.996 0 010 7.992zm39.96-33.966a3.996 3.996 0 110 7.992 3.996 3.996 0 010-7.992zM9.994 11.992a1.998 1.998 0 110-3.996 1.998 1.998 0 010 3.996zm19.98 43.956a1.998 1.998 0 110-3.996 1.998 1.998 0 010 3.996zm3.996-17.982a7.992 7.992 0 117.992-7.992 8.001 8.001 0 01-7.992 7.992zm19.98 9.99a1.998 1.998 0 110-3.996 1.998 1.998 0 010 3.996z"
	  })));
	}

	var _path$2h, _path2$s;

	function _extends$2j() { _extends$2j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

	function SvgNewContact(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2j({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32.007 37.992c8.835 0 15.996-7.162 15.996-15.996S40.842 6 32.007 6c-8.834 0-15.996 7.162-15.996 15.996 0 3.065.862 5.928 2.357 8.36a18.118 18.118 0 00-7.676 3.632c-2.006 1.623-3.664 3.72-4.905 6.18-.611 1.21-1.155 2.774-1.453 4.338-.159.833-.216 1.5-.272 2.837l-.048 1.249-.013.631c-.01.99.043 1.693.196 2.447l.052.23c.028.111.058.216.094.332l.12.373c.35 1.081.894 1.946 1.708 2.857.5.558.99.956 1.667 1.356.85.502 1.763.873 2.733 1.04l.226.036.238.029.604.056.301.02c.153.008.314.011.497.01l1.647-.029 1.022-.003 4.978.01h11.924a2 2 0 10-.002-4l-15.501-.003-1.788-.006-1.002.008-1.221.024-.334-.004-.646-.054-.19-.023a2.678 2.678 0 01-.074-.012c-.438-.075-.915-.269-1.378-.542-.33-.196-.5-.333-.72-.58-.471-.526-.726-.931-.885-1.424l-.11-.34-.041-.157c-.102-.498-.13-1.064-.109-2l.038-1.076.032-.719.03-.516c.035-.546.08-.916.155-1.309.226-1.188.648-2.399 1.095-3.285.992-1.966 2.296-3.614 3.85-4.872a14.096 14.096 0 017.692-3.071c.16-.013.315-.044.462-.092a15.936 15.936 0 0010.646 4.058zm0-4c-6.625 0-11.997-5.37-11.997-11.996S25.381 9.999 32.007 9.999c6.626 0 11.997 5.371 11.997 11.997 0 6.626-5.371 11.997-11.997 11.997z"
	  })), _path2$s || (_path2$s = /*#__PURE__*/React.createElement("path", {
	    d: "M48.003 33.993a2 2 0 00-2 2v7.997h-7.997a2 2 0 100 4h7.998v7.997a2 2 0 003.998 0V47.99H58a2 2 0 100-3.999h-7.998v-7.998a2 2 0 00-1.999-2z"
	  })));
	}

	var _path$2i, _path2$t;

	function _extends$2k() { _extends$2k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

	function SvgNewGroup(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2k({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M14.693 26.25C13.023 24.156 12 21.538 12 18.5 12 12.17 17.257 6 24 6c6.069 0 10.745 3.702 12.241 8.32 6.811.044 12.319 5.579 12.319 12.4 0 6.848-5.552 12.4-12.4 12.4-1.77 0-3.455-.371-4.979-1.04h-2.514c-2.185 0-4.825.9-6.902 2.523-2.059 1.608-3.365 3.755-3.365 6.192v2.965a2 2 0 002 2h14.72a2 2 0 010 4H20.4a6 6 0 01-6-6v-2.32H10a6 6 0 01-6-6v-2.965c0-3.992 2.16-7.202 4.902-9.344a16.4 16.4 0 015.79-2.88zM16 18.5c0-4.409 3.743-8.5 8-8.5 4.11 0 7.064 2.301 8.212 4.962-4.913 1.648-8.452 6.29-8.452 11.758 0 2.851.962 5.478 2.58 7.573-2.465.44-4.973 1.544-7.038 3.158-1.924 1.503-3.562 3.533-4.367 5.989H10a2 2 0 01-2-2v-2.965c0-2.437 1.307-4.584 3.365-6.192 2.077-1.623 4.717-2.523 6.902-2.523h.626a2 2 0 001.9-1.375 2 2 0 00-.684-2.55C17.58 24.15 16 21.64 16 18.5zm20.16-.18a8.4 8.4 0 100 16.8 8.4 8.4 0 000-16.8z"
	  })), _path2$t || (_path2$t = /*#__PURE__*/React.createElement("path", {
	    d: "M47.68 53.76a2 2 0 004 0v-6.32H58a2 2 0 100-4h-6.32v-6.32a2 2 0 10-4 0v6.32h-6.32a2 2 0 100 4h6.32v6.32z"
	  })));
	}

	var _path$2j;

	function _extends$2l() { _extends$2l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

	function SvgNews(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2l({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
	    d: "M36 36a2 2 0 01-2 2H18a2 2 0 010-4h16a2 2 0 012 2zm-2 6H18a2 2 0 000 4h16a2 2 0 000-4zm2-24v10a2 2 0 01-2 2H18a2 2 0 01-2-2V18a2 2 0 012-2h16a2 2 0 012 2zm-4 2H20v6h12v-6zm24 2v28a8.01 8.01 0 01-8 8H16a8.01 8.01 0 01-8-8V10a4.004 4.004 0 014-4h28a4.004 4.004 0 014 4v8h8a4.005 4.005 0 014 4zM41.083 54A7.94 7.94 0 0140 50V10H12v40a4.005 4.005 0 004 4h25.083zM52 22h-8v28a4 4 0 108 0V22z"
	  })));
	}

	var _path$2k;

	function _extends$2m() { _extends$2m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

	function SvgOffering(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2m({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
	    d: "M58.3 33.47a6.422 6.422 0 00-8.3-.613V26a4.004 4.004 0 004-4v-6a4.004 4.004 0 00-4-4h-2a7.989 7.989 0 00-14-5.274A7.989 7.989 0 0020 12h-2a4.004 4.004 0 00-4 4v6a4.005 4.005 0 004 4v8.09a3.97 3.97 0 00-2 1.082l-10 10a4.004 4.004 0 000 5.656L13.172 58a4.003 4.003 0 005.656 0l2-2h22.344A3.972 3.972 0 0046 54.828L58.3 42.53a6.412 6.412 0 000-9.058zM46 36.224l-2.282 1.957A6.01 6.01 0 0038 34h-2v-8h10v10.223zM50 16l.003 6H36v-6h14zM40 8a4.004 4.004 0 014 4h-8a4.004 4.004 0 014-4zM28 8a4.004 4.004 0 014 4h-8a4.004 4.004 0 014-4zm-10 8h14v6H18v-6zm14 10v8H22v-8h10zm23.47 13.701L43.173 52h-24L16 55.172 8.828 48l10-10H38a2 2 0 01.528 3.93c-.247.047-.497.07-.747.07H28a2 2 0 000 4h10a5.97 5.97 0 001.43-.173 8.01 8.01 0 003.556-1.753l9.217-7.9a2.405 2.405 0 013.267 3.527z"
	  })));
	}

	var _path$2l, _path2$u;

	function _extends$2n() { _extends$2n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

	function SvgOffshore(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2n({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 32h2a2 2 0 012 2v8a2 2 0 01-2 2h-8v6a2 2 0 01-4 0v-6H22v6a2 2 0 01-4 0v-6h-8a2 2 0 01-2-2v-8a2 2 0 012-2h6.39L8.3 19.06a2.003 2.003 0 113.4-2.12l8.44 13.5L22 9.82A2 2 0 0124 8h2a2 2 0 114 0h2a2 2 0 012 1.82l2 22c.005.06.005.12 0 .18h2v-6a6 6 0 016-6h6a2 2 0 012 2v10zm-9.414-7.414A2 2 0 0042 26v6h6v-8h-4a2 2 0 00-1.414.586zM30.53 16l-.36-4h-4.34l-.36 4h5.06zm.73 8l-.36-4h-5.8l-.36 4h6.52zm.74 8l-.37-4h-7.26L24 32h8zm-20 8h40v-4H12v4z"
	  })), _path2$u || (_path2$u = /*#__PURE__*/React.createElement("path", {
	    d: "M57.414 57.414A2 2 0 0058 56a2 2 0 00-2.07-2.07c-1.86 0-3.01-.82-4.26-3a2.873 2.873 0 00-.33-.43 2 2 0 00-1.85-.52l-.19.05-.19.07-.18.09a2.873 2.873 0 00-.43.33 2.07 2.07 0 00-.31.42c-1.26 2.19-2.4 3-4.26 3-1.86 0-3.01-.82-4.26-3a2.873 2.873 0 00-.33-.43 2.07 2.07 0 00-.42-.31l-.24-.11-.24-.08a1.19 1.19 0 00-.26 0 1.737 1.737 0 00-.51 0 2.449 2.449 0 00-.37.08 1.99 1.99 0 00-.36.16 2.873 2.873 0 00-.43.33 2.07 2.07 0 00-.31.42c-1.26 2.19-2.4 3-4.26 3-1.86 0-3.01-.82-4.26-3a2.078 2.078 0 00-.54-.6 1.999 1.999 0 00-1.79-.3 1.99 1.99 0 00-.36.16 2.873 2.873 0 00-.43.33 2.07 2.07 0 00-.31.42c-1.26 2.19-2.4 3-4.26 3-1.86 0-3.01-.82-4.26-3a1.999 1.999 0 00-.74-.75 1.99 1.99 0 00-.36-.16 2.323 2.323 0 00-.38-.08 1.737 1.737 0 00-.51 0 2.449 2.449 0 00-.37.08 2 2 0 00-1.11.9C11 53.19 9.86 54 8 54a2 2 0 100 4 7.86 7.86 0 006-2.59A7.86 7.86 0 0020 58a7.86 7.86 0 006-2.59A7.86 7.86 0 0032 58a7.86 7.86 0 006-2.59 8.24 8.24 0 0012 0A7.86 7.86 0 0056 58a2 2 0 001.414-.586z"
	  })));
	}

	var _path$2m;

	function _extends$2o() { _extends$2o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

	function SvgOptimization(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2o({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2m || (_path$2m = /*#__PURE__*/React.createElement("path", {
	    d: "M34.828 29.172a3.999 3.999 0 11-5.655 5.655 3.999 3.999 0 015.655-5.655zM48 32a16 16 0 11-16-16 16.018 16.018 0 0116 16zm-4 0a12 12 0 10-12 12 12.014 12.014 0 0012-12zm14 0A26 26 0 1132 6a26.03 26.03 0 0126 26zm-4 0a22 22 0 10-22 22 22.025 22.025 0 0022-22z"
	  })));
	}

	var _path$2n;

	function _extends$2p() { _extends$2p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

	function SvgOrgChart(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2p({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2n || (_path$2n = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M55.692 40.615h-6.461v-6.461a4.312 4.312 0 00-4.308-4.308h-10.77v-6.461h15.078a4.312 4.312 0 004.307-4.308V8.307A4.312 4.312 0 0049.231 4H14.769a4.312 4.312 0 00-4.308 4.308v10.769a4.312 4.312 0 004.308 4.308h15.077v6.461h-10.77a4.312 4.312 0 00-4.307 4.308v6.461H8.307A4.312 4.312 0 004 44.923v10.77A4.312 4.312 0 008.308 60h15.077a4.312 4.312 0 004.307-4.308V44.923a4.312 4.312 0 00-4.307-4.308h-4.309v-6.461h25.847v6.461h-4.308a4.312 4.312 0 00-4.307 4.308v10.77A4.312 4.312 0 0040.615 60h15.077A4.312 4.312 0 0060 55.692V44.923a4.312 4.312 0 00-4.308-4.308zM14.77 8.308h34.462v10.769H14.769V8.307zm8.616 47.384H8.308V44.923h15.077v10.77zm32.308 0H40.615V44.923h15.078v10.77z"
	  })));
	}

	var _path$2o;

	function _extends$2q() { _extends$2q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

	function SvgParentalGuide(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2o || (_path$2o = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56.745 39.273a16.597 16.597 0 00-12.667-16.096 13.473 13.473 0 10-24.41 0A16.597 16.597 0 007 39.273v4.145a8.3 8.3 0 008.29 8.291h8.292v2.073A6.225 6.225 0 0029.8 60h20.727a6.225 6.225 0 006.218-6.218v-2.073a8.228 8.228 0 00-1.152-4.195 8.026 8.026 0 001.152-4.096v-4.145zM31.873 8.183a9.327 9.327 0 11-9.328 9.326 9.337 9.337 0 019.327-9.327zM15.29 47.562a4.15 4.15 0 01-4.146-4.145v-4.145a12.451 12.451 0 0111.097-12.361 13.43 13.43 0 0019.261 0A12.451 12.451 0 0152.6 39.272v4.146c-.007.347-.063.69-.166 1.022a8.226 8.226 0 00-3.014-.96 9.327 9.327 0 10-18.513 0 8.297 8.297 0 00-6.204 4.084h-9.412zm30.054-5.181a5.182 5.182 0 11-10.363 0 5.182 5.182 0 0110.363 0zm7.255 11.4a2.075 2.075 0 01-2.073 2.073H29.8a2.075 2.075 0 01-2.073-2.073v-2.073a4.15 4.15 0 014.145-4.145h.541a9.318 9.318 0 0015.5 0h.541a4.15 4.15 0 014.146 4.145v2.073z"
	  })));
	}

	var _path$2p;

	function _extends$2r() { _extends$2r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

	function SvgPasswordInvisible(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2r({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2p || (_path$2p = /*#__PURE__*/React.createElement("path", {
	    d: "M49.128 19.836c-.432-.295-.868-.56-1.303-.833l5.59-5.59a2 2 0 10-2.83-2.827l-6.4 6.4A28.26 28.26 0 0032 14C16.919 14 4 28.582 4 32c0 2.103 4.898 8.434 12.178 12.993l-5.592 5.593a2 2 0 002.828 2.828l6.405-6.405A28.19 28.19 0 0032 49.999c15.081 0 28-14.581 28-18 0-2.477-5.182-8.275-10.872-12.163zM8.092 32C9.532 29.088 19.852 18 32 18a23.55 23.55 0 019.174 1.998l-2.232 2.232A11.98 11.98 0 0022.23 38.942l-3.157 3.157c-5.903-3.49-10.102-8.32-10.981-10.1zM40 32a7.985 7.985 0 01-12.056 6.883l6.378-6.378A1.996 1.996 0 0038.25 32c0-.957-.23-1.9-.673-2.75l1.307-1.306A7.939 7.939 0 0140 32zm-16 0a7.984 7.984 0 0112.056-6.884l-1.394 1.394A5.96 5.96 0 0032.25 26a1.995 1.995 0 00-.87 3.792l-6.264 6.263A7.94 7.94 0 0124 32zm8 14a23.5 23.5 0 01-9.175-1.997l2.233-2.233A11.981 11.981 0 0041.77 25.058l3.156-3.156c.7.415 1.353.832 1.945 1.236a32.512 32.512 0 019.032 8.873C54.441 34.941 44.133 46 32 46z"
	  })));
	}

	var _path$2q;

	function _extends$2s() { _extends$2s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

	function SvgPasswordVisible(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2s({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2q || (_path$2q = /*#__PURE__*/React.createElement("path", {
	    d: "M32 20a12 12 0 1012 12 12.013 12.013 0 00-12-12zm0 20a8 8 0 118-8 8.01 8.01 0 01-8 8zm6.25-8a2 2 0 01-4 0 2.003 2.003 0 00-2-2 2 2 0 010-4 6.006 6.006 0 016 6zm10.878-12.164C43.54 16.018 37.618 14 32 14 16.919 14 4 28.582 4 32c0 3.418 12.919 18 28 18s28-14.582 28-18c0-2.477-5.182-8.275-10.872-12.164zM32 46C19.852 46 9.531 34.912 8.092 32 9.532 29.088 19.852 18 32 18c6.075 0 11.44 2.794 14.871 5.139a32.513 32.513 0 019.032 8.873C54.441 34.942 44.133 46 32 46z"
	  })));
	}

	var _path$2r, _path2$v, _path3$d;

	function _extends$2t() { _extends$2t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

	function SvgPayMonthly(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2t({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2r || (_path$2r = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M4 12a8 8 0 018-8h40a8 8 0 018 8v40a8 8 0 01-8 8H12a8 8 0 01-8-8V12zm8-4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V12a4 4 0 00-4-4H12z"
	  })), _path2$v || (_path2$v = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M15.44 48.56a1.5 1.5 0 010-2.12l31-31a1.5 1.5 0 012.12 2.12l-31 31a1.5 1.5 0 01-2.12 0z"
	  })), _path3$d || (_path3$d = /*#__PURE__*/React.createElement("path", {
	    d: "M22.5 25.5c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.68c-.02-.08-.02-.28-.02-.58 0-.34 0-.56.02-.66h4.98c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.84c.72-1.46 1.8-2.2 3.22-2.2.62 0 1.3.22 2.04.64.14.08.28.12.38.12.18 0 .38-.08.56-.26.36-.32.64-.94.64-1.58 0-.22-.1-.4-.3-.54-.98-.62-2.06-.94-3.24-.94-2.78 0-5.16 1.82-6.2 4.76h-.28c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.24c-.02.1-.02.32-.02.66 0 .3 0 .5.02.58h-.12c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.78c.86 3.02 3.08 4.8 6.04 4.8 1.12 0 2.24-.26 2.88-.64.56-.34.92-1.08.92-1.86 0-.42-.24-.64-.7-.64-.22 0-.58.08-1.06.22-.78.24-1.4.36-1.84.36-1.5 0-2.58-.74-3.22-2.24h3.8zM39.744 48.696c.24.272.48.4.688.4.512 0 1.008-.816 1.008-1.648 0-.176-.048-.304-.144-.4L37.184 43l3.344-3.088c.432-.384.688-1.04.688-1.632 0-.384-.208-.576-.64-.576-.496 0-1.008.208-1.376.544l-3.888 3.6V38.28c0-.384-.208-.576-.624-.576-.784 0-1.6.528-1.6 1.04v9.072c0 .304.544 1.28 1.104 1.28s1.12-.864 1.12-1.744v-3.136l4.432 4.48zM49.369 48.696c.24.272.48.4.688.4.512 0 1.008-.816 1.008-1.648 0-.176-.048-.304-.144-.4L46.809 43l3.344-3.088c.432-.384.688-1.04.688-1.632 0-.384-.208-.576-.64-.576-.496 0-1.008.208-1.376.544l-3.888 3.6V38.28c0-.384-.208-.576-.624-.576-.784 0-1.6.528-1.6 1.04v9.072c0 .304.544 1.28 1.104 1.28s1.12-.864 1.12-1.744v-3.136l4.432 4.48z"
	  })));
	}

	var _path$2s;

	function _extends$2u() { _extends$2u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

	function SvgPayOnce(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2u({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2s || (_path$2s = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M3.963 10.97a7.003 7.003 0 017.007-7.007h41.986c3.87 0 7.007 3.13 7.007 7.007v41.985a7.004 7.004 0 01-7.007 7.008H10.97a7.004 7.004 0 01-7.007-7.008V10.97zm3.5 0v41.985a3.504 3.504 0 003.507 3.508h41.986a3.504 3.504 0 003.507-3.508V10.97a3.503 3.503 0 00-3.507-3.507H10.97a3.503 3.503 0 00-3.507 3.507zM28.22 36.176c1.159 2.704 3.103 4.055 5.83 4.055.796 0 1.907-.217 3.331-.65.87-.267 1.509-.4 1.92-.4.844 0 1.266.386 1.266 1.159 0 .7-.15 1.358-.452 1.974-.303.614-.706 1.08-1.214 1.394-.578.337-1.34.615-2.28.832-.942.218-1.92.326-2.934.326-2.678 0-4.978-.766-6.897-2.3-1.92-1.532-3.264-3.663-4.037-6.39h-1.411c-.17 0-.344-.066-.525-.199-.182-.133-.417-.368-.707-.705-.265-.339-.398-.677-.398-1.014 0-.363.253-.707.76-1.033.507-.325 1.038-.489 1.593-.489h.217c-.023-.144-.036-.494-.036-1.05 0-.627.013-1.025.036-1.194h-.434c-.17 0-.344-.067-.525-.2-.18-.132-.416-.367-.706-.706-.266-.337-.399-.675-.399-1.013 0-.362.255-.706.76-1.032a2.899 2.899 0 011.595-.489h.506c.941-2.655 2.42-4.755 4.436-6.3 2.016-1.544 4.278-2.317 6.788-2.317 2.125 0 4.08.567 5.865 1.701.363.242.544.567.544.978a4.02 4.02 0 01-.344 1.647c-.229.52-.507.93-.833 1.231-.326.302-.657.453-.995.453-.194 0-.423-.072-.689-.217-1.35-.772-2.583-1.159-3.692-1.159-2.583 0-4.527 1.328-5.83 3.983h8.763c.603 0 .904.278.904.833 0 .628-.175 1.218-.525 1.774-.35.555-.718.833-1.104.833h-9.016c-.023.169-.036.567-.036 1.194 0 .556.013.906.036 1.05h8.473c.604 0 .905.278.905.833 0 .628-.175 1.22-.525 1.775-.35.555-.718.832-1.104.832h-6.88z"
	  })));
	}

	var _path$2t;

	function _extends$2v() { _extends$2v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

	function SvgPaymentSuccess(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2v({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2t || (_path$2t = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56 30.836V16a8.01 8.01 0 00-8-8H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h18.302A14.997 14.997 0 1056 30.836zM12 12h36a4.004 4.004 0 014 4v2H8v-2a4.004 4.004 0 014-4zM8 36V22h44v5.743A14.97 14.97 0 0030.05 40H12a4.004 4.004 0 01-4-4zm37 16c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11c-.007 6.072-4.928 10.993-11 11zm6.664-13.89l-6 8.999a1.998 1.998 0 01-3.078.305l-4-4a2 2 0 112.828-2.828l2.275 2.274 4.647-6.97a2 2 0 113.328 2.22z"
	  })));
	}

	var _path$2u;

	function _extends$2w() { _extends$2w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

	function SvgPebble(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2w({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2u || (_path$2u = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59 17.517C59 7.476 51.703 4 43.638 4 26.739 4 6 15.2 6 29.49 6 40.69 20.978 60 32.116 60 42.87 60 59 42.234 59 17.517z"
	  })));
	}

	var _path$2v;

	function _extends$2x() { _extends$2x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

	function SvgPeopleHub(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2x({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2v || (_path$2v = /*#__PURE__*/React.createElement("path", {
	    d: "M53.999 40a5.979 5.979 0 00-4.293 1.817l-4.639-2.141a17.9 17.9 0 00-5.903-19.768l2.534-4.054a6.015 6.015 0 10-3.39-2.123l-2.536 4.059a17.967 17.967 0 00-21.208 28.148l-2.268 2.52a6.002 6.002 0 102.973 2.676l2.266-2.517A17.921 17.921 0 0043.38 43.3l4.647 2.145A6 6 0 1053.999 40zm-11-32a2 2 0 110 4 2 2 0 010-4zm-15 12a13.998 13.998 0 0112.89 19.462c-.079-.154-.143-.314-.229-.463a10.02 10.02 0 00-5.127-4.334 8 8 0 10-15.07-.007 10.043 10.043 0 00-5.359 4.793A14 14 0 0128 20zm0 16a4 4 0 110-8 4 4 0 010 8zm-18 20a2 2 0 110-4 2 2 0 010 4zm18-8a13.953 13.953 0 01-9.99-4.21 6.004 6.004 0 014.84-5.677 7.97 7.97 0 0010.288.01 5.94 5.94 0 014.848 5.67A13.953 13.953 0 0128 48zm26 0a2 2 0 110-4 2 2 0 010 4z"
	  })));
	}

	var _path$2w;

	function _extends$2y() { _extends$2y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

	function SvgPeople(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2w || (_path$2w = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M60.166 29.834V25.5a10.842 10.842 0 00-7.002-10.12 8.667 8.667 0 10-16.329 0A10.868 10.868 0 0032 19.028a10.87 10.87 0 00-4.836-3.648 8.667 8.667 0 10-16.329 0A10.842 10.842 0 003.833 25.5v4.334a6.507 6.507 0 006.5 6.5c.002.981.172 1.955.502 2.879a10.842 10.842 0 00-7.002 10.12v4.334a6.507 6.507 0 006.5 6.5h17.333A6.466 6.466 0 0032 58.498a6.466 6.466 0 004.333 1.669h17.333a6.507 6.507 0 006.5-6.5v-4.334a10.842 10.842 0 00-7.002-10.12c.33-.924.5-1.898.502-2.88a6.507 6.507 0 006.5-6.5zM45 8.166a4.333 4.333 0 110 8.667 4.333 4.333 0 010-8.667zm-26 0a4.333 4.333 0 110 8.667 4.333 4.333 0 010-8.667zm10.833 45.5a2.17 2.17 0 01-2.167 2.166H10.333a2.17 2.17 0 01-2.167-2.166v-4.334a6.508 6.508 0 015.255-6.377 8.634 8.634 0 0011.157 0 6.508 6.508 0 015.255 6.377v4.334zM14.666 36.334a4.333 4.333 0 118.667 0 4.333 4.333 0 01-8.667 0zm41.167 13v4.333a2.17 2.17 0 01-2.167 2.166H36.333a2.17 2.17 0 01-2.167-2.166v-4.334a6.509 6.509 0 015.255-6.377 8.634 8.634 0 0011.157 0 6.508 6.508 0 015.255 6.377zm-15.167-13a4.333 4.333 0 118.667 0 4.333 4.333 0 01-8.667 0zM52.494 32a8.655 8.655 0 00-15.659 7.213A10.868 10.868 0 0032 42.861a10.87 10.87 0 00-4.836-3.648A8.656 8.656 0 0011.506 32h-1.173a2.17 2.17 0 01-2.167-2.166V25.5a6.509 6.509 0 015.255-6.377 8.634 8.634 0 0011.157 0 6.509 6.509 0 015.255 6.377v4.334a2.167 2.167 0 004.333 0V25.5a6.509 6.509 0 015.255-6.377 8.634 8.634 0 0011.157 0 6.509 6.509 0 015.255 6.377v4.334A2.17 2.17 0 0153.666 32h-1.172z"
	  })));
	}

	var _path$2x;

	function _extends$2z() { _extends$2z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

	function SvgPhoneRecycling(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2x || (_path$2x = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46.655 50.135a2.053 2.053 0 114.106 0 2.053 2.053 0 01-4.106 0zM60 19.339v34.902a4.11 4.11 0 01-4.106 4.106H41.523a4.11 4.11 0 01-4.107-4.106V39.87a2.053 2.053 0 114.107 0v2.053h14.37V19.339h-14.37v4.106a2.053 2.053 0 01-4.107 0V19.34a4.11 4.11 0 014.107-4.106h14.37A4.11 4.11 0 0160 19.34zm-4.106 26.69H41.523v8.212h14.37V46.03zM37.444 29.62l-2.938-5.141a2.053 2.053 0 10-3.564 2.037l2.937 5.14h-7.93l.6-.6a2.053 2.053 0 10-2.902-2.904L19.54 32.26a2.032 2.032 0 00-.385.553 2.045 2.045 0 00-.174.488l-.004.013a2.054 2.054 0 00-.014.654c.02.18.064.357.13.526l.001.004.01.014c.069.159.159.308.266.444.03.038.058.074.09.11.028.032.05.067.08.097l4.106 4.106a2.053 2.053 0 002.903-2.903l-.602-.601h7.93a4.106 4.106 0 003.566-6.143zm-22.61 2.037H8.105l4.178-7.313.601 1.803a2.053 2.053 0 003.896-1.299l-2.053-6.16c-.015-.043-.038-.08-.055-.122a1.58 1.58 0 00-.194-.366 2.018 2.018 0 00-.112-.156 2.024 2.024 0 00-.153-.164c-.04-.04-.079-.079-.123-.115a2.07 2.07 0 00-.212-.152c-.028-.018-.051-.04-.08-.057-.013-.007-.026-.01-.038-.017a2.043 2.043 0 00-.253-.112c-.04-.016-.08-.034-.12-.047a2.013 2.013 0 00-.262-.058c-.043-.007-.086-.018-.13-.023a2.009 2.009 0 00-.25-.005c-.051 0-.101-.002-.151.003-.072.008-.144.02-.215.037-.064.013-.128.024-.19.043-.02.006-.04.007-.06.014l-6.159 2.053a2.053 2.053 0 001.3 3.895l1.06-.353-3.79 6.634a4.106 4.106 0 003.565 6.143h6.727a2.053 2.053 0 100-4.106zm9.922-15.966l-1.06-.354a2.053 2.053 0 10-1.3 3.896l6.159 2.053c.02.007.039.004.058.01.18.055.366.085.554.09.013 0 .025.006.038.006.009 0 .017-.004.026-.004.186-.003.37-.032.549-.086l.443-.181c.039-.022.07-.052.107-.076.04-.027.078-.054.116-.083.148-.11.282-.24.396-.386.007-.01.012-.022.02-.032.109-.153.196-.32.259-.496.008-.022.024-.038.031-.06l2.053-6.16a2.053 2.053 0 00-3.895-1.298l-.601 1.803-4.152-7.265a4.105 4.105 0 00-7.13 0l-2.91 5.093a2.053 2.053 0 003.565 2.037l2.91-5.093 3.764 6.586z"
	  })));
	}

	var _path$2y;

	function _extends$2A() { _extends$2A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

	function SvgPhoneRinging(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2A({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2y || (_path$2y = /*#__PURE__*/React.createElement("path", {
	    d: "M40.827 40a4.002 4.002 0 00-5.656 0L32 43.172 20.827 32 24 28.828a4.004 4.004 0 000-5.656L16.827 16a4.002 4.002 0 00-5.656 0L9.9 17.273a18.019 18.019 0 000 25.454L21.272 54.1a18.02 18.02 0 0025.455 0l1.272-1.272a4.004 4.004 0 000-5.656L40.827 40zM43.9 51.273a14.015 14.015 0 01-19.8 0L12.728 39.9a14.017 14.017 0 010-19.8l1.272-1.272L21.171 26 18 29.172a4.003 4.003 0 000 5.656L29.171 46a4.002 4.002 0 005.656 0L38 42.828 45.171 50 43.9 51.273zM57.999 30a2 2 0 01-4 0 20.022 20.022 0 00-20-20 2 2 0 110-4 24.027 24.027 0 0124 24zm-8 0a2 2 0 01-4 0 12.013 12.013 0 00-12-12 2 2 0 110-4 16.018 16.018 0 0116 16zm-16-4a2 2 0 110-4 8.009 8.009 0 018 8 2 2 0 01-4 0 4.005 4.005 0 00-4-4z"
	  })));
	}

	var _path$2z;

	function _extends$2B() { _extends$2B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

	function SvgPhone(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2B({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2z || (_path$2z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.742 44.261L49.681 35.2a4.54 4.54 0 00-6.273 0l-4.166 4.166a2.221 2.221 0 01-3.138.001l-11.47-11.471a2.216 2.216 0 010-3.136l4.167-4.167a4.442 4.442 0 000-6.272l-9.062-9.063a4.54 4.54 0 00-6.273 0l-3.629 3.63c-7.783 7.8-7.783 20.428 0 28.228l17.048 17.048c7.8 7.783 20.428 7.783 28.229 0l3.63-3.63a4.442 4.442 0 00-.002-6.272zm-6.765 6.766c-6.067 6.053-15.89 6.053-21.956 0L12.973 33.979c-6.053-6.067-6.053-15.89 0-21.956l3.63-3.63 9.061 9.063-4.166 4.166a6.652 6.652 0 000 9.41l11.47 11.472a6.664 6.664 0 009.41-.001l4.166-4.167 9.062 9.062-3.629 3.629z"
	  })));
	}

	var _path$2A;

	function _extends$2C() { _extends$2C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

	function SvgPieChart(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2C({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2A || (_path$2A = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M38.406 4.017a3.983 3.983 0 00-3.034 1.01 4.028 4.028 0 00-1.319 2.978v21.943H55.99a4.039 4.039 0 002.984-1.321 3.95 3.95 0 001.01-3.031c-1.127-11.418-10.16-20.451-21.578-21.58zm-.35 21.925l-.038-17.937a20.045 20.045 0 0117.974 17.937H38.055zm5.9 10.017H28.042V20.045a4.037 4.037 0 00-1.339-3 3.951 3.951 0 00-3.057-.992C12.236 17.299 3.693 27.095 4.008 38.568c.316 11.474 9.386 20.784 20.847 21.401.393.021.784.032 1.173.031 11.248.003 20.695-8.464 21.92-19.645a3.951 3.951 0 00-.992-3.057 4.037 4.037 0 00-3-1.34zM25.066 55.968c-9.368-.507-16.782-8.112-17.05-17.49-.27-9.377 6.697-17.395 16.02-18.437v15.918a4.011 4.011 0 004.008 4.007l15.922-.041c-1.06 9.508-9.346 16.543-18.9 16.043z"
	  })));
	}

	var _path$2B;

	function _extends$2D() { _extends$2D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

	function SvgPlane(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2D({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2B || (_path$2B = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M57.234 30.849l-7.428-4.727a13.913 13.913 0 00-7.481-2.178h-1.666l-10.8-10.877a2.071 2.071 0 00-.117-.109A3.983 3.983 0 0027.15 12h-2.886a3.98 3.98 0 00-3.927 4.636l1.218 7.308H16.94l-4.778-6.372a4.003 4.003 0 00-3.184-1.59H7.98A3.985 3.985 0 004 19.961v11.475a5.94 5.94 0 003.3 5.34l4.7 2.35a25.78 25.78 0 005.682 2.05l-3.1 4.34a3.98 3.98 0 003.239 6.295h5.402a4.009 4.009 0 002.444-.838l11.72-9.115h16.64a5.972 5.972 0 003.207-11.01zM24.265 15.98h2.877l7.907 7.963h-9.457l-1.327-7.963zm-1.042 31.85h-5.402l7.11-9.953 11.107-.016-.018.016h-.17v.133l-12.627 9.82zm32.716-11.388a1.923 1.923 0 01-1.911 1.435H40.004a4.05 4.05 0 00-.219-1.293 3.932 3.932 0 00-3.765-2.688H24.93a3.987 3.987 0 00-3.24 1.668l-1.459 2.043a21.778 21.778 0 01-6.45-2.041l-4.7-2.35a1.98 1.98 0 01-1.1-1.78V19.962h.996l4.778 6.372a4.003 4.003 0 003.184 1.59h25.386a9.94 9.94 0 015.343 1.557l7.428 4.727a1.923 1.923 0 01.843 2.235z"
	  })));
	}

	var _path$2C;

	function _extends$2E() { _extends$2E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

	function SvgPlay(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2E({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2C || (_path$2C = /*#__PURE__*/React.createElement("path", {
	    d: "M51.068 26.926L21.155 10.153A6 6 0 0012 15.257v33.486a5.922 5.922 0 003.104 5.254 5.926 5.926 0 006.051-.15l29.823-16.721.09-.053a6.001 6.001 0 000-10.147zm-2.1 6.74l-29.81 16.715-.09.052A2 2 0 0116 48.743V15.257a1.96 1.96 0 011.035-1.752c.3-.165.637-.253.98-.256.374.002.74.112 1.053.317l29.9 16.767a2 2 0 010 3.334z"
	  })));
	}

	var _path$2D;

	function _extends$2F() { _extends$2F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

	function SvgPlayerSettings(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2F({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2D || (_path$2D = /*#__PURE__*/React.createElement("path", {
	    d: "M52 12H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h4v5.586a2.999 2.999 0 005.121 2.121L28.828 48H52a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm4 28a4.005 4.005 0 01-4 4H27.172L20 51.172V44h-8a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.005 4.005 0 014 4v20zm-4-10a2 2 0 01-2 2H14a2 2 0 010-4h36a2 2 0 012 2zm-10 8a2 2 0 01-2 2H14a2 2 0 010-4h26a2 2 0 012 2z"
	  })));
	}

	var _path$2E;

	function _extends$2G() { _extends$2G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

	function SvgPlusMinus(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2G({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2E || (_path$2E = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M45 14.666H19c-9.573 0-17.333 7.76-17.333 17.333 0 9.573 7.76 17.334 17.333 17.334h26c9.573 0 17.334-7.76 17.334-17.334 0-9.573-7.76-17.333-17.334-17.333zm0 30.333H19c-7.18 0-13-5.82-13-13s5.82-13 13-13h26c7.18 0 13 5.82 13 13s-5.82 13-13 13zM27.667 32c0 1.197-.97 2.167-2.167 2.167H14.667a2.167 2.167 0 110-4.333H25.5c1.197 0 2.167.97 2.167 2.166zM51.5 32c0 1.197-.97 2.167-2.166 2.167h-3.25v3.25a2.167 2.167 0 01-4.334 0v-3.25H38.5a2.167 2.167 0 110-4.333h3.25v-3.25a2.167 2.167 0 014.334 0v3.25h3.25c1.196 0 2.166.97 2.166 2.166z"
	  })));
	}

	var _path$2F, _path2$w;

	function _extends$2H() { _extends$2H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

	function SvgPlus(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2H({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2F || (_path$2F = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M34.167 52V13a2.167 2.167 0 10-4.334 0v39a2.167 2.167 0 104.334 0z"
	  })), _path2$w || (_path2$w = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M51.5 30h-39a2.167 2.167 0 100 4.333h39a2.167 2.167 0 100-4.333z"
	  })));
	}

	var _path$2G, _path2$x;

	function _extends$2I() { _extends$2I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

	function SvgPolice(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2I({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2G || (_path$2G = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M38.36 41.78a2.1 2.1 0 01-.94-.23L32 38.7l-5.42 2.85a2 2 0 01-2.11-.15 2 2 0 01-.8-2l1-6-4.39-4.28a2 2 0 011.11-3.41l6.06-.88 2.72-5.5a2 2 0 013.58 0l2.72 5.5 6.06.88a2 2 0 011.11 3.41l-4.35 4.28 1 6a2 2 0 01-2 2.34l.07.04zM32 34.44a1.91 1.91 0 01.93.23l2.77 1.45-.53-3.12a2 2 0 01.58-1.77L38 29.09l-3.1-.45a2 2 0 01-1.51-1.1L32 24.74l-1.38 2.8a2 2 0 01-1.51 1.1l-3.1.45 2.24 2.18a2 2 0 01.58 1.73l-.53 3.08 2.77-1.45c.29-.14.61-.206.93-.19z"
	  })), _path2$x || (_path2$x = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 57a1.837 1.837 0 01-.41 0C18.08 54.11 10 43.56 10 35c.097-2.94.499-5.863 1.2-8.72 1.11-5.3 1.68-8.66-.59-10.84a2 2 0 010-2.85l5-5a2 2 0 012.35-.36 13.21 13.21 0 0013.13 0 2 2 0 011.86 0 13.21 13.21 0 0013.13 0 2 2 0 012.35.36l5 5a2 2 0 010 2.85c-2.27 2.18-1.7 5.54-.59 10.84A42.42 42.42 0 0154 35c0 8.56-8.08 19.11-21.59 22a1.837 1.837 0 01-.41 0zM14.69 14.13c2.375 3.662 1.394 8.369.437 12.97l-.007.03A39.373 39.373 0 0014 35c0 6.73 6.87 15.43 18 18 11.13-2.52 18-11.22 18-18a39.367 39.367 0 00-1.12-7.9c-1-4.58-2-9.3.43-13l-2.72-2.71A16.89 16.89 0 0132 11.23a16.89 16.89 0 01-14.59.19l-2.72 2.71z"
	  })));
	}

	var _path$2H, _path2$y, _path3$e;

	function _extends$2J() { _extends$2J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

	function SvgPortal(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2J({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2H || (_path$2H = /*#__PURE__*/React.createElement("path", {
	    d: "M13 17.707c0 .85-.672 1.54-1.5 1.54s-1.5-.69-1.5-1.54c0-.85.672-1.54 1.5-1.54s1.5.69 1.5 1.54zM18 17.707c0 .85-.672 1.54-1.5 1.54s-1.5-.69-1.5-1.54c0-.85.672-1.54 1.5-1.54s1.5.69 1.5 1.54z"
	  })), _path2$y || (_path2$y = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8 11a4 4 0 00-4 4v34a4 4 0 004 4h48a4 4 0 004-4V15a4 4 0 00-4-4H8zm0 4h48v5.64H8V15zm0 9.64V49h48V24.64H8z"
	  })), _path3$e || (_path3$e = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 26a7 7 0 00-6.386 9.872A6.998 6.998 0 0022 42v1a4 4 0 004 4h12a4 4 0 004-4v-1a6.998 6.998 0 00-3.614-6.128A7 7 0 0032 26zm-3 7a3 3 0 116 0 3 3 0 01-6 0zm6.53 6.047A6.968 6.968 0 0132 40a6.968 6.968 0 01-3.53-.953A3 3 0 0026 42v1h12v-1a3 3 0 00-2.47-2.953z"
	  })));
	}

	var _path$2I, _path2$z;

	function _extends$2K() { _extends$2K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

	function SvgPremisesDatacenter(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2K({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2I || (_path$2I = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M14 10a4 4 0 00-4 4v36a4 4 0 004 4h36a4 4 0 004-4V14a4 4 0 00-4-4H14zm0 4h36v36H38v-9a2 2 0 00-2-2h-8a2 2 0 00-2 2v9H14V14zm16 36h4v-7h-4v7z"
	  })), _path2$z || (_path2$z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M20 23a2 2 0 012-2h20a2 2 0 110 4H22a2 2 0 01-2-2zM20 32a2 2 0 012-2h20a2 2 0 110 4H22a2 2 0 01-2-2z"
	  })));
	}

	var _path$2J, _path2$A, _path3$f;

	function _extends$2L() { _extends$2L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

	function SvgPremisesLarge(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2L({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2J || (_path$2J = /*#__PURE__*/React.createElement("path", {
	    d: "M16 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM30 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
	  })), _path2$A || (_path2$A = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8 8a4 4 0 014-4h26a4 4 0 014 4v9.01c.166-.007.333-.01.5-.01C49.956 17 56 23.044 56 30.5S49.956 44 42.5 44c-.167 0-.334-.003-.5-.01V56a4 4 0 01-4 4H12a4 4 0 01-4-4V8zm30 35.232c-5.243-1.853-9-6.854-9-12.732 0-5.878 3.757-10.879 9-12.732V8H12v48h7v-9a2 2 0 012-2h8a2 2 0 012 2v9h7V43.232zM27 56h-4v-7h4v7zm6-25.5a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z"
	  })), _path3$f || (_path3$f = /*#__PURE__*/React.createElement("path", {
	    d: "M45.022 35c.14 0 .28-.07.434-.196.28-.266.504-.77.504-1.274 0-.322-.168-.49-.518-.49h-3.64v-7.42c0-.336-.182-.504-.546-.504-.686 0-1.4.462-1.4.91v7.854c0 .266.476 1.12.966 1.12h4.2z"
	  })));
	}

	var _path$2K, _path2$B, _path3$g;

	function _extends$2M() { _extends$2M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

	function SvgPremisesMedium(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2M({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2K || (_path$2K = /*#__PURE__*/React.createElement("path", {
	    d: "M16 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM30 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
	  })), _path2$B || (_path2$B = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8 8a4 4 0 014-4h26a4 4 0 014 4v9.01c.166-.007.333-.01.5-.01C49.956 17 56 23.044 56 30.5S49.956 44 42.5 44c-.167 0-.334-.003-.5-.01V56a4 4 0 01-4 4H12a4 4 0 01-4-4V8zm30 35.232c-5.243-1.853-9-6.854-9-12.732 0-5.878 3.757-10.879 9-12.732V8H12v48h7v-9a2 2 0 012-2h8a2 2 0 012 2v9h7V43.232zM27 56h-4v-7h4v7zm6-25.5a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z"
	  })), _path3$g || (_path3$g = /*#__PURE__*/React.createElement("path", {
	    d: "M45.647 33.992c0 .294.49 1.092.938 1.092.154 0 .294-.07.448-.21.28-.266.504-.77.504-1.274v-7.994c0-.322-.196-.49-.532-.49h-.896c-.56 0-1.148.308-1.33.7l-2.184 4.704-2.492-5.124c-.084-.182-.252-.28-.518-.28h-.77c-.672 0-1.358.448-1.358.882v7.994c0 .294.434 1.092.938 1.092.154 0 .294-.07.448-.21.28-.266.504-.77.504-1.274v-5.684l2.044 4.102c.084.168.154.294.224.364.238.308.49.462.728.462h.49c.294 0 .532-.21.742-.616l2.072-4.312v6.076z"
	  })));
	}

	var _path$2L, _path2$C, _path3$h;

	function _extends$2N() { _extends$2N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }

	function SvgPremisesSmall(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2N({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2L || (_path$2L = /*#__PURE__*/React.createElement("path", {
	    d: "M16 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM16 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM30 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
	  })), _path2$C || (_path2$C = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8 8a4 4 0 014-4h26a4 4 0 014 4v9.01c.166-.007.333-.01.5-.01C49.956 17 56 23.044 56 30.5S49.956 44 42.5 44c-.167 0-.334-.003-.5-.01V56a4 4 0 01-4 4H12a4 4 0 01-4-4V8zm30 35.232c-5.243-1.853-9-6.854-9-12.732 0-5.878 3.757-10.879 9-12.732V8H12v48h7v-9a2 2 0 012-2h8a2 2 0 012 2v9h7V43.232zM27 56h-4v-7h4v7zm6-25.5a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z"
	  })), _path3$h || (_path3$h = /*#__PURE__*/React.createElement("path", {
	    d: "M46.071 32.256c0-1.456-.798-2.394-2.59-3.066-.686-.266-1.176-.462-1.47-.616-.588-.28-.756-.49-.756-.868 0-.504.574-.854 1.372-.854.504 0 1.064.182 1.68.546.14.084.252.126.35.126.434 0 .854-.658.854-1.33a.458.458 0 00-.21-.406 4.651 4.651 0 00-2.604-.798 3.97 3.97 0 00-1.68.35c-1.022.462-1.722 1.358-1.722 2.408 0 1.386.798 2.184 2.87 2.954.742.266 1.246.518 1.526.742.28.224.42.504.42.826 0 .63-.602 1.036-1.512 1.036-.77 0-1.358-.28-1.988-.994a.538.538 0 00-.406-.154c-.63 0-1.274.42-1.274.826 0 .112.056.266.168.448.182.322.462.616.826.882.728.532 1.722.896 2.674.896.63 0 1.204-.126 1.736-.378 1.05-.49 1.736-1.442 1.736-2.576z"
	  })));
	}

	var _path$2M, _path2$D;

	function _extends$2O() { _extends$2O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }

	function SvgPremises(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2O({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2M || (_path$2M = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M19 4a4 4 0 00-4 4v48a4 4 0 004 4h26a4 4 0 004-4V8a4 4 0 00-4-4H19zm0 4h26v48h-6v-9a2 2 0 00-2-2H27a2 2 0 00-2 2v9h-6V8zm10 48h6v-7h-6v7z"
	  })), _path2$D || (_path2$D = /*#__PURE__*/React.createElement("path", {
	    d: "M23 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM23 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM37 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM30 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM37 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM30 22a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM37 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM30 29a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM37 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zM30 36a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
	  })));
	}

	var _path$2N;

	function _extends$2P() { _extends$2P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }

	function SvgPresent(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2P({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2N || (_path$2N = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56 17h-8.061A8.99 8.99 0 0032 10.356 8.993 8.993 0 0016.056 17H8a3.848 3.848 0 00-4 3.668v6.666A3.848 3.848 0 008 31v18a8.01 8.01 0 008 8h32a8.01 8.01 0 008-8V31a3.848 3.848 0 004-3.666v-6.666A3.848 3.848 0 0056 17zm-17-6a4.972 4.972 0 014.893 6h-9.781A4.953 4.953 0 0139 11zm-19 5a5 5 0 119.889 1h-9.784A5.03 5.03 0 0120 16zm10 5v6H8v-6h22zM12 49V31h18v22H16a4.004 4.004 0 01-4-4zm40 0a4.004 4.004 0 01-4 4H34V31h18v18zM34 27v-6h22v6H34z"
	  })));
	}

	var _path$2O;

	function _extends$2Q() { _extends$2Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }

	function SvgPressButton(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2Q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2O || (_path$2O = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46.06 30.964a6.186 6.186 0 00-2.293.437 6.246 6.246 0 00-2.986-3.799 14.514 14.514 0 10-17.535 4.028v2.607a6.335 6.335 0 00-7.173-2.218 6.224 6.224 0 00-3.454 8.546l7.123 14.746A8.34 8.34 0 0027.212 60h16.774a8.306 8.306 0 008.296-8.296V37.186a6.229 6.229 0 00-6.222-6.222zM19.098 18.519a10.37 10.37 0 1116.592 8.296v-8.117a6.368 6.368 0 00-5.618-6.372 6.223 6.223 0 00-6.826 6.193v8.296a10.392 10.392 0 01-4.148-8.296zm29.037 33.185a4.152 4.152 0 01-4.148 4.148H27.212a4.17 4.17 0 01-3.736-2.344L16.354 38.76a2.077 2.077 0 011.16-2.852 1.85 1.85 0 01.646-.115 2.287 2.287 0 012.008 1.324l2.472 5.118a2.075 2.075 0 001.867 1.172h.813a2.074 2.074 0 002.074-2.074V18.519a2.073 2.073 0 012.285-2.063 2.19 2.19 0 011.863 2.242v14.34a2.074 2.074 0 004.148 0 2.074 2.074 0 114.148 0v4.148a2.074 2.074 0 104.148 0 2.074 2.074 0 114.149 0v14.518z"
	  })));
	}

	var _path$2P;

	function _extends$2R() { _extends$2R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }

	function SvgPrice(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2R({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2P || (_path$2P = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.72 13.42A4 4 0 0055.66 12h-3.827V8a4.004 4.004 0 00-4-4h-32a4.004 4.004 0 00-4 4v4H8.006a4.006 4.006 0 00-3.952 4.661 16.097 16.097 0 0010.28 12.35 20.414 20.414 0 0011.5 10.009V42c.002.1.012.199.03.297a1.99 1.99 0 00-.024.23 18.937 18.937 0 00-11.39 12.347A4.004 4.004 0 0018.297 60H45.37a4.003 4.003 0 003.846-5.125 18.903 18.903 0 00-11.383-12.338 1.965 1.965 0 00-.027-.268c.015-.09.024-.179.027-.269v-2.981a20.2 20.2 0 0011.48-10.001 16.096 16.096 0 0010.3-12.357 3.985 3.985 0 00-.894-3.241zM8.001 16h3.831v2.741c0 .688.037 1.37.098 2.047.005.059.008.118.014.177.06.615.152 1.224.263 1.83.022.123.043.246.067.369l.03.162A12.01 12.01 0 018.002 16zM45.37 56l-27.084.006a14.874 14.874 0 018.916-9.719 4 4 0 002.631-3.75 1.992 1.992 0 00-.027-.27c.015-.088.024-.177.027-.267v-2.108a17.84 17.84 0 004-.01V42c.003.09.012.18.027.269a1.982 1.982 0 00-.027.268 3.997 3.997 0 002.63 3.75A14.843 14.843 0 0145.37 56zm2.463-37.26a18.156 18.156 0 01-1.742 7.796A15.85 15.85 0 0131.833 36a15.933 15.933 0 01-14.279-9.516 18.387 18.387 0 01-.789-1.994c-.157-.475-.29-.956-.407-1.44-.04-.166-.083-.33-.118-.496a18.067 18.067 0 01-.228-1.377c-.024-.177-.057-.35-.075-.529a18.538 18.538 0 01-.104-1.9V8h32v10.74zm3.529 4.586c.035-.166.06-.334.091-.5.032-.175.067-.349.095-.524.036-.223.064-.448.093-.673.022-.168.047-.334.065-.502.027-.257.045-.515.063-.773.01-.138.025-.275.032-.413.021-.399.032-.799.032-1.2V16h3.828l.006.001a12.018 12.018 0 01-4.305 7.325zM24.596 16.95a2.292 2.292 0 01-.431-1.065c0-.536.45-1.016 1.352-1.438l5.928-2.677c.4-.172.83-.26 1.266-.259.749 0 1.123.346 1.123 1.036v16.317a3.893 3.893 0 01-.633 2.159c-.26.543-.783.913-1.382.978-.48 0-.978-.374-1.496-1.122a2.42 2.42 0 01-.49-1.18V16.316l-3.395 1.554c-.144.07-.3.11-.46.115-.48 0-.94-.345-1.382-1.036z"
	  })));
	}

	var _path$2Q, _path2$E;

	function _extends$2S() { _extends$2S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }

	function SvgPrint(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2S({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2Q || (_path$2Q = /*#__PURE__*/React.createElement("path", {
	    d: "M22 42a2 2 0 012-2h16a2 2 0 110 4H24a2 2 0 01-2-2zM24 47a2 2 0 100 4h16a2 2 0 100-4H24z"
	  })), _path2$E || (_path2$E = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56 25h-4v-6.172A4 4 0 0050.828 16L40 5.172A4 4 0 0037.172 4H20a8 8 0 00-8 8v13H8a4 4 0 00-4 4v17a4 4 0 004 4h4v6a4 4 0 004 4h28a8 8 0 008-8v-2h4a4 4 0 004-4V29a4 4 0 00-4-4zM16 12a4 4 0 014-4h16v8a4 4 0 004 4h8v5H16V12zm24 4v-5.172L45.172 16H40zM12 46H8V29h48v17h-4V33H12v13zm4-9v19h28a4 4 0 004-4V37H16z"
	  })));
	}

	var _path$2R;

	function _extends$2T() { _extends$2T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }

	function SvgPulse(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2T({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2R || (_path$2R = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M17.252 21.029c.818-1.472 2.951-1.324 3.587.184l.058.155 4.562 13.685 2.793-5.024a2 2 0 011.582-1.022L30 29h24a2 2 0 01.15 3.995L54 33H31.176l-4.428 7.972c-.818 1.472-2.951 1.323-3.587-.184l-.058-.155-4.563-13.687-2.792 5.026a2 2 0 01-1.582 1.021L14 33h-4a2 2 0 01-.15-3.994L10 29h2.822l4.43-7.971z"
	  })));
	}

	var _path$2S;

	function _extends$2U() { _extends$2U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }

	function SvgQuestionFilled(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2U({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2S || (_path$2S = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M4 32C4 16.536 16.536 4 32 4c15.457.017 27.983 12.543 28 28 0 15.464-12.536 28-28 28S4 47.464 4 32zm32.311.906l-4.369 4.666c-.551.551-1.018.806-1.484.806-.721 0-1.4-.51-2.036-1.485-.424-.72-.636-1.272-.636-1.611 0-.34.17-.679.466-1.06l4.114-4.37c1.91-2.078 2.715-3.477 2.715-4.962 0-1.696-1.4-2.969-3.308-2.969-1.654 0-2.884.764-4.708 2.8-.467.509-.806.848-1.018 1.017-.255.17-.51.255-.764.255-1.357 0-2.587-2.29-2.587-3.011 0-.297.127-.68.424-1.103l.138-.202c2.055-2.936 5.498-4.76 9.024-4.76 3.35 0 6.022 1.441 7.422 3.732.721 1.145 1.06 2.46 1.06 3.86 0 2.555-1.009 4.607-4.029 7.935l-.424.462zM27.659 43.68c0 1.06 1.569 3.817 3.223 3.817.551 0 1.06-.255 1.57-.721 1.017-.933 1.823-2.715 1.823-4.454 0-1.145-.636-1.696-1.866-1.696-2.333 0-4.75 1.57-4.75 3.054z"
	  })));
	}

	var _path$2T, _path2$F;

	function _extends$2V() { _extends$2V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }

	function SvgQuestion(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2V({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2T || (_path$2T = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm0 51.692C18.915 55.692 8.308 45.085 8.308 32S18.915 8.308 32 8.308 55.692 18.915 55.692 32C55.678 45.079 45.08 55.678 32 55.692z"
	  })), _path2$F || (_path2$F = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.942 37.572l4.369-4.665.424-.462c3.02-3.329 4.03-5.38 4.03-7.936 0-1.4-.34-2.715-1.06-3.86-1.4-2.29-4.073-3.732-7.423-3.732-3.525 0-6.97 1.824-9.024 4.76l-.138.202c-.297.424-.424.806-.424 1.103 0 .72 1.23 3.011 2.587 3.011.255 0 .51-.085.764-.254.212-.17.551-.51 1.018-1.018 1.823-2.036 3.053-2.8 4.708-2.8 1.908 0 3.308 1.273 3.308 2.97 0 1.484-.806 2.884-2.715 4.962l-4.114 4.369c-.297.381-.466.72-.466 1.06 0 .34.212.89.636 1.612.636.975 1.315 1.484 2.036 1.484.466 0 .933-.254 1.484-.806zm-1.06 9.925c-1.654 0-3.224-2.757-3.224-3.817 0-1.485 2.418-3.054 4.75-3.054 1.23 0 1.867.552 1.867 1.697 0 1.739-.806 3.52-1.824 4.453-.509.467-1.018.721-1.569.721z"
	  })));
	}

	var _path$2U, _path2$G, _path3$i;

	function _extends$2W() { _extends$2W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }

	function SvgRack(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2W({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2U || (_path$2U = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M18 13a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zM18 27a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zM18 41a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2z"
	  })), _path2$G || (_path2$G = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M20 4a8 8 0 00-8 8v40a8 8 0 008 8h24a8 8 0 008-8V12a8 8 0 00-8-8H20zm28 42V36H16v10h32zm-32 4v2a4 4 0 004 4h24a4 4 0 004-4v-2H16zm32-28v10H16V22h32zM16 12a4 4 0 014-4h24a4 4 0 014 4v6H16v-6z"
	  })), _path3$i || (_path3$i = /*#__PURE__*/React.createElement("path", {
	    d: "M38 13a2 2 0 11-4 0 2 2 0 014 0zM38 27a2 2 0 11-4 0 2 2 0 014 0zM38 41a2 2 0 11-4 0 2 2 0 014 0zM44 13a2 2 0 11-4 0 2 2 0 014 0zM44 27a2 2 0 11-4 0 2 2 0 014 0zM44 41a2 2 0 11-4 0 2 2 0 014 0z"
	  })));
	}

	var _path$2V, _path2$H;

	function _extends$2X() { _extends$2X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }

	function SvgRecord(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2X({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2V || (_path$2V = /*#__PURE__*/React.createElement("path", {
	    d: "M37 32a5 5 0 11-10 0 5 5 0 0110 0z"
	  })), _path2$H || (_path2$H = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M16.444 55.281A28 28 0 1047.556 8.717a28 28 0 00-31.112 46.564zm2.222-43.236a24 24 0 1126.668 39.911 24 24 0 01-26.668-39.911z"
	  })));
	}

	var _path$2W;

	function _extends$2Y() { _extends$2Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }

	function SvgRecycle(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2Y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2W || (_path$2W = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56.513 49.367a8.585 8.585 0 01-7.486 4.3h-9.63l2.802 2.801a2.167 2.167 0 01-3.064 3.064l-6.5-6.5c-.032-.032-.055-.07-.084-.103a2.152 2.152 0 01-.094-.115 2.147 2.147 0 01-.285-.474l-.007-.01v-.004a2.159 2.159 0 01-.151-.688 2.173 2.173 0 01.028-.558l.004-.014a2.152 2.152 0 01.247-.635c.093-.169.208-.325.342-.463l6.5-6.5a2.167 2.167 0 113.064 3.064l-2.801 2.802h9.629a4.333 4.333 0 003.773-6.466l-5.54-9.801a2.167 2.167 0 013.772-2.133l5.54 9.802a8.586 8.586 0 01-.059 8.631zm-36.6-26.314a2.166 2.166 0 002.952-.82l5.363-9.489a4.334 4.334 0 017.545 0l5.985 10.59H38.5a2.167 2.167 0 100 4.333h8.667c1.196 0 2.166-.97 2.166-2.167v-8.667a2.167 2.167 0 10-4.333 0v3.43l-5.455-9.652a8.668 8.668 0 00-15.09.001l-5.363 9.489a2.168 2.168 0 00.82 2.952zm7.754 26.28H14.973a4.333 4.333 0 01-3.772-6.465l5.632-9.964v3.43a2.167 2.167 0 104.334 0v-8.668c0-1.196-.97-2.166-2.167-2.166h-8.667a2.167 2.167 0 100 4.333h3.258L7.428 40.735a8.667 8.667 0 007.545 12.931h12.694a2.167 2.167 0 100-4.333z"
	  })));
	}

	var _path$2X;

	function _extends$2Z() { _extends$2Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }

	function SvgRefillCard(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2Z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2X || (_path$2X = /*#__PURE__*/React.createElement("path", {
	    d: "M49.657 16.828L39.172 6.344A7.95 7.95 0 0033.515 4H20a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h24a8.009 8.009 0 008-8V22.485a7.953 7.953 0 00-2.343-5.657zM48 52a4.004 4.004 0 01-4 4H20a4.004 4.004 0 01-4-4V12a4.004 4.004 0 014-4h13.515a3.972 3.972 0 012.828 1.172l10.485 10.484A3.975 3.975 0 0148 22.486V52zm-4-14a12 12 0 11-12-12h1.172l-2.586-2.586a2 2 0 012.828-2.828l6 6a1.999 1.999 0 010 2.828l-6 6a2 2 0 01-2.828-2.828L33.172 30H32a8 8 0 108 8 2 2 0 014 0z"
	  })));
	}

	var _path$2Y, _path2$I;

	function _extends$2_() { _extends$2_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }

	function SvgRegister(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2_({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2Y || (_path$2Y = /*#__PURE__*/React.createElement("path", {
	    d: "M42 60H14a4 4 0 01-4-4V12a8.009 8.009 0 018-8h28a4 4 0 014 4v15.025a2 2 0 01-4 0V8H18a4 4 0 00-4 4v44h28a4.011 4.011 0 003.459-2 2 2 0 013.463 2A8.026 8.026 0 0142 60z"
	  })), _path2$I || (_path2$I = /*#__PURE__*/React.createElement("path", {
	    d: "M40.865 31.555c-.405-3.453-1.748-5.989-3.93-7.583a8 8 0 10-13.87 0c-2.182 1.594-3.525 4.131-3.93 7.585a3.967 3.967 0 00.98 3.1 4.013 4.013 0 003 1.347h13.772a4.013 4.013 0 003.821-2.793 3.969 3.969 0 00.157-1.656zM30 16a4 4 0 110 8 4 4 0 010-8zm-6.887 16l-.006.021c.3-2.571 1.2-4.233 2.819-5.148a7.924 7.924 0 008.148 0c1.623.914 2.515 2.571 2.813 5.128L23.113 32zM39.626 52.367a4 4 0 01-3.9-4.869l1.193-5.363A3.988 3.988 0 0138 40.174L50.172 28a4 4 0 015.656 0L60 32.172a4 4 0 010 5.656L47.826 50a4 4 0 01-1.963 1.077L40.5 52.271c-.287.063-.58.096-.874.096zm1.2-9.367l-1.192 5.363L45 47.174 57.172 35 53 30.828 40.826 43zM31 47H21a2 2 0 010-4h10a2 2 0 010 4z"
	  })));
	}

	var _path$2Z;

	function _extends$2$() { _extends$2$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }

	function SvgRemoteControl(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$2$({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2Z || (_path$2Z = /*#__PURE__*/React.createElement("path", {
	    d: "M17.997 40a2 2 0 114 0 2 2 0 01-4 0zm-2 2a2 2 0 100 4 2 2 0 000-4zm8 0a2 2 0 100 4 2 2 0 000-4zm-4 4a2 2 0 100 4 2 2 0 000-4zm18-14a6 6 0 11-6-6 6.006 6.006 0 016 6zm-4 0a2 2 0 10-4 0 2 2 0 004 0zm10-28a2 2 0 000 4 12.013 12.013 0 0112 12 2 2 0 004 0 16.018 16.018 0 00-16-16zm0 8a2 2 0 000 4 4.004 4.004 0 014 4 2 2 0 004 0 8.01 8.01 0 00-8-8zm1.672 12.844a8.008 8.008 0 010 11.312L25.41 56.414A12.607 12.607 0 017.583 38.586L27.84 18.328a8.008 8.008 0 0111.312 0l6.516 6.516zm-2.828 2.828l-6.516-6.516a4.006 4.006 0 00-5.656 0L10.41 41.414a8.607 8.607 0 0012.172 12.172L42.84 33.328a4.004 4.004 0 000-5.656z"
	  })));
	}

	var _path$2_;

	function _extends$30() { _extends$30 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }

	function SvgRepair(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$30({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2_ || (_path$2_ = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59.404 15.753a4.002 4.002 0 00-6.687-1.75L45.37 21.35a2.042 2.042 0 01-3.13-.294 2.195 2.195 0 01.408-2.753l7.097-7.097a4.023 4.023 0 001.03-3.9 3.925 3.925 0 00-2.839-2.801 15.974 15.974 0 00-19.296 20.01L6.35 46.758a7.847 7.847 0 00-.674 10.446A7.693 7.693 0 0011.588 60c2.03 0 3.978-.807 5.416-2.24l22.464-22.418a15.962 15.962 0 0020.324-12.883 16.084 16.084 0 00-.388-6.706zm-3.566 6.113a11.966 11.966 0 01-16.181 9.317l-1.213-.47L14.177 54.93a3.696 3.696 0 01-2.761 1.067 3.637 3.637 0 01-2.656-1.338 3.818 3.818 0 01.417-5.07L33.27 25.543l-.47-1.216a11.972 11.972 0 0114.117-15.95l-7.097 7.097a6.148 6.148 0 00-.85 7.884 6.04 6.04 0 009.228.819l7.348-7.369.002.006c.45 1.645.55 3.366.29 5.05zM13.983 52a2 2 0 11-4 0 2 2 0 014 0z"
	  })));
	}

	var _path$2$, _path2$J, _path3$j;

	function _extends$31() { _extends$31 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }

	function SvgReport(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$31({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$2$ || (_path$2$ = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M20 4a8 8 0 00-8 8v44a4 4 0 004 4h28a8 8 0 008-8V18.276a4 4 0 00-1.046-2.697L41.572 5.303A4 4 0 0038.618 4H20zm-4 8a4 4 0 014-4h17v8a4 4 0 004 4h7v32a4 4 0 01-4 4H16V12zm29.922 4L41 10.609V16h4.922z"
	  })), _path2$J || (_path2$J = /*#__PURE__*/React.createElement("path", {
	    d: "M24 28a2 2 0 10-4 0v20a2 2 0 002 2h20a2 2 0 100-4H24V28z"
	  })), _path3$j || (_path3$j = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M43.087 28.82a2 2 0 01.592 2.767l-5.5 8.5a2 2 0 01-2.996.418l-2.444-2.139-3.191 3.9a2 2 0 11-3.096-2.532l4.5-5.5a2 2 0 012.865-.24l2.26 1.978 4.244-6.559a2 2 0 012.766-.592z"
	  })));
	}

	var _path$30;

	function _extends$32() { _extends$32 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }

	function SvgReservation(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$32({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$30 || (_path$30 = /*#__PURE__*/React.createElement("path", {
	    d: "M32 8c7.495 0 13.316 2.145 17.586 6.414C53.856 18.684 56 24.504 56 32a2 2 0 104 0c0-8.505-2.522-15.35-7.586-20.414C47.35 6.522 40.504 4 32 4a2 2 0 100 4zM17 14a3 3 0 11-6 0 3 3 0 016 0zM7 35a3 3 0 100-6 3 3 0 000 6zM17 50a3 3 0 11-6 0 3 3 0 016 0zM50 53a3 3 0 100-6 3 3 0 000 6zM32 60a3 3 0 100-6 3 3 0 000 6zM34 25v7h12a2 2 0 110 4H32a2 2 0 01-2-2v-9a2 2 0 114 0z"
	  })));
	}

	var _path$31;

	function _extends$33() { _extends$33 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }

	function SvgReverse(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$33({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$31 || (_path$31 = /*#__PURE__*/React.createElement("path", {
	    d: "M37.785 10.624a2 2 0 00-2.903 2.752l3.823 4.032-20.713.01c-7.728.005-13.99 6.27-13.992 13.999v1.008a2 2 0 104 0v-1.008c0-5.52 4.474-9.995 9.994-9.998l21.498-.011-4.585 4.348a2 2 0 102.752 2.902l7.62-7.225a2 2 0 00.074-2.827l-7.568-7.982zM55.764 31.896c.005 5.525-4.47 10.007-9.994 10.01l-19.5.01 4.589-4.352a2 2 0 10-2.752-2.902l-7.62 7.225a2 2 0 00-.074 2.827l7.569 7.982a2 2 0 002.902-2.752l-3.82-4.029 18.708-.01c7.734-.003 13.999-6.279 13.992-14.013l-.001-.994a2 2 0 00-4 .003v.995z"
	  })));
	}

	var _path$32, _path2$K, _path3$k;

	function _extends$34() { _extends$34 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }

	function SvgRoaming(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$34({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$32 || (_path$32 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M37 4c-9.389 0-17 7.611-17 17s7.611 17 17 17 17-7.611 17-17S46.389 4 37 4zm-8.455 13.933l-4.356.847a12.969 12.969 0 013.629-6.983l.727 6.136zm3.972-.47l-.98-8.263a12.951 12.951 0 016.531-1.157v3.244l-1.833 1.753A4 4 0 0035 15.93v.08a4 4 0 004 4h2.444l.912 2.27c.676 1.681 2.86 2.107 4.119.804l3.441-3.567c.056.487.084.982.084 1.483 0 5.115-2.954 9.54-7.25 11.663v-3.235a4 4 0 00-4-4h-6.764a4 4 0 00-3.578 2.212l-1.043 2.088a12.953 12.953 0 01-3.232-6.862l5.176-1.006a4 4 0 003.208-4.398zm-1.962 14.83A12.94 12.94 0 0037 34c.593 0 1.178-.04 1.75-.117v-4.455h-6.763l-1.432 2.865zm17.658-17.876a13.05 13.05 0 00-6.145-5.392v2.262a4 4 0 01-1.235 2.89L39 15.931v.08h2.444a4 4 0 013.711 2.508l.05.121 1.747-1.81 1.26-2.413z"
	  })), _path2$K || (_path2$K = /*#__PURE__*/React.createElement("path", {
	    d: "M29 52a2 2 0 11-4 0 2 2 0 014 0z"
	  })), _path3$k || (_path3$k = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M19 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V42a2 2 0 10-4 0v2H15V12a4 4 0 014-4h2.5a2 2 0 100-4H19zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H15z"
	  })));
	}

	var _path$33;

	function _extends$35() { _extends$35 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }

	function SvgRouter(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$35({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$33 || (_path$33 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 33H12a8.01 8.01 0 00-8 8v6a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8v-6a8.01 8.01 0 00-8-8zm4 14a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4v-6a4.004 4.004 0 014-4h40a4.004 4.004 0 014 4v6zm-26-3a2 2 0 01-2 2H16a2 2 0 110-4h12a2 2 0 012 2zm12 0a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0zM15.543 17.848a2 2 0 01.215-2.82c9.337-8.037 23.147-8.037 32.484 0a2 2 0 01-2.605 3.034c-7.839-6.75-19.436-6.75-27.274 0a2 2 0 01-2.82-.214zM32 19a11.822 11.822 0 018.416 3.486 2 2 0 01-2.83 2.828 7.898 7.898 0 00-11.172 0 2 2 0 11-2.83-2.828A11.822 11.822 0 0132 19z"
	  })));
	}

	var _path$34, _path2$L;

	function _extends$36() { _extends$36 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }

	function SvgSatellite(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$36({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$34 || (_path$34 = /*#__PURE__*/React.createElement("path", {
	    d: "M14.308 25.371a1.996 1.996 0 001.88-.184 1.996 1.996 0 00.296-3.078l-4.234-4.234 7.06-7.06 4.233 4.244a2.002 2.002 0 102.825-2.836l-5.65-5.642a1.997 1.997 0 00-2.816 0l-9.885 9.886a1.997 1.997 0 000 2.816l5.641 5.652c.186.187.407.335.65.436zM44.73 56c.372.376.878.588 1.407.59a1.997 1.997 0 001.408-.59l9.874-9.885a1.997 1.997 0 000-2.816l-5.64-5.652a1.998 1.998 0 10-2.826 2.826l4.243 4.234-7.059 7.06-4.233-4.234a1.998 1.998 0 10-2.826 2.826L44.73 56z"
	  })), _path2$L || (_path2$L = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M42.722 9.996L54.015 21.29a5.99 5.99 0 01-.07 8.508L31.979 51.767c-.352.366-.83.583-1.337.609a1.996 1.996 0 01-1.408-.59l-1.867-1.867a12.754 12.754 0 01-1.628 6.082 1.997 1.997 0 01-1.468.998h-.28a1.997 1.997 0 01-1.467-.589l-3.235-3.225a5.993 5.993 0 11-8.476-8.478L7.588 41.47a1.997 1.997 0 01.43-3.155 12.748 12.748 0 016.13-1.658l-1.868-1.867a1.997 1.997 0 01-.589-1.408 1.998 1.998 0 01.59-1.418l21.965-21.97a5.991 5.991 0 018.476 0zM13.225 49.71a1.997 1.997 0 003.259.648l-2.826-2.826a1.999 1.999 0 00-.433 2.178zm.932-6.562a1.457 1.457 0 00-.549 0c.133-.013.267-.013.4 0h.15zm9.016 8.248A8.988 8.988 0 0012.62 40.832l2.835 2.846 7.718 7.72zm7.429-3.864l20.587-20.591a1.997 1.997 0 000-2.826L39.897 12.822a1.996 1.996 0 00-2.826 0l-20.587 20.59L30.6 47.533z"
	  })));
	}

	var _path$35;

	function _extends$37() { _extends$37 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }

	function SvgSave(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$37({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$35 || (_path$35 = /*#__PURE__*/React.createElement("path", {
	    d: "M54.828 16L48 9.172A3.974 3.974 0 0045.172 8H16a8.009 8.009 0 00-8 8v32a8.009 8.009 0 008 8h32a8.009 8.009 0 008-8V18.829A3.971 3.971 0 0054.828 16zM21 12h12v9H21v-9zm16 0h4v9h-4v-9zm6 40H21V38h22v14zm9-4a4 4 0 01-4 4h-1V38a4 4 0 00-4-4H21a4 4 0 00-4 4v14h-1a4 4 0 01-4-4V16a4 4 0 014-4h1v9a4 4 0 004 4h20a4 4 0 004-4v-9h.172L52 18.829V48z"
	  })));
	}

	var _path$36;

	function _extends$38() { _extends$38 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }

	function SvgSavings(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$38({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$36 || (_path$36 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56 27h-1.103a18.547 18.547 0 00-2.746-4.846l1.808-8.75a2 2 0 00-3.037-2.088l-7.317 4.683a11.991 11.991 0 00-23.067-.554l-.215.098c-.43.193-.86.387-1.264.604C12.814 19.478 8.85 24.93 8.129 31H6a2 2 0 100 4h2.128c.679 5.715 4.238 10.884 9.872 14.25V53a4.004 4.004 0 004 4h4a4.004 4.004 0 004-4v-2h4v2a4.004 4.004 0 004 4h4a4.004 4.004 0 004-4v-3.75A21.343 21.343 0 0054.003 41H56a4.004 4.004 0 004-4v-6a4.004 4.004 0 00-4-4zM32 11a8.01 8.01 0 018 8 7.916 7.916 0 01-2.725 6h-10.55A7.917 7.917 0 0124 19a8.01 8.01 0 018-8zm20.743 26H56v-6h-2.552c-.898 0-1.687-.6-1.926-1.466a14.489 14.489 0 00-3.04-5.55 2.001 2.001 0 01-.44-1.707l1.04-5.035-5.19 3.322a11.82 11.82 0 01-1.734 4.81A1.997 1.997 0 0141 29H22a1.998 1.998 0 01-.353-3.964 11.826 11.826 0 01-1.58-4.863C14.999 23.2 12 27.93 12 33c0 5.352 3.343 10.331 8.941 13.32A2 2 0 0122 48.083V53h4v-2a4.004 4.004 0 014-4h4a4.004 4.004 0 014 4v2h4v-4.916c0-.739.407-1.417 1.059-1.765a17.24 17.24 0 007.848-8.112A2 2 0 0152.743 37z"
	  })));
	}

	var _path$37;

	function _extends$39() { _extends$39 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }

	function SvgSearch(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$39({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$37 || (_path$37 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.607 55.543L47.773 44.71a2.153 2.153 0 00-.658-.446c8.249-9.776 7.325-24.316-2.093-32.97-9.42-8.655-23.986-8.347-33.03.698-9.045 9.044-9.353 23.61-.699 33.03 8.655 9.418 23.195 10.342 32.971 2.093.107.245.258.468.446.658l10.833 10.834a2.166 2.166 0 103.064-3.064zm-29.699-7.135c-10.77 0-19.5-8.73-19.5-19.5s8.73-19.5 19.5-19.5 19.5 8.73 19.5 19.5c-.012 10.764-8.736 19.488-19.5 19.5z"
	  })));
	}

	var _path$38, _path2$M, _path3$l, _path4$2;

	function _extends$3a() { _extends$3a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }

	function SvgSecureDevice(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3a({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$38 || (_path$38 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M28 16.341V13.6C28 8.741 32.142 5 37 5s9 3.741 9 8.6v2.741c2.33.824 4 3.047 4 5.659v9a6 6 0 01-6 6H30a6 6 0 01-6-6v-9a6.003 6.003 0 014-5.659zm4-2.741c0-2.431 2.126-4.6 5-4.6s5 2.169 5 4.6V16H32v-2.4zM28 22a2 2 0 012-2h14a2 2 0 012 2v9a2 2 0 01-2 2H30a2 2 0 01-2-2v-9z"
	  })), _path2$M || (_path2$M = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M37 24a2 2 0 012 2v2a2 2 0 11-4 0v-2a2 2 0 012-2z"
	  })), _path3$l || (_path3$l = /*#__PURE__*/React.createElement("path", {
	    d: "M31 52a2 2 0 11-4 0 2 2 0 014 0z"
	  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M21 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V41a2 2 0 10-4 0v3H17V12a4 4 0 014-4h4.5a2 2 0 100-4H21zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H17z"
	  })));
	}

	var _path$39;

	function _extends$3b() { _extends$3b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }

	function SvgSecured1(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3b({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$39 || (_path$39 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M54.074 12.117c-7-.4-13.715-2.915-19.254-7.215a4.31 4.31 0 00-5.276 0 34.617 34.617 0 01-19.254 7.215A4.367 4.367 0 006 16.48v10.91C6 52.061 26.406 58.7 30.495 59.78a6.588 6.588 0 003.373 0c4.09-1.08 24.497-7.718 24.497-32.39V16.48a4.367 4.367 0 00-4.29-4.363zm-.073 15.272c0 20.935-16.262 26.856-21.25 28.173-.373.1-.766.1-1.14 0-4.984-1.317-21.247-7.238-21.247-28.173l-.003-10.91h.003c.042 0 .082 0 .124-.002A38.591 38.591 0 0032.15 8.353a38.963 38.963 0 0021.727 8.124l.123.003v10.91zm-9.094-3.153L31.816 43.873a2.179 2.179 0 01-3.358.332l-8.728-8.728a2.182 2.182 0 113.085-3.085l6.846 6.845 11.615-17.422a2.182 2.182 0 113.63 2.42z"
	  })));
	}

	var _path$3a, _path2$N;

	function _extends$3c() { _extends$3c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }

	function SvgSecured2(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3c({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3a || (_path$3a = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M47.167 31.56c0 1.197-.97 2.167-2.167 2.167H34.167V44.56a2.167 2.167 0 01-4.334 0V33.726H19a2.167 2.167 0 110-4.333h10.833V18.56a2.167 2.167 0 114.334 0v10.833H45c1.197 0 2.167.97 2.167 2.167zM58 16.393v10.834c0 24.5-20.264 31.092-24.326 32.165a6.546 6.546 0 01-3.35 0C26.264 58.32 6 51.727 6 27.226V16.394a4.337 4.337 0 014.26-4.332 34.375 34.375 0 0019.12-7.166 4.28 4.28 0 015.24 0 34.376 34.376 0 0019.12 7.166A4.337 4.337 0 0158 16.393zm-4.333 0l-.123-.003A38.692 38.692 0 0131.97 8.323a38.322 38.322 0 01-21.513 8.067 2.39 2.39 0 01-.122.003h-.003l.003 10.833c0 20.789 16.15 26.669 21.1 27.977.37.099.76.099 1.131 0 4.953-1.308 21.102-7.188 21.102-27.977V16.393z"
	  })), _path2$N || (_path2$N = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M47.167 31.56c0 1.197-.97 2.167-2.167 2.167H34.167V44.56a2.167 2.167 0 01-4.334 0V33.726H19a2.167 2.167 0 110-4.333h10.833V18.56a2.167 2.167 0 114.334 0v10.833H45c1.197 0 2.167.97 2.167 2.167zM58 16.393v10.834c0 24.5-20.264 31.092-24.326 32.165a6.546 6.546 0 01-3.35 0C26.264 58.32 6 51.727 6 27.226V16.394a4.337 4.337 0 014.26-4.332 34.375 34.375 0 0019.12-7.166 4.28 4.28 0 015.24 0 34.376 34.376 0 0019.12 7.166A4.337 4.337 0 0158 16.393zm-4.333 0l-.123-.003A38.692 38.692 0 0131.97 8.323a38.322 38.322 0 01-21.513 8.067 2.39 2.39 0 01-.122.003h-.003l.003 10.833c0 20.789 16.15 26.669 21.1 27.977.37.099.76.099 1.131 0 4.953-1.308 21.102-7.188 21.102-27.977V16.393z"
	  })));
	}

	var _path$3b;

	function _extends$3d() { _extends$3d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }

	function SvgSend(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3d({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3b || (_path$3b = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8.416 6.293C5.997 5.18 3.386 7.418 4.13 9.968L10.543 32 4.129 54.032c-.743 2.55 1.868 4.788 4.287 3.675l49.778-22.895c2.408-1.107 2.408-4.517 0-5.624L8.416 6.293zm5.84 23.642L8.743 10.991 49.93 29.935H14.256zm0 4.13L8.743 53.01l41.187-18.944H14.257z"
	  })));
	}

	var _path$3c;

	function _extends$3e() { _extends$3e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }

	function SvgSenseCar(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3e({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3c || (_path$3c = /*#__PURE__*/React.createElement("path", {
	    d: "M52 34h-5.172L38 25.172A3.974 3.974 0 0035.172 24H17.355a3.983 3.983 0 00-3.715 2.515L10.645 34H8a4.005 4.005 0 00-4 4v6a8.006 8.006 0 007.338 7.967A5.99 5.99 0 0022.65 52H42a1.99 1.99 0 00.337-.034A5.99 5.99 0 0053.65 52H56a4.004 4.004 0 004-4v-6a8.01 8.01 0 00-8-8zM17 52a2 2 0 110-4 2 2 0 010 4zm31 0a2 2 0 110-4 2 2 0 010 4zm8-4h-2.35a5.991 5.991 0 00-11.313.034A2 2 0 0042 48H22.65a5.99 5.99 0 00-11.277-.063A3.996 3.996 0 018 44v-6h4.007a1.977 1.977 0 00.633-.114c.159-.052.31-.123.451-.213l.02-.011a2.003 2.003 0 00.467-.447c.111-.14.203-.295.272-.46l.007-.012L17.355 28h17.817l9.413 9.413a2 2 0 00.306.25c.048.032.1.054.149.081.063.038.128.073.196.103.065.024.132.045.2.062.057.017.112.04.172.052.13.026.26.039.392.039h6a4.005 4.005 0 014 4v6zM32.663 9.15a2 2 0 011.347-2.487A16.02 16.02 0 0153.917 17.43a1.999 1.999 0 11-3.834 1.14 12.02 12.02 0 00-14.933-8.073 2.001 2.001 0 01-2.487-1.347zm13.223 10.184a2.001 2.001 0 11-3.772 1.332 4.008 4.008 0 00-5.105-2.44 2 2 0 11-1.334-3.77 8.006 8.006 0 0110.21 4.878z"
	  })));
	}

	var _path$3d;

	function _extends$3f() { _extends$3f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }

	function SvgServer(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3f({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3d || (_path$3d = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46.77 4H16.614A8.625 8.625 0 008 12.615v38.77A8.625 8.625 0 0016.615 60H46.77a8.625 8.625 0 008.616-8.615v-38.77A8.625 8.625 0 0046.769 4zm4.307 47.385a4.312 4.312 0 01-4.308 4.307H16.615a4.312 4.312 0 01-4.307-4.307v-8.616h38.769v8.616zm0-12.923h-38.77V25.538h38.77v12.924zM12.307 21.23v-8.616a4.312 4.312 0 014.308-4.307H46.77a4.312 4.312 0 014.308 4.307v8.616h-38.77zm15.078-6.462c0 1.19-.965 2.154-2.154 2.154h-6.462a2.154 2.154 0 010-4.308h6.462c1.19 0 2.154.965 2.154 2.154zM16.615 32c0-1.19.965-2.154 2.154-2.154h6.462a2.154 2.154 0 010 4.308h-6.462A2.154 2.154 0 0116.615 32zm0 17.23c0-1.189.965-2.153 2.154-2.153h6.462a2.154 2.154 0 010 4.308h-6.462a2.154 2.154 0 01-2.154-2.154z"
	  })));
	}

	var _path$3e, _path2$O, _path3$m;

	function _extends$3g() { _extends$3g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }

	function SvgServiceDevice(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3g({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3e || (_path$3e = /*#__PURE__*/React.createElement("path", {
	    d: "M28 52a2 2 0 11-4 0 2 2 0 014 0z"
	  })), _path2$O || (_path2$O = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M18 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8v-6a2 2 0 00-2-2H14V12a4 4 0 014-4h16a4 4 0 014 4v4.5a2 2 0 104 0V12a8 8 0 00-8-8H18zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H14z"
	  })), _path3$m || (_path3$m = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.578 34.924c-3.59 1.636-7.535.679-10.606-1.571-2.914-2.135-4.392-5.489-4.315-8.861a3.414 3.414 0 012.24-3.17c1.177-.44 2.544-.254 3.62.534l3.698 2.71a.953.953 0 00.96-1.311l-3.54-2.594c-1.116-.817-1.702-2.119-1.591-3.41a3.432 3.432 0 012.54-3.042c3.01-.847 6.613-.637 9.388 1.396 3.072 2.25 5.175 5.723 4.698 9.639L51.443 34.6c1.29.945 1.821 2.411 1.837 3.79.015 1.377-.466 2.799-1.35 4.005-.883 1.207-2.093 2.094-3.412 2.494-1.318.401-2.877.337-4.167-.608l-12.773-9.357zm-8.243-4.798c-1.538-1.127-2.45-2.822-2.642-4.647l3.344 2.449c.304.223.648.386 1.012.48 4.338 1.128 7.822-3.628 5.44-7.424-.201-.32-.46-.598-.765-.82l-3.15-2.308c1.867-.316 3.714.009 5.034.976 2.523 1.847 3.595 4.325 2.928 6.745-.236.857.124 1.739.83 2.202l-.001.002 13.714 10.046c.046.034.196.177.2.608.006.432-.154 1.02-.575 1.596-.422.576-.935.906-1.349 1.031-.412.126-.593.026-.64-.008L33.001 31.008 33 31.01a2.001 2.001 0 00-2.35-.127c-2.107 1.365-4.792 1.09-7.315-.757z"
	  })));
	}

	var _path$3f, _path2$P, _path3$n, _path4$3;

	function _extends$3h() { _extends$3h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }

	function SvgServiceSupervision(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3h({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3f || (_path$3f = /*#__PURE__*/React.createElement("path", {
	    d: "M29 52a2 2 0 11-4 0 2 2 0 014 0z"
	  })), _path2$P || (_path2$P = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M19 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V42a2 2 0 10-4 0v2H15V12a4 4 0 014-4h16.5a4 4 0 014 4 2 2 0 104 0 8 8 0 00-8-8H19zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H15z"
	  })), _path3$n || (_path3$n = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M23.506 26.9c4.18 5.655 8.585 8.1 12.602 8.1 4.017 0 8.364-2.445 12.423-8.114-4.435-5.611-8.593-7.916-12.407-7.886-3.833.03-8.058 2.419-12.618 7.9zM36.092 15c5.965-.046 11.466 3.81 16.516 10.633a2 2 0 01.062 2.29C48.01 34.993 42.284 39 36.108 39c-6.165 0-11.961-3.995-16.762-11.052a2 2 0 01.077-2.356C24.603 18.955 30.16 15.047 36.093 15z"
	  })), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M36 24a3 3 0 100 6 3 3 0 000-6zm-7 3a7 7 0 1114 0 7 7 0 01-14 0z"
	  })));
	}

	var _path$3g;

	function _extends$3i() { _extends$3i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }

	function SvgServices(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3i({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3g || (_path$3g = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M12 18a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0zM28 18a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0zM44 18a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0z"
	  })));
	}

	var _path$3h;

	function _extends$3j() { _extends$3j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }

	function SvgSettings(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3j({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3h || (_path$3h = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.785 22.001c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c-.007-5.52-4.48-9.994-10-10zm0 16a6 6 0 116-6 6.006 6.006 0 01-6 6zm26.652 1.511a3.972 3.972 0 00-1.868-2.44l-3.044-1.757a21.35 21.35 0 000-6.629l3.043-1.757a4.002 4.002 0 001.468-5.458l-1.306-2.259a882.006 882.006 0 01-2.688-4.66 3.997 3.997 0 00-5.475-1.478l-3.053 1.763a21.72 21.72 0 00-5.73-3.332V8.002a4.002 4.002 0 00-3.992-4l-2.611.002c-1.863.003-3.924.006-5.377-.003a3.798 3.798 0 00-2.839 1.161 3.976 3.976 0 00-1.18 2.84v3.503a21.713 21.713 0 00-5.73 3.332L15 13.074a4.004 4.004 0 00-5.46 1.459L8.193 16.87a845.816 845.816 0 01-2.647 4.58 3.997 3.997 0 001.455 5.48l3.044 1.756a21.35 21.35 0 000 6.629l-3.043 1.757a4.005 4.005 0 00-1.468 5.46l1.242 2.143a873.29 873.29 0 012.752 4.772 3.995 3.995 0 005.474 1.481l3.054-1.764a21.736 21.736 0 005.73 3.332V56a4.002 4.002 0 003.994 4l2.603-.003c1.867-.002 3.93-.007 5.386.003h.021a3.997 3.997 0 003.996-4v-3.504a21.729 21.729 0 005.73-3.332l3.054 1.764a4.004 4.004 0 005.461-1.46l1.215-2.109c.952-1.654 2.022-3.513 2.778-4.807.54-.917.689-2.012.413-3.04zm-3.866 1.02c-.76 1.301-1.836 3.17-2.793 4.833l-1.209 2.099-5.552-3.206-1.081.992a17.843 17.843 0 01-6.75 3.923l-1.4.44L35.79 56c-.729-.004-1.608-.005-2.54-.005l-2.874.002-2.59.002v-6.385l-1.401-.44a17.835 17.835 0 01-6.75-3.923l-1.082-.993-5.55 3.21c-.74-1.3-1.81-3.147-2.768-4.798l-1.234-2.133 5.539-3.198-.317-1.431a17.616 17.616 0 010-7.812l.317-1.432-5.542-3.194c.726-1.242 1.738-3.001 2.66-4.605l1.342-2.327 5.552 3.206 1.082-.992a17.83 17.83 0 016.75-3.924l1.4-.44-.004-6.387c1.461.008 3.532.005 5.405.003l2.599-.002v6.386l1.4.44a17.828 17.828 0 016.749 3.923l1.082.992 5.551-3.21c.724 1.27 1.762 3.062 2.701 4.684l1.3 2.248-5.539 3.198.317 1.431c.584 2.571.584 5.24 0 7.812l-.317 1.431 5.54 3.198 1-1.732-.998 1.73z"
	  })));
	}

	var _path$3i;

	function _extends$3k() { _extends$3k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }

	function SvgShare(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3k({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3i || (_path$3i = /*#__PURE__*/React.createElement("path", {
	    d: "M40.929 40.928c-.29.295-.563.607-.814.934l-16.458-7.314a10.062 10.062 0 000-5.1l16.405-7.383a10.019 10.019 0 10-1.74-3.603l-16.44 7.397a10.07 10.07 0 10.003 12.278l16.458 7.315a9.98 9.98 0 102.586-4.524zm2.828-29.171a6 6 0 110 8.486 5.984 5.984 0 010-8.486zM18.243 36.243a5.997 5.997 0 110-8.486 6.01 6.01 0 010 8.486zm34 16a5.997 5.997 0 110-8.486 6.01 6.01 0 010 8.486z"
	  })));
	}

	var _path$3j;

	function _extends$3l() { _extends$3l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }

	function SvgShopping(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3l({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3j || (_path$3j = /*#__PURE__*/React.createElement("path", {
	    d: "M48 16h-4a12 12 0 00-24 0h-4a4.005 4.005 0 00-4 4v34a4.005 4.005 0 004 4h32a4.005 4.005 0 004-4V20a4.005 4.005 0 00-4-4zM32 8a8.01 8.01 0 018 8H24a8.01 8.01 0 018-8zm16 46H16V20h4v4a2 2 0 004 0v-4l16-.002V24a2 2 0 004 0v-4.002h4V54z"
	  })));
	}

	var _path$3k;

	function _extends$3m() { _extends$3m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3m.apply(this, arguments); }

	function SvgShuffle(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3m({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3k || (_path$3k = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M35.541 27.431a2.001 2.001 0 01.005-2.829l4.286-4.27A7.949 7.949 0 0145.478 18h7.694l-2.586-2.586a2 2 0 012.828-2.828l6 6a2 2 0 010 2.828l-6 6a2 2 0 01-2.828-2.828L53.172 22h-7.694a4.024 4.024 0 00-2.822 1.166l-4.286 4.27a2.002 2.002 0 01-2.829-.005zm17.873 9.155a2 2 0 10-2.828 2.828L53.172 42H45.48a3.973 3.973 0 01-2.824-1.167L32.552 30.756a1.183 1.183 0 00-.337-.336L22.1 20.334C20.502 18.742 18.39 18 15.452 18H6a2 2 0 100 4h9.452c2.338 0 3.245.59 3.824 1.167l8.862 8.837-8.86 8.83A3.98 3.98 0 0116.452 42H6a2 2 0 100 4h10.453a7.955 7.955 0 005.648-2.332l8.87-8.839 8.861 8.836A7.947 7.947 0 0045.48 46h7.692l-2.586 2.586a2 2 0 002.828 2.828l6-6a2 2 0 000-2.828l-6-6z"
	  })));
	}

	var _path$3l;

	function _extends$3n() { _extends$3n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3n.apply(this, arguments); }

	function SvgSignature(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3n({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3l || (_path$3l = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M21.333 39.629c-.53-2.145-1.95-4.268-4.62-4.554-4.796-.514-6.713 3.987-6.586 7.997.102 2.884 1.143 6.188 3.192 8.995-1.518 1.453-3.428 2.56-5.727 3.039a2 2 0 10.816 3.916c3.126-.651 5.669-2.14 7.658-4.045.064.053.13.105.195.157 2.42 1.91 4.339 3.062 5.959 3.5.848.23 1.69.286 2.504.092a4.279 4.279 0 001.964-1.085c.474-.45.832-.963 1.103-1.383.123-.192.244-.39.352-.567l.037-.06c.122-.2.232-.377.344-.547.453-.69.784-1 1.179-1.147.394-.148 1.028 0 1.677.671.11.136.229.294.36.468.842 1.112 2.18 2.88 4.497 3.837 2.886 1.191 5.69.677 7.628-.02a14.619 14.619 0 002.366-1.104c.287-.166.516-.313.68-.422l.284-.2h.002c.885-.66 1.464-2.22.803-3.106-.602-.806-1.769-1.235-3.192-.103-.1.067-.38.253-.585.372a10.62 10.62 0 01-1.712.799c-1.437.517-3.133.753-4.747.086-1.243-.513-1.887-1.342-2.742-2.445-.164-.211-.335-.432-.52-.664-.513-.638-1.258-1.498-2.357-1.972-1.208-.52-2.502-.447-3.847.057-1.605.602-2.524 1.793-3.118 2.697-.15.228-.29.455-.412.655l-.035.057c-.112.183-.209.341-.306.493-.22.34-.37.53-.49.644-.092.087-.13.096-.141.098h-.002c-.019.005-.166.038-.528-.06-.803-.218-2.32-1.04-4.65-2.88a19.088 19.088 0 002.3-4.956c.76-2.542.947-5.163.417-7.31zM17.5 45.56c-.32 1.637-1.5 4-1.5 4-1-1-1.926-4.125-2-6-.06-1.558 0-3 1-4s2.142-.32 2.5 1c.358 1.318.376 3.084 0 5zM32.334 5.072c-4.127.756-8.173 3.293-10.768 6.488-1.36 1.676-1.19 3.883-.2 5.431l19.636 30.67c.41.638.992 1.15 1.687 1.47 1.162.537 4.055 1.863 6.722 3.018a93.04 93.04 0 003.632 1.502c.497.188.964.354 1.345.464.182.052.407.11.634.143.11.016.287.036.493.027.143-.007.631-.035 1.117-.371.468-.324.667-.75.723-.874.082-.18.13-.346.156-.452.055-.218.087-.445.109-.634.045-.392.073-.887.092-1.419a95.81 95.81 0 00.027-3.932c-.027-2.905-.123-6.08-.164-7.343a3.988 3.988 0 00-.665-2.076L36.968 7.15c-.93-1.402-2.667-2.438-4.635-2.078zm-7.662 9.01c2.038-2.51 5.26-4.504 8.382-5.075a.378.378 0 01.24.042c.11.054.238.156.342.313l18.66 28.103c-.792.343-1.827.823-2.963 1.436-1.955 1.055-4.334 2.566-6.288 4.532l-18.31-28.599a.902.902 0 01-.15-.48c0-.126.036-.21.087-.272zM45.92 46.213c1.393.635 3.29 1.491 5.079 2.265.992.43 1.936.828 2.734 1.148.015-.866.015-1.898.005-2.985a307.11 307.11 0 00-.107-5.394c-.67.296-1.5.69-2.4 1.175-1.809.976-3.778 2.26-5.311 3.791z"
	  })));
	}

	var _path$3m;

	function _extends$3o() { _extends$3o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3o.apply(this, arguments); }

	function SvgSimcard(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3o({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3m || (_path$3m = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M40 32H24a4.004 4.004 0 00-4 4v12a4.004 4.004 0 004 4h16a4.004 4.004 0 004-4V36a4.004 4.004 0 00-4-4zm.001 8H34v-4h6l.001 4zM24 36h6v12h-6V36zm10 12v-4h6.002l.001 4H34zm15.656-31.171L39.172 6.342A7.956 7.956 0 0033.515 4H20a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h24a8.01 8.01 0 008-8V22.485a7.946 7.946 0 00-2.344-5.656zM48 52a4.004 4.004 0 01-4 4H20a4.004 4.004 0 01-4-4V12a4.004 4.004 0 014-4h13.515a3.978 3.978 0 012.829 1.171l10.484 10.487A3.968 3.968 0 0148 22.485V52z"
	  })));
	}

	var _path$3n;

	function _extends$3p() { _extends$3p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3p.apply(this, arguments); }

	function SvgSkipBack10Sec(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3p({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3n || (_path$3n = /*#__PURE__*/React.createElement("path", {
	    d: "M24.309 40.75V29.378l-2.887 1.32a.981.981 0 01-.391.098c-.408 0-.8-.293-1.174-.88a1.949 1.949 0 01-.367-.905c0-.457.383-.864 1.15-1.223l5.038-2.275c.34-.146.707-.221 1.077-.22.636 0 .954.293.954.88v13.87a3.31 3.31 0 01-.538 1.834 1.475 1.475 0 01-1.174.832c-.408 0-.832-.318-1.273-.954a2.059 2.059 0 01-.415-1.003zm7.45-1.8a11.195 11.195 0 01-.745-4.302v-1.297c0-3.388 1.082-5.91 2.956-7.183a5.766 5.766 0 013.293-.938 5.689 5.689 0 015.524 3.821c.51 1.375.754 2.834.722 4.3v1.297c0 3.389-1.058 5.91-2.932 7.16a5.97 5.97 0 01-8.817-2.858zm2.524-4.494c0 3.485.984 5.214 2.98 5.214 1.993 0 2.977-1.73 2.977-5.214v-.913c0-3.484-.984-5.214-2.977-5.214-1.996 0-2.98 1.73-2.98 5.214v.913zM30 10H18.828l2.586-2.586a2 2 0 10-2.828-2.828l-6 6a1.984 1.984 0 00-.375.538c-.076.151-.133.31-.169.475l-.004.013a2.006 2.006 0 00-.014.638c.02.175.062.347.127.511l.001.004.009.015c.068.154.155.3.26.432.028.037.057.072.088.107.027.031.047.065.077.095l6 6a2 2 0 002.828-2.828L18.828 14H30c12.542 0 22 8.597 22 20a20 20 0 11-40 0 2 2 0 10-4 0 24 24 0 0048 0c0-13.683-11.178-24-26-24z"
	  })));
	}

	var _path$3o;

	function _extends$3q() { _extends$3q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3q.apply(this, arguments); }

	function SvgSkipBack30Sec(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3o || (_path$3o = /*#__PURE__*/React.createElement("path", {
	    d: "M39.193 42.769a5.663 5.663 0 003.314-.96c1.874-1.25 2.933-3.772 2.933-7.16V33.35a11.665 11.665 0 00-.722-4.3 5.688 5.688 0 00-5.525-3.82 5.765 5.765 0 00-3.292.937c-1.875 1.273-2.956 3.795-2.956 7.183v1.297c-.037 1.47.217 2.931.745 4.302a5.64 5.64 0 005.503 3.819zm-2.98-9.226c0-3.484.985-5.214 2.98-5.214 1.994 0 2.977 1.73 2.977 5.214v.913c0 3.485-.983 5.214-2.977 5.214-1.995 0-2.98-1.73-2.98-5.214v-.913zm-8.715 4.33a2.111 2.111 0 00-.8-2.226 3.735 3.735 0 00-2.277-.63h-1.09c-.323 0-.654-.242-.992-.727a1.472 1.472 0 01-.315-.775c0-.29.202-.565.605-.823.373-.25.811-.384 1.26-.388a3.682 3.682 0 002.216-.593 1.869 1.869 0 00.811-1.586 1.654 1.654 0 00-.69-1.345 2.71 2.71 0 00-1.732-.545 4.638 4.638 0 00-3.294 1.696.959.959 0 01-.654.339 1.461 1.461 0 01-1.162-.823 1.663 1.663 0 01-.34-.872.899.899 0 01.146-.46 6.306 6.306 0 012.398-2.132 6.782 6.782 0 013.221-.823 5.871 5.871 0 012.725.629 4.907 4.907 0 011.9 1.656c.445.661.682 1.44.679 2.237a3.89 3.89 0 01-.533 1.983c-.39.65-.93 1.196-1.574 1.596a5.026 5.026 0 012.07 1.71c.497.697.764 1.532.764 2.388a4.674 4.674 0 01-.92 2.801 6.223 6.223 0 01-2.374 1.977 7.029 7.029 0 01-3.1.703 7.165 7.165 0 01-3.415-.824 5.313 5.313 0 01-2.277-2.18 1.818 1.818 0 01-.194-.653c0-.34.235-.662.703-.97.444-.298.966-.458 1.502-.46a.823.823 0 01.75.34c.367.52.842.953 1.393 1.271.518.273 1.097.41 1.683.4a3.108 3.108 0 002.57-1.134c.174-.22.29-.48.337-.756zM56 34a24 24 0 01-48 0 2 2 0 014 0 20 20 0 1040 0c0-11.402-9.458-20-22-20H18.828l2.586 2.586a1.999 1.999 0 11-2.828 2.828l-6-6c-.03-.03-.05-.064-.077-.095a1.898 1.898 0 01-.088-.107 1.99 1.99 0 01-.26-.432l-.009-.015v-.004a1.99 1.99 0 01-.14-.634 1.997 1.997 0 01.026-.515l.004-.013a1.992 1.992 0 01.228-.586c.085-.156.192-.3.316-.427l6-6a2 2 0 112.828 2.828L18.828 10H30c14.822 0 26 10.317 26 24z"
	  })));
	}

	var _path$3p;

	function _extends$3r() { _extends$3r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3r.apply(this, arguments); }

	function SvgSkipForward10Sec(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3r({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3p || (_path$3p = /*#__PURE__*/React.createElement("path", {
	    d: "M56 34a24 24 0 01-48 0c0-13.683 11.178-24 26-24h11.172l-2.586-2.586a2 2 0 012.828-2.828l6 6a1.986 1.986 0 01.375.538c.076.15.133.31.169.475l.004.013a2.001 2.001 0 01.014.638 1.99 1.99 0 01-.127.511l-.001.004-.009.015c-.068.154-.155.3-.26.432a1.98 1.98 0 01-.088.107c-.027.031-.047.065-.077.095l-6 6a2 2 0 01-2.828-2.828L45.172 14H34c-12.542 0-22 8.597-22 20a20 20 0 1040 0 2 2 0 114 0zm-31.275 7.754c.44.636.864.954 1.272.954a1.475 1.475 0 001.174-.832 3.309 3.309 0 00.538-1.834v-13.87c0-.587-.318-.88-.954-.88a2.704 2.704 0 00-1.076.22l-5.04 2.275c-.766.358-1.15.766-1.149 1.223.044.328.17.64.367.905.375.587.766.88 1.174.88a.98.98 0 00.391-.097l2.887-1.321V40.75c.046.365.19.712.416 1.003zM42.787 29.05c.51 1.376.754 2.834.722 4.3v1.297c0 3.389-1.058 5.91-2.932 7.16a5.97 5.97 0 01-8.817-2.858 11.197 11.197 0 01-.746-4.302v-1.297c0-3.388 1.082-5.91 2.956-7.183a5.766 5.766 0 013.293-.938 5.688 5.688 0 015.524 3.821zm-2.547 4.492c0-3.484-.984-5.214-2.977-5.214-1.996 0-2.98 1.73-2.98 5.214v.913c0 3.485.984 5.214 2.98 5.214 1.993 0 2.977-1.73 2.977-5.214v-.913z"
	  })));
	}

	var _path$3q;

	function _extends$3s() { _extends$3s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3s.apply(this, arguments); }

	function SvgSkipForward30Sec(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3s({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3q || (_path$3q = /*#__PURE__*/React.createElement("path", {
	    d: "M39.193 25.23a5.766 5.766 0 00-3.292.938c-1.875 1.273-2.956 3.795-2.956 7.183v1.297c-.037 1.47.216 2.931.745 4.302a5.971 5.971 0 008.817 2.858c1.874-1.25 2.933-3.771 2.933-7.16v-1.297a11.663 11.663 0 00-.722-4.3 5.689 5.689 0 00-5.525-3.82zm2.978 9.226c0 3.485-.984 5.214-2.978 5.214-1.995 0-2.98-1.73-2.98-5.214v-.913c0-3.484.985-5.214 2.98-5.214 1.994 0 2.978 1.73 2.978 5.214v.913zm-14.673 3.418a2.111 2.111 0 00-.8-2.227 3.735 3.735 0 00-2.277-.63h-1.09c-.323 0-.654-.242-.992-.727a1.472 1.472 0 01-.315-.775c0-.29.202-.565.605-.823.373-.249.811-.384 1.26-.388a3.684 3.684 0 002.216-.593 1.869 1.869 0 00.811-1.586 1.655 1.655 0 00-.69-1.345 2.71 2.71 0 00-1.732-.545 4.638 4.638 0 00-3.294 1.696.962.962 0 01-.654.339 1.46 1.46 0 01-1.162-.823 1.662 1.662 0 01-.34-.872.9.9 0 01.146-.46 6.305 6.305 0 012.398-2.132 6.783 6.783 0 013.221-.823 5.872 5.872 0 012.725.629 4.908 4.908 0 011.9 1.656c.445.661.682 1.44.679 2.237a3.89 3.89 0 01-.533 1.983c-.39.65-.93 1.196-1.574 1.596a5.026 5.026 0 012.07 1.71c.497.697.764 1.532.764 2.388a4.675 4.675 0 01-.92 2.801 6.223 6.223 0 01-2.374 1.977 7.027 7.027 0 01-3.1.703 7.166 7.166 0 01-3.415-.824 5.315 5.315 0 01-2.277-2.18 1.82 1.82 0 01-.194-.653c0-.34.235-.662.703-.97.443-.298.966-.458 1.501-.46a.824.824 0 01.751.34c.367.52.842.953 1.393 1.271.518.273 1.097.41 1.683.4a3.107 3.107 0 002.57-1.134c.174-.22.29-.48.337-.756zM56 34a24 24 0 01-48 0c0-13.683 11.178-24 26-24h11.172l-2.586-2.586a2 2 0 012.828-2.828l6 6a1.984 1.984 0 01.375.538c.076.151.133.31.169.475l.004.013a2.006 2.006 0 01.014.638c-.02.175-.062.347-.127.511l-.001.004-.009.015a1.99 1.99 0 01-.26.432 1.934 1.934 0 01-.088.107c-.027.031-.047.065-.077.095l-6 6a2 2 0 01-2.828-2.828L45.172 14H34c-12.542 0-22 8.597-22 20a20 20 0 1040 0 2 2 0 114 0z"
	  })));
	}

	var _path$3r;

	function _extends$3t() { _extends$3t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3t.apply(this, arguments); }

	function SvgSlowWifi(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3t({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3r || (_path$3r = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M53 28a2 2 0 11-4 0 2 2 0 014 0zm7-.128A9 9 0 0151 37h-2.172L46 39.828V41a8 8 0 01-16 0h-8a8 8 0 11-16 0 2 2 0 110-4h.05c.01-.05.03-.096.044-.144.002-.053-.008-.104-.004-.157C7.07 24.33 15.63 15 26 15c6.803 0 12.81 4.03 16.426 10.284A9.016 9.016 0 0151.001 19l.127.001A9.06 9.06 0 0160 27.872zm-23.864-4.356a1.995 1.995 0 01-.153.281l-3.608 5.273L37.133 37h4.781a21.646 21.646 0 00-5.778-13.484zM26 19c-2.518.01-4.983.727-7.114 2.067.073.073.14.152.201.236L23.047 27h5.899l3.736-5.46c.124-.179.277-.334.452-.462A13.473 13.473 0 0026 19zM10.08 37h4.787l4.752-7.92-3.817-5.494-.002-.003A21.715 21.715 0 0010.08 37zM18 41h-8a4 4 0 108 0zm14.467-4l-3.6-6h-5.734l-3.6 6h12.934zM42 41h-8a4 4 0 108 0zM56 27.929A5.094 5.094 0 0051.07 23l-.07-.001a5.02 5.02 0 00-4.882 3.906 3.943 3.943 0 01-1.79 2.481 27.582 27.582 0 011.322 5.133l.349-.348A3.973 3.973 0 0148.828 33H51a4.999 4.999 0 004.999-5.071z"
	  })));
	}

	var _path$3s;

	function _extends$3u() { _extends$3u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3u.apply(this, arguments); }

	function SvgSmartWifi(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3u({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3s || (_path$3s = /*#__PURE__*/React.createElement("path", {
	    d: "M39.074 35.93a2 2 0 01-2.828 2.828 6 6 0 00-8.487 0 2 2 0 01-2.828-2.829 10.001 10.001 0 0114.143 0zM32.003 41a3 3 0 100 6 3 3 0 000-6zm26.932-7.469a3.988 3.988 0 01-3.695 2.47h-1.237v18a4.005 4.005 0 01-4 4h-36a4.004 4.004 0 01-4-4V36H8.765a4 4 0 01-2.828-6.829L27.76 7.35a5.998 5.998 0 018.485 0l21.823 21.823a3.988 3.988 0 01.867 4.36zm-3.695-1.53L33.417 10.177a2.049 2.049 0 00-2.828 0L8.765 32.001h5.238v22h36V32h5.237zm-35.965-1.728a2 2 0 002.828 2.828 13.998 13.998 0 0119.8 0 2 2 0 002.827-2.828 17.996 17.996 0 00-25.455 0z"
	  })));
	}

	var _path$3t;

	function _extends$3v() { _extends$3v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3v.apply(this, arguments); }

	function SvgSmartphone(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3v({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3t || (_path$3t = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M40 4H24a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h16a8.01 8.01 0 008-8V12a8.01 8.01 0 00-8-8zm-20 8a4.004 4.004 0 014-4h16a4.004 4.004 0 014 4v32H20V12zm24 40a4.004 4.004 0 01-4 4H24a4.004 4.004 0 01-4-4v-4h24v4zm-14 0a2 2 0 114 0 2 2 0 01-4 0z"
	  })));
	}

	var _path$3u, _path2$Q;

	function _extends$3w() { _extends$3w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3w.apply(this, arguments); }

	function SvgSmartwatch(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3w({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3u || (_path$3u = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M14.23 9.276A6 6 0 0119.975 5h8.048a6 6 0 015.747 4.276l1.86 6.2A7.99 7.99 0 0139 22v20a7.99 7.99 0 01-3.37 6.524l-1.86 6.2A6 6 0 0128.025 59h-8.048a6 6 0 01-5.747-4.276l-1.86-6.2A7.99 7.99 0 019 42V22a7.99 7.99 0 013.37-6.524l1.86-6.2zM16.987 50l1.073 3.575A2 2 0 0019.976 55h8.048a2 2 0 001.915-1.425L31.012 50H16.988zM29.94 10.425L31.012 14H16.988l1.073-3.575A2 2 0 0119.976 9h8.048a2 2 0 011.915 1.425zM17 18a4 4 0 00-4 4v20a4 4 0 004 4h14a4 4 0 004-4V22a4 4 0 00-4-4H17zM50.315 34.87c.622-2.384.671-5.785-1.98-9.76a2 2 0 013.33-2.22c3.349 5.026 3.398 9.624 2.52 12.99a15.416 15.416 0 01-1.617 3.9c-.272.46-.52.824-.706 1.08a9.526 9.526 0 01-.303.394l-.025.03-.009.01-.003.004-.002.002s.014-.017-.002.002a2 2 0 01-3.043-2.595l1.84-3.837zm0 0a11.417 11.417 0 01-1.195 2.882 9.247 9.247 0 01-.62.923l-.018.022-.005.007 1.838-3.834z"
	  })), _path2$Q || (_path2$Q = /*#__PURE__*/React.createElement("path", {
	    d: "M42.336 29.11c1.15 1.725 1.044 3.255.854 4.073-.143.614-.216.728-.441 1.08-.075.116-.166.258-.282.453-.467.784-.601 2.089.232 2.803a2 2 0 002.82-.217l.003-.004.003-.004.008-.008.018-.022a4.14 4.14 0 00.188-.245c.11-.151.253-.36.407-.622.306-.52.67-1.27.914-2.204.503-1.929.454-4.527-1.396-7.302a2 2 0 00-3.328 2.219z"
	  })));
	}

	var _path$3v;

	function _extends$3x() { _extends$3x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3x.apply(this, arguments); }

	function SvgSmileyHappy(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3x({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3v || (_path$3v = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm0 51.692C18.915 55.692 8.308 45.085 8.308 32S18.915 8.308 32 8.308 55.693 18.915 55.693 32C55.678 45.079 45.079 55.677 32 55.692zm16.517-18.77a17.237 17.237 0 01-33.034 0 2.154 2.154 0 014.128-1.228 12.929 12.929 0 0024.777 0 2.154 2.154 0 014.129 1.228zM20.154 25.539a3.23 3.23 0 116.461 0 3.23 3.23 0 01-6.461 0zm17.23 0a3.23 3.23 0 116.462 0 3.23 3.23 0 01-6.461 0z"
	  })));
	}

	var _path$3w;

	function _extends$3y() { _extends$3y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3y.apply(this, arguments); }

	function SvgSmileySad(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3w || (_path$3w = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm0 51.692C18.915 55.692 8.308 45.085 8.308 32S18.915 8.308 32 8.308 55.692 18.915 55.692 32C55.678 45.079 45.08 55.678 32 55.692zM20.154 25.538a3.23 3.23 0 116.461 0 3.23 3.23 0 01-6.461 0zm17.23 0a3.23 3.23 0 116.462 0 3.23 3.23 0 01-6.461 0zm7.174 17.404c-.663.987-2 1.251-2.989.589a17.163 17.163 0 00-19.138 0 2.154 2.154 0 11-2.4-3.578 21.474 21.474 0 0123.938 0c.988.663 1.252 2 .59 2.989z"
	  })));
	}

	var _path$3x, _path2$R;

	function _extends$3z() { _extends$3z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3z.apply(this, arguments); }

	function SvgSms(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3x || (_path$3x = /*#__PURE__*/React.createElement("path", {
	    d: "M27.828 23.677a2.64 2.64 0 100-5.279 2.64 2.64 0 000 5.279zM40.995 21.037a2.64 2.64 0 11-5.278 0 2.64 2.64 0 015.278 0zM48.267 23.677a2.64 2.64 0 100-5.279 2.64 2.64 0 000 5.279z"
	  })), _path2$R || (_path2$R = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M24.319 7a7.93 7.93 0 00-7.93 7.93v8.424h-4.46A7.93 7.93 0 004 31.284V42.68a7.93 7.93 0 007.93 7.93h10.576l6.152 6.152c1.874 1.873 5.076.546 5.076-2.103v-4.05h5.947a7.93 7.93 0 007.93-7.929v-8.424h4.46A7.93 7.93 0 0060 26.327V14.93A7.93 7.93 0 0052.07 7H24.32zM52.07 30.292a3.965 3.965 0 003.964-3.965V14.93a3.965 3.965 0 00-3.964-3.964H24.319a3.965 3.965 0 00-3.965 3.964v11.398a3.965 3.965 0 003.965 3.965h9.911v5.621l5.622-5.621H52.07zm-35.62-2.973a7.93 7.93 0 007.868 6.938h5.947v4.05c0 2.648 3.202 3.975 5.076 2.102l6.152-6.152h2.152v8.424a3.965 3.965 0 01-3.965 3.965H29.77v5.621l-5.622-5.621H11.93a3.965 3.965 0 01-3.964-3.965V31.283a3.965 3.965 0 013.964-3.964h4.522z"
	  })));
	}

	var _path$3y;

	function _extends$3A() { _extends$3A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3A.apply(this, arguments); }

	function SvgSnapchat(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3A({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3y || (_path$3y = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.432 6.01c-2.31 0-10.139.64-13.832 8.925-1.243 2.787-.945 7.52-.706 11.32.028.448.059.914.08 1.36-.191.106-.54.24-1.09.24-.733 0-1.6-.231-2.575-.689a2.079 2.079 0 00-.887-.181c-1.142 0-2.51.752-2.72 1.872-.153.806.208 1.984 2.8 3.008.234.093.515.181.813.276 1.071.34 2.691.854 3.13 1.89.228.535.137 1.226-.27 2.05-.167.389-3.595 8.202-11.205 9.456a1.162 1.162 0 00-.968 1.213c.01.18.053.357.124.522.571 1.335 2.98 2.314 7.368 2.994.146.199.299.9.392 1.326.092.426.186.855.32 1.314.133.458.476.988 1.36.988.356 0 .777-.08 1.264-.177.731-.143 1.732-.339 2.985-.339.717.002 1.432.063 2.14.181 1.415.236 2.618 1.087 4.01 2.07 1.997 1.411 4.256 3.011 7.69 3.011.093 0 .188 0 .282-.01.111.005.256.01.41.01 3.435 0 5.693-1.6 7.687-3.006 1.396-.986 2.597-1.836 4.013-2.072.707-.118 1.422-.179 2.14-.18a14.88 14.88 0 012.984.32c.416.091.839.145 1.264.16.716 0 1.176-.345 1.36-.97.132-.45.227-.873.32-1.3.092-.429.244-1.12.39-1.32 4.389-.682 6.8-1.66 7.368-2.989.072-.166.114-.344.125-.525a1.16 1.16 0 00-.97-1.21c-7.613-1.255-11.04-9.067-11.181-9.4-.433-.88-.523-1.57-.295-2.106.439-1.035 2.058-1.55 3.13-1.888.299-.096.58-.185.812-.276 1.898-.75 2.85-1.67 2.83-2.736-.016-.838-.669-1.584-1.705-1.955a3.116 3.116 0 00-1.168-.224 2.584 2.584 0 00-1.072.218c-.903.423-1.714.653-2.413.684a2.144 2.144 0 01-.94-.234c.02-.385.046-.783.072-1.2l.01-.16c.24-3.805.538-8.54-.706-11.329C42.704 6.647 34.86 6 32.542 6l-1.11.01z"
	  })));
	}

	var _path$3z;

	function _extends$3B() { _extends$3B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3B.apply(this, arguments); }

	function SvgSnowflake(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3B({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3z || (_path$3z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56.279 29.581a2.166 2.166 0 101.701-3.984l-6.178-2.64 5.123-2.987a2.167 2.167 0 10-2.183-3.743l-4.88 2.846.752-6.235a2.166 2.166 0 10-4.302-.518l-1.144 9.49-5.106 2.98a10.824 10.824 0 00-5.895-3.404V15.75l7.8-5.85a2.166 2.166 0 10-2.6-3.467l-5.2 3.9V6.001a2.167 2.167 0 10-4.333 0v4.333l-5.2-3.9a2.166 2.166 0 10-2.6 3.466l7.8 5.85v5.636a10.825 10.825 0 00-5.895 3.404l-5.107-2.98-1.144-9.49a2.166 2.166 0 10-4.301.518l.75 6.235-4.878-2.846a2.167 2.167 0 10-2.184 3.743l5.123 2.988-6.178 2.639a2.166 2.166 0 101.702 3.984l9.14-3.903 4.886 2.85a10.662 10.662 0 000 6.945l-4.887 2.85-9.14-3.903a2.166 2.166 0 10-1.7 3.984l6.177 2.64-5.123 2.988a2.167 2.167 0 002.184 3.743l4.879-2.846-.751 6.234a2.165 2.165 0 104.301.519l1.144-9.492 5.107-2.978a10.825 10.825 0 005.895 3.404v5.635l-7.8 5.85a2.166 2.166 0 002.6 3.466l5.2-3.9v4.334a2.167 2.167 0 104.333 0v-4.334l5.2 3.9a2.167 2.167 0 102.6-3.466l-7.8-5.85v-5.635a10.824 10.824 0 005.895-3.404l5.106 2.979 1.144 9.49a2.166 2.166 0 104.302-.518l-.752-6.234 4.88 2.846a2.167 2.167 0 002.183-3.743l-5.186-3.026 6.058-2.693a2.166 2.166 0 10-1.76-3.958l-8.912 3.96-4.873-2.842a10.66 10.66 0 000-6.945l4.887-2.85 9.14 3.903zM32 38.501a6.5 6.5 0 116.5-6.5 6.507 6.507 0 01-6.5 6.5z"
	  })));
	}

	var _path$3A;

	function _extends$3C() { _extends$3C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3C.apply(this, arguments); }

	function SvgSorter(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3C({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3A || (_path$3A = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M33.153 42.686L20.301 55.414a2.034 2.034 0 01-2.857 0L4.592 42.686a1.986 1.986 0 010-2.828 2.034 2.034 0 012.856 0l9.405 9.314V10c0-1.105.904-2 2.02-2a2.01 2.01 0 012.02 2v39.172l9.404-9.314a2.033 2.033 0 012.856 0 1.986 1.986 0 010 2.828zM30.847 21.314L43.699 8.586a2.034 2.034 0 012.857 0l12.852 12.728a1.986 1.986 0 010 2.828 2.034 2.034 0 01-2.856 0l-9.405-9.314V54c0 1.105-.904 2-2.02 2a2.01 2.01 0 01-2.02-2V14.828l-9.404 9.314a2.033 2.033 0 01-2.856 0 1.986 1.986 0 010-2.828z"
	  })));
	}

	var _path$3B;

	function _extends$3D() { _extends$3D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3D.apply(this, arguments); }

	function SvgSpeedometer(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3D({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3B || (_path$3B = /*#__PURE__*/React.createElement("path", {
	    d: "M13 55.31a2 2 0 01-1.54-.72A28 28 0 0141.59 10c.37.12.74.25 1.1.39a2 2 0 11-1.38 3.75c-.32-.12-.63-.23-1-.33A24 24 0 0014.54 52a2 2 0 01-.26 2.81 2 2 0 01-1.28.5zM53 55.31a2 2 0 01-1.28-.47 2 2 0 01-.26-2.84 24 24 0 001.85-28.1 2 2 0 013.38-2.14 28 28 0 01-2.15 32.83 2 2 0 01-1.54.72zM31.73 38.24a2 2 0 001.27.45 2 2 0 001.55-.69l18-22a2.013 2.013 0 10-3.1-2.57l-18 22a2 2 0 00.28 2.81z"
	  })));
	}

	var _path$3C, _path2$S;

	function _extends$3E() { _extends$3E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3E.apply(this, arguments); }

	function SvgSpellCheck(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3E({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3C || (_path$3C = /*#__PURE__*/React.createElement("path", {
	    d: "M19.19 27.032c.107.287.248.56.42.812.486.728.972 1.092 1.456 1.092a1.688 1.688 0 001.344-.952 3.788 3.788 0 00.616-2.1 1.377 1.377 0 00-.112-.56l-5.6-15.54c-.133-.41-.478-.616-1.036-.616h-1.763c-.386.004-.77.071-1.135.2-.363.12-.704.3-1.008.532a1.652 1.652 0 00-.574.728L6.06 26.192c-.062.16-.1.328-.113.5.06.417.223.811.476 1.148.486.728.971 1.092 1.456 1.092a1.399 1.399 0 00.98-.476c.332-.34.58-.75.728-1.2l.84-2.38h8.01l.754 2.156zm-7.56-5.516l2.856-8.092 2.8 8.092H11.63zM27.338 28.768h6.355a6.087 6.087 0 004.4-1.668 5.6 5.6 0 001.736-4.22 4.714 4.714 0 00-.364-1.808 5.282 5.282 0 00-1.05-1.612 5.078 5.078 0 00-1.61-1.15 5.828 5.828 0 001.5-1.817c.34-.648.518-1.369.518-2.1a4.981 4.981 0 00-.714-2.614 5.246 5.246 0 00-2-1.9 5.918 5.918 0 00-2.913-.713h-4.99a3.452 3.452 0 00-1.918.574 1.574 1.574 0 00-.883 1.246v15.54a2.5 2.5 0 00.477 1.148c.486.73.971 1.094 1.456 1.094zm1.848-16.1h3.864a1.971 1.971 0 011.442.6 2 2 0 01.6 1.47 2.31 2.31 0 01-.6 1.6 1.9 1.9 0 01-1.47.672h-3.836v-4.342zm0 7.644h4.284a2.4 2.4 0 011.792.688 2.472 2.472 0 01.672 1.806 2.406 2.406 0 01-.7 1.75 2.333 2.333 0 01-1.736.714h-4.312v-4.958z"
	  })), _path2$S || (_path2$S = /*#__PURE__*/React.createElement("path", {
	    d: "M56.541 23.924c-.536.037-1.06.18-1.54.42-.12.055-.243.088-.365.136a6.941 6.941 0 00-2.176-2.968A7.027 7.027 0 0048.117 20c-.828 0-1.65.148-2.427.435A7.048 7.048 0 0145.537 19a6.614 6.614 0 01.742-3.122 5.68 5.68 0 012.128-2.254 5.96 5.96 0 013.151-.84 7.285 7.285 0 013.3.868c.206.117.436.185.672.2.43 0 .83-.294 1.2-.882a3.513 3.513 0 00.561-1.918.9.9 0 00-.42-.84 9.66 9.66 0 00-5.236-1.456A9.8 9.8 0 0046.65 10.1a10.43 10.43 0 00-3.765 3.752 10.157 10.157 0 00-1.443 5.32 10.399 10.399 0 00.783 3.99L28.486 40.518l-3.672-3.642a7 7 0 10-9.857 9.94l9.23 9.154a6.96 6.96 0 005.37 2.016 7 7 0 005.043-2.64l19-24a6.951 6.951 0 001.37-2.98 6.046 6.046 0 001.483-.884 3.14 3.14 0 00.784-1.134c.203-.456.31-.95.313-1.448a.88.88 0 00-1.009-.976zm-6.073 4.938l-19 24A3 3 0 0127 53.13l-9.23-9.154a3.002 3.002 0 014.23-4.26l6.85 6.792 16.916-21.37a3 3 0 014.705 3.724h-.003z"
	  })));
	}

	var _path$3D;

	function _extends$3F() { _extends$3F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3F.apply(this, arguments); }

	function SvgStarFilled(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3F({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3D || (_path$3D = /*#__PURE__*/React.createElement("path", {
	    d: "M28.202 7.746c1.223-3.661 6.373-3.661 7.596 0l4.974 14.879h15.213c3.863 0 5.49 4.954 2.386 7.267l-12.145 9.05 4.922 14.726c1.233 3.689-2.935 6.818-6.102 4.582L32 49.036 18.954 58.25c-3.167 2.236-7.335-.893-6.102-4.582l4.922-14.726-12.145-9.05c-3.103-2.313-1.477-7.267 2.386-7.267h15.213l4.974-14.88z"
	  })));
	}

	var _path$3E;

	function _extends$3G() { _extends$3G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3G.apply(this, arguments); }

	function SvgStar(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3G({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3E || (_path$3E = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59.763 25.024a4.236 4.236 0 00-4.065-2.915h-14.67L36.046 7.875a4.291 4.291 0 00-8.102-.001l-4.982 14.235H8.292a4.292 4.292 0 00-2.606 7.701l11.987 9.167-4.921 14.763a4.292 4.292 0 006.584 4.836l12.659-9.143 12.66 9.143a4.228 4.228 0 005.051-.02 4.227 4.227 0 001.532-4.817l-4.921-14.762 11.987-9.167a4.237 4.237 0 001.459-4.786zM43.712 35.568a4.295 4.295 0 00-1.466 4.767l4.921 14.762-12.66-9.143a4.284 4.284 0 00-5.024 0l-12.66 9.143 4.922-14.764a4.294 4.294 0 00-1.465-4.765L8.293 26.4h14.67a4.294 4.294 0 004.05-2.873l4.982-14.235 4.982 14.234a4.294 4.294 0 004.051 2.874h14.67l-11.986 9.167z"
	  })));
	}

	var _path$3F, _path2$T;

	function _extends$3H() { _extends$3H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3H.apply(this, arguments); }

	function SvgStop(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3H({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3F || (_path$3F = /*#__PURE__*/React.createElement("path", {
	    d: "M18 32a2 2 0 002 2h24a2 2 0 100-4H20a2 2 0 00-2 2z"
	  })), _path2$T || (_path2$T = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28A28 28 0 0032 4zm0 4c13.255 0 24 10.745 24 24S45.255 56 32 56 8 45.255 8 32 18.745 8 32 8z"
	  })));
	}

	var _path$3G, _path2$U;

	function _extends$3I() { _extends$3I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3I.apply(this, arguments); }

	function SvgStore(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3I({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3G || (_path$3G = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M26 32h-8a6 6 0 00-6 6v4a6 6 0 006 6h8a6 6 0 006-6v-4a6 6 0 00-6-6zm2 10a2 2 0 01-2 2h-8a2 2 0 01-2-2v-4a2 2 0 012-2h8a2 2 0 012 2v4z"
	  })), _path2$U || (_path2$U = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 8a8 8 0 016 2.69A8 8 0 0160 16v32a8 8 0 01-8 8H12a8 8 0 01-8-8V16a8 8 0 018-8h40zm2 5h-4v8a2 2 0 104 0v-8zm-12 0h4v8a2 2 0 11-4 0v-8zm-4 0h-4v8a2 2 0 104 0v-8zm-12 0h4v8a2 2 0 11-4 0v-8zm-4 0h-4v8a2 2 0 104 0v-8zm-8 0v8a2 2 0 11-4 0v-8h4zm26 25v14h8V38a2 2 0 00-2-2h-4a2 2 0 00-2 2zm16 10a4 4 0 01-4 4V38a6 6 0 00-6-6h-4a6 6 0 00-6 6v14H12a4 4 0 01-4-4V25.46a6 6 0 008 0 6 6 0 008 0 6 6 0 008 0 6 6 0 008 0 6 6 0 008 0 6 6 0 008 0V48z"
	  })));
	}

	var _path$3H;

	function _extends$3J() { _extends$3J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3J.apply(this, arguments); }

	function SvgStream(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3J({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3H || (_path$3H = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M9 18a5 5 0 00-5 5v18a5 5 0 005 5h46a5 5 0 005-5V23a5 5 0 00-5-5H9zm13.424 19.748c-.198.162-.378.252-.558.252h-5.4c-.63 0-1.242-1.098-1.242-1.44V26.462c0-.576.918-1.17 1.8-1.17.468 0 .702.216.702.648v9.54h4.68c.45 0 .666.216.666.63 0 .648-.288 1.296-.648 1.638zm3.288.36c-.63 0-1.242-1.098-1.242-1.44V26.462c0-.576.918-1.17 1.8-1.17.468 0 .702.216.702.648v10.206c0 .99-.63 1.962-1.26 1.962zm9.601-1.206c-.288.738-.72 1.206-1.206 1.206h-.522c-.342 0-.666-.234-.99-.702a2.763 2.763 0 01-.27-.522L28.51 26.876a1.265 1.265 0 01-.108-.414c0-.576.918-1.17 1.8-1.17.378 0 .594.144.684.45l3.042 8.622 2.79-8.064c.162-.522.99-1.008 1.782-1.008.468 0 .702.216.702.648 0 .306-.054.594-.162.882l-3.726 10.08zm13.16.846c-.197.162-.377.252-.557.252h-6.102c-.63 0-1.242-1.098-1.242-1.44v-9.99c0-.576.918-1.17 1.8-1.17h5.922c.45 0 .666.216.666.63 0 .648-.288 1.296-.648 1.638-.198.162-.378.252-.558.252h-4.68v2.538h4.41c.414 0 .63.198.63.594 0 .882-.558 1.746-1.134 1.746h-3.906v2.682h5.382c.45 0 .666.216.666.63 0 .648-.288 1.296-.648 1.638z"
	  })));
	}

	var _path$3I;

	function _extends$3K() { _extends$3K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3K.apply(this, arguments); }

	function SvgSuitcase(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3K({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3I || (_path$3I = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 18H42v-6a4.004 4.004 0 00-4-4H26a4.004 4.004 0 00-4 4v6H12a8.01 8.01 0 00-8 8v22a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V26a8.01 8.01 0 00-8-8zm-6 4v30H18V22h28zM26 12h12v6H26v-6zM8 48V26a4.004 4.004 0 014-4h2v30h-2a4.004 4.004 0 01-4-4zm48 0a4.004 4.004 0 01-4 4h-2V22h2a4.004 4.004 0 014 4v22z"
	  })));
	}

	var _path$3J;

	function _extends$3L() { _extends$3L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3L.apply(this, arguments); }

	function SvgSummary(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3L({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3J || (_path$3J = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M48 4H20a8.01 8.01 0 00-8 8v44a4.004 4.004 0 004 4h28a8.01 8.01 0 008-8V8a4.004 4.004 0 00-4-4zm0 48a4.004 4.004 0 01-4 4l-28 .003V12a4.004 4.004 0 014-4h28v44zm-18-8a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm0-12a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm0-12a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm-8 12a2 2 0 114 0 2 2 0 01-4 0zm0-12a2 2 0 114 0 2 2 0 01-4 0zm0 24a2 2 0 114 0 2 2 0 01-4 0z"
	  })));
	}

	var _path$3K;

	function _extends$3M() { _extends$3M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3M.apply(this, arguments); }

	function SvgSupport(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3M({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3K || (_path$3K = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M45.613 30.458c4.401-7.15 2.546-16.484-4.254-21.408-6.8-4.924-16.247-3.774-21.667 2.639-5.42 6.412-4.98 15.918 1.01 21.803 5.988 5.885 15.5 6.158 21.817.627 7.517.282 13.47 6.452 13.481 13.974v2a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4v-2a14.057 14.057 0 014.76-10.52 26.11 26.11 0 0015.653 8.26 3.988 3.988 0 10.29-4A22.089 22.089 0 0114.13 32.93l-.003-.005A21.846 21.846 0 0110 20.093a2 2 0 00-4 0 25.804 25.804 0 004.315 14.315A18.067 18.067 0 004 48.093v2a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8v-2a18.03 18.03 0 00-14.387-17.635zM32 34.093c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12c-.007 6.625-5.376 11.993-12 12z"
	  })));
	}

	var _path$3L;

	function _extends$3N() { _extends$3N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3N.apply(this, arguments); }

	function SvgSustainability(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3N({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3L || (_path$3L = /*#__PURE__*/React.createElement("path", {
	    d: "M58.297 33.471a6.39 6.39 0 00-5.13-1.816 19.997 19.997 0 10-37 3.378c-.055.05-.117.087-.169.14l-10 10a4.005 4.005 0 000 5.655L13.169 58a4 4 0 005.657 0l2-2H43.17a3.973 3.973 0 002.829-1.172L58.297 42.53a6.413 6.413 0 000-9.059zm-20.299.53h-8.427a28.92 28.92 0 01-.997-6H39.42a28.828 28.828 0 01-.997 6.034c-.142-.01-.28-.035-.424-.035zm-17.85 0a15.882 15.882 0 01-2.017-6h6.444c.102 2.02.386 4.028.846 6h-5.274zm13.85-23.658c2.606 1.928 5.03 6.847 5.434 13.657H28.564c.404-6.81 2.828-11.729 5.434-13.657zM43.437 28h6.423a15.843 15.843 0 01-3.021 7.503l-3.123 2.677a6.001 6.001 0 00-1.587-2.512A32.812 32.812 0 0043.437 28zm6.425-4H43.44a28.295 28.295 0 00-3.546-12.875A16.037 16.037 0 0149.862 24zm-21.76-12.875A28.296 28.296 0 0024.556 24h-6.422a16.038 16.038 0 019.968-12.875zM55.47 39.701l-12.3 12.3h-24l-3.171 3.171L8.826 48l10-10h9.241l.007.001h9.924c.26 0 .518.051.759.15.023.014.05.024.074.036a1.998 1.998 0 01-.306 3.743c-.246.047-.496.07-.747.07h-9.78a2 2 0 000 4h10a5.97 5.97 0 001.431-.173 8.006 8.006 0 003.556-1.752l9.217-7.9a2.406 2.406 0 013.267 3.526z"
	  })));
	}

	var _path$3M;

	function _extends$3O() { _extends$3O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3O.apply(this, arguments); }

	function SvgSwitch(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3O({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3M || (_path$3M = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59.369 20.446l-10.77 10.769a2.154 2.154 0 01-3.045-3.046l7.093-7.092H23.385a2.154 2.154 0 010-4.308h29.262l-7.093-7.092A2.154 2.154 0 1148.6 6.63L59.369 17.4a2.153 2.153 0 010 3.045zm-18.754 22.17H11.353l7.093-7.093a2.154 2.154 0 00-3.046-3.046L4.631 43.247a2.153 2.153 0 000 3.045l10.77 10.77a2.154 2.154 0 003.045-3.047l-7.093-7.092h29.262a2.154 2.154 0 000-4.308z"
	  })));
	}

	var _path$3N;

	function _extends$3P() { _extends$3P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3P.apply(this, arguments); }

	function SvgSync(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3P({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3N || (_path$3N = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M10.334 34.167A2.167 2.167 0 018.167 32a23.83 23.83 0 0141.167-16.354v-5.313a2.167 2.167 0 114.333 0v10.834c0 1.196-.97 2.166-2.167 2.166H40.667a2.167 2.167 0 110-4.333h5.864a19.498 19.498 0 00-34.03 13c0 1.197-.97 2.167-2.167 2.167zm43.333-4.334c-1.197 0-2.167.97-2.167 2.167a19.498 19.498 0 01-34.03 13h5.864a2.167 2.167 0 000-4.333H12.5c-1.196 0-2.166.97-2.166 2.166v10.834a2.167 2.167 0 104.333 0v-5.313A23.831 23.831 0 0055.834 32c0-1.197-.97-2.166-2.167-2.167z"
	  })));
	}

	var _path$3O;

	function _extends$3Q() { _extends$3Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Q.apply(this, arguments); }

	function SvgTableView(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3Q({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3O || (_path$3O = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56 53.474c0 .099-.005.196-.013.292.008.077.013.155.013.234 0 1.105-.877 2-1.958 2H10.958C9.877 56 9 55.105 9 54c0-.08.005-.157.013-.234A3.22 3.22 0 019 53.474V10.526C9 9.131 9.895 8 11 8c.152 0 .3.021.442.062.152-.04.31-.062.475-.062h42.166C55.142 8 56 8.895 56 10c0 .08-.005.158-.013.235.008.096.013.193.013.291v42.948zM13 16v16h17V16H13zm39 20H34v16h18V36zm0-4H34V16h18v16zm-39 4h17v16H13V36z"
	  })));
	}

	var _path$3P;

	function _extends$3R() { _extends$3R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3R.apply(this, arguments); }

	function SvgTablet(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3R({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3P || (_path$3P = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M44 4H20a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h24a8.01 8.01 0 008-8V12a8.01 8.01 0 00-8-8zm-28 8a4.004 4.004 0 014-4h24a4.004 4.004 0 014 4v32H16V12zm32 40a4.004 4.004 0 01-4 4H20a4.004 4.004 0 01-4-4v-4h32v4zm-18 0a2 2 0 114 0 2 2 0 01-4 0z"
	  })));
	}

	var _path$3Q, _path2$V;

	function _extends$3S() { _extends$3S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3S.apply(this, arguments); }

	function SvgTag(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3S({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3Q || (_path$3Q = /*#__PURE__*/React.createElement("path", {
	    d: "M38 55.512a7.975 7.975 0 01-5.656-2.34L9.172 30A3.972 3.972 0 018 27.171V12a4 4 0 014-4h15.171A3.972 3.972 0 0130 9.172l23.172 23.172a8.007 8.007 0 010 11.312l-9.516 9.516A7.976 7.976 0 0138 55.512zM12 12v15.171l23.172 23.173a4.006 4.006 0 005.656 0l9.516-9.516a4 4 0 000-5.656L27.172 12H12z"
	  })), _path2$V || (_path2$V = /*#__PURE__*/React.createElement("path", {
	    d: "M21 27a6 6 0 110-12 6 6 0 010 12zm0-8a2 2 0 100 4 2 2 0 000-4z"
	  })));
	}

	var _path$3R, _path2$W;

	function _extends$3T() { _extends$3T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3T.apply(this, arguments); }

	function SvgTime(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3T({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3R || (_path$3R = /*#__PURE__*/React.createElement("path", {
	    d: "M24.482 39.698L30 33.26V18a2 2 0 014 0v16a2 2 0 01-.481 1.302l-6 7a2 2 0 11-3.037-2.604z"
	  })), _path2$W || (_path2$W = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28zm0-4C18.745 56 8 45.255 8 32S18.745 8 32 8s24 10.745 24 24-10.745 24-24 24z"
	  })));
	}

	var _path$3S, _path2$X;

	function _extends$3U() { _extends$3U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3U.apply(this, arguments); }

	function SvgTradePhone(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3U({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3S || (_path$3S = /*#__PURE__*/React.createElement("path", {
	    d: "M31 52a2 2 0 11-4 0 2 2 0 014 0z"
	  })), _path2$X || (_path2$X = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M50.57 22.38a2 2 0 00-2.83 0L45 25.12V12a8 8 0 00-8-8H21a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V36.64a2 2 0 10-4 0V44H17V12a4 4 0 014-4h16a4 4 0 014 4v13.12l-2.73-2.74a2.001 2.001 0 10-2.83 2.83l5.54 5.54a2.89 2.89 0 004.05 0l5.54-5.54a2 2 0 000-2.83zM17 48h24v4a4 4 0 01-4 4H21a4 4 0 01-4-4v-4z"
	  })));
	}

	var _path$3T;

	function _extends$3V() { _extends$3V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3V.apply(this, arguments); }

	function SvgTrailer(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3V({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3T || (_path$3T = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.102 23.833a3.975 3.975 0 00-3.891-.175l-6.782 3.391a8.035 8.035 0 00-4.472-4.476A10.994 10.994 0 1026.521 22h-4.604a8 8 0 10-13.323.772A8.003 8.003 0 004 30v10a8.01 8.01 0 008 8h15.172l-8.586 8.586a2 2 0 102.828 2.828L30 50.828l8.586 8.586a2 2 0 002.828-2.828L32.828 48H40a8.008 8.008 0 007.429-5.05l6.782 3.392A4 4 0 0060 42.764V27.236a3.975 3.975 0 00-1.898-3.403zM28 15a7 7 0 117 7 7.008 7.008 0 01-7-7zm-13-1a4 4 0 110 8 4 4 0 010-8zm29 26a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V30a4.004 4.004 0 014-4h28a4.004 4.004 0 014 4v10zm12 2.764l-8-4v-7.528l8-4v15.528z"
	  })));
	}

	var _path$3U;

	function _extends$3W() { _extends$3W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3W.apply(this, arguments); }

	function SvgTransfer(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3W({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3U || (_path$3U = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M46 41a3 3 0 11-6 0 3 3 0 016 0zm-25-3a3 3 0 100 6 3 3 0 000-6zm39-16v6a4.004 4.004 0 01-4 4h-2v14a4.004 4.004 0 01-4 4v4a4.004 4.004 0 01-4 4h-4a4.004 4.004 0 01-4-4v-4H26v4a4.004 4.004 0 01-4 4h-4a4.004 4.004 0 01-4-4v-4a4.004 4.004 0 01-4-4V32H8a4.004 4.004 0 01-4-4v-6a4.004 4.004 0 014-4h2v-4a8.01 8.01 0 018-8h28a8.01 8.01 0 018 8v4h2a4.004 4.004 0 014 4zM30 32V18H14v14h16zm4 0h16.001v-1.988L50 30l.001-.012v-9.983L50 20v-2H34v14zM14 14h36a4.004 4.004 0 00-4-4H18a4.004 4.004 0 00-4 4zm-4 14v-6H8v6h2zm12 22h-4v4h4v-4zm24 0h-4v4h4v-4zm4.002-4V36H14v10h36.002zM56 22h-2v6h2v-6z"
	  })));
	}

	var _path$3V;

	function _extends$3X() { _extends$3X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3X.apply(this, arguments); }

	function SvgTvNext(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3X({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3V || (_path$3V = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M57.998 6v52a2 2 0 01-2 2h-6a2 2 0 01-2-2V36.35L10.92 59.511a3.22 3.22 0 01-4.257-.769l-.177-.255a3.217 3.217 0 01-.49-1.704V7.376a3.351 3.351 0 011.912-3.1 3.227 3.227 0 013.012.213l37.077 23.16V6a2 2 0 012-2h6a2 2 0 012 2z"
	  })));
	}

	var _path$3W;

	function _extends$3Y() { _extends$3Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Y.apply(this, arguments); }

	function SvgTvPause(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3Y({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3W || (_path$3W = /*#__PURE__*/React.createElement("path", {
	    d: "M54 6v52a2 2 0 01-2 2H42a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2zM22 4H12a2 2 0 00-2 2v52a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2z"
	  })));
	}

	var _path$3X;

	function _extends$3Z() { _extends$3Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Z.apply(this, arguments); }

	function SvgTvPlay(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3Z({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3X || (_path$3X = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M54.362 35.087L15.584 59.429A3.657 3.657 0 0110 56.275V7.59a3.657 3.657 0 015.584-3.155l38.778 24.343a3.738 3.738 0 010 6.309z"
	  })));
	}

	var _path$3Y;

	function _extends$3_() { _extends$3_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3_.apply(this, arguments); }

	function SvgTvPrevious(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3_({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3Y || (_path$3Y = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58 7.376v49.407c0 .602-.17 1.193-.489 1.704l-.177.255a3.219 3.219 0 01-4.257.769L16 36.351V58a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2h6a2 2 0 012 2v21.647l37.077-23.16a3.226 3.226 0 013.012-.212A3.351 3.351 0 0158 7.376z"
	  })));
	}

	var _path$3Z;

	function _extends$3$() { _extends$3$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3$.apply(this, arguments); }

	function SvgTv(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$3$({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3Z || (_path$3Z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 10H12a8.01 8.01 0 00-8 8v22a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V18a8.01 8.01 0 00-8-8zm4 30a4.005 4.005 0 01-4 4H12a4.005 4.005 0 01-4-4V18a4.005 4.005 0 014-4h40a4.005 4.005 0 014 4v22zM44 52a2 2 0 01-2 2H22a2 2 0 110-4h20a2 2 0 012 2zM31 19.993a3.62 3.62 0 01-.633 2.07c-.27.527-.791.88-1.381.937H25v12.993a3.62 3.62 0 01-.633 2.069c-.27.528-.791.881-1.381.938-.5 0-.998-.359-1.497-1.076a2.403 2.403 0 01-.489-1.13V23h-4.014c-.5 0-.998-.359-1.497-1.076a2.402 2.402 0 01-.489-1.13c0-.442.302-.851.906-1.228A3.656 3.656 0 0117.878 19h12c.748 0 1.122.331 1.122.993zm18-.031c0 .447-.082.89-.24 1.309L43.23 37.21a3.85 3.85 0 01-.788 1.309 1.388 1.388 0 01-1.002.48h-.775c-.499 0-.989-.346-1.47-1.041-.165-.24-.3-.5-.4-.775l-5.663-15.832a1.823 1.823 0 01-.16-.615 1.5 1.5 0 01.84-1.189c.543-.359 1.18-.55 1.83-.547a.922.922 0 011.016.668L41.01 34l4.302-13.504c.183-.457.531-.83.975-1.042a3.294 3.294 0 011.67-.454c.695 0 1.042.32 1.042.962z"
	  })));
	}

	var _path$3_;

	function _extends$40() { _extends$40 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$40.apply(this, arguments); }

	function SvgTwitter(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$40({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3_ || (_path$3_ = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M60 15.443a22.752 22.752 0 01-6.596 1.833 11.627 11.627 0 005.05-6.427 22.757 22.757 0 01-7.289 2.817A11.437 11.437 0 0042.778 10c-6.35 0-11.49 5.194-11.49 11.61 0 .906.102 1.8.303 2.648-9.551-.486-18.017-5.103-23.683-12.13a11.71 11.71 0 00-1.556 5.838c0 4.03 2.026 7.582 5.106 9.665a11.327 11.327 0 01-5.207-1.449v.147c0 5.624 3.964 10.32 9.215 11.384a11.61 11.61 0 01-3.023.407c-.739 0-1.456-.067-2.161-.203 1.467 4.617 5.7 7.966 10.727 8.057a22.891 22.891 0 01-14.266 4.968c-.929 0-1.836-.057-2.743-.159C9.084 54.076 15.12 56 21.603 56c21.13 0 32.686-17.687 32.686-33.032 0-.498-.011-1.007-.033-1.505A23.383 23.383 0 0060 15.443z"
	  })));
	}

	var _path$3$;

	function _extends$41() { _extends$41 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$41.apply(this, arguments); }

	function SvgUndo(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$41({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$3$ || (_path$3$ = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M56.461 34.915c.002 12.437-9.3 22.908-21.65 24.373-12.35 1.464-23.842-6.54-26.75-18.633a2 2 0 113.89-.93c2.51 10.416 12.601 17.153 23.182 15.477C45.714 53.528 53.231 44 52.398 33.32c-.832-10.68-9.734-18.927-20.447-18.944-.819 0-1.637.05-2.45.15l3 3a2 2 0 01-2.82 2.83l-5.91-5.91a2.9 2.9 0 01-.86-2.07 2.94 2.94 0 01.86-2.07l5.91-5.9a2 2 0 012.78 2.83l-3.29 3.29c.91-.1 1.825-.15 2.74-.15 13.55.011 24.534 10.99 24.55 24.54z"
	  })));
	}

	var _path$40, _path2$Y;

	function _extends$42() { _extends$42 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$42.apply(this, arguments); }

	function SvgUpload(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$42({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$40 || (_path$40 = /*#__PURE__*/React.createElement("path", {
	    d: "M16.355 32.688l13.171-13.183a3.5 3.5 0 014.947 0l13.172 13.183a2.333 2.333 0 01-3.29 3.29l-10.022-10.01v31.699a2.333 2.333 0 01-4.667 0V25.968l-10.021 10.01a2.333 2.333 0 01-3.29-3.29z"
	  })), _path2$Y || (_path2$Y = /*#__PURE__*/React.createElement("path", {
	    d: "M8.308 34.333c0 1.289-.965 2.334-2.154 2.334-1.19 0-2.154-1.045-2.154-2.334v-21C4 8.18 7.857 4 12.615 4h38.77C56.143 4 60 8.179 60 13.333v21c0 1.289-.964 2.334-2.154 2.334s-2.154-1.045-2.154-2.334v-21c0-2.577-1.928-4.666-4.307-4.666h-38.77c-2.379 0-4.307 2.089-4.307 4.666v21z"
	  })));
	}

	var _path$41;

	function _extends$43() { _extends$43 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$43.apply(this, arguments); }

	function SvgUsb(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$43({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$41 || (_path$41 = /*#__PURE__*/React.createElement("path", {
	    d: "M59.417 30.587l-6-6a2 2 0 10-2.828 2.828L53.175 30H24.83l6.844-6.843a7.004 7.004 0 10-2.828-2.828L19.175 30h-1.467a7 7 0 100 4h7.467l8.977 8.978A3.954 3.954 0 0034.003 44v6a4.004 4.004 0 004 4h6a4.004 4.004 0 004-4v-6a4.004 4.004 0 00-4-4h-6c-.346.004-.69.054-1.023.149L30.831 34h22.344l-2.586 2.587a2 2 0 002.828 2.828l6-6a2 2 0 000-2.828zM35.003 14a3 3 0 110 6 3 3 0 010-6zm9 30v6h-6v-6h6zm-33-9a3 3 0 110-6 3 3 0 010 6z"
	  })));
	}

	var _path$42, _path2$Z;

	function _extends$44() { _extends$44 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$44.apply(this, arguments); }

	function SvgUserAdmin(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$44({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$42 || (_path$42 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M48.015 21c0 8.837-7.164 16-16 16a15.94 15.94 0 01-10.65-4.059 2.01 2.01 0 01-.462.092 14.099 14.099 0 00-7.693 3.072c-1.555 1.258-2.86 2.907-3.852 4.873-.447.886-.868 2.098-1.095 3.286-.075.393-.12.763-.156 1.31l-.03.516-.03.719-.039 1.076c-.022.937.007 1.502.109 2l.041.157.11.34c.16.494.414.899.885 1.425.22.247.39.384.72.58.464.273.94.467 1.379.543l.074.011.19.023.646.054.334.004 1.222-.024 1.002-.008 1.788.006L32.013 53a2 2 0 11.003 4H20.088l-4.979-.01-1.022.003-1.647.03c-.184 0-.345-.003-.498-.01l-.301-.02-.604-.057-.238-.03-.226-.035c-.97-.167-1.884-.538-2.734-1.04a6.592 6.592 0 01-1.667-1.357c-.815-.91-1.358-1.776-1.71-2.857l-.12-.374a6.609 6.609 0 01-.092-.33l-.053-.231c-.153-.755-.206-1.457-.196-2.448l.013-.632.048-1.249c.056-1.337.113-2.004.272-2.837.298-1.565.842-3.129 1.453-4.34 1.242-2.46 2.9-4.557 4.907-6.18a18.122 18.122 0 017.678-3.633A15.925 15.925 0 0116.015 21c0-8.837 7.163-16 16-16 8.836 0 16 7.163 16 16zm-28 0c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12s-5.373-12-12-12c-6.628 0-12 5.373-12 12z"
	  })), _path2$Z || (_path2$Z = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.014 44h-1.2a10.092 10.092 0 00-1.46-3.51l1.07-1.08a2 2 0 00-2.82-2.82l-1.08 1.07a10.09 10.09 0 00-3.51-1.46V35a2 2 0 00-4 0v1.2a10.09 10.09 0 00-3.51 1.46l-1.08-1.07a2 2 0 00-2.82 2.82l1.07 1.08a10.088 10.088 0 00-1.46 3.51h-1.2a2 2 0 100 4h1.2c.26 1.252.756 2.443 1.46 3.51l-1.07 1.08a2 2 0 102.82 2.82l1.08-1.07a10.09 10.09 0 003.51 1.46V57a2 2 0 104 0v-1.2a10.09 10.09 0 003.51-1.46l1.08 1.07a2 2 0 002.82-2.82l-1.07-1.08a10.092 10.092 0 001.46-3.51h1.2a2 2 0 000-4zm-11 8a6 6 0 110-12 6 6 0 010 12z"
	  })));
	}

	var _path$43, _path2$_, _path3$o;

	function _extends$45() { _extends$45 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$45.apply(this, arguments); }

	function SvgVcard(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$45({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$43 || (_path$43 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M31.643 27.077a6.933 6.933 0 01-1.067 3.698c3.74.758 6.425 4.02 6.424 7.802v.885C37 41.416 35.401 43 33.429 43H15.57C13.6 43 12 41.416 12 39.462v-.885c-.001-3.783 2.684-7.044 6.424-7.802a6.933 6.933 0 01-1.067-3.698c0-3.909 3.198-7.077 7.143-7.077s7.143 3.168 7.143 7.077zM28 27.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zM31.583 39c.783 0 1.417-.537 1.417-1.2v-.6c.002-2.265-2.116-4.122-4.788-4.2-2.128 1.581-5.31 1.581-7.438 0-2.666.084-4.776 1.94-4.774 4.2v.6c0 .663.634 1.2 1.417 1.2h14.166z"
	  })), _path2$_ || (_path2$_ = /*#__PURE__*/React.createElement("path", {
	    d: "M39 21h11a2 2 0 110 4H39a2 2 0 110-4zM50 28H39a2 2 0 100 4h11a2 2 0 100-4z"
	  })), _path3$o || (_path3$o = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M10 12h44a6 6 0 016 6v28a6 6 0 01-6 6H10a6 6 0 01-6-6V18a6 6 0 016-6zm0 4h44a2 2 0 012 2v28a2 2 0 01-2 2H10a2 2 0 01-2-2V18a2 2 0 012-2z"
	  })));
	}

	var _path$44;

	function _extends$46() { _extends$46 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$46.apply(this, arguments); }

	function SvgVideoConference(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$46({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$44 || (_path$44 = /*#__PURE__*/React.createElement("path", {
	    d: "M52 12H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h18v4h-8a2 2 0 000 4h20a2 2 0 000-4h-8v-4h18a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zM20 44a8.018 8.018 0 016.28-7.81 9.945 9.945 0 0011.44 0A8.018 8.018 0 0144 44H20zm6-16a6 6 0 116 6 6.006 6.006 0 01-6-6zm30 12a4.005 4.005 0 01-4 4h-4a12.04 12.04 0 00-7.326-11.044 10 10 0 10-17.348 0A12.04 12.04 0 0016 44h-4a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.005 4.005 0 014 4v20z"
	  })));
	}

	var _path$45;

	function _extends$47() { _extends$47 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$47.apply(this, arguments); }

	function SvgVideo(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$47({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$45 || (_path$45 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M52 12H12a8.01 8.01 0 00-8 8v24a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm4 32a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.004 4.004 0 014 4v24zM40.346 28.608l-10.227-6.392A4 4 0 0024 25.608v12.784a4 4 0 006.12 3.392l10.226-6.391a4 4 0 000-6.785zM28 38.392V25.608L38.227 32 28 38.392z"
	  })));
	}

	var _path$46, _path2$$;

	function _extends$48() { _extends$48 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$48.apply(this, arguments); }

	function SvgVoiceSwitch(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$48({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$46 || (_path$46 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M24.037 6.006C26.287 5.971 28 7.808 28 9.948v9.703a4 4 0 01-4 4h-4a2 2 0 00-2 2V38.52a2 2 0 002 2h4a4 4 0 014 4v9.73c0 1.994-1.502 3.783-3.636 3.909-1.549.091-3.927.142-6.374-.153-2.392-.289-5.128-.94-7.176-2.448C5.284 51.48 4 46.677 4 44.013V20.186c0-2.427 1.115-4.949 2.63-7.043 1.533-2.122 3.645-4.043 5.978-5.206 1.711-.853 3.939-1.305 5.942-1.562 2.05-.263 4.072-.347 5.487-.369zM24 10.008c-1.326.023-3.14.103-4.94.334-1.893.243-3.575.63-4.668 1.175-1.667.831-3.305 2.286-4.521 3.97C8.635 17.196 8 18.905 8 20.185v23.827c0 1.44.717 5.03 5.186 8.323 1.208.89 3.11 1.435 5.284 1.698 2.056.248 4.11.217 5.53.138V44.52h-4a6 6 0 01-6-6V25.65a6 6 0 016-6h4v-9.643z"
	  })), _path2$$ || (_path2$$ = /*#__PURE__*/React.createElement("path", {
	    d: "M37.95 32.136a2 2 0 002.828-2.828L36.47 25H48a2 2 0 000-4H37.193l3.585-3.586a2 2 0 00-2.828-2.829l-7.269 7.269a2.009 2.009 0 00-.68 1.559 1.994 1.994 0 00.678 1.452l7.27 7.271zM58 41.348a1.994 1.994 0 00-.68-1.492l-7.27-7.27a2 2 0 10-2.828 2.828L50.808 39H40a2 2 0 100 4h11.53l-4.308 4.308a2 2 0 002.828 2.828l7.27-7.27a2 2 0 00.68-1.518z"
	  })));
	}

	var _path$47;

	function _extends$49() { _extends$49 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$49.apply(this, arguments); }

	function SvgVoicemail(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$49({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$47 || (_path$47 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M49.334 20.083a13 13 0 00-9.75 21.667H24.418a13 13 0 10-9.75 4.333h34.666c7.18 0 13-5.82 13-13s-5.82-13-13-13zM14.668 41.749a8.667 8.667 0 110-17.333 8.667 8.667 0 010 17.333zm34.666 0a8.667 8.667 0 110-17.333 8.667 8.667 0 010 17.333z"
	  })));
	}

	var _path$48;

	function _extends$4a() { _extends$4a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4a.apply(this, arguments); }

	function SvgVolume(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4a({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$48 || (_path$48 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M33.658 9.332a4.32 4.32 0 00-4.722.94L18.103 21.105h-3.436A8.677 8.677 0 006 29.772v4.333a8.677 8.677 0 008.667 8.667h3.436l10.833 10.833a4.333 4.333 0 007.397-3.064V13.335a4.321 4.321 0 00-2.675-4.003zM32 50.542L19.897 38.437h-5.23a4.338 4.338 0 01-4.334-4.333v-4.333a4.338 4.338 0 014.334-4.334h5.23L32 13.335v37.206zm17.333-18.604a22.355 22.355 0 01-4.853 14.41 2.167 2.167 0 01-3.293-2.819A17.987 17.987 0 0045 31.94c.118-4.19-1.23-8.29-3.813-11.591a2.167 2.167 0 013.293-2.819 22.356 22.356 0 014.853 14.41zm8.667 0c0 8.077-2.559 15.697-7.02 20.91a2.167 2.167 0 01-3.293-2.819c3.8-4.439 5.98-11.032 5.98-18.09 0-7.06-2.18-13.652-5.98-18.091a2.167 2.167 0 013.293-2.819C55.44 16.242 58 23.862 58 31.94z"
	  })));
	}

	var _path$49;

	function _extends$4b() { _extends$4b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4b.apply(this, arguments); }

	function SvgWallet(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4b({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$49 || (_path$49 = /*#__PURE__*/React.createElement("path", {
	    d: "M52 16a8.01 8.01 0 00-8-8H10a6.007 6.007 0 00-6 6v34a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V24a8.01 8.01 0 00-8-8zm4 24H46a4 4 0 110-8h10v8zM10 12h34a4.004 4.004 0 014 4H10a2 2 0 110-4zm42 40H12a4.004 4.004 0 01-4-4V19.65a5.96 5.96 0 002 .35h42a4.004 4.004 0 014 4v4H46a8 8 0 000 16h10v4a4.004 4.004 0 01-4 4zm-6-18a2 2 0 110 4 2 2 0 010-4z"
	  })));
	}

	var _path$4a;

	function _extends$4c() { _extends$4c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4c.apply(this, arguments); }

	function SvgWallplug(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4c({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4a || (_path$4a = /*#__PURE__*/React.createElement("path", {
	    d: "M59.412 14.586a1.999 1.999 0 00-2.828 0l-8.586 8.586L40.826 16l8.586-8.586a2 2 0 10-2.828-2.828l-8.586 8.586L34.826 10a4.002 4.002 0 00-5.656 0l-9.586 9.586a17.57 17.57 0 00-3.589 19.589L5.582 49.588a6.242 6.242 0 008.828 8.828l10.413-10.413a17.526 17.526 0 0019.589-3.59l9.586-9.585a4.004 4.004 0 000-5.656L50.826 26l8.586-8.586a1.998 1.998 0 000-2.828zm-47.83 41.002a2.243 2.243 0 01-3.172-3.172l9.7-9.7a15.836 15.836 0 003.173 3.17l-9.701 9.702zm30.002-14.002a13.557 13.557 0 11-19.172-19.172l9.586-9.586L51.17 32l-9.586 9.586z"
	  })));
	}

	var _path$4b;

	function _extends$4d() { _extends$4d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4d.apply(this, arguments); }

	function SvgWarning(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4d({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4b || (_path$4b = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M27.256 39.192c.064 1.344.768 1.984 2.112 1.984 2.752 0 5.44-1.792 5.504-3.584l1.024-25.216c0-1.728-.896-2.56-2.752-2.56-3.52 0-7.168 2.368-7.168 4.608l1.28 24.768zm3.648 16.193c-2.496 0-4.864-4.16-4.864-5.76 0-2.24 3.648-4.608 7.168-4.608 1.856 0 2.816.832 2.816 2.56 0 2.624-1.216 5.312-2.752 6.72-.768.704-1.536 1.088-2.368 1.088z"
	  })));
	}

	var _path$4c;

	function _extends$4e() { _extends$4e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4e.apply(this, arguments); }

	function SvgWeather(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4e({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4c || (_path$4c = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M43 16.873a9 9 0 012.933 17.512A9.468 9.468 0 0149 41.373c0 .494-.038.98-.11 1.453A6.5 6.5 0 0146 54.854v.02H12v-.015a8.5 8.5 0 01-8-8.486c0-4.544 3.882-8.617 8.083-8.523A13.046 13.046 0 0112 36.373c0-7.456 6.268-13.5 14-13.5 2.983 0 5.748.9 8.019 2.433A8.998 8.998 0 0143 16.873zm-17 10c-5.555 0-10 4.287-10 9.5 0 .347.02.689.058 1.025l.518 4.554-4.583-.103C10.1 41.806 8 44.016 8 46.373a4.5 4.5 0 004.232 4.492l.133.008H45.6l.098-.007a2.5 2.5 0 001.104-4.628l-2.269-1.39.404-2.629c.042-.277.064-.56.064-.846 0-3.037-2.462-5.5-5.439-5.5l-3.135.048-.977-2.668c-1.38-3.771-5.14-6.38-9.449-6.38zm26.99 9.962l1.438 1.39a2 2 0 01-2.779 2.877l-1.438-1.39a2 2 0 112.778-2.877zM43 20.873a5 5 0 100 10 5 5 0 000-10zm15 5a2 2 0 010 4h-2a2 2 0 110-4h2zM30.181 14.517l1.439 1.39a2 2 0 01-2.779 2.877l-1.438-1.39a2 2 0 112.778-2.877zm25.696-1.033a2 2 0 01-.049 2.828l-1.439 1.39a2 2 0 01-2.778-2.878l1.438-1.39a2 2 0 012.828.05zM40.917 9a2 2 0 012 2v2a2 2 0 11-4 0v-2a2 2 0 012-2z"
	  })));
	}

	var _path$4d;

	function _extends$4f() { _extends$4f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4f.apply(this, arguments); }

	function SvgWirelessOff(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4f({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4d || (_path$4d = /*#__PURE__*/React.createElement("path", {
	    d: "M36 50a4 4 0 11-8 0 4 4 0 018 0zm20.667-31.19a38.874 38.874 0 00-7.446-4.78l4.259-4.684a2 2 0 00-2.96-2.692l-5.191 5.711a38.87 38.87 0 00-37.996 6.446 2 2 0 002.533 3.095 34.884 34.884 0 0132.53-6.315l-6.148 6.763a26.726 26.726 0 00-21.494 5.881 2 2 0 102.557 3.076A23.017 23.017 0 0132 26c.3 0 .598.027.898.04L10.52 50.653a1.997 1.997 0 00.133 2.825 1.998 1.998 0 002.826-.133l11.962-13.159a10.933 10.933 0 0113.767.524 2 2 0 002.629-3.016A14.979 14.979 0 0032 34c-.325 0-.647.018-.969.039l6.649-7.314a23.002 23.002 0 019.01 4.586 2.001 2.001 0 003.28-1.72 2.002 2.002 0 00-.724-1.356 26.98 26.98 0 00-8.589-4.785l5.755-6.33a34.924 34.924 0 017.722 4.786 1.999 1.999 0 002.533-3.095z"
	  })));
	}

	var _path$4e;

	function _extends$4g() { _extends$4g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4g.apply(this, arguments); }

	function SvgWireless(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4g({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4e || (_path$4e = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M35.85 51.333a4.333 4.333 0 11-8.666 0 4.333 4.333 0 018.666 0zm22.39-33.788c-15.543-12.727-37.903-12.727-53.445 0a2.167 2.167 0 102.744 3.353c13.946-11.42 34.01-11.42 47.956 0a2.166 2.166 0 102.745-3.353zM31.517 34a16.227 16.227 0 00-10.658 4.003 2.167 2.167 0 002.848 3.267 11.852 11.852 0 0115.62 0 2.167 2.167 0 002.848-3.267A16.227 16.227 0 0031.517 34zm0-13a29.28 29.28 0 00-18.683 6.755 2.166 2.166 0 102.77 3.332c9.222-7.672 22.605-7.672 31.827 0a2.167 2.167 0 102.77-3.332A29.28 29.28 0 0031.516 21z"
	  })));
	}

	var _path$4f, _path2$10, _path3$p;

	function _extends$4h() { _extends$4h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4h.apply(this, arguments); }

	function SvgWorldAlert(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4h({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4f || (_path$4f = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M21 10.664A23.897 23.897 0 0132 8c.844 0 1.678.044 2.5.129v5.543L31.172 17A4 4 0 0030 19.828V23.5a2 2 0 104 0v-3.672l3.328-3.328a4 4 0 001.172-2.828V8.89a24.041 24.041 0 0113.07 9.211l-3.484 3.484a2 2 0 102.828 2.828l2.752-2.752a23.812 23.812 0 011.872 5.628c.397 1.994.3 4.648.066 6.93a48.811 48.811 0 01-.512 3.608c-.017.094-.03.165-.04.212l-.01.052-.002.01v.002a2 2 0 003.92.792L57 38.5l1.96.395.002-.008.004-.019.013-.068.047-.248a52.892 52.892 0 00.557-3.923c.243-2.367.397-5.513-.121-8.12C56.909 13.676 45.586 4 32 4 16.536 4 4 16.536 4 32c0 4.29 1.221 8.85 3.284 12.862 2.06 4.006 5.033 7.605 8.668 9.841a2 2 0 002.096-3.406c-2.865-1.764-5.392-4.735-7.207-8.264C9.03 39.509 8 35.57 8 32c0-1.453.13-2.875.376-4.257l9.492-2.11A4 4 0 0021 21.73V10.664zm-4 2.6a24.06 24.06 0 00-7.403 10.11L17 21.73v-8.465z"
	  })), _path2$10 || (_path2$10 = /*#__PURE__*/React.createElement("path", {
	    d: "M19 36a4 4 0 00-4 4v3a4 4 0 004 4h1a2 2 0 100-4h-1v-3h4.813a2 2 0 100-4H19zM39.093 45.072c.024.504.288.744.792.744 1.032 0 2.04-.672 2.064-1.344l.384-9.456c0-.648-.336-.96-1.032-.96-1.32 0-2.688.888-2.688 1.728l.48 9.288zM40.461 51.144c.312 0 .6-.144.888-.408.576-.528 1.032-1.536 1.032-2.52 0-.648-.36-.96-1.056-.96-1.32 0-2.688.888-2.688 1.728 0 .6.888 2.16 1.824 2.16z"
	  })), _path3$p || (_path3$p = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M44.946 26.267c-1.861-3.615-7.03-3.615-8.892 0L23.472 50.712C21.76 54.04 24.177 58 27.919 58h25.164c3.742 0 6.158-3.96 4.446-7.288L44.946 26.267zm-5.335 1.831a1 1 0 011.778 0l12.582 24.445a1 1 0 01-.89 1.457H27.919a1 1 0 01-.889-1.457l12.582-24.445z"
	  })));
	}

	var _path$4g, _path2$11, _path3$q;

	function _extends$4i() { _extends$4i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4i.apply(this, arguments); }

	function SvgWorldOff(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4i({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4g || (_path$4g = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M8.376 27.743A24.145 24.145 0 008 32c0 4.744 1.287 8.678 3.684 12.422a2 2 0 01-3.368 2.156C5.538 42.24 4 37.565 4 32 4 16.536 16.536 4 32 4c5.32 0 10.3 1.486 14.54 4.067a2 2 0 01-2.08 3.416 23.841 23.841 0 00-6.96-2.85v5.039a4 4 0 01-1.172 2.828L33 19.828V23.5a2 2 0 11-4 0v-3.672A4 4 0 0130.172 17l3.328-3.328V8.046C33.004 8.016 32.504 8 32 8c-3.965 0-7.705.961-11 2.664v11.065a4 4 0 01-3.132 3.905l-9.492 2.109zm1.22-4.369L17 21.73v-8.465a24.06 24.06 0 00-7.403 10.11z"
	  })), _path2$11 || (_path2$11 = /*#__PURE__*/React.createElement("path", {
	    d: "M53.93 17.083a1.987 1.987 0 00-.807.466l-4.814 4.376A4 4 0 0047 24.885V28.5h-4a2 2 0 100 4h5.5A2.5 2.5 0 0051 30v-5.115l2.916-2.65A23.72 23.72 0 0156 32c0 13.255-10.745 24-24 24-4.277 0-8.87-1.633-12.498-3.731a2 2 0 00-2.003 3.462C21.518 58.057 26.806 60 32 60c15.464 0 28-12.536 28-28 0-5.1-1.365-9.848-3.748-13.966a2.007 2.007 0 00-1.446-1.01 1.995 1.995 0 00-.877.059z"
	  })), _path3$q || (_path3$q = /*#__PURE__*/React.createElement("path", {
	    d: "M31.641 38.5a2 2 0 012-2h1.641a4 4 0 014 4v6.749a4 4 0 01-4 4h-3.558a4 4 0 01-2.56-.927l-3.944-3.285a2 2 0 112.56-3.074l3.944 3.286h3.558V40.5h-1.641a2 2 0 01-2-2zM5.586 55.758a2 2 0 102.828 2.828L58.586 8.415a2 2 0 00-2.829-2.829L5.586 55.758z"
	  })));
	}

	var _path$4h, _path2$12, _path3$r;

	function _extends$4j() { _extends$4j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4j.apply(this, arguments); }

	function SvgWorldQuestion(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4j({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4h || (_path$4h = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M21 10.664A23.897 23.897 0 0132 8c.84 0 1.675.048 2.5.142v5.53L31.172 17A4 4 0 0030 19.828V23a2 2 0 104 0v-3.172l3.328-3.328a4 4 0 001.172-2.828V8.958c5.3 1.572 9.964 4.944 13.087 9.126l-3.001 3.002a2 2 0 102.828 2.828l2.328-2.328c.9 1.828 1.512 3.745 1.776 5.684a2 2 0 003.964-.54C57.838 14.674 45.547 4 32 4 16.536 4 4 16.536 4 32c0 13 8.597 23.722 20.037 26.446a2 2 0 10.926-3.892C15.403 52.278 8 43.23 8 32c0-1.453.13-2.875.376-4.257l9.492-2.11A4 4 0 0021 21.73V10.664zm-4 2.6a24.06 24.06 0 00-7.403 10.11L17 21.73v-8.465z"
	  })), _path2$12 || (_path2$12 = /*#__PURE__*/React.createElement("path", {
	    d: "M19 36a4 4 0 00-4 4v3a4 4 0 004 4h1a2 2 0 100-4h-1v-3h1.5a2 2 0 100-4H19zM46.518 38.136c0 1.512-.624 2.712-2.52 4.752l-2.472 2.64c-.312.312-.576.456-.84.456-.408 0-.792-.288-1.152-.84-.24-.408-.36-.72-.36-.912 0-.192.096-.384.264-.6l2.328-2.472c1.08-1.176 1.536-1.968 1.536-2.808 0-.96-.792-1.68-1.872-1.68-.936 0-1.632.432-2.664 1.584-.264.288-.456.48-.576.576a.774.774 0 01-.432.144c-.768 0-1.464-1.296-1.464-1.704 0-.168.072-.384.24-.624 1.152-1.728 3.144-2.808 5.184-2.808 1.896 0 3.408.816 4.2 2.112.408.648.6 1.392.6 2.184zM41.814 50.736c-.288.264-.576.408-.888.408-.936 0-1.824-1.56-1.824-2.16 0-.84 1.368-1.728 2.688-1.728.696 0 1.056.312 1.056.96 0 .984-.456 1.992-1.032 2.52z"
	  })), _path3$r || (_path3$r = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M24 42.5C24 32.835 31.835 25 41.5 25S59 32.835 59 42.5 51.165 60 41.5 60 24 52.165 24 42.5zM41.5 29C34.044 29 28 35.044 28 42.5S34.044 56 41.5 56 55 49.956 55 42.5 48.956 29 41.5 29z"
	  })));
	}

	var _path$4i;

	function _extends$4k() { _extends$4k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4k.apply(this, arguments); }

	function SvgWorld(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4k({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4i || (_path$4i = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm6.462 10.77V9.21a23.767 23.767 0 0112.832 9.066l-3.586 3.586c-.404.404-.63.951-.631 1.523v4.307h-2.755l-1.172-3.516a4.303 4.303 0 00-4.087-2.945h-4.91v-1.262l3.678-3.677c.403-.404.63-.952.63-1.523zm-21.54-1.032v7.881l-6.828 1.366a23.81 23.81 0 016.829-9.247zM32 55.692a23.67 23.67 0 01-23.285-28.04l.016-.002 9.038-1.807a4.32 4.32 0 003.462-4.224V10.908A23.537 23.537 0 0134.154 8.41v5.467l-3.046 3.046a4.279 4.279 0 00-1.262 3.046v1.262a4.312 4.312 0 004.308 4.307h4.91l1.662 4.99A2.154 2.154 0 0042.769 32h6.462c1.19 0 2.154-.964 2.154-2.154v-5.569l2.146-2.146A23.678 23.678 0 0132 55.692zm2.154-19.384H21.23a4.312 4.312 0 00-4.308 4.307v2.154a4.312 4.312 0 004.308 4.308h3.416l3.045 3.046a4.278 4.278 0 003.046 1.262h3.416a4.312 4.312 0 004.307-4.308v-6.462a4.312 4.312 0 00-4.307-4.307zm0 10.769h-3.416l-3.046-3.046a4.279 4.279 0 00-3.045-1.262H21.23v-2.154h12.923v6.462z"
	  })));
	}

	var _path$4j;

	function _extends$4l() { _extends$4l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4l.apply(this, arguments); }

	function SvgYoutube(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4l({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4j || (_path$4j = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M59.142 20.696s-.644-3.913-2.146-5.653c-2.145-2.173-4.506-2.173-5.578-2.39C43.694 12 31.893 12 31.893 12s-11.801 0-19.525.652c-1.073.218-3.433.218-5.579 2.392-1.716 1.739-2.145 5.652-2.145 5.652S4 25.26 4 29.826v4.348c0 4.565.644 9.13.644 9.13s.643 3.913 2.145 5.652c2.146 2.174 4.935 2.174 6.223 2.392 4.505.435 19.095.652 19.095.652s11.801 0 19.525-.652c1.073-.218 3.433-.218 5.579-2.392 1.716-1.739 2.145-5.652 2.145-5.652S60 38.74 60 34.174v-4.348c-.215-4.565-.858-9.13-.858-9.13zM26.1 39.39v-15.87l15.019 8.044-15.02 7.826z"
	  })));
	}

	var _path$4k, _path2$13, _path3$s;

	function _extends$4m() { _extends$4m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4m.apply(this, arguments); }

	function SvgZoom(props) {
	  return /*#__PURE__*/React.createElement("svg", _extends$4m({
	    viewBox: "0 0 64 64",
	    xmlns: "http://www.w3.org/2000/svg",
	    fill: "currentColor"
	  }, props), _path$4k || (_path$4k = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M58.607 55.543L47.773 44.71a2.153 2.153 0 00-.658-.446c8.248-9.776 7.325-24.316-2.094-32.97-9.418-8.655-23.985-8.347-33.03.698-9.044 9.044-9.352 23.61-.698 33.03 8.655 9.418 23.195 10.342 32.971 2.093.106.245.258.468.445.658l10.834 10.834a2.166 2.166 0 103.064-3.064zm-29.699-7.135c-10.77 0-19.5-8.73-19.5-19.5s8.73-19.5 19.5-19.5 19.5 8.73 19.5 19.5c-.013 10.764-8.736 19.488-19.5 19.5z"
	  })), _path2$13 || (_path2$13 = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M29 18a2 2 0 012 2v18a2 2 0 11-4 0V20a2 2 0 012-2z"
	  })), _path3$s || (_path3$s = /*#__PURE__*/React.createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M18 29a2 2 0 012-2h18a2 2 0 110 4H20a2 2 0 01-2-2z"
	  })));
	}

	var iconData = {
	  '4g': Svg4G,
	  '5g': Svg5G,
	  add: SvgAdd,
	  'address-book': SvgAddressBook,
	  'ai-robot': SvgAiRobot,
	  airplay: SvgAirplay,
	  'alarm-off': SvgAlarmOff,
	  alarm: SvgAlarm,
	  'alert-filled': SvgAlertFilled,
	  alert: SvgAlert,
	  'arrow-down': SvgArrowDown,
	  'arrow-left': SvgArrowLeft,
	  'arrow-right': SvgArrowRight,
	  'arrow-subdirectory': SvgArrowSubdirectory,
	  'arrow-up': SvgArrowUp,
	  attachment: SvgAttachment,
	  'b2b-customer': SvgB2BCustomer,
	  bag: SvgBag,
	  'bar-chart': SvgBarChart,
	  basketball: SvgBasketball,
	  battery: SvgBattery,
	  'blood-pressure': SvgBloodPressure,
	  broadband: SvgBroadband,
	  'broken-phone': SvgBrokenPhone,
	  bulb: SvgBulb,
	  'business-continuity': SvgBusinessContinuity,
	  'business-intelligence': SvgBusinessIntelligence,
	  calendar: SvgCalendar,
	  camera: SvgCamera,
	  'card-view': SvgCardView,
	  care: SvgCare,
	  cart: SvgCart,
	  cast: SvgCast,
	  'chat-robot': SvgChatRobot,
	  chat: SvgChat,
	  'check-circle-filled': SvgCheckCircleFilled,
	  'check-circle': SvgCheckCircle,
	  checkmark: SvgCheckmark,
	  'chevron-down': SvgChevronDown,
	  'chevron-left': SvgChevronLeft,
	  'chevron-right': SvgChevronRight,
	  'chevron-up': SvgChevronUp,
	  'child-1': SvgChild1,
	  'child-2': SvgChild2,
	  'close-circle': SvgCloseCircle,
	  close: SvgClose,
	  cloud: SvgCloud,
	  coffee: SvgCoffee,
	  'connected-building': SvgConnectedBuilding,
	  connected: SvgConnected,
	  conversation: SvgConversation,
	  copy: SvgCopy,
	  'core-router': SvgCoreRouter,
	  'credit-card': SvgCreditCard,
	  'customer-dialogue': SvgCustomerDialogue,
	  'daas-device': SvgDaasDevice,
	  'data-transfer': SvgDataTransfer,
	  delete: SvgDelete,
	  delivery: SvgDelivery,
	  desktop: SvgDesktop,
	  devices: SvgDevices,
	  dislike: SvgDislike,
	  doc: SvgDoc,
	  'document-doc': SvgDocumentDoc,
	  'document-edit': SvgDocumentEdit,
	  'document-pdf': SvgDocumentPdf,
	  'document-ppt': SvgDocumentPpt,
	  dot: SvgDot,
	  download: SvgDownload,
	  'dsl-hub': SvgDslHub,
	  edit: SvgEdit,
	  education: SvgEducation,
	  efficiency: SvgEfficiency,
	  email: SvgEmail,
	  'end-user': SvgEndUser,
	  entertainment: SvgEntertainment,
	  environment: SvgEnvironment,
	  'error-filled': SvgErrorFilled,
	  error: SvgError,
	  'esim-simcard': SvgEsimSimcard,
	  euro: SvgEuro,
	  excel: SvgExcel,
	  external: SvgExternal,
	  'face-id': SvgFaceId,
	  facebook: SvgFacebook,
	  fiber: SvgFiber,
	  film: SvgFilm,
	  filter: SvgFilter,
	  fingerprint: SvgFingerprint,
	  focus: SvgFocus,
	  'folder-copy': SvgFolderCopy,
	  'folder-new': SvgFolderNew,
	  folder: SvgFolder,
	  food: SvgFood,
	  fraud: SvgFraud,
	  games: SvgGames,
	  'getting-started': SvgGettingStarted,
	  gif: SvgGif,
	  graph: SvgGraph,
	  'grid-view': SvgGridView,
	  handshake: SvgHandshake,
	  headphones: SvgHeadphones,
	  'heart-filled': SvgHeartFilled,
	  heart: SvgHeart,
	  help: SvgHelp,
	  helppi: SvgHelppi,
	  'home-care': SvgHomeCare,
	  'home-installation': SvgHomeInstallation,
	  home: SvgHome,
	  image: SvgImage,
	  industry: SvgIndustry,
	  infinite: SvgInfinite,
	  'info-filled': SvgInfoFilled,
	  info: SvgInfo,
	  instagram: SvgInstagram,
	  internet: SvgInternet,
	  invoice: SvgInvoice,
	  'job-search': SvgJobSearch,
	  kontantkort: SvgKontantkort,
	  laptop: SvgLaptop,
	  'late-payment': SvgLatePayment,
	  letter: SvgLetter,
	  like: SvgLike,
	  link: SvgLink,
	  linkedin: SvgLinkedin,
	  'list-view': SvgListView,
	  'lock-closed': SvgLockClosed,
	  'lock-open': SvgLockOpen,
	  login: SvgLogin,
	  logout: SvgLogout,
	  map: SvgMap,
	  'media-content': SvgMediaContent,
	  megaphone: SvgMegaphone,
	  menu: SvgMenu,
	  microphone: SvgMicrophone,
	  minus: SvgMinus,
	  mms: SvgMms,
	  moisture: SvgMoisture,
	  'money-back': SvgMoneyBack,
	  'money-euro': SvgMoneyEuro,
	  'money-krone': SvgMoneyKrone,
	  'more-horizontal': SvgMoreHorizontal,
	  'more-vertical': SvgMoreVertical,
	  music: SvgMusic,
	  mute: SvgMute,
	  network: SvgNetwork,
	  'new-contact': SvgNewContact,
	  'new-group': SvgNewGroup,
	  news: SvgNews,
	  offering: SvgOffering,
	  offshore: SvgOffshore,
	  optimization: SvgOptimization,
	  'org-chart': SvgOrgChart,
	  'parental-guide': SvgParentalGuide,
	  'password-invisible': SvgPasswordInvisible,
	  'password-visible': SvgPasswordVisible,
	  'pay-monthly': SvgPayMonthly,
	  'pay-once': SvgPayOnce,
	  'payment-success': SvgPaymentSuccess,
	  pebble: SvgPebble,
	  'people-hub': SvgPeopleHub,
	  people: SvgPeople,
	  'phone-recycling': SvgPhoneRecycling,
	  'phone-ringing': SvgPhoneRinging,
	  phone: SvgPhone,
	  'pie-chart': SvgPieChart,
	  plane: SvgPlane,
	  play: SvgPlay,
	  'player-settings': SvgPlayerSettings,
	  'plus-minus': SvgPlusMinus,
	  plus: SvgPlus,
	  police: SvgPolice,
	  portal: SvgPortal,
	  'premises-datacenter': SvgPremisesDatacenter,
	  'premises-large': SvgPremisesLarge,
	  'premises-medium': SvgPremisesMedium,
	  'premises-small': SvgPremisesSmall,
	  premises: SvgPremises,
	  present: SvgPresent,
	  'press-button': SvgPressButton,
	  price: SvgPrice,
	  print: SvgPrint,
	  pulse: SvgPulse,
	  'question-filled': SvgQuestionFilled,
	  question: SvgQuestion,
	  rack: SvgRack,
	  record: SvgRecord,
	  recycle: SvgRecycle,
	  'refill-card': SvgRefillCard,
	  register: SvgRegister,
	  'remote-control': SvgRemoteControl,
	  repair: SvgRepair,
	  report: SvgReport,
	  reservation: SvgReservation,
	  reverse: SvgReverse,
	  roaming: SvgRoaming,
	  router: SvgRouter,
	  satellite: SvgSatellite,
	  save: SvgSave,
	  savings: SvgSavings,
	  search: SvgSearch,
	  'secure-device': SvgSecureDevice,
	  'secured-1': SvgSecured1,
	  'secured-2': SvgSecured2,
	  send: SvgSend,
	  'sense-car': SvgSenseCar,
	  server: SvgServer,
	  'service-device': SvgServiceDevice,
	  'service-supervision': SvgServiceSupervision,
	  services: SvgServices,
	  settings: SvgSettings,
	  share: SvgShare,
	  shopping: SvgShopping,
	  shuffle: SvgShuffle,
	  signature: SvgSignature,
	  simcard: SvgSimcard,
	  'skip-back-10sec': SvgSkipBack10Sec,
	  'skip-back-30sec': SvgSkipBack30Sec,
	  'skip-forward-10sec': SvgSkipForward10Sec,
	  'skip-forward-30sec': SvgSkipForward30Sec,
	  'slow-wifi': SvgSlowWifi,
	  'smart-wifi': SvgSmartWifi,
	  smartphone: SvgSmartphone,
	  smartwatch: SvgSmartwatch,
	  'smiley-happy': SvgSmileyHappy,
	  'smiley-sad': SvgSmileySad,
	  sms: SvgSms,
	  snapchat: SvgSnapchat,
	  snowflake: SvgSnowflake,
	  sorter: SvgSorter,
	  speedometer: SvgSpeedometer,
	  'spell-check': SvgSpellCheck,
	  'star-filled': SvgStarFilled,
	  star: SvgStar,
	  stop: SvgStop,
	  store: SvgStore,
	  stream: SvgStream,
	  suitcase: SvgSuitcase,
	  summary: SvgSummary,
	  support: SvgSupport,
	  sustainability: SvgSustainability,
	  switch: SvgSwitch,
	  sync: SvgSync,
	  'table-view': SvgTableView,
	  tablet: SvgTablet,
	  tag: SvgTag,
	  time: SvgTime,
	  'trade-phone': SvgTradePhone,
	  trailer: SvgTrailer,
	  transfer: SvgTransfer,
	  'tv-next': SvgTvNext,
	  'tv-pause': SvgTvPause,
	  'tv-play': SvgTvPlay,
	  'tv-previous': SvgTvPrevious,
	  tv: SvgTv,
	  twitter: SvgTwitter,
	  undo: SvgUndo,
	  upload: SvgUpload,
	  usb: SvgUsb,
	  'user-admin': SvgUserAdmin,
	  vcard: SvgVcard,
	  'video-conference': SvgVideoConference,
	  video: SvgVideo,
	  'voice-switch': SvgVoiceSwitch,
	  voicemail: SvgVoicemail,
	  volume: SvgVolume,
	  wallet: SvgWallet,
	  wallplug: SvgWallplug,
	  warning: SvgWarning,
	  weather: SvgWeather,
	  'wireless-off': SvgWirelessOff,
	  wireless: SvgWireless,
	  'world-alert': SvgWorldAlert,
	  'world-off': SvgWorldOff,
	  'world-question': SvgWorldQuestion,
	  world: SvgWorld,
	  youtube: SvgYoutube,
	  zoom: SvgZoom
	};

	var nativePropertyIsEnumerable$1 = {}.propertyIsEnumerable;
	var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG$1 = getOwnPropertyDescriptor$4 && !nativePropertyIsEnumerable$1.call({ 1: 2 }, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	var f$9 = NASHORN_BUG$1 ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$4(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : nativePropertyIsEnumerable$1;

	var objectPropertyIsEnumerable$1 = {
		f: f$9
	};

	var createPropertyDescriptor$1 = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var toString$4 = {}.toString;

	var classofRaw$1 = function (it) {
	  return toString$4.call(it).slice(8, -1);
	};

	var split$1 = ''.split;

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var indexedObject$1 = fails$1(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins
	  return !Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classofRaw$1(it) == 'String' ? split$1.call(it, '') : Object(it);
	} : Object;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	var requireObjectCoercible$1 = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on " + it);
	  return it;
	};

	// toObject with fallback for non-array-like ES3 strings



	var toIndexedObject$1 = function (it) {
	  return indexedObject$1(requireObjectCoercible$1(it));
	};

	var hasOwnProperty$h = {}.hasOwnProperty;

	var has$2 = function (it, key) {
	  return hasOwnProperty$h.call(it, key);
	};

	var nativeGetOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	var f$a = descriptors$1 ? nativeGetOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject$1(O);
	  P = toPrimitive$1(P, true);
	  if (ie8DomDefine$1) try {
	    return nativeGetOwnPropertyDescriptor$2(O, P);
	  } catch (error) { /* empty */ }
	  if (has$2(O, P)) return createPropertyDescriptor$1(!objectPropertyIsEnumerable$1.f.call(O, P), O[P]);
	};

	var objectGetOwnPropertyDescriptor$1 = {
		f: f$a
	};

	var createNonEnumerableProperty$1 = descriptors$1 ? function (object, key, value) {
	  return objectDefineProperty$1.f(object, key, createPropertyDescriptor$1(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var setGlobal$1 = function (key, value) {
	  try {
	    createNonEnumerableProperty$1(global$2, key, value);
	  } catch (error) {
	    global$2[key] = value;
	  } return value;
	};

	var SHARED$1 = '__core-js_shared__';
	var store$2 = global$2[SHARED$1] || setGlobal$1(SHARED$1, {});

	var sharedStore$1 = store$2;

	var functionToString$1 = Function.toString;

	// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
	if (typeof sharedStore$1.inspectSource != 'function') {
	  sharedStore$1.inspectSource = function (it) {
	    return functionToString$1.call(it);
	  };
	}

	var inspectSource$1 = sharedStore$1.inspectSource;

	var WeakMap$4 = global$2.WeakMap;

	var nativeWeakMap$1 = typeof WeakMap$4 === 'function' && /native code/.test(inspectSource$1(WeakMap$4));

	var shared$1 = createCommonjsModule(function (module) {
	(module.exports = function (key, value) {
	  return sharedStore$1[key] || (sharedStore$1[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.8.2',
	  mode:  'global',
	  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
	});
	});

	var id$1 = 0;
	var postfix$1 = Math.random();

	var uid$1 = function (key) {
	  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$1 + postfix$1).toString(36);
	};

	var keys$7 = shared$1('keys');

	var sharedKey$1 = function (key) {
	  return keys$7[key] || (keys$7[key] = uid$1(key));
	};

	var hiddenKeys$2 = {};

	var WeakMap$5 = global$2.WeakMap;
	var set$1, get$2, has$3;

	var enforce$1 = function (it) {
	  return has$3(it) ? get$2(it) : set$1(it, {});
	};

	var getterFor$1 = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject$2(it) || (state = get$2(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};

	if (nativeWeakMap$1) {
	  var store$3 = sharedStore$1.state || (sharedStore$1.state = new WeakMap$5());
	  var wmget$1 = store$3.get;
	  var wmhas$1 = store$3.has;
	  var wmset$1 = store$3.set;
	  set$1 = function (it, metadata) {
	    metadata.facade = it;
	    wmset$1.call(store$3, it, metadata);
	    return metadata;
	  };
	  get$2 = function (it) {
	    return wmget$1.call(store$3, it) || {};
	  };
	  has$3 = function (it) {
	    return wmhas$1.call(store$3, it);
	  };
	} else {
	  var STATE$1 = sharedKey$1('state');
	  hiddenKeys$2[STATE$1] = true;
	  set$1 = function (it, metadata) {
	    metadata.facade = it;
	    createNonEnumerableProperty$1(it, STATE$1, metadata);
	    return metadata;
	  };
	  get$2 = function (it) {
	    return has$2(it, STATE$1) ? it[STATE$1] : {};
	  };
	  has$3 = function (it) {
	    return has$2(it, STATE$1);
	  };
	}

	var internalState$1 = {
	  set: set$1,
	  get: get$2,
	  has: has$3,
	  enforce: enforce$1,
	  getterFor: getterFor$1
	};

	var redefine$1 = createCommonjsModule(function (module) {
	var getInternalState = internalState$1.get;
	var enforceInternalState = internalState$1.enforce;
	var TEMPLATE = String(String).split('String');

	(module.exports = function (O, key, value, options) {
	  var unsafe = options ? !!options.unsafe : false;
	  var simple = options ? !!options.enumerable : false;
	  var noTargetGet = options ? !!options.noTargetGet : false;
	  var state;
	  if (typeof value == 'function') {
	    if (typeof key == 'string' && !has$2(value, 'name')) {
	      createNonEnumerableProperty$1(value, 'name', key);
	    }
	    state = enforceInternalState(value);
	    if (!state.source) {
	      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
	    }
	  }
	  if (O === global$2) {
	    if (simple) O[key] = value;
	    else setGlobal$1(key, value);
	    return;
	  } else if (!unsafe) {
	    delete O[key];
	  } else if (!noTargetGet && O[key]) {
	    simple = true;
	  }
	  if (simple) O[key] = value;
	  else createNonEnumerableProperty$1(O, key, value);
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, 'toString', function toString() {
	  return typeof this == 'function' && getInternalState(this).source || inspectSource$1(this);
	});
	});

	var path$1 = global$2;

	var aFunction$1 = function (variable) {
	  return typeof variable == 'function' ? variable : undefined;
	};

	var getBuiltIn$1 = function (namespace, method) {
	  return arguments.length < 2 ? aFunction$1(path$1[namespace]) || aFunction$1(global$2[namespace])
	    : path$1[namespace] && path$1[namespace][method] || global$2[namespace] && global$2[namespace][method];
	};

	var ceil$1 = Math.ceil;
	var floor$1 = Math.floor;

	// `ToInteger` abstract operation
	// https://tc39.es/ecma262/#sec-tointeger
	var toInteger$1 = function (argument) {
	  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil$1)(argument);
	};

	var min$2 = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	var toLength$1 = function (argument) {
	  return argument > 0 ? min$2(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	var max$1 = Math.max;
	var min$3 = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	var toAbsoluteIndex$1 = function (index, length) {
	  var integer = toInteger$1(index);
	  return integer < 0 ? max$1(integer + length, 0) : min$3(integer, length);
	};

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod$2 = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject$1($this);
	    var length = toLength$1(O.length);
	    var index = toAbsoluteIndex$1(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	var arrayIncludes$2 = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod$2(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod$2(false)
	};

	var indexOf$6 = arrayIncludes$2.indexOf;


	var objectKeysInternal$1 = function (object, names) {
	  var O = toIndexedObject$1(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !has$2(hiddenKeys$2, key) && has$2(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has$2(O, key = names[i++])) {
	    ~indexOf$6(result, key) || result.push(key);
	  }
	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys$1 = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];

	var hiddenKeys$3 = enumBugKeys$1.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	var f$b = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return objectKeysInternal$1(O, hiddenKeys$3);
	};

	var objectGetOwnPropertyNames$1 = {
		f: f$b
	};

	var f$c = Object.getOwnPropertySymbols;

	var objectGetOwnPropertySymbols$1 = {
		f: f$c
	};

	// all object keys, includes non-enumerable and symbols
	var ownKeys$2 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = objectGetOwnPropertyNames$1.f(anObject$1(it));
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1.f;
	  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
	};

	var copyConstructorProperties = function (target, source) {
	  var keys = ownKeys$2(source);
	  var defineProperty = objectDefineProperty$1.f;
	  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!has$2(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	  }
	};

	var replacement$1 = /#|\.prototype\./;

	var isForced$1 = function (feature, detection) {
	  var value = data$1[normalize$1(feature)];
	  return value == POLYFILL$1 ? true
	    : value == NATIVE$1 ? false
	    : typeof detection == 'function' ? fails$1(detection)
	    : !!detection;
	};

	var normalize$1 = isForced$1.normalize = function (string) {
	  return String(string).replace(replacement$1, '.').toLowerCase();
	};

	var data$1 = isForced$1.data = {};
	var NATIVE$1 = isForced$1.NATIVE = 'N';
	var POLYFILL$1 = isForced$1.POLYFILL = 'P';

	var isForced_1$1 = isForced$1;

	var getOwnPropertyDescriptor$5 = objectGetOwnPropertyDescriptor$1.f;






	/*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/
	var _export$1 = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global$2;
	  } else if (STATIC) {
	    target = global$2[TARGET] || setGlobal$1(TARGET, {});
	  } else {
	    target = (global$2[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.noTargetGet) {
	      descriptor = getOwnPropertyDescriptor$5(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced_1$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty === typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
	    }
	    // extend global
	    redefine$1(target, key, sourceProperty, options);
	  }
	};

	var quot = /"/g;

	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	// https://tc39.es/ecma262/#sec-createhtml
	var createHtml = function (string, tag, attribute, value) {
	  var S = String(requireObjectCoercible$1(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};

	// check the existence of a method, lowercase
	// of a tag and escaping quotes in arguments
	var stringHtmlForced = function (METHOD_NAME) {
	  return fails$1(function () {
	    var test = ''[METHOD_NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  });
	};

	// `String.prototype.link` method
	// https://tc39.es/ecma262/#sec-string.prototype.link
	_export$1({ target: 'String', proto: true, forced: stringHtmlForced('link') }, {
	  link: function link(url) {
	    return createHtml(this, 'a', 'href', url);
	  }
	});

	var styles$5 = {"link":"telia-react-link"};

	// get consumer context using 'useContext' hook
	var LinkAdapterContext = /*#__PURE__*/React.createContext(null);

	var LinkAdapterProvider = function LinkAdapterProvider(_ref) {
	  var linkAdapter = _ref.linkAdapter,
	      children = _ref.children;
	  return /*#__PURE__*/React__default['default'].createElement(LinkAdapterContext.Provider, {
	    value: linkAdapter
	  }, children);
	};

	LinkAdapterProvider.Context = LinkAdapterContext;

	var useLinkAdapter = function useLinkAdapter() {
	  var providedAdapter = React__default['default'].useContext(LinkAdapterProvider.Context);
	  return providedAdapter;
	};

	var _excluded$3 = ["to", "children", "openInNewWindow", "removeRelAttribute"];

	var DefaultLinkAdapter = function DefaultLinkAdapter(_ref) {
	  var to = _ref.to,
	      children = _ref.children,
	      _ref$openInNewWindow = _ref.openInNewWindow,
	      openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow,
	      _ref$removeRelAttribu = _ref.removeRelAttribute,
	      removeRelAttribute = _ref$removeRelAttribu === void 0 ? false : _ref$removeRelAttribu,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$3);

	  if (removeRelAttribute) {
	    return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({}, props, {
	      href: to,
	      target: openInNewWindow ? '_blank' : undefined,
	      tabIndex: 0,
	      tagName: "a"
	    }), children);
	  } else {
	    return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({}, props, {
	      href: to,
	      target: openInNewWindow ? '_blank' : undefined,
	      rel: "noopener noreferrer",
	      tabIndex: 0,
	      tagName: "a"
	    }), children);
	  }
	};

	var _excluded$4 = ["children", "openInNewWindow", "color", "hoverColor", "linkAdapter", "className", "occupyHorizontalSpace", "removeRelAttribute"];

	function ownKeys$3(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$3(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$3(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }

	var Link = function Link(_ref) {
	  var children = _ref.children,
	      _ref$openInNewWindow = _ref.openInNewWindow,
	      openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow,
	      _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'purple500' : _ref$color,
	      _ref$hoverColor = _ref.hoverColor,
	      hoverColor = _ref$hoverColor === void 0 ? 'purple400' : _ref$hoverColor,
	      linkAdapter = _ref.linkAdapter,
	      className = _ref.className,
	      _ref$occupyHorizontal = _ref.occupyHorizontalSpace,
	      occupyHorizontalSpace = _ref$occupyHorizontal === void 0 ? false : _ref$occupyHorizontal,
	      _ref$removeRelAttribu = _ref.removeRelAttribute,
	      removeRelAttribute = _ref$removeRelAttribu === void 0 ? false : _ref$removeRelAttribu,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$4);

	  // Figure out which adapter to use
	  var providedAdapter = useLinkAdapter();
	  var adapter = linkAdapter || providedAdapter || DefaultLinkAdapter; // Wrap the styled children using a interchangeable adapter

	  return adapter(_objectSpread$1(_objectSpread$1({
	    openInNewWindow: openInNewWindow,
	    removeRelAttribute: removeRelAttribute,
	    className: classnames([styles$5.link, className])
	  }, props), {}, {
	    children: /*#__PURE__*/React__default['default'].createElement(Element$2, {
	      color: color,
	      hoverColor: hoverColor,
	      tagName: "span",
	      occupyHorizontalSpace: occupyHorizontalSpace
	    }, children)
	  }));
	};

	//This is auto-generated file from scripts/process-icons.js
	var supportedIconNames = ['4g', '5g', 'add', 'address-book', 'ai-robot', 'airplay', 'alarm-off', 'alarm', 'alert-filled', 'alert', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-subdirectory', 'arrow-up', 'attachment', 'b2b-customer', 'bag', 'bar-chart', 'basketball', 'battery', 'blood-pressure', 'broadband', 'broken-phone', 'bulb', 'business-continuity', 'business-intelligence', 'calendar', 'camera', 'card-view', 'care', 'cart', 'cast', 'chat-robot', 'chat', 'check-circle-filled', 'check-circle', 'checkmark', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'child-1', 'child-2', 'close-circle', 'close', 'cloud', 'coffee', 'connected-building', 'connected', 'conversation', 'copy', 'core-router', 'credit-card', 'customer-dialogue', 'daas-device', 'data-transfer', 'delete', 'delivery', 'desktop', 'devices', 'dislike', 'doc', 'document-doc', 'document-edit', 'document-pdf', 'document-ppt', 'dot', 'download', 'dsl-hub', 'edit', 'education', 'efficiency', 'email', 'end-user', 'entertainment', 'environment', 'error-filled', 'error', 'esim-simcard', 'euro', 'excel', 'external', 'face-id', 'facebook', 'fiber', 'film', 'filter', 'fingerprint', 'focus', 'folder-copy', 'folder-new', 'folder', 'food', 'fraud', 'games', 'getting-started', 'gif', 'graph', 'grid-view', 'handshake', 'headphones', 'heart-filled', 'heart', 'help', 'helppi', 'home-care', 'home-installation', 'home', 'image', 'industry', 'infinite', 'info-filled', 'info', 'instagram', 'internet', 'invoice', 'job-search', 'kontantkort', 'laptop', 'late-payment', 'letter', 'like', 'link', 'linkedin', 'list-view', 'lock-closed', 'lock-open', 'login', 'logout', 'map', 'media-content', 'megaphone', 'menu', 'microphone', 'minus', 'mms', 'moisture', 'money-back', 'money-euro', 'money-krone', 'more-horizontal', 'more-vertical', 'music', 'mute', 'network', 'new-contact', 'new-group', 'news', 'offering', 'offshore', 'optimization', 'org-chart', 'parental-guide', 'password-invisible', 'password-visible', 'pay-monthly', 'pay-once', 'payment-success', 'pebble', 'people-hub', 'people', 'phone-recycling', 'phone-ringing', 'phone', 'pie-chart', 'plane', 'play', 'player-settings', 'plus-minus', 'plus', 'police', 'portal', 'premises-datacenter', 'premises-large', 'premises-medium', 'premises-small', 'premises', 'present', 'press-button', 'price', 'print', 'pulse', 'question-filled', 'question', 'rack', 'record', 'recycle', 'refill-card', 'register', 'remote-control', 'repair', 'report', 'reservation', 'reverse', 'roaming', 'router', 'satellite', 'save', 'savings', 'search', 'secure-device', 'secured-1', 'secured-2', 'send', 'sense-car', 'server', 'service-device', 'service-supervision', 'services', 'settings', 'share', 'shopping', 'shuffle', 'signature', 'simcard', 'skip-back-10sec', 'skip-back-30sec', 'skip-forward-10sec', 'skip-forward-30sec', 'slow-wifi', 'smart-wifi', 'smartphone', 'smartwatch', 'smiley-happy', 'smiley-sad', 'sms', 'snapchat', 'snowflake', 'sorter', 'speedometer', 'spell-check', 'star-filled', 'star', 'stop', 'store', 'stream', 'suitcase', 'summary', 'support', 'sustainability', 'switch', 'sync', 'table-view', 'tablet', 'tag', 'time', 'trade-phone', 'trailer', 'transfer', 'tv-next', 'tv-pause', 'tv-play', 'tv-previous', 'tv', 'twitter', 'undo', 'upload', 'usb', 'user-admin', 'vcard', 'video-conference', 'video', 'voice-switch', 'voicemail', 'volume', 'wallet', 'wallplug', 'warning', 'weather', 'wireless-off', 'wireless', 'world-alert', 'world-off', 'world-question', 'world', 'youtube', 'zoom'];

	var _excluded$5 = ["name", "size", "url", "className", "color", "svgFocusable", "tagName"];
	var supportedIconSizes = ['xs', 'sm', 'md', 'lg', 'xlg'];

	var Icon = function Icon(_ref) {
	  var name = _ref.name,
	      size = _ref.size,
	      url = _ref.url,
	      className = _ref.className,
	      color = _ref.color,
	      svgFocusable = _ref.svgFocusable,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$5);

	  var IconElement = iconData[name];

	  if (!IconElement) {
	    console.error("Unfortunately there's no icon with a name \"" + name + "\"");
	    return null;
	  }

	  var classNames = [styles$4.icon, "telia_icon__" + name, styles$4["icon__size" + upperFirst$1(size)]];
	  className && classNames.push(className);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    className: classNames,
	    tagName: tagName,
	    color: color
	  }, props), url ? /*#__PURE__*/React__default['default'].createElement(Link, {
	    color: color,
	    hoverColor: color,
	    to: url
	  }, /*#__PURE__*/React__default['default'].createElement(IconElement, {
	    focusable: svgFocusable,
	    className: styles$4['icon_svg']
	  })) : /*#__PURE__*/React__default['default'].createElement(IconElement, {
	    focusable: svgFocusable,
	    className: styles$4['icon_svg']
	  }));
	};

	var styles$6 = {"headline__size_xlg":"telia-react-headline__size_xlg","headline__size_lg":"telia-react-headline__size_lg","headline__size_md":"telia-react-headline__size_md","headline__size_sm":"telia-react-headline__size_sm","headline__size_xs":"telia-react-headline__size_xs"};

	var styles$7 = {"typography":"telia-react-typography","typography__pebble":"telia-react-typography__pebble","typography__teliasans":"telia-react-typography__teliasans","typography__teliasansHeading":"telia-react-typography__teliasansHeading","typography__uppercase":"telia-react-typography__uppercase","typography__strikeThrough":"telia-react-typography__strikeThrough","typography__singleLine":"telia-react-typography__singleLine"};

	var _excluded$6 = ["tagName", "font", "children", "singleLine", "uppercase", "strikeThrough", "className", "fontWeight", "margin", "block"];

	function Typography(_ref) {
	  var _ref2;

	  var tagName = _ref.tagName,
	      _ref$font = _ref.font,
	      font = _ref$font === void 0 ? 'teliasans' : _ref$font,
	      children = _ref.children,
	      singleLine = _ref.singleLine,
	      uppercase = _ref.uppercase,
	      strikeThrough = _ref.strikeThrough,
	      className = _ref.className,
	      _ref$fontWeight = _ref.fontWeight,
	      fontWeight = _ref$fontWeight === void 0 ? 'normal' : _ref$fontWeight,
	      margin = _ref.margin,
	      block = _ref.block,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$6);

	  var classNames = [styles$7.typography, styles$7["typography__" + font], (_ref2 = {}, _ref2[styles$7.typography__singleLine] = !!singleLine, _ref2[styles$7.typography__uppercase] = !!uppercase, _ref2[styles$7.typography__strikeThrough] = !!strikeThrough, _ref2), className];
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: tagName != null ? tagName : 'span' // this circumvents some weird ts problem
	    ,
	    className: classNames,
	    fontWeight: font === 'teliasans' ? fontWeight : 'normal',
	    margin: margin,
	    block: !!margin || block
	  }, props), children);
	}

	var _excluded$7 = ["tagName", "size", "children", "className", "allowSmallCaps", "color"];
	var headlineColor = {
	  white: 'white',
	  black: 'black',
	  purple500: 'purple500'
	};

	function Headline(_ref) {
	  var tagName = _ref.tagName,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'xlg' : _ref$size,
	      children = _ref.children,
	      className = _ref.className,
	      _ref$allowSmallCaps = _ref.allowSmallCaps,
	      allowSmallCaps = _ref$allowSmallCaps === void 0 ? true : _ref$allowSmallCaps,
	      _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'black' : _ref$color,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$7);

	  var classNames = [styles$6["headline__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({}, props, {
	    tagName: tagName // this circumvents some weird ts problem
	    ,
	    className: classNames,
	    fontWeight: "bold",
	    font: "teliasans",
	    uppercase: !allowSmallCaps,
	    color: headlineColor[color]
	  }), children);
	}

	var supportedHeadlineSizes = ['xlg', 'lg', 'md', 'sm', 'xs'];
	var supportedHeadlineColors = ['black', 'white', 'purple500'];

	var styles$8 = {"title__size_lg":"telia-react-title__size_lg","title__size_md":"telia-react-title__size_md","title__size_sm":"telia-react-title__size_sm","title__size_xs":"telia-react-title__size_xs","title__size_xxs":"telia-react-title__size_xxs","title__size_xxxs":"telia-react-title__size_xxxs"};

	var _excluded$8 = ["tagName", "size", "className", "children"];

	function Title(_ref) {
	  var tagName = _ref.tagName,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'lg' : _ref$size,
	      className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$8);

	  var classNames = [styles$8["title__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({}, props, {
	    tagName: tagName // this circumvents some weird ts problem
	    ,
	    className: classNames,
	    font: "teliasans",
	    fontWeight: "bold"
	  }), children);
	}

	var supportedTitleSizes = ['lg', 'md', 'sm', 'xs', 'xxs'];

	var styles$9 = {"accordion":"telia-react-accordion","accordion__header":"telia-react-accordion__header","accordion__image":"telia-react-accordion__image","accordion__icon":"telia-react-accordion__icon","accordion__icon_rotate":"telia-react-accordion__icon_rotate","accordion__content":"telia-react-accordion__content","accordion__content__wrapper":"telia-react-accordion__content__wrapper"};

	var styles$a = {"backgroundImage":"telia-react-backgroundImage","backgroundImage_responsiveSpace":"telia-react-backgroundImage_responsiveSpace","backgroundImage_image":"telia-react-backgroundImage_image","backgroundImage__scaleWithOriginalAspectRatio":"telia-react-backgroundImage__scaleWithOriginalAspectRatio"};

	var _excluded$9 = ["src", "mobileSrc", "alt", "style", "scaleWithOriginalAspectRatio", "className"];

	function ownKeys$4(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$4(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$4(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }

	var BackgroundImage = function BackgroundImage(_ref) {
	  var _ref2, _ref3;

	  var src = _ref.src,
	      mobileSrc = _ref.mobileSrc,
	      alt = _ref.alt,
	      style = _ref.style,
	      scaleWithOriginalAspectRatio = _ref.scaleWithOriginalAspectRatio,
	      className = _ref.className,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$9);

	  var classNames = [styles$a.backgroundImage, (_ref2 = {}, _ref2[styles$a.backgroundImage__scaleWithOriginalAspectRatio] = scaleWithOriginalAspectRatio, _ref2), className];
	  var responsiveSpaceClassNamesForDesktop = [styles$a.backgroundImage_responsiveSpace, (_ref3 = {}, _ref3[hiddenStyles.hidden__thinnerThanLg] = !!mobileSrc, _ref3)];
	  var responsiveSpaceClassNamesForMobile = [styles$a.backgroundImage_responsiveSpace, hiddenStyles.hidden__widerThanMd];

	  var inlineStylesForDesktop = _objectSpread$2(_objectSpread$2({}, style), {}, {
	    backgroundImage: "url(" + src + ")"
	  });

	  var inlineStylesForMobile = _objectSpread$2(_objectSpread$2({}, style), {}, {
	    backgroundImage: "url(" + mobileSrc + ")"
	  });

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: classNames
	  }, props), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: responsiveSpaceClassNamesForDesktop
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$a.backgroundImage_image,
	    style: inlineStylesForDesktop
	  })), mobileSrc && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: responsiveSpaceClassNamesForMobile
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$a.backgroundImage_image,
	    style: inlineStylesForMobile
	  })), /*#__PURE__*/React__default['default'].createElement("span", {
	    className: hiddenStyles.visuallyHidden
	  }, alt));
	};

	var _excluded$a = ["heading", "children", "className", "useHeadlineFontOnHeading", "open", "onClick", "imgSrc", "imgAlt"];

	var AccordionStateless = function AccordionStateless(_ref) {
	  var heading = _ref.heading,
	      children = _ref.children,
	      className = _ref.className,
	      _ref$useHeadlineFontO = _ref.useHeadlineFontOnHeading,
	      useHeadlineFontOnHeading = _ref$useHeadlineFontO === void 0 ? false : _ref$useHeadlineFontO,
	      open = _ref.open,
	      onClick = _ref.onClick,
	      imgSrc = _ref.imgSrc,
	      imgAlt = _ref.imgAlt,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$a);

	  var height = open ? 'auto' : 0;
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    boxShadow: 'sm',
	    borderRadius: {
	      size: 'md'
	    },
	    backgroundColor: "white",
	    className: [className, styles$9.accordion],
	    hideOverflow: true
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    tabIndex: 0,
	    onKeyPress: function onKeyPress(e) {
	      e.key === 'Enter' && onClick(e);
	    },
	    spaceBetween: true,
	    centeredVertically: true,
	    onClick: onClick,
	    className: styles$9.accordion__header,
	    hoverColor: "purple500"
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true,
	    margin: {
	      right: 'xs'
	    }
	  }, imgSrc && /*#__PURE__*/React__default['default'].createElement(BackgroundImage, {
	    src: imgSrc,
	    alt: imgAlt,
	    className: styles$9.accordion__image,
	    scaleWithOriginalAspectRatio: true
	  }), useHeadlineFontOnHeading ? /*#__PURE__*/React__default['default'].createElement(Headline, {
	    size: "xs"
	  }, heading) : /*#__PURE__*/React__default['default'].createElement(Title, {
	    size: "xs"
	  }, heading)), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    className: open ? styles$9.accordion__icon_rotate : styles$9.accordion__icon,
	    name: "chevron-down",
	    size: "md",
	    color: "black"
	  })), /*#__PURE__*/React__default['default'].createElement(_default, {
	    duration: 250,
	    height: height,
	    className: classnames(['expanded-content-test'])
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$9.accordion__content__wrapper
	  }, children)));
	};

	var _excluded$b = ["children", "initiallyExpanded"];

	var Accordion = function Accordion(_ref) {
	  var children = _ref.children,
	      initiallyExpanded = _ref.initiallyExpanded,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$b);

	  var _useState = React.useState(initiallyExpanded || false),
	      open = _useState[0],
	      setOpen = _useState[1];

	  var toggleExpanded = function toggleExpanded() {
	    setOpen(!open);
	  };

	  return /*#__PURE__*/React__default['default'].createElement(AccordionStateless, _extends_1({
	    onClick: toggleExpanded,
	    open: open
	  }, props), children);
	};

	var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('slice');
	var SPECIES$2 = wellKnownSymbol('species');
	var Array$2 = global$1.Array;
	var max$2 = Math.max; // `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects

	_export({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT$1
	}, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject(this);
	    var length = lengthOfArrayLike(O);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

	    var Constructor, result, n;

	    if (isArray(O)) {
	      Constructor = O.constructor; // cross-realm fallback

	      if (isConstructor(Constructor) && (Constructor === Array$2 || isArray(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject(Constructor)) {
	        Constructor = Constructor[SPECIES$2];
	        if (Constructor === null) Constructor = undefined;
	      }

	      if (Constructor === Array$2 || Constructor === undefined) {
	        return arraySlice(O, k, fin);
	      }
	    }

	    result = new (Constructor === undefined ? Array$2 : Constructor)(max$2(fin - k, 0));

	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);

	    result.length = n;
	    return result;
	  }
	});

	var slice = entryVirtual('Array').slice;

	var ArrayPrototype$3 = Array.prototype;

	var slice$1 = function (it) {
	  var own = it.slice;
	  return it === ArrayPrototype$3 || objectIsPrototypeOf(ArrayPrototype$3, it) && own === ArrayPrototype$3.slice ? slice : own;
	};

	var slice$2 = slice$1;

	var slice$3 = slice$2;

	var un$Reverse = functionUncurryThis([].reverse);
	var test$1 = [1, 2]; // `Array.prototype.reverse` method
	// https://tc39.es/ecma262/#sec-array.prototype.reverse
	// fix for Safari 12.0 bug
	// https://bugs.webkit.org/show_bug.cgi?id=188794

	_export({
	  target: 'Array',
	  proto: true,
	  forced: String(test$1) === String(test$1.reverse())
	}, {
	  reverse: function reverse() {
	    // eslint-disable-next-line no-self-assign -- dirty hack
	    if (isArray(this)) this.length = this.length;
	    return un$Reverse(this);
	  }
	});

	var reverse = entryVirtual('Array').reverse;

	var ArrayPrototype$4 = Array.prototype;

	var reverse$1 = function (it) {
	  var own = it.reverse;
	  return it === ArrayPrototype$4 || objectIsPrototypeOf(ArrayPrototype$4, it) && own === ArrayPrototype$4.reverse ? reverse : own;
	};

	var reverse$2 = reverse$1;

	var reverse$3 = reverse$2;

	var $find = arrayIteration.find;



	var FIND = 'find';
	var SKIPS_HOLES = true; // Shouldn't skip holes

	if (FIND in []) Array(1)[FIND](function () {
	  SKIPS_HOLES = false;
	}); // `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find

	_export({
	  target: 'Array',
	  proto: true,
	  forced: SKIPS_HOLES
	}, {
	  find: function find(callbackfn
	  /* , that = undefined */
	  ) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	var find = entryVirtual('Array').find;

	var ArrayPrototype$5 = Array.prototype;

	var find$1 = function (it) {
	  var own = it.find;
	  return it === ArrayPrototype$5 || objectIsPrototypeOf(ArrayPrototype$5, it) && own === ArrayPrototype$5.find ? find : own;
	};

	var find$2 = find$1;

	var find$3 = find$2;

	var indexOf$7 = indexOf$3;

	var styles$b = {"bodyText__size_md":"telia-react-bodyText__size_md","bodyText__size_sm":"telia-react-bodyText__size_sm","bodyText__size_xs":"telia-react-bodyText__size_xs"};

	var _excluded$c = ["tagName", "className", "size", "htmlFor", "children"];

	function BodyText(_ref) {
	  var _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'p' : _ref$tagName,
	      className = _ref.className,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      htmlFor = _ref.htmlFor,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$c);

	  var classNames = [styles$b["bodyText__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({
	    tagName: tagName // this circumvents some weird ts problem
	    ,
	    className: classNames,
	    font: "teliasans",
	    uppercase: false,
	    htmlFor: htmlFor
	  }, props), children);
	}

	var supportedBodyTextSizes = ['md', 'sm', 'xs'];

	var styles$c = {"gutter":"telia-react-gutter","gutter__half":"telia-react-gutter__half","gutter__quarter":"telia-react-gutter__quarter","gutter__zero":"telia-react-gutter__zero","gutter__layout_1":"telia-react-gutter__layout_1","gutter__layout_2":"telia-react-gutter__layout_2","gutter__layout_3":"telia-react-gutter__layout_3","gutter__layout_4":"telia-react-gutter__layout_4","gutter__layout_5":"telia-react-gutter__layout_5","gutter__layout_6":"telia-react-gutter__layout_6","gutter__layout_7":"telia-react-gutter__layout_7","gutter__layout_8":"telia-react-gutter__layout_8","gutter__layout_9":"telia-react-gutter__layout_9","gutter__sizeZero":"telia-react-gutter__sizeZero","gutter__sizeXxs":"telia-react-gutter__sizeXxs","gutter__sizeXs":"telia-react-gutter__sizeXs","gutter__sizeSm":"telia-react-gutter__sizeSm","gutter__sizeMd":"telia-react-gutter__sizeMd","gutter__sizeLg":"telia-react-gutter__sizeLg","gutter__sizeXlg":"telia-react-gutter__sizeXlg","gutter__sizeXxlg":"telia-react-gutter__sizeXxlg"};

	var _excluded$d = ["className", "half", "quarter", "size"];

	var Gutter = function Gutter(_ref) {
	  var _ref2;

	  var className = _ref.className,
	      half = _ref.half,
	      quarter = _ref.quarter,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? half && 'half' || quarter && 'quarter' || 'md' : _ref$size,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$d);

	  var classNames = [styles$c.gutter, (_ref2 = {}, _ref2[styles$c.gutter__zero] = size === 'zero', _ref2[styles$c.gutter__half] = size === 'half', _ref2[styles$c.gutter__quarter] = size === 'quarter', _ref2[styles$c.gutter__sizeXxs] = size === 'xxs', _ref2[styles$c.gutter__sizeXs] = size === 'xs', _ref2[styles$c.gutter__sizeSm] = size === 'sm', _ref2[styles$c.gutter__sizeMd] = size === 'md', _ref2[styles$c.gutter__sizeLg] = size === 'lg', _ref2[styles$c.gutter__sizeXlg] = size === 'xlg', _ref2[styles$c.gutter__layout_1] = size === 'layout-1', _ref2[styles$c.gutter__layout_2] = size === 'layout-2', _ref2[styles$c.gutter__layout_3] = size === 'layout-3', _ref2[styles$c.gutter__layout_4] = size === 'layout-4', _ref2[styles$c.gutter__layout_5] = size === 'layout-5', _ref2[styles$c.gutter__layout_6] = size === 'layout-6', _ref2[styles$c.gutter__layout_7] = size === 'layout-7', _ref2[styles$c.gutter__layout_8] = size === 'layout-8', _ref2[styles$c.gutter__layout_9] = size === 'layout-9', _ref2), className];
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: classNames
	  }, props));
	};

	var supportedGutterSizes = ['zero', 'xxs', 'xs', 'sm', 'md', 'lg', 'xlg', 'xxlg', //This should be removed when breaking happens, since it's not doing anything
	'half', 'quarter', 'layout-1', 'layout-2', 'layout-3', 'layout-4', 'layout-5', 'layout-6', 'layout-7', 'layout-8', 'layout-9'];

	var _excluded$e = ["children"];

	var Span = function Span(_ref) {
	  var children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$e);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "span"
	  }, props), children);
	};

	var styles$d = {"input":"telia-react-input","input_required":"telia-react-input_required","input__container":"telia-react-input__container","input__container_error":"telia-react-input__container_error","input__iconWrapper__icon":"telia-react-input__iconWrapper__icon","input__iconWrapper":"telia-react-input__iconWrapper","input__iconWrapper_clickable":"telia-react-input__iconWrapper_clickable","input__container_disabled":"telia-react-input__container_disabled","input__inputField":"telia-react-input__inputField","input__inputField_withIcon":"telia-react-input__inputField_withIcon","input__inputField_disabled":"telia-react-input__inputField_disabled"};

	var resolveIconProps = function resolveIconProps(_ref) {
	  var errorText = _ref.errorText,
	      confirmed = _ref.confirmed,
	      iconName = _ref.iconName,
	      disabled = _ref.disabled,
	      onIconClick = _ref.onIconClick,
	      iconColor = _ref.iconColor,
	      handleKeyPress = _ref.handleKeyPress;

	  if (errorText !== ' ' && errorText) {
	    return {
	      name: 'error-filled',
	      color: 'red600'
	    };
	  }

	  if (confirmed) {
	    return {
	      name: 'checkmark',
	      color: 'green500'
	    };
	  }

	  if (!iconName) {
	    return undefined;
	  }

	  if (disabled) {
	    return {
	      name: iconName,
	      color: 'gray400'
	    };
	  }

	  if (onIconClick) {
	    return {
	      name: iconName,
	      color: iconColor || 'black',
	      onClick: onIconClick,
	      clickableAppearance: true,
	      onKeyPress: handleKeyPress,
	      tabIndex: 0
	    };
	  }

	  return {
	    name: iconName,
	    color: iconColor || 'black'
	  };
	};

	var ResolveIcon = function ResolveIcon(_ref) {
	  var errorText = _ref.errorText,
	      confirmed = _ref.confirmed,
	      iconName = _ref.iconName,
	      iconColor = _ref.iconColor,
	      disabled = _ref.disabled,
	      svgFocusable = _ref.svgFocusable,
	      onIconClick = _ref.onIconClick,
	      handleKeyPress = _ref.handleKeyPress;
	  var iconProps = resolveIconProps({
	    errorText: errorText,
	    confirmed: confirmed,
	    iconName: iconName,
	    iconColor: iconColor,
	    disabled: disabled,
	    onIconClick: onIconClick,
	    handleKeyPress: handleKeyPress
	  });
	  var classNames = [styles$d.input__iconWrapper];

	  if (!!onIconClick) {
	    classNames.push(styles$d.input__iconWrapper_clickable);
	  }

	  return iconProps ? /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centered: true,
	    className: classNames,
	    borderRadius: {
	      size: 'rounded'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, _extends_1({
	    color: iconColor,
	    size: "sm",
	    svgFocusable: svgFocusable,
	    className: styles$d.input__iconWrapper__icon
	  }, iconProps))) : /*#__PURE__*/React__default['default'].createElement(Div, {
	    style: {
	      height: '16px',
	      width: '16px'
	    }
	  });
	};

	var styles$e = {"inputMessage_textContainer":"telia-react-inputMessage_textContainer","inputMessage_text":"telia-react-inputMessage_text"};

	var InputMessage = function InputMessage(_ref) {
	  var text = _ref.text,
	      color = _ref.color;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$e.inputMessage
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      top: 'xs',
	      right: 'xs'
	    },
	    className: styles$e.inputMessage_textContainer
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    block: true,
	    size: "sm",
	    color: color,
	    className: styles$e.inputMessage_text
	  }, text)));
	};

	InputMessage.propTypes = {
	  /** Error text shown */
	  text: propTypes.string.isRequired
	};

	var _excluded$f = ["label", "required", "className", "onClick", "onBlur", "onFocus", "onKeyUp", "borderRadius", "wrapperTabIndex", "showCustomLabel", "helperText", "disabled"],
	    _excluded2 = ["value", "placeholder", "type", "id", "name", "autocomplete", "disabled", "readonly", "onIconClick", "errorText", "confirmed", "iconName", "iconColor", "onChange", "borderRadius", "inputTabIndex"];

	function ownKeys$5(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$5(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$5(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }
	var BaseInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
	  var _ref2;

	  var label = _ref.label,
	      required = _ref.required,
	      className = _ref.className,
	      onClick = _ref.onClick,
	      onBlur = _ref.onBlur,
	      onFocus = _ref.onFocus,
	      onKeyUp = _ref.onKeyUp,
	      borderRadius = _ref.borderRadius,
	      wrapperTabIndex = _ref.wrapperTabIndex,
	      showCustomLabel = _ref.showCustomLabel,
	      helperText = _ref.helperText,
	      disabled = _ref.disabled,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$f);

	  var inputElement = React.useRef(null);

	  var handleInputFocus = function handleInputFocus() {
	    /* istanbul ignore else  */
	    if (!ref) {
	      var _inputElement$current;

	      (_inputElement$current = inputElement.current) == null ? void 0 : _inputElement$current.focus();
	    }
	  };

	  var resolveLabel = label ? required ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Span, null, label, " "), /*#__PURE__*/React__default['default'].createElement(Span, {
	    className: styles$d.input_required
	  }, "*")) : label : /*#__PURE__*/React__default['default'].createElement(Span, null, "\xA0");
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$d.input, className],
	    onClick: onClick,
	    onBlur: onBlur,
	    onKeyUp: onKeyUp,
	    onFocus: onFocus,
	    tabIndex: disabled ? undefined : wrapperTabIndex
	  }, !showCustomLabel && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    size: "sm",
	    block: true,
	    color: disabled ? 'gray400' : 'black',
	    tagName: "label",
	    htmlFor: !props.children && props.id ? props.id : undefined
	  }, resolveLabel), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  })), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centered: true,
	    className: (_ref2 = {}, _ref2[styles$d.input__container] = true, _ref2[styles$d.input__container_error] = !!props.errorText || props.errorText === ' ', _ref2[styles$d.input__container_disabled] = disabled, _ref2),
	    borderRadius: borderRadius || {
	      size: 'sm'
	    },
	    backgroundColor: !!disabled ? 'gray200' : 'white',
	    onClick: !!disabled ? undefined : handleInputFocus
	  }, props.children ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, props.children) : renderInput(_objectSpread$3(_objectSpread$3({}, props), {}, {
	    borderRadius: borderRadius,
	    disabled: disabled
	  }), ref || inputElement)), !!props.errorText && props.errorText !== ' ' && /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: props.errorText,
	    color: "red600"
	  }), !!helperText && /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: helperText,
	    color: "gray500"
	  }));
	});

	var renderInput = function renderInput(_ref3, ref) {
	  var _objectSpread2;

	  var value = _ref3.value,
	      placeholder = _ref3.placeholder,
	      _ref3$type = _ref3.type,
	      type = _ref3$type === void 0 ? 'text' : _ref3$type,
	      id = _ref3.id,
	      name = _ref3.name,
	      autocomplete = _ref3.autocomplete,
	      disabled = _ref3.disabled,
	      readonly = _ref3.readonly,
	      onIconClick = _ref3.onIconClick,
	      errorText = _ref3.errorText,
	      confirmed = _ref3.confirmed,
	      iconName = _ref3.iconName,
	      iconColor = _ref3.iconColor,
	      onChange = _ref3.onChange,
	      borderRadius = _ref3.borderRadius,
	      inputTabIndex = _ref3.inputTabIndex,
	      props = objectWithoutPropertiesLoose(_ref3, _excluded2);

	  var inputNotFocusable = !!disabled || !!readonly;
	  var hasIcon = !!iconName || !!errorText || !!confirmed;

	  var handleKeyPress = function handleKeyPress(event) {
	    event.key === 'Enter' && (onIconClick == null ? void 0 : onIconClick());
	  };

	  var classNames = classnames('inner-input-test', styles$d.input__inputField, _objectSpread$3((_objectSpread2 = {}, _objectSpread2[styles$d.input__inputField_withIcon] = hasIcon, _objectSpread2[styles$d.input__inputField_disabled] = disabled, _objectSpread2), getBorderRadiusClasses(borderRadius || {
	    size: 'sm'
	  })));
	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("input", _extends_1({
	    value: value || '' // The default value is here for keeping the input element controlled. If value is first undefined and then given it will cause an error.
	    ,
	    placeholder: placeholder,
	    onChange: !!readonly ? undefined : onChange ? function (event) {
	      return onChange(event, event.target.value);
	    } : undefined,
	    disabled: disabled,
	    ref: ref,
	    type: type,
	    id: id,
	    name: name,
	    className: classNames,
	    readOnly: !!readonly,
	    autoComplete: autocomplete,
	    tabIndex: inputNotFocusable ? undefined : inputTabIndex ? inputTabIndex : 0
	  }, props)), hasIcon && /*#__PURE__*/React__default['default'].createElement(ResolveIcon, {
	    errorText: errorText,
	    confirmed: confirmed,
	    iconColor: iconColor,
	    iconName: iconName,
	    svgFocusable: false,
	    handleKeyPress: handleKeyPress,
	    disabled: disabled,
	    onIconClick: onIconClick
	  }));
	};

	var $map = arrayIteration.map;



	var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('map'); // `Array.prototype.map` method
	// https://tc39.es/ecma262/#sec-array.prototype.map
	// with adding support of @@species

	_export({
	  target: 'Array',
	  proto: true,
	  forced: !HAS_SPECIES_SUPPORT$2
	}, {
	  map: function map(callbackfn
	  /* , thisArg */
	  ) {
	    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var map = entryVirtual('Array').map;

	var ArrayPrototype$6 = Array.prototype;

	var map$1 = function (it) {
	  var own = it.map;
	  return it === ArrayPrototype$6 || objectIsPrototypeOf(ArrayPrototype$6, it) && own === ArrayPrototype$6.map ? map : own;
	};

	var map$2 = map$1;

	var map$3 = map$2;

	var $findIndex = arrayIteration.findIndex;



	var FIND_INDEX = 'findIndex';
	var SKIPS_HOLES$1 = true; // Shouldn't skip holes

	if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () {
	  SKIPS_HOLES$1 = false;
	}); // `Array.prototype.findIndex` method
	// https://tc39.es/ecma262/#sec-array.prototype.findindex

	_export({
	  target: 'Array',
	  proto: true,
	  forced: SKIPS_HOLES$1
	}, {
	  findIndex: function findIndex(callbackfn
	  /* , that = undefined */
	  ) {
	    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	var findIndex = entryVirtual('Array').findIndex;

	var ArrayPrototype$7 = Array.prototype;

	var findIndex$1 = function (it) {
	  var own = it.findIndex;
	  return it === ArrayPrototype$7 || objectIsPrototypeOf(ArrayPrototype$7, it) && own === ArrayPrototype$7.findIndex ? findIndex : own;
	};

	var findIndex$2 = findIndex$1;

	var findIndex$3 = findIndex$2;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create


	_export({
	  target: 'Object',
	  stat: true,
	  sham: !descriptors
	}, {
	  create: objectCreate
	});

	var Object$6 = path.Object;

	var create = function create(P, D) {
	  return Object$6.create(P, D);
	};

	var create$1 = create;

	var create$2 = create$1;

	var create$3 = create$2;

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = create$3(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}

	var inheritsLoose = _inheritsLoose;

	var nativeSymbol$1 = !!Object.getOwnPropertySymbols && !fails$1(function () {
	  // Chrome 38 Symbol has incorrect toString conversion
	  // eslint-disable-next-line no-undef
	  return !String(Symbol());
	});

	var useSymbolAsUid$1 = nativeSymbol$1
	  // eslint-disable-next-line no-undef
	  && !Symbol.sham
	  // eslint-disable-next-line no-undef
	  && typeof Symbol.iterator == 'symbol';

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	var isArray$2 = Array.isArray || function isArray(arg) {
	  return classofRaw$1(arg) == 'Array';
	};

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	var toObject$2 = function (argument) {
	  return Object(requireObjectCoercible$1(argument));
	};

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	var objectKeys$1 = Object.keys || function keys(O) {
	  return objectKeysInternal$1(O, enumBugKeys$1);
	};

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	var objectDefineProperties$1 = descriptors$1 ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject$1(O);
	  var keys = objectKeys$1(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) objectDefineProperty$1.f(O, key = keys[index++], Properties[key]);
	  return O;
	};

	var html$1 = getBuiltIn$1('document', 'documentElement');

	var GT$1 = '>';
	var LT$1 = '<';
	var PROTOTYPE$2 = 'prototype';
	var SCRIPT$1 = 'script';
	var IE_PROTO$2 = sharedKey$1('IE_PROTO');

	var EmptyConstructor$1 = function () { /* empty */ };

	var scriptTag$1 = function (content) {
	  return LT$1 + SCRIPT$1 + GT$1 + content + LT$1 + '/' + SCRIPT$1 + GT$1;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX$1 = function (activeXDocument) {
	  activeXDocument.write(scriptTag$1(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame$1 = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement$1('iframe');
	  var JS = 'java' + SCRIPT$1 + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html$1.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag$1('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument$1;
	var NullProtoObject$1 = function () {
	  try {
	    /* global ActiveXObject */
	    activeXDocument$1 = document.domain && new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject$1 = activeXDocument$1 ? NullProtoObjectViaActiveX$1(activeXDocument$1) : NullProtoObjectViaIFrame$1();
	  var length = enumBugKeys$1.length;
	  while (length--) delete NullProtoObject$1[PROTOTYPE$2][enumBugKeys$1[length]];
	  return NullProtoObject$1();
	};

	hiddenKeys$2[IE_PROTO$2] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	var objectCreate$2 = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor$1[PROTOTYPE$2] = anObject$1(O);
	    result = new EmptyConstructor$1();
	    EmptyConstructor$1[PROTOTYPE$2] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO$2] = O;
	  } else result = NullProtoObject$1();
	  return Properties === undefined ? result : objectDefineProperties$1(result, Properties);
	};

	var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNames$1.f;

	var toString$5 = {}.toString;

	var windowNames$1 = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames$1 = function (it) {
	  try {
	    return nativeGetOwnPropertyNames$1(it);
	  } catch (error) {
	    return windowNames$1.slice();
	  }
	};

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var f$d = function getOwnPropertyNames(it) {
	  return windowNames$1 && toString$5.call(it) == '[object Window]'
	    ? getWindowNames$1(it)
	    : nativeGetOwnPropertyNames$1(toIndexedObject$1(it));
	};

	var objectGetOwnPropertyNamesExternal$1 = {
		f: f$d
	};

	var WellKnownSymbolsStore$2 = shared$1('wks');
	var Symbol$3 = global$2.Symbol;
	var createWellKnownSymbol$1 = useSymbolAsUid$1 ? Symbol$3 : Symbol$3 && Symbol$3.withoutSetter || uid$1;

	var wellKnownSymbol$1 = function (name) {
	  if (!has$2(WellKnownSymbolsStore$2, name)) {
	    if (nativeSymbol$1 && has$2(Symbol$3, name)) WellKnownSymbolsStore$2[name] = Symbol$3[name];
	    else WellKnownSymbolsStore$2[name] = createWellKnownSymbol$1('Symbol.' + name);
	  } return WellKnownSymbolsStore$2[name];
	};

	var f$e = wellKnownSymbol$1;

	var wellKnownSymbolWrapped$1 = {
		f: f$e
	};

	var defineProperty$b = objectDefineProperty$1.f;

	var defineWellKnownSymbol$1 = function (NAME) {
	  var Symbol = path$1.Symbol || (path$1.Symbol = {});
	  if (!has$2(Symbol, NAME)) defineProperty$b(Symbol, NAME, {
	    value: wellKnownSymbolWrapped$1.f(NAME)
	  });
	};

	var defineProperty$c = objectDefineProperty$1.f;



	var TO_STRING_TAG$4 = wellKnownSymbol$1('toStringTag');

	var setToStringTag$1 = function (it, TAG, STATIC) {
	  if (it && !has$2(it = STATIC ? it : it.prototype, TO_STRING_TAG$4)) {
	    defineProperty$c(it, TO_STRING_TAG$4, { configurable: true, value: TAG });
	  }
	};

	var aFunction$2 = function (it) {
	  if (typeof it != 'function') {
	    throw TypeError(String(it) + ' is not a function');
	  } return it;
	};

	// optional / simple context binding
	var functionBindContext$1 = function (fn, that, length) {
	  aFunction$2(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 0: return function () {
	      return fn.call(that);
	    };
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var SPECIES$3 = wellKnownSymbol$1('species');

	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	var arraySpeciesCreate$1 = function (originalArray, length) {
	  var C;
	  if (isArray$2(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray$2(C.prototype))) C = undefined;
	    else if (isObject$2(C)) {
	      C = C[SPECIES$3];
	      if (C === null) C = undefined;
	    }
	  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
	};

	var push$4 = [].push;

	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
	var createMethod$3 = function (TYPE) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var IS_FILTER_OUT = TYPE == 7;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject$2($this);
	    var self = indexedObject$1(O);
	    var boundFunction = functionBindContext$1(callbackfn, that, 3);
	    var length = toLength$1(self.length);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate$1;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push$4.call(target, value); // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push$4.call(target, value); // filterOut
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};

	var arrayIteration$1 = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod$3(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod$3(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod$3(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod$3(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod$3(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod$3(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod$3(6),
	  // `Array.prototype.filterOut` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterOut: createMethod$3(7)
	};

	var $forEach$2 = arrayIteration$1.forEach;

	var HIDDEN$1 = sharedKey$1('hidden');
	var SYMBOL$1 = 'Symbol';
	var PROTOTYPE$3 = 'prototype';
	var TO_PRIMITIVE$2 = wellKnownSymbol$1('toPrimitive');
	var setInternalState$2 = internalState$1.set;
	var getInternalState$2 = internalState$1.getterFor(SYMBOL$1);
	var ObjectPrototype$2 = Object[PROTOTYPE$3];
	var $Symbol$1 = global$2.Symbol;
	var $stringify$1 = getBuiltIn$1('JSON', 'stringify');
	var nativeGetOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor$1.f;
	var nativeDefineProperty$2 = objectDefineProperty$1.f;
	var nativeGetOwnPropertyNames$2 = objectGetOwnPropertyNamesExternal$1.f;
	var nativePropertyIsEnumerable$2 = objectPropertyIsEnumerable$1.f;
	var AllSymbols$1 = shared$1('symbols');
	var ObjectPrototypeSymbols$1 = shared$1('op-symbols');
	var StringToSymbolRegistry$1 = shared$1('string-to-symbol-registry');
	var SymbolToStringRegistry$1 = shared$1('symbol-to-string-registry');
	var WellKnownSymbolsStore$3 = shared$1('wks');
	var QObject$1 = global$2.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var USE_SETTER$1 = !QObject$1 || !QObject$1[PROTOTYPE$3] || !QObject$1[PROTOTYPE$3].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDescriptor$1 = descriptors$1 && fails$1(function () {
	  return objectCreate$2(nativeDefineProperty$2({}, 'a', {
	    get: function () { return nativeDefineProperty$2(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (O, P, Attributes) {
	  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$3(ObjectPrototype$2, P);
	  if (ObjectPrototypeDescriptor) delete ObjectPrototype$2[P];
	  nativeDefineProperty$2(O, P, Attributes);
	  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$2) {
	    nativeDefineProperty$2(ObjectPrototype$2, P, ObjectPrototypeDescriptor);
	  }
	} : nativeDefineProperty$2;

	var wrap$1 = function (tag, description) {
	  var symbol = AllSymbols$1[tag] = objectCreate$2($Symbol$1[PROTOTYPE$3]);
	  setInternalState$2(symbol, {
	    type: SYMBOL$1,
	    tag: tag,
	    description: description
	  });
	  if (!descriptors$1) symbol.description = description;
	  return symbol;
	};

	var isSymbol$2 = useSymbolAsUid$1 ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return Object(it) instanceof $Symbol$1;
	};

	var $defineProperty$2 = function defineProperty(O, P, Attributes) {
	  if (O === ObjectPrototype$2) $defineProperty$2(ObjectPrototypeSymbols$1, P, Attributes);
	  anObject$1(O);
	  var key = toPrimitive$1(P, true);
	  anObject$1(Attributes);
	  if (has$2(AllSymbols$1, key)) {
	    if (!Attributes.enumerable) {
	      if (!has$2(O, HIDDEN$1)) nativeDefineProperty$2(O, HIDDEN$1, createPropertyDescriptor$1(1, {}));
	      O[HIDDEN$1][key] = true;
	    } else {
	      if (has$2(O, HIDDEN$1) && O[HIDDEN$1][key]) O[HIDDEN$1][key] = false;
	      Attributes = objectCreate$2(Attributes, { enumerable: createPropertyDescriptor$1(0, false) });
	    } return setSymbolDescriptor$1(O, key, Attributes);
	  } return nativeDefineProperty$2(O, key, Attributes);
	};

	var $defineProperties$1 = function defineProperties(O, Properties) {
	  anObject$1(O);
	  var properties = toIndexedObject$1(Properties);
	  var keys = objectKeys$1(properties).concat($getOwnPropertySymbols$1(properties));
	  $forEach$2(keys, function (key) {
	    if (!descriptors$1 || $propertyIsEnumerable$2.call(properties, key)) $defineProperty$2(O, key, properties[key]);
	  });
	  return O;
	};

	var $create$1 = function create(O, Properties) {
	  return Properties === undefined ? objectCreate$2(O) : $defineProperties$1(objectCreate$2(O), Properties);
	};

	var $propertyIsEnumerable$2 = function propertyIsEnumerable(V) {
	  var P = toPrimitive$1(V, true);
	  var enumerable = nativePropertyIsEnumerable$2.call(this, P);
	  if (this === ObjectPrototype$2 && has$2(AllSymbols$1, P) && !has$2(ObjectPrototypeSymbols$1, P)) return false;
	  return enumerable || !has$2(this, P) || !has$2(AllSymbols$1, P) || has$2(this, HIDDEN$1) && this[HIDDEN$1][P] ? enumerable : true;
	};

	var $getOwnPropertyDescriptor$2 = function getOwnPropertyDescriptor(O, P) {
	  var it = toIndexedObject$1(O);
	  var key = toPrimitive$1(P, true);
	  if (it === ObjectPrototype$2 && has$2(AllSymbols$1, key) && !has$2(ObjectPrototypeSymbols$1, key)) return;
	  var descriptor = nativeGetOwnPropertyDescriptor$3(it, key);
	  if (descriptor && has$2(AllSymbols$1, key) && !(has$2(it, HIDDEN$1) && it[HIDDEN$1][key])) {
	    descriptor.enumerable = true;
	  }
	  return descriptor;
	};

	var $getOwnPropertyNames$2 = function getOwnPropertyNames(O) {
	  var names = nativeGetOwnPropertyNames$2(toIndexedObject$1(O));
	  var result = [];
	  $forEach$2(names, function (key) {
	    if (!has$2(AllSymbols$1, key) && !has$2(hiddenKeys$2, key)) result.push(key);
	  });
	  return result;
	};

	var $getOwnPropertySymbols$1 = function getOwnPropertySymbols(O) {
	  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$2;
	  var names = nativeGetOwnPropertyNames$2(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols$1 : toIndexedObject$1(O));
	  var result = [];
	  $forEach$2(names, function (key) {
	    if (has$2(AllSymbols$1, key) && (!IS_OBJECT_PROTOTYPE || has$2(ObjectPrototype$2, key))) {
	      result.push(AllSymbols$1[key]);
	    }
	  });
	  return result;
	};

	// `Symbol` constructor
	// https://tc39.es/ecma262/#sec-symbol-constructor
	if (!nativeSymbol$1) {
	  $Symbol$1 = function Symbol() {
	    if (this instanceof $Symbol$1) throw TypeError('Symbol is not a constructor');
	    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
	    var tag = uid$1(description);
	    var setter = function (value) {
	      if (this === ObjectPrototype$2) setter.call(ObjectPrototypeSymbols$1, value);
	      if (has$2(this, HIDDEN$1) && has$2(this[HIDDEN$1], tag)) this[HIDDEN$1][tag] = false;
	      setSymbolDescriptor$1(this, tag, createPropertyDescriptor$1(1, value));
	    };
	    if (descriptors$1 && USE_SETTER$1) setSymbolDescriptor$1(ObjectPrototype$2, tag, { configurable: true, set: setter });
	    return wrap$1(tag, description);
	  };

	  redefine$1($Symbol$1[PROTOTYPE$3], 'toString', function toString() {
	    return getInternalState$2(this).tag;
	  });

	  redefine$1($Symbol$1, 'withoutSetter', function (description) {
	    return wrap$1(uid$1(description), description);
	  });

	  objectPropertyIsEnumerable$1.f = $propertyIsEnumerable$2;
	  objectDefineProperty$1.f = $defineProperty$2;
	  objectGetOwnPropertyDescriptor$1.f = $getOwnPropertyDescriptor$2;
	  objectGetOwnPropertyNames$1.f = objectGetOwnPropertyNamesExternal$1.f = $getOwnPropertyNames$2;
	  objectGetOwnPropertySymbols$1.f = $getOwnPropertySymbols$1;

	  wellKnownSymbolWrapped$1.f = function (name) {
	    return wrap$1(wellKnownSymbol$1(name), name);
	  };

	  if (descriptors$1) {
	    // https://github.com/tc39/proposal-Symbol-description
	    nativeDefineProperty$2($Symbol$1[PROTOTYPE$3], 'description', {
	      configurable: true,
	      get: function description() {
	        return getInternalState$2(this).description;
	      }
	    });
	    {
	      redefine$1(ObjectPrototype$2, 'propertyIsEnumerable', $propertyIsEnumerable$2, { unsafe: true });
	    }
	  }
	}

	_export$1({ global: true, wrap: true, forced: !nativeSymbol$1, sham: !nativeSymbol$1 }, {
	  Symbol: $Symbol$1
	});

	$forEach$2(objectKeys$1(WellKnownSymbolsStore$3), function (name) {
	  defineWellKnownSymbol$1(name);
	});

	_export$1({ target: SYMBOL$1, stat: true, forced: !nativeSymbol$1 }, {
	  // `Symbol.for` method
	  // https://tc39.es/ecma262/#sec-symbol.for
	  'for': function (key) {
	    var string = String(key);
	    if (has$2(StringToSymbolRegistry$1, string)) return StringToSymbolRegistry$1[string];
	    var symbol = $Symbol$1(string);
	    StringToSymbolRegistry$1[string] = symbol;
	    SymbolToStringRegistry$1[symbol] = string;
	    return symbol;
	  },
	  // `Symbol.keyFor` method
	  // https://tc39.es/ecma262/#sec-symbol.keyfor
	  keyFor: function keyFor(sym) {
	    if (!isSymbol$2(sym)) throw TypeError(sym + ' is not a symbol');
	    if (has$2(SymbolToStringRegistry$1, sym)) return SymbolToStringRegistry$1[sym];
	  },
	  useSetter: function () { USE_SETTER$1 = true; },
	  useSimple: function () { USE_SETTER$1 = false; }
	});

	_export$1({ target: 'Object', stat: true, forced: !nativeSymbol$1, sham: !descriptors$1 }, {
	  // `Object.create` method
	  // https://tc39.es/ecma262/#sec-object.create
	  create: $create$1,
	  // `Object.defineProperty` method
	  // https://tc39.es/ecma262/#sec-object.defineproperty
	  defineProperty: $defineProperty$2,
	  // `Object.defineProperties` method
	  // https://tc39.es/ecma262/#sec-object.defineproperties
	  defineProperties: $defineProperties$1,
	  // `Object.getOwnPropertyDescriptor` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$2
	});

	_export$1({ target: 'Object', stat: true, forced: !nativeSymbol$1 }, {
	  // `Object.getOwnPropertyNames` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertynames
	  getOwnPropertyNames: $getOwnPropertyNames$2,
	  // `Object.getOwnPropertySymbols` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
	  getOwnPropertySymbols: $getOwnPropertySymbols$1
	});

	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	_export$1({ target: 'Object', stat: true, forced: fails$1(function () { objectGetOwnPropertySymbols$1.f(1); }) }, {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return objectGetOwnPropertySymbols$1.f(toObject$2(it));
	  }
	});

	// `JSON.stringify` method behavior with symbols
	// https://tc39.es/ecma262/#sec-json.stringify
	if ($stringify$1) {
	  var FORCED_JSON_STRINGIFY$1 = !nativeSymbol$1 || fails$1(function () {
	    var symbol = $Symbol$1();
	    // MS Edge converts symbol values to JSON as {}
	    return $stringify$1([symbol]) != '[null]'
	      // WebKit converts symbol values to JSON as null
	      || $stringify$1({ a: symbol }) != '{}'
	      // V8 throws on boxed symbols
	      || $stringify$1(Object(symbol)) != '{}';
	  });

	  _export$1({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY$1 }, {
	    // eslint-disable-next-line no-unused-vars
	    stringify: function stringify(it, replacer, space) {
	      var args = [it];
	      var index = 1;
	      var $replacer;
	      while (arguments.length > index) args.push(arguments[index++]);
	      $replacer = replacer;
	      if (!isObject$2(replacer) && it === undefined || isSymbol$2(it)) return; // IE8 returns string on undefined
	      if (!isArray$2(replacer)) replacer = function (key, value) {
	        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	        if (!isSymbol$2(value)) return value;
	      };
	      args[1] = replacer;
	      return $stringify$1.apply(null, args);
	    }
	  });
	}

	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	if (!$Symbol$1[PROTOTYPE$3][TO_PRIMITIVE$2]) {
	  createNonEnumerableProperty$1($Symbol$1[PROTOTYPE$3], TO_PRIMITIVE$2, $Symbol$1[PROTOTYPE$3].valueOf);
	}
	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag$1($Symbol$1, SYMBOL$1);

	hiddenKeys$2[HIDDEN$1] = true;

	var defineProperty$d = objectDefineProperty$1.f;


	var NativeSymbol = global$2.Symbol;

	if (descriptors$1 && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
	  // Safari 12 bug
	  NativeSymbol().description !== undefined
	)) {
	  var EmptyStringDescriptionStore = {};
	  // wrap Symbol constructor for correct work with undefined description
	  var SymbolWrapper = function Symbol() {
	    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
	    var result = this instanceof SymbolWrapper
	      ? new NativeSymbol(description)
	      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
	      : description === undefined ? NativeSymbol() : NativeSymbol(description);
	    if (description === '') EmptyStringDescriptionStore[result] = true;
	    return result;
	  };
	  copyConstructorProperties(SymbolWrapper, NativeSymbol);
	  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
	  symbolPrototype.constructor = SymbolWrapper;

	  var symbolToString$1 = symbolPrototype.toString;
	  var native = String(NativeSymbol('test')) == 'Symbol(test)';
	  var regexp = /^Symbol\((.*)\)[^)]+$/;
	  defineProperty$d(symbolPrototype, 'description', {
	    configurable: true,
	    get: function description() {
	      var symbol = isObject$2(this) ? this.valueOf() : this;
	      var string = symbolToString$1.call(symbol);
	      if (has$2(EmptyStringDescriptionStore, symbol)) return '';
	      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
	      return desc === '' ? undefined : desc;
	    }
	  });

	  _export$1({ global: true, forced: true }, {
	    Symbol: SymbolWrapper
	  });
	}

	var styles$f = {"smallText__size_md":"telia-react-smallText__size_md","smallText__size_sm":"telia-react-smallText__size_sm"};

	var _excluded$g = ["tagName", "size", "className", "children"];

	function SmallText(_ref) {
	  var tagName = _ref.tagName,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$g);

	  var classNames = [styles$f["smallText__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({}, props, {
	    tagName: tagName // this circumvents some weird ts problem
	    ,
	    font: "teliasans",
	    className: classNames,
	    uppercase: false,
	    fontWeight: "normal"
	  }), children);
	}

	var supportedSmallTextSizes = ['md', 'sm'];

	var styles$g = {"checkbox":"telia-react-checkbox","checkbox_label":"telia-react-checkbox_label","checkbox_fakeCheckbox":"telia-react-checkbox_fakeCheckbox","checkbox_fakeCheckbox__checked":"telia-react-checkbox_fakeCheckbox__checked","checkbox_fakeCheckbox__disabled":"telia-react-checkbox_fakeCheckbox__disabled","checkbox_fakeCheckbox_error":"telia-react-checkbox_fakeCheckbox_error","checkbox__disabled":"telia-react-checkbox__disabled","checkbox_description":"telia-react-checkbox_description","checkbox_hiddenCheckbox":"telia-react-checkbox_hiddenCheckbox","checkbox_fakeCheckbox__checked_checkIcon":"telia-react-checkbox_fakeCheckbox__checked_checkIcon","checkbox_checkIcon":"telia-react-checkbox_checkIcon","checkbox__checked":"telia-react-checkbox__checked","checkbox_fakeCheckbox_checkIcon":"telia-react-checkbox_fakeCheckbox_checkIcon","checkbox__loading":"telia-react-checkbox__loading","checkbox_loader":"telia-react-checkbox_loader"};

	var styles$h = {"spinningLoaderLarge":"telia-react-spinningLoaderLarge","rotate":"telia-react-rotate","spinningLoaderMedium":"telia-react-spinningLoaderMedium","spinningLoaderSmall":"telia-react-spinningLoaderSmall"};

	var _excluded$h = ["className", "size"];

	var SpinningLoader = function SpinningLoader(_ref) {
	  var className = _ref.className,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'lg' : _ref$size,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$h);

	  var cssClassBySize = {
	    sm: 'spinningLoaderSmall',
	    md: 'spinningLoaderMedium',
	    lg: 'spinningLoaderLarge'
	  };
	  var loaderSize = cssClassBySize[size];
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "span",
	    className: className
	  }, props), /*#__PURE__*/React__default['default'].createElement("svg", {
	    className: styles$h["" + loaderSize],
	    width: "64",
	    height: "64",
	    viewBox: "0 0 64 64"
	  }, /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("path", {
	    d: "M56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32H0C7.72511e-07 14.3269 14.3269 -7.7252e-07 32 0C49.6731 7.72511e-07 64 14.3269 64 32H56Z M60 36C57.7909 36 56 34.2091 56 32C56 29.7909 57.7909 28 60 28C62.2091 28 64 29.7909 64 32C64 34.2091 62.2091 36 60 36Z",
	    fill: "url(#paint0_linear)"
	  }), /*#__PURE__*/React__default['default'].createElement("path", {
	    d: "M8 32C8 45.2548 18.7452 56 32 56V64C14.3269 64 0 49.6731 0 31.95H8Z",
	    fill: "url(#paint1_linear)"
	  })), /*#__PURE__*/React__default['default'].createElement("defs", null, /*#__PURE__*/React__default['default'].createElement("linearGradient", {
	    id: "paint0_linear",
	    x1: "49.3638",
	    y1: "8.15909",
	    x2: "6.82861",
	    y2: "29.9562",
	    gradientUnits: "userSpaceOnUse"
	  }, /*#__PURE__*/React__default['default'].createElement("stop", {
	    stopColor: "#990AE3"
	  }), /*#__PURE__*/React__default['default'].createElement("stop", {
	    offset: "1",
	    stopColor: "#BC6BE6"
	  })), /*#__PURE__*/React__default['default'].createElement("linearGradient", {
	    id: "paint1_linear",
	    x1: "5.20659",
	    y1: "33.7612",
	    x2: "32",
	    y2: "64",
	    gradientUnits: "userSpaceOnUse"
	  }, /*#__PURE__*/React__default['default'].createElement("stop", {
	    stopColor: "#BC6BE6"
	  }), /*#__PURE__*/React__default['default'].createElement("stop", {
	    offset: "0.0972687",
	    stopColor: "#C074E7",
	    stopOpacity: "0.940565"
	  }), /*#__PURE__*/React__default['default'].createElement("stop", {
	    offset: "1",
	    stopColor: "white",
	    stopOpacity: "0"
	  })))));
	};

	var styles$i = {"icon":"telia-react-icon","checkboxIcon":"telia-react-checkboxIcon","icon__sizeXlg":"telia-react-icon__sizeXlg","icon__sizeLg":"telia-react-icon__sizeLg","icon__sizeMd":"telia-react-icon__sizeMd","icon__sizeSm":"telia-react-icon__sizeSm","icon__sizeXs":"telia-react-icon__sizeXs","icon_svg":"telia-react-icon_svg"};

	var _excluded$i = ["color", "className", "iconName"];

	var CheckboxIcon = function CheckboxIcon(_ref) {
	  var color = _ref.color,
	      className = _ref.className,
	      iconName = _ref.iconName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$i);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    color: color,
	    className: [styles$i.checkboxIcon, className]
	  }, props), iconName === 'minus' && /*#__PURE__*/React__default['default'].createElement("svg", {
	    width: "16",
	    height: "16",
	    viewBox: "0 0 16 16",
	    fill: "currentColor",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, /*#__PURE__*/React__default['default'].createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M1 8C1 7.17157 1.67157 6.5 2.5 6.5H13.5C14.3284 6.5 15 7.17157 15 8C15 8.82843 14.3284 9.5 13.5 9.5H2.5C1.67157 9.5 1 8.82843 1 8Z"
	  })), iconName === 'checkmark' && /*#__PURE__*/React__default['default'].createElement("svg", {
	    width: "16",
	    height: "16",
	    viewBox: "0 0 16 16",
	    fill: "currentColor",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, /*#__PURE__*/React__default['default'].createElement("path", {
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    d: "M14.1662 2.56234C14.8221 3.06834 14.9437 4.01028 14.4377 4.66622L8.03501 12.966C7.29827 13.921 5.89013 14.0115 5.03724 13.1586L1.68934 9.81067C1.10355 9.22489 1.10355 8.27514 1.68934 7.68935C2.27513 7.10357 3.22487 7.10357 3.81066 7.68935L6.35435 10.233L12.0623 2.83381C12.5683 2.17787 13.5103 2.05633 14.1662 2.56234Z"
	  })));
	};

	var _excluded$j = ["loading", "checked", "label", "description", "onChange", "disabled", "error", "className", "name", "value"];

	var Checkbox = function Checkbox(_ref) {
	  var _ref2, _ref3;

	  var _ref$loading = _ref.loading,
	      loading = _ref$loading === void 0 ? false : _ref$loading,
	      checked = _ref.checked,
	      label = _ref.label,
	      description = _ref.description,
	      _onChange = _ref.onChange,
	      disabled = _ref.disabled,
	      error = _ref.error,
	      className = _ref.className,
	      name = _ref.name,
	      value = _ref.value,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$j);

	  var blur = function blur(event) {
	    event.preventDefault();
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: [styles$g.checkbox, className, (_ref2 = {}, _ref2[styles$g.checkbox__checked] = !!checked, _ref2[styles$g.checkbox__disabled] = disabled, _ref2[styles$g.checkbox__loading] = loading, _ref2)]
	  }, props), /*#__PURE__*/React__default['default'].createElement("label", {
	    className: styles$g.checkbox_label
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, null, loading ? /*#__PURE__*/React__default['default'].createElement(SpinningLoader, {
	    className: styles$g.checkbox_loader,
	    size: "sm"
	  }) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("input", {
	    onMouseDown: blur,
	    className: styles$g.checkbox_hiddenCheckbox,
	    type: "checkbox",
	    checked: !!checked,
	    tabIndex: -1,
	    onChange: function onChange(event) {
	      return !disabled && (_onChange == null ? void 0 : _onChange(event, !checked));
	    },
	    name: name,
	    value: value
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    borderRadius: {
	      size: 'sm'
	    },
	    backgroundColor: "white",
	    className: [styles$g.checkbox_fakeCheckbox, 'checkbox-test', (_ref3 = {}, _ref3[styles$g.checkbox_fakeCheckbox_error] = error, _ref3[styles$g.checkbox_fakeCheckbox__checked] = !!checked, _ref3[styles$g.checkbox_fakeCheckbox__disabled] = disabled, _ref3)],
	    onMouseDown: blur,
	    tabIndex: disabled ? -1 : 0,
	    onKeyDown: function onKeyDown(event) {
	      event.keyCode === 13 && !disabled && (_onChange == null ? void 0 : _onChange(event, !checked));
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(CheckboxIcon, {
	    color: disabled ? 'gray400' : 'white',
	    iconName: checked === 'mixed' ? 'minus' : 'checkmark',
	    className: styles$g.checkbox_checkIcon
	  }))), (label || description) && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement("div", null, label ? /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    color: disabled ? 'gray400' : 'black',
	    block: true
	  }, label) : /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  }), description && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xxs"
	  }), /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    className: styles$g.checkbox_description,
	    color: error ? 'red600' : 'gray500',
	    block: true
	  }, description)))))));
	};

	var styles$j = {"optionlist":"telia-react-optionlist","optionlist_borderlessItems":"telia-react-optionlist_borderlessItems","optionlist_item":"telia-react-optionlist_item","optionlist__showKeyboardFocus":"telia-react-optionlist__showKeyboardFocus","optionlist_item__selected":"telia-react-optionlist_item__selected","optionlist_item__disabled":"telia-react-optionlist_item__disabled","checkbox__disabled":"telia-react-checkbox__disabled","checkbox_label":"telia-react-checkbox_label","checkbox_fakeCheckbox":"telia-react-checkbox_fakeCheckbox","optionlist_itemContent":"telia-react-optionlist_itemContent"};

	/* istanbul ignore file */
	var checkIE11 = function checkIE11() {
	  if (typeof document !== 'undefined' || typeof window !== 'undefined') {
	    return !!window.MSInputMethodContext && !!document.documentMode;
	  }

	  return false;
	};

	var isIE11 = checkIE11();

	function ownKeys$6(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; forEach$3(_context5 = ownKeys$6(Object(source), true)).call(_context5, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context6; forEach$3(_context6 = ownKeys$6(Object(source))).call(_context6, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }

	var OptionList = /*#__PURE__*/function (_Component) {
	  inheritsLoose(OptionList, _Component);

	  function OptionList(props) {
	    var _context2;

	    var _this;

	    _this = _Component.call(this, props) || this;
	    _this.optionListElement = /*#__PURE__*/React__default['default'].createRef();

	    _this.findFocusedIndex = function (focusedId) {
	      var focusableOptions = _this.state.focusableOptions;
	      return findIndex$3(focusableOptions).call(focusableOptions, function (option) {
	        return option.value === focusedId;
	      });
	    };

	    _this.focusOneOptionDown = function (focusedOptionIndex) {
	      var _nextOption$ref$curre;

	      var focusableOptions = _this.state.focusableOptions;
	      var nextOption = focusedOptionIndex === focusableOptions.length - 1 ? find$3(focusableOptions).call(focusableOptions, function (option, index) {
	        return index === 0;
	      }) : find$3(focusableOptions).call(focusableOptions, function (option, index) {
	        return index === focusedOptionIndex + 1;
	      });
	      nextOption == null ? void 0 : (_nextOption$ref$curre = nextOption.ref.current) == null ? void 0 : _nextOption$ref$curre.focus();
	    };

	    _this.focusOneOptionUp = function (focusedOptionIndex) {
	      var _nextOption$ref$curre2;

	      var focusableOptions = _this.state.focusableOptions;
	      var nextOption = focusedOptionIndex === 0 ? find$3(focusableOptions).call(focusableOptions, function (option, index) {
	        return index === focusableOptions.length - 1;
	      }) : find$3(focusableOptions).call(focusableOptions, function (option, index) {
	        return index === focusedOptionIndex - 1;
	      });
	      nextOption == null ? void 0 : (_nextOption$ref$curre2 = nextOption.ref.current) == null ? void 0 : _nextOption$ref$curre2.focus();
	    };

	    _this.keyDown = function (event) {
	      var focusedOptionIndex = _this.findFocusedIndex(event.currentTarget.id); // Enable keyboard focus styles


	      if (event.key === 'Tab' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
	        _this.setState({
	          keyboardStyles: true
	        });
	      }

	      if (event.shiftKey && event.key === 'Tab') {
	        event.preventDefault();

	        _this.focusOneOptionUp(focusedOptionIndex);
	      } else {
	        switch (event.key) {
	          case 'ArrowUp':
	            event.preventDefault();

	            _this.focusOneOptionUp(focusedOptionIndex);

	            break;

	          case 'ArrowDown':
	            event.preventDefault();

	            _this.focusOneOptionDown(focusedOptionIndex);

	            break;

	          case 'Escape':
	            event.preventDefault();
	            _this.props.onBlur == null ? void 0 : _this.props.onBlur(event);
	            break;

	          case 'Enter':
	            event.preventDefault();

	            _this.handleOptionOnClick(event);

	            break;

	          case 'Tab':
	            event.preventDefault();

	            _this.focusOneOptionDown(focusedOptionIndex);

	            break;
	        }
	      }
	    };

	    _this.handleOptionOnClick = function (event) {
	      var _context;

	      event.preventDefault(); // If target is a input, prevent parent event triggering.

	      var optionOnClick = _this.props.optionOnClick;
	      var selectedId = event.currentTarget.dataset.id;

	      var clickedOptionObject = find$3(_context = _this.state.focusableOptions).call(_context, function (option) {
	        return option.value === selectedId;
	      });
	      /* istanbul ignore else  */


	      if (clickedOptionObject) {
	        var _clickedOptionObject$;

	        (_clickedOptionObject$ = clickedOptionObject.ref.current) == null ? void 0 : _clickedOptionObject$.focus();
	        optionOnClick(event, clickedOptionObject);
	      }
	    };

	    _this.triggerClickOutside = function (event) {
	      if (_this.optionListElement.current && !_this.optionListElement.current.contains(event.relatedTarget)) {
	        /* In IE prevent the onBlur */

	        /* istanbul ignore else  */
	        if (!isIE11) {
	          _this.props.onBlur == null ? void 0 : _this.props.onBlur(event);
	        }
	      }
	    };

	    var options = map$3(_context2 = props.options).call(_context2, function (option) {
	      return _objectSpread$4(_objectSpread$4({}, option), {}, {
	        ref: /*#__PURE__*/React__default['default'].createRef()
	      });
	    });

	    _this.state = {
	      options: options,
	      focusableOptions: filter$3(options).call(options, function (option) {
	        return !option.disabled;
	      }),
	      keyboardStyles: false
	    };
	    return _this;
	  }

	  var _proto = OptionList.prototype;

	  _proto.componentDidMount = function componentDidMount() {
	    var focusedOptionId = this.props.focusedOptionId;
	    var focusableOptions = this.state.focusableOptions;

	    if (typeof focusedOptionId !== 'undefined') {
	      var _focusedOption$ref$cu;

	      var focusedOption = find$3(focusableOptions).call(focusableOptions, function (option) {
	        return option.value === focusedOptionId;
	      });

	      focusedOption == null ? void 0 : (_focusedOption$ref$cu = focusedOption.ref.current) == null ? void 0 : _focusedOption$ref$cu.focus();
	    }
	  };

	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;

	    /* istanbul ignore else  */
	    if (this.props.options !== prevProps.options) {
	      var _context3;

	      var optionsWithRefs = map$3(_context3 = this.props.options).call(_context3, function (option) {
	        return _objectSpread$4(_objectSpread$4({}, option), {}, {
	          ref: /*#__PURE__*/React__default['default'].createRef()
	        });
	      });

	      this.setState({
	        options: optionsWithRefs,
	        focusableOptions: filter$3(optionsWithRefs).call(optionsWithRefs, function (option) {
	          return !option.disabled;
	        })
	      });
	    }
	    /* istanbul ignore else  */


	    if (this.props.focusedOptionId !== prevProps.focusedOptionId) {
	      var _context4, _focusedOption$ref$cu2;

	      var focusedOption = find$3(_context4 = this.state.focusableOptions).call(_context4, function (option) {
	        return option.value === _this2.props.focusedOptionId;
	      });

	      focusedOption == null ? void 0 : (_focusedOption$ref$cu2 = focusedOption.ref.current) == null ? void 0 : _focusedOption$ref$cu2.focus();
	    }
	  };

	  _proto.render = function render() {
	    var _ref,
	        _this3 = this;

	    var _this$state = this.state,
	        options = _this$state.options,
	        keyboardStyles = _this$state.keyboardStyles;
	    return /*#__PURE__*/React__default['default'].createElement("div", {
	      style: {
	        marginTop: '4px'
	      },
	      className: classnames([styles$j.optionlist, this.props.className, (_ref = {}, _ref[styles$j.optionlist__showKeyboardFocus] = keyboardStyles, _ref[styles$j.optionlist_borderlessItems] = this.props.noBorderBottom, _ref)]),
	      onBlur: this.triggerClickOutside,
	      onMouseDown: this.props.onMouseDown,
	      ref: this.optionListElement
	    }, map$3(options).call(options, function (option, index) {
	      var _ref2;

	      var disabled = option.disabled,
	          value = option.value,
	          label = option.label,
	          ref = option.ref,
	          checked = option.checked;
	      var classNames = [styles$j.optionlist_item, 'optionList__optionId', (_ref2 = {}, _ref2[styles$j.optionlist_item__selected] = _this3.props.focusedOptionId === value || checked, _ref2[styles$j.optionlist_item__disabled] = option.disabled, _ref2)];
	      var isCheckable = typeof checked === 'boolean';
	      var fontWeight = _this3.props.focusedOptionId === value ? 'bold' : checked ? 'bold' : undefined;
	      return /*#__PURE__*/React__default['default'].createElement("div", {
	        key: index,
	        className: classnames(classNames),
	        tabIndex: disabled ? -1 : 0,
	        onClick: disabled ? undefined : _this3.handleOptionOnClick,
	        onKeyDown: disabled ? undefined : _this3.keyDown,
	        ref: disabled ? undefined : ref,
	        "data-id": value,
	        id: value
	      }, isCheckable ? /*#__PURE__*/React__default['default'].createElement(Flex, {
	        className: styles$j.optionlist_itemContent
	      }, /*#__PURE__*/React__default['default'].createElement(Checkbox, {
	        checked: checked,
	        disabled: disabled,
	        onChange: noop_1
	      }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	        size: "xs"
	      }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	        tagName: "span",
	        fontWeight: fontWeight
	      }, label)) : /*#__PURE__*/React__default['default'].createElement(Flex, {
	        centeredVertically: true,
	        spaceBetween: true
	      }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	        tagName: "span",
	        fontWeight: fontWeight
	      }, label), /*#__PURE__*/React__default['default'].createElement(Icon, {
	        hidden: _this3.props.focusedOptionId !== value,
	        name: "checkmark",
	        color: "purple500",
	        size: "sm"
	      })));
	    }));
	  };

	  return OptionList;
	}(React.Component);

	var styles$k = {"autocomplete":"telia-react-autocomplete","input":"telia-react-input","autocomplete_open":"telia-react-autocomplete_open","inputMessage_textContainer":"telia-react-inputMessage_textContainer","inputMessage_text":"telia-react-inputMessage_text","input__container_disabled":"telia-react-input__container_disabled","optionlist":"telia-react-optionlist"};

	var _excluded$k = ["options", "onChange", "value", "errorText", "disabled", "onOptionSelect"];

	var Autocomplete = function Autocomplete(_ref) {
	  var _ref2;

	  var options = _ref.options,
	      onChange = _ref.onChange,
	      value = _ref.value,
	      errorText = _ref.errorText,
	      disabled = _ref.disabled,
	      onOptionSelect = _ref.onOptionSelect,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$k);

	  var _useState = React.useState(false),
	      open = _useState[0],
	      setOpen = _useState[1];

	  var _useState2 = React.useState(false),
	      optionIsSelected = _useState2[0],
	      setOptionIsSelected = _useState2[1];

	  var _useState3 = React.useState(),
	      focusedOptionId = _useState3[0],
	      setFocusedOptionId = _useState3[1];

	  var inputElement = React.useRef(null);
	  var autocompleteElement = React.useRef(null);

	  var focusOnInput = function focusOnInput() {
	    var _inputElement$current;

	    (_inputElement$current = inputElement.current) == null ? void 0 : _inputElement$current.focus();
	  };

	  React.useEffect(function () {
	    var _options$;

	    if (((_options$ = options[0]) == null ? void 0 : _options$.label) === value) {
	      setOpen(false);
	    } else if (options.length > 0 && value && !optionIsSelected) {
	      setOpen(true);
	    } else {
	      setOpen(false);
	      setFocusedOptionId(undefined);
	      setOptionIsSelected(false);
	    }
	  }, [value, options]);

	  var handleOptionListBlur = function handleOptionListBlur(event) {
	    var _autocompleteElement$;

	    var isFocusEvent = function isFocusEvent(e) {
	      return 'relatedTarget' in e;
	    };
	    /* istanbul ignore else  */


	    if (!isFocusEvent(event) || !((_autocompleteElement$ = autocompleteElement.current) != null && _autocompleteElement$.contains(event.relatedTarget))) {
	      setOpen(false);
	      setFocusedOptionId(undefined);
	      focusOnInput();
	    }
	  };

	  var handleOnBlur = function handleOnBlur(e) {
	    /* istanbul ignore else */
	    if (!isIE11) {
	      var _autocompleteElement$2;

	      /* istanbul ignore else  */
	      if (!((_autocompleteElement$2 = autocompleteElement.current) != null && _autocompleteElement$2.contains(e.relatedTarget)) && open) {
	        setOpen(false);
	        setFocusedOptionId(undefined);
	      }
	    }
	    /* istanbul ignore next */


	    if (isIE11 && typeof document !== 'undefined') {
	      var _context;

	      /* Prevent the onBlur in IE if user has clicked an option from the list or the scrollbar inside the optionlist */
	      if (document.activeElement && indexOf$7(_context = document.activeElement.className).call(_context, 'telia-react-optionlist') < 0) {
	        setOpen(false);
	        setFocusedOptionId(undefined);
	      }
	    }
	  };

	  var handleOptionSelect = function handleOptionSelect(event, option) {
	    focusOnInput();
	    setOpen(false);
	    setOptionIsSelected(true);
	    setFocusedOptionId(undefined);
	    onOptionSelect && onOptionSelect(event, option);
	  };

	  var handleInputChange = function handleInputChange(event) {
	    onChange(event, event.target.value);
	  };

	  var keyDown = function keyDown(event) {
	    if (options.length === 0) {
	      return;
	    }

	    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
	      event.preventDefault();
	      /* istanbul ignore else  */

	      if (!open) {
	        setOpen(true);
	      }

	      if (event.target === inputElement.current || event.target === 'autocompleteTestEntryPoint') {
	        if (event.key === 'ArrowDown') {
	          var firstNotDisabledOption = find$3(options).call(options, function (option) {
	            return !!option.disabled === false;
	          });

	          setFocusedOptionId(firstNotDisabledOption == null ? void 0 : firstNotDisabledOption.value);
	        }

	        if (event.key === 'ArrowUp') {
	          var _context2, _context3;

	          var lastNotDisabledOption = find$3(_context2 = reverse$3(_context3 = slice$3(options).call(options)).call(_context3)).call(_context2, function (option) {
	            return !!option.disabled === false;
	          });

	          setFocusedOptionId(lastNotDisabledOption == null ? void 0 : lastNotDisabledOption.value);
	        }
	      }
	    }
	  };

	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: classnames([styles$k.autocomplete, (_ref2 = {}, _ref2[styles$k.autocomplete_open] = open, _ref2)]),
	    ref: autocompleteElement,
	    onKeyDown: keyDown,
	    onBlur: handleOnBlur
	  }, /*#__PURE__*/React__default['default'].createElement(BaseInput, _extends_1({}, props, {
	    disabled: disabled,
	    value: value || undefined,
	    onChange: disabled ? undefined : handleInputChange,
	    onClick: disabled ? undefined : focusOnInput,
	    ref: inputElement,
	    errorText: errorText && errorText === ' ' ? ' ' : errorText
	  })), !!open && /*#__PURE__*/React__default['default'].createElement(OptionList, {
	    options: options,
	    onBlur: handleOptionListBlur,
	    optionOnClick: handleOptionSelect,
	    focusedOptionId: focusedOptionId
	  }));
	};

	var supportedInputTypes = ['text', 'password', 'email', 'tel', 'search'];

	var styles$l = {"indicator":"telia-react-indicator"};

	var _excluded$l = ["color", "children"];

	var AvailabilityIndicator = function AvailabilityIndicator(_ref) {
	  var color = _ref.color,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$l);

	  return /*#__PURE__*/React__default['default'].createElement(Flex, _extends_1({
	    centeredVertically: true
	  }, props), /*#__PURE__*/React__default['default'].createElement(Div, {
	    backgroundColor: color,
	    borderRadius: {
	      size: 'rounded'
	    },
	    className: styles$l.indicator
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), children);
	};

	var styles$m = {"textlink__size_lg":"telia-react-textlink__size_lg","textlink__size_md":"telia-react-textlink__size_md","textlink__size_sm":"telia-react-textlink__size_sm"};

	var _excluded$m = ["size", "color", "className", "children"];
	var hoverColorMap = {
	  gray800: 'purple500',
	  black: 'purple500',
	  red600: 'red400',
	  purple500: 'purple400'
	};

	var TextLink = function TextLink(_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'purple500' : _ref$color,
	      className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$m);

	  var classNames = [styles$m["textlink__size_" + size.toLowerCase()], styles$m["textlink"], className];
	  return /*#__PURE__*/React__default['default'].createElement(Link, _extends_1({}, props, {
	    color: color,
	    hoverColor: hoverColorMap[color]
	  }), /*#__PURE__*/React__default['default'].createElement(Typography, {
	    font: "teliasans",
	    className: classNames,
	    uppercase: false,
	    fontWeight: "normal"
	  }, children));
	};

	var supportedTextLinkSizes = ['lg', 'md', 'sm'];
	var supportedTextLinkColors = ['purple500', 'gray800', 'black', 'red600'];

	var _excluded$n = ["label", "children", "truncateToggle"];

	var BreadcrumbItem = function BreadcrumbItem(_ref) {
	  var label = _ref.label,
	      children = _ref.children,
	      truncateToggle = _ref.truncateToggle,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$n);

	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, truncateToggle ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(TextLink, _extends_1({
	    size: "sm"
	  }, props, {
	    color: 'gray800'
	  }), label), children) : /*#__PURE__*/React__default['default'].createElement(TextLink, _extends_1({
	    size: "sm"
	  }, props, {
	    color: 'gray800'
	  }), label));
	};

	var style = {"breadcrumb_currentPage":"telia-react-breadcrumb_currentPage","breadcrumb_optionList":"telia-react-breadcrumb_optionList","breadcrumb_truncated_toggle":"telia-react-breadcrumb_truncated_toggle","breadcrumb_truncated_wrapper":"telia-react-breadcrumb_truncated_wrapper"};

	var BreadcrumbTruncatedItems = function BreadcrumbTruncatedItems(_ref) {
	  var onClose = _ref.onClose,
	      optionOnClick = _ref.optionOnClick,
	      options = _ref.options,
	      className = _ref.className;
	  var ref = React.useRef(null);
	  var escapeListener = React.useCallback(
	  /* istanbul ignore next  */
	  function (e) {
	    if (e.key === 'Escape') {
	      onClose && onClose();
	    }
	  }, []);
	  var clickListener = React.useCallback(
	  /* istanbul ignore next  */
	  function (e) {
	    if (ref.current) {
	      if (!ref.current.contains(e.target)) {
	        onClose && onClose();
	      }
	    }
	  }, [ref.current]);
	  React.useEffect(function () {
	    document.addEventListener('click', clickListener);
	    document.addEventListener('keyup', escapeListener);
	    return function () {
	      document.removeEventListener('click', clickListener);
	      document.removeEventListener('keyup', escapeListener);
	    };
	  }, []);
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    ref: ref,
	    className: style.breadcrumb_truncated_wrapper
	  }, /*#__PURE__*/React__default['default'].createElement(OptionList, {
	    noBorderBottom: true,
	    className: className,
	    optionOnClick: optionOnClick,
	    options: options
	  }));
	};

	var _excluded$o = ["truncated", "items"];

	var Separator = function Separator() {
	  return /*#__PURE__*/React__default['default'].createElement(Span, {
	    "aria-hidden": true,
	    inlineBlock: true,
	    padding: {
	      horizontal: 'xs'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "chevron-right",
	    color: "black",
	    size: "xs"
	  }));
	};

	var Breadcrumb = function Breadcrumb(_ref) {
	  var truncated = _ref.truncated,
	      items = _ref.items,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$o);

	  var _useState = React.useState(false),
	      open = _useState[0],
	      setOpen = _useState[1];

	  var renderItems = function renderItems(items) {
	    return map$3(items).call(items, function (item, index) {
	      if (index == items.length - 1) {
	        return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({
	          key: item.value,
	          font: "teliasans",
	          uppercase: false,
	          fontWeight: "medium",
	          color: "gray800",
	          className: style.breadcrumb_currentPage
	        }, item), item.label);
	      }

	      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, {
	        key: index
	      }, /*#__PURE__*/React__default['default'].createElement(BreadcrumbItem, _extends_1({
	        key: item.value,
	        onKeyPress: function onKeyPress(e) {
	          e.key === 'Enter' && item.onClick();
	        }
	      }, item)), /*#__PURE__*/React__default['default'].createElement(Separator, null));
	    });
	  };

	  var renderItemsTruncated = function renderItemsTruncated(items) {
	    var _context;

	    var firstItem = items[0];

	    var optionListItems = map$3(_context = slice$3(items).call(items, 1, items.length - 2)).call(_context, function (item) {
	      return {
	        label: item.label,
	        value: item.value
	      };
	    });

	    var lastTwoItems = slice$3(items).call(items, items.length - 2);

	    var optionOnClickHandler = function optionOnClickHandler(option) {
	      setOpen(false);

	      var selectedOption = filter$3(items).call(items, function (item) {
	        return item.value == option.value;
	      })[0];

	      selectedOption.onClick && selectedOption.onClick();
	    };

	    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(BreadcrumbItem, _extends_1({
	      onKeyPress: function onKeyPress(e) {
	        e.key === 'Enter' && firstItem.onClick();
	      }
	    }, firstItem)), /*#__PURE__*/React__default['default'].createElement(Separator, null), /*#__PURE__*/React__default['default'].createElement(BreadcrumbItem, {
	      truncateToggle: true,
	      value: "telia-react-component-library-truncated-items",
	      label: '...',
	      onClick: function onClick() {
	        setOpen(!open);
	      },
	      onKeyPress: function onKeyPress(e) {
	        e.key === 'Enter' && setOpen(!open);
	      }
	    }, !!open && /*#__PURE__*/React__default['default'].createElement("span", {
	      className: style.breadcrumb_truncated_toggle
	    }, /*#__PURE__*/React__default['default'].createElement(BreadcrumbTruncatedItems, {
	      onClose: function onClose() {
	        setOpen(false);
	      },
	      className: style.breadcrumb_optionList,
	      optionOnClick: function optionOnClick(e, option) {
	        optionOnClickHandler(option);
	      },
	      options: optionListItems
	    }))), /*#__PURE__*/React__default['default'].createElement(Separator, null), renderItems(lastTwoItems));
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: 'nav'
	  }, props), truncated ? renderItemsTruncated(items) : renderItems(items));
	};

	var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails$1(function () {
	    // eslint-disable-next-line no-useless-call,no-throw-literal
	    method.call(null, argument || function () { throw 1; }, 1);
	  });
	};

	var nativeJoin = [].join;

	var ES3_STRINGS = indexedObject$1 != Object;
	var STRICT_METHOD$2 = arrayMethodIsStrict$1('join', ',');

	// `Array.prototype.join` method
	// https://tc39.es/ecma262/#sec-array.prototype.join
	_export$1({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$2 }, {
	  join: function join(separator) {
	    return nativeJoin.call(toIndexedObject$1(this), separator === undefined ? ',' : separator);
	  }
	});

	var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
	var MAX_SAFE_INTEGER$2 = 0x1FFFFFFFFFFFFF;
	var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
	var TypeError$a = global$1.TypeError; // We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679

	var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

	var isConcatSpreadable = function (O) {
	  if (!isObject(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray(O);
	};

	var FORCED$1 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species

	_export({
	  target: 'Array',
	  proto: true,
	  forced: FORCED$1
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;

	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];

	      if (isConcatSpreadable(E)) {
	        len = lengthOfArrayLike(E);
	        if (n + len > MAX_SAFE_INTEGER$2) throw TypeError$a(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

	        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
	      } else {
	        if (n >= MAX_SAFE_INTEGER$2) throw TypeError$a(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
	        createProperty(A, n++, E);
	      }
	    }

	    A.length = n;
	    return A;
	  }
	});

	var concat$2 = entryVirtual('Array').concat;

	var ArrayPrototype$8 = Array.prototype;

	var concat$3 = function (it) {
	  var own = it.concat;
	  return it === ArrayPrototype$8 || objectIsPrototypeOf(ArrayPrototype$8, it) && own === ArrayPrototype$8.concat ? concat$2 : own;
	};

	var concat$4 = concat$3;

	var concat$5 = concat$4;

	var BREAKPOINTS = [{
	  breakpoint: 'xxxs',
	  to: 375
	}, {
	  breakpoint: 'xxs',
	  from: 375,
	  to: 480
	}, {
	  breakpoint: 'xs',
	  from: 480,
	  to: 600
	}, {
	  breakpoint: 'sm',
	  from: 600,
	  to: 840
	}, {
	  breakpoint: 'md',
	  from: 840,
	  to: 1080
	}, {
	  breakpoint: 'lg',
	  from: 1080,
	  to: 1440
	}, {
	  breakpoint: 'xlg',
	  from: 1440,
	  to: 1920
	}, {
	  breakpoint: 'xxlg',
	  from: 1920
	}];

	var BREAKPOINT_QUERIES = map$3(BREAKPOINTS).call(BREAKPOINTS, function (_ref) {
	  var _context;

	  var breakpoint = _ref.breakpoint,
	      from = _ref.from,
	      to = _ref.to;
	  return {
	    breakpoint: breakpoint,
	    // Creating media query for each breakpoint
	    query: concat$5(_context = []).call(_context, from ? ["(min-width: " + (from + 1) + "px)"] : [], to ? ["(max-width: " + to + "px)"] : []).join(' and ')
	  };
	});

	var useWatchBreakpoint = function useWatchBreakpoint() {
	  if (typeof matchMedia === 'undefined') {
	    return 'xxlg';
	  } // Creating memorized object for optimization


	  var matchers = React.useMemo(function () {
	    return map$3(BREAKPOINT_QUERIES).call(BREAKPOINT_QUERIES, function (_ref2) {
	      var breakpoint = _ref2.breakpoint,
	          query = _ref2.query;
	      return {
	        breakpoint: breakpoint,
	        matcher: matchMedia(query) // matchMedia browser's method

	      };
	    });
	  }, []); // main function to return matched breakpoint useCallback for optimized memorized function

	  var findMatchingBreakpoint = React.useCallback(function () {
	    var _foundMatcher$breakpo;

	    var foundMatcher = find$3(matchers).call(matchers, function (_ref3) {
	      var matcher = _ref3.matcher;
	      return matcher.matches;
	    });

	    return (_foundMatcher$breakpo = foundMatcher == null ? void 0 : foundMatcher.breakpoint) != null ? _foundMatcher$breakpo : 'xxlg';
	  }, [matchers]);

	  var _useState = React.useState(function () {
	    return findMatchingBreakpoint();
	  }),
	      currentBreakpoint = _useState[0],
	      setBreakpoint = _useState[1];

	  var breakpointRef = React.useRef(currentBreakpoint);
	  React.useEffect(function () {
	    breakpointRef.current = currentBreakpoint;
	  }, [currentBreakpoint]);
	  React.useEffect(function () {
	    // on media change it updates the breakpoint
	    var onChange = function onChange(_ref4) {
	      var matches = _ref4.matches;

	      if (!matches) {
	        return;
	      }

	      var newBreakpoint = findMatchingBreakpoint();

	      if (newBreakpoint !== breakpointRef.current) {
	        setBreakpoint(newBreakpoint);
	      }
	    }; // adding media listener to onChange so that onChange get called when screen size changes so that it can update the breakpoint


	    forEach$3(matchers).call(matchers, function (_ref5) {
	      var matcher = _ref5.matcher;
	      return matcher.addListener(onChange);
	    });

	    return function () {
	      forEach$3(matchers).call(matchers, function (_ref6) {
	        var matcher = _ref6.matcher;
	        return matcher.removeListener(onChange);
	      });
	    };
	  }, [matchers, findMatchingBreakpoint, setBreakpoint, breakpointRef]);
	  return currentBreakpoint;
	};

	var BREAKPOINT_ORDER = {
	  xxxs: 0,
	  xxs: 1,
	  xs: 2,
	  sm: 3,
	  md: 4,
	  lg: 5,
	  xlg: 6,
	  xxlg: 7
	};

	var compareBreakpoint = function compareBreakpoint(a, b) {
	  var aI = BREAKPOINT_ORDER[a];
	  var bI = BREAKPOINT_ORDER[b];

	  if (aI === bI) {
	    return 0;
	  } else if (aI > bI) {
	    return 1;
	  } else {
	    return -1;
	  }
	};

	var getMatchedBreakpoint = function getMatchedBreakpoint(breakpointMatcher, breakpoint) {
	  var widerThan = breakpointMatcher.widerThan,
	      narrowerThan = breakpointMatcher.narrowerThan,
	      at = breakpointMatcher.at;

	  if (widerThan !== undefined) {
	    return compareBreakpoint(breakpoint, widerThan) >= 0;
	  } else if (narrowerThan !== undefined) {
	    return compareBreakpoint(breakpoint, narrowerThan) < 0;
	  } else if (at !== undefined) {
	    return compareBreakpoint(breakpoint, at) === 0;
	  }

	  return false;
	};

	var Breakpoint = function Breakpoint(props) {
	  var children = props.children;
	  var breakpoint = useWatchBreakpoint();
	  var show = getMatchedBreakpoint(props, breakpoint);
	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, show ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, children) : null);
	};

	// get consumer context using 'useContext' hook
	var BreakpointContext = /*#__PURE__*/React.createContext('xxlg');

	var BreakpointProvider = function BreakpointProvider(_ref) {
	  var children = _ref.children;
	  var breakpoint = useWatchBreakpoint();
	  return /*#__PURE__*/React__default['default'].createElement(BreakpointContext.Provider, {
	    value: breakpoint
	  }, children);
	}; // another way to use consumer context


	BreakpointProvider.Consumer = BreakpointContext.Consumer;
	BreakpointProvider.Context = BreakpointContext;

	var styles$n = {"buttonText__size_md":"telia-react-buttonText__size_md","buttonText__size_sm":"telia-react-buttonText__size_sm"};

	var _excluded$p = ["size", "className", "children"];

	var ButtonText = function ButtonText(_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$p);

	  var classNames = [styles$n["buttonText__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({}, props, {
	    className: classNames,
	    font: "teliasans",
	    uppercase: true,
	    fontWeight: "bold"
	  }), children);
	};

	var styles$o = {"button":"telia-react-button","button__disabled":"telia-react-button__disabled","button__loading":"telia-react-button__loading","button__loader":"telia-react-button__loader","button__size__sm":"telia-react-button__size__sm","button__size__md":"telia-react-button__size__md","button__size__lg":"telia-react-button__size__lg","button__size__xl":"telia-react-button__size__xl","button__primary":"telia-react-button__primary","button__expandWhenMobile":"telia-react-button__expandWhenMobile","button__primaryWhite":"telia-react-button__primaryWhite","button__purchase":"telia-react-button__purchase","button__secondary":"telia-react-button__secondary","button__secondaryWhite":"telia-react-button__secondaryWhite","button__purchaseSecondary":"telia-react-button__purchaseSecondary","button__destructive":"telia-react-button__destructive","button__secondaryDestructive":"telia-react-button__secondaryDestructive","button__text":"telia-react-button__text"};

	var func$3 = convert_1('keys', keys_1, _falseOptions);

	func$3.placeholder = placeholder;
	var keys$8 = func$3;

	var styles$p = {"loaderLarge":"telia-react-loaderLarge","loaderLarge__iconContainer":"telia-react-loaderLarge__iconContainer","pebbleSpinner":"telia-react-pebbleSpinner","loaderMedium":"telia-react-loaderMedium","loaderMedium__iconContainer":"telia-react-loaderMedium__iconContainer","loaderSmall":"telia-react-loaderSmall","loaderSmall__iconContainer":"telia-react-loaderSmall__iconContainer"};

	var white = {
		color: "#ffffff"
	};
	var overlay = {
		color: "rgba(#222222, 0.5)"
	};
	var transparent = {
		color: "transparent"
	};
	var inherit = {
		color: "inherit"
	};
	var black = {
		color: "#222222"
	};
	var purple100 = {
		color: "#fbf4ff"
	};
	var purple200 = {
		color: "#edc8ff"
	};
	var purple300 = {
		color: "#de99ff"
	};
	var purple400 = {
		color: "#c158f8"
	};
	var purple500 = {
		color: "#990ae3"
	};
	var purple600 = {
		color: "#7d00bd"
	};
	var purple700 = {
		color: "#5f008f"
	};
	var purple800 = {
		color: "#3f005e"
	};
	var purple900 = {
		color: "#1f002e"
	};
	var gray100 = {
		color: "#fbfbfb"
	};
	var gray200 = {
		color: "#f2f2f2"
	};
	var gray300 = {
		color: "#cccccc"
	};
	var gray400 = {
		color: "#a0a0a0"
	};
	var gray500 = {
		color: "#6e6e6e"
	};
	var gray600 = {
		color: "#5e5e5e"
	};
	var gray700 = {
		color: "#4e4e4e"
	};
	var gray800 = {
		color: "#303030"
	};
	var gray900 = {
		color: "#222222"
	};
	var red100 = {
		color: "#fff4f7"
	};
	var red200 = {
		color: "#ffccdd"
	};
	var red300 = {
		color: "#ffa4c3"
	};
	var red400 = {
		color: "#f74f87"
	};
	var red500 = {
		color: "#e4175c"
	};
	var red600 = {
		color: "#be0040"
	};
	var red700 = {
		color: "#900030"
	};
	var red800 = {
		color: "#5e0020"
	};
	var red900 = {
		color: "#2e000f"
	};
	var green100 = {
		color: "#f3fff9"
	};
	var green200 = {
		color: "#c5f8de"
	};
	var green300 = {
		color: "#95f4c3"
	};
	var green400 = {
		color: "#48e494"
	};
	var green500 = {
		color: "#00d066"
	};
	var green600 = {
		color: "#00af56"
	};
	var green700 = {
		color: "#008641"
	};
	var green800 = {
		color: "#00592b"
	};
	var green900 = {
		color: "#002e16"
	};
	var orange100 = {
		color: "#fffaf4"
	};
	var orange200 = {
		color: "#ffefcb"
	};
	var orange300 = {
		color: "#ffe39f"
	};
	var orange400 = {
		color: "#ffc14d"
	};
	var orange500 = {
		color: "#ff9b00"
	};
	var orange600 = {
		color: "#d27f00"
	};
	var orange700 = {
		color: "#a86600"
	};
	var orange800 = {
		color: "#6b4100"
	};
	var orange900 = {
		color: "#2e1c00"
	};
	var blue100 = {
		color: "#f4faff"
	};
	var blue200 = {
		color: "#cbefff"
	};
	var blue300 = {
		color: "#9fe2ff"
	};
	var blue400 = {
		color: "#4dc0ff"
	};
	var blue500 = {
		color: "#0099ff"
	};
	var blue600 = {
		color: "#007acc"
	};
	var blue700 = {
		color: "#005f9e"
	};
	var blue800 = {
		color: "#003d65"
	};
	var blue900 = {
		color: "#001c2e"
	};
	var colors$1 = {
		white: white,
		overlay: overlay,
		transparent: transparent,
		inherit: inherit,
		black: black,
		purple100: purple100,
		purple200: purple200,
		purple300: purple300,
		purple400: purple400,
		purple500: purple500,
		purple600: purple600,
		purple700: purple700,
		purple800: purple800,
		purple900: purple900,
		gray100: gray100,
		gray200: gray200,
		gray300: gray300,
		gray400: gray400,
		gray500: gray500,
		gray600: gray600,
		gray700: gray700,
		gray800: gray800,
		gray900: gray900,
		red100: red100,
		red200: red200,
		red300: red300,
		red400: red400,
		red500: red500,
		red600: red600,
		red700: red700,
		red800: red800,
		red900: red900,
		green100: green100,
		green200: green200,
		green300: green300,
		green400: green400,
		green500: green500,
		green600: green600,
		green700: green700,
		green800: green800,
		green900: green900,
		orange100: orange100,
		orange200: orange200,
		orange300: orange300,
		orange400: orange400,
		orange500: orange500,
		orange600: orange600,
		orange700: orange700,
		orange800: orange800,
		orange900: orange900,
		blue100: blue100,
		blue200: blue200,
		blue300: blue300,
		blue400: blue400,
		blue500: blue500,
		blue600: blue600,
		blue700: blue700,
		blue800: blue800,
		blue900: blue900
	};

	var _excluded$q = ["className", "size", "light"];
	var supportedLoaderSizes = ['sm', 'md', 'lg'];

	var Loader = function Loader(_ref) {
	  var _context, _context2;

	  var className = _ref.className,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'lg' : _ref$size,
	      light = _ref.light,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$q);

	  var cssClassBySize = {
	    sm: 'loaderSmall',
	    md: 'loaderMedium',
	    lg: 'loaderLarge'
	  };
	  var loaderSize = cssClassBySize[size];
	  var classNames = classnames(styles$p[loaderSize], className);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "span",
	    className: classNames
	  }, props), map$3(_context = concat$5(_context2 = []).call(_context2, keys$8(new Array(8)))).call(_context, function (key) {
	    return /*#__PURE__*/React__default['default'].createElement("span", {
	      key: key,
	      className: styles$p[loaderSize + "__iconContainer"]
	    }, /*#__PURE__*/React__default['default'].createElement("svg", {
	      width: "24",
	      height: "24",
	      viewBox: "0 0 24 24"
	    }, /*#__PURE__*/React__default['default'].createElement("path", {
	      fill: !!light ? colors$1.white.color : colors$1.purple500.color,
	      d: "M22.9349564,6.18803226 C22.9349564,2.1584087 19.969785,0.763523756 16.6924777,0.763523756 C9.82572717,0.763523756 1.39837693,5.25812218 1.39837693,10.9925743 C1.39837693,15.4871727 7.4848276,23.2364762 12.0105987,23.2364762 C16.3803418,23.2364762 22.9349564,16.1071392 22.9349564,6.18803226 Z"
	    })));
	  }));
	};

	var _excluded$r = ["loading", "children", "iconName", "className", "variant", "size", "onClick", "disabled", "type", "iconOnRight", "expandWhenMobile", "textVariantProps"];
	var iconSizeByButtonSize = {
	  sm: 'xs',
	  md: 'sm',
	  lg: 'sm',
	  xl: 'sm'
	};
	var textButtonSizeByButtonSize = {
	  sm: 'xs',
	  md: 'xs',
	  lg: 'sm',
	  xl: 'md'
	};
	var horizontalPaddingSizeByButtonSize = {
	  sm: 'sm',
	  md: 'md',
	  lg: 'md',
	  xl: 'md'
	};

	var Button = function Button(_ref) {
	  var _getClassNames, _getClassNames2, _getClassNames3;

	  var _ref$loading = _ref.loading,
	      loading = _ref$loading === void 0 ? false : _ref$loading,
	      children = _ref.children,
	      iconName = _ref.iconName,
	      className = _ref.className,
	      _ref$variant = _ref.variant,
	      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      _onClick = _ref.onClick,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
	      type = _ref.type,
	      _ref$iconOnRight = _ref.iconOnRight,
	      iconOnRight = _ref$iconOnRight === void 0 ? false : _ref$iconOnRight,
	      expandWhenMobile = _ref.expandWhenMobile,
	      _ref$textVariantProps = _ref.textVariantProps,
	      textVariantProps = _ref$textVariantProps === void 0 ? {
	    color: 'black',
	    hoverColor: 'purple500'
	  } : _ref$textVariantProps,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$r);

	  var sizeLowerCase = size.toLowerCase();
	  var isText = variant === 'text';

	  var resolveGutter = function resolveGutter() {
	    if (isText && iconName) {
	      return /*#__PURE__*/React__default['default'].createElement(Gutter, {
	        quarter: true
	      });
	    }

	    return size === 'sm' ? /*#__PURE__*/React__default['default'].createElement(Gutter, {
	      half: true
	    }) : /*#__PURE__*/React__default['default'].createElement(Gutter, {
	      size: "sm"
	    });
	  };

	  var elementClassNames = classnames(styles$o.button, styles$o["button__" + variant], (_getClassNames = {}, _getClassNames[styles$o.button__disabled] = disabled, _getClassNames), (_getClassNames2 = {}, _getClassNames2[styles$o.button__expandWhenMobile] = expandWhenMobile, _getClassNames2), (_getClassNames3 = {}, _getClassNames3[styles$o.button__loading] = loading, _getClassNames3), className);

	  var getFlexClassName = function getFlexClassName() {
	    return isText ? 'button__size__md' : styles$o["button__size__" + sizeLowerCase];
	  };

	  var padding = {
	    horizontal: horizontalPaddingSizeByButtonSize[sizeLowerCase]
	  };
	  return /*#__PURE__*/React__default['default'].createElement(Flex, _extends_1({
	    centered: true,
	    alignBaseline: isText,
	    reverseDirection: iconOnRight,
	    padding: isText ? undefined : padding,
	    tagName: "button",
	    className: classnames([elementClassNames, getFlexClassName()]),
	    onClick: function onClick(e) {
	      return !loading && !disabled && _onClick && _onClick(e);
	    },
	    disabled: disabled === true,
	    type: type,
	    color: isText && disabled ? 'gray400' : textVariantProps.color,
	    borderRadius: isText ? undefined : {
	      size: 'rounded'
	    },
	    hoverColor: isText && !disabled ? textVariantProps.hoverColor : undefined,
	    onMouseDown: function onMouseDown(e) {
	      e.preventDefault();
	    }
	  }, props), loading ? /*#__PURE__*/React__default['default'].createElement(Loader, {
	    className: styles$o.button__loader,
	    light: loaderColor[variant],
	    size: "sm",
	    "aria-label": "Loading",
	    "aria-busy": "true"
	  }) : iconName && /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: iconName,
	    size: isText ? 'xs' : iconSizeByButtonSize[sizeLowerCase],
	    className: styles$o.button__icon,
	    "aria-hidden": "true"
	  }), // Adjust the gutter while loading or if the button has an icon
	  (loading || iconName) && resolveGutter(), isText ?
	  /*#__PURE__*/
	  // use BodyText with text variant
	  React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: textButtonSizeByButtonSize[sizeLowerCase],
	    singleLine: true,
	    fontWeight: textVariantProps.fontWeight
	  }, children) : /*#__PURE__*/React__default['default'].createElement(ButtonText, {
	    size: sizeLowerCase === 'xl' ? 'md' : 'sm'
	  }, children));
	};

	var loaderColor = {
	  primary: true,
	  purchase: true,
	  purchaseSecondary: false,
	  secondary: false,
	  primaryWhite: false,
	  secondaryWhite: true,
	  destructive: true,
	  secondaryDestructive: false,
	  text: false
	};
	var supportedButtonSizes = ['sm', 'md', 'lg', 'xl'];
	var supportedButtonVariants = ['primary', 'purchase', 'secondary', 'primaryWhite', 'purchaseSecondary', 'secondaryWhite', 'destructive', 'secondaryDestructive', 'text'];

	var _excluded$s = ["children", "padding"];

	var CollapsibleBlockContent = function CollapsibleBlockContent(_ref) {
	  var children = _ref.children,
	      _ref$padding = _ref.padding,
	      padding = _ref$padding === void 0 ? {
	    horizontal: 'sm',
	    vertical: 'sm'
	  } : _ref$padding,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$s);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    padding: padding
	  }, props), children);
	};

	var style$1 = {"collapsibleBlock":"telia-react-collapsibleBlock","collapsibleBlock__purpleBackground":"telia-react-collapsibleBlock__purpleBackground","collapsibleBlock_header":"telia-react-collapsibleBlock_header","collapsibleBlock_label":"telia-react-collapsibleBlock_label","collapsibleBlock_icon":"telia-react-collapsibleBlock_icon","collapsibleBlock_numberOfItems":"telia-react-collapsibleBlock_numberOfItems","collapsibleBlockList":"telia-react-collapsibleBlockList"};

	var CollapsibleBlock = function CollapsibleBlock(_ref) {
	  var _ref2;

	  var blockTitle = _ref.blockTitle,
	      children = _ref.children,
	      className = _ref.className,
	      _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
	      initiallyExpanded = _ref.expanded,
	      numberOfItems = _ref.numberOfItems;

	  var _useState = React.useState(initiallyExpanded != null ? initiallyExpanded : false),
	      expanded = _useState[0],
	      setExpanded = _useState[1];

	  var toggleExpanded = function toggleExpanded() {
	    setExpanded(!expanded);
	  };

	  var blur = function blur(event) {
	    event.preventDefault();
	  };

	  var collapsibleBlockClasses = [className, style$1.collapsibleBlock, 'collapsibleBlock-test', (_ref2 = {}, _ref2[style$1.collapsibleBlock__purpleBackground] = backgroundColor === 'purple500', _ref2)];
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    backgroundColor: backgroundColor,
	    className: collapsibleBlockClasses
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: [style$1.collapsibleBlock_header],
	    "data-testid": "collapsibleBlock-header",
	    onMouseDown: blur,
	    onClick: toggleExpanded,
	    tabIndex: 0,
	    onKeyPress: function onKeyPress(e) {
	      e.key === 'Enter' && toggleExpanded();
	    },
	    clickableAppearance: true,
	    spaceBetween: true,
	    centeredVertically: true,
	    padding: {
	      horizontal: 'sm',
	      vertical: 'xs'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    className: style$1.collapsibleBlock_label,
	    fontWeight: "medium",
	    size: "md"
	  }, blockTitle), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "sm"
	  }), numberOfItems && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: style$1.collapsibleBlock_numberOfItems,
	    backgroundColor: "purple300",
	    fontWeight: "medium",
	    "data-testid": "numberOfItems"
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centered: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    size: "sm"
	  }, numberOfItems))))), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    className: style$1.collapsibleBlock_icon,
	    name: expanded ? 'chevron-up' : 'chevron-down',
	    size: "md",
	    color: "black"
	  })), expanded && children);
	};

	CollapsibleBlock.Content = CollapsibleBlockContent;
	var backgroundColors = ['white', 'gray200', 'purple500'];

	var _excluded$t = ["className", "children"];

	var CollapsibleBlockList = function CollapsibleBlockList(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$t);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: [className, style$1.collapsibleBlockList]
	  }, props), children);
	};

	var styles$q = {"dot":"telia-react-dot","dot_with_border":"telia-react-dot_with_border"};

	var ColorDot = function ColorDot(_ref) {
	  var color = _ref.color,
	      withBorder = _ref.withBorder;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    style: {
	      backgroundColor: color
	    },
	    borderRadius: {
	      size: 'rounded'
	    },
	    className: withBorder ? [styles$q.dot, styles$q.dot_with_border] : styles$q.dot,
	    children: null
	  });
	};

	var moment = createCommonjsModule(function (module, exports) {

	(function (global, factory) {
	   module.exports = factory() ;
	})(commonjsGlobal, function () {

	  var hookCallback;

	  function hooks() {
	    return hookCallback.apply(null, arguments);
	  } // This is done to register the method called with moment()
	  // without creating circular dependencies.


	  function setHookCallback(callback) {
	    hookCallback = callback;
	  }

	  function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	  }

	  function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	  }

	  function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	  }

	  function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	      return Object.getOwnPropertyNames(obj).length === 0;
	    } else {
	      var k;

	      for (k in obj) {
	        if (hasOwnProp(obj, k)) {
	          return false;
	        }
	      }

	      return true;
	    }
	  }

	  function isUndefined(input) {
	    return input === void 0;
	  }

	  function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	  }

	  function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	  }

	  function map(arr, fn) {
	    var res = [],
	        i;

	    for (i = 0; i < arr.length; ++i) {
	      res.push(fn(arr[i], i));
	    }

	    return res;
	  }

	  function extend(a, b) {
	    for (var i in b) {
	      if (hasOwnProp(b, i)) {
	        a[i] = b[i];
	      }
	    }

	    if (hasOwnProp(b, 'toString')) {
	      a.toString = b.toString;
	    }

	    if (hasOwnProp(b, 'valueOf')) {
	      a.valueOf = b.valueOf;
	    }

	    return a;
	  }

	  function createUTC(input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	  }

	  function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	      empty: false,
	      unusedTokens: [],
	      unusedInput: [],
	      overflow: -2,
	      charsLeftOver: 0,
	      nullInput: false,
	      invalidEra: null,
	      invalidMonth: null,
	      invalidFormat: false,
	      userInvalidated: false,
	      iso: false,
	      parsedDateParts: [],
	      era: null,
	      meridiem: null,
	      rfc2822: false,
	      weekdayMismatch: false
	    };
	  }

	  function getParsingFlags(m) {
	    if (m._pf == null) {
	      m._pf = defaultParsingFlags();
	    }

	    return m._pf;
	  }

	  var some;

	  if (Array.prototype.some) {
	    some = Array.prototype.some;
	  } else {
	    some = function (fun) {
	      var t = Object(this),
	          len = t.length >>> 0,
	          i;

	      for (i = 0; i < len; i++) {
	        if (i in t && fun.call(this, t[i], i, t)) {
	          return true;
	        }
	      }

	      return false;
	    };
	  }

	  function isValid(m) {
	    if (m._isValid == null) {
	      var flags = getParsingFlags(m),
	          parsedParts = some.call(flags.parsedDateParts, function (i) {
	        return i != null;
	      }),
	          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

	      if (m._strict) {
	        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
	      }

	      if (Object.isFrozen == null || !Object.isFrozen(m)) {
	        m._isValid = isNowValid;
	      } else {
	        return isNowValid;
	      }
	    }

	    return m._isValid;
	  }

	  function createInvalid(flags) {
	    var m = createUTC(NaN);

	    if (flags != null) {
	      extend(getParsingFlags(m), flags);
	    } else {
	      getParsingFlags(m).userInvalidated = true;
	    }

	    return m;
	  } // Plugins that add properties should also add the key here (null value),
	  // so we can properly clone ourselves.


	  var momentProperties = hooks.momentProperties = [],
	      updateInProgress = false;

	  function copyConfig(to, from) {
	    var i, prop, val;

	    if (!isUndefined(from._isAMomentObject)) {
	      to._isAMomentObject = from._isAMomentObject;
	    }

	    if (!isUndefined(from._i)) {
	      to._i = from._i;
	    }

	    if (!isUndefined(from._f)) {
	      to._f = from._f;
	    }

	    if (!isUndefined(from._l)) {
	      to._l = from._l;
	    }

	    if (!isUndefined(from._strict)) {
	      to._strict = from._strict;
	    }

	    if (!isUndefined(from._tzm)) {
	      to._tzm = from._tzm;
	    }

	    if (!isUndefined(from._isUTC)) {
	      to._isUTC = from._isUTC;
	    }

	    if (!isUndefined(from._offset)) {
	      to._offset = from._offset;
	    }

	    if (!isUndefined(from._pf)) {
	      to._pf = getParsingFlags(from);
	    }

	    if (!isUndefined(from._locale)) {
	      to._locale = from._locale;
	    }

	    if (momentProperties.length > 0) {
	      for (i = 0; i < momentProperties.length; i++) {
	        prop = momentProperties[i];
	        val = from[prop];

	        if (!isUndefined(val)) {
	          to[prop] = val;
	        }
	      }
	    }

	    return to;
	  } // Moment prototype object


	  function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);

	    if (!this.isValid()) {
	      this._d = new Date(NaN);
	    } // Prevent infinite loop in case updateOffset creates new moment
	    // objects.


	    if (updateInProgress === false) {
	      updateInProgress = true;
	      hooks.updateOffset(this);
	      updateInProgress = false;
	    }
	  }

	  function isMoment(obj) {
	    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
	  }

	  function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	      console.warn('Deprecation warning: ' + msg);
	    }
	  }

	  function deprecate(msg, fn) {
	    var firstTime = true;
	    return extend(function () {
	      if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(null, msg);
	      }

	      if (firstTime) {
	        var args = [],
	            arg,
	            i,
	            key;

	        for (i = 0; i < arguments.length; i++) {
	          arg = '';

	          if (typeof arguments[i] === 'object') {
	            arg += '\n[' + i + '] ';

	            for (key in arguments[0]) {
	              if (hasOwnProp(arguments[0], key)) {
	                arg += key + ': ' + arguments[0][key] + ', ';
	              }
	            }

	            arg = arg.slice(0, -2); // Remove trailing comma and space
	          } else {
	            arg = arguments[i];
	          }

	          args.push(arg);
	        }

	        warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
	        firstTime = false;
	      }

	      return fn.apply(this, arguments);
	    }, fn);
	  }

	  var deprecations = {};

	  function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	      hooks.deprecationHandler(name, msg);
	    }

	    if (!deprecations[name]) {
	      warn(msg);
	      deprecations[name] = true;
	    }
	  }

	  hooks.suppressDeprecationWarnings = false;
	  hooks.deprecationHandler = null;

	  function isFunction(input) {
	    return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	  }

	  function set(config) {
	    var prop, i;

	    for (i in config) {
	      if (hasOwnProp(config, i)) {
	        prop = config[i];

	        if (isFunction(prop)) {
	          this[i] = prop;
	        } else {
	          this['_' + i] = prop;
	        }
	      }
	    }

	    this._config = config; // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.

	    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
	  }

	  function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig),
	        prop;

	    for (prop in childConfig) {
	      if (hasOwnProp(childConfig, prop)) {
	        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	          res[prop] = {};
	          extend(res[prop], parentConfig[prop]);
	          extend(res[prop], childConfig[prop]);
	        } else if (childConfig[prop] != null) {
	          res[prop] = childConfig[prop];
	        } else {
	          delete res[prop];
	        }
	      }
	    }

	    for (prop in parentConfig) {
	      if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
	        // make sure changes to properties don't modify parent config
	        res[prop] = extend({}, res[prop]);
	      }
	    }

	    return res;
	  }

	  function Locale(config) {
	    if (config != null) {
	      this.set(config);
	    }
	  }

	  var keys;

	  if (Object.keys) {
	    keys = Object.keys;
	  } else {
	    keys = function (obj) {
	      var i,
	          res = [];

	      for (i in obj) {
	        if (hasOwnProp(obj, i)) {
	          res.push(i);
	        }
	      }

	      return res;
	    };
	  }

	  var defaultCalendar = {
	    sameDay: '[Today at] LT',
	    nextDay: '[Tomorrow at] LT',
	    nextWeek: 'dddd [at] LT',
	    lastDay: '[Yesterday at] LT',
	    lastWeek: '[Last] dddd [at] LT',
	    sameElse: 'L'
	  };

	  function calendar(key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	  }

	  function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	  }

	  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	      formatFunctions = {},
	      formatTokenFunctions = {}; // token:    'M'
	  // padded:   ['MM', 2]
	  // ordinal:  'Mo'
	  // callback: function () { this.month() + 1 }

	  function addFormatToken(token, padded, ordinal, callback) {
	    var func = callback;

	    if (typeof callback === 'string') {
	      func = function () {
	        return this[callback]();
	      };
	    }

	    if (token) {
	      formatTokenFunctions[token] = func;
	    }

	    if (padded) {
	      formatTokenFunctions[padded[0]] = function () {
	        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	      };
	    }

	    if (ordinal) {
	      formatTokenFunctions[ordinal] = function () {
	        return this.localeData().ordinal(func.apply(this, arguments), token);
	      };
	    }
	  }

	  function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	      return input.replace(/^\[|\]$/g, '');
	    }

	    return input.replace(/\\/g, '');
	  }

	  function makeFormatFunction(format) {
	    var array = format.match(formattingTokens),
	        i,
	        length;

	    for (i = 0, length = array.length; i < length; i++) {
	      if (formatTokenFunctions[array[i]]) {
	        array[i] = formatTokenFunctions[array[i]];
	      } else {
	        array[i] = removeFormattingTokens(array[i]);
	      }
	    }

	    return function (mom) {
	      var output = '',
	          i;

	      for (i = 0; i < length; i++) {
	        output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	      }

	      return output;
	    };
	  } // format date using native date object


	  function formatMoment(m, format) {
	    if (!m.isValid()) {
	      return m.localeData().invalidDate();
	    }

	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	    return formatFunctions[format](m);
	  }

	  function expandFormat(format, locale) {
	    var i = 5;

	    function replaceLongDateFormatTokens(input) {
	      return locale.longDateFormat(input) || input;
	    }

	    localFormattingTokens.lastIndex = 0;

	    while (i >= 0 && localFormattingTokens.test(format)) {
	      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	      localFormattingTokens.lastIndex = 0;
	      i -= 1;
	    }

	    return format;
	  }

	  var defaultLongDateFormat = {
	    LTS: 'h:mm:ss A',
	    LT: 'h:mm A',
	    L: 'MM/DD/YYYY',
	    LL: 'MMMM D, YYYY',
	    LLL: 'MMMM D, YYYY h:mm A',
	    LLLL: 'dddd, MMMM D, YYYY h:mm A'
	  };

	  function longDateFormat(key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];

	    if (format || !formatUpper) {
	      return format;
	    }

	    this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
	      if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
	        return tok.slice(1);
	      }

	      return tok;
	    }).join('');
	    return this._longDateFormat[key];
	  }

	  var defaultInvalidDate = 'Invalid date';

	  function invalidDate() {
	    return this._invalidDate;
	  }

	  var defaultOrdinal = '%d',
	      defaultDayOfMonthOrdinalParse = /\d{1,2}/;

	  function ordinal(number) {
	    return this._ordinal.replace('%d', number);
	  }

	  var defaultRelativeTime = {
	    future: 'in %s',
	    past: '%s ago',
	    s: 'a few seconds',
	    ss: '%d seconds',
	    m: 'a minute',
	    mm: '%d minutes',
	    h: 'an hour',
	    hh: '%d hours',
	    d: 'a day',
	    dd: '%d days',
	    w: 'a week',
	    ww: '%d weeks',
	    M: 'a month',
	    MM: '%d months',
	    y: 'a year',
	    yy: '%d years'
	  };

	  function relativeTime(number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
	  }

	  function pastFuture(diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	  }

	  var aliases = {};

	  function addUnitAlias(unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	  }

	  function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	  }

	  function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;

	    for (prop in inputObject) {
	      if (hasOwnProp(inputObject, prop)) {
	        normalizedProp = normalizeUnits(prop);

	        if (normalizedProp) {
	          normalizedInput[normalizedProp] = inputObject[prop];
	        }
	      }
	    }

	    return normalizedInput;
	  }

	  var priorities = {};

	  function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	  }

	  function getPrioritizedUnits(unitsObj) {
	    var units = [],
	        u;

	    for (u in unitsObj) {
	      if (hasOwnProp(unitsObj, u)) {
	        units.push({
	          unit: u,
	          priority: priorities[u]
	        });
	      }
	    }

	    units.sort(function (a, b) {
	      return a.priority - b.priority;
	    });
	    return units;
	  }

	  function isLeapYear(year) {
	    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	  }

	  function absFloor(number) {
	    if (number < 0) {
	      // -0 -> 0
	      return Math.ceil(number) || 0;
	    } else {
	      return Math.floor(number);
	    }
	  }

	  function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;

	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	      value = absFloor(coercedNumber);
	    }

	    return value;
	  }

	  function makeGetSet(unit, keepTime) {
	    return function (value) {
	      if (value != null) {
	        set$1(this, unit, value);
	        hooks.updateOffset(this, keepTime);
	        return this;
	      } else {
	        return get(this, unit);
	      }
	    };
	  }

	  function get(mom, unit) {
	    return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	  }

	  function set$1(mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	      if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	        value = toInt(value);

	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	      } else {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	      }
	    }
	  } // MOMENTS


	  function stringGet(units) {
	    units = normalizeUnits(units);

	    if (isFunction(this[units])) {
	      return this[units]();
	    }

	    return this;
	  }

	  function stringSet(units, value) {
	    if (typeof units === 'object') {
	      units = normalizeObjectUnits(units);
	      var prioritized = getPrioritizedUnits(units),
	          i;

	      for (i = 0; i < prioritized.length; i++) {
	        this[prioritized[i].unit](units[prioritized[i].unit]);
	      }
	    } else {
	      units = normalizeUnits(units);

	      if (isFunction(this[units])) {
	        return this[units](value);
	      }
	    }

	    return this;
	  }

	  var match1 = /\d/,
	      //       0 - 9
	  match2 = /\d\d/,
	      //      00 - 99
	  match3 = /\d{3}/,
	      //     000 - 999
	  match4 = /\d{4}/,
	      //    0000 - 9999
	  match6 = /[+-]?\d{6}/,
	      // -999999 - 999999
	  match1to2 = /\d\d?/,
	      //       0 - 99
	  match3to4 = /\d\d\d\d?/,
	      //     999 - 9999
	  match5to6 = /\d\d\d\d\d\d?/,
	      //   99999 - 999999
	  match1to3 = /\d{1,3}/,
	      //       0 - 999
	  match1to4 = /\d{1,4}/,
	      //       0 - 9999
	  match1to6 = /[+-]?\d{1,6}/,
	      // -999999 - 999999
	  matchUnsigned = /\d+/,
	      //       0 - inf
	  matchSigned = /[+-]?\d+/,
	      //    -inf - inf
	  matchOffset = /Z|[+-]\d\d:?\d\d/gi,
	      // +00:00 -00:00 +0000 -0000 or Z
	  matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
	      // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	  matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
	      // 123456789 123456789.123
	  // any word (or two) characters or numbers including two/three word month in arabic.
	  // includes scottish gaelic two word and hyphenated months
	  matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	      regexes;
	  regexes = {};

	  function addRegexToken(token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	      return isStrict && strictRegex ? strictRegex : regex;
	    };
	  }

	  function getParseRegexForToken(token, config) {
	    if (!hasOwnProp(regexes, token)) {
	      return new RegExp(unescapeFormat(token));
	    }

	    return regexes[token](config._strict, config._locale);
	  } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


	  function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	      return p1 || p2 || p3 || p4;
	    }));
	  }

	  function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	  }

	  var tokens = {};

	  function addParseToken(token, callback) {
	    var i,
	        func = callback;

	    if (typeof token === 'string') {
	      token = [token];
	    }

	    if (isNumber(callback)) {
	      func = function (input, array) {
	        array[callback] = toInt(input);
	      };
	    }

	    for (i = 0; i < token.length; i++) {
	      tokens[token[i]] = func;
	    }
	  }

	  function addWeekParseToken(token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	      config._w = config._w || {};
	      callback(input, config._w, config, token);
	    });
	  }

	  function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	      tokens[token](input, config._a, config, token);
	    }
	  }

	  var YEAR = 0,
	      MONTH = 1,
	      DATE = 2,
	      HOUR = 3,
	      MINUTE = 4,
	      SECOND = 5,
	      MILLISECOND = 6,
	      WEEK = 7,
	      WEEKDAY = 8;

	  function mod(n, x) {
	    return (n % x + x) % x;
	  }

	  var indexOf;

	  if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	  } else {
	    indexOf = function (o) {
	      // I know
	      var i;

	      for (i = 0; i < this.length; ++i) {
	        if (this[i] === o) {
	          return i;
	        }
	      }

	      return -1;
	    };
	  }

	  function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	      return NaN;
	    }

	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
	  } // FORMATTING


	  addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	  });
	  addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	  });
	  addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	  }); // ALIASES

	  addUnitAlias('month', 'M'); // PRIORITY

	  addUnitPriority('month', 8); // PARSING

	  addRegexToken('M', match1to2);
	  addRegexToken('MM', match1to2, match2);
	  addRegexToken('MMM', function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	  });
	  addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	  });
	  addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	  });
	  addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


	    if (month != null) {
	      array[MONTH] = month;
	    } else {
	      getParsingFlags(config).invalidMonth = input;
	    }
	  }); // LOCALES

	  var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	      defaultMonthsShortRegex = matchWord,
	      defaultMonthsRegex = matchWord;

	  function localeMonths(m, format) {
	    if (!m) {
	      return isArray(this._months) ? this._months : this._months['standalone'];
	    }

	    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	  }

	  function localeMonthsShort(m, format) {
	    if (!m) {
	      return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
	    }

	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	  }

	  function handleStrictParse(monthName, format, strict) {
	    var i,
	        ii,
	        mom,
	        llc = monthName.toLocaleLowerCase();

	    if (!this._monthsParse) {
	      // this is not used
	      this._monthsParse = [];
	      this._longMonthsParse = [];
	      this._shortMonthsParse = [];

	      for (i = 0; i < 12; ++i) {
	        mom = createUTC([2000, i]);
	        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	      }
	    }

	    if (strict) {
	      if (format === 'MMM') {
	        ii = indexOf.call(this._shortMonthsParse, llc);
	        return ii !== -1 ? ii : null;
	      } else {
	        ii = indexOf.call(this._longMonthsParse, llc);
	        return ii !== -1 ? ii : null;
	      }
	    } else {
	      if (format === 'MMM') {
	        ii = indexOf.call(this._shortMonthsParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._longMonthsParse, llc);
	        return ii !== -1 ? ii : null;
	      } else {
	        ii = indexOf.call(this._longMonthsParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._shortMonthsParse, llc);
	        return ii !== -1 ? ii : null;
	      }
	    }
	  }

	  function localeMonthsParse(monthName, format, strict) {
	    var i, mom, regex;

	    if (this._monthsParseExact) {
	      return handleStrictParse.call(this, monthName, format, strict);
	    }

	    if (!this._monthsParse) {
	      this._monthsParse = [];
	      this._longMonthsParse = [];
	      this._shortMonthsParse = [];
	    } // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse


	    for (i = 0; i < 12; i++) {
	      // make the regex if we don't have it already
	      mom = createUTC([2000, i]);

	      if (strict && !this._longMonthsParse[i]) {
	        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	      }

	      if (!strict && !this._monthsParse[i]) {
	        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	      } // test the regex


	      if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	        return i;
	      } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	        return i;
	      } else if (!strict && this._monthsParse[i].test(monthName)) {
	        return i;
	      }
	    }
	  } // MOMENTS


	  function setMonth(mom, value) {
	    var dayOfMonth;

	    if (!mom.isValid()) {
	      // No op
	      return mom;
	    }

	    if (typeof value === 'string') {
	      if (/^\d+$/.test(value)) {
	        value = toInt(value);
	      } else {
	        value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

	        if (!isNumber(value)) {
	          return mom;
	        }
	      }
	    }

	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

	    return mom;
	  }

	  function getSetMonth(value) {
	    if (value != null) {
	      setMonth(this, value);
	      hooks.updateOffset(this, true);
	      return this;
	    } else {
	      return get(this, 'Month');
	    }
	  }

	  function getDaysInMonth() {
	    return daysInMonth(this.year(), this.month());
	  }

	  function monthsShortRegex(isStrict) {
	    if (this._monthsParseExact) {
	      if (!hasOwnProp(this, '_monthsRegex')) {
	        computeMonthsParse.call(this);
	      }

	      if (isStrict) {
	        return this._monthsShortStrictRegex;
	      } else {
	        return this._monthsShortRegex;
	      }
	    } else {
	      if (!hasOwnProp(this, '_monthsShortRegex')) {
	        this._monthsShortRegex = defaultMonthsShortRegex;
	      }

	      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	  }

	  function monthsRegex(isStrict) {
	    if (this._monthsParseExact) {
	      if (!hasOwnProp(this, '_monthsRegex')) {
	        computeMonthsParse.call(this);
	      }

	      if (isStrict) {
	        return this._monthsStrictRegex;
	      } else {
	        return this._monthsRegex;
	      }
	    } else {
	      if (!hasOwnProp(this, '_monthsRegex')) {
	        this._monthsRegex = defaultMonthsRegex;
	      }

	      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
	    }
	  }

	  function computeMonthsParse() {
	    function cmpLenRev(a, b) {
	      return b.length - a.length;
	    }

	    var shortPieces = [],
	        longPieces = [],
	        mixedPieces = [],
	        i,
	        mom;

	    for (i = 0; i < 12; i++) {
	      // make the regex if we don't have it already
	      mom = createUTC([2000, i]);
	      shortPieces.push(this.monthsShort(mom, ''));
	      longPieces.push(this.months(mom, ''));
	      mixedPieces.push(this.months(mom, ''));
	      mixedPieces.push(this.monthsShort(mom, ''));
	    } // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.


	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);

	    for (i = 0; i < 12; i++) {
	      shortPieces[i] = regexEscape(shortPieces[i]);
	      longPieces[i] = regexEscape(longPieces[i]);
	    }

	    for (i = 0; i < 24; i++) {
	      mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }

	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	  } // FORMATTING


	  addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	  });
	  addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	  });
	  addFormatToken(0, ['YYYY', 4], 0, 'year');
	  addFormatToken(0, ['YYYYY', 5], 0, 'year');
	  addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

	  addUnitAlias('year', 'y'); // PRIORITIES

	  addUnitPriority('year', 1); // PARSING

	  addRegexToken('Y', matchSigned);
	  addRegexToken('YY', match1to2, match2);
	  addRegexToken('YYYY', match1to4, match4);
	  addRegexToken('YYYYY', match1to6, match6);
	  addRegexToken('YYYYYY', match1to6, match6);
	  addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	  addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	  });
	  addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	  });
	  addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	  }); // HELPERS

	  function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	  } // HOOKS


	  hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	  }; // MOMENTS


	  var getSetYear = makeGetSet('FullYear', true);

	  function getIsLeapYear() {
	    return isLeapYear(this.year());
	  }

	  function createDate(y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date; // the date constructor remaps years 0-99 to 1900-1999

	    if (y < 100 && y >= 0) {
	      // preserve leap years using a full 400 year cycle, then reset
	      date = new Date(y + 400, m, d, h, M, s, ms);

	      if (isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	      }
	    } else {
	      date = new Date(y, m, d, h, M, s, ms);
	    }

	    return date;
	  }

	  function createUTCDate(y) {
	    var date, args; // the Date.UTC function remaps years 0-99 to 1900-1999

	    if (y < 100 && y >= 0) {
	      args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

	      args[0] = y + 400;
	      date = new Date(Date.UTC.apply(null, args));

	      if (isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	      }
	    } else {
	      date = new Date(Date.UTC.apply(null, arguments));
	    }

	    return date;
	  } // start-of-first-week - start-of-year


	  function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	    fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	    fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	    return -fwdlw + fwd - 1;
	  } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


	  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear,
	        resDayOfYear;

	    if (dayOfYear <= 0) {
	      resYear = year - 1;
	      resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	      resYear = year + 1;
	      resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	      resYear = year;
	      resDayOfYear = dayOfYear;
	    }

	    return {
	      year: resYear,
	      dayOfYear: resDayOfYear
	    };
	  }

	  function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek,
	        resYear;

	    if (week < 1) {
	      resYear = mom.year() - 1;
	      resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	      resWeek = week - weeksInYear(mom.year(), dow, doy);
	      resYear = mom.year() + 1;
	    } else {
	      resYear = mom.year();
	      resWeek = week;
	    }

	    return {
	      week: resWeek,
	      year: resYear
	    };
	  }

	  function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	  } // FORMATTING


	  addFormatToken('w', ['ww', 2], 'wo', 'week');
	  addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

	  addUnitAlias('week', 'w');
	  addUnitAlias('isoWeek', 'W'); // PRIORITIES

	  addUnitPriority('week', 5);
	  addUnitPriority('isoWeek', 5); // PARSING

	  addRegexToken('w', match1to2);
	  addRegexToken('ww', match1to2, match2);
	  addRegexToken('W', match1to2);
	  addRegexToken('WW', match1to2, match2);
	  addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	  }); // HELPERS
	  // LOCALES

	  function localeWeek(mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	  }

	  var defaultLocaleWeek = {
	    dow: 0,
	    // Sunday is the first day of the week.
	    doy: 6 // The week that contains Jan 6th is the first week of the year.

	  };

	  function localeFirstDayOfWeek() {
	    return this._week.dow;
	  }

	  function localeFirstDayOfYear() {
	    return this._week.doy;
	  } // MOMENTS


	  function getSetWeek(input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	  }

	  function getSetISOWeek(input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	  } // FORMATTING


	  addFormatToken('d', 0, 'do', 'day');
	  addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	  });
	  addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	  });
	  addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	  });
	  addFormatToken('e', 0, 0, 'weekday');
	  addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

	  addUnitAlias('day', 'd');
	  addUnitAlias('weekday', 'e');
	  addUnitAlias('isoWeekday', 'E'); // PRIORITY

	  addUnitPriority('day', 11);
	  addUnitPriority('weekday', 11);
	  addUnitPriority('isoWeekday', 11); // PARSING

	  addRegexToken('d', match1to2);
	  addRegexToken('e', match1to2);
	  addRegexToken('E', match1to2);
	  addRegexToken('dd', function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	  });
	  addRegexToken('ddd', function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	  });
	  addRegexToken('dddd', function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	  });
	  addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


	    if (weekday != null) {
	      week.d = weekday;
	    } else {
	      getParsingFlags(config).invalidWeekday = input;
	    }
	  });
	  addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	  }); // HELPERS

	  function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	      return input;
	    }

	    if (!isNaN(input)) {
	      return parseInt(input, 10);
	    }

	    input = locale.weekdaysParse(input);

	    if (typeof input === 'number') {
	      return input;
	    }

	    return null;
	  }

	  function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	      return locale.weekdaysParse(input) % 7 || 7;
	    }

	    return isNaN(input) ? null : input;
	  } // LOCALES


	  function shiftWeekdays(ws, n) {
	    return ws.slice(n, 7).concat(ws.slice(0, n));
	  }

	  var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	      defaultWeekdaysRegex = matchWord,
	      defaultWeekdaysShortRegex = matchWord,
	      defaultWeekdaysMinRegex = matchWord;

	  function localeWeekdays(m, format) {
	    var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
	    return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
	  }

	  function localeWeekdaysShort(m) {
	    return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	  }

	  function localeWeekdaysMin(m) {
	    return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	  }

	  function handleStrictParse$1(weekdayName, format, strict) {
	    var i,
	        ii,
	        mom,
	        llc = weekdayName.toLocaleLowerCase();

	    if (!this._weekdaysParse) {
	      this._weekdaysParse = [];
	      this._shortWeekdaysParse = [];
	      this._minWeekdaysParse = [];

	      for (i = 0; i < 7; ++i) {
	        mom = createUTC([2000, 1]).day(i);
	        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	      }
	    }

	    if (strict) {
	      if (format === 'dddd') {
	        ii = indexOf.call(this._weekdaysParse, llc);
	        return ii !== -1 ? ii : null;
	      } else if (format === 'ddd') {
	        ii = indexOf.call(this._shortWeekdaysParse, llc);
	        return ii !== -1 ? ii : null;
	      } else {
	        ii = indexOf.call(this._minWeekdaysParse, llc);
	        return ii !== -1 ? ii : null;
	      }
	    } else {
	      if (format === 'dddd') {
	        ii = indexOf.call(this._weekdaysParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._shortWeekdaysParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._minWeekdaysParse, llc);
	        return ii !== -1 ? ii : null;
	      } else if (format === 'ddd') {
	        ii = indexOf.call(this._shortWeekdaysParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._weekdaysParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._minWeekdaysParse, llc);
	        return ii !== -1 ? ii : null;
	      } else {
	        ii = indexOf.call(this._minWeekdaysParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._weekdaysParse, llc);

	        if (ii !== -1) {
	          return ii;
	        }

	        ii = indexOf.call(this._shortWeekdaysParse, llc);
	        return ii !== -1 ? ii : null;
	      }
	    }
	  }

	  function localeWeekdaysParse(weekdayName, format, strict) {
	    var i, mom, regex;

	    if (this._weekdaysParseExact) {
	      return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }

	    if (!this._weekdaysParse) {
	      this._weekdaysParse = [];
	      this._minWeekdaysParse = [];
	      this._shortWeekdaysParse = [];
	      this._fullWeekdaysParse = [];
	    }

	    for (i = 0; i < 7; i++) {
	      // make the regex if we don't have it already
	      mom = createUTC([2000, 1]).day(i);

	      if (strict && !this._fullWeekdaysParse[i]) {
	        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	      }

	      if (!this._weekdaysParse[i]) {
	        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	      } // test the regex


	      if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	        return i;
	      } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	        return i;
	      } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	        return i;
	      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	        return i;
	      }
	    }
	  } // MOMENTS


	  function getSetDayOfWeek(input) {
	    if (!this.isValid()) {
	      return input != null ? this : NaN;
	    }

	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

	    if (input != null) {
	      input = parseWeekday(input, this.localeData());
	      return this.add(input - day, 'd');
	    } else {
	      return day;
	    }
	  }

	  function getSetLocaleDayOfWeek(input) {
	    if (!this.isValid()) {
	      return input != null ? this : NaN;
	    }

	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	  }

	  function getSetISODayOfWeek(input) {
	    if (!this.isValid()) {
	      return input != null ? this : NaN;
	    } // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.


	    if (input != null) {
	      var weekday = parseIsoWeekday(input, this.localeData());
	      return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	      return this.day() || 7;
	    }
	  }

	  function weekdaysRegex(isStrict) {
	    if (this._weekdaysParseExact) {
	      if (!hasOwnProp(this, '_weekdaysRegex')) {
	        computeWeekdaysParse.call(this);
	      }

	      if (isStrict) {
	        return this._weekdaysStrictRegex;
	      } else {
	        return this._weekdaysRegex;
	      }
	    } else {
	      if (!hasOwnProp(this, '_weekdaysRegex')) {
	        this._weekdaysRegex = defaultWeekdaysRegex;
	      }

	      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	  }

	  function weekdaysShortRegex(isStrict) {
	    if (this._weekdaysParseExact) {
	      if (!hasOwnProp(this, '_weekdaysRegex')) {
	        computeWeekdaysParse.call(this);
	      }

	      if (isStrict) {
	        return this._weekdaysShortStrictRegex;
	      } else {
	        return this._weekdaysShortRegex;
	      }
	    } else {
	      if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	      }

	      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	  }

	  function weekdaysMinRegex(isStrict) {
	    if (this._weekdaysParseExact) {
	      if (!hasOwnProp(this, '_weekdaysRegex')) {
	        computeWeekdaysParse.call(this);
	      }

	      if (isStrict) {
	        return this._weekdaysMinStrictRegex;
	      } else {
	        return this._weekdaysMinRegex;
	      }
	    } else {
	      if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	      }

	      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	  }

	  function computeWeekdaysParse() {
	    function cmpLenRev(a, b) {
	      return b.length - a.length;
	    }

	    var minPieces = [],
	        shortPieces = [],
	        longPieces = [],
	        mixedPieces = [],
	        i,
	        mom,
	        minp,
	        shortp,
	        longp;

	    for (i = 0; i < 7; i++) {
	      // make the regex if we don't have it already
	      mom = createUTC([2000, 1]).day(i);
	      minp = regexEscape(this.weekdaysMin(mom, ''));
	      shortp = regexEscape(this.weekdaysShort(mom, ''));
	      longp = regexEscape(this.weekdays(mom, ''));
	      minPieces.push(minp);
	      shortPieces.push(shortp);
	      longPieces.push(longp);
	      mixedPieces.push(minp);
	      mixedPieces.push(shortp);
	      mixedPieces.push(longp);
	    } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.


	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	  } // FORMATTING


	  function hFormat() {
	    return this.hours() % 12 || 12;
	  }

	  function kFormat() {
	    return this.hours() || 24;
	  }

	  addFormatToken('H', ['HH', 2], 0, 'hour');
	  addFormatToken('h', ['hh', 2], 0, hFormat);
	  addFormatToken('k', ['kk', 2], 0, kFormat);
	  addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	  });
	  addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
	  });
	  addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	  });
	  addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
	  });

	  function meridiem(token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	  }

	  meridiem('a', true);
	  meridiem('A', false); // ALIASES

	  addUnitAlias('hour', 'h'); // PRIORITY

	  addUnitPriority('hour', 13); // PARSING

	  function matchMeridiem(isStrict, locale) {
	    return locale._meridiemParse;
	  }

	  addRegexToken('a', matchMeridiem);
	  addRegexToken('A', matchMeridiem);
	  addRegexToken('H', match1to2);
	  addRegexToken('h', match1to2);
	  addRegexToken('k', match1to2);
	  addRegexToken('HH', match1to2, match2);
	  addRegexToken('hh', match1to2, match2);
	  addRegexToken('kk', match1to2, match2);
	  addRegexToken('hmm', match3to4);
	  addRegexToken('hmmss', match5to6);
	  addRegexToken('Hmm', match3to4);
	  addRegexToken('Hmmss', match5to6);
	  addParseToken(['H', 'HH'], HOUR);
	  addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	  });
	  addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	  });
	  addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	  });
	  addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	  });
	  addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4,
	        pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	  });
	  addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	  });
	  addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4,
	        pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	  }); // LOCALES

	  function localeIsPM(input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return (input + '').toLowerCase().charAt(0) === 'p';
	  }

	  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	      // Setting the hour should keep the time, because the user explicitly
	  // specified which hour they want. So trying to maintain the same hour (in
	  // a new timezone) makes sense. Adding/subtracting hours does not follow
	  // this rule.
	  getSetHour = makeGetSet('Hours', true);

	  function localeMeridiem(hours, minutes, isLower) {
	    if (hours > 11) {
	      return isLower ? 'pm' : 'PM';
	    } else {
	      return isLower ? 'am' : 'AM';
	    }
	  }

	  var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	    week: defaultLocaleWeek,
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	    meridiemParse: defaultLocaleMeridiemParse
	  }; // internal storage for locale config files

	  var locales = {},
	      localeFamilies = {},
	      globalLocale;

	  function commonPrefix(arr1, arr2) {
	    var i,
	        minl = Math.min(arr1.length, arr2.length);

	    for (i = 0; i < minl; i += 1) {
	      if (arr1[i] !== arr2[i]) {
	        return i;
	      }
	    }

	    return minl;
	  }

	  function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	  } // pick the locale from the array
	  // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	  // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


	  function chooseLocale(names) {
	    var i = 0,
	        j,
	        next,
	        locale,
	        split;

	    while (i < names.length) {
	      split = normalizeLocale(names[i]).split('-');
	      j = split.length;
	      next = normalizeLocale(names[i + 1]);
	      next = next ? next.split('-') : null;

	      while (j > 0) {
	        locale = loadLocale(split.slice(0, j).join('-'));

	        if (locale) {
	          return locale;
	        }

	        if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
	          //the next array item is better than a shallower substring of this one
	          break;
	        }

	        j--;
	      }

	      i++;
	    }

	    return globalLocale;
	  }

	  function loadLocale(name) {
	    var oldLocale = null,
	        aliasedRequire; // TODO: Find a better way to register and load all the locales in Node

	    if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports) {
	      try {
	        oldLocale = globalLocale._abbr;
	        aliasedRequire = commonjsRequire;
	        aliasedRequire('./locale/' + name);
	        getSetGlobalLocale(oldLocale);
	      } catch (e) {
	        // mark as not found to avoid repeating expensive file require call causing high CPU
	        // when trying to find en-US, en_US, en-us for every format call
	        locales[name] = null; // null means not found
	      }
	    }

	    return locales[name];
	  } // This function will load locale and then set the global locale.  If
	  // no arguments are passed in, it will simply return the current global
	  // locale key.


	  function getSetGlobalLocale(key, values) {
	    var data;

	    if (key) {
	      if (isUndefined(values)) {
	        data = getLocale(key);
	      } else {
	        data = defineLocale(key, values);
	      }

	      if (data) {
	        // moment.duration._locale = moment._locale = data;
	        globalLocale = data;
	      } else {
	        if (typeof console !== 'undefined' && console.warn) {
	          //warn user if arguments are passed but the locale could not be set
	          console.warn('Locale ' + key + ' not found. Did you forget to load it?');
	        }
	      }
	    }

	    return globalLocale._abbr;
	  }

	  function defineLocale(name, config) {
	    if (config !== null) {
	      var locale,
	          parentConfig = baseConfig;
	      config.abbr = name;

	      if (locales[name] != null) {
	        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	        parentConfig = locales[name]._config;
	      } else if (config.parentLocale != null) {
	        if (locales[config.parentLocale] != null) {
	          parentConfig = locales[config.parentLocale]._config;
	        } else {
	          locale = loadLocale(config.parentLocale);

	          if (locale != null) {
	            parentConfig = locale._config;
	          } else {
	            if (!localeFamilies[config.parentLocale]) {
	              localeFamilies[config.parentLocale] = [];
	            }

	            localeFamilies[config.parentLocale].push({
	              name: name,
	              config: config
	            });
	            return null;
	          }
	        }
	      }

	      locales[name] = new Locale(mergeConfigs(parentConfig, config));

	      if (localeFamilies[name]) {
	        localeFamilies[name].forEach(function (x) {
	          defineLocale(x.name, x.config);
	        });
	      } // backwards compat for now: also set the locale
	      // make sure we set the locale AFTER all child locales have been
	      // created, so we won't end up with the child locale set.


	      getSetGlobalLocale(name);
	      return locales[name];
	    } else {
	      // useful for testing
	      delete locales[name];
	      return null;
	    }
	  }

	  function updateLocale(name, config) {
	    if (config != null) {
	      var locale,
	          tmpLocale,
	          parentConfig = baseConfig;

	      if (locales[name] != null && locales[name].parentLocale != null) {
	        // Update existing child locale in-place to avoid memory-leaks
	        locales[name].set(mergeConfigs(locales[name]._config, config));
	      } else {
	        // MERGE
	        tmpLocale = loadLocale(name);

	        if (tmpLocale != null) {
	          parentConfig = tmpLocale._config;
	        }

	        config = mergeConfigs(parentConfig, config);

	        if (tmpLocale == null) {
	          // updateLocale is called for creating a new locale
	          // Set abbr so it will have a name (getters return
	          // undefined otherwise).
	          config.abbr = name;
	        }

	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	      } // backwards compat for now: also set the locale


	      getSetGlobalLocale(name);
	    } else {
	      // pass null for config to unupdate, useful for tests
	      if (locales[name] != null) {
	        if (locales[name].parentLocale != null) {
	          locales[name] = locales[name].parentLocale;

	          if (name === getSetGlobalLocale()) {
	            getSetGlobalLocale(name);
	          }
	        } else if (locales[name] != null) {
	          delete locales[name];
	        }
	      }
	    }

	    return locales[name];
	  } // returns locale data


	  function getLocale(key) {
	    var locale;

	    if (key && key._locale && key._locale._abbr) {
	      key = key._locale._abbr;
	    }

	    if (!key) {
	      return globalLocale;
	    }

	    if (!isArray(key)) {
	      //short-circuit everything else
	      locale = loadLocale(key);

	      if (locale) {
	        return locale;
	      }

	      key = [key];
	    }

	    return chooseLocale(key);
	  }

	  function listLocales() {
	    return keys(locales);
	  }

	  function checkOverflow(m) {
	    var overflow,
	        a = m._a;

	    if (a && getParsingFlags(m).overflow === -2) {
	      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

	      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	        overflow = DATE;
	      }

	      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	        overflow = WEEK;
	      }

	      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	        overflow = WEEKDAY;
	      }

	      getParsingFlags(m).overflow = overflow;
	    }

	    return m;
	  } // iso 8601 regex
	  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


	  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
	      // iso time formats and regexes
	  isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
	      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	      // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	  rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	      obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	  }; // date from iso format

	  function configFromISO(config) {
	    var i,
	        l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime,
	        dateFormat,
	        timeFormat,
	        tzFormat;

	    if (match) {
	      getParsingFlags(config).iso = true;

	      for (i = 0, l = isoDates.length; i < l; i++) {
	        if (isoDates[i][1].exec(match[1])) {
	          dateFormat = isoDates[i][0];
	          allowTime = isoDates[i][2] !== false;
	          break;
	        }
	      }

	      if (dateFormat == null) {
	        config._isValid = false;
	        return;
	      }

	      if (match[3]) {
	        for (i = 0, l = isoTimes.length; i < l; i++) {
	          if (isoTimes[i][1].exec(match[3])) {
	            // match[2] should be 'T' or space
	            timeFormat = (match[2] || ' ') + isoTimes[i][0];
	            break;
	          }
	        }

	        if (timeFormat == null) {
	          config._isValid = false;
	          return;
	        }
	      }

	      if (!allowTime && timeFormat != null) {
	        config._isValid = false;
	        return;
	      }

	      if (match[4]) {
	        if (tzRegex.exec(match[4])) {
	          tzFormat = 'Z';
	        } else {
	          config._isValid = false;
	          return;
	        }
	      }

	      config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	      configFromStringAndFormat(config);
	    } else {
	      config._isValid = false;
	    }
	  }

	  function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

	    if (secondStr) {
	      result.push(parseInt(secondStr, 10));
	    }

	    return result;
	  }

	  function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);

	    if (year <= 49) {
	      return 2000 + year;
	    } else if (year <= 999) {
	      return 1900 + year;
	    }

	    return year;
	  }

	  function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	  }

	  function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	      // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	      var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

	      if (weekdayProvided !== weekdayActual) {
	        getParsingFlags(config).weekdayMismatch = true;
	        config._isValid = false;
	        return false;
	      }
	    }

	    return true;
	  }

	  function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	      return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	      // the only allowed military tz is Z
	      return 0;
	    } else {
	      var hm = parseInt(numOffset, 10),
	          m = hm % 100,
	          h = (hm - m) / 100;
	      return h * 60 + m;
	    }
	  } // date and time from ref 2822 format


	  function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i)),
	        parsedArray;

	    if (match) {
	      parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

	      if (!checkWeekday(match[1], parsedArray, config)) {
	        return;
	      }

	      config._a = parsedArray;
	      config._tzm = calculateOffset(match[8], match[9], match[10]);
	      config._d = createUTCDate.apply(null, config._a);

	      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	      getParsingFlags(config).rfc2822 = true;
	    } else {
	      config._isValid = false;
	    }
	  } // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict


	  function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);

	    if (matched !== null) {
	      config._d = new Date(+matched[1]);
	      return;
	    }

	    configFromISO(config);

	    if (config._isValid === false) {
	      delete config._isValid;
	    } else {
	      return;
	    }

	    configFromRFC2822(config);

	    if (config._isValid === false) {
	      delete config._isValid;
	    } else {
	      return;
	    }

	    if (config._strict) {
	      config._isValid = false;
	    } else {
	      // Final attempt, use Input Fallback
	      hooks.createFromInputFallback(config);
	    }
	  }

	  hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
	    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	  }); // Pick the first defined of two or three arguments.

	  function defaults(a, b, c) {
	    if (a != null) {
	      return a;
	    }

	    if (b != null) {
	      return b;
	    }

	    return c;
	  }

	  function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());

	    if (config._useUTC) {
	      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }

	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	  } // convert an array to a date.
	  // the array should mirror the parameters below
	  // note: all values past the year are optional and will default to the lowest possible value.
	  // [year, month, day , hour, minute, second, millisecond]


	  function configFromArray(config) {
	    var i,
	        date,
	        input = [],
	        currentDate,
	        expectedWeekday,
	        yearToUse;

	    if (config._d) {
	      return;
	    }

	    currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	      dayOfYearFromWeekInfo(config);
	    } //if the day of the year is set, figure out what it is


	    if (config._dayOfYear != null) {
	      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

	      if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	        getParsingFlags(config)._overflowDayOfYear = true;
	      }

	      date = createUTCDate(yearToUse, 0, config._dayOfYear);
	      config._a[MONTH] = date.getUTCMonth();
	      config._a[DATE] = date.getUTCDate();
	    } // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything


	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	      config._a[i] = input[i] = currentDate[i];
	    } // Zero out whatever was not defaulted, including time


	    for (; i < 7; i++) {
	      config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
	    } // Check for 24:00:00.000


	    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
	      config._nextDay = true;
	      config._a[HOUR] = 0;
	    }

	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.

	    if (config._tzm != null) {
	      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }

	    if (config._nextDay) {
	      config._a[HOUR] = 24;
	    } // check for mismatching day of week


	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	      getParsingFlags(config).weekdayMismatch = true;
	    }
	  }

	  function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	    w = config._w;

	    if (w.GG != null || w.W != null || w.E != null) {
	      dow = 1;
	      doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
	      // how we interpret now (local, utc, fixed offset). So create
	      // a now version of current config (take local/utc/offset flags, and
	      // create now).

	      weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	      week = defaults(w.W, 1);
	      weekday = defaults(w.E, 1);

	      if (weekday < 1 || weekday > 7) {
	        weekdayOverflow = true;
	      }
	    } else {
	      dow = config._locale._week.dow;
	      doy = config._locale._week.doy;
	      curWeek = weekOfYear(createLocal(), dow, doy);
	      weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

	      week = defaults(w.w, curWeek.week);

	      if (w.d != null) {
	        // weekday -- low day numbers are considered next week
	        weekday = w.d;

	        if (weekday < 0 || weekday > 6) {
	          weekdayOverflow = true;
	        }
	      } else if (w.e != null) {
	        // local weekday -- counting starts from beginning of week
	        weekday = w.e + dow;

	        if (w.e < 0 || w.e > 6) {
	          weekdayOverflow = true;
	        }
	      } else {
	        // default to beginning of week
	        weekday = dow;
	      }
	    }

	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	      getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	      getParsingFlags(config)._overflowWeekday = true;
	    } else {
	      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	      config._a[YEAR] = temp.year;
	      config._dayOfYear = temp.dayOfYear;
	    }
	  } // constant that refers to the ISO standard


	  hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


	  hooks.RFC_2822 = function () {}; // date from string and format string


	  function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	      configFromISO(config);
	      return;
	    }

	    if (config._f === hooks.RFC_2822) {
	      configFromRFC2822(config);
	      return;
	    }

	    config._a = [];
	    getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

	    var string = '' + config._i,
	        i,
	        parsedInput,
	        tokens,
	        token,
	        skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0,
	        era;
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

	    for (i = 0; i < tokens.length; i++) {
	      token = tokens[i];
	      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];

	      if (parsedInput) {
	        skipped = string.substr(0, string.indexOf(parsedInput));

	        if (skipped.length > 0) {
	          getParsingFlags(config).unusedInput.push(skipped);
	        }

	        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	        totalParsedInputLength += parsedInput.length;
	      } // don't parse if it's not a known token


	      if (formatTokenFunctions[token]) {
	        if (parsedInput) {
	          getParsingFlags(config).empty = false;
	        } else {
	          getParsingFlags(config).unusedTokens.push(token);
	        }

	        addTimeToArrayFromToken(token, parsedInput, config);
	      } else if (config._strict && !parsedInput) {
	        getParsingFlags(config).unusedTokens.push(token);
	      }
	    } // add remaining unparsed input length to the string


	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

	    if (string.length > 0) {
	      getParsingFlags(config).unusedInput.push(string);
	    } // clear _12h flag if hour is <= 12


	    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
	      getParsingFlags(config).bigHour = undefined;
	    }

	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem); // handle era

	    era = getParsingFlags(config).era;

	    if (era !== null) {
	      config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	    }

	    configFromArray(config);
	    checkOverflow(config);
	  }

	  function meridiemFixWrap(locale, hour, meridiem) {
	    var isPm;

	    if (meridiem == null) {
	      // nothing to do
	      return hour;
	    }

	    if (locale.meridiemHour != null) {
	      return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	      // Fallback
	      isPm = locale.isPM(meridiem);

	      if (isPm && hour < 12) {
	        hour += 12;
	      }

	      if (!isPm && hour === 12) {
	        hour = 0;
	      }

	      return hour;
	    } else {
	      // this is not supposed to happen
	      return hour;
	    }
	  } // date from string and array of format strings


	  function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	        scoreToBeat,
	        i,
	        currentScore,
	        validFormatFound,
	        bestFormatIsValid = false;

	    if (config._f.length === 0) {
	      getParsingFlags(config).invalidFormat = true;
	      config._d = new Date(NaN);
	      return;
	    }

	    for (i = 0; i < config._f.length; i++) {
	      currentScore = 0;
	      validFormatFound = false;
	      tempConfig = copyConfig({}, config);

	      if (config._useUTC != null) {
	        tempConfig._useUTC = config._useUTC;
	      }

	      tempConfig._f = config._f[i];
	      configFromStringAndFormat(tempConfig);

	      if (isValid(tempConfig)) {
	        validFormatFound = true;
	      } // if there is any input that was not parsed add a penalty for that format


	      currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

	      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	      getParsingFlags(tempConfig).score = currentScore;

	      if (!bestFormatIsValid) {
	        if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
	          scoreToBeat = currentScore;
	          bestMoment = tempConfig;

	          if (validFormatFound) {
	            bestFormatIsValid = true;
	          }
	        }
	      } else {
	        if (currentScore < scoreToBeat) {
	          scoreToBeat = currentScore;
	          bestMoment = tempConfig;
	        }
	      }
	    }

	    extend(config, bestMoment || tempConfig);
	  }

	  function configFromObject(config) {
	    if (config._d) {
	      return;
	    }

	    var i = normalizeObjectUnits(config._i),
	        dayOrDate = i.day === undefined ? i.date : i.day;
	    config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	      return obj && parseInt(obj, 10);
	    });
	    configFromArray(config);
	  }

	  function createFromConfig(config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));

	    if (res._nextDay) {
	      // Adding is smart enough around DST
	      res.add(1, 'd');
	      res._nextDay = undefined;
	    }

	    return res;
	  }

	  function prepareConfig(config) {
	    var input = config._i,
	        format = config._f;
	    config._locale = config._locale || getLocale(config._l);

	    if (input === null || format === undefined && input === '') {
	      return createInvalid({
	        nullInput: true
	      });
	    }

	    if (typeof input === 'string') {
	      config._i = input = config._locale.preparse(input);
	    }

	    if (isMoment(input)) {
	      return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	      config._d = input;
	    } else if (isArray(format)) {
	      configFromStringAndArray(config);
	    } else if (format) {
	      configFromStringAndFormat(config);
	    } else {
	      configFromInput(config);
	    }

	    if (!isValid(config)) {
	      config._d = null;
	    }

	    return config;
	  }

	  function configFromInput(config) {
	    var input = config._i;

	    if (isUndefined(input)) {
	      config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	      config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	      configFromString(config);
	    } else if (isArray(input)) {
	      config._a = map(input.slice(0), function (obj) {
	        return parseInt(obj, 10);
	      });
	      configFromArray(config);
	    } else if (isObject(input)) {
	      configFromObject(config);
	    } else if (isNumber(input)) {
	      // from milliseconds
	      config._d = new Date(input);
	    } else {
	      hooks.createFromInputFallback(config);
	    }
	  }

	  function createLocalOrUTC(input, format, locale, strict, isUTC) {
	    var c = {};

	    if (format === true || format === false) {
	      strict = format;
	      format = undefined;
	    }

	    if (locale === true || locale === false) {
	      strict = locale;
	      locale = undefined;
	    }

	    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
	      input = undefined;
	    } // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423


	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	    return createFromConfig(c);
	  }

	  function createLocal(input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	  }

	  var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
	    var other = createLocal.apply(null, arguments);

	    if (this.isValid() && other.isValid()) {
	      return other < this ? this : other;
	    } else {
	      return createInvalid();
	    }
	  }),
	      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
	    var other = createLocal.apply(null, arguments);

	    if (this.isValid() && other.isValid()) {
	      return other > this ? this : other;
	    } else {
	      return createInvalid();
	    }
	  }); // Pick a moment m from moments so that m[fn](other) is true for all
	  // other. This relies on the function fn to be transitive.
	  //
	  // moments should either be an array of moment objects or an array, whose
	  // first element is an array of moment objects.

	  function pickBy(fn, moments) {
	    var res, i;

	    if (moments.length === 1 && isArray(moments[0])) {
	      moments = moments[0];
	    }

	    if (!moments.length) {
	      return createLocal();
	    }

	    res = moments[0];

	    for (i = 1; i < moments.length; ++i) {
	      if (!moments[i].isValid() || moments[i][fn](res)) {
	        res = moments[i];
	      }
	    }

	    return res;
	  } // TODO: Use [].sort instead?


	  function min() {
	    var args = [].slice.call(arguments, 0);
	    return pickBy('isBefore', args);
	  }

	  function max() {
	    var args = [].slice.call(arguments, 0);
	    return pickBy('isAfter', args);
	  }

	  var now = function () {
	    return Date.now ? Date.now() : +new Date();
	  };

	  var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

	  function isDurationValid(m) {
	    var key,
	        unitHasDecimal = false,
	        i;

	    for (key in m) {
	      if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	        return false;
	      }
	    }

	    for (i = 0; i < ordering.length; ++i) {
	      if (m[ordering[i]]) {
	        if (unitHasDecimal) {
	          return false; // only allow non-integers for smallest unit
	        }

	        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	          unitHasDecimal = true;
	        }
	      }
	    }

	    return true;
	  }

	  function isValid$1() {
	    return this._isValid;
	  }

	  function createInvalid$1() {
	    return createDuration(NaN);
	  }

	  function Duration(duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	    this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

	    this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
	    minutes * 6e4 + // 1000 * 60
	    hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately

	    this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.

	    this._months = +months + quarters * 3 + years * 12;
	    this._data = {};
	    this._locale = getLocale();

	    this._bubble();
	  }

	  function isDuration(obj) {
	    return obj instanceof Duration;
	  }

	  function absRound(number) {
	    if (number < 0) {
	      return Math.round(-1 * number) * -1;
	    } else {
	      return Math.round(number);
	    }
	  } // compare two arrays, return the number of differences


	  function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;

	    for (i = 0; i < len; i++) {
	      if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
	        diffs++;
	      }
	    }

	    return diffs + lengthDiff;
	  } // FORMATTING


	  function offset(token, separator) {
	    addFormatToken(token, 0, 0, function () {
	      var offset = this.utcOffset(),
	          sign = '+';

	      if (offset < 0) {
	        offset = -offset;
	        sign = '-';
	      }

	      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
	    });
	  }

	  offset('Z', ':');
	  offset('ZZ', ''); // PARSING

	  addRegexToken('Z', matchShortOffset);
	  addRegexToken('ZZ', matchShortOffset);
	  addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	  }); // HELPERS
	  // timezone chunker
	  // '+10:00' > ['10',  '00']
	  // '-1530'  > ['-15', '30']

	  var chunkOffset = /([\+\-]|\d\d)/gi;

	  function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher),
	        chunk,
	        parts,
	        minutes;

	    if (matches === null) {
	      return null;
	    }

	    chunk = matches[matches.length - 1] || [];
	    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    minutes = +(parts[1] * 60) + toInt(parts[2]);
	    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	  } // Return a moment from input, that is local/utc/zone equivalent to model.


	  function cloneWithOffset(input, model) {
	    var res, diff;

	    if (model._isUTC) {
	      res = model.clone();
	      diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

	      res._d.setTime(res._d.valueOf() + diff);

	      hooks.updateOffset(res, false);
	      return res;
	    } else {
	      return createLocal(input).local();
	    }
	  }

	  function getDateOffset(m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset());
	  } // HOOKS
	  // This function will be called whenever a moment is mutated.
	  // It is intended to keep the offset in sync with the timezone.


	  hooks.updateOffset = function () {}; // MOMENTS
	  // keepLocalTime = true means only change the timezone, without
	  // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	  // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	  // +0200, so we adjust the time as needed, to be valid.
	  //
	  // Keeping the time actually adds/subtracts (one hour)
	  // from the actual represented time. That is why we call updateOffset
	  // a second time. In case it wants us to change the offset again
	  // _changeInProgress == true case, then we have to adjust, because
	  // there is no such time in the given timezone.


	  function getSetOffset(input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;

	    if (!this.isValid()) {
	      return input != null ? this : NaN;
	    }

	    if (input != null) {
	      if (typeof input === 'string') {
	        input = offsetFromString(matchShortOffset, input);

	        if (input === null) {
	          return this;
	        }
	      } else if (Math.abs(input) < 16 && !keepMinutes) {
	        input = input * 60;
	      }

	      if (!this._isUTC && keepLocalTime) {
	        localAdjust = getDateOffset(this);
	      }

	      this._offset = input;
	      this._isUTC = true;

	      if (localAdjust != null) {
	        this.add(localAdjust, 'm');
	      }

	      if (offset !== input) {
	        if (!keepLocalTime || this._changeInProgress) {
	          addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	        } else if (!this._changeInProgress) {
	          this._changeInProgress = true;
	          hooks.updateOffset(this, true);
	          this._changeInProgress = null;
	        }
	      }

	      return this;
	    } else {
	      return this._isUTC ? offset : getDateOffset(this);
	    }
	  }

	  function getSetZone(input, keepLocalTime) {
	    if (input != null) {
	      if (typeof input !== 'string') {
	        input = -input;
	      }

	      this.utcOffset(input, keepLocalTime);
	      return this;
	    } else {
	      return -this.utcOffset();
	    }
	  }

	  function setOffsetToUTC(keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	  }

	  function setOffsetToLocal(keepLocalTime) {
	    if (this._isUTC) {
	      this.utcOffset(0, keepLocalTime);
	      this._isUTC = false;

	      if (keepLocalTime) {
	        this.subtract(getDateOffset(this), 'm');
	      }
	    }

	    return this;
	  }

	  function setOffsetToParsedOffset() {
	    if (this._tzm != null) {
	      this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	      var tZone = offsetFromString(matchOffset, this._i);

	      if (tZone != null) {
	        this.utcOffset(tZone);
	      } else {
	        this.utcOffset(0, true);
	      }
	    }

	    return this;
	  }

	  function hasAlignedHourOffset(input) {
	    if (!this.isValid()) {
	      return false;
	    }

	    input = input ? createLocal(input).utcOffset() : 0;
	    return (this.utcOffset() - input) % 60 === 0;
	  }

	  function isDaylightSavingTime() {
	    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
	  }

	  function isDaylightSavingTimeShifted() {
	    if (!isUndefined(this._isDSTShifted)) {
	      return this._isDSTShifted;
	    }

	    var c = {},
	        other;
	    copyConfig(c, this);
	    c = prepareConfig(c);

	    if (c._a) {
	      other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	    } else {
	      this._isDSTShifted = false;
	    }

	    return this._isDSTShifted;
	  }

	  function isLocal() {
	    return this.isValid() ? !this._isUTC : false;
	  }

	  function isUtcOffset() {
	    return this.isValid() ? this._isUTC : false;
	  }

	  function isUtc() {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	  } // ASP.NET json date format regex


	  var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	      // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	  // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	  // and further modified to allow for strings containing both week and day
	  isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	  function createDuration(input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	    match = null,
	        sign,
	        ret,
	        diffRes;

	    if (isDuration(input)) {
	      duration = {
	        ms: input._milliseconds,
	        d: input._days,
	        M: input._months
	      };
	    } else if (isNumber(input) || !isNaN(+input)) {
	      duration = {};

	      if (key) {
	        duration[key] = +input;
	      } else {
	        duration.milliseconds = +input;
	      }
	    } else if (match = aspNetRegex.exec(input)) {
	      sign = match[1] === '-' ? -1 : 1;
	      duration = {
	        y: 0,
	        d: toInt(match[DATE]) * sign,
	        h: toInt(match[HOUR]) * sign,
	        m: toInt(match[MINUTE]) * sign,
	        s: toInt(match[SECOND]) * sign,
	        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

	      };
	    } else if (match = isoRegex.exec(input)) {
	      sign = match[1] === '-' ? -1 : 1;
	      duration = {
	        y: parseIso(match[2], sign),
	        M: parseIso(match[3], sign),
	        w: parseIso(match[4], sign),
	        d: parseIso(match[5], sign),
	        h: parseIso(match[6], sign),
	        m: parseIso(match[7], sign),
	        s: parseIso(match[8], sign)
	      };
	    } else if (duration == null) {
	      // checks for null or undefined
	      duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	      diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	      duration = {};
	      duration.ms = diffRes.milliseconds;
	      duration.M = diffRes.months;
	    }

	    ret = new Duration(duration);

	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	      ret._locale = input._locale;
	    }

	    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	      ret._isValid = input._isValid;
	    }

	    return ret;
	  }

	  createDuration.fn = Duration.prototype;
	  createDuration.invalid = createInvalid$1;

	  function parseIso(inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

	    return (isNaN(res) ? 0 : res) * sign;
	  }

	  function positiveMomentsDifference(base, other) {
	    var res = {};
	    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	      --res.months;
	    }

	    res.milliseconds = +other - +base.clone().add(res.months, 'M');
	    return res;
	  }

	  function momentsDifference(base, other) {
	    var res;

	    if (!(base.isValid() && other.isValid())) {
	      return {
	        milliseconds: 0,
	        months: 0
	      };
	    }

	    other = cloneWithOffset(other, base);

	    if (base.isBefore(other)) {
	      res = positiveMomentsDifference(base, other);
	    } else {
	      res = positiveMomentsDifference(other, base);
	      res.milliseconds = -res.milliseconds;
	      res.months = -res.months;
	    }

	    return res;
	  } // TODO: remove 'name' arg after deprecation is removed


	  function createAdder(direction, name) {
	    return function (val, period) {
	      var dur, tmp; //invert the arguments, but complain about it

	      if (period !== null && !isNaN(+period)) {
	        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	        tmp = val;
	        val = period;
	        period = tmp;
	      }

	      dur = createDuration(val, period);
	      addSubtract(this, dur, direction);
	      return this;
	    };
	  }

	  function addSubtract(mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);

	    if (!mom.isValid()) {
	      // No op
	      return;
	    }

	    updateOffset = updateOffset == null ? true : updateOffset;

	    if (months) {
	      setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }

	    if (days) {
	      set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }

	    if (milliseconds) {
	      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }

	    if (updateOffset) {
	      hooks.updateOffset(mom, days || months);
	    }
	  }

	  var add = createAdder(1, 'add'),
	      subtract = createAdder(-1, 'subtract');

	  function isString(input) {
	    return typeof input === 'string' || input instanceof String;
	  } // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined


	  function isMomentInput(input) {
	    return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
	  }

	  function isMomentInputObject(input) {
	    var objectTest = isObject(input) && !isObjectEmpty(input),
	        propertyTest = false,
	        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
	        i,
	        property;

	    for (i = 0; i < properties.length; i += 1) {
	      property = properties[i];
	      propertyTest = propertyTest || hasOwnProp(input, property);
	    }

	    return objectTest && propertyTest;
	  }

	  function isNumberOrStringArray(input) {
	    var arrayTest = isArray(input),
	        dataTypeTest = false;

	    if (arrayTest) {
	      dataTypeTest = input.filter(function (item) {
	        return !isNumber(item) && isString(input);
	      }).length === 0;
	    }

	    return arrayTest && dataTypeTest;
	  }

	  function isCalendarSpec(input) {
	    var objectTest = isObject(input) && !isObjectEmpty(input),
	        propertyTest = false,
	        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
	        i,
	        property;

	    for (i = 0; i < properties.length; i += 1) {
	      property = properties[i];
	      propertyTest = propertyTest || hasOwnProp(input, property);
	    }

	    return objectTest && propertyTest;
	  }

	  function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
	  }

	  function calendar$1(time, formats) {
	    // Support for single parameter, formats only overload to the calendar function
	    if (arguments.length === 1) {
	      if (!arguments[0]) {
	        time = undefined;
	        formats = undefined;
	      } else if (isMomentInput(arguments[0])) {
	        time = arguments[0];
	        formats = undefined;
	      } else if (isCalendarSpec(arguments[0])) {
	        formats = arguments[0];
	        time = undefined;
	      }
	    } // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.


	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse',
	        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	  }

	  function clone() {
	    return new Moment(this);
	  }

	  function isAfter(input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);

	    if (!(this.isValid() && localInput.isValid())) {
	      return false;
	    }

	    units = normalizeUnits(units) || 'millisecond';

	    if (units === 'millisecond') {
	      return this.valueOf() > localInput.valueOf();
	    } else {
	      return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	  }

	  function isBefore(input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);

	    if (!(this.isValid() && localInput.isValid())) {
	      return false;
	    }

	    units = normalizeUnits(units) || 'millisecond';

	    if (units === 'millisecond') {
	      return this.valueOf() < localInput.valueOf();
	    } else {
	      return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	  }

	  function isBetween(from, to, units, inclusivity) {
	    var localFrom = isMoment(from) ? from : createLocal(from),
	        localTo = isMoment(to) ? to : createLocal(to);

	    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	      return false;
	    }

	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	  }

	  function isSame(input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;

	    if (!(this.isValid() && localInput.isValid())) {
	      return false;
	    }

	    units = normalizeUnits(units) || 'millisecond';

	    if (units === 'millisecond') {
	      return this.valueOf() === localInput.valueOf();
	    } else {
	      inputMs = localInput.valueOf();
	      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	  }

	  function isSameOrAfter(input, units) {
	    return this.isSame(input, units) || this.isAfter(input, units);
	  }

	  function isSameOrBefore(input, units) {
	    return this.isSame(input, units) || this.isBefore(input, units);
	  }

	  function diff(input, units, asFloat) {
	    var that, zoneDelta, output;

	    if (!this.isValid()) {
	      return NaN;
	    }

	    that = cloneWithOffset(input, this);

	    if (!that.isValid()) {
	      return NaN;
	    }

	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	    units = normalizeUnits(units);

	    switch (units) {
	      case 'year':
	        output = monthDiff(this, that) / 12;
	        break;

	      case 'month':
	        output = monthDiff(this, that);
	        break;

	      case 'quarter':
	        output = monthDiff(this, that) / 3;
	        break;

	      case 'second':
	        output = (this - that) / 1e3;
	        break;
	      // 1000

	      case 'minute':
	        output = (this - that) / 6e4;
	        break;
	      // 1000 * 60

	      case 'hour':
	        output = (this - that) / 36e5;
	        break;
	      // 1000 * 60 * 60

	      case 'day':
	        output = (this - that - zoneDelta) / 864e5;
	        break;
	      // 1000 * 60 * 60 * 24, negate dst

	      case 'week':
	        output = (this - that - zoneDelta) / 6048e5;
	        break;
	      // 1000 * 60 * 60 * 24 * 7, negate dst

	      default:
	        output = this - that;
	    }

	    return asFloat ? output : absFloor(output);
	  }

	  function monthDiff(a, b) {
	    if (a.date() < b.date()) {
	      // end-of-month calculations work correct when the start month has more
	      // days than the end month.
	      return -monthDiff(b, a);
	    } // difference in months


	    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	    anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2,
	        adjust;

	    if (b - anchor < 0) {
	      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

	      adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

	      adjust = (b - anchor) / (anchor2 - anchor);
	    } //check for negative zero, return zero if negative zero


	    return -(wholeMonthDiff + adjust) || 0;
	  }

	  hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	  hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	  function toString() {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	  }

	  function toISOString(keepOffset) {
	    if (!this.isValid()) {
	      return null;
	    }

	    var utc = keepOffset !== true,
	        m = utc ? this.clone().utc() : this;

	    if (m.year() < 0 || m.year() > 9999) {
	      return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }

	    if (isFunction(Date.prototype.toISOString)) {
	      // native implementation is ~50x faster, use it when we can
	      if (utc) {
	        return this.toDate().toISOString();
	      } else {
	        return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	      }
	    }

	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	  }
	  /**
	   * Return a human readable representation of a moment that can
	   * also be evaluated to get a new moment which is the same
	   *
	   * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	   */


	  function inspect() {
	    if (!this.isValid()) {
	      return 'moment.invalid(/* ' + this._i + ' */)';
	    }

	    var func = 'moment',
	        zone = '',
	        prefix,
	        year,
	        datetime,
	        suffix;

	    if (!this.isLocal()) {
	      func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	      zone = 'Z';
	    }

	    prefix = '[' + func + '("]';
	    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	    datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    suffix = zone + '[")]';
	    return this.format(prefix + year + datetime + suffix);
	  }

	  function format(inputString) {
	    if (!inputString) {
	      inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }

	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	  }

	  function from(time, withoutSuffix) {
	    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
	      return createDuration({
	        to: this,
	        from: time
	      }).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	      return this.localeData().invalidDate();
	    }
	  }

	  function fromNow(withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	  }

	  function to(time, withoutSuffix) {
	    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
	      return createDuration({
	        from: this,
	        to: time
	      }).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	      return this.localeData().invalidDate();
	    }
	  }

	  function toNow(withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	  } // If passed a locale key, it will set the locale for this
	  // instance.  Otherwise, it will return the locale configuration
	  // variables for this instance.


	  function locale(key) {
	    var newLocaleData;

	    if (key === undefined) {
	      return this._locale._abbr;
	    } else {
	      newLocaleData = getLocale(key);

	      if (newLocaleData != null) {
	        this._locale = newLocaleData;
	      }

	      return this;
	    }
	  }

	  var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
	    if (key === undefined) {
	      return this.localeData();
	    } else {
	      return this.locale(key);
	    }
	  });

	  function localeData() {
	    return this._locale;
	  }

	  var MS_PER_SECOND = 1000,
	      MS_PER_MINUTE = 60 * MS_PER_SECOND,
	      MS_PER_HOUR = 60 * MS_PER_MINUTE,
	      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

	  function mod$1(dividend, divisor) {
	    return (dividend % divisor + divisor) % divisor;
	  }

	  function localStartOfDate(y, m, d) {
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	      // preserve leap years using a full 400 year cycle, then reset
	      return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	    } else {
	      return new Date(y, m, d).valueOf();
	    }
	  }

	  function utcStartOfDate(y, m, d) {
	    // Date.UTC remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	      // preserve leap years using a full 400 year cycle, then reset
	      return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	    } else {
	      return Date.UTC(y, m, d);
	    }
	  }

	  function startOf(units) {
	    var time, startOfDate;
	    units = normalizeUnits(units);

	    if (units === undefined || units === 'millisecond' || !this.isValid()) {
	      return this;
	    }

	    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	    switch (units) {
	      case 'year':
	        time = startOfDate(this.year(), 0, 1);
	        break;

	      case 'quarter':
	        time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	        break;

	      case 'month':
	        time = startOfDate(this.year(), this.month(), 1);
	        break;

	      case 'week':
	        time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	        break;

	      case 'isoWeek':
	        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	        break;

	      case 'day':
	      case 'date':
	        time = startOfDate(this.year(), this.month(), this.date());
	        break;

	      case 'hour':
	        time = this._d.valueOf();
	        time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	        break;

	      case 'minute':
	        time = this._d.valueOf();
	        time -= mod$1(time, MS_PER_MINUTE);
	        break;

	      case 'second':
	        time = this._d.valueOf();
	        time -= mod$1(time, MS_PER_SECOND);
	        break;
	    }

	    this._d.setTime(time);

	    hooks.updateOffset(this, true);
	    return this;
	  }

	  function endOf(units) {
	    var time, startOfDate;
	    units = normalizeUnits(units);

	    if (units === undefined || units === 'millisecond' || !this.isValid()) {
	      return this;
	    }

	    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	    switch (units) {
	      case 'year':
	        time = startOfDate(this.year() + 1, 0, 1) - 1;
	        break;

	      case 'quarter':
	        time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	        break;

	      case 'month':
	        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	        break;

	      case 'week':
	        time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	        break;

	      case 'isoWeek':
	        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	        break;

	      case 'day':
	      case 'date':
	        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	        break;

	      case 'hour':
	        time = this._d.valueOf();
	        time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	        break;

	      case 'minute':
	        time = this._d.valueOf();
	        time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	        break;

	      case 'second':
	        time = this._d.valueOf();
	        time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	        break;
	    }

	    this._d.setTime(time);

	    hooks.updateOffset(this, true);
	    return this;
	  }

	  function valueOf() {
	    return this._d.valueOf() - (this._offset || 0) * 60000;
	  }

	  function unix() {
	    return Math.floor(this.valueOf() / 1000);
	  }

	  function toDate() {
	    return new Date(this.valueOf());
	  }

	  function toArray() {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	  }

	  function toObject() {
	    var m = this;
	    return {
	      years: m.year(),
	      months: m.month(),
	      date: m.date(),
	      hours: m.hours(),
	      minutes: m.minutes(),
	      seconds: m.seconds(),
	      milliseconds: m.milliseconds()
	    };
	  }

	  function toJSON() {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	  }

	  function isValid$2() {
	    return isValid(this);
	  }

	  function parsingFlags() {
	    return extend({}, getParsingFlags(this));
	  }

	  function invalidAt() {
	    return getParsingFlags(this).overflow;
	  }

	  function creationData() {
	    return {
	      input: this._i,
	      format: this._f,
	      locale: this._locale,
	      isUTC: this._isUTC,
	      strict: this._strict
	    };
	  }

	  addFormatToken('N', 0, 0, 'eraAbbr');
	  addFormatToken('NN', 0, 0, 'eraAbbr');
	  addFormatToken('NNN', 0, 0, 'eraAbbr');
	  addFormatToken('NNNN', 0, 0, 'eraName');
	  addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	  addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	  addFormatToken('y', ['yy', 2], 0, 'eraYear');
	  addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	  addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	  addRegexToken('N', matchEraAbbr);
	  addRegexToken('NN', matchEraAbbr);
	  addRegexToken('NNN', matchEraAbbr);
	  addRegexToken('NNNN', matchEraName);
	  addRegexToken('NNNNN', matchEraNarrow);
	  addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
	    var era = config._locale.erasParse(input, token, config._strict);

	    if (era) {
	      getParsingFlags(config).era = era;
	    } else {
	      getParsingFlags(config).invalidEra = input;
	    }
	  });
	  addRegexToken('y', matchUnsigned);
	  addRegexToken('yy', matchUnsigned);
	  addRegexToken('yyy', matchUnsigned);
	  addRegexToken('yyyy', matchUnsigned);
	  addRegexToken('yo', matchEraYearOrdinal);
	  addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	  addParseToken(['yo'], function (input, array, config, token) {
	    var match;

	    if (config._locale._eraYearOrdinalRegex) {
	      match = input.match(config._locale._eraYearOrdinalRegex);
	    }

	    if (config._locale.eraYearOrdinalParse) {
	      array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	    } else {
	      array[YEAR] = parseInt(input, 10);
	    }
	  });

	  function localeEras(m, format) {
	    var i,
	        l,
	        date,
	        eras = this._eras || getLocale('en')._eras;

	    for (i = 0, l = eras.length; i < l; ++i) {
	      switch (typeof eras[i].since) {
	        case 'string':
	          // truncate time
	          date = hooks(eras[i].since).startOf('day');
	          eras[i].since = date.valueOf();
	          break;
	      }

	      switch (typeof eras[i].until) {
	        case 'undefined':
	          eras[i].until = +Infinity;
	          break;

	        case 'string':
	          // truncate time
	          date = hooks(eras[i].until).startOf('day').valueOf();
	          eras[i].until = date.valueOf();
	          break;
	      }
	    }

	    return eras;
	  }

	  function localeErasParse(eraName, format, strict) {
	    var i,
	        l,
	        eras = this.eras(),
	        name,
	        abbr,
	        narrow;
	    eraName = eraName.toUpperCase();

	    for (i = 0, l = eras.length; i < l; ++i) {
	      name = eras[i].name.toUpperCase();
	      abbr = eras[i].abbr.toUpperCase();
	      narrow = eras[i].narrow.toUpperCase();

	      if (strict) {
	        switch (format) {
	          case 'N':
	          case 'NN':
	          case 'NNN':
	            if (abbr === eraName) {
	              return eras[i];
	            }

	            break;

	          case 'NNNN':
	            if (name === eraName) {
	              return eras[i];
	            }

	            break;

	          case 'NNNNN':
	            if (narrow === eraName) {
	              return eras[i];
	            }

	            break;
	        }
	      } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	        return eras[i];
	      }
	    }
	  }

	  function localeErasConvertYear(era, year) {
	    var dir = era.since <= era.until ? +1 : -1;

	    if (year === undefined) {
	      return hooks(era.since).year();
	    } else {
	      return hooks(era.since).year() + (year - era.offset) * dir;
	    }
	  }

	  function getEraName() {
	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();

	    for (i = 0, l = eras.length; i < l; ++i) {
	      // truncate time
	      val = this.clone().startOf('day').valueOf();

	      if (eras[i].since <= val && val <= eras[i].until) {
	        return eras[i].name;
	      }

	      if (eras[i].until <= val && val <= eras[i].since) {
	        return eras[i].name;
	      }
	    }

	    return '';
	  }

	  function getEraNarrow() {
	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();

	    for (i = 0, l = eras.length; i < l; ++i) {
	      // truncate time
	      val = this.clone().startOf('day').valueOf();

	      if (eras[i].since <= val && val <= eras[i].until) {
	        return eras[i].narrow;
	      }

	      if (eras[i].until <= val && val <= eras[i].since) {
	        return eras[i].narrow;
	      }
	    }

	    return '';
	  }

	  function getEraAbbr() {
	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();

	    for (i = 0, l = eras.length; i < l; ++i) {
	      // truncate time
	      val = this.clone().startOf('day').valueOf();

	      if (eras[i].since <= val && val <= eras[i].until) {
	        return eras[i].abbr;
	      }

	      if (eras[i].until <= val && val <= eras[i].since) {
	        return eras[i].abbr;
	      }
	    }

	    return '';
	  }

	  function getEraYear() {
	    var i,
	        l,
	        dir,
	        val,
	        eras = this.localeData().eras();

	    for (i = 0, l = eras.length; i < l; ++i) {
	      dir = eras[i].since <= eras[i].until ? +1 : -1; // truncate time

	      val = this.clone().startOf('day').valueOf();

	      if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
	        return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
	      }
	    }

	    return this.year();
	  }

	  function erasNameRegex(isStrict) {
	    if (!hasOwnProp(this, '_erasNameRegex')) {
	      computeErasParse.call(this);
	    }

	    return isStrict ? this._erasNameRegex : this._erasRegex;
	  }

	  function erasAbbrRegex(isStrict) {
	    if (!hasOwnProp(this, '_erasAbbrRegex')) {
	      computeErasParse.call(this);
	    }

	    return isStrict ? this._erasAbbrRegex : this._erasRegex;
	  }

	  function erasNarrowRegex(isStrict) {
	    if (!hasOwnProp(this, '_erasNarrowRegex')) {
	      computeErasParse.call(this);
	    }

	    return isStrict ? this._erasNarrowRegex : this._erasRegex;
	  }

	  function matchEraAbbr(isStrict, locale) {
	    return locale.erasAbbrRegex(isStrict);
	  }

	  function matchEraName(isStrict, locale) {
	    return locale.erasNameRegex(isStrict);
	  }

	  function matchEraNarrow(isStrict, locale) {
	    return locale.erasNarrowRegex(isStrict);
	  }

	  function matchEraYearOrdinal(isStrict, locale) {
	    return locale._eraYearOrdinalRegex || matchUnsigned;
	  }

	  function computeErasParse() {
	    var abbrPieces = [],
	        namePieces = [],
	        narrowPieces = [],
	        mixedPieces = [],
	        i,
	        l,
	        eras = this.eras();

	    for (i = 0, l = eras.length; i < l; ++i) {
	      namePieces.push(regexEscape(eras[i].name));
	      abbrPieces.push(regexEscape(eras[i].abbr));
	      narrowPieces.push(regexEscape(eras[i].narrow));
	      mixedPieces.push(regexEscape(eras[i].name));
	      mixedPieces.push(regexEscape(eras[i].abbr));
	      mixedPieces.push(regexEscape(eras[i].narrow));
	    }

	    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	    this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
	  } // FORMATTING


	  addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	  });
	  addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	  });

	  function addWeekYearFormatToken(token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	  }

	  addWeekYearFormatToken('gggg', 'weekYear');
	  addWeekYearFormatToken('ggggg', 'weekYear');
	  addWeekYearFormatToken('GGGG', 'isoWeekYear');
	  addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

	  addUnitAlias('weekYear', 'gg');
	  addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

	  addUnitPriority('weekYear', 1);
	  addUnitPriority('isoWeekYear', 1); // PARSING

	  addRegexToken('G', matchSigned);
	  addRegexToken('g', matchSigned);
	  addRegexToken('GG', match1to2, match2);
	  addRegexToken('gg', match1to2, match2);
	  addRegexToken('GGGG', match1to4, match4);
	  addRegexToken('gggg', match1to4, match4);
	  addRegexToken('GGGGG', match1to6, match6);
	  addRegexToken('ggggg', match1to6, match6);
	  addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	  });
	  addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	  }); // MOMENTS

	  function getSetWeekYear(input) {
	    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
	  }

	  function getSetISOWeekYear(input) {
	    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
	  }

	  function getISOWeeksInYear() {
	    return weeksInYear(this.year(), 1, 4);
	  }

	  function getISOWeeksInISOWeekYear() {
	    return weeksInYear(this.isoWeekYear(), 1, 4);
	  }

	  function getWeeksInYear() {
	    var weekInfo = this.localeData()._week;

	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	  }

	  function getWeeksInWeekYear() {
	    var weekInfo = this.localeData()._week;

	    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	  }

	  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;

	    if (input == null) {
	      return weekOfYear(this, dow, doy).year;
	    } else {
	      weeksTarget = weeksInYear(input, dow, doy);

	      if (week > weeksTarget) {
	        week = weeksTarget;
	      }

	      return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	  }

	  function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	  } // FORMATTING


	  addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

	  addUnitAlias('quarter', 'Q'); // PRIORITY

	  addUnitPriority('quarter', 7); // PARSING

	  addRegexToken('Q', match1);
	  addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	  }); // MOMENTS

	  function getSetQuarter(input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	  } // FORMATTING


	  addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

	  addUnitAlias('date', 'D'); // PRIORITY

	  addUnitPriority('date', 9); // PARSING

	  addRegexToken('D', match1to2);
	  addRegexToken('DD', match1to2, match2);
	  addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
	  });
	  addParseToken(['D', 'DD'], DATE);
	  addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	  }); // MOMENTS

	  var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

	  addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

	  addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

	  addUnitPriority('dayOfYear', 4); // PARSING

	  addRegexToken('DDD', match1to3);
	  addRegexToken('DDDD', match3);
	  addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	  }); // HELPERS
	  // MOMENTS

	  function getSetDayOfYear(input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	  } // FORMATTING


	  addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

	  addUnitAlias('minute', 'm'); // PRIORITY

	  addUnitPriority('minute', 14); // PARSING

	  addRegexToken('m', match1to2);
	  addRegexToken('mm', match1to2, match2);
	  addParseToken(['m', 'mm'], MINUTE); // MOMENTS

	  var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

	  addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

	  addUnitAlias('second', 's'); // PRIORITY

	  addUnitPriority('second', 15); // PARSING

	  addRegexToken('s', match1to2);
	  addRegexToken('ss', match1to2, match2);
	  addParseToken(['s', 'ss'], SECOND); // MOMENTS

	  var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

	  addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	  });
	  addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	  });
	  addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	  addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	  });
	  addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	  });
	  addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	  });
	  addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	  });
	  addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	  });
	  addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	  }); // ALIASES

	  addUnitAlias('millisecond', 'ms'); // PRIORITY

	  addUnitPriority('millisecond', 16); // PARSING

	  addRegexToken('S', match1to3, match1);
	  addRegexToken('SS', match1to3, match2);
	  addRegexToken('SSS', match1to3, match3);
	  var token, getSetMillisecond;

	  for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	  }

	  function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	  }

	  for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	  }

	  getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

	  addFormatToken('z', 0, 0, 'zoneAbbr');
	  addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

	  function getZoneAbbr() {
	    return this._isUTC ? 'UTC' : '';
	  }

	  function getZoneName() {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	  }

	  var proto = Moment.prototype;
	  proto.add = add;
	  proto.calendar = calendar$1;
	  proto.clone = clone;
	  proto.diff = diff;
	  proto.endOf = endOf;
	  proto.format = format;
	  proto.from = from;
	  proto.fromNow = fromNow;
	  proto.to = to;
	  proto.toNow = toNow;
	  proto.get = stringGet;
	  proto.invalidAt = invalidAt;
	  proto.isAfter = isAfter;
	  proto.isBefore = isBefore;
	  proto.isBetween = isBetween;
	  proto.isSame = isSame;
	  proto.isSameOrAfter = isSameOrAfter;
	  proto.isSameOrBefore = isSameOrBefore;
	  proto.isValid = isValid$2;
	  proto.lang = lang;
	  proto.locale = locale;
	  proto.localeData = localeData;
	  proto.max = prototypeMax;
	  proto.min = prototypeMin;
	  proto.parsingFlags = parsingFlags;
	  proto.set = stringSet;
	  proto.startOf = startOf;
	  proto.subtract = subtract;
	  proto.toArray = toArray;
	  proto.toObject = toObject;
	  proto.toDate = toDate;
	  proto.toISOString = toISOString;
	  proto.inspect = inspect;

	  if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	    proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	      return 'Moment<' + this.format() + '>';
	    };
	  }

	  proto.toJSON = toJSON;
	  proto.toString = toString;
	  proto.unix = unix;
	  proto.valueOf = valueOf;
	  proto.creationData = creationData;
	  proto.eraName = getEraName;
	  proto.eraNarrow = getEraNarrow;
	  proto.eraAbbr = getEraAbbr;
	  proto.eraYear = getEraYear;
	  proto.year = getSetYear;
	  proto.isLeapYear = getIsLeapYear;
	  proto.weekYear = getSetWeekYear;
	  proto.isoWeekYear = getSetISOWeekYear;
	  proto.quarter = proto.quarters = getSetQuarter;
	  proto.month = getSetMonth;
	  proto.daysInMonth = getDaysInMonth;
	  proto.week = proto.weeks = getSetWeek;
	  proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	  proto.weeksInYear = getWeeksInYear;
	  proto.weeksInWeekYear = getWeeksInWeekYear;
	  proto.isoWeeksInYear = getISOWeeksInYear;
	  proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	  proto.date = getSetDayOfMonth;
	  proto.day = proto.days = getSetDayOfWeek;
	  proto.weekday = getSetLocaleDayOfWeek;
	  proto.isoWeekday = getSetISODayOfWeek;
	  proto.dayOfYear = getSetDayOfYear;
	  proto.hour = proto.hours = getSetHour;
	  proto.minute = proto.minutes = getSetMinute;
	  proto.second = proto.seconds = getSetSecond;
	  proto.millisecond = proto.milliseconds = getSetMillisecond;
	  proto.utcOffset = getSetOffset;
	  proto.utc = setOffsetToUTC;
	  proto.local = setOffsetToLocal;
	  proto.parseZone = setOffsetToParsedOffset;
	  proto.hasAlignedHourOffset = hasAlignedHourOffset;
	  proto.isDST = isDaylightSavingTime;
	  proto.isLocal = isLocal;
	  proto.isUtcOffset = isUtcOffset;
	  proto.isUtc = isUtc;
	  proto.isUTC = isUtc;
	  proto.zoneAbbr = getZoneAbbr;
	  proto.zoneName = getZoneName;
	  proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	  proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	  proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	  proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	  proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

	  function createUnix(input) {
	    return createLocal(input * 1000);
	  }

	  function createInZone() {
	    return createLocal.apply(null, arguments).parseZone();
	  }

	  function preParsePostFormat(string) {
	    return string;
	  }

	  var proto$1 = Locale.prototype;
	  proto$1.calendar = calendar;
	  proto$1.longDateFormat = longDateFormat;
	  proto$1.invalidDate = invalidDate;
	  proto$1.ordinal = ordinal;
	  proto$1.preparse = preParsePostFormat;
	  proto$1.postformat = preParsePostFormat;
	  proto$1.relativeTime = relativeTime;
	  proto$1.pastFuture = pastFuture;
	  proto$1.set = set;
	  proto$1.eras = localeEras;
	  proto$1.erasParse = localeErasParse;
	  proto$1.erasConvertYear = localeErasConvertYear;
	  proto$1.erasAbbrRegex = erasAbbrRegex;
	  proto$1.erasNameRegex = erasNameRegex;
	  proto$1.erasNarrowRegex = erasNarrowRegex;
	  proto$1.months = localeMonths;
	  proto$1.monthsShort = localeMonthsShort;
	  proto$1.monthsParse = localeMonthsParse;
	  proto$1.monthsRegex = monthsRegex;
	  proto$1.monthsShortRegex = monthsShortRegex;
	  proto$1.week = localeWeek;
	  proto$1.firstDayOfYear = localeFirstDayOfYear;
	  proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	  proto$1.weekdays = localeWeekdays;
	  proto$1.weekdaysMin = localeWeekdaysMin;
	  proto$1.weekdaysShort = localeWeekdaysShort;
	  proto$1.weekdaysParse = localeWeekdaysParse;
	  proto$1.weekdaysRegex = weekdaysRegex;
	  proto$1.weekdaysShortRegex = weekdaysShortRegex;
	  proto$1.weekdaysMinRegex = weekdaysMinRegex;
	  proto$1.isPM = localeIsPM;
	  proto$1.meridiem = localeMeridiem;

	  function get$1(format, index, field, setter) {
	    var locale = getLocale(),
	        utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	  }

	  function listMonthsImpl(format, index, field) {
	    if (isNumber(format)) {
	      index = format;
	      format = undefined;
	    }

	    format = format || '';

	    if (index != null) {
	      return get$1(format, index, field, 'month');
	    }

	    var i,
	        out = [];

	    for (i = 0; i < 12; i++) {
	      out[i] = get$1(format, i, field, 'month');
	    }

	    return out;
	  } // ()
	  // (5)
	  // (fmt, 5)
	  // (fmt)
	  // (true)
	  // (true, 5)
	  // (true, fmt, 5)
	  // (true, fmt)


	  function listWeekdaysImpl(localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	      if (isNumber(format)) {
	        index = format;
	        format = undefined;
	      }

	      format = format || '';
	    } else {
	      format = localeSorted;
	      index = format;
	      localeSorted = false;

	      if (isNumber(format)) {
	        index = format;
	        format = undefined;
	      }

	      format = format || '';
	    }

	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0,
	        i,
	        out = [];

	    if (index != null) {
	      return get$1(format, (index + shift) % 7, field, 'day');
	    }

	    for (i = 0; i < 7; i++) {
	      out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }

	    return out;
	  }

	  function listMonths(format, index) {
	    return listMonthsImpl(format, index, 'months');
	  }

	  function listMonthsShort(format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	  }

	  function listWeekdays(localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	  }

	  function listWeekdaysShort(localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	  }

	  function listWeekdaysMin(localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	  }

	  getSetGlobalLocale('en', {
	    eras: [{
	      since: '0001-01-01',
	      until: +Infinity,
	      offset: 1,
	      name: 'Anno Domini',
	      narrow: 'AD',
	      abbr: 'AD'
	    }, {
	      since: '0000-12-31',
	      until: -Infinity,
	      offset: 1,
	      name: 'Before Christ',
	      narrow: 'BC',
	      abbr: 'BC'
	    }],
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal: function (number) {
	      var b = number % 10,
	          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	      return number + output;
	    }
	  }); // Side effect imports

	  hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	  hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	  var mathAbs = Math.abs;

	  function abs() {
	    var data = this._data;
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days = mathAbs(this._days);
	    this._months = mathAbs(this._months);
	    data.milliseconds = mathAbs(data.milliseconds);
	    data.seconds = mathAbs(data.seconds);
	    data.minutes = mathAbs(data.minutes);
	    data.hours = mathAbs(data.hours);
	    data.months = mathAbs(data.months);
	    data.years = mathAbs(data.years);
	    return this;
	  }

	  function addSubtract$1(duration, input, value, direction) {
	    var other = createDuration(input, value);
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days += direction * other._days;
	    duration._months += direction * other._months;
	    return duration._bubble();
	  } // supports only 2.0-style add(1, 's') or add(duration)


	  function add$1(input, value) {
	    return addSubtract$1(this, input, value, 1);
	  } // supports only 2.0-style subtract(1, 's') or subtract(duration)


	  function subtract$1(input, value) {
	    return addSubtract$1(this, input, value, -1);
	  }

	  function absCeil(number) {
	    if (number < 0) {
	      return Math.floor(number);
	    } else {
	      return Math.ceil(number);
	    }
	  }

	  function bubble() {
	    var milliseconds = this._milliseconds,
	        days = this._days,
	        months = this._months,
	        data = this._data,
	        seconds,
	        minutes,
	        hours,
	        years,
	        monthsFromDays; // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166

	    if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
	      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	      days = 0;
	      months = 0;
	    } // The following code bubbles up values, see the tests for
	    // examples of what that means.


	    data.milliseconds = milliseconds % 1000;
	    seconds = absFloor(milliseconds / 1000);
	    data.seconds = seconds % 60;
	    minutes = absFloor(seconds / 60);
	    data.minutes = minutes % 60;
	    hours = absFloor(minutes / 60);
	    data.hours = hours % 24;
	    days += absFloor(hours / 24); // convert days to months

	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

	    years = absFloor(months / 12);
	    months %= 12;
	    data.days = days;
	    data.months = months;
	    data.years = years;
	    return this;
	  }

	  function daysToMonths(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	  }

	  function monthsToDays(months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	  }

	  function as(units) {
	    if (!this.isValid()) {
	      return NaN;
	    }

	    var days,
	        months,
	        milliseconds = this._milliseconds;
	    units = normalizeUnits(units);

	    if (units === 'month' || units === 'quarter' || units === 'year') {
	      days = this._days + milliseconds / 864e5;
	      months = this._months + daysToMonths(days);

	      switch (units) {
	        case 'month':
	          return months;

	        case 'quarter':
	          return months / 3;

	        case 'year':
	          return months / 12;
	      }
	    } else {
	      // handle milliseconds separately because of floating point math errors (issue #1867)
	      days = this._days + Math.round(monthsToDays(this._months));

	      switch (units) {
	        case 'week':
	          return days / 7 + milliseconds / 6048e5;

	        case 'day':
	          return days + milliseconds / 864e5;

	        case 'hour':
	          return days * 24 + milliseconds / 36e5;

	        case 'minute':
	          return days * 1440 + milliseconds / 6e4;

	        case 'second':
	          return days * 86400 + milliseconds / 1000;
	        // Math.floor prevents floating point math errors here

	        case 'millisecond':
	          return Math.floor(days * 864e5) + milliseconds;

	        default:
	          throw new Error('Unknown unit ' + units);
	      }
	    }
	  } // TODO: Use this.as('ms')?


	  function valueOf$1() {
	    if (!this.isValid()) {
	      return NaN;
	    }

	    return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
	  }

	  function makeAs(alias) {
	    return function () {
	      return this.as(alias);
	    };
	  }

	  var asMilliseconds = makeAs('ms'),
	      asSeconds = makeAs('s'),
	      asMinutes = makeAs('m'),
	      asHours = makeAs('h'),
	      asDays = makeAs('d'),
	      asWeeks = makeAs('w'),
	      asMonths = makeAs('M'),
	      asQuarters = makeAs('Q'),
	      asYears = makeAs('y');

	  function clone$1() {
	    return createDuration(this);
	  }

	  function get$2(units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	  }

	  function makeGetter(name) {
	    return function () {
	      return this.isValid() ? this._data[name] : NaN;
	    };
	  }

	  var milliseconds = makeGetter('milliseconds'),
	      seconds = makeGetter('seconds'),
	      minutes = makeGetter('minutes'),
	      hours = makeGetter('hours'),
	      days = makeGetter('days'),
	      months = makeGetter('months'),
	      years = makeGetter('years');

	  function weeks() {
	    return absFloor(this.days() / 7);
	  }

	  var round = Math.round,
	      thresholds = {
	    ss: 44,
	    // a few seconds to seconds
	    s: 45,
	    // seconds to minute
	    m: 45,
	    // minutes to hour
	    h: 22,
	    // hours to day
	    d: 26,
	    // days to month/week
	    w: null,
	    // weeks to month
	    M: 11 // months to year

	  }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

	  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	  }

	  function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	    var duration = createDuration(posNegDuration).abs(),
	        seconds = round(duration.as('s')),
	        minutes = round(duration.as('m')),
	        hours = round(duration.as('h')),
	        days = round(duration.as('d')),
	        months = round(duration.as('M')),
	        weeks = round(duration.as('w')),
	        years = round(duration.as('y')),
	        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

	    if (thresholds.w != null) {
	      a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
	    }

	    a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	  } // This function allows you to set the rounding function for relative time strings


	  function getSetRelativeTimeRounding(roundingFunction) {
	    if (roundingFunction === undefined) {
	      return round;
	    }

	    if (typeof roundingFunction === 'function') {
	      round = roundingFunction;
	      return true;
	    }

	    return false;
	  } // This function allows you to set a threshold for relative time strings


	  function getSetRelativeTimeThreshold(threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	      return false;
	    }

	    if (limit === undefined) {
	      return thresholds[threshold];
	    }

	    thresholds[threshold] = limit;

	    if (threshold === 's') {
	      thresholds.ss = limit - 1;
	    }

	    return true;
	  }

	  function humanize(argWithSuffix, argThresholds) {
	    if (!this.isValid()) {
	      return this.localeData().invalidDate();
	    }

	    var withSuffix = false,
	        th = thresholds,
	        locale,
	        output;

	    if (typeof argWithSuffix === 'object') {
	      argThresholds = argWithSuffix;
	      argWithSuffix = false;
	    }

	    if (typeof argWithSuffix === 'boolean') {
	      withSuffix = argWithSuffix;
	    }

	    if (typeof argThresholds === 'object') {
	      th = Object.assign({}, thresholds, argThresholds);

	      if (argThresholds.s != null && argThresholds.ss == null) {
	        th.ss = argThresholds.s - 1;
	      }
	    }

	    locale = this.localeData();
	    output = relativeTime$1(this, !withSuffix, th, locale);

	    if (withSuffix) {
	      output = locale.pastFuture(+this, output);
	    }

	    return locale.postformat(output);
	  }

	  var abs$1 = Math.abs;

	  function sign(x) {
	    return (x > 0) - (x < 0) || +x;
	  }

	  function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	      return this.localeData().invalidDate();
	    }

	    var seconds = abs$1(this._milliseconds) / 1000,
	        days = abs$1(this._days),
	        months = abs$1(this._months),
	        minutes,
	        hours,
	        years,
	        s,
	        total = this.asSeconds(),
	        totalSign,
	        ymSign,
	        daysSign,
	        hmsSign;

	    if (!total) {
	      // this is the same as C#'s (Noda) and python (isodate)...
	      // but not other JS (goog.date)
	      return 'P0D';
	    } // 3600 seconds -> 60 minutes -> 1 hour


	    minutes = absFloor(seconds / 60);
	    hours = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60; // 12 months -> 1 year

	    years = absFloor(months / 12);
	    months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

	    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    totalSign = total < 0 ? '-' : '';
	    ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	    return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
	  }

	  var proto$2 = Duration.prototype;
	  proto$2.isValid = isValid$1;
	  proto$2.abs = abs;
	  proto$2.add = add$1;
	  proto$2.subtract = subtract$1;
	  proto$2.as = as;
	  proto$2.asMilliseconds = asMilliseconds;
	  proto$2.asSeconds = asSeconds;
	  proto$2.asMinutes = asMinutes;
	  proto$2.asHours = asHours;
	  proto$2.asDays = asDays;
	  proto$2.asWeeks = asWeeks;
	  proto$2.asMonths = asMonths;
	  proto$2.asQuarters = asQuarters;
	  proto$2.asYears = asYears;
	  proto$2.valueOf = valueOf$1;
	  proto$2._bubble = bubble;
	  proto$2.clone = clone$1;
	  proto$2.get = get$2;
	  proto$2.milliseconds = milliseconds;
	  proto$2.seconds = seconds;
	  proto$2.minutes = minutes;
	  proto$2.hours = hours;
	  proto$2.days = days;
	  proto$2.weeks = weeks;
	  proto$2.months = months;
	  proto$2.years = years;
	  proto$2.humanize = humanize;
	  proto$2.toISOString = toISOString$1;
	  proto$2.toString = toISOString$1;
	  proto$2.toJSON = toISOString$1;
	  proto$2.locale = locale;
	  proto$2.localeData = localeData;
	  proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	  proto$2.lang = lang; // FORMATTING

	  addFormatToken('X', 0, 0, 'unix');
	  addFormatToken('x', 0, 0, 'valueOf'); // PARSING

	  addRegexToken('x', matchSigned);
	  addRegexToken('X', matchTimestamp);
	  addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input) * 1000);
	  });
	  addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	  }); //! moment.js

	  hooks.version = '2.29.1';
	  setHookCallback(createLocal);
	  hooks.fn = proto;
	  hooks.min = min;
	  hooks.max = max;
	  hooks.now = now;
	  hooks.utc = createUTC;
	  hooks.unix = createUnix;
	  hooks.months = listMonths;
	  hooks.isDate = isDate;
	  hooks.locale = getSetGlobalLocale;
	  hooks.invalid = createInvalid;
	  hooks.duration = createDuration;
	  hooks.isMoment = isMoment;
	  hooks.weekdays = listWeekdays;
	  hooks.parseZone = createInZone;
	  hooks.localeData = getLocale;
	  hooks.isDuration = isDuration;
	  hooks.monthsShort = listMonthsShort;
	  hooks.weekdaysMin = listWeekdaysMin;
	  hooks.defineLocale = defineLocale;
	  hooks.updateLocale = updateLocale;
	  hooks.locales = listLocales;
	  hooks.weekdaysShort = listWeekdaysShort;
	  hooks.normalizeUnits = normalizeUnits;
	  hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	  hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	  hooks.calendarFormat = getCalendarFormat;
	  hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

	  hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
	    // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
	    // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
	    // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',
	    // <input type="date" />
	    TIME: 'HH:mm',
	    // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',
	    // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',
	    // <input type="time" step="0.001" />
	    WEEK: 'GGGG-[W]WW',
	    // <input type="week" />
	    MONTH: 'YYYY-MM' // <input type="month" />

	  };
	  return hooks;
	});
	});

	var fi = createCommonjsModule(function (module, exports) {

	(function (global, factory) {
	   typeof commonjsRequire === 'function' ? factory(moment) :  factory(global.moment);
	})(commonjsGlobal, function (moment) {

	  var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	      numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];

	  function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';

	    switch (key) {
	      case 's':
	        return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';

	      case 'ss':
	        result = isFuture ? 'sekunnin' : 'sekuntia';
	        break;

	      case 'm':
	        return isFuture ? 'minuutin' : 'minuutti';

	      case 'mm':
	        result = isFuture ? 'minuutin' : 'minuuttia';
	        break;

	      case 'h':
	        return isFuture ? 'tunnin' : 'tunti';

	      case 'hh':
	        result = isFuture ? 'tunnin' : 'tuntia';
	        break;

	      case 'd':
	        return isFuture ? 'päivän' : 'päivä';

	      case 'dd':
	        result = isFuture ? 'päivän' : 'päivää';
	        break;

	      case 'M':
	        return isFuture ? 'kuukauden' : 'kuukausi';

	      case 'MM':
	        result = isFuture ? 'kuukauden' : 'kuukautta';
	        break;

	      case 'y':
	        return isFuture ? 'vuoden' : 'vuosi';

	      case 'yy':
	        result = isFuture ? 'vuoden' : 'vuotta';
	        break;
	    }

	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	  }

	  function verbalNumber(number, isFuture) {
	    return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
	  }

	  var fi = moment.defineLocale('fi', {
	    months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat: {
	      LT: 'HH.mm',
	      LTS: 'HH.mm.ss',
	      L: 'DD.MM.YYYY',
	      LL: 'Do MMMM[ta] YYYY',
	      LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	      LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	      l: 'D.M.YYYY',
	      ll: 'Do MMM YYYY',
	      lll: 'Do MMM YYYY, [klo] HH.mm',
	      llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar: {
	      sameDay: '[tänään] [klo] LT',
	      nextDay: '[huomenna] [klo] LT',
	      nextWeek: 'dddd [klo] LT',
	      lastDay: '[eilen] [klo] LT',
	      lastWeek: '[viime] dddd[na] [klo] LT',
	      sameElse: 'L'
	    },
	    relativeTime: {
	      future: '%s päästä',
	      past: '%s sitten',
	      s: translate,
	      ss: translate,
	      m: translate,
	      mm: translate,
	      h: translate,
	      hh: translate,
	      d: translate,
	      dd: translate,
	      M: translate,
	      MM: translate,
	      y: translate,
	      yy: translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	      dow: 1,
	      // Monday is the first day of the week.
	      doy: 4 // The week that contains Jan 4th is the first week of the year.

	    }
	  });
	  return fi;
	});
	});

	var sv = createCommonjsModule(function (module, exports) {

	(function (global, factory) {
	   typeof commonjsRequire === 'function' ? factory(moment) :  factory(global.moment);
	})(commonjsGlobal, function (moment) {

	  var sv = moment.defineLocale('sv', {
	    months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat: {
	      LT: 'HH:mm',
	      LTS: 'HH:mm:ss',
	      L: 'YYYY-MM-DD',
	      LL: 'D MMMM YYYY',
	      LLL: 'D MMMM YYYY [kl.] HH:mm',
	      LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	      lll: 'D MMM YYYY HH:mm',
	      llll: 'ddd D MMM YYYY HH:mm'
	    },
	    calendar: {
	      sameDay: '[Idag] LT',
	      nextDay: '[Imorgon] LT',
	      lastDay: '[Igår] LT',
	      nextWeek: '[På] dddd LT',
	      lastWeek: '[I] dddd[s] LT',
	      sameElse: 'L'
	    },
	    relativeTime: {
	      future: 'om %s',
	      past: 'för %s sedan',
	      s: 'några sekunder',
	      ss: '%d sekunder',
	      m: 'en minut',
	      mm: '%d minuter',
	      h: 'en timme',
	      hh: '%d timmar',
	      d: 'en dag',
	      dd: '%d dagar',
	      M: 'en månad',
	      MM: '%d månader',
	      y: 'ett år',
	      yy: '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	    ordinal: function (number) {
	      var b = number % 10,
	          output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
	      return number + output;
	    },
	    week: {
	      dow: 1,
	      // Monday is the first day of the week.
	      doy: 4 // The week that contains Jan 4th is the first week of the year.

	    }
	  });
	  return sv;
	});
	});

	var formatDay_1 = formatDay;
	var formatMonthTitle_1 = formatMonthTitle;
	var formatWeekdayShort_1 = formatWeekdayShort;
	var formatWeekdayLong_1 = formatWeekdayLong;
	var getFirstDayOfWeek_1 = getFirstDayOfWeek;
	var getMonths_1 = getMonths;
	var formatDate_1 = formatDate;
	var parseDate_1 = parseDate;



	var _moment2 = _interopRequireDefault$1(moment);

	function _interopRequireDefault$1(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function formatDay(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	  return (0, _moment2.default)(day).locale(locale).format('ddd ll');
	}
	/* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */


	function formatMonthTitle(date) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	  return (0, _moment2.default)(date).locale(locale).format('MMMM YYYY');
	}

	function formatWeekdayShort(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	  return (0, _moment2.default)().locale(locale)._locale.weekdaysMin()[day];
	}

	function formatWeekdayLong(day) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	  return (0, _moment2.default)().locale(locale)._locale.weekdays()[day];
	}

	function getFirstDayOfWeek() {
	  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

	  var localeData = _moment2.default.localeData(locale);

	  return localeData.firstDayOfWeek();
	}

	function getMonths() {
	  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	  var months = [];
	  var i = 0;

	  while (i < 12) {
	    months.push((0, _moment2.default)().locale(locale).month(i).format('MMMM'));
	    i += 1;
	  }

	  return months;
	}

	function formatDate(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
	  return (0, _moment2.default)(date).locale(locale).format(Array.isArray(format) ? format[0] : format);
	}

	function parseDate(str) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
	  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
	  var m = (0, _moment2.default)(str, format, locale, true);

	  if (m.isValid()) {
	    return m.toDate();
	  }

	  return undefined;
	}

	var _default$1 = {
	  formatDay: formatDay,
	  formatMonthTitle: formatMonthTitle,
	  formatWeekdayShort: formatWeekdayShort,
	  formatWeekdayLong: formatWeekdayLong,
	  getFirstDayOfWeek: getFirstDayOfWeek,
	  getMonths: getMonths,
	  formatDate: formatDate,
	  parseDate: parseDate
	};

	var MomentLocaleUtils = /*#__PURE__*/Object.defineProperty({
		formatDay: formatDay_1,
		formatMonthTitle: formatMonthTitle_1,
		formatWeekdayShort: formatWeekdayShort_1,
		formatWeekdayLong: formatWeekdayLong_1,
		getFirstDayOfWeek: getFirstDayOfWeek_1,
		getMonths: getMonths_1,
		formatDate: formatDate_1,
		parseDate: parseDate_1,
		default: _default$1
	}, '__esModule', {value: true});

	/* eslint-env node */

	var moment$1 = MomentLocaleUtils;
	var localeUtils = MomentLocaleUtils;
	moment$1.localeUtils = localeUtils;

	var formatDay_1$1 = formatDay$1;
	var formatMonthTitle_1$1 = formatMonthTitle$1;
	var formatWeekdayShort_1$1 = formatWeekdayShort$1;
	var formatWeekdayLong_1$1 = formatWeekdayLong$1;
	var getFirstDayOfWeek_1$1 = getFirstDayOfWeek$1;
	var getMonths_1$1 = getMonths$1;
	var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

	function formatDay$1(day) {
	  return day.toDateString();
	}

	function formatMonthTitle$1(d) {
	  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
	}

	function formatWeekdayShort$1(i) {
	  return WEEKDAYS_SHORT[i];
	}

	function formatWeekdayLong$1(i) {
	  return WEEKDAYS_LONG[i];
	}

	function getFirstDayOfWeek$1() {
	  return 0;
	}

	function getMonths$1() {
	  return MONTHS;
	}

	var _default$2 = {
	  formatDay: formatDay$1,
	  formatMonthTitle: formatMonthTitle$1,
	  formatWeekdayShort: formatWeekdayShort$1,
	  formatWeekdayLong: formatWeekdayLong$1,
	  getFirstDayOfWeek: getFirstDayOfWeek$1,
	  getMonths: getMonths$1
	};

	var LocaleUtils = /*#__PURE__*/Object.defineProperty({
		formatDay: formatDay_1$1,
		formatMonthTitle: formatMonthTitle_1$1,
		formatWeekdayShort: formatWeekdayShort_1$1,
		formatWeekdayLong: formatWeekdayLong_1$1,
		getFirstDayOfWeek: getFirstDayOfWeek_1$1,
		getMonths: getMonths_1$1,
		default: _default$2
	}, '__esModule', {value: true});

	var keys$9 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LEFT = exports.LEFT = 37;
	var UP = exports.UP = 38;
	var RIGHT = exports.RIGHT = 39;
	var DOWN = exports.DOWN = 40;
	var ENTER = exports.ENTER = 13;
	var SPACE = exports.SPACE = 32;
	var ESC = exports.ESC = 27;
	var TAB = exports.TAB = 9;
	});

	var _createClass$1 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2$1 = _interopRequireDefault$2(React__default['default']);



	var _propTypes2$1 = _interopRequireDefault$2(propTypes);



	var _LocaleUtils2 = _interopRequireDefault$2(LocaleUtils);



	function _interopRequireDefault$2(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck$1(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn$1(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits$1(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var Caption = function (_Component) {
	  _inherits$1(Caption, _Component);

	  function Caption(props) {
	    _classCallCheck$1(this, Caption);

	    var _this = _possibleConstructorReturn$1(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

	    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
	    return _this;
	  }

	  _createClass$1(Caption, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(e) {
	      if (e.keyCode === keys$9.ENTER) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          date = _props.date,
	          months = _props.months,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          onClick = _props.onClick;
	      return _react2$1.default.createElement('div', {
	        className: classNames.caption,
	        role: 'heading'
	      }, _react2$1.default.createElement('div', {
	        onClick: onClick,
	        onKeyUp: this.handleKeyUp
	      }, months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
	    }
	  }]);

	  return Caption;
	}(React__default['default'].Component);

	Caption.propTypes = {
	  date: _propTypes2$1.default.instanceOf(Date),
	  months: _propTypes2$1.default.arrayOf(_propTypes2$1.default.string),
	  locale: _propTypes2$1.default.string,
	  localeUtils: _propTypes2$1.default.object,
	  onClick: _propTypes2$1.default.func,
	  classNames: _propTypes2$1.default.shape({
	    caption: _propTypes2$1.default.string.isRequired
	  }).isRequired
	};
	Caption.defaultProps = {
	  localeUtils: _LocaleUtils2.default
	};
	var _default$3 = Caption;

	var Caption_1 = /*#__PURE__*/Object.defineProperty({
		default: _default$3
	}, '__esModule', {value: true});

	// Proxy object to map classnames when css modules are not used

	var _default$4 = {
	  container: 'DayPicker',
	  wrapper: 'DayPicker-wrapper',
	  interactionDisabled: 'DayPicker--interactionDisabled',
	  months: 'DayPicker-Months',
	  month: 'DayPicker-Month',
	  navBar: 'DayPicker-NavBar',
	  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
	  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
	  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
	  caption: 'DayPicker-Caption',
	  weekdays: 'DayPicker-Weekdays',
	  weekdaysRow: 'DayPicker-WeekdaysRow',
	  weekday: 'DayPicker-Weekday',
	  body: 'DayPicker-Body',
	  week: 'DayPicker-Week',
	  weekNumber: 'DayPicker-WeekNumber',
	  day: 'DayPicker-Day',
	  footer: 'DayPicker-Footer',
	  todayButton: 'DayPicker-TodayButton',
	  // default modifiers
	  today: 'today',
	  selected: 'selected',
	  disabled: 'disabled',
	  outside: 'outside'
	};

	var classNames = /*#__PURE__*/Object.defineProperty({
		default: _default$4
	}, '__esModule', {value: true});

	var _createClass$2 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2$2 = _interopRequireDefault$3(React__default['default']);



	var _propTypes2$2 = _interopRequireDefault$3(propTypes);



	var _classNames2 = _interopRequireDefault$3(classNames);



	function _interopRequireDefault$3(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck$2(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn$2(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits$2(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var Navbar = function (_Component) {
	  _inherits$2(Navbar, _Component);

	  function Navbar() {
	    var _ref;

	    var _temp, _this, _ret;

	    _classCallCheck$2(this, Navbar);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn$2(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
	      if (_this.props.onNextClick) {
	        _this.props.onNextClick();
	      }
	    }, _this.handlePreviousClick = function () {
	      if (_this.props.onPreviousClick) {
	        _this.props.onPreviousClick();
	      }
	    }, _this.handleNextKeyDown = function (e) {
	      if (e.keyCode !== keys$9.ENTER && e.keyCode !== keys$9.SPACE) {
	        return;
	      }

	      e.preventDefault();

	      _this.handleNextClick();
	    }, _this.handlePreviousKeyDown = function (e) {
	      if (e.keyCode !== keys$9.ENTER && e.keyCode !== keys$9.SPACE) {
	        return;
	      }

	      e.preventDefault();

	      _this.handlePreviousClick();
	    }, _temp), _possibleConstructorReturn$2(_this, _ret);
	  }

	  _createClass$2(Navbar, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          className = _props.className,
	          showPreviousButton = _props.showPreviousButton,
	          showNextButton = _props.showNextButton,
	          labels = _props.labels,
	          dir = _props.dir;
	      var previousClickHandler = void 0;
	      var nextClickHandler = void 0;
	      var previousKeyDownHandler = void 0;
	      var nextKeyDownHandler = void 0;
	      var shouldShowPrevious = void 0;
	      var shouldShowNext = void 0;

	      if (dir === 'rtl') {
	        previousClickHandler = this.handleNextClick;
	        nextClickHandler = this.handlePreviousClick;
	        previousKeyDownHandler = this.handleNextKeyDown;
	        nextKeyDownHandler = this.handlePreviousKeyDown;
	        shouldShowNext = showPreviousButton;
	        shouldShowPrevious = showNextButton;
	      } else {
	        previousClickHandler = this.handlePreviousClick;
	        nextClickHandler = this.handleNextClick;
	        previousKeyDownHandler = this.handlePreviousKeyDown;
	        nextKeyDownHandler = this.handleNextKeyDown;
	        shouldShowNext = showNextButton;
	        shouldShowPrevious = showPreviousButton;
	      }

	      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;
	      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

	      var previousButton = _react2$2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.previousMonth,
	        key: 'previous',
	        className: previousClassName,
	        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
	        onClick: shouldShowPrevious ? previousClickHandler : undefined
	      });

	      var nextButton = _react2$2.default.createElement('span', {
	        tabIndex: '0',
	        role: 'button',
	        'aria-label': labels.nextMonth,
	        key: 'right',
	        className: nextClassName,
	        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
	        onClick: shouldShowNext ? nextClickHandler : undefined
	      });

	      return _react2$2.default.createElement('div', {
	        className: className || classNames.navBar
	      }, dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]);
	    }
	  }]);

	  return Navbar;
	}(React__default['default'].Component);

	Navbar.propTypes = {
	  classNames: _propTypes2$2.default.shape({
	    navBar: _propTypes2$2.default.string.isRequired,
	    navButtonPrev: _propTypes2$2.default.string.isRequired,
	    navButtonNext: _propTypes2$2.default.string.isRequired,
	    navButtonInteractionDisabled: _propTypes2$2.default.string.isRequired
	  }),
	  className: _propTypes2$2.default.string,
	  showPreviousButton: _propTypes2$2.default.bool,
	  showNextButton: _propTypes2$2.default.bool,
	  onPreviousClick: _propTypes2$2.default.func,
	  onNextClick: _propTypes2$2.default.func,
	  dir: _propTypes2$2.default.string,
	  labels: _propTypes2$2.default.shape({
	    previousMonth: _propTypes2$2.default.string.isRequired,
	    nextMonth: _propTypes2$2.default.string.isRequired
	  })
	};
	Navbar.defaultProps = {
	  classNames: _classNames2.default,
	  dir: 'ltr',
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  showPreviousButton: true,
	  showNextButton: true
	};
	var _default$5 = Navbar;

	var Navbar_1 = /*#__PURE__*/Object.defineProperty({
		default: _default$5
	}, '__esModule', {value: true});

	var _createClass$3 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2$3 = _interopRequireDefault$4(React__default['default']);



	var _propTypes2$3 = _interopRequireDefault$4(propTypes);

	function _interopRequireDefault$4(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck$3(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn$3(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits$3(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var Weekdays = function (_Component) {
	  _inherits$3(Weekdays, _Component);

	  function Weekdays() {
	    _classCallCheck$3(this, Weekdays);

	    return _possibleConstructorReturn$3(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
	  }

	  _createClass$3(Weekdays, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          showWeekNumbers = _props.showWeekNumbers,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdayElement = _props.weekdayElement;
	      var days = [];

	      for (var i = 0; i < 7; i += 1) {
	        var weekday = (i + firstDayOfWeek) % 7;
	        var elementProps = {
	          key: i,
	          className: classNames.weekday,
	          weekday: weekday,
	          weekdaysLong: weekdaysLong,
	          weekdaysShort: weekdaysShort,
	          localeUtils: localeUtils,
	          locale: locale
	        };
	        var element = _react2$3.default.isValidElement(weekdayElement) ? _react2$3.default.cloneElement(weekdayElement, elementProps) : _react2$3.default.createElement(weekdayElement, elementProps);
	        days.push(element);
	      }

	      return _react2$3.default.createElement('div', {
	        className: classNames.weekdays,
	        role: 'rowgroup'
	      }, _react2$3.default.createElement('div', {
	        className: classNames.weekdaysRow,
	        role: 'row'
	      }, showWeekNumbers && _react2$3.default.createElement('div', {
	        className: classNames.weekday
	      }), days));
	    }
	  }]);

	  return Weekdays;
	}(React__default['default'].Component);

	Weekdays.propTypes = {
	  classNames: _propTypes2$3.default.shape({
	    weekday: _propTypes2$3.default.string.isRequired,
	    weekdays: _propTypes2$3.default.string.isRequired,
	    weekdaysRow: _propTypes2$3.default.string.isRequired
	  }).isRequired,
	  firstDayOfWeek: _propTypes2$3.default.number.isRequired,
	  weekdaysLong: _propTypes2$3.default.arrayOf(_propTypes2$3.default.string),
	  weekdaysShort: _propTypes2$3.default.arrayOf(_propTypes2$3.default.string),
	  showWeekNumbers: _propTypes2$3.default.bool,
	  locale: _propTypes2$3.default.string.isRequired,
	  localeUtils: _propTypes2$3.default.object.isRequired,
	  weekdayElement: _propTypes2$3.default.oneOfType([_propTypes2$3.default.element, _propTypes2$3.default.func, _propTypes2$3.default.instanceOf(_react2$3.default.Component)])
	};
	var _default$6 = Weekdays;

	var Weekdays_1 = /*#__PURE__*/Object.defineProperty({
		default: _default$6
	}, '__esModule', {value: true});

	var clone_1$1 = clone$1;
	var isDate_1 = isDate;
	var addMonths_1 = addMonths;
	var isSameDay_1 = isSameDay;
	var isSameMonth_1 = isSameMonth;
	var isDayBefore_1 = isDayBefore;
	var isDayAfter_1 = isDayAfter;
	var isPastDay_1 = isPastDay;
	var isFutureDay_1 = isFutureDay;
	var isDayBetween_1 = isDayBetween;
	var addDayToRange_1 = addDayToRange;
	var isDayInRange_1 = isDayInRange;
	var getWeekNumber_1 = getWeekNumber;
	/**
	 * Clone a date object.
	 *
	 * @export
	 * @param  {Date} d The date to clone
	 * @return {Date} The cloned date
	 */

	function clone$1(d) {
	  return new Date(d.getTime());
	}
	/**
	 * Return `true` if the passed value is a valid JavaScript Date object.
	 *
	 * @export
	 * @param {any} value
	 * @returns {Boolean}
	 */


	function isDate(value) {
	  return value instanceof Date && !isNaN(value.valueOf());
	}
	/**
	 * Return `d` as a new date with `n` months added.
	 *
	 * @export
	 * @param {Date} d
	 * @param {number} n
	 */


	function addMonths(d, n) {
	  var newDate = clone$1(d);
	  newDate.setMonth(d.getMonth() + n);
	  return newDate;
	}
	/**
	 * Return `true` if two dates are the same day, ignoring the time.
	 *
	 * @export
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */


	function isSameDay(d1, d2) {
	  if (!d1 || !d2) {
	    return false;
	  }

	  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	}
	/**
	 * Return `true` if two dates fall in the same month.
	 *
	 * @export
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */


	function isSameMonth(d1, d2) {
	  if (!d1 || !d2) {
	    return false;
	  }

	  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
	}
	/**
	 * Returns `true` if the first day is before the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */


	function isDayBefore(d1, d2) {
	  var day1 = clone$1(d1).setHours(0, 0, 0, 0);
	  var day2 = clone$1(d2).setHours(0, 0, 0, 0);
	  return day1 < day2;
	}
	/**
	 * Returns `true` if the first day is after the second day.
	 *
	 * @export
	 * @param {Date} d1
	 * @param {Date} d2
	 * @returns {Boolean}
	 */


	function isDayAfter(d1, d2) {
	  var day1 = clone$1(d1).setHours(0, 0, 0, 0);
	  var day2 = clone$1(d2).setHours(0, 0, 0, 0);
	  return day1 > day2;
	}
	/**
	 * Return `true` if a day is in the past, e.g. yesterday or any day
	 * before yesterday.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */


	function isPastDay(d) {
	  var today = new Date();
	  today.setHours(0, 0, 0, 0);
	  return isDayBefore(d, today);
	}
	/**
	 * Return `true` if a day is in the future, e.g. tomorrow or any day
	 * after tomorrow.
	 *
	 * @export
	 * @param  {Date}  d
	 * @return {Boolean}
	 */


	function isFutureDay(d) {
	  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	  tomorrow.setHours(0, 0, 0, 0);
	  return d >= tomorrow;
	}
	/**
	 * Return `true` if day `d` is between days `d1` and `d2`,
	 * without including them.
	 *
	 * @export
	 * @param  {Date}  d
	 * @param  {Date}  d1
	 * @param  {Date}  d2
	 * @return {Boolean}
	 */


	function isDayBetween(d, d1, d2) {
	  var date = clone$1(d);
	  date.setHours(0, 0, 0, 0);
	  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
	}
	/**
	 * Add a day to a range and return a new range. A range is an object with
	 * `from` and `to` days.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} range
	 * @return {Object} Returns a new range object
	 */


	function addDayToRange(day) {
	  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    from: null,
	    to: null
	  };
	  var from = range.from,
	      to = range.to;

	  if (!from) {
	    from = day;
	  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
	    from = null;
	    to = null;
	  } else if (to && isDayBefore(day, from)) {
	    from = day;
	  } else if (to && isSameDay(day, to)) {
	    from = day;
	    to = day;
	  } else {
	    to = day;

	    if (isDayBefore(to, from)) {
	      to = from;
	      from = day;
	    }
	  }

	  return {
	    from: from,
	    to: to
	  };
	}
	/**
	 * Return `true` if a day is included in a range of days.
	 *
	 * @export
	 * @param  {Date}  day
	 * @param  {Object}  range
	 * @return {Boolean}
	 */


	function isDayInRange(day, range) {
	  var from = range.from,
	      to = range.to;
	  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
	}
	/**
	 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
	 * for the given day.
	 *
	 * @export
	 * @param {Date} day
	 * @returns {Number}
	 */


	function getWeekNumber(day) {
	  var date = clone$1(day);
	  date.setHours(0, 0, 0);
	  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
	  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
	}

	var _default$7 = {
	  addDayToRange: addDayToRange,
	  addMonths: addMonths,
	  clone: clone$1,
	  getWeekNumber: getWeekNumber,
	  isDate: isDate,
	  isDayAfter: isDayAfter,
	  isDayBefore: isDayBefore,
	  isDayBetween: isDayBetween,
	  isDayInRange: isDayInRange,
	  isFutureDay: isFutureDay,
	  isPastDay: isPastDay,
	  isSameDay: isSameDay,
	  isSameMonth: isSameMonth
	};

	var DateUtils = /*#__PURE__*/Object.defineProperty({
		clone: clone_1$1,
		isDate: isDate_1,
		addMonths: addMonths_1,
		isSameDay: isSameDay_1,
		isSameMonth: isSameMonth_1,
		isDayBefore: isDayBefore_1,
		isDayAfter: isDayAfter_1,
		isPastDay: isPastDay_1,
		isFutureDay: isFutureDay_1,
		isDayBetween: isDayBetween_1,
		addDayToRange: addDayToRange_1,
		isDayInRange: isDayInRange_1,
		getWeekNumber: getWeekNumber_1,
		default: _default$7
	}, '__esModule', {value: true});

	var _extends$4n = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var cancelEvent_1 = cancelEvent;
	var getFirstDayOfMonth_1 = getFirstDayOfMonth;
	var getDaysInMonth_1 = getDaysInMonth;
	var getModifiersFromProps_1 = getModifiersFromProps;
	var getFirstDayOfWeekFromProps_1 = getFirstDayOfWeekFromProps;
	var isRangeOfDates_1 = isRangeOfDates;
	var getMonthsDiff_1 = getMonthsDiff;
	var getWeekArray_1 = getWeekArray;
	var startOfMonth_1 = startOfMonth;
	var getDayNodes_1 = getDayNodes;
	var nodeListToArray_1 = nodeListToArray;
	var hasOwnProp_1 = hasOwnProp;







	var _classNames2$1 = _interopRequireDefault$5(classNames);

	function _interopRequireDefault$5(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function cancelEvent(e) {
	  e.preventDefault();
	  e.stopPropagation();
	}

	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
	}

	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	  return resultDate.getDate();
	}

	function getModifiersFromProps(props) {
	  var modifiers = _extends$4n({}, props.modifiers);

	  if (props.selectedDays) {
	    modifiers[props.classNames.selected] = props.selectedDays;
	  }

	  if (props.disabledDays) {
	    modifiers[props.classNames.disabled] = props.disabledDays;
	  }

	  return modifiers;
	}

	function getFirstDayOfWeekFromProps(props) {
	  var firstDayOfWeek = props.firstDayOfWeek,
	      _props$locale = props.locale,
	      locale = _props$locale === undefined ? 'en' : _props$locale,
	      _props$localeUtils = props.localeUtils,
	      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

	  if (!isNaN(firstDayOfWeek)) {
	    return firstDayOfWeek;
	  }

	  if (localeUtils.getFirstDayOfWeek) {
	    return localeUtils.getFirstDayOfWeek(locale);
	  }

	  return 0;
	}

	function isRangeOfDates(value) {
	  return !!(value && value.from && value.to);
	}

	function getMonthsDiff(d1, d2) {
	  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
	}

	function getWeekArray(d) {
	  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, LocaleUtils.getFirstDayOfWeek)();
	  var fixedWeeks = arguments[2];
	  var daysInMonth = getDaysInMonth(d);
	  var dayArray = [];
	  var week = [];
	  var weekArray = [];

	  for (var i = 1; i <= daysInMonth; i += 1) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
	  }

	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      weekArray.push(week);
	      week = [];
	    }

	    week.push(day);

	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      weekArray.push(week);
	    }
	  }); // unshift days to start the first week

	  var firstWeek = weekArray[0];

	  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
	    var outsideDate = (0, DateUtils.clone)(firstWeek[0]);
	    outsideDate.setDate(firstWeek[0].getDate() - 1);
	    firstWeek.unshift(outsideDate);
	  } // push days until the end of the last week


	  var lastWeek = weekArray[weekArray.length - 1];

	  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
	    var _outsideDate = (0, DateUtils.clone)(lastWeek[lastWeek.length - 1]);

	    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);

	    lastWeek.push(_outsideDate);
	  } // add extra weeks to reach 6 weeks


	  if (fixedWeeks && weekArray.length < 6) {
	    var lastExtraWeek = void 0;

	    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
	      lastExtraWeek = weekArray[weekArray.length - 1];
	      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
	      var extraWeek = [];

	      for (var j = 0; j < 7; j += 1) {
	        var _outsideDate2 = (0, DateUtils.clone)(lastDay);

	        _outsideDate2.setDate(lastDay.getDate() + j + 1);

	        extraWeek.push(_outsideDate2);
	      }

	      weekArray.push(extraWeek);
	    }
	  }

	  return weekArray;
	}

	function startOfMonth(d) {
	  var newDate = (0, DateUtils.clone)(d);
	  newDate.setDate(1);
	  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues

	  return newDate;
	}

	function getDayNodes(node, classNames) {
	  var outsideClassName = void 0;

	  if (classNames === _classNames2$1.default) {
	    // When using CSS modules prefix the modifier as required by the BEM syntax
	    outsideClassName = classNames.day + '--' + classNames.outside;
	  } else {
	    outsideClassName = '' + classNames.outside;
	  }

	  var dayQuery = classNames.day.replace(/ /g, '.');
	  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
	  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
	  return node.querySelectorAll(selector);
	}

	function nodeListToArray(nodeList) {
	  return Array.prototype.slice.call(nodeList, 0);
	}

	function hasOwnProp(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	var Helpers = /*#__PURE__*/Object.defineProperty({
		cancelEvent: cancelEvent_1,
		getFirstDayOfMonth: getFirstDayOfMonth_1,
		getDaysInMonth: getDaysInMonth_1,
		getModifiersFromProps: getModifiersFromProps_1,
		getFirstDayOfWeekFromProps: getFirstDayOfWeekFromProps_1,
		isRangeOfDates: isRangeOfDates_1,
		getMonthsDiff: getMonthsDiff_1,
		getWeekArray: getWeekArray_1,
		startOfMonth: startOfMonth_1,
		getDayNodes: getDayNodes_1,
		nodeListToArray: nodeListToArray_1,
		hasOwnProp: hasOwnProp_1
	}, '__esModule', {value: true});

	var _extends$4o = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var _createClass$4 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2$4 = _interopRequireDefault$6(React__default['default']);



	var _propTypes2$4 = _interopRequireDefault$6(propTypes);







	var _classNames2$2 = _interopRequireDefault$6(classNames);

	function _interopRequireDefault$6(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck$4(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn$4(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits$4(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	/* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */


	function handleEvent(handler, day, modifiers) {
	  if (!handler) {
	    return undefined;
	  }

	  return function (e) {
	    e.persist();
	    handler(day, modifiers, e);
	  };
	}

	var Day = function (_Component) {
	  _inherits$4(Day, _Component);

	  function Day() {
	    _classCallCheck$4(this, Day);

	    return _possibleConstructorReturn$4(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
	  }

	  _createClass$4(Day, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;

	      var propNames = Object.keys(this.props);
	      var nextPropNames = Object.keys(nextProps);

	      if (propNames.length !== nextPropNames.length) {
	        return true;
	      }

	      return propNames.some(function (name) {
	        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
	          var prop = _this2.props[name];
	          var nextProp = nextProps[name];
	          var modifiers = Object.keys(prop);
	          var nextModifiers = Object.keys(nextProp);

	          if (modifiers.length !== nextModifiers.length) {
	            return true;
	          }

	          return modifiers.some(function (mod) {
	            return !(0, Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
	          });
	        }

	        if (name === 'day') {
	          return !(0, DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
	        }

	        return !(0, Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classNames = _props.classNames,
	          modifiersStyles = _props.modifiersStyles,
	          day = _props.day,
	          tabIndex = _props.tabIndex,
	          empty = _props.empty,
	          modifiers = _props.modifiers,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onClick = _props.onClick,
	          onKeyDown = _props.onKeyDown,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onFocus = _props.onFocus,
	          ariaLabel = _props.ariaLabel,
	          ariaDisabled = _props.ariaDisabled,
	          ariaSelected = _props.ariaSelected,
	          children = _props.children;
	      var className = classNames.day;

	      if (classNames !== _classNames2$2.default) {
	        // When using CSS modules prefix the modifier as required by the BEM syntax
	        className += ' ' + Object.keys(modifiers).join(' ');
	      } else {
	        className += Object.keys(modifiers).map(function (modifier) {
	          return ' ' + className + '--' + modifier;
	        }).join('');
	      }

	      var style = void 0;

	      if (modifiersStyles) {
	        Object.keys(modifiers).filter(function (modifier) {
	          return !!modifiersStyles[modifier];
	        }).forEach(function (modifier) {
	          style = _extends$4o({}, style, modifiersStyles[modifier]);
	        });
	      }

	      if (empty) {
	        return _react2$4.default.createElement('div', {
	          'aria-disabled': true,
	          className: className,
	          style: style
	        });
	      }

	      return _react2$4.default.createElement('div', {
	        className: className,
	        tabIndex: tabIndex,
	        style: style,
	        role: 'gridcell',
	        'aria-label': ariaLabel,
	        'aria-disabled': ariaDisabled,
	        'aria-selected': ariaSelected,
	        onClick: handleEvent(onClick, day, modifiers),
	        onKeyDown: handleEvent(onKeyDown, day, modifiers),
	        onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
	        onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
	        onMouseUp: handleEvent(onMouseUp, day, modifiers),
	        onMouseDown: handleEvent(onMouseDown, day, modifiers),
	        onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
	        onTouchStart: handleEvent(onTouchStart, day, modifiers),
	        onFocus: handleEvent(onFocus, day, modifiers)
	      }, children);
	    }
	  }]);

	  return Day;
	}(React__default['default'].Component);

	Day.propTypes = {
	  classNames: _propTypes2$4.default.shape({
	    day: _propTypes2$4.default.string.isRequired
	  }).isRequired,
	  day: _propTypes2$4.default.instanceOf(Date).isRequired,
	  children: _propTypes2$4.default.node.isRequired,
	  ariaDisabled: _propTypes2$4.default.bool,
	  ariaLabel: _propTypes2$4.default.string,
	  ariaSelected: _propTypes2$4.default.bool,
	  empty: _propTypes2$4.default.bool,
	  modifiers: _propTypes2$4.default.object,
	  modifiersStyles: _propTypes2$4.default.object,
	  onClick: _propTypes2$4.default.func,
	  onKeyDown: _propTypes2$4.default.func,
	  onMouseEnter: _propTypes2$4.default.func,
	  onMouseLeave: _propTypes2$4.default.func,
	  onMouseDown: _propTypes2$4.default.func,
	  onMouseUp: _propTypes2$4.default.func,
	  onTouchEnd: _propTypes2$4.default.func,
	  onTouchStart: _propTypes2$4.default.func,
	  onFocus: _propTypes2$4.default.func,
	  tabIndex: _propTypes2$4.default.number
	};
	Day.defaultProps = {
	  tabIndex: -1
	};
	Day.defaultProps = {
	  modifiers: {},
	  modifiersStyles: {},
	  empty: false
	};
	var _default$8 = Day;

	var Day_1 = /*#__PURE__*/Object.defineProperty({
		default: _default$8
	}, '__esModule', {value: true});

	var dayMatchesModifier_1 = dayMatchesModifier;
	var getModifiersForDay_1 = getModifiersForDay;




	/**
	 * Return `true` if a date matches the specified modifier.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Any} modifier
	 * @return {Boolean}
	 */


	function dayMatchesModifier(day, modifier) {
	  if (!modifier) {
	    return false;
	  }

	  var arr = Array.isArray(modifier) ? modifier : [modifier];
	  return arr.some(function (mod) {
	    if (!mod) {
	      return false;
	    }

	    if (mod instanceof Date) {
	      return (0, DateUtils.isSameDay)(day, mod);
	    }

	    if ((0, Helpers.isRangeOfDates)(mod)) {
	      return (0, DateUtils.isDayInRange)(day, mod);
	    }

	    if (mod.after && mod.before && (0, DateUtils.isDayAfter)(mod.before, mod.after)) {
	      return (0, DateUtils.isDayAfter)(day, mod.after) && (0, DateUtils.isDayBefore)(day, mod.before);
	    }

	    if (mod.after && mod.before && ((0, DateUtils.isDayAfter)(mod.after, mod.before) || (0, DateUtils.isSameDay)(mod.after, mod.before))) {
	      return (0, DateUtils.isDayAfter)(day, mod.after) || (0, DateUtils.isDayBefore)(day, mod.before);
	    }

	    if (mod.after) {
	      return (0, DateUtils.isDayAfter)(day, mod.after);
	    }

	    if (mod.before) {
	      return (0, DateUtils.isDayBefore)(day, mod.before);
	    }

	    if (mod.daysOfWeek) {
	      return mod.daysOfWeek.some(function (dayOfWeek) {
	        return day.getDay() === dayOfWeek;
	      });
	    }

	    if (typeof mod === 'function') {
	      return mod(day);
	    }

	    return false;
	  });
	}
	/**
	 * Return the modifiers matching the given day for the given
	 * object of modifiers.
	 *
	 * @export
	 * @param {Date} day
	 * @param {Object} [modifiersObj={}]
	 * @return {Array}
	 */


	function getModifiersForDay(day) {
	  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
	    var value = modifiersObj[modifierName];

	    if (dayMatchesModifier(day, value)) {
	      modifiers.push(modifierName);
	    }

	    return modifiers;
	  }, []);
	}

	var _default$9 = {
	  dayMatchesModifier: dayMatchesModifier,
	  getModifiersForDay: getModifiersForDay
	};

	var ModifiersUtils = /*#__PURE__*/Object.defineProperty({
		dayMatchesModifier: dayMatchesModifier_1,
		getModifiersForDay: getModifiersForDay_1,
		default: _default$9
	}, '__esModule', {value: true});

	var _createClass$5 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2$5 = _interopRequireDefault$7(React__default['default']);



	var _propTypes2$5 = _interopRequireDefault$7(propTypes);



	var _Weekdays2 = _interopRequireDefault$7(Weekdays_1);



	var _Day2 = _interopRequireDefault$7(Day_1);





	var ModifiersUtils$1 = _interopRequireWildcard(ModifiersUtils);



	var Helpers$1 = _interopRequireWildcard(Helpers);



	var DateUtils$1 = _interopRequireWildcard(DateUtils);

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj.default = obj;
	    return newObj;
	  }
	}

	function _interopRequireDefault$7(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck$5(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn$5(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits$5(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var Month = function (_Component) {
	  _inherits$5(Month, _Component);

	  function Month() {
	    var _ref;

	    var _temp, _this, _ret;

	    _classCallCheck$5(this, Month);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = _possibleConstructorReturn$5(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
	      var monthNumber = _this.props.month.getMonth();

	      var propModifiers = Helpers$1.getModifiersFromProps(_this.props);
	      var dayModifiers = ModifiersUtils$1.getModifiersForDay(day, propModifiers);

	      if (DateUtils$1.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
	        dayModifiers.push(_this.props.classNames.today);
	      }

	      if (day.getMonth() !== monthNumber) {
	        dayModifiers.push(_this.props.classNames.outside);
	      }

	      var isOutside = day.getMonth() !== monthNumber;
	      var tabIndex = -1; // Focus on the first day of the month

	      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
	        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
	      }

	      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
	      var modifiers = {};
	      dayModifiers.forEach(function (modifier) {
	        modifiers[modifier] = true;
	      });
	      return _react2$5.default.createElement(_Day2.default, {
	        key: '' + (isOutside ? 'outside-' : '') + key,
	        classNames: _this.props.classNames,
	        day: day,
	        modifiers: modifiers,
	        modifiersStyles: _this.props.modifiersStyles,
	        empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
	        tabIndex: tabIndex,
	        ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
	        ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
	        ariaSelected: dayModifiers.indexOf('selected') > -1,
	        onClick: _this.props.onDayClick,
	        onFocus: _this.props.onDayFocus,
	        onKeyDown: _this.props.onDayKeyDown,
	        onMouseEnter: _this.props.onDayMouseEnter,
	        onMouseLeave: _this.props.onDayMouseLeave,
	        onMouseDown: _this.props.onDayMouseDown,
	        onMouseUp: _this.props.onDayMouseUp,
	        onTouchEnd: _this.props.onDayTouchEnd,
	        onTouchStart: _this.props.onDayTouchStart
	      }, _this.props.renderDay(day, modifiers));
	    }, _temp), _possibleConstructorReturn$5(_this, _ret);
	  }

	  _createClass$5(Month, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;

	      var _props = this.props,
	          classNames = _props.classNames,
	          month = _props.month,
	          months = _props.months,
	          fixedWeeks = _props.fixedWeeks,
	          captionElement = _props.captionElement,
	          weekdayElement = _props.weekdayElement,
	          locale = _props.locale,
	          localeUtils = _props.localeUtils,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          onCaptionClick = _props.onCaptionClick,
	          showWeekNumbers = _props.showWeekNumbers,
	          showWeekDays = _props.showWeekDays,
	          onWeekClick = _props.onWeekClick;
	      var captionProps = {
	        date: month,
	        classNames: classNames,
	        months: months,
	        localeUtils: localeUtils,
	        locale: locale,
	        onClick: onCaptionClick ? function (e) {
	          return onCaptionClick(month, e);
	        } : undefined
	      };
	      var caption = _react2$5.default.isValidElement(captionElement) ? _react2$5.default.cloneElement(captionElement, captionProps) : _react2$5.default.createElement(captionElement, captionProps);
	      var weeks = Helpers$1.getWeekArray(month, firstDayOfWeek, fixedWeeks);
	      return _react2$5.default.createElement('div', {
	        className: classNames.month,
	        role: 'grid'
	      }, caption, showWeekDays && _react2$5.default.createElement(_Weekdays2.default, {
	        classNames: classNames,
	        weekdaysShort: weekdaysShort,
	        weekdaysLong: weekdaysLong,
	        firstDayOfWeek: firstDayOfWeek,
	        showWeekNumbers: showWeekNumbers,
	        locale: locale,
	        localeUtils: localeUtils,
	        weekdayElement: weekdayElement
	      }), _react2$5.default.createElement('div', {
	        className: classNames.body,
	        role: 'rowgroup'
	      }, weeks.map(function (week) {
	        var weekNumber = void 0;

	        if (showWeekNumbers) {
	          weekNumber = DateUtils$1.getWeekNumber(week[6]);
	        }

	        return _react2$5.default.createElement('div', {
	          key: week[0].getTime(),
	          className: classNames.week,
	          role: 'row'
	        }, showWeekNumbers && _react2$5.default.createElement('div', {
	          className: classNames.weekNumber,
	          tabIndex: onWeekClick ? 0 : -1,
	          role: 'gridcell',
	          onClick: onWeekClick ? function (e) {
	            return onWeekClick(weekNumber, week, e);
	          } : undefined,
	          onKeyUp: onWeekClick ? function (e) {
	            return e.keyCode === keys$9.ENTER && onWeekClick(weekNumber, week, e);
	          } : undefined
	        }, _this2.props.renderWeek(weekNumber, week, month)), week.map(_this2.renderDay));
	      })));
	    }
	  }]);

	  return Month;
	}(React__default['default'].Component);

	Month.propTypes = {
	  classNames: _propTypes2$5.default.shape({
	    body: _propTypes2$5.default.string.isRequired,
	    month: _propTypes2$5.default.string.isRequired,
	    outside: _propTypes2$5.default.string.isRequired,
	    today: _propTypes2$5.default.string.isRequired,
	    week: _propTypes2$5.default.string.isRequired,
	    weekNumber: _propTypes2$5.default.string.isRequired
	  }).isRequired,
	  tabIndex: _propTypes2$5.default.number,
	  month: _propTypes2$5.default.instanceOf(Date).isRequired,
	  months: _propTypes2$5.default.arrayOf(_propTypes2$5.default.string),
	  modifiersStyles: _propTypes2$5.default.object,
	  showWeekDays: _propTypes2$5.default.bool,
	  showOutsideDays: _propTypes2$5.default.bool,
	  renderDay: _propTypes2$5.default.func.isRequired,
	  renderWeek: _propTypes2$5.default.func.isRequired,
	  captionElement: _propTypes2$5.default.oneOfType([_propTypes2$5.default.element, _propTypes2$5.default.func, _propTypes2$5.default.instanceOf(_react2$5.default.Component)]).isRequired,
	  weekdayElement: _propTypes2$5.default.oneOfType([_propTypes2$5.default.element, _propTypes2$5.default.func, _propTypes2$5.default.instanceOf(_react2$5.default.Component)]),
	  fixedWeeks: _propTypes2$5.default.bool,
	  showWeekNumbers: _propTypes2$5.default.bool,
	  locale: _propTypes2$5.default.string.isRequired,
	  localeUtils: _propTypes2$5.default.object.isRequired,
	  weekdaysLong: _propTypes2$5.default.arrayOf(_propTypes2$5.default.string),
	  weekdaysShort: _propTypes2$5.default.arrayOf(_propTypes2$5.default.string),
	  firstDayOfWeek: _propTypes2$5.default.number.isRequired,
	  onCaptionClick: _propTypes2$5.default.func,
	  onDayClick: _propTypes2$5.default.func,
	  onDayFocus: _propTypes2$5.default.func,
	  onDayKeyDown: _propTypes2$5.default.func,
	  onDayMouseEnter: _propTypes2$5.default.func,
	  onDayMouseLeave: _propTypes2$5.default.func,
	  onDayMouseDown: _propTypes2$5.default.func,
	  onDayMouseUp: _propTypes2$5.default.func,
	  onDayTouchEnd: _propTypes2$5.default.func,
	  onDayTouchStart: _propTypes2$5.default.func,
	  onWeekClick: _propTypes2$5.default.func
	};
	var _default$a = Month;

	var Month_1 = /*#__PURE__*/Object.defineProperty({
		default: _default$a
	}, '__esModule', {value: true});

	var _createClass$6 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2$6 = _interopRequireDefault$8(React__default['default']);



	var _propTypes2$6 = _interopRequireDefault$8(propTypes);

	function _interopRequireDefault$8(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck$6(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn$6(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits$6(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var Weekday = function (_Component) {
	  _inherits$6(Weekday, _Component);

	  function Weekday() {
	    _classCallCheck$6(this, Weekday);

	    return _possibleConstructorReturn$6(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
	  }

	  _createClass$6(Weekday, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          weekday = _props.weekday,
	          className = _props.className,
	          weekdaysLong = _props.weekdaysLong,
	          weekdaysShort = _props.weekdaysShort,
	          localeUtils = _props.localeUtils,
	          locale = _props.locale;
	      var title = void 0;

	      if (weekdaysLong) {
	        title = weekdaysLong[weekday];
	      } else {
	        title = localeUtils.formatWeekdayLong(weekday, locale);
	      }

	      var content = void 0;

	      if (weekdaysShort) {
	        content = weekdaysShort[weekday];
	      } else {
	        content = localeUtils.formatWeekdayShort(weekday, locale);
	      }

	      return _react2$6.default.createElement('div', {
	        className: className,
	        role: 'columnheader'
	      }, _react2$6.default.createElement('abbr', {
	        title: title
	      }, content));
	    }
	  }]);

	  return Weekday;
	}(React__default['default'].Component);

	Weekday.propTypes = {
	  weekday: _propTypes2$6.default.number,
	  className: _propTypes2$6.default.string,
	  locale: _propTypes2$6.default.string,
	  localeUtils: _propTypes2$6.default.object,
	  weekdaysLong: _propTypes2$6.default.arrayOf(_propTypes2$6.default.string),
	  weekdaysShort: _propTypes2$6.default.arrayOf(_propTypes2$6.default.string)
	};
	var _default$b = Weekday;

	var Weekday_1 = /*#__PURE__*/Object.defineProperty({
		default: _default$b
	}, '__esModule', {value: true});

	var DayPicker_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();



	var _react2 = _interopRequireDefault(React__default['default']);



	var _propTypes2 = _interopRequireDefault(propTypes);



	var _Caption2 = _interopRequireDefault(Caption_1);



	var _Navbar2 = _interopRequireDefault(Navbar_1);



	var _Month2 = _interopRequireDefault(Month_1);



	var _Weekday2 = _interopRequireDefault(Weekday_1);



	var Helpers$1 = _interopRequireWildcard(Helpers);



	var DateUtils$1 = _interopRequireWildcard(DateUtils);



	var LocaleUtils$1 = _interopRequireWildcard(LocaleUtils);



	var ModifiersUtils$1 = _interopRequireWildcard(ModifiersUtils);



	var _classNames2 = _interopRequireDefault(classNames);



	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj.default = obj;
	    return newObj;
	  }
	}

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _objectWithoutProperties(obj, keys) {
	  var target = {};

	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }

	  return target;
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var DayPicker = exports.DayPicker = function (_Component) {
	  _inherits(DayPicker, _Component);

	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);

	    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

	    _this.dayPicker = null;

	    _this.showNextMonth = function (callback) {
	      if (!_this.allowNextMonth()) {
	        return;
	      }

	      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
	      var nextMonth = DateUtils$1.addMonths(_this.state.currentMonth, deltaMonths);

	      _this.showMonth(nextMonth, callback);
	    };

	    _this.showPreviousMonth = function (callback) {
	      if (!_this.allowPreviousMonth()) {
	        return;
	      }

	      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
	      var previousMonth = DateUtils$1.addMonths(_this.state.currentMonth, -deltaMonths);

	      _this.showMonth(previousMonth, callback);
	    };

	    _this.handleKeyDown = function (e) {
	      e.persist();

	      switch (e.keyCode) {
	        case keys$9.LEFT:
	          if (_this.props.dir === 'rtl') {
	            _this.showNextMonth();
	          } else {
	            _this.showPreviousMonth();
	          }

	          Helpers$1.cancelEvent(e);
	          break;

	        case keys$9.RIGHT:
	          if (_this.props.dir === 'rtl') {
	            _this.showPreviousMonth();
	          } else {
	            _this.showNextMonth();
	          }

	          Helpers$1.cancelEvent(e);
	          break;

	        case keys$9.UP:
	          _this.showPreviousYear();

	          Helpers$1.cancelEvent(e);
	          break;

	        case keys$9.DOWN:
	          _this.showNextYear();

	          Helpers$1.cancelEvent(e);
	          break;
	      }

	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	    };

	    _this.handleDayKeyDown = function (day, modifiers, e) {
	      e.persist();

	      switch (e.keyCode) {
	        case keys$9.LEFT:
	          Helpers$1.cancelEvent(e);

	          if (_this.props.dir === 'rtl') {
	            _this.focusNextDay(e.target);
	          } else {
	            _this.focusPreviousDay(e.target);
	          }

	          break;

	        case keys$9.RIGHT:
	          Helpers$1.cancelEvent(e);

	          if (_this.props.dir === 'rtl') {
	            _this.focusPreviousDay(e.target);
	          } else {
	            _this.focusNextDay(e.target);
	          }

	          break;

	        case keys$9.UP:
	          Helpers$1.cancelEvent(e);

	          _this.focusPreviousWeek(e.target);

	          break;

	        case keys$9.DOWN:
	          Helpers$1.cancelEvent(e);

	          _this.focusNextWeek(e.target);

	          break;

	        case keys$9.ENTER:
	        case keys$9.SPACE:
	          Helpers$1.cancelEvent(e);

	          if (_this.props.onDayClick) {
	            _this.handleDayClick(day, modifiers, e);
	          }

	          break;
	      }

	      if (_this.props.onDayKeyDown) {
	        _this.props.onDayKeyDown(day, modifiers, e);
	      }
	    };

	    _this.handleDayClick = function (day, modifiers, e) {
	      e.persist();

	      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
	        _this.handleOutsideDayClick(day);
	      }

	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, modifiers, e);
	      }
	    };

	    _this.handleTodayButtonClick = function (e) {
	      var today = new Date();
	      var month = new Date(today.getFullYear(), today.getMonth());

	      _this.showMonth(month);

	      e.target.blur();

	      if (_this.props.onTodayButtonClick) {
	        e.persist();

	        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils$1.getModifiersForDay(today, _this.props.modifiers), e);
	      }
	    };

	    var currentMonth = _this.getCurrentMonthFromProps(props);

	    _this.state = {
	      currentMonth: currentMonth
	    };
	    return _this;
	  }

	  _createClass(DayPicker, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // Changing the `month` props means changing the current displayed month
	      if (prevProps.month !== this.props.month && !DateUtils$1.isSameMonth(prevProps.month, this.props.month)) {
	        var currentMonth = this.getCurrentMonthFromProps(this.props); // eslint-disable-next-line react/no-did-update-set-state

	        this.setState({
	          currentMonth: currentMonth
	        });
	      }
	    }
	    /**
	     * Return the month to be shown in the calendar based on the component props.
	     *
	     * @param {Object} props
	     * @returns Date
	     * @memberof DayPicker
	     * @private
	     */

	  }, {
	    key: 'getCurrentMonthFromProps',
	    value: function getCurrentMonthFromProps(props) {
	      var initialMonth = Helpers$1.startOfMonth(props.month || props.initialMonth);
	      var currentMonth = initialMonth;

	      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
	        var fromMonth = Helpers$1.startOfMonth(props.fromMonth);
	        var diffInMonths = Helpers$1.getMonthsDiff(fromMonth, currentMonth);
	        currentMonth = DateUtils$1.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
	      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers$1.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
	        currentMonth = DateUtils$1.addMonths(Helpers$1.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
	      }

	      return currentMonth;
	    }
	  }, {
	    key: 'getNextNavigableMonth',
	    value: function getNextNavigableMonth() {
	      return DateUtils$1.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	    }
	  }, {
	    key: 'getPreviousNavigableMonth',
	    value: function getPreviousNavigableMonth() {
	      return DateUtils$1.addMonths(this.state.currentMonth, -1);
	    }
	  }, {
	    key: 'allowPreviousMonth',
	    value: function allowPreviousMonth() {
	      var previousMonth = DateUtils$1.addMonths(this.state.currentMonth, -1);
	      return this.allowMonth(previousMonth);
	    }
	  }, {
	    key: 'allowNextMonth',
	    value: function allowNextMonth() {
	      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, this.props.numberOfMonths);
	      return this.allowMonth(nextMonth);
	    }
	  }, {
	    key: 'allowMonth',
	    value: function allowMonth(d) {
	      var _props = this.props,
	          fromMonth = _props.fromMonth,
	          toMonth = _props.toMonth,
	          canChangeMonth = _props.canChangeMonth;

	      if (!canChangeMonth || fromMonth && Helpers$1.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers$1.getMonthsDiff(toMonth, d) > 0) {
	        return false;
	      }

	      return true;
	    }
	  }, {
	    key: 'allowYearChange',
	    value: function allowYearChange() {
	      return this.props.canChangeMonth;
	    }
	  }, {
	    key: 'showMonth',
	    value: function showMonth(d, callback) {
	      var _this2 = this;

	      if (!this.allowMonth(d)) {
	        return;
	      }

	      this.setState({
	        currentMonth: Helpers$1.startOfMonth(d)
	      }, function () {
	        if (callback) {
	          callback();
	        }

	        if (_this2.props.onMonthChange) {
	          _this2.props.onMonthChange(_this2.state.currentMonth);
	        }
	      });
	    }
	  }, {
	    key: 'showNextYear',
	    value: function showNextYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }

	      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, 12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'showPreviousYear',
	    value: function showPreviousYear() {
	      if (!this.allowYearChange()) {
	        return;
	      }

	      var nextMonth = DateUtils$1.addMonths(this.state.currentMonth, -12);
	      this.showMonth(nextMonth);
	    }
	  }, {
	    key: 'focusFirstDayOfMonth',
	    value: function focusFirstDayOfMonth() {
	      Helpers$1.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
	    }
	  }, {
	    key: 'focusLastDayOfMonth',
	    value: function focusLastDayOfMonth() {
	      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
	      dayNodes[dayNodes.length - 1].focus();
	    }
	  }, {
	    key: 'focusPreviousDay',
	    value: function focusPreviousDay(dayNode) {
	      var _this3 = this;

	      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
	      if (dayNodeIndex === -1) return;

	      if (dayNodeIndex === 0) {
	        this.showPreviousMonth(function () {
	          return _this3.focusLastDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextDay',
	    value: function focusNextDay(dayNode) {
	      var _this4 = this;

	      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
	      if (dayNodeIndex === -1) return;

	      if (dayNodeIndex === dayNodes.length - 1) {
	        this.showNextMonth(function () {
	          return _this4.focusFirstDayOfMonth();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 1].focus();
	      }
	    }
	  }, {
	    key: 'focusNextWeek',
	    value: function focusNextWeek(dayNode) {
	      var _this5 = this;

	      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

	      if (isInLastWeekOfMonth) {
	        this.showNextMonth(function () {
	          var daysAfterIndex = dayNodes.length - dayNodeIndex;
	          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
	          Helpers$1.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex + 7].focus();
	      }
	    }
	  }, {
	    key: 'focusPreviousWeek',
	    value: function focusPreviousWeek(dayNode) {
	      var _this6 = this;

	      var dayNodes = Helpers$1.getDayNodes(this.dayPicker, this.props.classNames);
	      var dayNodeIndex = Helpers$1.nodeListToArray(dayNodes).indexOf(dayNode);
	      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

	      if (isInFirstWeekOfMonth) {
	        this.showPreviousMonth(function () {
	          var previousMonthDayNodes = Helpers$1.getDayNodes(_this6.dayPicker, _this6.props.classNames);
	          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
	          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
	          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
	        });
	      } else {
	        dayNodes[dayNodeIndex - 7].focus();
	      }
	    } // Event handlers

	  }, {
	    key: 'handleOutsideDayClick',
	    value: function handleOutsideDayClick(day) {
	      var currentMonth = this.state.currentMonth;
	      var numberOfMonths = this.props.numberOfMonths;
	      var diffInMonths = Helpers$1.getMonthsDiff(currentMonth, day);

	      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
	        this.showNextMonth();
	      } else if (diffInMonths < 0) {
	        this.showPreviousMonth();
	      }
	    }
	  }, {
	    key: 'renderNavbar',
	    value: function renderNavbar() {
	      var _props2 = this.props,
	          labels = _props2.labels,
	          locale = _props2.locale,
	          localeUtils = _props2.localeUtils,
	          canChangeMonth = _props2.canChangeMonth,
	          navbarElement = _props2.navbarElement,
	          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

	      if (!canChangeMonth) return null;
	      var props = {
	        month: this.state.currentMonth,
	        classNames: this.props.classNames,
	        className: this.props.classNames.navBar,
	        nextMonth: this.getNextNavigableMonth(),
	        previousMonth: this.getPreviousNavigableMonth(),
	        showPreviousButton: this.allowPreviousMonth(),
	        showNextButton: this.allowNextMonth(),
	        onNextClick: this.showNextMonth,
	        onPreviousClick: this.showPreviousMonth,
	        dir: attributes.dir,
	        labels: labels,
	        locale: locale,
	        localeUtils: localeUtils
	      };
	      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
	    }
	  }, {
	    key: 'renderMonths',
	    value: function renderMonths() {
	      var months = [];
	      var firstDayOfWeek = Helpers$1.getFirstDayOfWeekFromProps(this.props);

	      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
	        var month = DateUtils$1.addMonths(this.state.currentMonth, i);
	        months.push(_react2.default.createElement(_Month2.default, _extends({
	          key: i
	        }, this.props, {
	          month: month,
	          firstDayOfWeek: firstDayOfWeek,
	          onDayKeyDown: this.handleDayKeyDown,
	          onDayClick: this.handleDayClick
	        })));
	      }

	      if (this.props.reverseMonths) {
	        months.reverse();
	      }

	      return months;
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      if (this.props.todayButton) {
	        return _react2.default.createElement('div', {
	          className: this.props.classNames.footer
	        }, this.renderTodayButton());
	      }

	      return null;
	    }
	  }, {
	    key: 'renderTodayButton',
	    value: function renderTodayButton() {
	      return _react2.default.createElement('button', {
	        type: 'button',
	        tabIndex: 0,
	        className: this.props.classNames.todayButton,
	        'aria-label': this.props.todayButton,
	        onClick: this.handleTodayButtonClick
	      }, this.props.todayButton);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;

	      var className = this.props.classNames.container;

	      if (!this.props.onDayClick) {
	        className = className + ' ' + this.props.classNames.interactionDisabled;
	      }

	      if (this.props.className) {
	        className = className + ' ' + this.props.className;
	      }

	      return _react2.default.createElement('div', _extends({}, this.props.containerProps, {
	        className: className,
	        ref: function ref(el) {
	          return _this7.dayPicker = el;
	        },
	        lang: this.props.locale
	      }), _react2.default.createElement('div', {
	        className: this.props.classNames.wrapper,
	        tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
	        onKeyDown: this.handleKeyDown,
	        onFocus: this.props.onFocus,
	        onBlur: this.props.onBlur
	      }, this.renderNavbar(), _react2.default.createElement('div', {
	        className: this.props.classNames.months
	      }, this.renderMonths()), this.renderFooter()));
	    }
	  }]);

	  return DayPicker;
	}(React__default['default'].Component);

	DayPicker.VERSION = '7.3.2';
	DayPicker.propTypes = {
	  // Rendering months
	  initialMonth: _propTypes2.default.instanceOf(Date),
	  month: _propTypes2.default.instanceOf(Date),
	  numberOfMonths: _propTypes2.default.number,
	  fromMonth: _propTypes2.default.instanceOf(Date),
	  toMonth: _propTypes2.default.instanceOf(Date),
	  canChangeMonth: _propTypes2.default.bool,
	  reverseMonths: _propTypes2.default.bool,
	  pagedNavigation: _propTypes2.default.bool,
	  todayButton: _propTypes2.default.string,
	  showWeekNumbers: _propTypes2.default.bool,
	  showWeekDays: _propTypes2.default.bool,
	  // Modifiers
	  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
	  modifiers: _propTypes2.default.object,
	  modifiersStyles: _propTypes2.default.object,
	  // Localization
	  dir: _propTypes2.default.string,
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	  labels: _propTypes2.default.shape({
	    nextMonth: _propTypes2.default.string.isRequired,
	    previousMonth: _propTypes2.default.string.isRequired
	  }),
	  locale: _propTypes2.default.string,
	  localeUtils: _propTypes2.default.shape({
	    formatMonthTitle: _propTypes2.default.func,
	    formatWeekdayShort: _propTypes2.default.func,
	    formatWeekdayLong: _propTypes2.default.func,
	    getFirstDayOfWeek: _propTypes2.default.func
	  }),
	  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  // Customization
	  showOutsideDays: _propTypes2.default.bool,
	  enableOutsideDaysClick: _propTypes2.default.bool,
	  fixedWeeks: _propTypes2.default.bool,
	  // CSS and HTML
	  classNames: _propTypes2.default.shape({
	    body: _propTypes2.default.string,
	    container: _propTypes2.default.string,
	    day: _propTypes2.default.string.isRequired,
	    disabled: _propTypes2.default.string.isRequired,
	    footer: _propTypes2.default.string,
	    interactionDisabled: _propTypes2.default.string,
	    months: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    navBar: _propTypes2.default.string,
	    outside: _propTypes2.default.string.isRequired,
	    selected: _propTypes2.default.string.isRequired,
	    today: _propTypes2.default.string.isRequired,
	    todayButton: _propTypes2.default.string,
	    week: _propTypes2.default.string,
	    wrapper: _propTypes2.default.string
	  }),
	  className: _propTypes2.default.string,
	  containerProps: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	  // Custom elements
	  renderDay: _propTypes2.default.func,
	  renderWeek: _propTypes2.default.func,
	  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(React__default['default'].Component)]),
	  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(React__default['default'].Component)]),
	  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(React__default['default'].Component)]),
	  // Events
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onDayClick: _propTypes2.default.func,
	  onDayKeyDown: _propTypes2.default.func,
	  onDayMouseEnter: _propTypes2.default.func,
	  onDayMouseLeave: _propTypes2.default.func,
	  onDayMouseDown: _propTypes2.default.func,
	  onDayMouseUp: _propTypes2.default.func,
	  onDayTouchStart: _propTypes2.default.func,
	  onDayTouchEnd: _propTypes2.default.func,
	  onDayFocus: _propTypes2.default.func,
	  onMonthChange: _propTypes2.default.func,
	  onCaptionClick: _propTypes2.default.func,
	  onWeekClick: _propTypes2.default.func,
	  onTodayButtonClick: _propTypes2.default.func
	};
	DayPicker.defaultProps = {
	  classNames: _classNames2.default,
	  tabIndex: 0,
	  initialMonth: new Date(),
	  numberOfMonths: 1,
	  labels: {
	    previousMonth: 'Previous Month',
	    nextMonth: 'Next Month'
	  },
	  locale: 'en',
	  localeUtils: LocaleUtils$1,
	  showOutsideDays: false,
	  enableOutsideDaysClick: true,
	  fixedWeeks: false,
	  canChangeMonth: true,
	  reverseMonths: false,
	  pagedNavigation: false,
	  showWeekNumbers: false,
	  showWeekDays: true,
	  renderDay: function renderDay(day) {
	    return day.getDate();
	  },
	  renderWeek: function renderWeek(weekNumber) {
	    return weekNumber;
	  },
	  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
	  navbarElement: _react2.default.createElement(_Navbar2.default, {
	    classNames: _classNames2.default
	  }),
	  captionElement: _react2.default.createElement(_Caption2.default, {
	    classNames: _classNames2.default
	  })
	};
	DayPicker.DateUtils = DateUtils$1;
	DayPicker.LocaleUtils = LocaleUtils$1;
	DayPicker.ModifiersUtils = ModifiersUtils$1;
	exports.DateUtils = DateUtils$1;
	exports.LocaleUtils = LocaleUtils$1;
	exports.ModifiersUtils = ModifiersUtils$1;
	exports.default = DayPicker;
	});

	var DayPickerInput_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HIDE_TIMEOUT = undefined;

	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	exports.OverlayComponent = OverlayComponent;
	exports.defaultFormat = defaultFormat;
	exports.defaultParse = defaultParse;



	var _react2 = _interopRequireDefault(React__default['default']);



	var _propTypes2 = _interopRequireDefault(propTypes);



	var _DayPicker2 = _interopRequireDefault(DayPicker_1);







	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	function _objectWithoutProperties(obj, keys) {
	  var target = {};

	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }

	  return target;
	} // When clicking on a day cell, overlay will be hidden after this timeout


	var HIDE_TIMEOUT = exports.HIDE_TIMEOUT = 100;
	/**
	 * The default component used as Overlay.
	 *
	 * @param {Object} props
	 */

	function OverlayComponent(_ref) {
	  var input = _ref.input,
	      selectedDay = _ref.selectedDay,
	      month = _ref.month,
	      children = _ref.children,
	      classNames = _ref.classNames,
	      props = _objectWithoutProperties(_ref, ['input', 'selectedDay', 'month', 'children', 'classNames']);

	  return _react2.default.createElement('div', _extends({
	    className: classNames.overlayWrapper
	  }, props), _react2.default.createElement('div', {
	    className: classNames.overlay
	  }, children));
	}

	OverlayComponent.propTypes = {
	  input: _propTypes2.default.any,
	  selectedDay: _propTypes2.default.any,
	  month: _propTypes2.default.instanceOf(Date),
	  children: _propTypes2.default.node,
	  classNames: _propTypes2.default.object
	};
	/**
	 * The default function used to format a Date to String, passed to the `format`
	 * prop.
	 * @param {Date} d
	 * @return {String}
	 */

	function defaultFormat(d) {
	  if ((0, DateUtils.isDate)(d)) {
	    var year = d.getFullYear();
	    var month = '' + (d.getMonth() + 1);
	    var day = '' + d.getDate();
	    return year + '-' + month + '-' + day;
	  }

	  return '';
	}
	/**
	 * The default function used to parse a String as Date, passed to the `parse`
	 * prop.
	 * @param {String} str
	 * @return {Date}
	 */


	function defaultParse(str) {
	  if (typeof str !== 'string') {
	    return undefined;
	  }

	  var split = str.split('-');

	  if (split.length !== 3) {
	    return undefined;
	  }

	  var year = parseInt(split[0], 10);
	  var month = parseInt(split[1], 10) - 1;
	  var day = parseInt(split[2], 10);

	  if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) {
	    return undefined;
	  }

	  return new Date(year, month, day, 12, 0, 0, 0); // always set noon to avoid time zone issues
	}

	var DayPickerInput = function (_React$Component) {
	  _inherits(DayPickerInput, _React$Component);

	  function DayPickerInput(props) {
	    _classCallCheck(this, DayPickerInput);

	    var _this = _possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));

	    _this.input = null;
	    _this.daypicker = null;
	    _this.clickTimeout = null;
	    _this.hideTimeout = null;
	    _this.inputBlurTimeout = null;
	    _this.inputFocusTimeout = null;
	    _this.state = _this.getInitialStateFromProps(props);
	    _this.state.showOverlay = props.showOverlay;
	    _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
	    _this.handleInputClick = _this.handleInputClick.bind(_this);
	    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
	    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
	    _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
	    _this.handleDayClick = _this.handleDayClick.bind(_this);
	    _this.handleMonthChange = _this.handleMonthChange.bind(_this);
	    _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
	    _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
	    return _this;
	  }

	  _createClass(DayPickerInput, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var newState = {}; // Current props

	      var _props = this.props,
	          value = _props.value,
	          formatDate = _props.formatDate,
	          format = _props.format,
	          dayPickerProps = _props.dayPickerProps; // Update the input value if the `value` prop has changed

	      if (value !== prevProps.value) {
	        if ((0, DateUtils.isDate)(value)) {
	          newState.value = formatDate(value, format, dayPickerProps.locale);
	        } else {
	          newState.value = value;
	        }
	      } // Update the month if the months from props changed


	      var prevMonth = prevProps.dayPickerProps.month;

	      if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, DateUtils.isSameMonth)(dayPickerProps.month, prevMonth)) {
	        newState.month = dayPickerProps.month;
	      } // Updated the selected days from props if they changed


	      if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) {
	        newState.selectedDays = dayPickerProps.selectedDays;
	      }

	      if (Object.keys(newState).length > 0) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.clickTimeout);
	      clearTimeout(this.hideTimeout);
	      clearTimeout(this.inputFocusTimeout);
	      clearTimeout(this.inputBlurTimeout);
	      clearTimeout(this.overlayBlurTimeout);
	    }
	  }, {
	    key: 'getInitialMonthFromProps',
	    value: function getInitialMonthFromProps(props) {
	      var dayPickerProps = props.dayPickerProps,
	          format = props.format;
	      var day = void 0;

	      if (props.value) {
	        if ((0, DateUtils.isDate)(props.value)) {
	          day = props.value;
	        } else {
	          day = props.parseDate(props.value, format, dayPickerProps.locale);
	        }
	      }

	      return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
	    }
	  }, {
	    key: 'getInitialStateFromProps',
	    value: function getInitialStateFromProps(props) {
	      var dayPickerProps = props.dayPickerProps,
	          formatDate = props.formatDate,
	          format = props.format;
	      var value = props.value;

	      if (props.value && (0, DateUtils.isDate)(props.value)) {
	        value = formatDate(props.value, format, dayPickerProps.locale);
	      }

	      return {
	        value: value,
	        month: this.getInitialMonthFromProps(props),
	        selectedDays: dayPickerProps.selectedDays
	      };
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput() {
	      return this.input;
	    }
	  }, {
	    key: 'getDayPicker',
	    value: function getDayPicker() {
	      return this.daypicker;
	    }
	    /**
	     * Update the component's state and fire the `onDayChange` event passing the
	     * day's modifiers to it.
	     *
	     * @param {Date} day - Will be used for changing the month
	     * @param {String} value - Input field value
	     * @private
	     */

	  }, {
	    key: 'updateState',
	    value: function updateState(day, value, callback) {
	      var _this2 = this;

	      var _props2 = this.props,
	          dayPickerProps = _props2.dayPickerProps,
	          onDayChange = _props2.onDayChange;
	      this.setState({
	        month: day,
	        value: value,
	        typedValue: undefined
	      }, function () {
	        if (callback) {
	          callback();
	        }

	        if (!onDayChange) {
	          return;
	        }

	        var modifiersObj = _extends({
	          disabled: dayPickerProps.disabledDays,
	          selected: dayPickerProps.selectedDays
	        }, dayPickerProps.modifiers);

	        var modifiers = (0, ModifiersUtils.getModifiersForDay)(day, modifiersObj).reduce(function (obj, modifier) {
	          return _extends({}, obj, _defineProperty({}, modifier, true));
	        }, {});
	        onDayChange(day, modifiers, _this2);
	      });
	    }
	    /**
	     * Show the Day Picker overlay.
	     *
	     * @memberof DayPickerInput
	     */

	  }, {
	    key: 'showDayPicker',
	    value: function showDayPicker() {
	      var _this3 = this;

	      var _props3 = this.props,
	          parseDate = _props3.parseDate,
	          format = _props3.format,
	          dayPickerProps = _props3.dayPickerProps;
	      var _state = this.state,
	          value = _state.value,
	          showOverlay = _state.showOverlay;

	      if (showOverlay) {
	        return;
	      } // Reset the current displayed month when showing the overlay


	      var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
	      : this.getInitialMonthFromProps(this.props); // Restore the month from the props

	      this.setState(function (state) {
	        return {
	          showOverlay: true,
	          month: month || state.month
	        };
	      }, function () {
	        if (_this3.props.onDayPickerShow) _this3.props.onDayPickerShow();
	      });
	    }
	    /**
	     * Hide the Day Picker overlay
	     *
	     * @memberof DayPickerInput
	     */

	  }, {
	    key: 'hideDayPicker',
	    value: function hideDayPicker() {
	      var _this4 = this;

	      if (this.state.showOverlay === false) {
	        return;
	      }

	      this.setState({
	        showOverlay: false
	      }, function () {
	        if (_this4.props.onDayPickerHide) _this4.props.onDayPickerHide();
	      });
	    }
	  }, {
	    key: 'hideAfterDayClick',
	    value: function hideAfterDayClick() {
	      var _this5 = this;

	      if (!this.props.hideOnDayClick) {
	        return;
	      }

	      this.hideTimeout = setTimeout(function () {
	        return _this5.hideDayPicker();
	      }, HIDE_TIMEOUT);
	    }
	  }, {
	    key: 'handleInputClick',
	    value: function handleInputClick(e) {
	      this.showDayPicker();

	      if (this.props.inputProps.onClick) {
	        e.persist();
	        this.props.inputProps.onClick(e);
	      }
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus(e) {
	      var _this6 = this;

	      this.showDayPicker(); // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
	      // the input is blurred

	      this.inputFocusTimeout = setTimeout(function () {
	        _this6.overlayHasFocus = false;
	      }, 2);

	      if (this.props.inputProps.onFocus) {
	        e.persist();
	        this.props.inputProps.onFocus(e);
	      }
	    } // When the input is blurred, the overlay should disappear. However the input
	    // is blurred also when the user interacts with the overlay (e.g. the overlay
	    // get the focus by clicking it). In these cases, the overlay should not be
	    // hidden. There are different approaches to avoid hiding the overlay when
	    // this happens, but the only cross-browser hack we’ve found is to set all
	    // these timeouts in code before changing `overlayHasFocus`.

	  }, {
	    key: 'handleInputBlur',
	    value: function handleInputBlur(e) {
	      var _this7 = this;

	      this.inputBlurTimeout = setTimeout(function () {
	        if (!_this7.overlayHasFocus) {
	          _this7.hideDayPicker();
	        }
	      }, 1);

	      if (this.props.inputProps.onBlur) {
	        e.persist();
	        this.props.inputProps.onBlur(e);
	      }
	    }
	  }, {
	    key: 'handleOverlayFocus',
	    value: function handleOverlayFocus(e) {
	      e.preventDefault();
	      this.overlayHasFocus = true;

	      if (!this.props.keepFocus || !this.input || typeof this.input.focus !== 'function') {
	        return;
	      }

	      this.input.focus();
	    }
	  }, {
	    key: 'handleOverlayBlur',
	    value: function handleOverlayBlur() {
	      var _this8 = this; // We need to set a timeout otherwise IE11 will hide the overlay when
	      // focusing it


	      this.overlayBlurTimeout = setTimeout(function () {
	        _this8.overlayHasFocus = false;
	      }, 3);
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(e) {
	      var _props4 = this.props,
	          dayPickerProps = _props4.dayPickerProps,
	          format = _props4.format,
	          inputProps = _props4.inputProps,
	          onDayChange = _props4.onDayChange,
	          parseDate = _props4.parseDate;

	      if (inputProps.onChange) {
	        e.persist();
	        inputProps.onChange(e);
	      }

	      var value = e.target.value;

	      if (value.trim() === '') {
	        this.setState({
	          value: value,
	          typedValue: undefined
	        });
	        if (onDayChange) onDayChange(undefined, {}, this);
	        return;
	      }

	      var day = parseDate(value, format, dayPickerProps.locale);

	      if (!day) {
	        // Day is invalid: we save the value in the typedValue state
	        this.setState({
	          value: value,
	          typedValue: value
	        });
	        if (onDayChange) onDayChange(undefined, {}, this);
	        return;
	      }

	      this.updateState(day, value);
	    }
	  }, {
	    key: 'handleInputKeyDown',
	    value: function handleInputKeyDown(e) {
	      if (e.keyCode === keys$9.TAB) {
	        this.hideDayPicker();
	      } else {
	        this.showDayPicker();
	      }

	      if (this.props.inputProps.onKeyDown) {
	        e.persist();
	        this.props.inputProps.onKeyDown(e);
	      }
	    }
	  }, {
	    key: 'handleInputKeyUp',
	    value: function handleInputKeyUp(e) {
	      if (e.keyCode === keys$9.ESC) {
	        this.hideDayPicker();
	      } else {
	        this.showDayPicker();
	      }

	      if (this.props.inputProps.onKeyUp) {
	        e.persist();
	        this.props.inputProps.onKeyUp(e);
	      }
	    }
	  }, {
	    key: 'handleMonthChange',
	    value: function handleMonthChange(month) {
	      var _this9 = this;

	      this.setState({
	        month: month
	      }, function () {
	        if (_this9.props.dayPickerProps && _this9.props.dayPickerProps.onMonthChange) {
	          _this9.props.dayPickerProps.onMonthChange(month);
	        }
	      });
	    }
	  }, {
	    key: 'handleDayClick',
	    value: function handleDayClick(day, modifiers, e) {
	      var _this10 = this;

	      var _props5 = this.props,
	          clickUnselectsDay = _props5.clickUnselectsDay,
	          dayPickerProps = _props5.dayPickerProps,
	          onDayChange = _props5.onDayChange,
	          formatDate = _props5.formatDate,
	          format = _props5.format;

	      if (dayPickerProps.onDayClick) {
	        dayPickerProps.onDayClick(day, modifiers, e);
	      } // Do nothing if the day is disabled


	      if (modifiers.disabled || dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled]) {
	        return;
	      } // If the clicked day is already selected, remove the clicked day
	      // from the selected days and empty the field value


	      if (modifiers.selected && clickUnselectsDay) {
	        var selectedDays = this.state.selectedDays;

	        if (Array.isArray(selectedDays)) {
	          selectedDays = selectedDays.slice(0);
	          var selectedDayIdx = selectedDays.indexOf(day);
	          selectedDays.splice(selectedDayIdx, 1);
	        } else if (selectedDays) {
	          selectedDays = null;
	        }

	        this.setState({
	          value: '',
	          typedValue: undefined,
	          selectedDays: selectedDays
	        }, this.hideAfterDayClick);

	        if (onDayChange) {
	          onDayChange(undefined, modifiers, this);
	        }

	        return;
	      }

	      var value = formatDate(day, format, dayPickerProps.locale);
	      this.setState({
	        value: value,
	        typedValue: undefined,
	        month: day
	      }, function () {
	        if (onDayChange) {
	          onDayChange(day, modifiers, _this10);
	        }

	        _this10.hideAfterDayClick();
	      });
	    }
	  }, {
	    key: 'renderOverlay',
	    value: function renderOverlay() {
	      var _this11 = this;

	      var _props6 = this.props,
	          classNames = _props6.classNames,
	          dayPickerProps = _props6.dayPickerProps,
	          parseDate = _props6.parseDate,
	          formatDate = _props6.formatDate,
	          format = _props6.format;
	      var _state2 = this.state,
	          selectedDays = _state2.selectedDays,
	          value = _state2.value;
	      var selectedDay = void 0;

	      if (!selectedDays && value) {
	        var day = parseDate(value, format, dayPickerProps.locale);

	        if (day) {
	          selectedDay = day;
	        }
	      } else if (selectedDays) {
	        selectedDay = selectedDays;
	      }

	      var onTodayButtonClick = void 0;

	      if (dayPickerProps.todayButton) {
	        // Set the current day when clicking the today button
	        onTodayButtonClick = function onTodayButtonClick() {
	          return _this11.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this11.hideAfterDayClick);
	        };
	      }

	      var Overlay = this.props.overlayComponent;
	      return _react2.default.createElement(Overlay, {
	        classNames: classNames,
	        month: this.state.month,
	        selectedDay: selectedDay,
	        input: this.input,
	        tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
	        ,
	        onFocus: this.handleOverlayFocus,
	        onBlur: this.handleOverlayBlur
	      }, _react2.default.createElement(_DayPicker2.default, _extends({
	        ref: function ref(el) {
	          return _this11.daypicker = el;
	        },
	        onTodayButtonClick: onTodayButtonClick
	      }, dayPickerProps, {
	        month: this.state.month,
	        selectedDays: selectedDay,
	        onDayClick: this.handleDayClick,
	        onMonthChange: this.handleMonthChange
	      })));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;

	      var Input = this.props.component;
	      var inputProps = this.props.inputProps;
	      return _react2.default.createElement('div', {
	        className: this.props.classNames.container,
	        style: this.props.style
	      }, _react2.default.createElement(Input, _extends({
	        ref: function ref(el) {
	          return _this12.input = el;
	        },
	        placeholder: this.props.placeholder
	      }, inputProps, {
	        value: this.state.typedValue || this.state.value,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus,
	        onBlur: this.handleInputBlur,
	        onKeyDown: this.handleInputKeyDown,
	        onKeyUp: this.handleInputKeyUp,
	        onClick: !inputProps.disabled ? this.handleInputClick : undefined
	      })), this.state.showOverlay && this.renderOverlay());
	    }
	  }]);

	  return DayPickerInput;
	}(_react2.default.Component);

	DayPickerInput.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	  inputProps: _propTypes2.default.object,
	  placeholder: _propTypes2.default.string,
	  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  formatDate: _propTypes2.default.func,
	  parseDate: _propTypes2.default.func,
	  showOverlay: _propTypes2.default.bool,
	  dayPickerProps: _propTypes2.default.object,
	  hideOnDayClick: _propTypes2.default.bool,
	  clickUnselectsDay: _propTypes2.default.bool,
	  keepFocus: _propTypes2.default.bool,
	  component: _propTypes2.default.any,
	  overlayComponent: _propTypes2.default.any,
	  style: _propTypes2.default.object,
	  classNames: _propTypes2.default.shape({
	    container: _propTypes2.default.string,
	    overlayWrapper: _propTypes2.default.string,
	    overlay: _propTypes2.default.string.isRequired
	  }),
	  onDayChange: _propTypes2.default.func,
	  onDayPickerHide: _propTypes2.default.func,
	  onDayPickerShow: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func
	};
	DayPickerInput.defaultProps = {
	  dayPickerProps: {},
	  value: '',
	  placeholder: 'YYYY-M-D',
	  format: 'L',
	  formatDate: defaultFormat,
	  parseDate: defaultParse,
	  showOverlay: false,
	  hideOnDayClick: true,
	  clickUnselectsDay: false,
	  keepFocus: true,
	  component: 'input',
	  inputProps: {},
	  overlayComponent: OverlayComponent,
	  classNames: {
	    container: 'DayPickerInput',
	    overlayWrapper: 'DayPickerInput-OverlayWrapper',
	    overlay: 'DayPickerInput-Overlay'
	  }
	};
	exports.default = DayPickerInput;
	});

	var DayPickerInput = /*@__PURE__*/getDefaultExportFromCjs(DayPickerInput_1);

	var func$4 = convert_1('get', get_1);

	func$4.placeholder = placeholder;
	var get$3 = func$4;

	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return _arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}

	var _baseToPairs = baseToPairs;

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}

	var _setToPairs = setToPairs;

	/** `Object#toString` result references. */
	var mapTag$6 = '[object Map]',
	    setTag$6 = '[object Set]';

	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = _getTag(object);
	    if (tag == mapTag$6) {
	      return _mapToArray(object);
	    }
	    if (tag == setTag$6) {
	      return _setToPairs(object);
	    }
	    return _baseToPairs(object, keysFunc(object));
	  };
	}

	var _createToPairs = createToPairs;

	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = _createToPairs(keys_1);

	var toPairs_1 = toPairs;

	var func$5 = convert_1('toPairs', toPairs_1, _falseOptions);

	func$5.placeholder = placeholder;
	var toPairs$1 = func$5;

	var entries = toPairs$1;

	/** Error message constants. */
	var FUNC_ERROR_TEXT$2 = 'Expected a function';

	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG$6 = 8,
	    WRAP_PARTIAL_FLAG$3 = 32,
	    WRAP_ARY_FLAG$4 = 128,
	    WRAP_REARG_FLAG$3 = 256;

	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return _flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = _LodashWrapper.prototype.thru;

	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT$2);
	      }
	      if (prereq && !wrapper && _getFuncName(func) == 'wrapper') {
	        var wrapper = new _LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];

	      var funcName = _getFuncName(func),
	          data = funcName == 'wrapper' ? _getData(func) : undefined;

	      if (data && _isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG$4 | WRAP_CURRY_FLAG$6 | WRAP_PARTIAL_FLAG$3 | WRAP_REARG_FLAG$3) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[_getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && _isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];

	      if (wrapper && args.length == 1 && isArray_1(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;

	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}

	var _createFlow = createFlow;

	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = _createFlow();

	var flow_1 = flow;

	var func$6 = convert_1('flow', flow_1);

	func$6.placeholder = placeholder;
	var flow$1 = func$6;

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}

	var _arrayReduce = arrayReduce;

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	var _createBaseFor = createBaseFor;

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = _createBaseFor();

	var _baseFor = baseFor;

	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && _baseFor(object, iteratee, keys_1);
	}

	var _baseForOwn = baseForOwn;

	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike_1(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}

	var _createBaseEach = createBaseEach;

	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = _createBaseEach(_baseForOwn);

	var _baseEach = baseEach;

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}

	var _baseReduce = baseReduce;

	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray_1(collection) ? _arrayReduce : _baseReduce,
	      initAccum = arguments.length < 3;

	  return func(collection, _baseIteratee(iteratee), accumulator, initAccum, _baseEach);
	}

	var reduce_1 = reduce;

	var func$7 = convert_1('reduce', reduce_1);

	func$7.placeholder = placeholder;
	var reduce$1 = func$7;

	function ownKeys$7(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$7(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$7(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }
	var dayPickerDefaultClasses = {
	  container: 'DayPicker',
	  wrapper: 'DayPicker-wrapper',
	  interactionDisabled: 'DayPicker--interactionDisabled',
	  months: 'DayPicker-Months',
	  month: 'DayPicker-Month',
	  navBar: 'DayPicker-NavBar',
	  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
	  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
	  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',
	  caption: 'DayPicker-Caption',
	  weekdays: 'DayPicker-Weekdays',
	  weekdaysRow: 'DayPicker-WeekdaysRow',
	  weekday: 'DayPicker-Weekday',
	  body: 'DayPicker-Body',
	  week: 'DayPicker-Week',
	  weekNumber: 'DayPicker-WeekNumber',
	  day: 'DayPicker-Day',
	  footer: 'DayPicker-Footer',
	  todayButton: 'DayPicker-TodayButton',
	  // default modifiers
	  today: 'DayPicker-Day--today',
	  selected: 'DayPicker-Day--selected',
	  disabled: 'DayPicker-Day--disabled',
	  outside: 'DayPicker-Day--outside',
	  disabledSelected: 'DayPicker-Day--selected DayPicker-Day--disabled'
	};
	var dayPickerInputDefaultClasses = {
	  container: 'DayPickerInput',
	  overlayWrapper: 'DayPickerInput-OverlayWrapper',
	  overlay: 'DayPickerInput-Overlay'
	};

	var extendClassName = function extendClassName(initial, _ref) {
	  var _objectSpread2;

	  var key = _ref[0],
	      value = _ref[1];
	  return _objectSpread$5(_objectSpread$5({}, initial), {}, (_objectSpread2 = {}, _objectSpread2[key] = initial[key] + " " + value, _objectSpread2));
	};

	var extendClassNames = function extendClassNames(base, classes) {
	  return flow$1(entries, reduce$1(extendClassName, base))(classes);
	};

	// `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	var regexpFlags = function () {
	  var that = anObject$1(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};

	// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
	// so we use an intermediate function.
	function RE(s, f) {
	  return RegExp(s, f);
	}

	var UNSUPPORTED_Y = fails$1(function () {
	  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	  var re = RE('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') != null;
	});

	var BROKEN_CARET = fails$1(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = RE('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') != null;
	});

	var regexpStickyHelpers = {
		UNSUPPORTED_Y: UNSUPPORTED_Y,
		BROKEN_CARET: BROKEN_CARET
	};

	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;

	var patchedExec = nativeExec;

	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	})();

	var UNSUPPORTED_Y$1 = regexpStickyHelpers.UNSUPPORTED_Y || regexpStickyHelpers.BROKEN_CARET;

	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1;

	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	    var sticky = UNSUPPORTED_Y$1 && re.sticky;
	    var flags = regexpFlags.call(re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;

	    if (sticky) {
	      flags = flags.replace('y', '');
	      if (flags.indexOf('g') === -1) {
	        flags += 'g';
	      }

	      strCopy = String(str).slice(re.lastIndex);
	      // Support anchored sticky behavior.
	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      }
	      // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.
	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

	    match = nativeExec.call(sticky ? reCopy : re, strCopy);

	    if (sticky) {
	      if (match) {
	        match.input = match.input.slice(charsAdded);
	        match[0] = match[0].slice(charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    return match;
	  };
	}

	var regexpExec = patchedExec;

	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec
	_export$1({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
	  exec: regexpExec
	});

	// TODO: Remove from `core-js@4` since it's moved to entry points







	var SPECIES$4 = wellKnownSymbol$1('species');

	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$1(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});

	// IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
	var REPLACE_KEEPS_$0 = (function () {
	  return 'a'.replace(/./, '$0') === '$0';
	})();

	var REPLACE = wellKnownSymbol$1('replace');
	// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }
	  return false;
	})();

	// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$1(function () {
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	});

	var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
	  var SYMBOL = wellKnownSymbol$1(KEY);

	  var DELEGATES_TO_SYMBOL = !fails$1(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });

	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;

	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {};
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES$4] = function () { return re; };
	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }

	    re.exec = function () { execCalled = true; return null; };

	    re[SYMBOL]('');
	    return !execCalled;
	  });

	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !(
	      REPLACE_SUPPORTS_NAMED_GROUPS &&
	      REPLACE_KEEPS_$0 &&
	      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
	    )) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      if (regexp.exec === regexpExec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	        }
	        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	      }
	      return { done: false };
	    }, {
	      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
	      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
	    });
	    var stringMethod = methods[0];
	    var regexMethod = methods[1];

	    redefine$1(String.prototype, KEY, stringMethod);
	    redefine$1(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return regexMethod.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return regexMethod.call(string, this); }
	    );
	  }

	  if (sham) createNonEnumerableProperty$1(RegExp.prototype[SYMBOL], 'sham', true);
	};

	var MATCH = wellKnownSymbol$1('match');

	// `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp
	var isRegexp = function (it) {
	  var isRegExp;
	  return isObject$2(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw$1(it) == 'RegExp');
	};

	var SPECIES$5 = wellKnownSymbol$1('species');

	// `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor
	var speciesConstructor = function (O, defaultConstructor) {
	  var C = anObject$1(O).constructor;
	  var S;
	  return C === undefined || (S = anObject$1(C)[SPECIES$5]) == undefined ? defaultConstructor : aFunction$2(S);
	};

	// `String.prototype.{ codePointAt, at }` methods implementation
	var createMethod$4 = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = String(requireObjectCoercible$1($this));
	    var position = toInteger$1(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = S.charCodeAt(position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING ? S.charAt(position) : first
	        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	var stringMultibyte = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod$4(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod$4(true)
	};

	var charAt = stringMultibyte.charAt;

	// `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex
	var advanceStringIndex = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};

	// `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec
	var regexpExecAbstract = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }

	  if (classofRaw$1(R) !== 'RegExp') {
	    throw TypeError('RegExp#exec called on incompatible receiver');
	  }

	  return regexpExec.call(R, S);
	};

	var arrayPush$1 = [].push;
	var min$4 = Math.min;
	var MAX_UINT32 = 0xFFFFFFFF;

	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails$1(function () { return !RegExp(MAX_UINT32, 'y'); });

	// @@split logic
	fixRegexpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'.split(/(b)*/)[1] == 'c' ||
	    'test'.split(/(?:)/, -1).length != 4 ||
	    'ab'.split(/(?:ab)*/).length != 2 ||
	    '.'.split(/(.?)(.?)/).length != 4 ||
	    '.'.split(/()()/).length > 1 ||
	    ''.split(/.?/).length
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(requireObjectCoercible$1(this));
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (separator === undefined) return [string];
	      // If `separator` is not a regex, use native split
	      if (!isRegexp(separator)) {
	        return nativeSplit.call(string, separator, lim);
	      }
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy.lastIndex;
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match.length > 1 && match.index < string.length) arrayPush$1.apply(output, match.slice(1));
	          lastLength = match[0].length;
	          lastLastIndex = lastIndex;
	          if (output.length >= lim) break;
	        }
	        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string.length) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output.length > lim ? output.slice(0, lim) : output;
	    };
	  // Chakra, V8
	  } else if ('0'.split(undefined, 0).length) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
	    };
	  } else internalSplit = nativeSplit;

	  return [
	    // `String.prototype.split` method
	    // https://tc39.es/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = requireObjectCoercible$1(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
	      if (res.done) return res.value;

	      var rx = anObject$1(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);

	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');

	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = min$4(toLength$1(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	}, !SUPPORTS_Y);

	var $includes = arrayIncludes.includes;

	 // `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes


	_export({
	  target: 'Array',
	  proto: true
	}, {
	  includes: function includes(el
	  /* , fromIndex = 0 */
	  ) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

	var includes$2 = entryVirtual('Array').includes;

	var MATCH$1 = wellKnownSymbol('match'); // `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp

	var isRegexp$1 = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
	};

	var TypeError$b = global$1.TypeError;

	var notARegexp = function (it) {
	  if (isRegexp$1(it)) {
	    throw TypeError$b("The method doesn't accept regular expressions");
	  }

	  return it;
	};

	var MATCH$2 = wellKnownSymbol('match');

	var correctIsRegexpLogic = function (METHOD_NAME) {
	  var regexp = /./;

	  try {
	    '/./'[METHOD_NAME](regexp);
	  } catch (error1) {
	    try {
	      regexp[MATCH$2] = false;
	      return '/./'[METHOD_NAME](regexp);
	    } catch (error2) {
	      /* empty */
	    }
	  }

	  return false;
	};

	var stringIndexOf = functionUncurryThis(''.indexOf); // `String.prototype.includes` method
	// https://tc39.es/ecma262/#sec-string.prototype.includes

	_export({
	  target: 'String',
	  proto: true,
	  forced: !correctIsRegexpLogic('includes')
	}, {
	  includes: function includes(searchString
	  /* , position = 0 */
	  ) {
	    return !!~stringIndexOf(toString$2(requireObjectCoercible(this)), toString$2(notARegexp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var includes$3 = entryVirtual('String').includes;

	var ArrayPrototype$9 = Array.prototype;
	var StringPrototype = String.prototype;

	var includes$4 = function (it) {
	  var own = it.includes;
	  if (it === ArrayPrototype$9 || objectIsPrototypeOf(ArrayPrototype$9, it) && own === ArrayPrototype$9.includes) return includes$2;

	  if (typeof it == 'string' || it === StringPrototype || objectIsPrototypeOf(StringPrototype, it) && own === StringPrototype.includes) {
	    return includes$3;
	  }

	  return own;
	};

	var includes$5 = includes$4;

	var includes$6 = includes$5;

	var styles$r = {"input__readonly":"telia-react-input__readonly","input__container":"telia-react-input__container","input":"telia-react-input","input__iconWrapper__icon":"telia-react-input__iconWrapper__icon"};

	var _excluded$u = ["type", "className", "inputRef", "iconColor"];

	var Input = function Input(_ref) {
	  var _ref$type = _ref.type,
	      type = _ref$type === void 0 ? 'text' : _ref$type,
	      className = _ref.className,
	      inputRef = _ref.inputRef,
	      _ref$iconColor = _ref.iconColor,
	      iconColor = _ref$iconColor === void 0 ? 'gray500' : _ref$iconColor,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$u);

	  var classNames = [];

	  if (!!props.readonly) {
	    classNames.push(styles$r.input__readonly);
	  }

	  if (!!className) {
	    classNames.push(className);
	  }

	  return /*#__PURE__*/React__default['default'].createElement(BaseInput, _extends_1({
	    type: type,
	    className: classNames,
	    ref: inputRef,
	    iconColor: iconColor
	  }, props));
	};

	// This internal custom input is a class component because it needs to support `ref` for react-day-picker
	var DatePickerInputWrapper = /*#__PURE__*/function (_Component) {
	  inheritsLoose(DatePickerInputWrapper, _Component);

	  function DatePickerInputWrapper() {
	    var _context, _this$props$inputRef;

	    var _this;

	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    _this = _Component.call.apply(_Component, concat$5(_context = [this]).call(_context, args)) || this;
	    _this.inputRef = (_this$props$inputRef = _this.props.inputRef) != null ? _this$props$inputRef : /*#__PURE__*/React__default['default'].createRef();
	    _this.allowedKeys = ['Tab', 'Backspace', 'Enter', 'ArrowLeft', 'ArrowRight', ' '];
	    _this.allowedChars = /^[0-9_./-]*$/;
	    return _this;
	  }

	  var _proto = DatePickerInputWrapper.prototype;

	  // To keep focus on input field after valid date is selected of filled to input
	  _proto.focus = function focus() {
	    var _this$inputRef$curren;

	    (_this$inputRef$curren = this.inputRef.current) == null ? void 0 : _this$inputRef$curren.focus();
	  } // Currently allowed special chars are : "- _ . /" and the following special keys :
	  ;

	  _proto.render = function render() {
	    var _this2 = this;

	    return /*#__PURE__*/React__default['default'].createElement(Input, _extends_1({}, this.props, {
	      onKeyDown: function onKeyDown(e) {
	        var _context2;

	        if (!_this2.allowedChars.test(e.key) && !includes$6(_context2 = _this2.allowedKeys).call(_context2, e.key)) {
	          e.preventDefault();
	        }

	        e.target.value = e.target.value.split(/-|_|\/|,/).join('.');
	      },
	      label: this.props.label || '',
	      className: ['datepicker-input-test', this.props.className],
	      onChange: function onChange(e) {
	        return _this2.props.onChange(e);
	      },
	      iconName: "calendar",
	      inputRef: this.inputRef,
	      iconColor: this.props.errorText ? 'red600' : 'black'
	    }));
	  };

	  return DatePickerInputWrapper;
	}(React.Component);

	var styles$s = {"datepicker":"telia-react-datepicker","icon":"telia-react-icon","datepicker__caption":"telia-react-datepicker__caption","datepicker__container":"telia-react-datepicker__container","datepicker__navButtonPrev":"telia-react-datepicker__navButtonPrev","datepicker__navButtonNext":"telia-react-datepicker__navButtonNext","datepicker__navButtonDisabled":"telia-react-datepicker__navButtonDisabled","datepicker__weekday":"telia-react-datepicker__weekday","datepicker__day":"telia-react-datepicker__day","datepicker__outside":"telia-react-datepicker__outside","datepicker__disabled":"telia-react-datepicker__disabled","datepicker__today":"telia-react-datepicker__today","datepicker__selected":"telia-react-datepicker__selected","datepicker__disabledSelected":"telia-react-datepicker__disabledSelected","datepicker__overlay":"telia-react-datepicker__overlay"};

	var _excluded$v = ["label", "showCustomLabel", "className", "onChange", "dayPickerProps", "placeholderFormat", "locale", "errorText", "helperText", "disabled", "inputRef", "id", "required"];

	function ownKeys$8(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$8(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$8(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }
	var dayPickerClassNamesToBeAppended = {
	  day: styles$s.datepicker__day,
	  today: styles$s.datepicker__today,
	  selected: styles$s.datepicker__selected,
	  disabled: styles$s.datepicker__disabled,
	  outside: styles$s.datepicker__outside,
	  container: styles$s.datepicker__container,
	  caption: styles$s.datepicker__caption,
	  navButtonPrev: styles$s.datepicker__navButtonPrev,
	  navButtonNext: styles$s.datepicker__navButtonNext,
	  navButtonInteractionDisabled: styles$s.datepicker__navButtonDisabled,
	  weekday: styles$s.datepicker__weekday
	};
	var dayPickerClassNames = extendClassNames(dayPickerDefaultClasses, dayPickerClassNamesToBeAppended);

	var DatePicker = function DatePicker(_ref) {
	  var label = _ref.label,
	      showCustomLabel = _ref.showCustomLabel,
	      className = _ref.className,
	      onChange = _ref.onChange,
	      _ref$dayPickerProps = _ref.dayPickerProps,
	      dayPickerProps = _ref$dayPickerProps === void 0 ? null : _ref$dayPickerProps,
	      _ref$placeholderForma = _ref.placeholderFormat,
	      placeholderFormat = _ref$placeholderForma === void 0 ? 'D.M.YYYY' : _ref$placeholderForma,
	      _ref$locale = _ref.locale,
	      locale = _ref$locale === void 0 ? 'fi' : _ref$locale,
	      errorText = _ref.errorText,
	      helperText = _ref.helperText,
	      disabled = _ref.disabled,
	      inputRef = _ref.inputRef,
	      id = _ref.id,
	      required = _ref.required,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$v);

	  var handleDayChange = function handleDayChange(selectedDay, modifiers) {
	    onChange(selectedDay, modifiers);
	  };

	  var dayPickerInputClassNamesToBeAppended = _objectSpread$6(_objectSpread$6({}, dayPickerProps == null ? void 0 : dayPickerProps.inputClassNames), {}, {
	    overlay: styles$s.datepicker__overlay,
	    container: styles$s.datepicker
	  });

	  if (className) {
	    dayPickerInputClassNamesToBeAppended.container = className;
	  }

	  var dayPickerInputClassNames = extendClassNames(dayPickerInputDefaultClasses, dayPickerInputClassNamesToBeAppended);
	  return /*#__PURE__*/React__default['default'].createElement(DayPickerInput, _extends_1({
	    component: DatePickerInputWrapper,
	    inputProps: {
	      label: label,
	      errorText: errorText,
	      helperText: helperText,
	      disabled: disabled,
	      id: id,
	      showCustomLabel: showCustomLabel,
	      inputRef: inputRef,
	      required: required
	    },
	    onDayChange: handleDayChange,
	    classNames: dayPickerInputClassNames,
	    dayPickerProps: _objectSpread$6(_objectSpread$6({}, dayPickerProps), {}, {
	      classNames: dayPickerClassNames,
	      renderDay: function renderDay(day) {
	        return /*#__PURE__*/React__default['default'].createElement("span", null, day.getDate());
	      },
	      locale: locale,
	      localeUtils: moment$1
	    }),
	    formatDate: moment$1.formatDate,
	    parseDate: moment$1.parseDate,
	    placeholder: moment$1.formatDate(get$3('initialMonth', dayPickerProps) || new Date(), placeholderFormat, locale)
	  }, props));
	};

	var styles$t = {"datePickerWithRange_required":"telia-react-datePickerWithRange_required","datePickerWithRange_inputContainer":"telia-react-datePickerWithRange_inputContainer","datePickerWithRange_inputContainer__error":"telia-react-datePickerWithRange_inputContainer__error","datePickerWithRange_inputContainer__disabled":"telia-react-datePickerWithRange_inputContainer__disabled","datePickerWithRange_fromDatePicker":"telia-react-datePickerWithRange_fromDatePicker","input__container":"telia-react-input__container","input__iconWrapper":"telia-react-input__iconWrapper","datePickerWithRange_toDatePicker":"telia-react-datePickerWithRange_toDatePicker","icon":"telia-react-icon","datepicker__overlay":"telia-react-datepicker__overlay","inputMessage_textContainer":"telia-react-inputMessage_textContainer","datePickerWithRange":"telia-react-datePickerWithRange","datepicker__selected":"telia-react-datepicker__selected","DayPicker-Day--disabled":"telia-react-DayPicker-Day--disabled","DayPicker-Day--outside":"telia-react-DayPicker-Day--outside","datePickerWithRange_rangeStart":"telia-react-datePickerWithRange_rangeStart","datePickerWithRange_rangeEnd":"telia-react-datePickerWithRange_rangeEnd","datePickerWithRange_spacer":"telia-react-datePickerWithRange_spacer","datePickerWithRange_overlayWrapper":"telia-react-datePickerWithRange_overlayWrapper"};

	var _excluded$w = ["fromDatePicker", "toDatePicker", "showCustomLabel", "label", "className", "errorText", "helperText", "disabled", "required"];

	function ownKeys$9(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$9(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$9(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }
	var dayPickerInputClassNamesToBeAppended = {
	  overlayWrapper: styles$t.datePickerWithRange_overlayWrapper
	};
	var dayPickerInputClassNames = extendClassNames(dayPickerInputDefaultClasses, dayPickerInputClassNamesToBeAppended);

	var DatePickerWithRange = function DatePickerWithRange(_ref) {
	  var _modifiers, _ref2;

	  var fromDatePicker = _ref.fromDatePicker,
	      toDatePicker = _ref.toDatePicker,
	      showCustomLabel = _ref.showCustomLabel,
	      label = _ref.label,
	      className = _ref.className,
	      errorText = _ref.errorText,
	      helperText = _ref.helperText,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$w);

	  var fromDatePickerRef = React.useRef(null);
	  var toDatePickerRef = React.useRef(null);
	  var fromDate = fromDatePicker.value;
	  var toDate = toDatePicker.value;
	  /* istanbul ignore next */

	  var focusToDatePicker = function focusToDatePicker() {
	    /* istanbul ignore else */
	    if (toDatePickerRef && toDatePickerRef.current) {
	      toDatePickerRef.current.focus();
	    }
	  };

	  var handleFromDateClick = function handleFromDateClick() {
	    // Hack to fix resetting ref on render
	    // https://stackoverflow.com/questions/35522220/react-ref-with-focus-doesnt-work-without-settimeout-my-example
	    window.setTimeout(focusToDatePicker, 0);
	  };
	  /* istanbul ignore next */


	  var selectedDays = fromDate && toDate ? [fromDate, {
	    from: fromDate,
	    to: toDate
	  }] : undefined;
	  var modifiers = (_modifiers = {}, _modifiers[styles$t.datePickerWithRange_rangeStart] = fromDate, _modifiers[styles$t.datePickerWithRange_rangeEnd] = toDate, _modifiers);
	  var resolveLabel = label ? required ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Span, null, label, " "), /*#__PURE__*/React__default['default'].createElement(Span, {
	    className: styles$t.datePickerWithRange_required
	  }, "*")) : label : /*#__PURE__*/React__default['default'].createElement(Span, null, "\xA0");
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({}, props, {
	    className: [styles$t.datePickerWithRange, className],
	    inlineBlock: true
	  }), !showCustomLabel && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    size: "sm",
	    block: true,
	    color: disabled ? 'gray400' : 'black',
	    tagName: "label",
	    htmlFor: fromDatePicker == null ? void 0 : fromDatePicker.id
	  }, resolveLabel), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  })), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    occupyVerticalSpace: false,
	    className: [styles$t.datePickerWithRange_inputContainer, (_ref2 = {}, _ref2[styles$t.datePickerWithRange_inputContainer__error] = !!errorText || errorText === ' ', _ref2[styles$t.datePickerWithRange_inputContainer__disabled] = !!disabled, _ref2)]
	  }, /*#__PURE__*/React__default['default'].createElement(DatePicker, _extends_1({}, fromDatePicker, {
	    disabled: disabled,
	    showCustomLabel: true,
	    className: styles$t.datePickerWithRange_fromDatePicker,
	    dayPickerProps: {
	      selectedDays: selectedDays,
	      disabledDays: toDate && {
	        after: toDate
	      },
	      numberOfMonths: 2,
	      modifiers: modifiers,
	      inputClassNames: _objectSpread$7({}, dayPickerInputClassNames),
	      onDayClick: handleFromDateClick,
	      initialMonth: toDate
	    },
	    onDayChange: fromDatePicker.onChange,
	    inputRef: fromDatePickerRef
	  })), /*#__PURE__*/React__default['default'].createElement("label", null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true,
	    centeredHorizontally: true,
	    className: styles$t.datePickerWithRange_spacer
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    "data-testid": "separator-icon",
	    "aria-label": label,
	    name: 'chevron-right',
	    size: 'xs',
	    color: disabled ? 'gray400' : 'black'
	  }))), /*#__PURE__*/React__default['default'].createElement(DatePicker, _extends_1({}, toDatePicker, {
	    disabled: disabled,
	    showCustomLabel: true,
	    className: styles$t.datePickerWithRange_toDatePicker,
	    dayPickerProps: {
	      selectedDays: selectedDays,
	      disabledDays: fromDate && {
	        before: fromDate
	      },
	      numberOfMonths: 2,
	      modifiers: modifiers,
	      inputClassNames: _objectSpread$7({}, dayPickerInputClassNames),
	      initialMonth: fromDate
	    },
	    onDayChange: toDatePicker.onChange,
	    inputRef: toDatePickerRef,
	    errorText: errorText
	  }))), !!errorText && errorText !== ' ' && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xxs"
	  }), /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: errorText,
	    color: "red600"
	  })), helperText ? /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: helperText,
	    color: "gray500"
	  }) : null);
	};

	var styles$u = {"dropdown":"telia-react-dropdown","input__container":"telia-react-input__container","input__container_error":"telia-react-input__container_error","dropdown_open":"telia-react-dropdown_open","inputMessage_textContainer":"telia-react-inputMessage_textContainer","inputMessage_text":"telia-react-inputMessage_text","input":"telia-react-input","input__container_disabled":"telia-react-input__container_disabled","optionlist":"telia-react-optionlist"};

	var _excluded$x = ["options", "onChange", "selectedOption", "errorText", "disabled", "className"];

	var Dropdown = function Dropdown(_ref) {
	  var _ref2;

	  var options = _ref.options,
	      onChange = _ref.onChange,
	      selectedOption = _ref.selectedOption,
	      errorText = _ref.errorText,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$x);

	  var _useState = React.useState(false),
	      open = _useState[0],
	      setOpen = _useState[1];

	  var _useState2 = React.useState(),
	      focusedOptionId = _useState2[0],
	      setFocusedOptionId = _useState2[1];

	  var inputElement = React.useRef(null);
	  var dropdownElement = React.useRef(null);

	  var updateFocusedOptionId = function updateFocusedOptionId() {
	    setFocusedOptionId(selectedOption == null ? void 0 : selectedOption.value);
	  };

	  var focusOnFirstFocusableOption = function focusOnFirstFocusableOption() {
	    var firstFocusableOption = filter$3(options).call(options, function (option) {
	      return !option.disabled;
	    })[0];

	    setFocusedOptionId(firstFocusableOption.value);
	  };

	  var handleInputClick = function handleInputClick() {
	    if (open) {
	      setOpen(false);
	    } else {
	      if (!!selectedOption) {
	        updateFocusedOptionId();
	      }

	      setOpen(true);
	    }
	  };

	  var handleOptionListBlur = function handleOptionListBlur(event) {
	    var isFocusEvent = function isFocusEvent(e) {
	      return 'relatedTarget' in e;
	    };
	    /* This logic is related to the keyboard usability (closing on ESC) which is not supported in IE. That's why we leave IE out  */

	    /* istanbul ignore else */


	    if (!isIE11) {
	      var _dropdownElement$curr;

	      if (!isFocusEvent(event) || !((_dropdownElement$curr = dropdownElement.current) != null && _dropdownElement$curr.contains(event.relatedTarget))) {
	        var _inputElement$current;

	        setOpen(false);
	        (_inputElement$current = inputElement.current) == null ? void 0 : _inputElement$current.focus();
	      }
	    }
	  };

	  var handleOnBlur = function handleOnBlur(event) {
	    var isFocusEvent = function isFocusEvent(e) {
	      return 'relatedTarget' in e;
	    };
	    /* istanbul ignore else */


	    if (!isIE11) {
	      var _dropdownElement$curr2;

	      /* istanbul ignore else  */
	      if (!isFocusEvent(event) || !((_dropdownElement$curr2 = dropdownElement.current) != null && _dropdownElement$curr2.contains(event.relatedTarget)) && open) {
	        setOpen(false);
	      }
	    }
	    /* istanbul ignore next  */


	    if (isIE11 && typeof document !== 'undefined') {
	      var _context;

	      /* Prevent the onBlur in IE if user has clicked an option from the list or the scrollbar inside the optionlist */
	      if (!!document.activeElement && indexOf$7(_context = document.activeElement.className).call(_context, 'telia-react-optionlist') < 0) {
	        setOpen(false);
	      }
	    }
	  };

	  var handleOptionSelect = function handleOptionSelect(event, option) {
	    var _inputElement$current2;

	    setOpen(false);
	    (_inputElement$current2 = inputElement.current) == null ? void 0 : _inputElement$current2.focus();
	    onChange(event, option);
	  };

	  var keyDown = function keyDown(event) {
	    if (event.key === 'Enter') {
	      handleInputClick();
	    }

	    if (event.key === 'ArrowDown' && !open || event.key === 'ArrowUp' && !open) {
	      event.preventDefault();

	      if (!!selectedOption) {
	        updateFocusedOptionId();
	      } else {
	        focusOnFirstFocusableOption();
	      }

	      setOpen(true);
	    }
	  };

	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: classnames([styles$u.dropdown, className, (_ref2 = {}, _ref2[styles$u.dropdown_open] = open, _ref2)]),
	    ref: dropdownElement,
	    onKeyDown: keyDown,
	    onBlur: handleOnBlur
	  }, /*#__PURE__*/React__default['default'].createElement(BaseInput, _extends_1({}, props, {
	    disabled: disabled,
	    wrapperTabIndex: -1,
	    confirmed: false,
	    iconName: open ? 'chevron-up' : 'chevron-down',
	    iconColor: open ? 'purple500' : 'black',
	    value: selectedOption ? selectedOption.secondaryLabel ? selectedOption.secondaryLabel : selectedOption.label : undefined,
	    inputTabIndex: -1,
	    readonly: true,
	    onClick: disabled ? undefined : handleInputClick,
	    ref: inputElement,
	    errorText: errorText && errorText === ' ' ? ' ' : errorText,
	    borderRadius: {
	      size: 'sm'
	    }
	  })), !!open && /*#__PURE__*/React__default['default'].createElement(OptionList, {
	    options: options,
	    onBlur: handleOptionListBlur,
	    optionOnClick: handleOptionSelect,
	    focusedOptionId: focusedOptionId
	  }));
	};

	function _typeof$1(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof$1 = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof$1 = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof$1(obj);
	}

	function _defineProperty$3(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function ownKeys$a(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);

	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }

	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys$a(Object(source), true).forEach(function (key) {
	        _defineProperty$3(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$a(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _objectWithoutPropertiesLoose$1(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;

	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }

	  return target;
	}

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = _objectWithoutPropertiesLoose$1(source, excluded);
	  var key, i;

	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }

	  return target;
	}

	function _extends$4p() {
	  _extends$4p = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  return _extends$4p.apply(this, arguments);
	}

	function _classCallCheck$7(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$7(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf(o, p);
	}

	function _inherits$7(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}

	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}

	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;

	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}

	var _typeof_1 = createCommonjsModule(function (module) {
	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };

	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };

	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }

	  return _typeof(obj);
	}

	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;
	});

	var _typeof$2 = /*@__PURE__*/getDefaultExportFromCjs(_typeof_1);

	function _possibleConstructorReturn$7(self, call) {
	  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }

	  return _assertThisInitialized(self);
	}

	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct();
	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf(Derived),
	        result;

	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf(this).constructor;
	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }

	    return _possibleConstructorReturn$7(this, result);
	  };
	}

	var raf = function raf(callback) {
	  return +setTimeout(callback, 16);
	};

	var caf = function caf(num) {
	  return clearTimeout(num);
	};

	if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
	  raf = function raf(callback) {
	    return window.requestAnimationFrame(callback);
	  };

	  caf = function caf(handle) {
	    return window.cancelAnimationFrame(handle);
	  };
	}

	var rafUUID = 0;
	var rafIds = new Map();

	function cleanup(id) {
	  rafIds.delete(id);
	}

	function wrapperRaf(callback) {
	  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  rafUUID += 1;
	  var id = rafUUID;

	  function callRef(leftTimes) {
	    if (leftTimes === 0) {
	      // Clean up
	      cleanup(id); // Trigger

	      callback();
	    } else {
	      // Next raf
	      var realId = raf(function () {
	        callRef(leftTimes - 1);
	      }); // Bind real raf id

	      rafIds.set(id, realId);
	    }
	  }

	  callRef(times);
	  return id;
	}

	wrapperRaf.cancel = function (id) {
	  var realId = rafIds.get(id);
	  cleanup(realId);
	  return caf(realId);
	};

	function contains$1(root, n) {
	  if (!root) {
	    return false;
	  }

	  return root.contains(n);
	}

	/**
	 * Return if a node is a DOM node. Else will return by `findDOMNode`
	 */

	function findDOMNode(node) {
	  if (node instanceof HTMLElement) {
	    return node;
	  }

	  return ReactDOM__default['default'].findDOMNode(node);
	}

	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if (_typeof$1(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	/**
	 * Merge refs into one ref function to support ref passing.
	 */

	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }

	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}
	function supportRef(nodeOrComponent) {
	  var _type$prototype, _nodeOrComponent$prot;

	  var type = reactIs.isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type; // Function component node

	  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
	    return false;
	  } // Class component


	  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
	    return false;
	  }

	  return true;
	}
	/* eslint-enable */

	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = ReactDOM__default['default'].unstable_batchedUpdates ? function run(e) {
	    ReactDOM__default['default'].unstable_batchedUpdates(cb, e);
	  } : cb;

	  if (target.addEventListener) {
	    target.addEventListener(eventType, callback, option);
	  }

	  return {
	    remove: function remove() {
	      if (target.removeEventListener) {
	        target.removeEventListener(eventType, callback);
	      }
	    }
	  };
	}

	function canUseDom() {
	  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	}

	var Portal$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
	  var didUpdate = props.didUpdate,
	      getContainer = props.getContainer,
	      children = props.children;
	  var containerRef = React.useRef(); // Ref return nothing, only for wrapper check exist

	  React.useImperativeHandle(ref, function () {
	    return {};
	  }); // Create container in client side with sync to avoid useEffect not get ref

	  var initRef = React.useRef(false);

	  if (!initRef.current && canUseDom()) {
	    containerRef.current = getContainer();
	    initRef.current = true;
	  } // [Legacy] Used by `rc-trigger`


	  React.useEffect(function () {
	    didUpdate === null || didUpdate === void 0 ? void 0 : didUpdate(props);
	  });
	  React.useEffect(function () {
	    return function () {
	      var _containerRef$current, _containerRef$current2; // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
	      // Since some component use `Portal` directly, we have to keep the logic here.


	      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.parentNode) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.removeChild(containerRef.current);
	    };
	  }, []);
	  return containerRef.current ? /*#__PURE__*/ReactDOM__default['default'].createPortal(children, containerRef.current) : null;
	});

	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }

	  return a1[0] === a2[0] && a1[1] === a2[1];
	}

	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return _objectSpread2(_objectSpread2({}, baseAlign), align);
	}
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  var placements = Object.keys(builtinPlacements);

	  for (var i = 0; i < placements.length; i += 1) {
	    var placement = placements[i];

	    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	      return "".concat(prefixCls, "-placement-").concat(placement);
	    }
	  }

	  return '';
	}

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}

	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;

	  var _s, _e;

	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);

	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }

	  return _arr;
	}

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;

	  for (var i = 0, arr2 = new Array(len); i < len; i++) {
	    arr2[i] = arr[i];
	  }

	  return arr2;
	}

	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}

	var isMobile = (function () {
	  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
	    return false;
	  }

	  var agent = navigator.userAgent || navigator.vendor || window.opera;

	  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4))) {
	    return true;
	  }

	  return false;
	});

	// Event wrapper. Copy from react source code

	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
	  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
	  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
	  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
	  return prefixes;
	}

	function getVendorPrefixes(domSupport, win) {
	  var prefixes = {
	    animationend: makePrefixMap('Animation', 'AnimationEnd'),
	    transitionend: makePrefixMap('Transition', 'TransitionEnd')
	  };

	  if (domSupport) {
	    if (!('AnimationEvent' in win)) {
	      delete prefixes.animationend.animation;
	    }

	    if (!('TransitionEvent' in win)) {
	      delete prefixes.transitionend.transition;
	    }
	  }

	  return prefixes;
	}
	var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== 'undefined' ? window : {});
	var style$2 = {};

	if (canUseDom()) {
	  var _document$createEleme = document.createElement('div');

	  style$2 = _document$createEleme.style;
	}

	var prefixedEventNames = {};
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  }

	  var prefixMap = vendorPrefixes[eventName];

	  if (prefixMap) {
	    var stylePropList = Object.keys(prefixMap);
	    var len = stylePropList.length;

	    for (var i = 0; i < len; i += 1) {
	      var styleProp = stylePropList[i];

	      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style$2) {
	        prefixedEventNames[eventName] = prefixMap[styleProp];
	        return prefixedEventNames[eventName];
	      }
	    }
	  }

	  return '';
	}
	var internalAnimationEndName = getVendorPrefixedEventName('animationend');
	var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
	var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
	var animationEndName = internalAnimationEndName || 'animationend';
	var transitionEndName = internalTransitionEndName || 'transitionend';
	function getTransitionName(transitionName, transitionType) {
	  if (!transitionName) return null;

	  if (_typeof$1(transitionName) === 'object') {
	    var type = transitionType.replace(/-\w/g, function (match) {
	      return match[1].toUpperCase();
	    });
	    return transitionName[type];
	  }

	  return "".concat(transitionName, "-").concat(transitionType);
	}

	var STATUS_NONE = 'none';
	var STATUS_APPEAR = 'appear';
	var STATUS_ENTER = 'enter';
	var STATUS_LEAVE = 'leave';
	var STEP_NONE = 'none';
	var STEP_PREPARE = 'prepare';
	var STEP_START = 'start';
	var STEP_ACTIVE = 'active';
	var STEP_ACTIVATED = 'end';

	function useMountStatus(defaultValue) {
	  var destroyRef = React.useRef(false);

	  var _useState = React.useState(defaultValue),
	      _useState2 = _slicedToArray(_useState, 2),
	      val = _useState2[0],
	      setVal = _useState2[1];

	  function setValue(next) {
	    if (!destroyRef.current) {
	      setVal(next);
	    }
	  }

	  React.useEffect(function () {
	    return function () {
	      destroyRef.current = true;
	    };
	  }, []);
	  return [val, setValue];
	}

	var useIsomorphicLayoutEffect = canUseDom() ? React.useLayoutEffect : React.useEffect;

	var useNextFrame = (function () {
	  var nextFrameRef = React.useRef(null);

	  function cancelNextFrame() {
	    wrapperRaf.cancel(nextFrameRef.current);
	  }

	  function nextFrame(callback) {
	    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	    cancelNextFrame();
	    var nextFrameId = wrapperRaf(function () {
	      if (delay <= 1) {
	        callback({
	          isCanceled: function isCanceled() {
	            return nextFrameId !== nextFrameRef.current;
	          }
	        });
	      } else {
	        nextFrame(callback, delay - 1);
	      }
	    });
	    nextFrameRef.current = nextFrameId;
	  }

	  React.useEffect(function () {
	    return function () {
	      cancelNextFrame();
	    };
	  }, []);
	  return [nextFrame, cancelNextFrame];
	});

	var STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
	/** Skip current step */

	var SkipStep = false;
	/** Current step should be update in */

	var DoStep = true;
	function isActive(step) {
	  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
	}
	var useStepQueue = (function (status, callback) {
	  var _React$useState = React.useState(STEP_NONE),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      step = _React$useState2[0],
	      setStep = _React$useState2[1];

	  var _useNextFrame = useNextFrame(),
	      _useNextFrame2 = _slicedToArray(_useNextFrame, 2),
	      nextFrame = _useNextFrame2[0],
	      cancelNextFrame = _useNextFrame2[1];

	  function startQueue() {
	    setStep(STEP_PREPARE);
	  }

	  useIsomorphicLayoutEffect(function () {
	    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
	      var index = STEP_QUEUE.indexOf(step);
	      var nextStep = STEP_QUEUE[index + 1];
	      var result = callback(step);

	      if (result === SkipStep) {
	        // Skip when no needed
	        setStep(nextStep);
	      } else {
	        // Do as frame for step update
	        nextFrame(function (info) {
	          function doNext() {
	            // Skip since current queue is ood
	            if (info.isCanceled()) return;
	            setStep(nextStep);
	          }

	          if (result === true) {
	            doNext();
	          } else {
	            // Only promise should be async
	            Promise.resolve(result).then(doNext);
	          }
	        });
	      }
	    }
	  }, [status, step]);
	  React.useEffect(function () {
	    return function () {
	      cancelNextFrame();
	    };
	  }, []);
	  return [startQueue, step];
	});

	var useDomMotionEvents = (function (callback) {
	  var cacheElementRef = React.useRef(); // Cache callback

	  var callbackRef = React.useRef(callback);
	  callbackRef.current = callback; // Internal motion event handler

	  var onInternalMotionEnd = React.useCallback(function (event) {
	    callbackRef.current(event);
	  }, []); // Remove events

	  function removeMotionEvents(element) {
	    if (element) {
	      element.removeEventListener(transitionEndName, onInternalMotionEnd);
	      element.removeEventListener(animationEndName, onInternalMotionEnd);
	    }
	  } // Patch events


	  function patchMotionEvents(element) {
	    if (cacheElementRef.current && cacheElementRef.current !== element) {
	      removeMotionEvents(cacheElementRef.current);
	    }

	    if (element && element !== cacheElementRef.current) {
	      element.addEventListener(transitionEndName, onInternalMotionEnd);
	      element.addEventListener(animationEndName, onInternalMotionEnd); // Save as cache in case dom removed trigger by `motionDeadline`

	      cacheElementRef.current = element;
	    }
	  } // Clean up when removed


	  React.useEffect(function () {
	    return function () {
	      removeMotionEvents(cacheElementRef.current);
	    };
	  }, []);
	  return [patchMotionEvents, removeMotionEvents];
	});

	function useStatus(supportMotion, visible, getElement, _ref) {
	  var _ref$motionEnter = _ref.motionEnter,
	      motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
	      _ref$motionAppear = _ref.motionAppear,
	      motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
	      _ref$motionLeave = _ref.motionLeave,
	      motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
	      motionDeadline = _ref.motionDeadline,
	      motionLeaveImmediately = _ref.motionLeaveImmediately,
	      onAppearPrepare = _ref.onAppearPrepare,
	      onEnterPrepare = _ref.onEnterPrepare,
	      onLeavePrepare = _ref.onLeavePrepare,
	      onAppearStart = _ref.onAppearStart,
	      onEnterStart = _ref.onEnterStart,
	      onLeaveStart = _ref.onLeaveStart,
	      onAppearActive = _ref.onAppearActive,
	      onEnterActive = _ref.onEnterActive,
	      onLeaveActive = _ref.onLeaveActive,
	      onAppearEnd = _ref.onAppearEnd,
	      onEnterEnd = _ref.onEnterEnd,
	      onLeaveEnd = _ref.onLeaveEnd,
	      onVisibleChanged = _ref.onVisibleChanged; // Used for outer render usage to avoid `visible: false & status: none` to render nothing

	  var _useState = useMountStatus(),
	      _useState2 = _slicedToArray(_useState, 2),
	      asyncVisible = _useState2[0],
	      setAsyncVisible = _useState2[1];

	  var _useState3 = useMountStatus(STATUS_NONE),
	      _useState4 = _slicedToArray(_useState3, 2),
	      status = _useState4[0],
	      setStatus = _useState4[1];

	  var _useState5 = useMountStatus(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      style = _useState6[0],
	      setStyle = _useState6[1];

	  var mountedRef = React.useRef(false);
	  var deadlineRef = React.useRef(null);
	  var destroyedRef = React.useRef(false); // =========================== Dom Node ===========================

	  var cacheElementRef = React.useRef(null);

	  function getDomElement() {
	    var element = getElement();
	    return element || cacheElementRef.current;
	  } // ========================== Motion End ==========================


	  var activeRef = React.useRef(false);

	  function onInternalMotionEnd(event) {
	    var element = getDomElement();

	    if (event && !event.deadline && event.target !== element) {
	      // event exists
	      // not initiated by deadline
	      // transitionEnd not fired by inner elements
	      return;
	    }

	    var canEnd;

	    if (status === STATUS_APPEAR && activeRef.current) {
	      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
	    } else if (status === STATUS_ENTER && activeRef.current) {
	      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
	    } else if (status === STATUS_LEAVE && activeRef.current) {
	      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
	    } // Only update status when `canEnd` and not destroyed


	    if (canEnd !== false && !destroyedRef.current) {
	      setStatus(STATUS_NONE);
	      setStyle(null);
	    }
	  }

	  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
	      _useDomMotionEvents2 = _slicedToArray(_useDomMotionEvents, 1),
	      patchMotionEvents = _useDomMotionEvents2[0]; // ============================= Step =============================


	  var eventHandlers = React.useMemo(function () {
	    var _ref2, _ref3, _ref4;

	    switch (status) {
	      case 'appear':
	        return _ref2 = {}, _defineProperty$3(_ref2, STEP_PREPARE, onAppearPrepare), _defineProperty$3(_ref2, STEP_START, onAppearStart), _defineProperty$3(_ref2, STEP_ACTIVE, onAppearActive), _ref2;

	      case 'enter':
	        return _ref3 = {}, _defineProperty$3(_ref3, STEP_PREPARE, onEnterPrepare), _defineProperty$3(_ref3, STEP_START, onEnterStart), _defineProperty$3(_ref3, STEP_ACTIVE, onEnterActive), _ref3;

	      case 'leave':
	        return _ref4 = {}, _defineProperty$3(_ref4, STEP_PREPARE, onLeavePrepare), _defineProperty$3(_ref4, STEP_START, onLeaveStart), _defineProperty$3(_ref4, STEP_ACTIVE, onLeaveActive), _ref4;

	      default:
	        return {};
	    }
	  }, [status]);

	  var _useStepQueue = useStepQueue(status, function (newStep) {
	    // Only prepare step can be skip
	    if (newStep === STEP_PREPARE) {
	      var onPrepare = eventHandlers[STEP_PREPARE];

	      if (!onPrepare) {
	        return SkipStep;
	      }

	      return onPrepare(getDomElement());
	    } // Rest step is sync update
	    // Rest step is sync update


	    if (step in eventHandlers) {
	      var _eventHandlers$step;

	      setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
	    }

	    if (step === STEP_ACTIVE) {
	      // Patch events when motion needed
	      patchMotionEvents(getDomElement());

	      if (motionDeadline > 0) {
	        clearTimeout(deadlineRef.current);
	        deadlineRef.current = setTimeout(function () {
	          onInternalMotionEnd({
	            deadline: true
	          });
	        }, motionDeadline);
	      }
	    }

	    return DoStep;
	  }),
	      _useStepQueue2 = _slicedToArray(_useStepQueue, 2),
	      startStep = _useStepQueue2[0],
	      step = _useStepQueue2[1];

	  var active = isActive(step);
	  activeRef.current = active; // ============================ Status ============================
	  // Update with new status

	  useIsomorphicLayoutEffect(function () {
	    setAsyncVisible(visible);
	    var isMounted = mountedRef.current;
	    mountedRef.current = true;

	    if (!supportMotion) {
	      return;
	    }

	    var nextStatus; // Appear

	    if (!isMounted && visible && motionAppear) {
	      nextStatus = STATUS_APPEAR;
	    } // Enter


	    if (isMounted && visible && motionEnter) {
	      nextStatus = STATUS_ENTER;
	    } // Leave


	    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
	      nextStatus = STATUS_LEAVE;
	    } // Update to next status


	    if (nextStatus) {
	      setStatus(nextStatus);
	      startStep();
	    }
	  }, [visible]); // ============================ Effect ============================
	  // Reset when motion changed

	  React.useEffect(function () {
	    if ( // Cancel appear
	    status === STATUS_APPEAR && !motionAppear || // Cancel enter
	    status === STATUS_ENTER && !motionEnter || // Cancel leave
	    status === STATUS_LEAVE && !motionLeave) {
	      setStatus(STATUS_NONE);
	    }
	  }, [motionAppear, motionEnter, motionLeave]);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(deadlineRef.current);
	      destroyedRef.current = true;
	    };
	  }, []); // Trigger `onVisibleChanged`

	  React.useEffect(function () {
	    if (asyncVisible !== undefined && status === STATUS_NONE) {
	      onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
	    }
	  }, [asyncVisible, status]); // ============================ Styles ============================

	  var mergedStyle = style;

	  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
	    mergedStyle = _objectSpread2({
	      transition: 'none'
	    }, mergedStyle);
	  }

	  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
	}

	var DomWrapper = /*#__PURE__*/function (_React$Component) {
	  _inherits$7(DomWrapper, _React$Component);

	  var _super = _createSuper(DomWrapper);

	  function DomWrapper() {
	    _classCallCheck$7(this, DomWrapper);

	    return _super.apply(this, arguments);
	  }

	  _createClass$7(DomWrapper, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);

	  return DomWrapper;
	}(React.Component);

	/**
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */

	function genCSSMotion(config) {
	  var transitionSupport = config;

	  if (_typeof$1(config) === 'object') {
	    transitionSupport = config.transitionSupport;
	  }

	  function isSupportTransition(props) {
	    return !!(props.motionName && transitionSupport);
	  }

	  var CSSMotion = /*#__PURE__*/React.forwardRef(function (props, ref) {
	    var _props$visible = props.visible,
	        visible = _props$visible === void 0 ? true : _props$visible,
	        _props$removeOnLeave = props.removeOnLeave,
	        removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
	        forceRender = props.forceRender,
	        children = props.children,
	        motionName = props.motionName,
	        leavedClassName = props.leavedClassName,
	        eventProps = props.eventProps;
	    var supportMotion = isSupportTransition(props); // Ref to the react node, it may be a HTMLElement

	    var nodeRef = React.useRef(); // Ref to the dom wrapper in case ref can not pass to HTMLElement

	    var wrapperNodeRef = React.useRef();

	    function getDomElement() {
	      try {
	        return findDOMNode(nodeRef.current || wrapperNodeRef.current);
	      } catch (e) {
	        // Only happen when `motionDeadline` trigger but element removed.
	        return null;
	      }
	    }

	    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
	        _useStatus2 = _slicedToArray(_useStatus, 4),
	        status = _useStatus2[0],
	        statusStep = _useStatus2[1],
	        statusStyle = _useStatus2[2],
	        mergedVisible = _useStatus2[3]; // Record whether content has rended
	    // Will return null for un-rendered even when `removeOnLeave={false}`


	    var renderedRef = React.useRef(mergedVisible);

	    if (mergedVisible) {
	      renderedRef.current = true;
	    } // ====================== Refs ======================


	    var originRef = React.useRef(ref);
	    originRef.current = ref;
	    var setNodeRef = React.useCallback(function (node) {
	      nodeRef.current = node;
	      fillRef(originRef.current, node);
	    }, []); // ===================== Render =====================

	    var motionChildren;

	    var mergedProps = _objectSpread2(_objectSpread2({}, eventProps), {}, {
	      visible: visible
	    });

	    if (!children) {
	      // No children
	      motionChildren = null;
	    } else if (status === STATUS_NONE || !isSupportTransition(props)) {
	      // Stable children
	      if (mergedVisible) {
	        motionChildren = children(_objectSpread2({}, mergedProps), setNodeRef);
	      } else if (!removeOnLeave && renderedRef.current) {
	        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
	          className: leavedClassName
	        }), setNodeRef);
	      } else if (forceRender) {
	        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
	          style: {
	            display: 'none'
	          }
	        }), setNodeRef);
	      } else {
	        motionChildren = null;
	      }
	    } else {
	      var _classNames; // In motion


	      var statusSuffix;

	      if (statusStep === STEP_PREPARE) {
	        statusSuffix = 'prepare';
	      } else if (isActive(statusStep)) {
	        statusSuffix = 'active';
	      } else if (statusStep === STEP_START) {
	        statusSuffix = 'start';
	      }

	      motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
	        className: classnames$1(getTransitionName(motionName, status), (_classNames = {}, _defineProperty$3(_classNames, getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix)), statusSuffix), _defineProperty$3(_classNames, motionName, typeof motionName === 'string'), _classNames)),
	        style: statusStyle
	      }), setNodeRef);
	    }

	    return /*#__PURE__*/React.createElement(DomWrapper, {
	      ref: wrapperNodeRef
	    }, motionChildren);
	  });
	  CSSMotion.displayName = 'CSSMotion';
	  return CSSMotion;
	}
	var CSSMotion = genCSSMotion(supportTransition);

	function getMotion(_ref) {
	  var prefixCls = _ref.prefixCls,
	      motion = _ref.motion,
	      animation = _ref.animation,
	      transitionName = _ref.transitionName;

	  if (motion) {
	    return motion;
	  }

	  if (animation) {
	    return {
	      motionName: "".concat(prefixCls, "-").concat(animation)
	    };
	  }

	  if (transitionName) {
	    return {
	      motionName: transitionName
	    };
	  }

	  return null;
	}

	function Mask(props) {
	  var prefixCls = props.prefixCls,
	      visible = props.visible,
	      zIndex = props.zIndex,
	      mask = props.mask,
	      maskMotion = props.maskMotion,
	      maskAnimation = props.maskAnimation,
	      maskTransitionName = props.maskTransitionName;

	  if (!mask) {
	    return null;
	  }

	  var motion = {};

	  if (maskMotion || maskTransitionName || maskAnimation) {
	    motion = _objectSpread2({
	      motionAppear: true
	    }, getMotion({
	      motion: maskMotion,
	      prefixCls: prefixCls,
	      transitionName: maskTransitionName,
	      animation: maskAnimation
	    }));
	  }

	  return /*#__PURE__*/React.createElement(CSSMotion, _extends$4p({}, motion, {
	    visible: visible,
	    removeOnLeave: true
	  }), function (_ref) {
	    var className = _ref.className;
	    return /*#__PURE__*/React.createElement("div", {
	      style: {
	        zIndex: zIndex
	      },
	      className: classnames$1("".concat(prefixCls, "-mask"), className)
	    });
	  });
	}

	var isVisible = (function (element) {
	  if (!element) {
	    return false;
	  }

	  if (element.offsetParent) {
	    return true;
	  }

	  if (element.getBBox) {
	    var box = element.getBBox();

	    if (box.width || box.height) {
	      return true;
	    }
	  }

	  if (element.getBoundingClientRect) {
	    var _box = element.getBoundingClientRect();

	    if (_box.width || _box.height) {
	      return true;
	    }
	  }

	  return false;
	});

	function ownKeys$b(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);

	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }

	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2$1(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys$b(Object(source), true).forEach(function (key) {
	        _defineProperty$4(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$b(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _typeof$3(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof$3 = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof$3 = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof$3(obj);
	}

	function _defineProperty$4(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var vendorPrefix;
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};

	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }

	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';

	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }

	  return vendorPrefix;
	}

	function getTransitionName$1() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
	}

	function getTransformName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
	}

	function setTransitionProperty(node, value) {
	  var name = getTransitionName$1();

	  if (name) {
	    node.style[name] = value;

	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}

	function setTransform(node, value) {
	  var name = getTransformName();

	  if (name) {
	    node.style[name] = value;

	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}

	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName$1()];
	}

	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return {
	      x: parseFloat(matrix[12] || matrix[4], 0),
	      y: parseFloat(matrix[13] || matrix[5], 0)
	    };
	  }

	  return {
	    x: 0,
	    y: 0
	  };
	}

	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;

	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

	  if (transform && transform !== 'none') {
	    var arr;
	    var match2d = transform.match(matrix2d);

	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, "matrix(".concat(arr.join(','), ")"));
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
	    }
	  } else {
	    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
	  }
	}

	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line

	  elem.style.display = originalStyle;
	}

	function css(el, name, v) {
	  var value = v;

	  if (_typeof$3(name) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }

	    return undefined;
	  }

	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = "".concat(value, "px");
	    }

	    el.style[name] = value;
	    return undefined;
	  }

	  return getComputedStyleX(el, name);
	}

	function getClientPosition(elem) {
	  var box;
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

	  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

	  x = box.left;
	  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}

	function getScroll(w, top) {
	  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
	  var method = "scroll".concat(top ? 'Top' : 'Left');

	  if (typeof ret !== 'number') {
	    var d = w.document; // ie6,7,8 standard mode

	    ret = d.documentElement[method];

	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }

	  return ret;
	}

	function getScrollLeft(w) {
	  return getScroll(w);
	}

	function getScrollTop(w) {
	  return getScroll(w, true);
	}

	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */


	function isWindow(obj) {
	  // must use == for ie8

	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}

	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }

	  if (node.nodeType === 9) {
	    return node;
	  }

	  return node.ownerDocument;
	}

	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }

	  return val;
	}

	var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';

	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity

	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX; // Revert the changed values

	    style[LEFT] = left;
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }

	  return ret === '' ? 'auto' : ret;
	}

	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}

	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }

	  return option.useCssBottom ? 'bottom' : dir;
	}

	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	} // 设置 elem 相对 elem.ownerDocument 的坐标


	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }

	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }

	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }

	  var originalTransition = '';
	  var originalOffset = getOffset(elem);

	  if ('left' in offset || 'top' in offset) {
	    originalTransition = getTransitionProperty(elem) || '';
	    setTransitionProperty(elem, 'none');
	  }

	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = "".concat(presetH, "px");
	  }

	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = "".concat(presetV, "px");
	  } // force relayout


	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};

	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];

	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }

	  css(elem, originalStyle); // force relayout

	  forceRelayout(elem);

	  if ('left' in offset || 'top' in offset) {
	    setTransitionProperty(elem, originalTransition);
	  }

	  var ret = {};

	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);

	      var _off = offset[_key] - originalOffset[_key];

	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }

	  css(elem, ret);
	}

	function setTransform$1(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = getTransformXY(elem);
	  var resultXY = {
	    x: originalXY.x,
	    y: originalXY.y
	  };

	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }

	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }

	  setTransformXY(elem, resultXY);
	}

	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);

	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }

	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && getTransformName() in document.body.style) {
	    setTransform$1(elem, offset);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}

	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}

	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}

	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;

	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name; // Remember the old values, and insert the new ones

	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }

	  callback.call(elem); // Revert the old values

	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}

	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop;
	  var j;
	  var i;

	  for (j = 0; j < props.length; j++) {
	    prop = props[j];

	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;

	        if (prop === 'border') {
	          cssProp = "".concat(prop).concat(which[i], "Width");
	        } else {
	          cssProp = prop + which[i];
	        }

	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }

	  return value;
	}

	var domUtils = {
	  getParent: function getParent(element) {
	    var parent = element;

	    do {
	      if (parent.nodeType === 11 && parent.host) {
	        parent = parent.host;
	      } else {
	        parent = parent.parentNode;
	      }
	    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

	    return parent;
	  }
	};
	each(['Width', 'Height'], function (name) {
	  domUtils["doc".concat(name)] = function (refWin) {
	    var d = refWin.document;
	    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
	  };

	  domUtils["viewport".concat(name)] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = "client".concat(name);
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
	    // backcompat 取 body

	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */

	function getWH(elem, name, ex) {
	  var extra = ex;

	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }

	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
	  var isBorderBox = isBorderBoxFn(elem);
	  var cssBoxValue = 0;

	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

	    cssBoxValue = getComputedStyleX(elem, name);

	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    } // Normalize '', auto, and prepare for extra


	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }

	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }

	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;

	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which);
	    }

	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }

	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
	  }

	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
	}

	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }

	  var val;
	  var elem = args[0]; // in case elem is window
	  // elem.offsetWidth === undefined

	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }

	  return val;
	}

	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);

	  domUtils["outer".concat(first)] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };

	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

	  domUtils[name] = function (elem, v) {
	    var val = v;

	    if (val !== undefined) {
	      if (elem) {
	        var isBorderBox = isBorderBoxFn(elem);

	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which);
	        }

	        return css(elem, name, val);
	      }

	      return undefined;
	    }

	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});

	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }

	  return to;
	}

	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }

	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i;
	    var ret = {};

	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }

	    var overflow = obj.overflow;

	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }

	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};

	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
	    }

	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	mix(utils, domUtils);
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */

	var getParent = utils.getParent;

	function getOffsetParent(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return null;
	  } // ie 这个也不是完全可行

	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法


	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent;
	  var positionStyle = utils.css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
	  }

	  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
	    positionStyle = utils.css(parent, 'position');

	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }

	  return null;
	}

	var getParent$1 = utils.getParent;

	function isAncestorFixed(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return false;
	  }

	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent = null;

	  for (parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
	  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
	    var positionStyle = utils.css(parent, 'position');

	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }

	  return false;
	}
	/**
	 * 获得元素的显示部分的区域
	 */


	function getVisibleRectForElement(element, alwaysByViewport) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = getOffsetParent(element);
	  var doc = utils.getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.

	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
	      var pos = utils.offset(el); // add border

	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }

	    el = getOffsetParent(el);
	  } // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601


	  var originalPosition = null;

	  if (!utils.isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = utils.css(element, 'position');

	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }

	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
	  // We should cut this ourself.

	  var bodyStyle = window.getComputedStyle(body);

	  if (bodyStyle.overflowX === 'hidden') {
	    documentWidth = win.innerWidth;
	  }

	  if (bodyStyle.overflowY === 'hidden') {
	    documentHeight = win.innerHeight;
	  } // Reset element position after calculate the visible area


	  if (element.style) {
	    element.style.position = originalPosition;
	  }

	  if (alwaysByViewport || isAncestorFixed(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }

	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}

	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = utils.clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };

	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  } // Left edge inside and right edge outside viewport, try to resize it.


	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  } // Right edge outside viewport, try to move it.


	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  } // Top edge outside viewport, try to move it.


	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  } // Top edge inside and bottom edge outside viewport, try to resize it.


	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  } // Bottom edge outside viewport, try to move it.


	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }

	  return utils.mix(pos, size);
	}

	function getRegion(node) {
	  var offset;
	  var w;
	  var h;

	  if (!utils.isWindow(node) && node.nodeType !== 9) {
	    offset = utils.offset(node);
	    w = utils.outerWidth(node);
	    h = utils.outerHeight(node);
	  } else {
	    var win = utils.getWindow(node);
	    offset = {
	      left: utils.getWindowScrollLeft(win),
	      top: utils.getWindowScrollTop(win)
	    };
	    w = utils.viewportWidth(win);
	    h = utils.viewportHeight(win);
	  }

	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */


	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = region.left;
	  var y = region.top;

	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }

	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }

	  return {
	    left: x,
	    top: y
	  };
	}

	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = getAlignOffset(refNodeRegion, points[1]);
	  var p2 = getAlignOffset(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	  return {
	    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
	    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
	  };
	}
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */


	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}

	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}

	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}

	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}

	function flip(points, reg, map) {
	  var ret = [];
	  utils.each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}

	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}

	function convertOffset(str, offsetLen) {
	  var n;

	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }

	  return n || 0;
	}

	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */


	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

	  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

	  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

	  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

	  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        }); // 偏移量也反下

	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }

	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        }); // 偏移量也反下


	        var _newOffset = flipOffset(offset, 1);

	        var _newTargetOffset = flipOffset(targetOffset, 1);

	        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    } // 如果失败，重新计算当前节点将要被放置的位置


	    if (fail) {
	      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	      utils.mix(newElRegion, elFuturePos);
	    }

	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数

	    if (isStillFailX || isStillFailY) {
	      var _newPoints2 = points; // 重置对应部分的翻转逻辑

	      if (isStillFailX) {
	        _newPoints2 = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	      }

	      if (isStillFailY) {
	        _newPoints2 = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	      }

	      points = _newPoints2;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    } // 2. 只有指定了可以调整当前方向才调整


	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  } // need judge to in case set fixed with in css on height auto element


	  if (newElRegion.width !== elRegion.width) {
	    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
	  }

	  if (newElRegion.height !== elRegion.height) {
	    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
	  } // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>


	  utils.offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/


	function isOutOfVisibleRect(target, alwaysByViewport) {
	  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
	  var targetRegion = getRegion(target);
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}

	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = getRegion(target);
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
	  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}

	alignElement.__getOffsetParent = getOffsetParent;
	alignElement.__getVisibleRectForElement = getVisibleRectForElement;
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */

	function alignPoint(el, tgtPoint, align) {
	  var pageX;
	  var pageY;
	  var doc = utils.getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);

	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }

	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }

	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

	  var points = [align.points[0], 'cc'];
	  return doAlign(el, tgtRegion, _objectSpread2$1(_objectSpread2$1({}, align), {}, {
	    points: points
	  }), pointInView);
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear$1() {
	  this.__data__ = [];
	  this.size = 0;
	}

	var _listCacheClear$1 = listCacheClear$1;

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq$1(value, other) {
	  return value === other || value !== value && other !== other;
	}

	var eq_1$1 = eq$1;

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */


	function assocIndexOf$1(array, key) {
	  var length = array.length;

	  while (length--) {
	    if (eq_1$1(array[length][0], key)) {
	      return length;
	    }
	  }

	  return -1;
	}

	var _assocIndexOf$1 = assocIndexOf$1;

	/** Used for built-in method references. */


	var arrayProto$1 = Array.prototype;
	/** Built-in value references. */

	var splice$1 = arrayProto$1.splice;
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */

	function listCacheDelete$1(key) {
	  var data = this.__data__,
	      index = _assocIndexOf$1(data, key);

	  if (index < 0) {
	    return false;
	  }

	  var lastIndex = data.length - 1;

	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice$1.call(data, index, 1);
	  }

	  --this.size;
	  return true;
	}

	var _listCacheDelete$1 = listCacheDelete$1;

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */


	function listCacheGet$1(key) {
	  var data = this.__data__,
	      index = _assocIndexOf$1(data, key);
	  return index < 0 ? undefined : data[index][1];
	}

	var _listCacheGet$1 = listCacheGet$1;

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */


	function listCacheHas$1(key) {
	  return _assocIndexOf$1(this.__data__, key) > -1;
	}

	var _listCacheHas$1 = listCacheHas$1;

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */


	function listCacheSet$1(key, value) {
	  var data = this.__data__,
	      index = _assocIndexOf$1(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }

	  return this;
	}

	var _listCacheSet$1 = listCacheSet$1;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */


	function ListCache$1(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	  this.clear();

	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	} // Add methods to `ListCache`.


	ListCache$1.prototype.clear = _listCacheClear$1;
	ListCache$1.prototype['delete'] = _listCacheDelete$1;
	ListCache$1.prototype.get = _listCacheGet$1;
	ListCache$1.prototype.has = _listCacheHas$1;
	ListCache$1.prototype.set = _listCacheSet$1;
	var _ListCache$1 = ListCache$1;

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */


	function stackClear$1() {
	  this.__data__ = new _ListCache$1();
	  this.size = 0;
	}

	var _stackClear$1 = stackClear$1;

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete$1(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	  this.size = data.size;
	  return result;
	}

	var _stackDelete$1 = stackDelete$1;

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet$1(key) {
	  return this.__data__.get(key);
	}

	var _stackGet$1 = stackGet$1;

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas$1(key) {
	  return this.__data__.has(key);
	}

	var _stackHas$1 = stackHas$1;

	/** Detect free variable `global` from Node.js. */

	var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	var _freeGlobal$1 = freeGlobal$1;

	/** Detect free variable `self`. */


	var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
	/** Used as a reference to the global object. */

	var root$1 = _freeGlobal$1 || freeSelf$1 || Function('return this')();
	var _root$1 = root$1;

	/** Built-in value references. */


	var Symbol$4 = _root$1.Symbol;
	var _Symbol$1 = Symbol$4;

	/** Used for built-in method references. */


	var objectProto$i = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$i = objectProto$i.hasOwnProperty;
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */

	var nativeObjectToString$2 = objectProto$i.toString;
	/** Built-in value references. */

	var symToStringTag$2 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */

	function getRawTag$1(value) {
	  var isOwn = hasOwnProperty$i.call(value, symToStringTag$2),
	      tag = value[symToStringTag$2];

	  try {
	    value[symToStringTag$2] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString$2.call(value);

	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$2] = tag;
	    } else {
	      delete value[symToStringTag$2];
	    }
	  }

	  return result;
	}

	var _getRawTag$1 = getRawTag$1;

	/** Used for built-in method references. */
	var objectProto$j = Object.prototype;
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */

	var nativeObjectToString$3 = objectProto$j.toString;
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */

	function objectToString$2(value) {
	  return nativeObjectToString$3.call(value);
	}

	var _objectToString$1 = objectToString$2;

	/** `Object#toString` result references. */


	var nullTag$1 = '[object Null]',
	    undefinedTag$1 = '[object Undefined]';
	/** Built-in value references. */

	var symToStringTag$3 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */

	function baseGetTag$1(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag$1 : nullTag$1;
	  }

	  return symToStringTag$3 && symToStringTag$3 in Object(value) ? _getRawTag$1(value) : _objectToString$1(value);
	}

	var _baseGetTag$1 = baseGetTag$1;

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject$3(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	var isObject_1$1 = isObject$3;

	/** `Object#toString` result references. */


	var asyncTag$1 = '[object AsyncFunction]',
	    funcTag$3 = '[object Function]',
	    genTag$2 = '[object GeneratorFunction]',
	    proxyTag$1 = '[object Proxy]';
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */

	function isFunction$1(value) {
	  if (!isObject_1$1(value)) {
	    return false;
	  } // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.


	  var tag = _baseGetTag$1(value);
	  return tag == funcTag$3 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
	}

	var isFunction_1$1 = isFunction$1;

	/** Used to detect overreaching core-js shims. */


	var coreJsData$1 = _root$1['__core-js_shared__'];
	var _coreJsData$1 = coreJsData$1;

	/** Used to detect methods masquerading as native. */


	var maskSrcKey$1 = function () {
	  var uid = /[^.]+$/.exec(_coreJsData$1 && _coreJsData$1.keys && _coreJsData$1.keys.IE_PROTO || '');
	  return uid ? 'Symbol(src)_1.' + uid : '';
	}();
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */


	function isMasked$1(func) {
	  return !!maskSrcKey$1 && maskSrcKey$1 in func;
	}

	var _isMasked$1 = isMasked$1;

	/** Used for built-in method references. */
	var funcProto$3 = Function.prototype;
	/** Used to resolve the decompiled source of functions. */

	var funcToString$3 = funcProto$3.toString;
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */

	function toSource$1(func) {
	  if (func != null) {
	    try {
	      return funcToString$3.call(func);
	    } catch (e) {}

	    try {
	      return func + '';
	    } catch (e) {}
	  }

	  return '';
	}

	var _toSource$1 = toSource$1;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */


	var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
	/** Used to detect host constructors (Safari). */

	var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
	/** Used for built-in method references. */

	var funcProto$4 = Function.prototype,
	    objectProto$k = Object.prototype;
	/** Used to resolve the decompiled source of functions. */

	var funcToString$4 = funcProto$4.toString;
	/** Used to check objects for own properties. */

	var hasOwnProperty$j = objectProto$k.hasOwnProperty;
	/** Used to detect if a method is native. */

	var reIsNative$1 = RegExp('^' + funcToString$4.call(hasOwnProperty$j).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */

	function baseIsNative$1(value) {
	  if (!isObject_1$1(value) || _isMasked$1(value)) {
	    return false;
	  }

	  var pattern = isFunction_1$1(value) ? reIsNative$1 : reIsHostCtor$1;
	  return pattern.test(_toSource$1(value));
	}

	var _baseIsNative$1 = baseIsNative$1;

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue$1(object, key) {
	  return object == null ? undefined : object[key];
	}

	var _getValue$1 = getValue$1;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */


	function getNative$1(object, key) {
	  var value = _getValue$1(object, key);
	  return _baseIsNative$1(value) ? value : undefined;
	}

	var _getNative$1 = getNative$1;

	/* Built-in method references that are verified to be native. */


	var Map$2 = _getNative$1(_root$1, 'Map');
	var _Map$1 = Map$2;

	/* Built-in method references that are verified to be native. */


	var nativeCreate$1 = _getNative$1(Object, 'create');
	var _nativeCreate$1 = nativeCreate$1;

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */


	function hashClear$1() {
	  this.__data__ = _nativeCreate$1 ? _nativeCreate$1(null) : {};
	  this.size = 0;
	}

	var _hashClear$1 = hashClear$1;

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete$1(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _hashDelete$1 = hashDelete$1;

	/** Used to stand-in for `undefined` hash values. */


	var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';
	/** Used for built-in method references. */

	var objectProto$l = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$k = objectProto$l.hasOwnProperty;
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */

	function hashGet$1(key) {
	  var data = this.__data__;

	  if (_nativeCreate$1) {
	    var result = data[key];
	    return result === HASH_UNDEFINED$3 ? undefined : result;
	  }

	  return hasOwnProperty$k.call(data, key) ? data[key] : undefined;
	}

	var _hashGet$1 = hashGet$1;

	/** Used for built-in method references. */


	var objectProto$m = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$l = objectProto$m.hasOwnProperty;
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */

	function hashHas$1(key) {
	  var data = this.__data__;
	  return _nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$l.call(data, key);
	}

	var _hashHas$1 = hashHas$1;

	/** Used to stand-in for `undefined` hash values. */


	var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */

	function hashSet$1(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = _nativeCreate$1 && value === undefined ? HASH_UNDEFINED$4 : value;
	  return this;
	}

	var _hashSet$1 = hashSet$1;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */


	function Hash$1(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	  this.clear();

	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	} // Add methods to `Hash`.


	Hash$1.prototype.clear = _hashClear$1;
	Hash$1.prototype['delete'] = _hashDelete$1;
	Hash$1.prototype.get = _hashGet$1;
	Hash$1.prototype.has = _hashHas$1;
	Hash$1.prototype.set = _hashSet$1;
	var _Hash$1 = Hash$1;

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */


	function mapCacheClear$1() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new _Hash$1(),
	    'map': new (_Map$1 || _ListCache$1)(),
	    'string': new _Hash$1()
	  };
	}

	var _mapCacheClear$1 = mapCacheClear$1;

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable$1(value) {
	  var type = typeof value;
	  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
	}

	var _isKeyable$1 = isKeyable$1;

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */


	function getMapData$1(map, key) {
	  var data = map.__data__;
	  return _isKeyable$1(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
	}

	var _getMapData$1 = getMapData$1;

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */


	function mapCacheDelete$1(key) {
	  var result = _getMapData$1(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _mapCacheDelete$1 = mapCacheDelete$1;

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */


	function mapCacheGet$1(key) {
	  return _getMapData$1(this, key).get(key);
	}

	var _mapCacheGet$1 = mapCacheGet$1;

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */


	function mapCacheHas$1(key) {
	  return _getMapData$1(this, key).has(key);
	}

	var _mapCacheHas$1 = mapCacheHas$1;

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */


	function mapCacheSet$1(key, value) {
	  var data = _getMapData$1(this, key),
	      size = data.size;
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	var _mapCacheSet$1 = mapCacheSet$1;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */


	function MapCache$1(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	  this.clear();

	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	} // Add methods to `MapCache`.


	MapCache$1.prototype.clear = _mapCacheClear$1;
	MapCache$1.prototype['delete'] = _mapCacheDelete$1;
	MapCache$1.prototype.get = _mapCacheGet$1;
	MapCache$1.prototype.has = _mapCacheHas$1;
	MapCache$1.prototype.set = _mapCacheSet$1;
	var _MapCache$1 = MapCache$1;

	/** Used as the size to enable large array optimizations. */


	var LARGE_ARRAY_SIZE$1 = 200;
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */

	function stackSet$1(key, value) {
	  var data = this.__data__;

	  if (data instanceof _ListCache$1) {
	    var pairs = data.__data__;

	    if (!_Map$1 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }

	    data = this.__data__ = new _MapCache$1(pairs);
	  }

	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	var _stackSet$1 = stackSet$1;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */


	function Stack$1(entries) {
	  var data = this.__data__ = new _ListCache$1(entries);
	  this.size = data.size;
	} // Add methods to `Stack`.


	Stack$1.prototype.clear = _stackClear$1;
	Stack$1.prototype['delete'] = _stackDelete$1;
	Stack$1.prototype.get = _stackGet$1;
	Stack$1.prototype.has = _stackHas$1;
	Stack$1.prototype.set = _stackSet$1;
	var _Stack$1 = Stack$1;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$5 = '__lodash_hash_undefined__';
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */

	function setCacheAdd$1(value) {
	  this.__data__.set(value, HASH_UNDEFINED$5);

	  return this;
	}

	var _setCacheAdd$1 = setCacheAdd$1;

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas$1(value) {
	  return this.__data__.has(value);
	}

	var _setCacheHas$1 = setCacheHas$1;

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */


	function SetCache$1(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	  this.__data__ = new _MapCache$1();

	  while (++index < length) {
	    this.add(values[index]);
	  }
	} // Add methods to `SetCache`.


	SetCache$1.prototype.add = SetCache$1.prototype.push = _setCacheAdd$1;
	SetCache$1.prototype.has = _setCacheHas$1;
	var _SetCache$1 = SetCache$1;

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome$1(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }

	  return false;
	}

	var _arraySome$1 = arraySome$1;

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas$1(cache, key) {
	  return cache.has(key);
	}

	var _cacheHas$1 = cacheHas$1;

	/** Used to compose bitmasks for value comparisons. */


	var COMPARE_PARTIAL_FLAG$6 = 1,
	    COMPARE_UNORDERED_FLAG$4 = 2;
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */

	function equalArrays$1(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$6,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  } // Check that cyclic values are equal.


	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);

	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }

	  var index = -1,
	      result = true,
	      seen = bitmask & COMPARE_UNORDERED_FLAG$4 ? new _SetCache$1() : undefined;
	  stack.set(array, other);
	  stack.set(other, array); // Ignore non-index properties.

	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
	    }

	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }

	      result = false;
	      break;
	    } // Recursively compare arrays (susceptible to call stack limits).


	    if (seen) {
	      if (!_arraySome$1(other, function (othValue, othIndex) {
	        if (!_cacheHas$1(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	          return seen.push(othIndex);
	        }
	      })) {
	        result = false;
	        break;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	      result = false;
	      break;
	    }
	  }

	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	var _equalArrays$1 = equalArrays$1;

	/** Built-in value references. */


	var Uint8Array$1 = _root$1.Uint8Array;
	var _Uint8Array$1 = Uint8Array$1;

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray$1(map) {
	  var index = -1,
	      result = Array(map.size);
	  map.forEach(function (value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	var _mapToArray$1 = mapToArray$1;

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray$1(set) {
	  var index = -1,
	      result = Array(set.size);
	  set.forEach(function (value) {
	    result[++index] = value;
	  });
	  return result;
	}

	var _setToArray$1 = setToArray$1;

	/** Used to compose bitmasks for value comparisons. */


	var COMPARE_PARTIAL_FLAG$7 = 1,
	    COMPARE_UNORDERED_FLAG$5 = 2;
	/** `Object#toString` result references. */

	var boolTag$4 = '[object Boolean]',
	    dateTag$4 = '[object Date]',
	    errorTag$4 = '[object Error]',
	    mapTag$7 = '[object Map]',
	    numberTag$4 = '[object Number]',
	    regexpTag$4 = '[object RegExp]',
	    setTag$7 = '[object Set]',
	    stringTag$5 = '[object String]',
	    symbolTag$4 = '[object Symbol]';
	var arrayBufferTag$4 = '[object ArrayBuffer]',
	    dataViewTag$5 = '[object DataView]';
	/** Used to convert symbols to primitives and strings. */

	var symbolProto$3 = _Symbol$1 ? _Symbol$1.prototype : undefined,
	    symbolValueOf$2 = symbolProto$3 ? symbolProto$3.valueOf : undefined;
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */

	function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag$5:
	      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
	        return false;
	      }

	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag$4:
	      if (object.byteLength != other.byteLength || !equalFunc(new _Uint8Array$1(object), new _Uint8Array$1(other))) {
	        return false;
	      }

	      return true;

	    case boolTag$4:
	    case dateTag$4:
	    case numberTag$4:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq_1$1(+object, +other);

	    case errorTag$4:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag$4:
	    case stringTag$5:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == other + '';

	    case mapTag$7:
	      var convert = _mapToArray$1;

	    case setTag$7:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$7;
	      convert || (convert = _setToArray$1);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      } // Assume cyclic values are equal.


	      var stacked = stack.get(object);

	      if (stacked) {
	        return stacked == other;
	      }

	      bitmask |= COMPARE_UNORDERED_FLAG$5; // Recursively compare objects (susceptible to call stack limits).

	      stack.set(object, other);
	      var result = _equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag$4:
	      if (symbolValueOf$2) {
	        return symbolValueOf$2.call(object) == symbolValueOf$2.call(other);
	      }

	  }

	  return false;
	}

	var _equalByTag$1 = equalByTag$1;

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush$2(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }

	  return array;
	}

	var _arrayPush$1 = arrayPush$2;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray$3 = Array.isArray;
	var isArray_1$1 = isArray$3;

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */


	function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray_1$1(object) ? result : _arrayPush$1(result, symbolsFunc(object));
	}

	var _baseGetAllKeys$1 = baseGetAllKeys$1;

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter$1(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];

	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }

	  return result;
	}

	var _arrayFilter$1 = arrayFilter$1;

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray$1() {
	  return [];
	}

	var stubArray_1$1 = stubArray$1;

	/** Used for built-in method references. */


	var objectProto$n = Object.prototype;
	/** Built-in value references. */

	var propertyIsEnumerable$2 = objectProto$n.propertyIsEnumerable;
	/* Built-in method references for those with the same name as other `lodash` methods. */

	var nativeGetSymbols$2 = Object.getOwnPropertySymbols;
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */

	var getSymbols$1 = !nativeGetSymbols$2 ? stubArray_1$1 : function (object) {
	  if (object == null) {
	    return [];
	  }

	  object = Object(object);
	  return _arrayFilter$1(nativeGetSymbols$2(object), function (symbol) {
	    return propertyIsEnumerable$2.call(object, symbol);
	  });
	};
	var _getSymbols$1 = getSymbols$1;

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes$1(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }

	  return result;
	}

	var _baseTimes$1 = baseTimes$1;

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike$1(value) {
	  return value != null && typeof value == 'object';
	}

	var isObjectLike_1$1 = isObjectLike$1;

	/** `Object#toString` result references. */


	var argsTag$4 = '[object Arguments]';
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */

	function baseIsArguments$1(value) {
	  return isObjectLike_1$1(value) && _baseGetTag$1(value) == argsTag$4;
	}

	var _baseIsArguments$1 = baseIsArguments$1;

	/** Used for built-in method references. */


	var objectProto$o = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$m = objectProto$o.hasOwnProperty;
	/** Built-in value references. */

	var propertyIsEnumerable$3 = objectProto$o.propertyIsEnumerable;
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */

	var isArguments$1 = _baseIsArguments$1(function () {
	  return arguments;
	}()) ? _baseIsArguments$1 : function (value) {
	  return isObjectLike_1$1(value) && hasOwnProperty$m.call(value, 'callee') && !propertyIsEnumerable$3.call(value, 'callee');
	};
	var isArguments_1$1 = isArguments$1;

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse$1() {
	  return false;
	}

	var stubFalse_1$1 = stubFalse$1;

	var isBuffer_1$1 = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */


	var freeExports =  exports && !exports.nodeType && exports;
	/** Detect free variable `module`. */

	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	/** Detect the popular CommonJS extension `module.exports`. */

	var moduleExports = freeModule && freeModule.exports === freeExports;
	/** Built-in value references. */

	var Buffer = moduleExports ? _root$1.Buffer : undefined;
	/* Built-in method references for those with the same name as other `lodash` methods. */

	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */

	var isBuffer = nativeIsBuffer || stubFalse_1$1;
	module.exports = isBuffer;
	});

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$3 = 9007199254740991;
	/** Used to detect unsigned integer values. */

	var reIsUint$1 = /^(?:0|[1-9]\d*)$/;
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */

	function isIndex$1(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER$3 : length;
	  return !!length && (type == 'number' || type != 'symbol' && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
	}

	var _isIndex$1 = isIndex$1;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$4 = 9007199254740991;
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */

	function isLength$1(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$4;
	}

	var isLength_1$1 = isLength$1;

	/** `Object#toString` result references. */


	var argsTag$5 = '[object Arguments]',
	    arrayTag$3 = '[object Array]',
	    boolTag$5 = '[object Boolean]',
	    dateTag$5 = '[object Date]',
	    errorTag$5 = '[object Error]',
	    funcTag$4 = '[object Function]',
	    mapTag$8 = '[object Map]',
	    numberTag$5 = '[object Number]',
	    objectTag$5 = '[object Object]',
	    regexpTag$5 = '[object RegExp]',
	    setTag$8 = '[object Set]',
	    stringTag$6 = '[object String]',
	    weakMapTag$4 = '[object WeakMap]';
	var arrayBufferTag$5 = '[object ArrayBuffer]',
	    dataViewTag$6 = '[object DataView]',
	    float32Tag$3 = '[object Float32Array]',
	    float64Tag$3 = '[object Float64Array]',
	    int8Tag$3 = '[object Int8Array]',
	    int16Tag$3 = '[object Int16Array]',
	    int32Tag$3 = '[object Int32Array]',
	    uint8Tag$3 = '[object Uint8Array]',
	    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
	    uint16Tag$3 = '[object Uint16Array]',
	    uint32Tag$3 = '[object Uint32Array]';
	/** Used to identify `toStringTag` values of typed arrays. */

	var typedArrayTags$1 = {};
	typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = true;
	typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$3] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] = typedArrayTags$1[dataViewTag$6] = typedArrayTags$1[dateTag$5] = typedArrayTags$1[errorTag$5] = typedArrayTags$1[funcTag$4] = typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$5] = typedArrayTags$1[objectTag$5] = typedArrayTags$1[regexpTag$5] = typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$6] = typedArrayTags$1[weakMapTag$4] = false;
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */

	function baseIsTypedArray$1(value) {
	  return isObjectLike_1$1(value) && isLength_1$1(value.length) && !!typedArrayTags$1[_baseGetTag$1(value)];
	}

	var _baseIsTypedArray$1 = baseIsTypedArray$1;

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary$1(func) {
	  return function (value) {
	    return func(value);
	  };
	}

	var _baseUnary$1 = baseUnary$1;

	var _nodeUtil$1 = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */


	var freeExports =  exports && !exports.nodeType && exports;
	/** Detect free variable `module`. */

	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	/** Detect the popular CommonJS extension `module.exports`. */

	var moduleExports = freeModule && freeModule.exports === freeExports;
	/** Detect free variable `process` from Node.js. */

	var freeProcess = moduleExports && _freeGlobal$1.process;
	/** Used to access faster Node.js helpers. */

	var nodeUtil = function () {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    } // Legacy `process.binding('util')` for Node.js < 10.


	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}();

	module.exports = nodeUtil;
	});

	/* Node.js helper references. */


	var nodeIsTypedArray$1 = _nodeUtil$1 && _nodeUtil$1.isTypedArray;
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */

	var isTypedArray$1 = nodeIsTypedArray$1 ? _baseUnary$1(nodeIsTypedArray$1) : _baseIsTypedArray$1;
	var isTypedArray_1$1 = isTypedArray$1;

	/** Used for built-in method references. */


	var objectProto$p = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$n = objectProto$p.hasOwnProperty;
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */

	function arrayLikeKeys$1(value, inherited) {
	  var isArr = isArray_1$1(value),
	      isArg = !isArr && isArguments_1$1(value),
	      isBuff = !isArr && !isArg && isBuffer_1$1(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray_1$1(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? _baseTimes$1(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$n.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
	    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
	    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
	    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
	    _isIndex$1(key, length)))) {
	      result.push(key);
	    }
	  }

	  return result;
	}

	var _arrayLikeKeys$1 = arrayLikeKeys$1;

	/** Used for built-in method references. */
	var objectProto$q = Object.prototype;
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */

	function isPrototype$1(value) {
	  var Ctor = value && value.constructor,
	      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$q;
	  return value === proto;
	}

	var _isPrototype$1 = isPrototype$1;

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg$1(func, transform) {
	  return function (arg) {
	    return func(transform(arg));
	  };
	}

	var _overArg$1 = overArg$1;

	/* Built-in method references for those with the same name as other `lodash` methods. */


	var nativeKeys$1 = _overArg$1(Object.keys, Object);
	var _nativeKeys$1 = nativeKeys$1;

	/** Used for built-in method references. */


	var objectProto$r = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$o = objectProto$r.hasOwnProperty;
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */

	function baseKeys$1(object) {
	  if (!_isPrototype$1(object)) {
	    return _nativeKeys$1(object);
	  }

	  var result = [];

	  for (var key in Object(object)) {
	    if (hasOwnProperty$o.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }

	  return result;
	}

	var _baseKeys$1 = baseKeys$1;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */


	function isArrayLike$1(value) {
	  return value != null && isLength_1$1(value.length) && !isFunction_1$1(value);
	}

	var isArrayLike_1$1 = isArrayLike$1;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */


	function keys$a(object) {
	  return isArrayLike_1$1(object) ? _arrayLikeKeys$1(object) : _baseKeys$1(object);
	}

	var keys_1$1 = keys$a;

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */


	function getAllKeys$1(object) {
	  return _baseGetAllKeys$1(object, keys_1$1, _getSymbols$1);
	}

	var _getAllKeys$1 = getAllKeys$1;

	/** Used to compose bitmasks for value comparisons. */


	var COMPARE_PARTIAL_FLAG$8 = 1;
	/** Used for built-in method references. */

	var objectProto$s = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$p = objectProto$s.hasOwnProperty;
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */

	function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$8,
	      objProps = _getAllKeys$1(object),
	      objLength = objProps.length,
	      othProps = _getAllKeys$1(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }

	  var index = objLength;

	  while (index--) {
	    var key = objProps[index];

	    if (!(isPartial ? key in other : hasOwnProperty$p.call(other, key))) {
	      return false;
	    }
	  } // Check that cyclic values are equal.


	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);

	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }

	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	  var skipCtor = isPartial;

	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
	    } // Recursively compare objects (susceptible to call stack limits).


	    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
	      result = false;
	      break;
	    }

	    skipCtor || (skipCtor = key == 'constructor');
	  }

	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

	    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }

	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	var _equalObjects$1 = equalObjects$1;

	/* Built-in method references that are verified to be native. */


	var DataView$1 = _getNative$1(_root$1, 'DataView');
	var _DataView$1 = DataView$1;

	/* Built-in method references that are verified to be native. */


	var Promise$2 = _getNative$1(_root$1, 'Promise');
	var _Promise$1 = Promise$2;

	/* Built-in method references that are verified to be native. */


	var Set$1 = _getNative$1(_root$1, 'Set');
	var _Set$1 = Set$1;

	/* Built-in method references that are verified to be native. */


	var WeakMap$6 = _getNative$1(_root$1, 'WeakMap');
	var _WeakMap$1 = WeakMap$6;

	/** `Object#toString` result references. */


	var mapTag$9 = '[object Map]',
	    objectTag$6 = '[object Object]',
	    promiseTag$1 = '[object Promise]',
	    setTag$9 = '[object Set]',
	    weakMapTag$5 = '[object WeakMap]';
	var dataViewTag$7 = '[object DataView]';
	/** Used to detect maps, sets, and weakmaps. */

	var dataViewCtorString$1 = _toSource$1(_DataView$1),
	    mapCtorString$1 = _toSource$1(_Map$1),
	    promiseCtorString$1 = _toSource$1(_Promise$1),
	    setCtorString$1 = _toSource$1(_Set$1),
	    weakMapCtorString$1 = _toSource$1(_WeakMap$1);
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */

	var getTag$1 = _baseGetTag$1; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

	if (_DataView$1 && getTag$1(new _DataView$1(new ArrayBuffer(1))) != dataViewTag$7 || _Map$1 && getTag$1(new _Map$1()) != mapTag$9 || _Promise$1 && getTag$1(_Promise$1.resolve()) != promiseTag$1 || _Set$1 && getTag$1(new _Set$1()) != setTag$9 || _WeakMap$1 && getTag$1(new _WeakMap$1()) != weakMapTag$5) {
	  getTag$1 = function (value) {
	    var result = _baseGetTag$1(value),
	        Ctor = result == objectTag$6 ? value.constructor : undefined,
	        ctorString = Ctor ? _toSource$1(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString$1:
	          return dataViewTag$7;

	        case mapCtorString$1:
	          return mapTag$9;

	        case promiseCtorString$1:
	          return promiseTag$1;

	        case setCtorString$1:
	          return setTag$9;

	        case weakMapCtorString$1:
	          return weakMapTag$5;
	      }
	    }

	    return result;
	  };
	}

	var _getTag$1 = getTag$1;

	/** Used to compose bitmasks for value comparisons. */


	var COMPARE_PARTIAL_FLAG$9 = 1;
	/** `Object#toString` result references. */

	var argsTag$6 = '[object Arguments]',
	    arrayTag$4 = '[object Array]',
	    objectTag$7 = '[object Object]';
	/** Used for built-in method references. */

	var objectProto$t = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$q = objectProto$t.hasOwnProperty;
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */

	function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray_1$1(object),
	      othIsArr = isArray_1$1(other),
	      objTag = objIsArr ? arrayTag$4 : _getTag$1(object),
	      othTag = othIsArr ? arrayTag$4 : _getTag$1(other);
	  objTag = objTag == argsTag$6 ? objectTag$7 : objTag;
	  othTag = othTag == argsTag$6 ? objectTag$7 : othTag;
	  var objIsObj = objTag == objectTag$7,
	      othIsObj = othTag == objectTag$7,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer_1$1(object)) {
	    if (!isBuffer_1$1(other)) {
	      return false;
	    }

	    objIsArr = true;
	    objIsObj = false;
	  }

	  if (isSameTag && !objIsObj) {
	    stack || (stack = new _Stack$1());
	    return objIsArr || isTypedArray_1$1(object) ? _equalArrays$1(object, other, bitmask, customizer, equalFunc, stack) : _equalByTag$1(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }

	  if (!(bitmask & COMPARE_PARTIAL_FLAG$9)) {
	    var objIsWrapped = objIsObj && hasOwnProperty$q.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty$q.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	      stack || (stack = new _Stack$1());
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }

	  if (!isSameTag) {
	    return false;
	  }

	  stack || (stack = new _Stack$1());
	  return _equalObjects$1(object, other, bitmask, customizer, equalFunc, stack);
	}

	var _baseIsEqualDeep$1 = baseIsEqualDeep$1;

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */


	function baseIsEqual$1(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }

	  if (value == null || other == null || !isObjectLike_1$1(value) && !isObjectLike_1$1(other)) {
	    return value !== value && other !== other;
	  }

	  return _baseIsEqualDeep$1(value, other, bitmask, customizer, baseIsEqual$1, stack);
	}

	var _baseIsEqual$1 = baseIsEqual$1;

	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */


	function isEqual(value, other) {
	  return _baseIsEqual$1(value, other);
	}

	var isEqual_1 = isEqual;

	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */

	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = function () {
	  if (typeof Map !== 'undefined') {
	    return Map;
	  }
	  /**
	   * Returns index in provided array that matches the specified key.
	   *
	   * @param {Array<Array>} arr
	   * @param {*} key
	   * @returns {number}
	   */


	  function getIndex(arr, key) {
	    var result = -1;
	    arr.some(function (entry, index) {
	      if (entry[0] === key) {
	        result = index;
	        return true;
	      }

	      return false;
	    });
	    return result;
	  }

	  return (
	    /** @class */
	    function () {
	      function class_1() {
	        this.__entries__ = [];
	      }

	      Object.defineProperty(class_1.prototype, "size", {
	        /**
	         * @returns {boolean}
	         */
	        get: function () {
	          return this.__entries__.length;
	        },
	        enumerable: true,
	        configurable: true
	      });
	      /**
	       * @param {*} key
	       * @returns {*}
	       */

	      class_1.prototype.get = function (key) {
	        var index = getIndex(this.__entries__, key);
	        var entry = this.__entries__[index];
	        return entry && entry[1];
	      };
	      /**
	       * @param {*} key
	       * @param {*} value
	       * @returns {void}
	       */


	      class_1.prototype.set = function (key, value) {
	        var index = getIndex(this.__entries__, key);

	        if (~index) {
	          this.__entries__[index][1] = value;
	        } else {
	          this.__entries__.push([key, value]);
	        }
	      };
	      /**
	       * @param {*} key
	       * @returns {void}
	       */


	      class_1.prototype.delete = function (key) {
	        var entries = this.__entries__;
	        var index = getIndex(entries, key);

	        if (~index) {
	          entries.splice(index, 1);
	        }
	      };
	      /**
	       * @param {*} key
	       * @returns {void}
	       */


	      class_1.prototype.has = function (key) {
	        return !!~getIndex(this.__entries__, key);
	      };
	      /**
	       * @returns {void}
	       */


	      class_1.prototype.clear = function () {
	        this.__entries__.splice(0);
	      };
	      /**
	       * @param {Function} callback
	       * @param {*} [ctx=null]
	       * @returns {void}
	       */


	      class_1.prototype.forEach = function (callback, ctx) {
	        if (ctx === void 0) {
	          ctx = null;
	        }

	        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	          var entry = _a[_i];
	          callback.call(ctx, entry[1], entry[0]);
	        }
	      };

	      return class_1;
	    }()
	  );
	}();
	/**
	 * Detects whether window and document objects are available in current environment.
	 */


	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document; // Returns global object of a current environment.

	var global$1$1 = function () {
	  if (typeof global !== 'undefined' && global.Math === Math) {
	    return global;
	  }

	  if (typeof self !== 'undefined' && self.Math === Math) {
	    return self;
	  }

	  if (typeof window !== 'undefined' && window.Math === Math) {
	    return window;
	  } // eslint-disable-next-line no-new-func


	  return Function('return this')();
	}();
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */


	var requestAnimationFrame$1 = function () {
	  if (typeof requestAnimationFrame === 'function') {
	    // It's required to use a bounded function because IE sometimes throws
	    // an "Invalid calling object" error if rAF is invoked without the global
	    // object on the left hand side.
	    return requestAnimationFrame.bind(global$1$1);
	  }

	  return function (callback) {
	    return setTimeout(function () {
	      return callback(Date.now());
	    }, 1000 / 60);
	  };
	}(); // Defines minimum timeout before adding a trailing call.


	var trailingTimeout = 2;
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */

	function throttle(callback, delay) {
	  var leadingCall = false,
	      trailingCall = false,
	      lastCallTime = 0;
	  /**
	   * Invokes the original callback function and schedules new invocation if
	   * the "proxy" was called during current request.
	   *
	   * @returns {void}
	   */

	  function resolvePending() {
	    if (leadingCall) {
	      leadingCall = false;
	      callback();
	    }

	    if (trailingCall) {
	      proxy();
	    }
	  }
	  /**
	   * Callback invoked after the specified delay. It will further postpone
	   * invocation of the original function delegating it to the
	   * requestAnimationFrame.
	   *
	   * @returns {void}
	   */


	  function timeoutCallback() {
	    requestAnimationFrame$1(resolvePending);
	  }
	  /**
	   * Schedules invocation of the original function.
	   *
	   * @returns {void}
	   */


	  function proxy() {
	    var timeStamp = Date.now();

	    if (leadingCall) {
	      // Reject immediately following calls.
	      if (timeStamp - lastCallTime < trailingTimeout) {
	        return;
	      } // Schedule new call to be in invoked when the pending one is resolved.
	      // This is important for "transitions" which never actually start
	      // immediately so there is a chance that we might miss one if change
	      // happens amids the pending invocation.


	      trailingCall = true;
	    } else {
	      leadingCall = true;
	      trailingCall = false;
	      setTimeout(timeoutCallback, delay);
	    }

	    lastCallTime = timeStamp;
	  }

	  return proxy;
	} // Minimum delay before invoking the update of observers.


	var REFRESH_DELAY = 20; // A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.

	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight']; // Check if MutationObserver is available.

	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */

	var ResizeObserverController =
	/** @class */
	function () {
	  /**
	   * Creates a new instance of ResizeObserverController.
	   *
	   * @private
	   */
	  function ResizeObserverController() {
	    /**
	     * Indicates whether DOM listeners have been added.
	     *
	     * @private {boolean}
	     */
	    this.connected_ = false;
	    /**
	     * Tells that controller has subscribed for Mutation Events.
	     *
	     * @private {boolean}
	     */

	    this.mutationEventsAdded_ = false;
	    /**
	     * Keeps reference to the instance of MutationObserver.
	     *
	     * @private {MutationObserver}
	     */

	    this.mutationsObserver_ = null;
	    /**
	     * A list of connected observers.
	     *
	     * @private {Array<ResizeObserverSPI>}
	     */

	    this.observers_ = [];
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	  }
	  /**
	   * Adds observer to observers list.
	   *
	   * @param {ResizeObserverSPI} observer - Observer to be added.
	   * @returns {void}
	   */


	  ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	      this.observers_.push(observer);
	    } // Add listeners if they haven't been added yet.


	    if (!this.connected_) {
	      this.connect_();
	    }
	  };
	  /**
	   * Removes observer from observers list.
	   *
	   * @param {ResizeObserverSPI} observer - Observer to be removed.
	   * @returns {void}
	   */


	  ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer); // Remove observer if it's present in registry.

	    if (~index) {
	      observers.splice(index, 1);
	    } // Remove listeners if controller has no connected observers.


	    if (!observers.length && this.connected_) {
	      this.disconnect_();
	    }
	  };
	  /**
	   * Invokes the update of observers. It will continue running updates insofar
	   * it detects changes.
	   *
	   * @returns {void}
	   */


	  ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_(); // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.

	    if (changesDetected) {
	      this.refresh();
	    }
	  };
	  /**
	   * Updates every observer from observers list and notifies them of queued
	   * entries.
	   *
	   * @private
	   * @returns {boolean} Returns "true" if any observer has detected changes in
	   *      dimensions of it's elements.
	   */


	  ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	      return observer.gatherActive(), observer.hasActive();
	    }); // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.

	    activeObservers.forEach(function (observer) {
	      return observer.broadcastActive();
	    });
	    return activeObservers.length > 0;
	  };
	  /**
	   * Initializes DOM listeners.
	   *
	   * @private
	   * @returns {void}
	   */


	  ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	      return;
	    } // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.


	    document.addEventListener('transitionend', this.onTransitionEnd_);
	    window.addEventListener('resize', this.refresh);

	    if (mutationObserverSupported) {
	      this.mutationsObserver_ = new MutationObserver(this.refresh);
	      this.mutationsObserver_.observe(document, {
	        attributes: true,
	        childList: true,
	        characterData: true,
	        subtree: true
	      });
	    } else {
	      document.addEventListener('DOMSubtreeModified', this.refresh);
	      this.mutationEventsAdded_ = true;
	    }

	    this.connected_ = true;
	  };
	  /**
	   * Removes DOM listeners.
	   *
	   * @private
	   * @returns {void}
	   */


	  ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	      return;
	    }

	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);

	    if (this.mutationsObserver_) {
	      this.mutationsObserver_.disconnect();
	    }

	    if (this.mutationEventsAdded_) {
	      document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }

	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	  };
	  /**
	   * "Transitionend" event handler.
	   *
	   * @private
	   * @param {TransitionEvent} event
	   * @returns {void}
	   */


	  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	    var _b = _a.propertyName,
	        propertyName = _b === void 0 ? '' : _b; // Detect whether transition may affect dimensions of an element.

	    var isReflowProperty = transitionKeys.some(function (key) {
	      return !!~propertyName.indexOf(key);
	    });

	    if (isReflowProperty) {
	      this.refresh();
	    }
	  };
	  /**
	   * Returns instance of the ResizeObserverController.
	   *
	   * @returns {ResizeObserverController}
	   */


	  ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	      this.instance_ = new ResizeObserverController();
	    }

	    return this.instance_;
	  };
	  /**
	   * Holds reference to the controller's instance.
	   *
	   * @private {ResizeObserverController}
	   */


	  ResizeObserverController.instance_ = null;
	  return ResizeObserverController;
	}();
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */


	var defineConfigurable = function (target, props) {
	  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	    var key = _a[_i];
	    Object.defineProperty(target, key, {
	      value: props[key],
	      enumerable: false,
	      writable: false,
	      configurable: true
	    });
	  }

	  return target;
	};
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */


	var getWindowOf = function (target) {
	  // Assume that the element is an instance of Node, which means that it
	  // has the "ownerDocument" property from which we can retrieve a
	  // corresponding global object.
	  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local global object if it's not possible extract one from
	  // provided element.

	  return ownerGlobal || global$1$1;
	}; // Placeholder of an empty content rectangle.


	var emptyRect = createRectInit(0, 0, 0, 0);
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */

	function toFloat(value) {
	  return parseFloat(value) || 0;
	}
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */


	function getBordersSize(styles) {
	  var positions = [];

	  for (var _i = 1; _i < arguments.length; _i++) {
	    positions[_i - 1] = arguments[_i];
	  }

	  return positions.reduce(function (size, position) {
	    var value = styles['border-' + position + '-width'];
	    return size + toFloat(value);
	  }, 0);
	}
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */


	function getPaddings(styles) {
	  var positions = ['top', 'right', 'bottom', 'left'];
	  var paddings = {};

	  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	    var position = positions_1[_i];
	    var value = styles['padding-' + position];
	    paddings[position] = toFloat(value);
	  }

	  return paddings;
	}
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */


	function getSVGContentRect(target) {
	  var bbox = target.getBBox();
	  return createRectInit(0, 0, bbox.width, bbox.height);
	}
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */


	function getHTMLElementContentRect(target) {
	  // Client width & height properties can't be
	  // used exclusively as they provide rounded values.
	  var clientWidth = target.clientWidth,
	      clientHeight = target.clientHeight; // By this condition we can catch all non-replaced inline, hidden and
	  // detached elements. Though elements with width & height properties less
	  // than 0.5 will be discarded as well.
	  //
	  // Without it we would need to implement separate methods for each of
	  // those cases and it's not possible to perform a precise and performance
	  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	  // gives wrong results for elements with width & height less than 0.5.

	  if (!clientWidth && !clientHeight) {
	    return emptyRect;
	  }

	  var styles = getWindowOf(target).getComputedStyle(target);
	  var paddings = getPaddings(styles);
	  var horizPad = paddings.left + paddings.right;
	  var vertPad = paddings.top + paddings.bottom; // Computed styles of width & height are being used because they are the
	  // only dimensions available to JS that contain non-rounded values. It could
	  // be possible to utilize the getBoundingClientRect if only it's data wasn't
	  // affected by CSS transformations let alone paddings, borders and scroll bars.

	  var width = toFloat(styles.width),
	      height = toFloat(styles.height); // Width & height include paddings and borders when the 'border-box' box
	  // model is applied (except for IE).

	  if (styles.boxSizing === 'border-box') {
	    // Following conditions are required to handle Internet Explorer which
	    // doesn't include paddings and borders to computed CSS dimensions.
	    //
	    // We can say that if CSS dimensions + paddings are equal to the "client"
	    // properties then it's either IE, and thus we don't need to subtract
	    // anything, or an element merely doesn't have paddings/borders styles.
	    if (Math.round(width + horizPad) !== clientWidth) {
	      width -= getBordersSize(styles, 'left', 'right') + horizPad;
	    }

	    if (Math.round(height + vertPad) !== clientHeight) {
	      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	    }
	  } // Following steps can't be applied to the document's root element as its
	  // client[Width/Height] properties represent viewport area of the window.
	  // Besides, it's as well not necessary as the <html> itself neither has
	  // rendered scroll bars nor it can be clipped.


	  if (!isDocumentElement(target)) {
	    // In some browsers (only in Firefox, actually) CSS width & height
	    // include scroll bars size which can be removed at this step as scroll
	    // bars are the only difference between rounded dimensions + paddings
	    // and "client" properties, though that is not always true in Chrome.
	    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	    var horizScrollbar = Math.round(height + vertPad) - clientHeight; // Chrome has a rather weird rounding of "client" properties.
	    // E.g. for an element with content width of 314.2px it sometimes gives
	    // the client width of 315px and for the width of 314.7px it may give
	    // 314px. And it doesn't happen all the time. So just ignore this delta
	    // as a non-relevant.

	    if (Math.abs(vertScrollbar) !== 1) {
	      width -= vertScrollbar;
	    }

	    if (Math.abs(horizScrollbar) !== 1) {
	      height -= horizScrollbar;
	    }
	  }

	  return createRectInit(paddings.left, paddings.top, width, height);
	}
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */


	var isSVGGraphicsElement = function () {
	  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	  // interface.
	  if (typeof SVGGraphicsElement !== 'undefined') {
	    return function (target) {
	      return target instanceof getWindowOf(target).SVGGraphicsElement;
	    };
	  } // If it's so, then check that element is at least an instance of the
	  // SVGElement and that it has the "getBBox" method.
	  // eslint-disable-next-line no-extra-parens


	  return function (target) {
	    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
	  };
	}();
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */


	function isDocumentElement(target) {
	  return target === getWindowOf(target).document.documentElement;
	}
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */


	function getContentRect(target) {
	  if (!isBrowser) {
	    return emptyRect;
	  }

	  if (isSVGGraphicsElement(target)) {
	    return getSVGContentRect(target);
	  }

	  return getHTMLElementContentRect(target);
	}
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */


	function createReadOnlyRect(_a) {
	  var x = _a.x,
	      y = _a.y,
	      width = _a.width,
	      height = _a.height; // If DOMRectReadOnly is available use it as a prototype for the rectangle.

	  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	  var rect = Object.create(Constr.prototype); // Rectangle's properties are not writable and non-enumerable.

	  defineConfigurable(rect, {
	    x: x,
	    y: y,
	    width: width,
	    height: height,
	    top: y,
	    right: x + width,
	    bottom: height + y,
	    left: x
	  });
	  return rect;
	}
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */


	function createRectInit(x, y, width, height) {
	  return {
	    x: x,
	    y: y,
	    width: width,
	    height: height
	  };
	}
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */


	var ResizeObservation =
	/** @class */
	function () {
	  /**
	   * Creates an instance of ResizeObservation.
	   *
	   * @param {Element} target - Element to be observed.
	   */
	  function ResizeObservation(target) {
	    /**
	     * Broadcasted width of content rectangle.
	     *
	     * @type {number}
	     */
	    this.broadcastWidth = 0;
	    /**
	     * Broadcasted height of content rectangle.
	     *
	     * @type {number}
	     */

	    this.broadcastHeight = 0;
	    /**
	     * Reference to the last observed content rectangle.
	     *
	     * @private {DOMRectInit}
	     */

	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	    this.target = target;
	  }
	  /**
	   * Updates content rectangle and tells whether it's width or height properties
	   * have changed since the last broadcast.
	   *
	   * @returns {boolean}
	   */


	  ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	    this.contentRect_ = rect;
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	  };
	  /**
	   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	   * from the corresponding properties of the last observed content rectangle.
	   *
	   * @returns {DOMRectInit} Last observed content rectangle.
	   */


	  ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	    return rect;
	  };

	  return ResizeObservation;
	}();

	var ResizeObserverEntry =
	/** @class */
	function () {
	  /**
	   * Creates an instance of ResizeObserverEntry.
	   *
	   * @param {Element} target - Element that is being observed.
	   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	   */
	  function ResizeObserverEntry(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit); // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.

	    defineConfigurable(this, {
	      target: target,
	      contentRect: contentRect
	    });
	  }

	  return ResizeObserverEntry;
	}();

	var ResizeObserverSPI =
	/** @class */
	function () {
	  /**
	   * Creates a new instance of ResizeObserver.
	   *
	   * @param {ResizeObserverCallback} callback - Callback function that is invoked
	   *      when one of the observed elements changes it's content dimensions.
	   * @param {ResizeObserverController} controller - Controller instance which
	   *      is responsible for the updates of observer.
	   * @param {ResizeObserver} callbackCtx - Reference to the public
	   *      ResizeObserver instance which will be passed to callback function.
	   */
	  function ResizeObserverSPI(callback, controller, callbackCtx) {
	    /**
	     * Collection of resize observations that have detected changes in dimensions
	     * of elements.
	     *
	     * @private {Array<ResizeObservation>}
	     */
	    this.activeObservations_ = [];
	    /**
	     * Registry of the ResizeObservation instances.
	     *
	     * @private {Map<Element, ResizeObservation>}
	     */

	    this.observations_ = new MapShim();

	    if (typeof callback !== 'function') {
	      throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }

	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	  }
	  /**
	   * Starts observing provided element.
	   *
	   * @param {Element} target - Element to be observed.
	   * @returns {void}
	   */


	  ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	      throw new TypeError('1 argument required, but only 0 present.');
	    } // Do nothing if current environment doesn't have the Element interface.


	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	      return;
	    }

	    if (!(target instanceof getWindowOf(target).Element)) {
	      throw new TypeError('parameter 1 is not of type "Element".');
	    }

	    var observations = this.observations_; // Do nothing if element is already being observed.

	    if (observations.has(target)) {
	      return;
	    }

	    observations.set(target, new ResizeObservation(target));
	    this.controller_.addObserver(this); // Force the update of observations.

	    this.controller_.refresh();
	  };
	  /**
	   * Stops observing provided element.
	   *
	   * @param {Element} target - Element to stop observing.
	   * @returns {void}
	   */


	  ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	      throw new TypeError('1 argument required, but only 0 present.');
	    } // Do nothing if current environment doesn't have the Element interface.


	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	      return;
	    }

	    if (!(target instanceof getWindowOf(target).Element)) {
	      throw new TypeError('parameter 1 is not of type "Element".');
	    }

	    var observations = this.observations_; // Do nothing if element is not being observed.

	    if (!observations.has(target)) {
	      return;
	    }

	    observations.delete(target);

	    if (!observations.size) {
	      this.controller_.removeObserver(this);
	    }
	  };
	  /**
	   * Stops observing all elements.
	   *
	   * @returns {void}
	   */


	  ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	  };
	  /**
	   * Collects observation instances the associated element of which has changed
	   * it's content rectangle.
	   *
	   * @returns {void}
	   */


	  ResizeObserverSPI.prototype.gatherActive = function () {
	    var _this = this;

	    this.clearActive();
	    this.observations_.forEach(function (observation) {
	      if (observation.isActive()) {
	        _this.activeObservations_.push(observation);
	      }
	    });
	  };
	  /**
	   * Invokes initial callback function with a list of ResizeObserverEntry
	   * instances collected from active resize observations.
	   *
	   * @returns {void}
	   */


	  ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	      return;
	    }

	    var ctx = this.callbackCtx_; // Create ResizeObserverEntry instance for every active observation.

	    var entries = this.activeObservations_.map(function (observation) {
	      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	  };
	  /**
	   * Clears the collection of active observations.
	   *
	   * @returns {void}
	   */


	  ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	  };
	  /**
	   * Tells whether observer has active observations.
	   *
	   * @returns {boolean}
	   */


	  ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	  };

	  return ResizeObserverSPI;
	}(); // Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.


	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */

	var ResizeObserver =
	/** @class */
	function () {
	  /**
	   * Creates a new instance of ResizeObserver.
	   *
	   * @param {ResizeObserverCallback} callback - Callback that is invoked when
	   *      dimensions of the observed elements change.
	   */
	  function ResizeObserver(callback) {
	    if (!(this instanceof ResizeObserver)) {
	      throw new TypeError('Cannot call a class as a function.');
	    }

	    if (!arguments.length) {
	      throw new TypeError('1 argument required, but only 0 present.');
	    }

	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	    observers.set(this, observer);
	  }

	  return ResizeObserver;
	}(); // Expose public methods of ResizeObserver.


	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	  ResizeObserver.prototype[method] = function () {
	    var _a;

	    return (_a = observers.get(this))[method].apply(_a, arguments);
	  };
	});

	var index = function () {
	  // Export existing implementation if available.
	  if (typeof global$1$1.ResizeObserver !== 'undefined') {
	    return global$1$1.ResizeObserver;
	  }

	  return ResizeObserver;
	}();

	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;

	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }

	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }

	  return false;
	}
	function restoreFocus(activeElement, container) {
	  // Focus back if is in the container
	  if (activeElement !== document.activeElement && contains$1(container, activeElement) && typeof activeElement.focus === 'function') {
	    activeElement.focus();
	  }
	}
	function monitorResize(element, callback) {
	  var prevWidth = null;
	  var prevHeight = null;

	  function onResize(_ref) {
	    var _ref2 = _slicedToArray(_ref, 1),
	        target = _ref2[0].target;

	    if (!document.documentElement.contains(target)) return;

	    var _target$getBoundingCl = target.getBoundingClientRect(),
	        width = _target$getBoundingCl.width,
	        height = _target$getBoundingCl.height;

	    var fixedWidth = Math.floor(width);
	    var fixedHeight = Math.floor(height);

	    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
	      // https://webkit.org/blog/9997/resizeobserver-in-webkit/
	      Promise.resolve().then(function () {
	        callback({
	          width: fixedWidth,
	          height: fixedHeight
	        });
	      });
	    }

	    prevWidth = fixedWidth;
	    prevHeight = fixedHeight;
	  }

	  var resizeObserver = new index(onResize);

	  if (element) {
	    resizeObserver.observe(element);
	  }

	  return function () {
	    resizeObserver.disconnect();
	  };
	}

	var useBuffer = (function (callback, buffer) {
	  var calledRef = React__default['default'].useRef(false);
	  var timeoutRef = React__default['default'].useRef(null);

	  function cancelTrigger() {
	    window.clearTimeout(timeoutRef.current);
	  }

	  function trigger(force) {
	    if (!calledRef.current || force === true) {
	      if (callback() === false) {
	        // Not delay since callback cancelled self
	        return;
	      }

	      calledRef.current = true;
	      cancelTrigger();
	      timeoutRef.current = window.setTimeout(function () {
	        calledRef.current = false;
	      }, buffer);
	    } else {
	      cancelTrigger();
	      timeoutRef.current = window.setTimeout(function () {
	        calledRef.current = false;
	        trigger();
	      }, buffer);
	    }
	  }

	  return [trigger, function () {
	    calledRef.current = false;
	    cancelTrigger();
	  }];
	});

	function getElement(func) {
	  if (typeof func !== 'function') return null;
	  return func();
	}

	function getPoint(point) {
	  if (_typeof$1(point) !== 'object' || !point) return null;
	  return point;
	}

	var Align = function Align(_ref, ref) {
	  var children = _ref.children,
	      disabled = _ref.disabled,
	      target = _ref.target,
	      align = _ref.align,
	      onAlign = _ref.onAlign,
	      monitorWindowResize = _ref.monitorWindowResize,
	      _ref$monitorBufferTim = _ref.monitorBufferTime,
	      monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
	  var cacheRef = React__default['default'].useRef({});
	  var nodeRef = React__default['default'].useRef();
	  var childNode = React__default['default'].Children.only(children); // ===================== Align ======================
	  // We save the props here to avoid closure makes props ood

	  var forceAlignPropsRef = React__default['default'].useRef({});
	  forceAlignPropsRef.current.disabled = disabled;
	  forceAlignPropsRef.current.target = target;
	  forceAlignPropsRef.current.align = align;
	  forceAlignPropsRef.current.onAlign = onAlign;

	  var _useBuffer = useBuffer(function () {
	    var _forceAlignPropsRef$c = forceAlignPropsRef.current,
	        latestDisabled = _forceAlignPropsRef$c.disabled,
	        latestTarget = _forceAlignPropsRef$c.target,
	        latestAlign = _forceAlignPropsRef$c.align,
	        latestOnAlign = _forceAlignPropsRef$c.onAlign;

	    if (!latestDisabled && latestTarget) {
	      var source = nodeRef.current;
	      var result;
	      var element = getElement(latestTarget);
	      var point = getPoint(latestTarget);
	      cacheRef.current.element = element;
	      cacheRef.current.point = point;
	      cacheRef.current.align = latestAlign; // IE lose focus after element realign
	      // We should record activeElement and restore later
	      // IE lose focus after element realign
	      // We should record activeElement and restore later

	      var _document = document,
	          activeElement = _document.activeElement; // We only align when element is visible
	      // We only align when element is visible

	      if (element && isVisible(element)) {
	        result = alignElement(source, element, latestAlign);
	      } else if (point) {
	        result = alignPoint(source, point, latestAlign);
	      }

	      restoreFocus(activeElement, source);

	      if (latestOnAlign && result) {
	        latestOnAlign(source, result);
	      }

	      return true;
	    }

	    return false;
	  }, monitorBufferTime),
	      _useBuffer2 = _slicedToArray(_useBuffer, 2),
	      _forceAlign = _useBuffer2[0],
	      cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
	  // Listen for target updated


	  var resizeMonitor = React__default['default'].useRef({
	    cancel: function cancel() {}
	  }); // Listen for source updated

	  var sourceResizeMonitor = React__default['default'].useRef({
	    cancel: function cancel() {}
	  });
	  React__default['default'].useEffect(function () {
	    var element = getElement(target);
	    var point = getPoint(target);

	    if (nodeRef.current !== sourceResizeMonitor.current.element) {
	      sourceResizeMonitor.current.cancel();
	      sourceResizeMonitor.current.element = nodeRef.current;
	      sourceResizeMonitor.current.cancel = monitorResize(nodeRef.current, _forceAlign);
	    }

	    if (cacheRef.current.element !== element || !isSamePoint(cacheRef.current.point, point) || !isEqual_1(cacheRef.current.align, align)) {
	      _forceAlign(); // Add resize observer


	      if (resizeMonitor.current.element !== element) {
	        resizeMonitor.current.cancel();
	        resizeMonitor.current.element = element;
	        resizeMonitor.current.cancel = monitorResize(element, _forceAlign);
	      }
	    }
	  }); // Listen for disabled change

	  React__default['default'].useEffect(function () {
	    if (!disabled) {
	      _forceAlign();
	    } else {
	      cancelForceAlign();
	    }
	  }, [disabled]); // Listen for window resize

	  var winResizeRef = React__default['default'].useRef(null);
	  React__default['default'].useEffect(function () {
	    if (monitorWindowResize) {
	      if (!winResizeRef.current) {
	        winResizeRef.current = addEventListenerWrap(window, 'resize', _forceAlign);
	      }
	    } else if (winResizeRef.current) {
	      winResizeRef.current.remove();
	      winResizeRef.current = null;
	    }
	  }, [monitorWindowResize]); // Clear all if unmount

	  React__default['default'].useEffect(function () {
	    return function () {
	      resizeMonitor.current.cancel();
	      sourceResizeMonitor.current.cancel();
	      if (winResizeRef.current) winResizeRef.current.remove();
	      cancelForceAlign();
	    };
	  }, []); // ====================== Ref =======================

	  React__default['default'].useImperativeHandle(ref, function () {
	    return {
	      forceAlign: function forceAlign() {
	        return _forceAlign(true);
	      }
	    };
	  }); // ===================== Render =====================

	  if ( /*#__PURE__*/React__default['default'].isValidElement(childNode)) {
	    childNode = /*#__PURE__*/React__default['default'].cloneElement(childNode, {
	      ref: composeRef(childNode.ref, nodeRef)
	    });
	  }

	  return childNode;
	};

	var RcAlign = /*#__PURE__*/React__default['default'].forwardRef(Align);
	RcAlign.displayName = 'Align';

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var runtime_1 = createCommonjsModule(function (module) {
	var runtime = function (exports) {

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined$1; // More compressible than void 0.

	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }

	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function (obj, key, value) {
	      return obj[key] = value;
	    };
	  }

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.

	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	    return generator;
	  }

	  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.

	  function tryCatch(fn, obj, arg) {
	    try {
	      return {
	        type: "normal",
	        arg: fn.call(obj, arg)
	      };
	    } catch (err) {
	      return {
	        type: "throw",
	        arg: err
	      };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.

	  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.

	  function Generator() {}

	  function GeneratorFunction() {}

	  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.


	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

	  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = GeneratorFunctionPrototype;
	  define(Gp, "constructor", GeneratorFunctionPrototype);
	  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
	  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.

	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      define(prototype, method, function (arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }

	  exports.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };

	  exports.mark = function (genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }

	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  }; // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.


	  exports.awrap = function (arg) {
	    return {
	      __await: arg
	    };
	  };

	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);

	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;

	        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return PromiseImpl.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function (error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise = // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    } // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).


	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  });
	  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.

	  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
	    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        } // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;

	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);

	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;
	        var record = tryCatch(innerFn, self, context);

	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };
	        } else if (record.type === "throw") {
	          state = GenStateCompleted; // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.

	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  } // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.


	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];

	    if (method === undefined$1) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        // Note: ["return"] must be used for ES3 parsing compatibility.
	        if (delegate.iterator["return"]) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined$1;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError("The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (!info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

	      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.

	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined$1;
	      }
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    } // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.


	    context.delegate = null;
	    return ContinueSentinel;
	  } // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.


	  defineIteratorMethods(Gp);
	  define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.

	  define(Gp, iteratorSymbol, function () {
	    return this;
	  });
	  define(Gp, "toString", function () {
	    return "[object Generator]";
	  });

	  function pushTryEntry(locs) {
	    var entry = {
	      tryLoc: locs[0]
	    };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{
	      tryLoc: "root"
	    }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  exports.keys = function (object) {
	    var keys = [];

	    for (var key in object) {
	      keys.push(key);
	    }

	    keys.reverse(); // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.

	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();

	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      } // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.


	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];

	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined$1;
	          next.done = true;
	          return next;
	        };

	        return next.next = next;
	      }
	    } // Return an iterator with no values.


	    return {
	      next: doneResult
	    };
	  }

	  exports.values = values;

	  function doneResult() {
	    return {
	      value: undefined$1,
	      done: true
	    };
	  }

	  Context.prototype = {
	    constructor: Context,
	    reset: function (skipTempReset) {
	      this.prev = 0;
	      this.next = 0; // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.

	      this.sent = this._sent = undefined$1;
	      this.done = false;
	      this.delegate = null;
	      this.method = "next";
	      this.arg = undefined$1;
	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined$1;
	          }
	        }
	      }
	    },
	    stop: function () {
	      this.done = true;
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;

	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },
	    dispatchException: function (exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;

	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined$1;
	        }

	        return !!caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	    abrupt: function (type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];

	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },
	    complete: function (record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },
	    finish: function (finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];

	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	    "catch": function (tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];

	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;

	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }

	          return thrown;
	        }
	      } // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.


	      throw new Error("illegal catch attempt");
	    },
	    delegateYield: function (iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined$1;
	      }

	      return ContinueSentinel;
	    }
	  }; // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.

	  return exports;
	}( // If this script is executing as a CommonJS module, use module.exports
	// as the regeneratorRuntime namespace. Otherwise create a new empty
	// object. Either way, the resulting object will be used to initialize
	// the regeneratorRuntime variable at the top of this file.
	 module.exports );

	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, in modern engines
	  // we can explicitly access globalThis. In older engines we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}
	});

	var regenerator = runtime_1;

	function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
	  try {
	    var info = gen[key](arg);
	    var value = info.value;
	  } catch (error) {
	    reject(error);
	    return;
	  }

	  if (info.done) {
	    resolve(value);
	  } else {
	    Promise.resolve(value).then(_next, _throw);
	  }
	}

	function _asyncToGenerator(fn) {
	  return function () {
	    var self = this,
	        args = arguments;
	    return new Promise(function (resolve, reject) {
	      var gen = fn.apply(self, args);

	      function _next(value) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
	      }

	      function _throw(err) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
	      }

	      _next(undefined);
	    });
	  };
	}

	var StatusQueue = ['measure', 'align', null, 'motion'];
	var useVisibleStatus = (function (visible, doMeasure) {
	  var _useState = React.useState(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      status = _useState2[0],
	      setInternalStatus = _useState2[1];

	  var rafRef = React.useRef();
	  var destroyRef = React.useRef(false);

	  function setStatus(nextStatus) {
	    if (!destroyRef.current) {
	      setInternalStatus(nextStatus);
	    }
	  }

	  function cancelRaf() {
	    wrapperRaf.cancel(rafRef.current);
	  }

	  function goNextStatus(callback) {
	    cancelRaf();
	    rafRef.current = wrapperRaf(function () {
	      // Only align should be manually trigger
	      setStatus(function (prev) {
	        switch (status) {
	          case 'align':
	            return 'motion';

	          case 'motion':
	            return 'stable';
	        }

	        return prev;
	      });
	      callback === null || callback === void 0 ? void 0 : callback();
	    });
	  } // Init status


	  React.useEffect(function () {
	    setStatus('measure');
	  }, [visible]); // Go next status

	  React.useEffect(function () {
	    switch (status) {
	      case 'measure':
	        doMeasure();
	        break;
	    }

	    if (status) {
	      rafRef.current = wrapperRaf( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
	        var index, nextStatus;
	        return regenerator.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                index = StatusQueue.indexOf(status);
	                nextStatus = StatusQueue[index + 1];

	                if (nextStatus && index !== -1) {
	                  setStatus(nextStatus);
	                }

	              case 3:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee);
	      })));
	    }
	  }, [status]);
	  React.useEffect(function () {
	    return function () {
	      destroyRef.current = true;
	      cancelRaf();
	    };
	  }, []);
	  return [status, goNextStatus];
	});

	var useStretchStyle = (function (stretch) {
	  var _React$useState = React.useState({
	    width: 0,
	    height: 0
	  }),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      targetSize = _React$useState2[0],
	      setTargetSize = _React$useState2[1];

	  function measureStretch(element) {
	    setTargetSize({
	      width: element.offsetWidth,
	      height: element.offsetHeight
	    });
	  } // Merge stretch style


	  var style = React.useMemo(function () {
	    var sizeStyle = {};

	    if (stretch) {
	      var width = targetSize.width,
	          height = targetSize.height; // Stretch with target

	      if (stretch.indexOf('height') !== -1 && height) {
	        sizeStyle.height = height;
	      } else if (stretch.indexOf('minHeight') !== -1 && height) {
	        sizeStyle.minHeight = height;
	      }

	      if (stretch.indexOf('width') !== -1 && width) {
	        sizeStyle.width = width;
	      } else if (stretch.indexOf('minWidth') !== -1 && width) {
	        sizeStyle.minWidth = width;
	      }
	    }

	    return sizeStyle;
	  }, [stretch, targetSize]);
	  return [style, measureStretch];
	});

	var PopupInner = /*#__PURE__*/React.forwardRef(function (props, ref) {
	  var visible = props.visible,
	      prefixCls = props.prefixCls,
	      className = props.className,
	      style = props.style,
	      children = props.children,
	      zIndex = props.zIndex,
	      stretch = props.stretch,
	      destroyPopupOnHide = props.destroyPopupOnHide,
	      forceRender = props.forceRender,
	      align = props.align,
	      point = props.point,
	      getRootDomNode = props.getRootDomNode,
	      getClassNameFromAlign = props.getClassNameFromAlign,
	      onAlign = props.onAlign,
	      onMouseEnter = props.onMouseEnter,
	      onMouseLeave = props.onMouseLeave,
	      onMouseDown = props.onMouseDown,
	      onTouchStart = props.onTouchStart;
	  var alignRef = React.useRef();
	  var elementRef = React.useRef();

	  var _useState = React.useState(),
	      _useState2 = _slicedToArray(_useState, 2),
	      alignedClassName = _useState2[0],
	      setAlignedClassName = _useState2[1]; // ======================= Measure ========================


	  var _useStretchStyle = useStretchStyle(stretch),
	      _useStretchStyle2 = _slicedToArray(_useStretchStyle, 2),
	      stretchStyle = _useStretchStyle2[0],
	      measureStretchStyle = _useStretchStyle2[1];

	  function doMeasure() {
	    if (stretch) {
	      measureStretchStyle(getRootDomNode());
	    }
	  } // ======================== Status ========================


	  var _useVisibleStatus = useVisibleStatus(visible, doMeasure),
	      _useVisibleStatus2 = _slicedToArray(_useVisibleStatus, 2),
	      status = _useVisibleStatus2[0],
	      goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================


	  var prepareResolveRef = React.useRef(); // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align

	  function getAlignTarget() {
	    if (point) {
	      return point;
	    }

	    return getRootDomNode;
	  }

	  function forceAlign() {
	    var _alignRef$current;

	    (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 ? void 0 : _alignRef$current.forceAlign();
	  }

	  function onInternalAlign(popupDomNode, matchAlign) {
	    var nextAlignedClassName = getClassNameFromAlign(matchAlign);

	    if (alignedClassName !== nextAlignedClassName) {
	      setAlignedClassName(nextAlignedClassName);
	    }

	    if (status === 'align') {
	      // Repeat until not more align needed
	      if (alignedClassName !== nextAlignedClassName) {
	        Promise.resolve().then(function () {
	          forceAlign();
	        });
	      } else {
	        goNextStatus(function () {
	          var _prepareResolveRef$cu;

	          (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 ? void 0 : _prepareResolveRef$cu.call(prepareResolveRef);
	        });
	      }

	      onAlign === null || onAlign === void 0 ? void 0 : onAlign(popupDomNode, matchAlign);
	    }
	  } // ======================== Motion ========================


	  var motion = _objectSpread2({}, getMotion(props));

	  ['onAppearEnd', 'onEnterEnd', 'onLeaveEnd'].forEach(function (eventName) {
	    var originHandler = motion[eventName];

	    motion[eventName] = function (element, event) {
	      goNextStatus();
	      return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
	    };
	  });

	  function onShowPrepare() {
	    return new Promise(function (resolve) {
	      prepareResolveRef.current = resolve;
	    });
	  } // Go to stable directly when motion not provided


	  React.useEffect(function () {
	    if (!motion.motionName && status === 'motion') {
	      goNextStatus();
	    }
	  }, [motion.motionName, status]); // ========================= Refs =========================

	  React.useImperativeHandle(ref, function () {
	    return {
	      forceAlign: forceAlign,
	      getElement: function getElement() {
	        return elementRef.current;
	      }
	    };
	  }); // ======================== Render ========================

	  var mergedStyle = _objectSpread2(_objectSpread2({}, stretchStyle), {}, {
	    zIndex: zIndex,
	    opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
	    pointerEvents: status === 'stable' ? undefined : 'none'
	  }, style); // Align status


	  var alignDisabled = true;

	  if ((align === null || align === void 0 ? void 0 : align.points) && (status === 'align' || status === 'stable')) {
	    alignDisabled = false;
	  }

	  var childNode = children; // Wrapper when multiple children

	  if (React.Children.count(children) > 1) {
	    childNode = /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children);
	  }

	  return /*#__PURE__*/React.createElement(CSSMotion, _extends$4p({
	    visible: visible,
	    ref: elementRef,
	    leavedClassName: "".concat(prefixCls, "-hidden")
	  }, motion, {
	    onAppearPrepare: onShowPrepare,
	    onEnterPrepare: onShowPrepare,
	    removeOnLeave: destroyPopupOnHide,
	    forceRender: forceRender
	  }), function (_ref, motionRef) {
	    var motionClassName = _ref.className,
	        motionStyle = _ref.style;
	    var mergedClassName = classnames$1(prefixCls, className, alignedClassName, motionClassName);
	    return /*#__PURE__*/React.createElement(RcAlign, {
	      target: getAlignTarget(),
	      key: "popup",
	      ref: alignRef,
	      monitorWindowResize: true,
	      disabled: alignDisabled,
	      align: align,
	      onAlign: onInternalAlign
	    }, /*#__PURE__*/React.createElement("div", {
	      ref: motionRef,
	      className: mergedClassName,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDownCapture: onMouseDown,
	      onTouchStartCapture: onTouchStart,
	      style: _objectSpread2(_objectSpread2({}, motionStyle), mergedStyle)
	    }, childNode));
	  });
	});
	PopupInner.displayName = 'PopupInner';

	var MobilePopupInner = /*#__PURE__*/React.forwardRef(function (props, ref) {
	  var prefixCls = props.prefixCls,
	      visible = props.visible,
	      zIndex = props.zIndex,
	      children = props.children,
	      _props$mobile = props.mobile;
	  _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
	  var popupClassName = _props$mobile.popupClassName,
	      popupStyle = _props$mobile.popupStyle,
	      _props$mobile$popupMo = _props$mobile.popupMotion,
	      popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo,
	      popupRender = _props$mobile.popupRender;
	  var elementRef = React.useRef(); // ========================= Refs =========================

	  React.useImperativeHandle(ref, function () {
	    return {
	      forceAlign: function forceAlign() {},
	      getElement: function getElement() {
	        return elementRef.current;
	      }
	    };
	  }); // ======================== Render ========================

	  var mergedStyle = _objectSpread2({
	    zIndex: zIndex
	  }, popupStyle);

	  var childNode = children; // Wrapper when multiple children

	  if (React.Children.count(children) > 1) {
	    childNode = /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children);
	  } // Mobile support additional render


	  if (popupRender) {
	    childNode = popupRender(childNode);
	  }

	  return /*#__PURE__*/React.createElement(CSSMotion, _extends$4p({
	    visible: visible,
	    ref: elementRef,
	    removeOnLeave: true
	  }, popupMotion), function (_ref, motionRef) {
	    var motionClassName = _ref.className,
	        motionStyle = _ref.style;
	    var mergedClassName = classnames$1(prefixCls, popupClassName, motionClassName);
	    return /*#__PURE__*/React.createElement("div", {
	      ref: motionRef,
	      className: mergedClassName,
	      style: _objectSpread2(_objectSpread2({}, motionStyle), mergedStyle)
	    }, childNode);
	  });
	});
	MobilePopupInner.displayName = 'MobilePopupInner';

	var _excluded$y = ["visible", "mobile"];
	var Popup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
	  var visible = _ref.visible,
	      mobile = _ref.mobile,
	      props = _objectWithoutProperties(_ref, _excluded$y);

	  var _useState = React.useState(visible),
	      _useState2 = _slicedToArray(_useState, 2),
	      innerVisible = _useState2[0],
	      serInnerVisible = _useState2[1];

	  var _useState3 = React.useState(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inMobile = _useState4[0],
	      setInMobile = _useState4[1];

	  var cloneProps = _objectSpread2(_objectSpread2({}, props), {}, {
	    visible: innerVisible
	  }); // We check mobile in visible changed here.
	  // And this also delay set `innerVisible` to avoid popup component render flash


	  React.useEffect(function () {
	    serInnerVisible(visible);

	    if (visible && mobile) {
	      setInMobile(isMobile());
	    }
	  }, [visible, mobile]);
	  var popupNode = inMobile ? /*#__PURE__*/React.createElement(MobilePopupInner, _extends$4p({}, cloneProps, {
	    mobile: mobile,
	    ref: ref
	  })) : /*#__PURE__*/React.createElement(PopupInner, _extends$4p({}, cloneProps, {
	    ref: ref
	  })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic

	  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Mask, cloneProps), popupNode);
	});
	Popup.displayName = 'Popup';

	var TriggerContext = /*#__PURE__*/React.createContext(null);

	function noop$2() {}

	function returnEmptyString() {
	  return '';
	}

	function returnDocument(element) {
	  if (element) {
	    return element.ownerDocument;
	  }

	  return window.document;
	}

	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	/**
	 * Internal usage. Do not use in your code since this will be removed.
	 */

	function generateTrigger(PortalComponent) {
	  var Trigger = /*#__PURE__*/function (_React$Component) {
	    _inherits$7(Trigger, _React$Component);

	    var _super = _createSuper(Trigger);

	    function Trigger(props) {
	      var _this;

	      _classCallCheck$7(this, Trigger);

	      _this = _super.call(this, props);
	      _this.popupRef = /*#__PURE__*/React.createRef();
	      _this.triggerRef = /*#__PURE__*/React.createRef();
	      _this.attachId = void 0;
	      _this.clickOutsideHandler = void 0;
	      _this.touchOutsideHandler = void 0;
	      _this.contextMenuOutsideHandler1 = void 0;
	      _this.contextMenuOutsideHandler2 = void 0;
	      _this.mouseDownTimeout = void 0;
	      _this.focusTime = void 0;
	      _this.preClickTime = void 0;
	      _this.preTouchTime = void 0;
	      _this.delayTimer = void 0;
	      _this.hasPopupMouseDown = void 0;

	      _this.onMouseEnter = function (e) {
	        var mouseEnterDelay = _this.props.mouseEnterDelay;

	        _this.fireEvents('onMouseEnter', e);

	        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	      };

	      _this.onMouseMove = function (e) {
	        _this.fireEvents('onMouseMove', e);

	        _this.setPoint(e);
	      };

	      _this.onMouseLeave = function (e) {
	        _this.fireEvents('onMouseLeave', e);

	        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
	      };

	      _this.onPopupMouseEnter = function () {
	        _this.clearDelayTimer();
	      };

	      _this.onPopupMouseLeave = function (e) {
	        var _this$popupRef$curren; // https://github.com/react-component/trigger/pull/13
	        // react bug?


	        if (e.relatedTarget && !e.relatedTarget.setTimeout && contains$1((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) {
	          return;
	        }

	        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
	      };

	      _this.onFocus = function (e) {
	        _this.fireEvents('onFocus', e); // incase focusin and focusout


	        _this.clearDelayTimer();

	        if (_this.isFocusToShow()) {
	          _this.focusTime = Date.now();

	          _this.delaySetPopupVisible(true, _this.props.focusDelay);
	        }
	      };

	      _this.onMouseDown = function (e) {
	        _this.fireEvents('onMouseDown', e);

	        _this.preClickTime = Date.now();
	      };

	      _this.onTouchStart = function (e) {
	        _this.fireEvents('onTouchStart', e);

	        _this.preTouchTime = Date.now();
	      };

	      _this.onBlur = function (e) {
	        _this.fireEvents('onBlur', e);

	        _this.clearDelayTimer();

	        if (_this.isBlurToHide()) {
	          _this.delaySetPopupVisible(false, _this.props.blurDelay);
	        }
	      };

	      _this.onContextMenu = function (e) {
	        e.preventDefault();

	        _this.fireEvents('onContextMenu', e);

	        _this.setPopupVisible(true, e);
	      };

	      _this.onContextMenuClose = function () {
	        if (_this.isContextMenuToShow()) {
	          _this.close();
	        }
	      };

	      _this.onClick = function (event) {
	        _this.fireEvents('onClick', event); // focus will trigger click


	        if (_this.focusTime) {
	          var preTime;

	          if (_this.preClickTime && _this.preTouchTime) {
	            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
	          } else if (_this.preClickTime) {
	            preTime = _this.preClickTime;
	          } else if (_this.preTouchTime) {
	            preTime = _this.preTouchTime;
	          }

	          if (Math.abs(preTime - _this.focusTime) < 20) {
	            return;
	          }

	          _this.focusTime = 0;
	        }

	        _this.preClickTime = 0;
	        _this.preTouchTime = 0; // Only prevent default when all the action is click.
	        // https://github.com/ant-design/ant-design/issues/17043
	        // https://github.com/ant-design/ant-design/issues/17291

	        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
	          event.preventDefault();
	        }

	        var nextVisible = !_this.state.popupVisible;

	        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
	          _this.setPopupVisible(!_this.state.popupVisible, event);
	        }
	      };

	      _this.onPopupMouseDown = function () {
	        _this.hasPopupMouseDown = true;
	        clearTimeout(_this.mouseDownTimeout);
	        _this.mouseDownTimeout = window.setTimeout(function () {
	          _this.hasPopupMouseDown = false;
	        }, 0);

	        if (_this.context) {
	          var _this$context;

	          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
	        }
	      };

	      _this.onDocumentClick = function (event) {
	        if (_this.props.mask && !_this.props.maskClosable) {
	          return;
	        }

	        var target = event.target;

	        var root = _this.getRootDomNode();

	        var popupNode = _this.getPopupDomNode();

	        if ( // mousedown on the target should also close popup when action is contextMenu.
	        // https://github.com/ant-design/ant-design/issues/29853
	        (!contains$1(root, target) || _this.isContextMenuOnly()) && !contains$1(popupNode, target) && !_this.hasPopupMouseDown) {
	          _this.close();
	        }
	      };

	      _this.getRootDomNode = function () {
	        var getTriggerDOMNode = _this.props.getTriggerDOMNode;

	        if (getTriggerDOMNode) {
	          return getTriggerDOMNode(_this.triggerRef.current);
	        }

	        try {
	          var domNode = findDOMNode(_this.triggerRef.current);

	          if (domNode) {
	            return domNode;
	          }
	        } catch (err) {// Do nothing
	        }

	        return ReactDOM__default['default'].findDOMNode(_assertThisInitialized(_this));
	      };

	      _this.getPopupClassNameFromAlign = function (align) {
	        var className = [];
	        var _this$props = _this.props,
	            popupPlacement = _this$props.popupPlacement,
	            builtinPlacements = _this$props.builtinPlacements,
	            prefixCls = _this$props.prefixCls,
	            alignPoint = _this$props.alignPoint,
	            getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;

	        if (popupPlacement && builtinPlacements) {
	          className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
	        }

	        if (getPopupClassNameFromAlign) {
	          className.push(getPopupClassNameFromAlign(align));
	        }

	        return className.join(' ');
	      };

	      _this.getComponent = function () {
	        var _this$props2 = _this.props,
	            prefixCls = _this$props2.prefixCls,
	            destroyPopupOnHide = _this$props2.destroyPopupOnHide,
	            popupClassName = _this$props2.popupClassName,
	            onPopupAlign = _this$props2.onPopupAlign,
	            popupMotion = _this$props2.popupMotion,
	            popupAnimation = _this$props2.popupAnimation,
	            popupTransitionName = _this$props2.popupTransitionName,
	            popupStyle = _this$props2.popupStyle,
	            mask = _this$props2.mask,
	            maskAnimation = _this$props2.maskAnimation,
	            maskTransitionName = _this$props2.maskTransitionName,
	            maskMotion = _this$props2.maskMotion,
	            zIndex = _this$props2.zIndex,
	            popup = _this$props2.popup,
	            stretch = _this$props2.stretch,
	            alignPoint = _this$props2.alignPoint,
	            mobile = _this$props2.mobile,
	            forceRender = _this$props2.forceRender;
	        var _this$state = _this.state,
	            popupVisible = _this$state.popupVisible,
	            point = _this$state.point;

	        var align = _this.getPopupAlign();

	        var mouseProps = {};

	        if (_this.isMouseEnterToShow()) {
	          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
	        }

	        if (_this.isMouseLeaveToHide()) {
	          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
	        }

	        mouseProps.onMouseDown = _this.onPopupMouseDown;
	        mouseProps.onTouchStart = _this.onPopupMouseDown;
	        return /*#__PURE__*/React.createElement(Popup, _extends$4p({
	          prefixCls: prefixCls,
	          destroyPopupOnHide: destroyPopupOnHide,
	          visible: popupVisible,
	          point: alignPoint && point,
	          className: popupClassName,
	          align: align,
	          onAlign: onPopupAlign,
	          animation: popupAnimation,
	          getClassNameFromAlign: _this.getPopupClassNameFromAlign
	        }, mouseProps, {
	          stretch: stretch,
	          getRootDomNode: _this.getRootDomNode,
	          style: popupStyle,
	          mask: mask,
	          zIndex: zIndex,
	          transitionName: popupTransitionName,
	          maskAnimation: maskAnimation,
	          maskTransitionName: maskTransitionName,
	          maskMotion: maskMotion,
	          ref: _this.popupRef,
	          motion: popupMotion,
	          mobile: mobile,
	          forceRender: forceRender
	        }), typeof popup === 'function' ? popup() : popup);
	      };

	      _this.attachParent = function (popupContainer) {
	        wrapperRaf.cancel(_this.attachId);
	        var _this$props3 = _this.props,
	            getPopupContainer = _this$props3.getPopupContainer,
	            getDocument = _this$props3.getDocument;

	        var domNode = _this.getRootDomNode();

	        var mountNode;

	        if (!getPopupContainer) {
	          mountNode = getDocument(_this.getRootDomNode()).body;
	        } else if (domNode || getPopupContainer.length === 0) {
	          // Compatible for legacy getPopupContainer with domNode argument.
	          // If no need `domNode` argument, will call directly.
	          // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
	          mountNode = getPopupContainer(domNode);
	        }

	        if (mountNode) {
	          mountNode.appendChild(popupContainer);
	        } else {
	          // Retry after frame render in case parent not ready
	          _this.attachId = wrapperRaf(function () {
	            _this.attachParent(popupContainer);
	          });
	        }
	      };

	      _this.getContainer = function () {
	        var getDocument = _this.props.getDocument;
	        var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
	        // https://github.com/react-component/trigger/issues/41

	        popupContainer.style.position = 'absolute';
	        popupContainer.style.top = '0';
	        popupContainer.style.left = '0';
	        popupContainer.style.width = '100%';

	        _this.attachParent(popupContainer);

	        return popupContainer;
	      };

	      _this.setPoint = function (point) {
	        var alignPoint = _this.props.alignPoint;
	        if (!alignPoint || !point) return;

	        _this.setState({
	          point: {
	            pageX: point.pageX,
	            pageY: point.pageY
	          }
	        });
	      };

	      _this.handlePortalUpdate = function () {
	        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
	          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
	        }
	      };

	      _this.triggerContextValue = {
	        onPopupMouseDown: _this.onPopupMouseDown
	      };

	      var _popupVisible;

	      if ('popupVisible' in props) {
	        _popupVisible = !!props.popupVisible;
	      } else {
	        _popupVisible = !!props.defaultPopupVisible;
	      }

	      _this.state = {
	        prevPopupVisible: _popupVisible,
	        popupVisible: _popupVisible
	      };
	      ALL_HANDLERS.forEach(function (h) {
	        _this["fire".concat(h)] = function (e) {
	          _this.fireEvents(h, e);
	        };
	      });
	      return _this;
	    }

	    _createClass$7(Trigger, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.componentDidUpdate();
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate() {
	        var props = this.props;
	        var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
	        // https://github.com/ant-design/ant-design/issues/5804
	        // https://github.com/react-component/calendar/issues/250
	        // https://github.com/react-component/trigger/issues/50

	        if (state.popupVisible) {
	          var currentDocument;

	          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	            currentDocument = props.getDocument(this.getRootDomNode());
	            this.clickOutsideHandler = addEventListenerWrap(currentDocument, 'mousedown', this.onDocumentClick);
	          } // always hide on mobile


	          if (!this.touchOutsideHandler) {
	            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
	            this.touchOutsideHandler = addEventListenerWrap(currentDocument, 'touchstart', this.onDocumentClick);
	          } // close popup when trigger type contains 'onContextMenu' and document is scrolling.


	          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
	            this.contextMenuOutsideHandler1 = addEventListenerWrap(currentDocument, 'scroll', this.onContextMenuClose);
	          } // close popup when trigger type contains 'onContextMenu' and window is blur.


	          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	            this.contextMenuOutsideHandler2 = addEventListenerWrap(window, 'blur', this.onContextMenuClose);
	          }

	          return;
	        }

	        this.clearOutsideHandler();
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.clearDelayTimer();
	        this.clearOutsideHandler();
	        clearTimeout(this.mouseDownTimeout);
	        wrapperRaf.cancel(this.attachId);
	      }
	    }, {
	      key: "getPopupDomNode",
	      value: function getPopupDomNode() {
	        var _this$popupRef$curren2; // for test


	        return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
	      }
	    }, {
	      key: "getPopupAlign",
	      value: function getPopupAlign() {
	        var props = this.props;
	        var popupPlacement = props.popupPlacement,
	            popupAlign = props.popupAlign,
	            builtinPlacements = props.builtinPlacements;

	        if (popupPlacement && builtinPlacements) {
	          return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
	        }

	        return popupAlign;
	      }
	    }, {
	      key: "setPopupVisible",
	      value:
	      /**
	       * @param popupVisible    Show or not the popup element
	       * @param event           SyntheticEvent, used for `pointAlign`
	       */
	      function setPopupVisible(popupVisible, event) {
	        var alignPoint = this.props.alignPoint;
	        var prevPopupVisible = this.state.popupVisible;
	        this.clearDelayTimer();

	        if (prevPopupVisible !== popupVisible) {
	          if (!('popupVisible' in this.props)) {
	            this.setState({
	              popupVisible: popupVisible,
	              prevPopupVisible: prevPopupVisible
	            });
	          }

	          this.props.onPopupVisibleChange(popupVisible);
	        } // Always record the point position since mouseEnterDelay will delay the show


	        if (alignPoint && event && popupVisible) {
	          this.setPoint(event);
	        }
	      }
	    }, {
	      key: "delaySetPopupVisible",
	      value: function delaySetPopupVisible(visible, delayS, event) {
	        var _this2 = this;

	        var delay = delayS * 1000;
	        this.clearDelayTimer();

	        if (delay) {
	          var point = event ? {
	            pageX: event.pageX,
	            pageY: event.pageY
	          } : null;
	          this.delayTimer = window.setTimeout(function () {
	            _this2.setPopupVisible(visible, point);

	            _this2.clearDelayTimer();
	          }, delay);
	        } else {
	          this.setPopupVisible(visible, event);
	        }
	      }
	    }, {
	      key: "clearDelayTimer",
	      value: function clearDelayTimer() {
	        if (this.delayTimer) {
	          clearTimeout(this.delayTimer);
	          this.delayTimer = null;
	        }
	      }
	    }, {
	      key: "clearOutsideHandler",
	      value: function clearOutsideHandler() {
	        if (this.clickOutsideHandler) {
	          this.clickOutsideHandler.remove();
	          this.clickOutsideHandler = null;
	        }

	        if (this.contextMenuOutsideHandler1) {
	          this.contextMenuOutsideHandler1.remove();
	          this.contextMenuOutsideHandler1 = null;
	        }

	        if (this.contextMenuOutsideHandler2) {
	          this.contextMenuOutsideHandler2.remove();
	          this.contextMenuOutsideHandler2 = null;
	        }

	        if (this.touchOutsideHandler) {
	          this.touchOutsideHandler.remove();
	          this.touchOutsideHandler = null;
	        }
	      }
	    }, {
	      key: "createTwoChains",
	      value: function createTwoChains(event) {
	        var childPros = this.props.children.props;
	        var props = this.props;

	        if (childPros[event] && props[event]) {
	          return this["fire".concat(event)];
	        }

	        return childPros[event] || props[event];
	      }
	    }, {
	      key: "isClickToShow",
	      value: function isClickToShow() {
	        var _this$props4 = this.props,
	            action = _this$props4.action,
	            showAction = _this$props4.showAction;
	        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	      }
	    }, {
	      key: "isContextMenuOnly",
	      value: function isContextMenuOnly() {
	        var action = this.props.action;
	        return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
	      }
	    }, {
	      key: "isContextMenuToShow",
	      value: function isContextMenuToShow() {
	        var _this$props5 = this.props,
	            action = _this$props5.action,
	            showAction = _this$props5.showAction;
	        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	      }
	    }, {
	      key: "isClickToHide",
	      value: function isClickToHide() {
	        var _this$props6 = this.props,
	            action = _this$props6.action,
	            hideAction = _this$props6.hideAction;
	        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	      }
	    }, {
	      key: "isMouseEnterToShow",
	      value: function isMouseEnterToShow() {
	        var _this$props7 = this.props,
	            action = _this$props7.action,
	            showAction = _this$props7.showAction;
	        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	      }
	    }, {
	      key: "isMouseLeaveToHide",
	      value: function isMouseLeaveToHide() {
	        var _this$props8 = this.props,
	            action = _this$props8.action,
	            hideAction = _this$props8.hideAction;
	        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	      }
	    }, {
	      key: "isFocusToShow",
	      value: function isFocusToShow() {
	        var _this$props9 = this.props,
	            action = _this$props9.action,
	            showAction = _this$props9.showAction;
	        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	      }
	    }, {
	      key: "isBlurToHide",
	      value: function isBlurToHide() {
	        var _this$props10 = this.props,
	            action = _this$props10.action,
	            hideAction = _this$props10.hideAction;
	        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	      }
	    }, {
	      key: "forcePopupAlign",
	      value: function forcePopupAlign() {
	        if (this.state.popupVisible) {
	          var _this$popupRef$curren3;

	          (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 ? void 0 : _this$popupRef$curren3.forceAlign();
	        }
	      }
	    }, {
	      key: "fireEvents",
	      value: function fireEvents(type, e) {
	        var childCallback = this.props.children.props[type];

	        if (childCallback) {
	          childCallback(e);
	        }

	        var callback = this.props[type];

	        if (callback) {
	          callback(e);
	        }
	      }
	    }, {
	      key: "close",
	      value: function close() {
	        this.setPopupVisible(false);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var popupVisible = this.state.popupVisible;
	        var _this$props11 = this.props,
	            children = _this$props11.children,
	            forceRender = _this$props11.forceRender,
	            alignPoint = _this$props11.alignPoint,
	            className = _this$props11.className,
	            autoDestroy = _this$props11.autoDestroy;
	        var child = React.Children.only(children);
	        var newChildProps = {
	          key: 'trigger'
	        }; // ============================== Visible Handlers ==============================
	        // >>> ContextMenu

	        if (this.isContextMenuToShow()) {
	          newChildProps.onContextMenu = this.onContextMenu;
	        } else {
	          newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	        } // >>> Click


	        if (this.isClickToHide() || this.isClickToShow()) {
	          newChildProps.onClick = this.onClick;
	          newChildProps.onMouseDown = this.onMouseDown;
	          newChildProps.onTouchStart = this.onTouchStart;
	        } else {
	          newChildProps.onClick = this.createTwoChains('onClick');
	          newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	          newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	        } // >>> Hover(enter)


	        if (this.isMouseEnterToShow()) {
	          newChildProps.onMouseEnter = this.onMouseEnter; // Point align

	          if (alignPoint) {
	            newChildProps.onMouseMove = this.onMouseMove;
	          }
	        } else {
	          newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	        } // >>> Hover(leave)


	        if (this.isMouseLeaveToHide()) {
	          newChildProps.onMouseLeave = this.onMouseLeave;
	        } else {
	          newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	        } // >>> Focus


	        if (this.isFocusToShow() || this.isBlurToHide()) {
	          newChildProps.onFocus = this.onFocus;
	          newChildProps.onBlur = this.onBlur;
	        } else {
	          newChildProps.onFocus = this.createTwoChains('onFocus');
	          newChildProps.onBlur = this.createTwoChains('onBlur');
	        } // =================================== Render ===================================


	        var childrenClassName = classnames$1(child && child.props && child.props.className, className);

	        if (childrenClassName) {
	          newChildProps.className = childrenClassName;
	        }

	        var cloneProps = _objectSpread2({}, newChildProps);

	        if (supportRef(child)) {
	          cloneProps.ref = composeRef(this.triggerRef, child.ref);
	        }

	        var trigger = /*#__PURE__*/React.cloneElement(child, cloneProps);
	        var portal; // prevent unmounting after it's rendered

	        if (popupVisible || this.popupRef.current || forceRender) {
	          portal = /*#__PURE__*/React.createElement(PortalComponent, {
	            key: "portal",
	            getContainer: this.getContainer,
	            didUpdate: this.handlePortalUpdate
	          }, this.getComponent());
	        }

	        if (!popupVisible && autoDestroy) {
	          portal = null;
	        }

	        return /*#__PURE__*/React.createElement(TriggerContext.Provider, {
	          value: this.triggerContextValue
	        }, trigger, portal);
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(_ref, prevState) {
	        var popupVisible = _ref.popupVisible;
	        var newState = {};

	        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
	          newState.popupVisible = popupVisible;
	          newState.prevPopupVisible = prevState.popupVisible;
	        }

	        return newState;
	      }
	    }]);

	    return Trigger;
	  }(React.Component);

	  Trigger.contextType = TriggerContext;
	  Trigger.defaultProps = {
	    prefixCls: 'rc-trigger-popup',
	    getPopupClassNameFromAlign: returnEmptyString,
	    getDocument: returnDocument,
	    onPopupVisibleChange: noop$2,
	    afterPopupVisibleChange: noop$2,
	    onPopupAlign: noop$2,
	    popupClassName: '',
	    mouseEnterDelay: 0,
	    mouseLeaveDelay: 0.1,
	    focusDelay: 0,
	    blurDelay: 0.15,
	    popupStyle: {},
	    destroyPopupOnHide: false,
	    popupAlign: {},
	    defaultPopupVisible: false,
	    mask: false,
	    maskClosable: true,
	    action: [],
	    showAction: [],
	    hideAction: [],
	    autoDestroy: false
	  };
	  return Trigger;
	}
	var Trigger = generateTrigger(Portal$1);

	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	var targetOffset = [0, 0];
	var placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};

	var Content = function Content(props) {
	  var overlay = props.overlay,
	      prefixCls = props.prefixCls,
	      id = props.id,
	      overlayInnerStyle = props.overlayInnerStyle;
	  return React.createElement("div", {
	    className: "".concat(prefixCls, "-inner"),
	    id: id,
	    role: "tooltip",
	    style: overlayInnerStyle
	  }, typeof overlay === 'function' ? overlay() : overlay);
	};

	var Tooltip = function Tooltip(props, ref) {
	  var overlayClassName = props.overlayClassName,
	      _props$trigger = props.trigger,
	      trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
	      _props$mouseEnterDela = props.mouseEnterDelay,
	      mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
	      _props$mouseLeaveDela = props.mouseLeaveDelay,
	      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
	      overlayStyle = props.overlayStyle,
	      _props$prefixCls = props.prefixCls,
	      prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls,
	      children = props.children,
	      onVisibleChange = props.onVisibleChange,
	      afterVisibleChange = props.afterVisibleChange,
	      transitionName = props.transitionName,
	      animation = props.animation,
	      _props$placement = props.placement,
	      placement = _props$placement === void 0 ? 'right' : _props$placement,
	      _props$align = props.align,
	      align = _props$align === void 0 ? {} : _props$align,
	      _props$destroyTooltip = props.destroyTooltipOnHide,
	      destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip,
	      defaultVisible = props.defaultVisible,
	      getTooltipContainer = props.getTooltipContainer,
	      overlayInnerStyle = props.overlayInnerStyle,
	      restProps = _objectWithoutProperties(props, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle"]);

	  var domRef = React.useRef(null);
	  React.useImperativeHandle(ref, function () {
	    return domRef.current;
	  });

	  var extraProps = _objectSpread2({}, restProps);

	  if ('visible' in props) {
	    extraProps.popupVisible = props.visible;
	  }

	  var getPopupElement = function getPopupElement() {
	    var _props$arrowContent = props.arrowContent,
	        arrowContent = _props$arrowContent === void 0 ? null : _props$arrowContent,
	        overlay = props.overlay,
	        id = props.id;
	    return [React.createElement("div", {
	      className: "".concat(prefixCls, "-arrow"),
	      key: "arrow"
	    }, arrowContent), React.createElement(Content, {
	      key: "content",
	      prefixCls: prefixCls,
	      id: id,
	      overlay: overlay,
	      overlayInnerStyle: overlayInnerStyle
	    })];
	  };

	  var destroyTooltip = false;
	  var autoDestroy = false;

	  if (typeof destroyTooltipOnHide === 'boolean') {
	    destroyTooltip = destroyTooltipOnHide;
	  } else if (destroyTooltipOnHide && _typeof$1(destroyTooltipOnHide) === 'object') {
	    var keepParent = destroyTooltipOnHide.keepParent;
	    destroyTooltip = keepParent === true;
	    autoDestroy = keepParent === false;
	  }

	  return React.createElement(Trigger, Object.assign({
	    popupClassName: overlayClassName,
	    prefixCls: prefixCls,
	    popup: getPopupElement,
	    action: trigger,
	    builtinPlacements: placements,
	    popupPlacement: placement,
	    ref: domRef,
	    popupAlign: align,
	    getPopupContainer: getTooltipContainer,
	    onPopupVisibleChange: onVisibleChange,
	    afterPopupVisibleChange: afterVisibleChange,
	    popupTransitionName: transitionName,
	    popupAnimation: animation,
	    defaultPopupVisible: defaultVisible,
	    destroyPopupOnHide: destroyTooltip,
	    autoDestroy: autoDestroy,
	    mouseLeaveDelay: mouseLeaveDelay,
	    popupStyle: overlayStyle,
	    mouseEnterDelay: mouseEnterDelay
	  }, extraProps), children);
	};

	var Tooltip$1 = React.forwardRef(Tooltip);

	var BASE_OFFSET = 4;
	var adjustOverflow = {
	  adjustX: false,
	  adjustY: false
	};
	var positions = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: adjustOverflow,
	    offset: [-4 * BASE_OFFSET, -0.5 * BASE_OFFSET]
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: adjustOverflow,
	    offset: [4 * BASE_OFFSET, -0.5 * BASE_OFFSET]
	  },
	  topCenter: {
	    points: ['bc', 'tc'],
	    overflow: adjustOverflow,
	    offset: [-1 * BASE_OFFSET, -4 * BASE_OFFSET]
	  },
	  bottomCenter: {
	    points: ['tc', 'bc'],
	    overflow: adjustOverflow,
	    offset: [-1 * BASE_OFFSET, 4 * BASE_OFFSET]
	  },
	  topEnd: {
	    points: ['br', 'tr'],
	    overflow: adjustOverflow,
	    offset: [BASE_OFFSET, -4 * BASE_OFFSET]
	  },
	  topStart: {
	    points: ['bl', 'tl'],
	    overflow: adjustOverflow,
	    offset: [-BASE_OFFSET, -4 * BASE_OFFSET]
	  },
	  bottomEnd: {
	    points: ['tr', 'br'],
	    overflow: adjustOverflow,
	    offset: [BASE_OFFSET, 4 * BASE_OFFSET]
	  },
	  bottomStart: {
	    points: ['tl', 'bl'],
	    overflow: adjustOverflow,
	    offset: [-BASE_OFFSET, 4 * BASE_OFFSET]
	  }
	};

	var styles$v = {"tooltip":"telia-react-tooltip","tooltip-arrow":"telia-react-tooltip-arrow","tooltip-placement-right":"telia-react-tooltip-placement-right","tooltip-placement-left":"telia-react-tooltip-placement-left","tooltip-placement-top":"telia-react-tooltip-placement-top","tooltip-placement-topLeft":"telia-react-tooltip-placement-topLeft","tooltip-placement-topRight":"telia-react-tooltip-placement-topRight","tooltip-placement-bottom":"telia-react-tooltip-placement-bottom","tooltip-placement-bottomLeft":"telia-react-tooltip-placement-bottomLeft","tooltip-placement-bottomRight":"telia-react-tooltip-placement-bottomRight"};

	var ContainerContext = /*#__PURE__*/React.createContext({
	  getContainer: function getContainer() {
	    return document.body;
	  }
	});

	var _excluded$z = ["tooltipContent", "children", "trigger", "placement", "getTooltipContainer"];
	var triggerOptions = ['click', 'hover', 'focus'];
	var placementOptions = ['topCenter', 'bottomCenter', 'right', 'left', 'topStart', 'topEnd', 'bottomStart', 'bottomEnd'];

	var Tooltip$2 = function Tooltip(_ref) {
	  var tooltipContent = _ref.tooltipContent,
	      children = _ref.children,
	      _ref$trigger = _ref.trigger,
	      trigger = _ref$trigger === void 0 ? 'click' : _ref$trigger,
	      _ref$placement = _ref.placement,
	      placement = _ref$placement === void 0 ? 'right' : _ref$placement,
	      getTooltipContainer = _ref.getTooltipContainer,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$z);

	  if (typeof tooltipContent === 'string') {
	    tooltipContent = /*#__PURE__*/React__default['default'].createElement(BodyText, {
	      tagName: "span",
	      size: "sm",
	      block: true
	    }, tooltipContent);
	  }

	  var _useContext = React.useContext(ContainerContext),
	      getContainer = _useContext.getContainer;

	  return /*#__PURE__*/React__default['default'].createElement(Tooltip$1, _extends_1({
	    trigger: trigger,
	    overlay: tooltipContent,
	    placement: placement,
	    destroyTooltipOnHide: true,
	    overlayClassName: styles$v.tooltip,
	    prefixCls: "telia-react-tooltip",
	    align: positions[placement],
	    getTooltipContainer: getTooltipContainer != null ? getTooltipContainer : getContainer
	  }, props), children);
	}; // Aliases for backwards compatibility

	var styles$w = {"amountChip":"telia-react-amountChip","amountChip_disabled":"telia-react-amountChip_disabled","amountChip_icon":"telia-react-amountChip_icon"};

	var _excluded$A = ["text", "disabled", "onClick"];

	var AmountChip = function AmountChip(_ref) {
	  var text = _ref.text,
	      disabled = _ref.disabled,
	      onClick = _ref.onClick,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$A);

	  var classNames = [styles$w.amountChip];
	  disabled && classNames.push(styles$w.amountChip_disabled);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "button",
	    onClick: onClick,
	    borderRadius: {
	      size: 'md'
	    },
	    className: ['amountChip-test', classNames],
	    padding: {
	      vertical: 'xs',
	      horizontal: 'xs'
	    }
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centered: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm"
	  }, text), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "close",
	    size: "xs",
	    className: styles$w.amountChip_icon
	  })));
	};

	var styles$x = {"dropdownMultiselect":"telia-react-dropdownMultiselect","dropdownMultiselect__container":"telia-react-dropdownMultiselect__container","dropdownMultiselect_error":"telia-react-dropdownMultiselect_error","input__container_error":"telia-react-input__container_error","dropdownMultiselect_open":"telia-react-dropdownMultiselect_open","inputMessage_textContainer":"telia-react-inputMessage_textContainer","inputMessage_text":"telia-react-inputMessage_text","input":"telia-react-input","input__container":"telia-react-input__container","input__container_disabled":"telia-react-input__container_disabled","input__iconWrapper__icon":"telia-react-input__iconWrapper__icon","optionlist":"telia-react-optionlist"};

	var _excluded$B = ["options", "onChange", "onClear", "errorText", "disabled", "className", "placeholder", "tooltip"];

	var DropdownMultiselect = function DropdownMultiselect(_ref) {
	  var _ref2, _ref3, _ref4;

	  var options = _ref.options,
	      onChange = _ref.onChange,
	      onClear = _ref.onClear,
	      errorText = _ref.errorText,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      placeholder = _ref.placeholder,
	      tooltip = _ref.tooltip,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$B);

	  var _useState = React.useState(false),
	      open = _useState[0],
	      setOpen = _useState[1];

	  var _useState2 = React.useState(),
	      focusedOptionId = _useState2[0],
	      setFocusedOptionId = _useState2[1];

	  var inputElement = React.useRef(null);
	  var dropdownElement = React.useRef(null);

	  var focusOnFirstFocusableOption = function focusOnFirstFocusableOption() {
	    var firstFocusableOption = filter$3(options).call(options, function (option) {
	      return !option.disabled;
	    })[0];

	    setFocusedOptionId(firstFocusableOption.value);
	  };

	  var handleInputClick = function handleInputClick() {
	    setOpen(!open);
	  };

	  var handleOptionListBlur = function handleOptionListBlur(event) {
	    var isFocusEvent = function isFocusEvent(e) {
	      return 'relatedTarget' in e;
	    };
	    /* This logic is related to the keyboard usability (closing on ESC) which is not supported in IE. That's why we leave IE out  */

	    /* istanbul ignore else */


	    if (!isIE11) {
	      var _dropdownElement$curr;

	      if (!isFocusEvent(event) || !((_dropdownElement$curr = dropdownElement.current) != null && _dropdownElement$curr.contains(event.relatedTarget))) {
	        setOpen(false);
	      }
	    }
	  };

	  var handleOnBlur = function handleOnBlur(event) {
	    var isFocusEvent = function isFocusEvent(e) {
	      return 'relatedTarget' in e;
	    };
	    /* istanbul ignore else */


	    if (!isIE11) {
	      var _dropdownElement$curr2;

	      /* istanbul ignore else  */
	      if (!isFocusEvent(event) || !((_dropdownElement$curr2 = dropdownElement.current) != null && _dropdownElement$curr2.contains(event.relatedTarget)) && open) {
	        setOpen(false);
	      }
	    }
	    /* istanbul ignore next  */


	    if (isIE11 && typeof document !== 'undefined') {
	      var _context;

	      /* Prevent the onBlur in IE if user has clicked an option from the list or the scrollbar inside the optionlist */
	      if (document.activeElement && indexOf$7(_context = document.activeElement.className).call(_context, 'telia-react-optionlist') < 0) {
	        setOpen(false);
	      }
	    }
	  };

	  var handleOptionSelect = function handleOptionSelect(event, option) {
	    onChange(event, option);
	  };

	  var handleOnClear = function handleOnClear(event) {
	    event.stopPropagation();
	    onClear();
	  };

	  var keyDown = function keyDown(event) {
	    if (event.key === 'Enter') {
	      handleInputClick();
	    }

	    if (event.key === 'ArrowDown' && !open || event.key === 'ArrowUp' && !open) {
	      event.preventDefault();
	      focusOnFirstFocusableOption();
	      setOpen(true);
	    }

	    if (event.key === 'Tab') {
	      setFocusedOptionId('');
	    }
	  };

	  var selectedOptionAmount = filter$3(options).call(options, function (option) {
	    return option.checked === true;
	  }).length;

	  var amountChip = /*#__PURE__*/React__default['default'].createElement(AmountChip, {
	    disabled: disabled,
	    text: selectedOptionAmount,
	    onClick: disabled ? undefined : handleOnClear,
	    tabIndex: disabled ? -1 : 0
	  });
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: classnames([styles$x.dropdownMultiselect, (_ref2 = {}, _ref2[styles$x.dropdownMultiselect_disabled] = disabled, _ref2), (_ref3 = {}, _ref3[styles$x.dropdownMultiselect_error] = errorText, _ref3), (_ref4 = {}, _ref4[styles$x.dropdownMultiselect_open] = open, _ref4), className]),
	    ref: dropdownElement,
	    onBlur: handleOnBlur
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$x.dropdownMultiselect__container,
	    tabIndex: 0,
	    onKeyDown: keyDown
	  }, /*#__PURE__*/React__default['default'].createElement(BaseInput, _extends_1({}, props, {
	    disabled: disabled,
	    wrapperTabIndex: -1,
	    confirmed: false,
	    onClick: disabled ? undefined : handleInputClick,
	    ref: inputElement,
	    errorText: errorText && errorText === ' ' ? ' ' : errorText,
	    borderRadius: {
	      size: 'sm'
	    }
	  }), !!selectedOptionAmount && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, !!tooltip && !disabled ? /*#__PURE__*/React__default['default'].createElement(Tooltip$2, {
	    placement: "bottomStart",
	    tooltipContent: tooltip,
	    trigger: "hover"
	  }, amountChip) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, amountChip), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  })), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    color: "gray400",
	    tagName: "span",
	    flexItem: true,
	    singleLine: true
	  }, placeholder), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(ResolveIcon, {
	    errorText: errorText,
	    iconColor: open ? 'purple500' : 'black',
	    iconName: open ? 'chevron-up' : 'chevron-down',
	    disabled: disabled
	  }))), !!open && /*#__PURE__*/React__default['default'].createElement(OptionList, {
	    options: options,
	    onBlur: handleOptionListBlur,
	    optionOnClick: handleOptionSelect,
	    focusedOptionId: focusedOptionId
	  }));
	};

	var styles$y = {"divider":"telia-react-divider"};

	var supportedDividerColors = keys$5(colors$1);

	var Divider = function Divider(_ref) {
	  var _ref$width = _ref.width,
	      width = _ref$width === void 0 ? 100 : _ref$width,
	      _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'gray300' : _ref$color;
	  var dividerWidth;

	  if (width > 100) {
	    dividerWidth = 100;
	  } else {
	    dividerWidth = width;
	  }

	  var hexColor = colors$1[color].color;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    style: {
	      width: dividerWidth + "%",
	      borderTop: "1px solid " + hexColor
	    },
	    className: styles$y.divider
	  });
	};

	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike_1(collection) ? Array(collection.length) : [];

	  _baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}

	var _baseMap = baseMap;

	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map$4(collection, iteratee) {
	  var func = isArray_1(collection) ? _arrayMap : _baseMap;
	  return func(collection, _baseIteratee(iteratee));
	}

	var map_1 = map$4;

	var func$8 = convert_1('map', map_1);

	func$8.placeholder = placeholder;
	var map$5 = func$8;

	var styles$z = {"fileUploader_input__hidden":"telia-react-fileUploader_input__hidden"};

	function Empty(_ref) {
	  var children = _ref.children;
	  return children;
	}

	var wrapEachComponentWithKey = (function (toBeWrappeds) {
	  return map$3(toBeWrappeds).call(toBeWrappeds, function (toBeWrapped, index) {
	    return /*#__PURE__*/React__default['default'].createElement(Empty, {
	      key: index
	    }, toBeWrapped);
	  });
	});

	function DeleteIcon(_ref) {
	  var onClick = _ref.onClick;
	  return /*#__PURE__*/React__default['default'].createElement(Link, {
	    onClick: onClick
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "close-circle",
	    color: "gray400",
	    size: "sm",
	    clickableAppearance: true,
	    hoverColor: "purple500"
	  })));
	}

	function FileIcon(_ref) {
	  var loading = _ref.loading,
	      showError = _ref.showError;

	  if (loading) {
	    return /*#__PURE__*/React__default['default'].createElement(Loader, {
	      size: "sm"
	    });
	  }

	  if (showError) {
	    return /*#__PURE__*/React__default['default'].createElement(Icon, {
	      name: "error-filled",
	      color: "red600",
	      size: "sm"
	    });
	  }

	  return /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "doc",
	    color: "gray400",
	    size: "sm"
	  });
	}

	function DownloadIcon(_ref) {
	  var url = _ref.url;
	  return /*#__PURE__*/React__default['default'].createElement(Link, {
	    openInNewWindow: true,
	    to: url
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "download",
	    size: "sm",
	    clickableAppearance: true
	  })));
	}

	var styles$A = {"file_box__error":"telia-react-file_box__error"};

	var isString$1 = function isString(str) {
	  return typeof str === 'string';
	};

	var isFunction$2 = function isFunction(obj) {
	  return typeof obj === 'function';
	};

	var isValidUrl = function isValidUrl(url) {
	  return isString$1(url) && indexOf$7(url).call(url, 'http') === 0;
	};

	var hasError = function hasError(message) {
	  return isString$1(message) && message.length > 0;
	};

	var File = function File(_ref) {
	  var name = _ref.name,
	      url = _ref.url,
	      onDelete = _ref.onDelete,
	      _ref$loading = _ref.loading,
	      loading = _ref$loading === void 0 ? false : _ref$loading,
	      _ref$message = _ref.message,
	      message = _ref$message === void 0 ? '' : _ref$message;
	  var showDelete = !loading && isFunction$2(onDelete);
	  var showDownload = !loading && isValidUrl(url);
	  var showError = !loading && hasError(message);
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$A.file,
	    borderRadius: true
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    borderRadius: {
	      size: 'sm'
	    },
	    backgroundColor: "gray100",
	    padding: {
	      horizontal: 'sm',
	      vertical: 'sm'
	    },
	    className: showError ? styles$A.file_box__error : null
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(FileIcon, {
	    loading: loading,
	    showError: showError
	  }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    padding: {
	      horizontal: 'xs'
	    },
	    flexItem: true
	  }, name), showDownload && /*#__PURE__*/React__default['default'].createElement(DownloadIcon, {
	    url: url
	  }), showDelete && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "sm"
	  }), /*#__PURE__*/React__default['default'].createElement(DeleteIcon, {
	    onClick: onDelete
	  })))), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    padding: {
	      horizontal: 'xs',
	      vertical: 'xs'
	    },
	    block: true,
	    color: "red600"
	  }, showError ? message : ''));
	};

	var _excluded$C = ["buttonText", "onChange", "files", "validTypes", "maximumAmountOfFiles"];

	var normalizeType = function normalizeType(type) {
	  return "." + type.toLowerCase();
	};

	var typesToAttribute = function typesToAttribute(types) {
	  return map$3(types).call(types, normalizeType).join(',');
	};

	var renderFile = function renderFile(_ref) {
	  var name = _ref.name,
	      url = _ref.url,
	      onDelete = _ref.onDelete,
	      loading = _ref.loading,
	      message = _ref.message;
	  return /*#__PURE__*/React__default['default'].createElement(File, {
	    name: name,
	    url: url,
	    onDelete: onDelete,
	    loading: loading,
	    message: message
	  });
	};

	var renderFiles = flow$1(map$5(renderFile), wrapEachComponentWithKey);

	var filesFromEvent = function filesFromEvent(_ref2) {
	  var _context;

	  var target = _ref2.target;
	  return concat$5(_context = []).call(_context, target.files);
	};

	var limitItems = function limitItems(list, quota, used) {
	  var remainingQuota = quota - used;
	  var end = remainingQuota >= 0 ? remainingQuota : 0;
	  return slice$3(list).call(list, 0, end);
	};

	var FileUploader = function FileUploader(_ref3) {
	  var buttonText = _ref3.buttonText,
	      onChange = _ref3.onChange,
	      files = _ref3.files,
	      _ref3$validTypes = _ref3.validTypes,
	      validTypes = _ref3$validTypes === void 0 ? [] : _ref3$validTypes,
	      _ref3$maximumAmountOf = _ref3.maximumAmountOfFiles,
	      maximumAmountOfFiles = _ref3$maximumAmountOf === void 0 ? 1 : _ref3$maximumAmountOf,
	      props = objectWithoutPropertiesLoose(_ref3, _excluded$C);

	  var fileInput = React.useRef(null);
	  var types = validTypes.length > 0 ? typesToAttribute(validTypes) : undefined;
	  var allowMultipleFiles = maximumAmountOfFiles - files.length > 1;
	  var maximumAmountOfFilesReached = files.length >= maximumAmountOfFiles;

	  var changeHandler = function changeHandler(event) {
	    var selectedFiles = filesFromEvent(event);
	    var allowedFiles = limitItems(selectedFiles, maximumAmountOfFiles, files.length);
	    onChange(event, allowedFiles);
	    event.target.value = '';
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement("input", _extends_1({
	    className: styles$z.fileUploader_input__hidden,
	    type: "file",
	    accept: types,
	    ref: fileInput,
	    onChange: changeHandler,
	    multiple: allowMultipleFiles
	  }, props)), /*#__PURE__*/React__default['default'].createElement(Button, {
	    variant: "secondary",
	    disabled: maximumAmountOfFilesReached,
	    onClick: function onClick() {
	      return fileInput.current && fileInput.current.click();
	    }
	  }, buttonText), /*#__PURE__*/React__default['default'].createElement(Gutter, null), renderFiles(files));
	};

	var regenerator$1 = runtime_1;

	var copyConstructorProperties$1 = function (target, source) {
	  var keys = ownKeys(source);
	  var defineProperty = objectDefineProperty.f;
	  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwnProperty_1(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	  }
	};

	var replace = functionUncurryThis(''.replace);
	var split$2 = functionUncurryThis(''.split);
	var join = functionUncurryThis([].join);

	var TEST = function (arg) {
	  return String(Error(arg).stack);
	}('zxcasd');

	var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
	var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
	var IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);

	var clearErrorStack = function (stack, dropEntries) {
	  if (typeof stack != 'string') return stack;

	  if (IS_V8_OR_CHAKRA_STACK) {
	    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
	  } else if (IS_FIREFOX_OR_SAFARI_STACK) {
	    return join(arraySlice(split$2(stack, '\n'), dropEntries), '\n');
	  }

	  return stack;
	};

	// `InstallErrorCause` abstract operation
	// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause


	var installErrorCause = function (O, options) {
	  if (isObject(options) && 'cause' in options) {
	    createNonEnumerableProperty(O, 'cause', options.cause);
	  }
	};

	var ITERATOR$2 = wellKnownSymbol('iterator');
	var ArrayPrototype$a = Array.prototype; // check on default Array iterator

	var isArrayIteratorMethod = function (it) {
	  return it !== undefined && (iterators.Array === it || ArrayPrototype$a[ITERATOR$2] === it);
	};

	var ITERATOR$3 = wellKnownSymbol('iterator');

	var getIteratorMethod = function (it) {
	  if (it != undefined) return getMethod(it, ITERATOR$3) || getMethod(it, '@@iterator') || iterators[classof(it)];
	};

	var TypeError$c = global$1.TypeError;

	var getIterator = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
	  throw TypeError$c(tryToString(argument) + ' is not iterable');
	};

	var iteratorClose = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);

	  try {
	    innerResult = getMethod(iterator, 'return');

	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }

	    innerResult = functionCall(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }

	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};

	var TypeError$d = global$1.TypeError;

	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};

	var ResultPrototype = Result.prototype;

	var iterate = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = functionBindContext(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;

	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal', condition);
	    return new Result(true, condition);
	  };

	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    }

	    return INTERRUPTED ? fn(value, stop) : fn(value);
	  };

	  if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw TypeError$d(tryToString(iterable) + ' is not iterable'); // optimisation for array iterators

	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	      }

	      return new Result(false);
	    }

	    iterator = getIterator(iterable, iterFn);
	  }

	  next = iterator.next;

	  while (!(step = functionCall(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }

	    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	  }

	  return new Result(false);
	};

	var normalizeStringArgument = function (argument, $default) {
	  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$2(argument);
	};

	var errorStackInstallable = !fails(function () {
	  var error = Error('a');
	  if (!('stack' in error)) return true; // eslint-disable-next-line es/no-object-defineproperty -- safe

	  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
	  return error.stack !== 7;
	});

	var TO_STRING_TAG$5 = wellKnownSymbol('toStringTag');
	var Error$1 = global$1.Error;
	var push$5 = [].push;

	var $AggregateError = function AggregateError(errors, message
	/* , options */
	) {
	  var options = arguments.length > 2 ? arguments[2] : undefined;
	  var isInstance = objectIsPrototypeOf(AggregateErrorPrototype, this);
	  var that;

	  if (objectSetPrototypeOf) {
	    that = objectSetPrototypeOf(new Error$1(undefined), isInstance ? objectGetPrototypeOf(this) : AggregateErrorPrototype);
	  } else {
	    that = isInstance ? this : objectCreate(AggregateErrorPrototype);
	    createNonEnumerableProperty(that, TO_STRING_TAG$5, 'Error');
	  }

	  createNonEnumerableProperty(that, 'message', normalizeStringArgument(message, ''));
	  if (errorStackInstallable) createNonEnumerableProperty(that, 'stack', clearErrorStack(that.stack, 1));
	  installErrorCause(that, options);
	  var errorsArray = [];
	  iterate(errors, push$5, {
	    that: errorsArray
	  });
	  createNonEnumerableProperty(that, 'errors', errorsArray);
	  return that;
	};

	if (objectSetPrototypeOf) objectSetPrototypeOf($AggregateError, Error$1);else copyConstructorProperties$1($AggregateError, Error$1);
	var AggregateErrorPrototype = $AggregateError.prototype = objectCreate(Error$1.prototype, {
	  constructor: createPropertyDescriptor(1, $AggregateError),
	  message: createPropertyDescriptor(1, ''),
	  name: createPropertyDescriptor(1, 'AggregateError')
	}); // `AggregateError` constructor
	// https://tc39.es/ecma262/#sec-aggregate-error-constructor

	_export({
	  global: true
	}, {
	  AggregateError: $AggregateError
	});

	var nativePromiseConstructor = global$1.Promise;

	var redefineAll = function (target, src, options) {
	  for (var key in src) {
	    if (options && options.unsafe && target[key]) target[key] = src[key];else redefine(target, key, src[key], options);
	  }

	  return target;
	};

	var SPECIES$6 = wellKnownSymbol('species');

	var setSpecies = function (CONSTRUCTOR_NAME) {
	  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
	  var defineProperty = objectDefineProperty.f;

	  if (descriptors && Constructor && !Constructor[SPECIES$6]) {
	    defineProperty(Constructor, SPECIES$6, {
	      configurable: true,
	      get: function () {
	        return this;
	      }
	    });
	  }
	};

	var TypeError$e = global$1.TypeError;

	var anInstance = function (it, Prototype) {
	  if (objectIsPrototypeOf(Prototype, it)) return it;
	  throw TypeError$e('Incorrect invocation');
	};

	var ITERATOR$4 = wellKnownSymbol('iterator');
	var SAFE_CLOSING = false;

	try {
	  var called = 0;
	  var iteratorWithReturn = {
	    next: function () {
	      return {
	        done: !!called++
	      };
	    },
	    'return': function () {
	      SAFE_CLOSING = true;
	    }
	  };

	  iteratorWithReturn[ITERATOR$4] = function () {
	    return this;
	  }; // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing


	  Array.from(iteratorWithReturn, function () {
	    throw 2;
	  });
	} catch (error) {
	  /* empty */
	}

	var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
	  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
	  var ITERATION_SUPPORT = false;

	  try {
	    var object = {};

	    object[ITERATOR$4] = function () {
	      return {
	        next: function () {
	          return {
	            done: ITERATION_SUPPORT = true
	          };
	        }
	      };
	    };

	    exec(object);
	  } catch (error) {
	    /* empty */
	  }

	  return ITERATION_SUPPORT;
	};

	var TypeError$f = global$1.TypeError; // `Assert: IsConstructor(argument) is true`

	var aConstructor = function (argument) {
	  if (isConstructor(argument)) return argument;
	  throw TypeError$f(tryToString(argument) + ' is not a constructor');
	};

	var SPECIES$7 = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor

	var speciesConstructor$1 = function (O, defaultConstructor) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES$7]) == undefined ? defaultConstructor : aConstructor(S);
	};

	var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent);

	var engineIsNode = classofRaw(global$1.process) == 'process';

	var set$2 = global$1.setImmediate;
	var clear = global$1.clearImmediate;
	var process$1 = global$1.process;
	var Dispatch = global$1.Dispatch;
	var Function$1 = global$1.Function;
	var MessageChannel = global$1.MessageChannel;
	var String$5 = global$1.String;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var location, defer, channel, port;

	try {
	  // Deno throws a ReferenceError on `location` access without `--location` flag
	  location = global$1.location;
	} catch (error) {
	  /* empty */
	}

	var run = function (id) {
	  if (hasOwnProperty_1(queue, id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};

	var runner = function (id) {
	  return function () {
	    run(id);
	  };
	};

	var listener = function (event) {
	  run(event.data);
	};

	var post = function (id) {
	  // old engines have not location.origin
	  global$1.postMessage(String$5(id), location.protocol + '//' + location.host);
	}; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


	if (!set$2 || !clear) {
	  set$2 = function setImmediate(fn) {
	    var args = arraySlice(arguments, 1);

	    queue[++counter] = function () {
	      functionApply(isCallable(fn) ? fn : Function$1(fn), undefined, args);
	    };

	    defer(counter);
	    return counter;
	  };

	  clear = function clearImmediate(id) {
	    delete queue[id];
	  }; // Node.js 0.8-


	  if (engineIsNode) {
	    defer = function (id) {
	      process$1.nextTick(runner(id));
	    }; // Sphere (JS game engine) Dispatch API

	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(runner(id));
	    }; // Browsers with MessageChannel, includes WebWorkers
	    // except iOS - https://github.com/zloirock/core-js/issues/624

	  } else if (MessageChannel && !engineIsIos) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = functionBindContext(port.postMessage, port); // Browsers with postMessage, skip WebWorkers
	    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global$1.addEventListener && isCallable(global$1.postMessage) && !global$1.importScripts && location && location.protocol !== 'file:' && !fails(post)) {
	    defer = post;
	    global$1.addEventListener('message', listener, false); // IE8-
	  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
	    defer = function (id) {
	      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run(id);
	      };
	    }; // Rest old browsers

	  } else {
	    defer = function (id) {
	      setTimeout(runner(id), 0);
	    };
	  }
	}

	var task = {
	  set: set$2,
	  clear: clear
	};

	var engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && global$1.Pebble !== undefined;

	var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);

	var getOwnPropertyDescriptor$6 = objectGetOwnPropertyDescriptor.f;

	var macrotask = task.set;









	var MutationObserver$1 = global$1.MutationObserver || global$1.WebKitMutationObserver;
	var document$3 = global$1.document;
	var process$2 = global$1.process;
	var Promise$3 = global$1.Promise; // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`

	var queueMicrotaskDescriptor = getOwnPropertyDescriptor$6(global$1, 'queueMicrotask');
	var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
	var flush, head, last, notify, toggle, node, promise, then; // modern engines have queueMicrotask method

	if (!queueMicrotask) {
	  flush = function () {
	    var parent, fn;
	    if (engineIsNode && (parent = process$2.domain)) parent.exit();

	    while (head) {
	      fn = head.fn;
	      head = head.next;

	      try {
	        fn();
	      } catch (error) {
	        if (head) notify();else last = undefined;
	        throw error;
	      }
	    }

	    last = undefined;
	    if (parent) parent.enter();
	  }; // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
	  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898


	  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver$1 && document$3) {
	    toggle = true;
	    node = document$3.createTextNode('');
	    new MutationObserver$1(flush).observe(node, {
	      characterData: true
	    });

	    notify = function () {
	      node.data = toggle = !toggle;
	    }; // environments with maybe non-completely correct, but existent Promise

	  } else if (!engineIsIosPebble && Promise$3 && Promise$3.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    promise = Promise$3.resolve(undefined); // workaround of WebKit ~ iOS Safari 10.1 bug

	    promise.constructor = Promise$3;
	    then = functionBindContext(promise.then, promise);

	    notify = function () {
	      then(flush);
	    }; // Node.js without promises

	  } else if (engineIsNode) {
	    notify = function () {
	      process$2.nextTick(flush);
	    }; // for other environments - macrotask based on:
	    // - setImmediate
	    // - MessageChannel
	    // - window.postMessag
	    // - onreadystatechange
	    // - setTimeout

	  } else {
	    // strange IE + webpack dev server bug - use .bind(global)
	    macrotask = functionBindContext(macrotask, global$1);

	    notify = function () {
	      macrotask(flush);
	    };
	  }
	}

	var microtask = queueMicrotask || function (fn) {
	  var task = {
	    fn: fn,
	    next: undefined
	  };
	  if (last) last.next = task;

	  if (!head) {
	    head = task;
	    notify();
	  }

	  last = task;
	};

	var PromiseCapability = function (C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aCallable(resolve);
	  this.reject = aCallable(reject);
	}; // `NewPromiseCapability` abstract operation
	// https://tc39.es/ecma262/#sec-newpromisecapability


	var f$f = function (C) {
	  return new PromiseCapability(C);
	};

	var newPromiseCapability = {
		f: f$f
	};

	var promiseResolve = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};

	var hostReportErrors = function (a, b) {
	  var console = global$1.console;

	  if (console && console.error) {
	    arguments.length == 1 ? console.error(a) : console.error(a, b);
	  }
	};

	var perform = function (exec) {
	  try {
	    return {
	      error: false,
	      value: exec()
	    };
	  } catch (error) {
	    return {
	      error: true,
	      value: error
	    };
	  }
	};

	var engineIsBrowser = typeof window == 'object';

	var task$1 = task.set;























	var SPECIES$8 = wellKnownSymbol('species');
	var PROMISE = 'Promise';
	var getInternalState$3 = internalState.get;
	var setInternalState$3 = internalState.set;
	var getInternalPromiseState = internalState.getterFor(PROMISE);
	var NativePromisePrototype = nativePromiseConstructor && nativePromiseConstructor.prototype;
	var PromiseConstructor = nativePromiseConstructor;
	var PromisePrototype = NativePromisePrototype;
	var TypeError$g = global$1.TypeError;
	var document$4 = global$1.document;
	var process$3 = global$1.process;
	var newPromiseCapability$1 = newPromiseCapability.f;
	var newGenericPromiseCapability = newPromiseCapability$1;
	var DISPATCH_EVENT = !!(document$4 && document$4.createEvent && global$1.dispatchEvent);
	var NATIVE_REJECTION_EVENT = isCallable(global$1.PromiseRejectionEvent);
	var UNHANDLED_REJECTION = 'unhandledrejection';
	var REJECTION_HANDLED = 'rejectionhandled';
	var PENDING = 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	var HANDLED = 1;
	var UNHANDLED = 2;
	var SUBCLASSING = false;
	var Internal, OwnPromiseCapability, PromiseWrapper;
	var FORCED$2 = isForced_1(PROMISE, function () {
	  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
	  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor); // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	  // We can't detect it synchronously, so just check versions

	  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version === 66) return true; // We need Promise#finally in the pure version for preventing prototype pollution

	  if ( !PromisePrototype['finally']) return true; // We can't use @@species feature detection in V8 since it causes
	  // deoptimization and performance degradation
	  // https://github.com/zloirock/core-js/issues/679

	  if (engineV8Version >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false; // Detect correctness of subclassing with @@species support

	  var promise = new PromiseConstructor(function (resolve) {
	    resolve(1);
	  });

	  var FakePromise = function (exec) {
	    exec(function () {
	      /* empty */
	    }, function () {
	      /* empty */
	    });
	  };

	  var constructor = promise.constructor = {};
	  constructor[SPECIES$8] = FakePromise;
	  SUBCLASSING = promise.then(function () {
	    /* empty */
	  }) instanceof FakePromise;
	  if (!SUBCLASSING) return true; // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test

	  return !GLOBAL_CORE_JS_PROMISE && engineIsBrowser && !NATIVE_REJECTION_EVENT;
	});
	var INCORRECT_ITERATION = FORCED$2 || !checkCorrectnessOfIteration(function (iterable) {
	  PromiseConstructor.all(iterable)['catch'](function () {
	    /* empty */
	  });
	}); // helpers

	var isThenable = function (it) {
	  var then;
	  return isObject(it) && isCallable(then = it.then) ? then : false;
	};

	var notify$1 = function (state, isReject) {
	  if (state.notified) return;
	  state.notified = true;
	  var chain = state.reactions;
	  microtask(function () {
	    var value = state.value;
	    var ok = state.state == FULFILLED;
	    var index = 0; // variable length - can't use forEach

	    while (chain.length > index) {
	      var reaction = chain[index++];
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;

	      try {
	        if (handler) {
	          if (!ok) {
	            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
	            state.rejection = HANDLED;
	          }

	          if (handler === true) result = value;else {
	            if (domain) domain.enter();
	            result = handler(value); // can throw

	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }

	          if (result === reaction.promise) {
	            reject(TypeError$g('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            functionCall(then, result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (error) {
	        if (domain && !exited) domain.exit();
	        reject(error);
	      }
	    }

	    state.reactions = [];
	    state.notified = false;
	    if (isReject && !state.rejection) onUnhandled(state);
	  });
	};

	var dispatchEvent = function (name, promise, reason) {
	  var event, handler;

	  if (DISPATCH_EVENT) {
	    event = document$4.createEvent('Event');
	    event.promise = promise;
	    event.reason = reason;
	    event.initEvent(name, false, true);
	    global$1.dispatchEvent(event);
	  } else event = {
	    promise: promise,
	    reason: reason
	  };

	  if (!NATIVE_REJECTION_EVENT && (handler = global$1['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
	};

	var onUnhandled = function (state) {
	  functionCall(task$1, global$1, function () {
	    var promise = state.facade;
	    var value = state.value;
	    var IS_UNHANDLED = isUnhandled(state);
	    var result;

	    if (IS_UNHANDLED) {
	      result = perform(function () {
	        if (engineIsNode) {
	          process$3.emit('unhandledRejection', value, promise);
	        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
	      }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

	      state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED;
	      if (result.error) throw result.value;
	    }
	  });
	};

	var isUnhandled = function (state) {
	  return state.rejection !== HANDLED && !state.parent;
	};

	var onHandleUnhandled = function (state) {
	  functionCall(task$1, global$1, function () {
	    var promise = state.facade;

	    if (engineIsNode) {
	      process$3.emit('rejectionHandled', promise);
	    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
	  });
	};

	var bind$3 = function (fn, state, unwrap) {
	  return function (value) {
	    fn(state, value, unwrap);
	  };
	};

	var internalReject = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  state.value = value;
	  state.state = REJECTED;
	  notify$1(state, true);
	};

	var internalResolve = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;

	  try {
	    if (state.facade === value) throw TypeError$g("Promise can't be resolved itself");
	    var then = isThenable(value);

	    if (then) {
	      microtask(function () {
	        var wrapper = {
	          done: false
	        };

	        try {
	          functionCall(then, value, bind$3(internalResolve, wrapper, state), bind$3(internalReject, wrapper, state));
	        } catch (error) {
	          internalReject(wrapper, error, state);
	        }
	      });
	    } else {
	      state.value = value;
	      state.state = FULFILLED;
	      notify$1(state, false);
	    }
	  } catch (error) {
	    internalReject({
	      done: false
	    }, error, state);
	  }
	}; // constructor polyfill


	if (FORCED$2) {
	  // 25.4.3.1 Promise(executor)
	  PromiseConstructor = function Promise(executor) {
	    anInstance(this, PromisePrototype);
	    aCallable(executor);
	    functionCall(Internal, this);
	    var state = getInternalState$3(this);

	    try {
	      executor(bind$3(internalResolve, state), bind$3(internalReject, state));
	    } catch (error) {
	      internalReject(state, error);
	    }
	  };

	  PromisePrototype = PromiseConstructor.prototype; // eslint-disable-next-line no-unused-vars -- required for `.length`

	  Internal = function Promise(executor) {
	    setInternalState$3(this, {
	      type: PROMISE,
	      done: false,
	      notified: false,
	      parent: false,
	      reactions: [],
	      rejection: false,
	      state: PENDING,
	      value: undefined
	    });
	  };

	  Internal.prototype = redefineAll(PromisePrototype, {
	    // `Promise.prototype.then` method
	    // https://tc39.es/ecma262/#sec-promise.prototype.then
	    then: function then(onFulfilled, onRejected) {
	      var state = getInternalPromiseState(this);
	      var reactions = state.reactions;
	      var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
	      reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
	      reaction.fail = isCallable(onRejected) && onRejected;
	      reaction.domain = engineIsNode ? process$3.domain : undefined;
	      state.parent = true;
	      reactions[reactions.length] = reaction;
	      if (state.state != PENDING) notify$1(state, false);
	      return reaction.promise;
	    },
	    // `Promise.prototype.catch` method
	    // https://tc39.es/ecma262/#sec-promise.prototype.catch
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });

	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    var state = getInternalState$3(promise);
	    this.promise = promise;
	    this.resolve = bind$3(internalResolve, state);
	    this.reject = bind$3(internalReject, state);
	  };

	  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
	    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
	  };
	}

	_export({
	  global: true,
	  wrap: true,
	  forced: FORCED$2
	}, {
	  Promise: PromiseConstructor
	});
	setToStringTag(PromiseConstructor, PROMISE, false, true);
	setSpecies(PROMISE);
	PromiseWrapper = getBuiltIn(PROMISE); // statics

	_export({
	  target: PROMISE,
	  stat: true,
	  forced: FORCED$2
	}, {
	  // `Promise.reject` method
	  // https://tc39.es/ecma262/#sec-promise.reject
	  reject: function reject(r) {
	    var capability = newPromiseCapability$1(this);
	    functionCall(capability.reject, undefined, r);
	    return capability.promise;
	  }
	});
	_export({
	  target: PROMISE,
	  stat: true,
	  forced: isPure 
	}, {
	  // `Promise.resolve` method
	  // https://tc39.es/ecma262/#sec-promise.resolve
	  resolve: function resolve(x) {
	    return promiseResolve( this === PromiseWrapper ? PromiseConstructor : this, x);
	  }
	});
	_export({
	  target: PROMISE,
	  stat: true,
	  forced: INCORRECT_ITERATION
	}, {
	  // `Promise.all` method
	  // https://tc39.es/ecma262/#sec-promise.all
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability$1(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aCallable(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        functionCall($promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  },
	  // `Promise.race` method
	  // https://tc39.es/ecma262/#sec-promise.race
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability$1(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aCallable(C.resolve);
	      iterate(iterable, function (promise) {
	        functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});

	// `Promise.allSettled` method
	// https://tc39.es/ecma262/#sec-promise.allsettled


	_export({
	  target: 'Promise',
	  stat: true
	}, {
	  allSettled: function allSettled(iterable) {
	    var C = this;
	    var capability = newPromiseCapability.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aCallable(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        functionCall(promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = {
	            status: 'fulfilled',
	            value: value
	          };
	          --remaining || resolve(values);
	        }, function (error) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = {
	            status: 'rejected',
	            reason: error
	          };
	          --remaining || resolve(values);
	        });
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});

	var PROMISE_ANY_ERROR = 'No one promise resolved'; // `Promise.any` method
	// https://tc39.es/ecma262/#sec-promise.any

	_export({
	  target: 'Promise',
	  stat: true
	}, {
	  any: function any(iterable) {
	    var C = this;
	    var AggregateError = getBuiltIn('AggregateError');
	    var capability = newPromiseCapability.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aCallable(C.resolve);
	      var errors = [];
	      var counter = 0;
	      var remaining = 1;
	      var alreadyResolved = false;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyRejected = false;
	        remaining++;
	        functionCall(promiseResolve, C, promise).then(function (value) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyResolved = true;
	          resolve(value);
	        }, function (error) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyRejected = true;
	          errors[index] = error;
	          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	        });
	      });
	      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});

	// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829


	var NON_GENERIC = !!nativePromiseConstructor && fails(function () {
	  nativePromiseConstructor.prototype['finally'].call({
	    then: function () {
	      /* empty */
	    }
	  }, function () {
	    /* empty */
	  });
	}); // `Promise.prototype.finally` method
	// https://tc39.es/ecma262/#sec-promise.prototype.finally

	_export({
	  target: 'Promise',
	  proto: true,
	  real: true,
	  forced: NON_GENERIC
	}, {
	  'finally': function (onFinally) {
	    var C = speciesConstructor$1(this, getBuiltIn('Promise'));
	    var isFunction = isCallable(onFinally);
	    return this.then(isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () {
	        return x;
	      });
	    } : onFinally, isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () {
	        throw e;
	      });
	    } : onFinally);
	  }
	}); // makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`

	var charAt$1 = functionUncurryThis(''.charAt);
	var charCodeAt = functionUncurryThis(''.charCodeAt);
	var stringSlice$1 = functionUncurryThis(''.slice);

	var createMethod$5 = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString$2(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$1(S, position) : first : CONVERT_TO_STRING ? stringSlice$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	var stringMultibyte$1 = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod$5(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod$5(true)
	};

	var charAt$2 = stringMultibyte$1.charAt;







	var STRING_ITERATOR = 'String Iterator';
	var setInternalState$4 = internalState.set;
	var getInternalState$4 = internalState.getterFor(STRING_ITERATOR); // `String.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-string.prototype-@@iterator

	defineIterator(String, 'String', function (iterated) {
	  setInternalState$4(this, {
	    type: STRING_ITERATOR,
	    string: toString$2(iterated),
	    index: 0
	  }); // `%StringIteratorPrototype%.next` method
	  // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState$4(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return {
	    value: undefined,
	    done: true
	  };
	  point = charAt$2(string, index);
	  state.index += point.length;
	  return {
	    value: point,
	    done: false
	  };
	});

	var promise$1 = path.Promise;

	var promise$2 = promise$1;

	// `Promise.try` method
	// https://github.com/tc39/proposal-promise-try


	_export({
	  target: 'Promise',
	  stat: true
	}, {
	  'try': function (callbackfn) {
	    var promiseCapability = newPromiseCapability.f(this);
	    var result = perform(callbackfn);
	    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
	    return promiseCapability.promise;
	  }
	});

	// TODO: Remove from `core-js@4`








	var promise$3 = promise$2;

	var promise$4 = promise$3;

	function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
	  try {
	    var info = gen[key](arg);
	    var value = info.value;
	  } catch (error) {
	    reject(error);
	    return;
	  }

	  if (info.done) {
	    resolve(value);
	  } else {
	    promise$4.resolve(value).then(_next, _throw);
	  }
	}

	function _asyncToGenerator$1(fn) {
	  return function () {
	    var self = this,
	        args = arguments;
	    return new promise$4(function (resolve, reject) {
	      var gen = fn.apply(self, args);

	      function _next(value) {
	        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
	      }

	      function _throw(err) {
	        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
	      }

	      _next(undefined);
	    });
	  };
	}

	var asyncToGenerator = _asyncToGenerator$1;

	var handleResponse = /*#__PURE__*/function () {
	  var _ref = asyncToGenerator( /*#__PURE__*/regenerator$1.mark(function _callee(givenPromise, onSuccess, onError) {
	    var value;
	    return regenerator$1.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.prev = 0;
	            _context.next = 3;
	            return givenPromise;

	          case 3:
	            value = _context.sent;
	            onSuccess(value);
	            _context.next = 10;
	            break;

	          case 7:
	            _context.prev = 7;
	            _context.t0 = _context["catch"](0);
	            onError(_context.t0);

	          case 10:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, null, [[0, 7]]);
	  }));

	  return function handleResponse(_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  };
	}();

	var TypeError$h = global$1.TypeError; // `Array.prototype.{ reduce, reduceRight }` methods implementation

	var createMethod$6 = function (IS_RIGHT) {
	  return function (that, callbackfn, argumentsLength, memo) {
	    aCallable(callbackfn);
	    var O = toObject(that);
	    var self = indexedObject(O);
	    var length = lengthOfArrayLike(O);
	    var index = IS_RIGHT ? length - 1 : 0;
	    var i = IS_RIGHT ? -1 : 1;
	    if (argumentsLength < 2) while (true) {
	      if (index in self) {
	        memo = self[index];
	        index += i;
	        break;
	      }

	      index += i;

	      if (IS_RIGHT ? index < 0 : length <= index) {
	        throw TypeError$h('Reduce of empty array with no initial value');
	      }
	    }

	    for (; IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
	      memo = callbackfn(memo, self[index], index, O);
	    }

	    return memo;
	  };
	};

	var arrayReduce$1 = {
	  // `Array.prototype.reduce` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduce
	  left: createMethod$6(false),
	  // `Array.prototype.reduceRight` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
	  right: createMethod$6(true)
	};

	var $reduce = arrayReduce$1.left;







	var STRICT_METHOD$3 = arrayMethodIsStrict('reduce'); // Chrome 80-82 has a critical bug
	// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

	var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83; // `Array.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-array.prototype.reduce

	_export({
	  target: 'Array',
	  proto: true,
	  forced: !STRICT_METHOD$3 || CHROME_BUG
	}, {
	  reduce: function reduce(callbackfn
	  /* , initialValue */
	  ) {
	    var length = arguments.length;
	    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
	  }
	});

	var reduce$2 = entryVirtual('Array').reduce;

	var ArrayPrototype$b = Array.prototype;

	var reduce$3 = function (it) {
	  var own = it.reduce;
	  return it === ArrayPrototype$b || objectIsPrototypeOf(ArrayPrototype$b, it) && own === ArrayPrototype$b.reduce ? reduce$2 : own;
	};

	var reduce$4 = reduce$3;

	var reduce$5 = reduce$4;

	function ownKeys$c(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; forEach$3(_context3 = ownKeys$c(Object(source), true)).call(_context3, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context4; forEach$3(_context4 = ownKeys$c(Object(source))).call(_context4, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }

	var replaceItem = function replaceItem(list, identifier, idValue, newValue) {
	  var _context2;

	  var index = findIndex$3(list).call(list, function (item) {
	    return item[identifier] === idValue;
	  });

	  if (index === -1) {
	    var _context, _objectSpread2;

	    return concat$5(_context = []).call(_context, list, [_objectSpread$8(_objectSpread$8({}, (_objectSpread2 = {}, _objectSpread2[identifier] = idValue, _objectSpread2)), newValue)]);
	  }

	  return concat$5(_context2 = []).call(_context2, slice$3(list).call(list, 0, index), [_objectSpread$8(_objectSpread$8({}, list[index]), newValue)], slice$3(list).call(list, index + 1, list.length));
	};

	var status = {
	  FILE_SELECTED: 'FILE_SELECTED',
	  UPLOADING: 'UPLOADING',
	  UPLOADED: 'UPLOADED',
	  NOTUPLOADED: 'NOTUPLOADED',
	  DELETE_CLICKED: 'DELETE_CLICKED',
	  DELETING: 'DELETING',
	  NOTDELETED: 'NOTDELETED',
	  REMOVE: 'REMOVE'
	};

	var uploading = function uploading(state, value) {
	  var queueId = value.queueId,
	      name = value.name;
	  return replaceItem(state, 'queueId', queueId, {
	    queueId: queueId,
	    loading: true,
	    name: name,
	    message: '',
	    canRemove: false
	  });
	};

	var uploaded = function uploaded(state, value) {
	  var queueId = value.queueId,
	      id = value.id,
	      url = value.url;
	  return replaceItem(state, 'queueId', queueId, {
	    url: url,
	    id: id,
	    loading: false,
	    canRemove: false
	  });
	};

	var notUploaded = function notUploaded(state, value) {
	  var queueId = value.queueId,
	      message = value.message;
	  return replaceItem(state, 'queueId', queueId, {
	    loading: false,
	    message: message,
	    canRemove: true
	  });
	};

	var deleting = function deleting(state, value) {
	  var queueId = value.queueId;
	  return replaceItem(state, 'queueId', queueId, {
	    loading: true,
	    canRemove: false
	  });
	};

	var notDeleted = function notDeleted(state, value) {
	  var queueId = value.queueId,
	      message = value.message;
	  return replaceItem(state, 'queueId', queueId, {
	    loading: false,
	    canRemove: false,
	    message: message
	  });
	};

	var remove = function remove(state, value) {
	  var queueId = value.queueId;
	  return reduce$5(state).call(state, function (list, item) {
	    var _context;

	    return item.queueId === queueId ? list : concat$5(_context = []).call(_context, list, [item]);
	  }, []);
	};

	var reducer = function reducer(state, action) {
	  var type = action.type,
	      value = action.value;

	  switch (type) {
	    case status.UPLOADING:
	      return uploading(state, value);

	    case status.UPLOADED:
	      return uploaded(state, value);

	    case status.NOTUPLOADED:
	      return notUploaded(state, value);

	    case status.DELETING:
	      return deleting(state, value);

	    case status.NOTDELETED:
	      return notDeleted(state, value);

	    case status.REMOVE:
	      return remove(state, value);

	    default:
	      throw new Error(type + ' has no reducer');
	  }
	};

	var uploadingAction = function uploadingAction(dispatch) {
	  return function (queueId, _ref) {
	    var name = _ref.name;
	    return dispatch({
	      type: status.UPLOADING,
	      value: {
	        queueId: queueId,
	        name: name
	      }
	    });
	  };
	};
	var uploadedAction = function uploadedAction(dispatch) {
	  return function (queueId, _ref2) {
	    var id = _ref2.id,
	        url = _ref2.url;
	    return dispatch({
	      type: status.UPLOADED,
	      value: {
	        queueId: queueId,
	        url: url,
	        id: id
	      }
	    });
	  };
	};
	var notUploadedAction = function notUploadedAction(dispatch) {
	  return function (queueId, _ref3) {
	    var message = _ref3.message;
	    return dispatch({
	      type: status.NOTUPLOADED,
	      value: {
	        queueId: queueId,
	        message: message
	      }
	    });
	  };
	};
	var removeItemAction = function removeItemAction(dispatch) {
	  return function (queueId) {
	    return dispatch({
	      type: status.REMOVE,
	      value: {
	        queueId: queueId
	      }
	    });
	  };
	};
	var deletingAction = function deletingAction(dispatch) {
	  return function (queueId) {
	    return dispatch({
	      type: status.DELETING,
	      value: {
	        queueId: queueId
	      }
	    });
	  };
	};
	var notDeletedAction = function notDeletedAction(dispatch) {
	  return function (queueId, _ref4) {
	    var message = _ref4.message;
	    return dispatch({
	      type: status.NOTDELETED,
	      value: {
	        queueId: queueId,
	        message: message
	      }
	    });
	  };
	};

	var TO_STRING_TAG$6 = wellKnownSymbol$1('toStringTag');
	var test$2 = {};

	test$2[TO_STRING_TAG$6] = 'z';

	var toStringTagSupport$1 = String(test$2) === '[object z]';

	var TO_STRING_TAG$7 = wellKnownSymbol$1('toStringTag');
	// ES3 wrong here
	var CORRECT_ARGUMENTS$1 = classofRaw$1(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet$1 = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};

	// getting tag from ES6+ `Object.prototype.toString`
	var classof$1 = toStringTagSupport$1 ? classofRaw$1 : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet$1(O = Object(it), TO_STRING_TAG$7)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS$1 ? classofRaw$1(O)
	    // ES3 arguments fallback
	    : (result = classofRaw$1(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
	};

	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	var objectToString$3 = toStringTagSupport$1 ? {}.toString : function toString() {
	  return '[object ' + classof$1(this) + ']';
	};

	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	if (!toStringTagSupport$1) {
	  redefine$1(Object.prototype, 'toString', objectToString$3, { unsafe: true });
	}

	var TO_STRING = 'toString';
	var RegExpPrototype = RegExp.prototype;
	var nativeToString = RegExpPrototype[TO_STRING];

	var NOT_GENERIC = fails$1(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
	// FF44- RegExp#toString has a wrong name
	var INCORRECT_NAME = nativeToString.name != TO_STRING;

	// `RegExp.prototype.toString` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
	if (NOT_GENERIC || INCORRECT_NAME) {
	  redefine$1(RegExp.prototype, TO_STRING, function toString() {
	    var R = anObject$1(this);
	    var p = String(R.source);
	    var rf = R.flags;
	    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? regexpFlags.call(R) : rf);
	    return '/' + p + '/' + f;
	  }, { unsafe: true });
	}

	var Date$1 = global$1.Date;
	var getTime = functionUncurryThis(Date$1.prototype.getTime); // `Date.now` method
	// https://tc39.es/ecma262/#sec-date.now

	_export({
	  target: 'Date',
	  stat: true
	}, {
	  now: function now() {
	    return getTime(new Date$1());
	  }
	});

	var now = path.Date.now;

	var now$1 = now;

	var now$2 = now$1;

	var createId = function createId() {
	  var _context;

	  return slice$3(_context = (now$2() + Math.random()).toString(36)).call(_context, 2);
	};

	var dispatchMiddleware = function dispatchMiddleware(createFile, deleteFile, dispatch) {
	  var uploading = uploadingAction(dispatch);
	  var uploaded = uploadedAction(dispatch);
	  var notUploaded = notUploadedAction(dispatch);
	  var deleting = deletingAction(dispatch);
	  var notDeleted = notDeletedAction(dispatch);
	  var removeItem = removeItemAction(dispatch);
	  var queueId = createId();
	  return function (action) {
	    var type = action.type,
	        value = action.value;

	    switch (type) {
	      case status.FILE_SELECTED:
	        handleResponse(createFile(value), function (data) {
	          return uploaded(queueId, data);
	        }, function (error) {
	          return notUploaded(queueId, error);
	        });
	        return uploading(queueId, value);

	      case status.DELETE_CLICKED:
	        handleResponse(deleteFile(value.fileId), function () {
	          return removeItem(value.queueId);
	        }, function (error) {
	          return notDeleted(value.queueId, error);
	        });
	        return deleting(value.queueId);

	      default:
	        return dispatch(action);
	    }
	  };
	};

	var useQueue = function useQueue(initialFileQueue, createFile, deleteFile, middleware) {
	  var _useReducer = React.useReducer(reducer, initialFileQueue),
	      fileQueue = _useReducer[0],
	      reducerDispatch = _useReducer[1];

	  var dispatch = middleware(createFile, deleteFile, reducerDispatch);
	  var removeItem = removeItemAction(dispatch);

	  var onChange = function onChange(event, files) {
	    forEach$3(files).call(files, function (file) {
	      dispatch({
	        type: status.FILE_SELECTED,
	        value: file
	      });
	    });
	  };

	  var deleteRemoteFile = function deleteRemoteFile(queueId, fileId) {
	    return dispatch({
	      type: status.DELETE_CLICKED,
	      value: {
	        fileId: fileId,
	        queueId: queueId
	      }
	    });
	  };

	  return {
	    fileQueue: fileQueue,
	    onChange: onChange,
	    deleteRemoteFile: deleteRemoteFile,
	    removeItem: removeItem
	  };
	};

	function ownKeys$d(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$d(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$d(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }
	var queueToFiles = function queueToFiles(fileQueue, removeItem, deleteRemoteFile) {
	  return map$3(fileQueue).call(fileQueue, function (file) {
	    return _objectSpread$9(_objectSpread$9({}, file), {}, {
	      name: file.name,
	      url: file.url,
	      onDelete: file.canRemove ? function () {
	        return removeItem(file.queueId);
	      } : function () {
	        return deleteRemoteFile(file.queueId, file.id);
	      }
	    });
	  });
	};

	var FileUploaderContainer = function FileUploaderContainer(_ref) {
	  var buttonText = _ref.buttonText,
	      createFile = _ref.createFile,
	      deleteFile = _ref.deleteFile,
	      validTypes = _ref.validTypes,
	      maximumAmountOfFiles = _ref.maximumAmountOfFiles,
	      onFileQueueChange = _ref.onFileQueueChange,
	      _ref$initialFileQueue = _ref.initialFileQueue,
	      initialFileQueue = _ref$initialFileQueue === void 0 ? [] : _ref$initialFileQueue;

	  var _useQueue = useQueue(initialFileQueue, createFile, deleteFile, dispatchMiddleware),
	      fileQueue = _useQueue.fileQueue,
	      onChange = _useQueue.onChange,
	      deleteRemoteFile = _useQueue.deleteRemoteFile,
	      removeItem = _useQueue.removeItem;

	  React.useEffect(function () {
	    onFileQueueChange(fileQueue);
	  }, [fileQueue]);
	  var files = queueToFiles(fileQueue, removeItem, deleteRemoteFile);
	  return /*#__PURE__*/React__default['default'].createElement(FileUploader, {
	    buttonText: buttonText,
	    onChange: onChange,
	    validTypes: validTypes,
	    maximumAmountOfFiles: maximumAmountOfFiles,
	    files: files
	  });
	};

	var styles$B = {"filterChip":"telia-react-filterChip","filterChip__disabled":"telia-react-filterChip__disabled","filterChip__icon":"telia-react-filterChip__icon"};

	var _excluded$D = ["text", "disabled", "onClick"];

	var FilterChip = function FilterChip(_ref) {
	  var text = _ref.text,
	      disabled = _ref.disabled,
	      onClick = _ref.onClick,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$D);

	  var classNames = [styles$B.filterChip];
	  disabled && classNames.push(styles$B.filterChip__disabled);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "button",
	    color: "gray400",
	    hoverColor: "gray500",
	    boxShadow: "sm",
	    onClick: onClick,
	    borderRadius: {
	      size: 'sm'
	    },
	    className: ['filterChip-test', classNames],
	    padding: {
	      vertical: 'xs',
	      horizontal: 'sm'
	    },
	    backgroundColor: disabled ? 'gray200' : 'white'
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centered: true
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "close",
	    size: "xs",
	    className: styles$B.filterChip__icon
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'xs'
	  }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: 'sm'
	  }, text)));
	};

	var styles$C = {"footer__links":"telia-react-footer__links","footer__link":"telia-react-footer__link","footer__copyright":"telia-react-footer__copyright","footer__bottom":"telia-react-footer__bottom"};

	var styles$D = {"marginSpace":"telia-react-marginSpace","marginSpace__narrow":"telia-react-marginSpace__narrow","marginSpace__noPaddingForSmallerThanSm":"telia-react-marginSpace__noPaddingForSmallerThanSm","marginSpace_panel":"telia-react-marginSpace_panel","marginSpace_panel_footer":"telia-react-marginSpace_panel_footer","marginSpace__noPaddingForSmallerThanMd":"telia-react-marginSpace__noPaddingForSmallerThanMd","marginSpace_panel__separateWithBorder":"telia-react-marginSpace_panel__separateWithBorder"};

	var _excluded$E = ["padding", "narrow", "noPaddingForSmallerThanMd", "noPaddingForSmallerThanSm", "className", "children", "tagName"];

	function ownKeys$e(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$e(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$e(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }

	var MarginSpace = function MarginSpace(_ref) {
	  var _ref2;

	  var _ref$padding = _ref.padding,
	      padding = _ref$padding === void 0 ? {} : _ref$padding,
	      narrow = _ref.narrow,
	      noPaddingForSmallerThanMd = _ref.noPaddingForSmallerThanMd,
	      noPaddingForSmallerThanSm = _ref.noPaddingForSmallerThanSm,
	      className = _ref.className,
	      children = _ref.children,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$E);

	  var classNames = [styles$D.marginSpace, (_ref2 = {}, _ref2[styles$D.marginSpace__narrow] = narrow, _ref2[styles$D.marginSpace__noPaddingForSmallerThanMd] = noPaddingForSmallerThanMd, _ref2[styles$D.marginSpace__noPaddingForSmallerThanSm] = noPaddingForSmallerThanSm, _ref2), className];

	  var paddingWithHorizontalDefault = _objectSpread$a({
	    horizontal: 'md'
	  }, padding);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    padding: paddingWithHorizontalDefault,
	    className: classNames,
	    tagName: tagName
	  }, props), children);
	};

	var _excluded$F = ["links", "bottomText", "className", "copyrightYear"],
	    _excluded2$1 = ["title", "onClick", "to", "openInNewWindow"];

	var Footer = function Footer(_ref) {
	  var links = _ref.links,
	      bottomText = _ref.bottomText,
	      className = _ref.className,
	      _ref$copyrightYear = _ref.copyrightYear,
	      copyrightYear = _ref$copyrightYear === void 0 ? new Date().getFullYear() : _ref$copyrightYear,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$F);

	  var resolvePadding = links ? {
	    top: 'xlg',
	    bottom: 'lg'
	  } : {
	    bottom: 'md'
	  };
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    padding: resolvePadding,
	    className: className,
	    tagName: "footer",
	    backgroundColor: "purple700"
	  }, props), /*#__PURE__*/React__default['default'].createElement(MarginSpace, null, links && /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredHorizontally: true,
	    wrapContent: true,
	    className: styles$C.footer__links
	  }, map$3(links).call(links, function (_ref2, key) {
	    var title = _ref2.title,
	        onClick = _ref2.onClick,
	        to = _ref2.to,
	        openInNewWindow = _ref2.openInNewWindow,
	        linkProps = objectWithoutPropertiesLoose(_ref2, _excluded2$1);

	    return /*#__PURE__*/React__default['default'].createElement(Link, _extends_1({
	      key: key,
	      onClick: onClick,
	      to: to,
	      openInNewWindow: openInNewWindow
	    }, linkProps), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	      block: true,
	      tagName: "p",
	      color: "white",
	      className: styles$C.footer__link,
	      padding: {
	        horizontal: 'lg'
	      }
	    }, title));
	  })), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredHorizontally: true,
	    padding: {
	      vertical: 'md'
	    },
	    className: styles$C.footer__bottom
	  }, bottomText && /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, bottomText), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    className: styles$C.footer__copyright
	  }, "\xA9 Telia Company ", copyrightYear))));
	};

	var styles$E = {"growlNotification":"telia-react-growlNotification","growlNotification_close":"telia-react-growlNotification_close","growlNotification_readMore":"telia-react-growlNotification_readMore","growlNotification_readMore_hover":"telia-react-growlNotification_readMore_hover","growlNotification_relative":"telia-react-growlNotification_relative","growlNotification_fixed":"telia-react-growlNotification_fixed","growlNotification_wrapper":"telia-react-growlNotification_wrapper","growlNotification_notification":"telia-react-growlNotification_notification"};

	var _excluded$G = ["notification", "variant", "icon", "background", "verticalPadding", "position", "closeOnClick", "wrapper", "ctaText", "ctaOnClick", "ctaTo", "wrapperProps"];

	var GrowlNotification = function GrowlNotification(_ref) {
	  var notification = _ref.notification,
	      _ref$variant = _ref.variant,
	      variant = _ref$variant === void 0 ? 'success' : _ref$variant,
	      icon = _ref.icon,
	      background = _ref.background,
	      verticalPadding = _ref.verticalPadding,
	      _ref$position = _ref.position,
	      position = _ref$position === void 0 ? 'fixed' : _ref$position,
	      closeOnClick = _ref.closeOnClick,
	      _ref$wrapper = _ref.wrapper,
	      Wrapper = _ref$wrapper === void 0 ? Link : _ref$wrapper,
	      ctaText = _ref.ctaText,
	      ctaOnClick = _ref.ctaOnClick,
	      ctaTo = _ref.ctaTo,
	      _ref$wrapperProps = _ref.wrapperProps,
	      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$G);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    backgroundColor: background ? background : mapVariant[variant].background,
	    className: "growl-notification-test " + styles$E.growlNotification + " " + (position && styles$E.growlNotification) + "_" + (position && position),
	    shown: !!notification
	  }, props), /*#__PURE__*/React__default['default'].createElement(MarginSpace, {
	    padding: {
	      vertical: verticalPadding ? verticalPadding : 'xs'
	    },
	    noPaddingForSmallerThanMd: true
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    spaceBetween: true,
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    flexItem: true,
	    occupyVerticalSpace: true,
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'sm',
	    responsiveHidden: {
	      widerThan: 'sm'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: icon ? icon : mapVariant[variant].icon,
	    size: "md",
	    color: mapVariant[variant].contentColor,
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    flexItem: true,
	    color: mapVariant[variant].contentColor,
	    size: "sm",
	    fontWeight: "medium",
	    className: styles$E.growlNotification_notification,
	    style: {
	      WebkitBoxOrient: 'vertical'
	    }
	  }, notification), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'sm',
	    responsiveHidden: {
	      widerThan: 'xs'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'md',
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  })), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, ctaText && /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends_1({
	    "data-testid": "wrapper",
	    to: ctaTo,
	    onClick: ctaOnClick,
	    className: wrapperProps && wrapperProps.className ? wrapperProps.className : [styles$E.growlNotification_wrapper, styles$E.growlNotification_readMore_hover]
	  }, wrapperProps), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    color: mapVariant[variant].contentColor,
	    size: "sm",
	    fontWeight: "medium",
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }, ctaText), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    responsiveHidden: {
	      widerThan: 'xs'
	    },
	    size: 'md',
	    className: styles$E.growlNotification_readMore,
	    name: "more-horizontal",
	    color: mapVariant[variant].contentColor
	  })), closeOnClick && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'sm',
	    responsiveHidden: {
	      widerThan: 'xs'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'md',
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "close",
	    size: 'md',
	    tabIndex: 0,
	    clickableAppearance: true,
	    className: styles$E.growlNotification_close,
	    color: mapVariant[variant].contentColor,
	    onClick: closeOnClick
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'sm',
	    responsiveHidden: {
	      widerThan: 'md'
	    }
	  })))));
	};

	var growlVariants = ['warning', 'error', 'success', 'info', 'other', 'secondary'];
	var growlPositions = ['relative', 'fixed'];
	var mapVariant = {
	  warning: {
	    background: 'orange400',
	    icon: 'alert-filled',
	    contentColor: 'orange800'
	  },
	  error: {
	    background: 'red600',
	    icon: 'error-filled',
	    contentColor: 'white'
	  },
	  success: {
	    background: 'green700',
	    icon: 'check-circle-filled',
	    contentColor: 'white'
	  },
	  info: {
	    background: 'blue600',
	    icon: 'info-filled',
	    contentColor: 'white'
	  },
	  other: {
	    background: 'purple500',
	    icon: 'star-filled',
	    contentColor: 'white'
	  },
	  secondary: {
	    background: 'gray800',
	    icon: 'error-filled',
	    contentColor: 'white'
	  }
	};

	var keys$b = entryVirtual('Array').keys;

	var keys$c = keys$b;

	var ArrayPrototype$c = Array.prototype;
	var DOMIterables$1 = {
	  DOMTokenList: true,
	  NodeList: true
	};

	var keys$d = function (it) {
	  var own = it.keys;
	  return it === ArrayPrototype$c || objectIsPrototypeOf(ArrayPrototype$c, it) && own === ArrayPrototype$c.keys || hasOwnProperty_1(DOMIterables$1, classof(it)) ? keys$c : own;
	};

	var keys$e = keys$d;

	var styles$F = {"gridBag_contents":"telia-react-gridBag_contents","gridBag_item":"telia-react-gridBag_item","noHorizontalGutter":"telia-react-noHorizontalGutter","noVerticalGutter":"telia-react-noVerticalGutter","gridBagRuler_container":"telia-react-gridBagRuler_container","gridBagRuler_table":"telia-react-gridBagRuler_table","gridBagRuler_noGutter":"telia-react-gridBagRuler_noGutter","gridBagRuler_cell":"telia-react-gridBagRuler_cell","gridLines_container":"telia-react-gridLines_container","gridLines_innerContainerLeft":"telia-react-gridLines_innerContainerLeft","gridLines_innerContainerRight":"telia-react-gridLines_innerContainerRight","gridLines_gridLine":"telia-react-gridLines_gridLine"};

	var _excluded$H = ["showGridLines", "noGutter"];

	var GridBagRulerGridLines = function GridBagRulerGridLines() {
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$F.gridLines_container
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$F.gridLines_innerContainerLeft
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$F.gridLines_gridLine
	  })), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$F.gridLines_innerContainerRight
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$F.gridLines_gridLine
	  })));
	};

	var GridBagRuler = function GridBagRuler(_ref) {
	  var _cn, _cn2, _context, _context2, _context3;

	  var showGridLines = _ref.showGridLines,
	      noGutter = _ref.noGutter,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$H);

	  var containerClasses = classnames(styles$F.gridBagRuler_container, (_cn = {}, _cn[styles$F.gridBagRuler_noGutter] = noGutter, _cn));
	  var tableClasses = classnames(styles$F.gridBagRuler_table, (_cn2 = {}, _cn2[styles$F.gridBagRuler_noGutter] = noGutter, _cn2));
	  return /*#__PURE__*/React__default['default'].createElement("div", _extends_1({
	    className: containerClasses
	  }, props), /*#__PURE__*/React__default['default'].createElement("table", {
	    className: tableClasses
	  }, /*#__PURE__*/React__default['default'].createElement("tbody", {
	    style: {
	      position: 'relative'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement("tr", null, map$3(_context = concat$5(_context2 = []).call(_context2, keys$e(_context3 = Array(12)).call(_context3))).call(_context, function (column) {
	    return /*#__PURE__*/React__default['default'].createElement("td", {
	      key: column,
	      className: styles$F.gridBagRuler_cell,
	      style: {
	        position: 'relative'
	      }
	    }, column + 1, showGridLines && /*#__PURE__*/React__default['default'].createElement(GridBagRulerGridLines, null));
	  })))));
	};

	var supportedBreakpoints = ['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xlg', 'xxlg'];

	function columnDefinitionAtBreakpoints(columnsAtBreakpoints) {
	  var columns = [];

	  var firstDefinedBreakpointName = find$3(supportedBreakpoints).call(supportedBreakpoints, function (breakpoint) {
	    return columnsAtBreakpoints[breakpoint] !== undefined && columnsAtBreakpoints[breakpoint] !== null;
	  });

	  if (!firstDefinedBreakpointName) {
	    return map$3(supportedBreakpoints).call(supportedBreakpoints, function () {
	      return 1;
	    });
	  }

	  var firstColumnCount = columnsAtBreakpoints[firstDefinedBreakpointName];
	  var previousColumnCount = null;

	  for (var i = 0; i < supportedBreakpoints.length; i++) {
	    var columnCountDefined = columnsAtBreakpoints[supportedBreakpoints[i]] !== undefined && columnsAtBreakpoints[supportedBreakpoints[i]] !== null;
	    var previousCountDefined = previousColumnCount !== undefined && previousColumnCount !== null;

	    if (columnCountDefined) {
	      columns[i] = columnsAtBreakpoints[supportedBreakpoints[i]];
	    } else if (previousCountDefined) {
	      columns[i] = previousColumnCount;
	    } else {
	      columns[i] = firstColumnCount;
	    }

	    previousColumnCount = columns[i];
	  }

	  return columns;
	}

	var _excluded$I = ["xxxs", "xxs", "xs", "sm", "md", "lg", "xlg", "xxlg", "children", "noHorizontalGutter", "noVerticalGutter", "onLastColumn", "onLastRow", "className", "tagName"];

	// Adds column information to the element for different breakpoints
	var breakpointColumnDataAttribute = function breakpointColumnDataAttribute(columnsAtBreakpoints) {
	  var _context;

	  var entries = map$3(_context = columnDefinitionAtBreakpoints(columnsAtBreakpoints)).call(_context, function (columns, index) {
	    return supportedBreakpoints[index] + "-" + columns;
	  });

	  return {
	    'data-col': entries.join(' ')
	  };
	}; // Adds last row data


	var breakPointLastRowDataAttribute = function breakPointLastRowDataAttribute(lastRowAtBreakpoints) {
	  var entries = reduce$5(supportedBreakpoints).call(supportedBreakpoints, function (dataAttribute, breakpoint, index) {
	    var _context2;

	    return lastRowAtBreakpoints && lastRowAtBreakpoints[index] ? concat$5(_context2 = []).call(_context2, dataAttribute, [breakpoint]) : dataAttribute;
	  }, []);

	  return entries.length > 0 ? {
	    'data-last-row': entries.join(' ')
	  } : {};
	}; // Adds last column data


	var breakPointLastColDataAttribute = function breakPointLastColDataAttribute(lastColumnAtBreakpoints) {
	  var entries = reduce$5(supportedBreakpoints).call(supportedBreakpoints, function (dataAttribute, breakpoint, index) {
	    var _context3;

	    return lastColumnAtBreakpoints && lastColumnAtBreakpoints[index] ? concat$5(_context3 = []).call(_context3, dataAttribute, [breakpoint]) : dataAttribute;
	  }, []);

	  return entries.length > 0 ? {
	    'data-last-col': entries.join(' ')
	  } : {};
	};

	var GridBagItem = function GridBagItem(_ref) {
	  var _context4;

	  var xxxs = _ref.xxxs,
	      xxs = _ref.xxs,
	      xs = _ref.xs,
	      sm = _ref.sm,
	      md = _ref.md,
	      lg = _ref.lg,
	      xlg = _ref.xlg,
	      xxlg = _ref.xxlg,
	      children = _ref.children,
	      noHorizontalGutter = _ref.noHorizontalGutter,
	      noVerticalGutter = _ref.noVerticalGutter,
	      onLastColumn = _ref.onLastColumn,
	      onLastRow = _ref.onLastRow,
	      className = _ref.className,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      restProps = objectWithoutPropertiesLoose(_ref, _excluded$I);

	  var breakpointDefinitions = {
	    xxxs: xxxs,
	    xxs: xxs,
	    xs: xs,
	    sm: sm,
	    md: md,
	    lg: lg,
	    xlg: xlg,
	    xxlg: xxlg
	  };
	  var itemClasses = classnames.apply(void 0, concat$5(_context4 = [styles$F.gridBag_item]).call(_context4, noHorizontalGutter ? [styles$F.noHorizontalGutter] : [], noVerticalGutter ? [styles$F.noVerticalGutter] : [], [className]));
	  var columnDataAttribute = breakpointColumnDataAttribute(breakpointDefinitions);
	  var lastRowDataAttribute = breakPointLastRowDataAttribute(onLastRow);
	  var lastColDataAttribute = breakPointLastColDataAttribute(onLastColumn);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    className: itemClasses,
	    tagName: tagName
	  }, columnDataAttribute, lastRowDataAttribute, lastColDataAttribute, restProps), children);
	};

	var columnwiseSum = function columnwiseSum(leftArray, rightArray) {
	  return map$3(leftArray).call(leftArray, function (item, index) {
	    return item + rightArray[index];
	  });
	};

	var wrapColumns = function wrapColumns(columnArray, definitions) {
	  var wraps = map$3(supportedBreakpoints).call(supportedBreakpoints, function () {
	    return 0;
	  });

	  var wrappedArray = map$3(columnArray).call(columnArray, function (item, index) {
	    if (item > 12) {
	      wraps[index]++;
	      return definitions[index];
	    }

	    return item;
	  });

	  return [wrappedArray, wraps];
	};

	var GridBag = function GridBag(_ref) {
	  var _context5;

	  var children = _ref.children,
	      noGutter = _ref.noGutter,
	      noHorizontalGutter = _ref.noHorizontalGutter,
	      noVerticalGutter = _ref.noVerticalGutter;

	  if (noGutter) {
	    noHorizontalGutter = true;
	    noVerticalGutter = true;
	  }

	  var childArray = React__default['default'].Children.toArray(children);

	  var emptyColumns = map$3(supportedBreakpoints).call(supportedBreakpoints, function () {
	    return 0;
	  }); // settingup item's row and column positions


	  var itemSetup = reduce$5(childArray).call(childArray, function (accumulator, child, index) {
	    var _context, _context2, _context3, _context4;

	    var definitions = columnDefinitionAtBreakpoints(child == null ? void 0 : child.props);
	    var previousSetup = index > 0 ? accumulator[index - 1] : {
	      cumulativeColumnCounts: concat$5(_context = []).call(_context, emptyColumns),
	      rowPositions: concat$5(_context2 = []).call(_context2, emptyColumns),
	      columnPositions: concat$5(_context3 = []).call(_context3, emptyColumns)
	    };

	    var _wrapColumns = wrapColumns(columnwiseSum(previousSetup.columnPositions, definitions), definitions),
	        columnPositions = _wrapColumns[0],
	        columnWraps = _wrapColumns[1];

	    var rowPositions = columnwiseSum(previousSetup.rowPositions, columnWraps);
	    return concat$5(_context4 = []).call(_context4, accumulator, [{
	      rowPositions: rowPositions,
	      columnPositions: columnPositions
	    }]);
	  }, []);

	  var lastRows = itemSetup.length ? itemSetup[itemSetup.length - 1].rowPositions : concat$5(_context5 = []).call(_context5, emptyColumns);
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$F.gridBag
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$F.gridBag_contents
	  }, map$3(childArray).call(childArray, function (child, index) {
	    var _context6, _context7;

	    var setup = itemSetup[index];

	    var onLastColumn = map$3(_context6 = setup.columnPositions).call(_context6, function (position) {
	      return position === 12;
	    });

	    var onLastRow = map$3(_context7 = setup.rowPositions).call(_context7, function (position, index) {
	      return position === lastRows[index];
	    });

	    return /*#__PURE__*/React__default['default'].createElement(GridBagItem, _extends_1({
	      key: String(index)
	    }, child == null ? void 0 : child.props, {
	      noHorizontalGutter: noHorizontalGutter,
	      noVerticalGutter: noVerticalGutter,
	      onLastColumn: onLastColumn,
	      onLastRow: onLastRow
	    }));
	  })));
	};

	GridBag.Item = function () {
	  return null;
	};

	GridBag.Ruler = GridBagRuler;

	var styles$G = {"gutterBag":"telia-react-gutterBag","gutterBag_item":"telia-react-gutterBag_item","gutterBag_itemGrow":"telia-react-gutterBag_itemGrow","gutterBag__fullWidth_thinnerThanXxxs":"telia-react-gutterBag__fullWidth_thinnerThanXxxs","gutterBag__fullWidth_widerThanXxxs":"telia-react-gutterBag__fullWidth_widerThanXxxs","gutterBag__fullWidth_atXxxs":"telia-react-gutterBag__fullWidth_atXxxs","gutterBag__fullWidth_thinnerThanXxs":"telia-react-gutterBag__fullWidth_thinnerThanXxs","gutterBag__fullWidth_widerThanXxs":"telia-react-gutterBag__fullWidth_widerThanXxs","gutterBag__fullWidth_atXxs":"telia-react-gutterBag__fullWidth_atXxs","gutterBag__fullWidth_thinnerThanXs":"telia-react-gutterBag__fullWidth_thinnerThanXs","gutterBag__fullWidth_widerThanXs":"telia-react-gutterBag__fullWidth_widerThanXs","gutterBag__fullWidth_atXs":"telia-react-gutterBag__fullWidth_atXs","gutterBag__fullWidth_thinnerThanSm":"telia-react-gutterBag__fullWidth_thinnerThanSm","gutterBag__fullWidth_widerThanSm":"telia-react-gutterBag__fullWidth_widerThanSm","gutterBag__fullWidth_atSm":"telia-react-gutterBag__fullWidth_atSm","gutterBag__fullWidth_thinnerThanMd":"telia-react-gutterBag__fullWidth_thinnerThanMd","gutterBag__fullWidth_widerThanMd":"telia-react-gutterBag__fullWidth_widerThanMd","gutterBag__fullWidth_atMd":"telia-react-gutterBag__fullWidth_atMd","gutterBag__fullWidth_thinnerThanLg":"telia-react-gutterBag__fullWidth_thinnerThanLg","gutterBag__fullWidth_widerThanLg":"telia-react-gutterBag__fullWidth_widerThanLg","gutterBag__fullWidth_atLg":"telia-react-gutterBag__fullWidth_atLg","gutterBag__fullWidth_thinnerThanXlg":"telia-react-gutterBag__fullWidth_thinnerThanXlg","gutterBag__fullWidth_widerThanXlg":"telia-react-gutterBag__fullWidth_widerThanXlg","gutterBag__fullWidth_atXlg":"telia-react-gutterBag__fullWidth_atXlg","gutterBag__fullWidth_thinnerThanXxlg":"telia-react-gutterBag__fullWidth_thinnerThanXxlg","gutterBag__fullWidth_widerThanXxlg":"telia-react-gutterBag__fullWidth_widerThanXxlg","gutterBag__fullWidth_atXxlg":"telia-react-gutterBag__fullWidth_atXxlg","gutterBag__gutterZero":"telia-react-gutterBag__gutterZero","gutterBag__horizontalGutterZero":"telia-react-gutterBag__horizontalGutterZero","gutterBag__verticalGutterZero":"telia-react-gutterBag__verticalGutterZero","gutterBag__gutterXxxs":"telia-react-gutterBag__gutterXxxs","gutterBag__horizontalGutterXxxs":"telia-react-gutterBag__horizontalGutterXxxs","gutterBag__verticalGutterXxxs":"telia-react-gutterBag__verticalGutterXxxs","gutterBag__gutterXxs":"telia-react-gutterBag__gutterXxs","gutterBag__horizontalGutterXxs":"telia-react-gutterBag__horizontalGutterXxs","gutterBag__verticalGutterXxs":"telia-react-gutterBag__verticalGutterXxs","gutterBag__gutterXs":"telia-react-gutterBag__gutterXs","gutterBag__horizontalGutterXs":"telia-react-gutterBag__horizontalGutterXs","gutterBag__verticalGutterXs":"telia-react-gutterBag__verticalGutterXs","gutterBag__gutterSm":"telia-react-gutterBag__gutterSm","gutterBag__horizontalGutterSm":"telia-react-gutterBag__horizontalGutterSm","gutterBag__verticalGutterSm":"telia-react-gutterBag__verticalGutterSm","gutterBag__gutterMd":"telia-react-gutterBag__gutterMd","gutterBag__horizontalGutterMd":"telia-react-gutterBag__horizontalGutterMd","gutterBag__verticalGutterMd":"telia-react-gutterBag__verticalGutterMd","gutterBag__gutterLg":"telia-react-gutterBag__gutterLg","gutterBag__horizontalGutterLg":"telia-react-gutterBag__horizontalGutterLg","gutterBag__verticalGutterLg":"telia-react-gutterBag__verticalGutterLg","gutterBag__gutterXlg":"telia-react-gutterBag__gutterXlg","gutterBag__horizontalGutterXlg":"telia-react-gutterBag__horizontalGutterXlg","gutterBag__verticalGutterXlg":"telia-react-gutterBag__verticalGutterXlg","gutterBag__gutterXxlg":"telia-react-gutterBag__gutterXxlg","gutterBag__horizontalGutterXxlg":"telia-react-gutterBag__horizontalGutterXxlg","gutterBag__verticalGutterXxlg":"telia-react-gutterBag__verticalGutterXxlg","gutterBag__gutterLayout-0":"telia-react-gutterBag__gutterLayout-0","gutterBag__horizontalGutterLayout-0":"telia-react-gutterBag__horizontalGutterLayout-0","gutterBag__verticalGutterLayout-0":"telia-react-gutterBag__verticalGutterLayout-0","gutterBag__gutterLayout-1":"telia-react-gutterBag__gutterLayout-1","gutterBag__horizontalGutterLayout-1":"telia-react-gutterBag__horizontalGutterLayout-1","gutterBag__verticalGutterLayout-1":"telia-react-gutterBag__verticalGutterLayout-1","gutterBag__gutterLayout-2":"telia-react-gutterBag__gutterLayout-2","gutterBag__horizontalGutterLayout-2":"telia-react-gutterBag__horizontalGutterLayout-2","gutterBag__verticalGutterLayout-2":"telia-react-gutterBag__verticalGutterLayout-2","gutterBag__gutterLayout-3":"telia-react-gutterBag__gutterLayout-3","gutterBag__horizontalGutterLayout-3":"telia-react-gutterBag__horizontalGutterLayout-3","gutterBag__verticalGutterLayout-3":"telia-react-gutterBag__verticalGutterLayout-3","gutterBag__gutterLayout-4":"telia-react-gutterBag__gutterLayout-4","gutterBag__horizontalGutterLayout-4":"telia-react-gutterBag__horizontalGutterLayout-4","gutterBag__verticalGutterLayout-4":"telia-react-gutterBag__verticalGutterLayout-4","gutterBag__gutterLayout-5":"telia-react-gutterBag__gutterLayout-5","gutterBag__horizontalGutterLayout-5":"telia-react-gutterBag__horizontalGutterLayout-5","gutterBag__verticalGutterLayout-5":"telia-react-gutterBag__verticalGutterLayout-5","gutterBag__gutterLayout-6":"telia-react-gutterBag__gutterLayout-6","gutterBag__horizontalGutterLayout-6":"telia-react-gutterBag__horizontalGutterLayout-6","gutterBag__verticalGutterLayout-6":"telia-react-gutterBag__verticalGutterLayout-6","gutterBag__gutterLayout-7":"telia-react-gutterBag__gutterLayout-7","gutterBag__horizontalGutterLayout-7":"telia-react-gutterBag__horizontalGutterLayout-7","gutterBag__verticalGutterLayout-7":"telia-react-gutterBag__verticalGutterLayout-7","gutterBag__gutterLayout-8":"telia-react-gutterBag__gutterLayout-8","gutterBag__horizontalGutterLayout-8":"telia-react-gutterBag__horizontalGutterLayout-8","gutterBag__verticalGutterLayout-8":"telia-react-gutterBag__verticalGutterLayout-8","gutterBag__gutterLayout-9":"telia-react-gutterBag__gutterLayout-9","gutterBag__horizontalGutterLayout-9":"telia-react-gutterBag__horizontalGutterLayout-9","gutterBag__verticalGutterLayout-9":"telia-react-gutterBag__verticalGutterLayout-9"};

	var _excluded$J = ["contents", "spacing", "className", "responsiveFullWidth", "showOverflow", "growEqually"];

	var getGutterBagItem = function getGutterBagItem(hideOverflow, growEqually) {
	  return function (content) {
	    var _ref;

	    var classes = [styles$G.gutterBag_item, (_ref = {}, _ref[styles$G.gutterBag_itemGrow] = growEqually, _ref)];
	    return /*#__PURE__*/React__default['default'].createElement(Div, {
	      className: classes,
	      hideOverflow: hideOverflow
	    }, content);
	  };
	};

	var getSpacingClasses = function getSpacingClasses(_ref2) {
	  var size = _ref2.size,
	      horizontal = _ref2.horizontal,
	      vertical = _ref2.vertical;
	  var classes = [];

	  if (horizontal) {
	    classes.push(styles$G["gutterBag__horizontalGutter" + upperFirst$1(horizontal)]);
	  }

	  if (vertical) {
	    classes.push(styles$G["gutterBag__verticalGutter" + upperFirst$1(vertical)]);
	  }

	  if (size) {
	    classes.push(styles$G["gutterBag__gutter" + upperFirst$1(size)]);
	  }

	  return classes;
	};

	var GutterBag = function GutterBag(_ref3) {
	  var _context;

	  var contents = _ref3.contents,
	      spacing = _ref3.spacing,
	      className = _ref3.className,
	      responsiveFullWidth = _ref3.responsiveFullWidth,
	      showOverflow = _ref3.showOverflow,
	      _ref3$growEqually = _ref3.growEqually,
	      growEqually = _ref3$growEqually === void 0 ? false : _ref3$growEqually,
	      props = objectWithoutPropertiesLoose(_ref3, _excluded$J);

	  var classes = [];

	  if (spacing) {
	    classes.push.apply(classes, getSpacingClasses(spacing));
	  }

	  if (responsiveFullWidth) {
	    classes.push.apply(classes, getResponsiveClasses({
	      styles: styles$G,
	      prefix: 'gutterBag__fullWidth_',
	      selector: responsiveFullWidth
	    }));
	  }

	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    hideOverflow: !showOverflow
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, _extends_1({
	    wrapContent: true,
	    className: concat$5(_context = [styles$G.gutterBag, className]).call(_context, classes)
	  }, props), flow$1(map$5(getGutterBagItem(!showOverflow, growEqually)), wrapEachComponentWithKey)(contents)));
	};

	var styles$H = {"heroBanner":"telia-react-heroBanner","heroBanner_contentContainer":"telia-react-heroBanner_contentContainer","heroBanner_contentContainer__noDescriptionText":"telia-react-heroBanner_contentContainer__noDescriptionText","heroBanner_descriptionContainer":"telia-react-heroBanner_descriptionContainer","heroBanner_image":"telia-react-heroBanner_image"};

	var _excluded$K = ["breadcrumb", "heading", "description", "image", "imageAlt", "backgroundImageUrl", "color", "bottomContent", "className", "tagName", "headlineTagName"];

	var HeroBannerLayout = function HeroBannerLayout(_ref) {
	  var breadcrumb = _ref.breadcrumb,
	      heading = _ref.heading,
	      description = _ref.description,
	      image = _ref.image,
	      _ref$imageAlt = _ref.imageAlt,
	      imageAlt = _ref$imageAlt === void 0 ? '' : _ref$imageAlt,
	      backgroundImageUrl = _ref.backgroundImageUrl,
	      color = _ref.color,
	      bottomContent = _ref.bottomContent,
	      className = _ref.className,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      headlineTagName = _ref.headlineTagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$K);

	  var resolveBackgroundImage = backgroundImageUrl ? {
	    backgroundImage: "url(" + backgroundImageUrl + ")"
	  } : undefined;
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    occupyVerticalSpace: true,
	    tagName: tagName,
	    style: resolveBackgroundImage,
	    className: [styles$H.heroBanner, className]
	  }, props), /*#__PURE__*/React__default['default'].createElement(MarginSpace, null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true,
	    padding: {
	      vertical: 'lg'
	    },
	    className: [styles$H.heroBanner_contentContainer, !description && styles$H.heroBanner_contentContainer__noDescriptionText]
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    flexItem: true
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }, breadcrumb), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs",
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }), /*#__PURE__*/React__default['default'].isValidElement(heading) ? heading : /*#__PURE__*/React__default['default'].createElement(Headline, {
	    tagName: headlineTagName,
	    size: "lg",
	    color: color || 'black',
	    margin: {
	      bottom: 'lg'
	    },
	    block: true
	  }, heading), image && /*#__PURE__*/React__default['default'].createElement(Div, {
	    alignTextToCenter: true,
	    responsiveHidden: {
	      widerThan: 'xs'
	    },
	    margin: {
	      bottom: 'xlg'
	    }
	  }, /*#__PURE__*/React__default['default'].isValidElement(image) ? image : /*#__PURE__*/React__default['default'].createElement(BackgroundImage, {
	    inlineBlock: true,
	    scaleWithOriginalAspectRatio: true,
	    className: styles$H.heroBanner_image,
	    src: image,
	    alt: imageAlt
	  })), description && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$H.heroBanner_descriptionContainer
	  }, /*#__PURE__*/React__default['default'].isValidElement(description) ? description : /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    color: color || 'gray500',
	    size: "sm"
	  }, description)), bottomContent && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xlg"
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$H.heroBanner_bottomContent
	  }, /*#__PURE__*/React__default['default'].isValidElement(bottomContent) ? bottomContent : /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    color: color || 'gray500',
	    size: "sm"
	  }, bottomContent)))), image && /*#__PURE__*/React__default['default'].createElement(Div, {
	    flexItem: true,
	    alignTextToCenter: true,
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }, /*#__PURE__*/React__default['default'].isValidElement(image) ? image : /*#__PURE__*/React__default['default'].createElement(BackgroundImage, {
	    scaleWithOriginalAspectRatio: true,
	    inlineBlock: true,
	    className: styles$H.heroBanner_image,
	    src: image,
	    alt: imageAlt
	  })))));
	};

	function _extends$4q() {
	  _extends$4q = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  return _extends$4q.apply(this, arguments);
	}

	function _inheritsLoose$1(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}

	var defaultProps = {
	  preventDefaultTouchmoveEvent: false,
	  delta: 10,
	  rotationAngle: 0,
	  trackMouse: false,
	  trackTouch: true
	};
	var initialState = {
	  xy: [0, 0],
	  swiping: false,
	  eventData: undefined,
	  start: undefined
	};
	var LEFT$1 = 'Left';
	var RIGHT = 'Right';
	var UP = 'Up';
	var DOWN = 'Down';
	var touchStart = 'touchstart';
	var touchMove = 'touchmove';
	var touchEnd = 'touchend';
	var mouseMove = 'mousemove';
	var mouseUp = 'mouseup';

	function getDirection(absX, absY, deltaX, deltaY) {
	  if (absX > absY) {
	    if (deltaX > 0) {
	      return LEFT$1;
	    }

	    return RIGHT;
	  } else if (deltaY > 0) {
	    return UP;
	  }

	  return DOWN;
	}

	function rotateXYByAngle(pos, angle) {
	  if (angle === 0) return pos;
	  var angleInRadians = Math.PI / 180 * angle;
	  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
	  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
	  return [x, y];
	}

	function getHandlers(set, handlerProps) {
	  var onStart = function onStart(event) {
	    // if more than a single touch don't track, for now...
	    if (event.touches && event.touches.length > 1) return;
	    set(function (state, props) {
	      // setup mouse listeners on document to track swipe since swipe can leave container
	      if (props.trackMouse) {
	        document.addEventListener(mouseMove, onMove);
	        document.addEventListener(mouseUp, onUp);
	      }

	      var _ref = event.touches ? event.touches[0] : event,
	          clientX = _ref.clientX,
	          clientY = _ref.clientY;

	      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
	      return _extends$4q({}, state, initialState, {
	        eventData: {
	          initial: [].concat(xy),
	          first: true
	        },
	        xy: xy,
	        start: event.timeStamp || 0
	      });
	    });
	  };

	  var onMove = function onMove(event) {
	    set(function (state, props) {
	      if (!state.xy[0] || !state.xy[1] || event.touches && event.touches.length > 1) {
	        return state;
	      }

	      var _ref2 = event.touches ? event.touches[0] : event,
	          clientX = _ref2.clientX,
	          clientY = _ref2.clientY;

	      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
	          x = _rotateXYByAngle[0],
	          y = _rotateXYByAngle[1];

	      var deltaX = state.xy[0] - x;
	      var deltaY = state.xy[1] - y;
	      var absX = Math.abs(deltaX);
	      var absY = Math.abs(deltaY);
	      var time = (event.timeStamp || 0) - state.start;
	      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1); // if swipe is under delta and we have not started to track a swipe: skip update

	      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
	      var dir = getDirection(absX, absY, deltaX, deltaY);

	      var eventData = _extends$4q({}, state.eventData, {
	        event: event,
	        absX: absX,
	        absY: absY,
	        deltaX: deltaX,
	        deltaY: deltaY,
	        velocity: velocity,
	        dir: dir
	      });

	      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
	      // so we can call preventDefault if needed

	      var cancelablePageSwipe = false;

	      if (props.onSwiping || props.onSwiped || props["onSwiped" + dir]) {
	        cancelablePageSwipe = true;
	      }

	      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault(); // first is now always false

	      return _extends$4q({}, state, {
	        eventData: _extends$4q({}, eventData, {
	          first: false
	        }),
	        swiping: true
	      });
	    });
	  };

	  var onEnd = function onEnd(event) {
	    set(function (state, props) {
	      var eventData;

	      if (state.swiping) {
	        eventData = _extends$4q({}, state.eventData, {
	          event: event
	        });
	        props.onSwiped && props.onSwiped(eventData);
	        props["onSwiped" + eventData.dir] && props["onSwiped" + eventData.dir](eventData);
	      }

	      return _extends$4q({}, state, initialState, {
	        eventData: eventData
	      });
	    });
	  };

	  var cleanUpMouse = function cleanUpMouse() {
	    // safe to just call removeEventListener
	    document.removeEventListener(mouseMove, onMove);
	    document.removeEventListener(mouseUp, onUp);
	  };

	  var onUp = function onUp(e) {
	    cleanUpMouse();
	    onEnd(e);
	  };

	  var attachTouch = function attachTouch(el) {
	    if (el && el.addEventListener) {
	      // attach touch event listeners and handlers
	      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
	      tls.forEach(function (_ref3) {
	        var e = _ref3[0],
	            h = _ref3[1];
	        return el.addEventListener(e, h);
	      }); // return properly scoped cleanup method for removing listeners

	      return function () {
	        return tls.forEach(function (_ref4) {
	          var e = _ref4[0],
	              h = _ref4[1];
	          return el.removeEventListener(e, h);
	        });
	      };
	    }
	  };

	  var onRef = function onRef(el) {
	    // "inline" ref functions are called twice on render, once with null then again with DOM element
	    // ignore null here
	    if (el === null) return;
	    set(function (state, props) {
	      // if the same DOM el as previous just return state
	      if (state.el === el) return state;
	      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

	      if (state.el && state.el !== el && state.cleanUpTouch) {
	        state.cleanUpTouch();
	        addState.cleanUpTouch = null;
	      } // only attach if we want to track touch


	      if (props.trackTouch && el) {
	        addState.cleanUpTouch = attachTouch(el);
	      } // store event attached DOM el for comparison, clean up, and re-attachment


	      return _extends$4q({}, state, {
	        el: el
	      }, addState);
	    });
	  }; // set ref callback to attach touch event listeners


	  var output = {
	    ref: onRef // if track mouse attach mouse down listener

	  };

	  if (handlerProps.trackMouse) {
	    output.onMouseDown = onStart;
	  }

	  return [output, attachTouch];
	}

	function updateTransientState(state, props, attachTouch) {
	  var addState = {}; // clean up touch handlers if no longer tracking touches

	  if (!props.trackTouch && state.cleanUpTouch) {
	    state.cleanUpTouch();
	    addState.cleanUpTouch = null;
	  } else if (props.trackTouch && !state.cleanUpTouch) {
	    // attach/re-attach touch handlers
	    if (state.el) {
	      addState.cleanUpTouch = attachTouch(state.el);
	    }
	  }

	  return _extends$4q({}, state, addState);
	}

	var Swipeable = /*#__PURE__*/function (_React$PureComponent) {
	  _inheritsLoose$1(Swipeable, _React$PureComponent);

	  function Swipeable(props) {
	    var _this;

	    _this = _React$PureComponent.call(this, props) || this;

	    _this._set = function (cb) {
	      _this.transientState = cb(_this.transientState, _this.props);
	    };

	    _this.transientState = _extends$4q({}, initialState, {
	      type: 'class'
	    });
	    return _this;
	  }

	  var _proto = Swipeable.prototype;

	  _proto.render = function render() {
	    var _this$props = this.props,
	        className = _this$props.className,
	        style = _this$props.style,
	        _this$props$nodeName = _this$props.nodeName,
	        nodeName = _this$props$nodeName === void 0 ? 'div' : _this$props$nodeName,
	        innerRef = _this$props.innerRef,
	        children = _this$props.children,
	        trackMouse = _this$props.trackMouse;

	    var _getHandlers = getHandlers(this._set, {
	      trackMouse: trackMouse
	    }),
	        handlers = _getHandlers[0],
	        attachTouch = _getHandlers[1];

	    this.transientState = updateTransientState(this.transientState, this.props, attachTouch);
	    var ref = innerRef ? function (el) {
	      return innerRef(el), handlers.ref(el);
	    } : handlers.ref;
	    return React__default['default'].createElement(nodeName, _extends$4q({}, handlers, {
	      className: className,
	      style: style,
	      ref: ref
	    }), children);
	  };

	  return Swipeable;
	}(React__default['default'].PureComponent);

	Swipeable.propTypes = {
	  onSwiped: propTypes.func,
	  onSwiping: propTypes.func,
	  onSwipedUp: propTypes.func,
	  onSwipedRight: propTypes.func,
	  onSwipedDown: propTypes.func,
	  onSwipedLeft: propTypes.func,
	  delta: propTypes.number,
	  preventDefaultTouchmoveEvent: propTypes.bool,
	  nodeName: propTypes.string,
	  trackMouse: propTypes.bool,
	  trackTouch: propTypes.bool,
	  innerRef: propTypes.func,
	  rotationAngle: propTypes.number
	};
	Swipeable.defaultProps = defaultProps;

	var styles$I = {"imageCarousel__mainImage":"telia-react-imageCarousel__mainImage","imageCarousel__mainImage__wrapper":"telia-react-imageCarousel__mainImage__wrapper","imageCarousel__mainImage__imageContainer":"telia-react-imageCarousel__mainImage__imageContainer","imageCarousel__mainImage__image":"telia-react-imageCarousel__mainImage__image","imageCarousel__thumbnail__small":"telia-react-imageCarousel__thumbnail__small","imageCarousel__thumbnail__small__active":"telia-react-imageCarousel__thumbnail__small__active"};

	var styles$J = {"image":"telia-react-image"};

	var _excluded$L = ["src", "alt", "mobileSrc", "className", "breakPoint"];
	var Image = function Image(_ref) {
	  var src = _ref.src,
	      alt = _ref.alt,
	      mobileSrc = _ref.mobileSrc,
	      className = _ref.className,
	      breakPoint = _ref.breakPoint,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$L);

	  var classNames = [styles$J.image, className];
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "picture",
	    block: true
	  }, props), /*#__PURE__*/React__default['default'].createElement("source", {
	    media: breakPoint ? "(max-width: " + breakPoint + "px)" : undefined,
	    srcSet: mobileSrc
	  }), /*#__PURE__*/React__default['default'].createElement("img", _extends_1({
	    src: src,
	    alt: alt,
	    className: classnames(classNames)
	  }, props)));
	};

	var styles$K = {"selectionButton":"telia-react-selectionButton","selectionButton_hiddenRadioInput":"telia-react-selectionButton_hiddenRadioInput","selectionButton__notAvailable":"telia-react-selectionButton__notAvailable","selectionButton__selected":"telia-react-selectionButton__selected","selectionButton__disabled":"telia-react-selectionButton__disabled","selectionButton_lineContainer":"telia-react-selectionButton_lineContainer","lineImage":"telia-react-lineImage","line":"telia-react-line"};

	var _excluded$M = ["disabled", "notAvailable", "onClick", "className", "selected", "label", "src", "title", "description", "alt", "narrow", "children", "withShadow", "id", "name", "value"];

	var SelectionButton = function SelectionButton(_ref) {
	  var disabled = _ref.disabled,
	      notAvailable = _ref.notAvailable,
	      _onClick = _ref.onClick,
	      className = _ref.className,
	      selected = _ref.selected,
	      label = _ref.label,
	      src = _ref.src,
	      title = _ref.title,
	      description = _ref.description,
	      alt = _ref.alt,
	      narrow = _ref.narrow,
	      children = _ref.children,
	      withShadow = _ref.withShadow,
	      id = _ref.id,
	      name = _ref.name,
	      value = _ref.value,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$M);

	  var classNames = [styles$K.selectionButton];

	  if (disabled) {
	    classNames.push(styles$K.selectionButton__disabled);
	  }

	  if (selected && !disabled) {
	    classNames.push(styles$K.selectionButton__selected);
	  }

	  if (notAvailable) {
	    classNames.push(styles$K.selectionButton__notAvailable);
	  }

	  if (className) {
	    classNames.push(className);
	  }
	  /** Blur method is used, to remove focus style onClick or touchStart events.
	   * So we don't get unnesessary focus on mobile or mouseClick. */


	  var blur = function blur(event) {
	    event.preventDefault();
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "button",
	    type: "button",
	    className: classNames,
	    "aria-disabled": disabled,
	    backgroundColor: disabled ? 'gray100' : 'white',
	    boxShadow: withShadow && !disabled ? 'sm' : 'zero',
	    color: disabled || notAvailable ? 'gray400' : 'inherit',
	    padding: narrow ? {
	      horizontal: 'md',
	      vertical: 'xs'
	    } : src ? {
	      size: 'xs'
	    } : {
	      size: 'md'
	    },
	    margin: src ? {
	      size: 'xs'
	    } : {},
	    borderRadius: {
	      size: 'sm'
	    },
	    onMouseDown: function onMouseDown(event) {
	      return blur(event);
	    },
	    onTouchStart: function onTouchStart(event) {
	      return blur(event);
	    },
	    onClick: function onClick(event) {
	      return !disabled && _onClick && _onClick(event, id);
	    },
	    tabIndex: disabled ? -1 : 0
	  }, props), !!name && !!value && /*#__PURE__*/React__default['default'].createElement("input", {
	    checked: selected,
	    tabIndex: -1,
	    className: styles$K.selectionButton_hiddenRadioInput,
	    type: "radio",
	    name: name,
	    value: value,
	    readOnly: true
	  }), !!notAvailable && /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$K.selectionButton_lineContainer
	  }, /*#__PURE__*/React__default['default'].createElement("svg", {
	    width: "100%",
	    height: "100%",
	    className: styles$K.lineImage
	  }, /*#__PURE__*/React__default['default'].createElement("line", {
	    x1: 0,
	    x2: "100%",
	    y1: 0,
	    y2: "100%",
	    strokeWidth: "1",
	    className: styles$K.line
	  }))), !!label && /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    color: disabled || notAvailable ? 'gray400' : selected ? 'purple500' : 'black',
	    fontWeight: "bold"
	  }, label), !!src && !!alt && /*#__PURE__*/React__default['default'].createElement(Image, {
	    style: {
	      width: '58px',
	      height: '58px'
	    },
	    src: src,
	    alt: alt,
	    title: title
	  }), !!description && /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    color: disabled || notAvailable ? 'gray400' : selected ? 'purple500' : 'gray500'
	  }, description), children);
	};

	var _excluded$N = ["images", "numberShown"];

	var MainImage = function MainImage(_ref) {
	  var src = _ref.src,
	      alt = _ref.alt,
	      onSwipedRight = _ref.onSwipedRight,
	      onSwipedLeft = _ref.onSwipedLeft;
	  return /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$I.imageCarousel__mainImage
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$I.imageCarousel__mainImage__wrapper
	  }, /*#__PURE__*/React__default['default'].createElement(Swipeable, {
	    className: styles$I.imageCarousel__mainImage__imageContainer,
	    onSwipedRight: onSwipedRight,
	    onSwipedLeft: onSwipedLeft,
	    trackMouse: true
	  }, /*#__PURE__*/React__default['default'].createElement(BackgroundImage, {
	    src: src,
	    alt: alt,
	    className: styles$I.imageCarousel__mainImage__image,
	    scaleWithOriginalAspectRatio: true
	  })))));
	};

	var ImageCarousel = function ImageCarousel(_ref2) {
	  var _context;

	  var images = _ref2.images,
	      _ref2$numberShown = _ref2.numberShown,
	      numberShown = _ref2$numberShown === void 0 ? 4 : _ref2$numberShown,
	      props = objectWithoutPropertiesLoose(_ref2, _excluded$N);

	  var _useState = React.useState(0),
	      currentImg = _useState[0],
	      setCurrentImg = _useState[1];

	  var _useState2 = React.useState(0),
	      currentSet = _useState2[0],
	      setCurrentSet = _useState2[1];

	  var setMaxIdx = Math.floor((images.length - 1) / numberShown);
	  React.useLayoutEffect(function () {
	    setCurrentImg(0);
	    setCurrentSet(0);
	    setMaxIdx = Math.floor((images.length - 1) / numberShown);
	  }, [images]);
	  var isScrollableToLeft = currentSet - 1 < 0;
	  var isScrollableToRight = currentSet + 1 > setMaxIdx;
	  var leftIconStyles = {
	    color: isScrollableToLeft ? 'gray300' : 'black',
	    hoverColor: isScrollableToLeft ? undefined : 'purple500'
	  };
	  var rightIconStyles = {
	    color: isScrollableToRight ? 'gray300' : 'black',
	    hoverColor: isScrollableToRight ? undefined : 'purple500'
	  };

	  var nextImage = function nextImage() {
	    var next = currentImg + 1;
	    if (next > images.length - 1) return;
	    setCurrentImg(next);
	    /* Function which automatically rolls thumbnails right when user swipes */

	    /* istanbul ignore if */

	    if (next / numberShown % 1 === 0) {
	      carouselRollRight();
	    }
	  };

	  var prevImage = function prevImage() {
	    var next = currentImg - 1;
	    if (next < 0) return;
	    setCurrentImg(next);
	    /* Function which automatically rolls thumbnails left when user swipes */

	    /* istanbul ignore if */

	    if ((next + 1) / numberShown % 1 === 0) {
	      carouselRollLeft();
	    }
	  };

	  var carouselRollRight = function carouselRollRight() {
	    var next = currentSet + 1;
	    if (next > setMaxIdx) return;
	    setCurrentSet(next);
	  };

	  var carouselRollLeft = function carouselRollLeft() {
	    var next = currentSet - 1;
	    if (next < 0) return;
	    setCurrentSet(next);
	  };

	  var solveImageUrl = currentImg >= images.length ? '' : images[currentImg].url;
	  var solveImageAlt = currentImg >= images.length ? '' : images[currentImg].name;
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    padding: {
	      size: 'lg'
	    }
	  }, props), /*#__PURE__*/React__default['default'].createElement(MainImage, {
	    src: solveImageUrl,
	    alt: solveImageAlt,
	    onSwipedLeft: nextImage,
	    onSwipedRight: prevImage
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "lg"
	  }), /*#__PURE__*/React__default['default'].createElement(Swipeable, {
	    onSwipedRight: carouselRollLeft,
	    onSwipedLeft: carouselRollRight,
	    trackMouse: true
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centered: true
	  }, setMaxIdx > 0 && /*#__PURE__*/React__default['default'].createElement(Icon, _extends_1({
	    margin: {
	      right: 'xxs'
	    },
	    name: "chevron-left",
	    size: "sm",
	    clickableAppearance: true,
	    onClick: carouselRollLeft
	  }, leftIconStyles)), map$3(_context = slice$3(images).call(images, currentSet * numberShown, (currentSet + 1) * numberShown)).call(_context, function (image, i) {
	    return /*#__PURE__*/React__default['default'].createElement(SelectionButton, {
	      id: image.name,
	      key: currentSet * numberShown + i,
	      src: image.url,
	      alt: image.name,
	      selected: currentSet * numberShown + i === currentImg,
	      onClick: function onClick() {
	        return setCurrentImg(currentSet * numberShown + i);
	      },
	      responsiveHidden: {
	        thinnerThan: 'sm'
	      }
	    });
	  }), map$3(images).call(images, function (_, i) {
	    return /*#__PURE__*/React__default['default'].createElement(Div, {
	      key: i,
	      className: [styles$I.imageCarousel__thumbnail__small, i === currentImg ? styles$I.imageCarousel__thumbnail__small__active : ''].join(' '),
	      responsiveHidden: {
	        widerThan: 'xs'
	      }
	    });
	  }), setMaxIdx > 0 && /*#__PURE__*/React__default['default'].createElement(Icon, _extends_1({
	    name: "chevron-right",
	    size: "sm",
	    onClick: carouselRollRight
	  }, rightIconStyles, {
	    clickableAppearance: true
	  })))));
	};

	var styles$L = {"inlineNotification_icon":"telia-react-inlineNotification_icon","inlineNotification_spacer":"telia-react-inlineNotification_spacer","inlineNotification_close":"telia-react-inlineNotification_close"};

	var _excluded$O = ["title", "messageText", "closeOnClick", "variant", "hideIcon", "forceMultiline", "button", "children"];
	var notificationVariants = ['information', 'warning', 'success', 'error'];

	var InlineNotification = function InlineNotification(_ref) {
	  var title = _ref.title,
	      messageText = _ref.messageText,
	      closeOnClick = _ref.closeOnClick,
	      variant = _ref.variant,
	      _ref$hideIcon = _ref.hideIcon,
	      hideIcon = _ref$hideIcon === void 0 ? false : _ref$hideIcon,
	      _ref$forceMultiline = _ref.forceMultiline,
	      forceMultiline = _ref$forceMultiline === void 0 ? false : _ref$forceMultiline,
	      button = _ref.button,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$O);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    boxShadow: 'sm',
	    backgroundColor: mapVariant$1[variant].backgroundColor,
	    borderRadius: {
	      size: 'sm'
	    },
	    className: styles$L.inlineNotification,
	    padding: {
	      size: 'sm'
	    },
	    style: {
	      borderLeft: "6px solid " + mapVariant$1[variant].leftBorderColor
	    }
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    margin: {
	      top: 'xxs'
	    }
	  }, !hideIcon && /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: mapVariant$1[variant].icon,
	    color: mapVariant$1[variant].iconColor,
	    size: "sm",
	    className: styles$L.inlineNotification_icon
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: 'sm'
	  }), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    wrapContent: true,
	    occupyHorizontalSpace: true,
	    directionColumn: forceMultiline
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    margin: {
	      right: 'md',
	      bottom: 'xxs'
	    },
	    fontWeight: 'medium',
	    size: 'sm',
	    color: "black"
	  }, title), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: 'sm',
	    color: "gray700"
	  }, messageText), children), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$L.inlineNotification_spacer
	  }), closeOnClick && /*#__PURE__*/React__default['default'].createElement(Flex, null, /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    onClick: closeOnClick,
	    className: ['inline-notification-onClose-test', styles$L.inlineNotification_close],
	    tagName: "button"
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "close",
	    size: "sm",
	    color: 'gray700',
	    className: styles$L.inlineNotification_icon
	  })))), button && /*#__PURE__*/React__default['default'].createElement(Flex, null, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$L.inlineNotification_spacer
	  }), button));
	};

	var mapVariant$1 = {
	  information: {
	    icon: 'info-filled',
	    iconColor: 'blue600',
	    leftBorderColor: colors$1.blue600.color,
	    backgroundColor: 'blue100'
	  },
	  warning: {
	    icon: 'alert-filled',
	    iconColor: 'orange500',
	    leftBorderColor: colors$1.orange500.color,
	    backgroundColor: 'orange100'
	  },
	  success: {
	    icon: 'check-circle-filled',
	    iconColor: 'green700',
	    leftBorderColor: colors$1.green700.color,
	    backgroundColor: 'green100'
	  },
	  error: {
	    icon: 'error-filled',
	    iconColor: 'red600',
	    leftBorderColor: colors$1.red600.color,
	    backgroundColor: 'red100'
	  }
	};

	var styles$M = {"linkList":"telia-react-linkList","linkList_item":"telia-react-linkList_item"};

	function LinkListHeading(_ref) {
	  var children = _ref.children;
	  return /*#__PURE__*/React__default['default'].createElement(Flex, {
	    occupyVerticalSpace: false
	  }, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xlg",
	    responsiveHidden: {
	      widerThan: 'md'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    responsiveHidden: {
	      thinnerThan: 'lg'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    flexItem: true
	  }, children));
	}

	var LinkListItem = function LinkListItem(_ref) {
	  var iconName = _ref.iconName,
	      to = _ref.href,
	      children = _ref.children;
	  return /*#__PURE__*/React__default['default'].createElement("li", {
	    className: styles$M.linkList_item
	  }, /*#__PURE__*/React__default['default'].createElement(Link, {
	    to: to,
	    block: true
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true,
	    spaceBetween: true,
	    padding: {
	      vertical: 'sm'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xlg",
	    responsiveHidden: {
	      widerThan: 'md'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    responsiveHidden: {
	      thinnerThan: 'lg'
	    }
	  }), iconName && /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: iconName,
	    size: "md",
	    color: "black"
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, null), /*#__PURE__*/React__default['default'].createElement(Div, {
	    flexItem: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    block: true
	  }, children)), /*#__PURE__*/React__default['default'].createElement(Gutter, null), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "arrow-right",
	    size: "sm",
	    color: "gray300"
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xlg",
	    responsiveHidden: {
	      widerThan: 'md'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    responsiveHidden: {
	      thinnerThan: 'lg'
	    }
	  }))));
	};

	var _excluded$P = ["children"];

	var LinkList = function LinkList(_ref) {
	  var children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$P);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "ul",
	    className: styles$M.linkList
	  }, props), children);
	};

	LinkList.Heading = LinkListHeading;
	LinkList.Item = LinkListItem;

	var styles$N = {"list":"telia-react-list","list__ul":"telia-react-list__ul","list__disc":"telia-react-list__disc","list__ol":"telia-react-list__ol","list_item":"telia-react-list_item"};

	var _excluded$Q = ["margin", "children"];

	var ListItem = function ListItem(_ref) {
	  var _ref$margin = _ref.margin,
	      margin = _ref$margin === void 0 ? {
	    bottom: 'xs'
	  } : _ref$margin,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$Q);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "li",
	    className: styles$N.list_item,
	    margin: margin
	  }, props), children);
	};

	var _excluded$R = ["className", "numbered", "children", "tagName", "disc"];

	var List = function List(_ref) {
	  var _ref2;

	  var className = _ref.className,
	      numbered = _ref.numbered,
	      children = _ref.children,
	      tagName = _ref.tagName,
	      disc = _ref.disc,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$R);

	  var TagName = numbered ? 'ol' : 'ul';
	  var classNames = [styles$N.list, (_ref2 = {}, _ref2[styles$N.list__ol] = numbered, _ref2[styles$N.list__ul] = !numbered, _ref2[styles$N.list__disc] = disc, _ref2)];

	  if (!!className) {
	    classNames.push(className);
	  }

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: tagName || TagName,
	    className: classNames
	  }, props), children);
	};

	List.Item = ListItem;

	var styles$O = {"logo__sizeXlg":"telia-react-logo__sizeXlg","logo__sizeLg":"telia-react-logo__sizeLg","logo__sizeMd":"telia-react-logo__sizeMd","logo__sizeSm":"telia-react-logo__sizeSm","logo__sizeXs":"telia-react-logo__sizeXs","logo_svg":"telia-react-logo_svg"};

	var supportedLogoSizes = ['xs', 'sm', 'md', 'lg', 'xlg'];

	var TeliaFullLogo = function TeliaFullLogo() {
	  return /*#__PURE__*/React__default['default'].createElement("svg", {
	    fill: "currentColor",
	    fillRule: "evenodd",
	    xmlns: "http://www.w3.org/2000/svg",
	    viewBox: "0 0 760.71 300",
	    className: styles$O['logo_svg']
	  }, /*#__PURE__*/React__default['default'].createElement("path", {
	    d: "M455.19 105.91H408.9v130.4h-29.37v-130.4H332.8V80.54h122.39v25.37z"
	  }), /*#__PURE__*/React__default['default'].createElement("path", {
	    d: "M543.31 188.47H461.2c2.89 16.47 14.69 27.37 29.82 27.37 11.35 0 20.47-5.12 26.04-13.57l21.81 13.13c-11.13 14.91-29.37 23.81-47.84 23.81-30.48 0-56.96-24.25-56.96-58.97s26.26-58.74 55.63-58.74c38.48-.01 57.39 30.7 53.61 66.97zm-81.22-20.7h54.74c-3.34-14.46-12.68-23.59-27.15-23.59-13.57.01-23.81 9.35-27.59 23.59zM601.61 236.75c-4.23.89-8.68 1.11-12.68 1.11-19.58 0-28.26-9.35-28.26-28.26V80.54h27.37v125.28c0 9.57 5.79 10.9 13.57 10.01v20.92zM615.85 93.45c0-8.68 7.57-15.8 16.24-15.8 8.46 0 16.02 7.12 16.02 15.8s-7.57 15.8-16.02 15.8c-8.67 0-16.24-7.12-16.24-15.8zm2.45 142.86V125.05h27.37v111.26H618.3zM760.71 157.54v78.77h-25.59V223.4c-8.68 11.35-22.48 15.58-34.05 15.58-24.03 0-38.27-15.13-38.27-34.05 0-21.58 24.26-39.16 53.85-39.16 5.79 0 12.02.45 17.58 2.23v-7.34c0-11.13-6.45-16.91-19.58-16.91-11.79 0-22.25 6.01-28.7 13.8l-19.36-14.24c10.9-12.68 29.6-21.58 48.51-21.58 29.59-.02 45.61 12.89 45.61 35.81zm-26.48 35.82v-4.9c-4.45-1.56-9.12-2-14.91-2-20.03 0-30.26 8.01-30.26 17.8 0 8.01 6.9 13.13 17.36 13.13 13.79 0 27.81-8.23 27.81-24.03z"
	  }), /*#__PURE__*/React__default['default'].createElement("path", {
	    d: "M196.36 210.79c38.9-22.56 73.94-60.82 84.99-88.1 3.14-22.58 3.78-25.43 4.16-50.27.05-3.44-.16-6.74-.48-9.9-2.27 36.48-49.42 82.35-111.8 112.32-75.25 36.15-131.7 45.88-156.89 18.31 8.75 17.28 14.49 25.67 24.33 38.49 29.06 25.74 90.22 17.13 155.69-20.85z"
	  }), /*#__PURE__*/React__default['default'].createElement("path", {
	    d: "M164.46 148.99c70.98-34.24 120.42-82.95 111.8-115.24C262.11 9.31 233.47 0 202.76 0 111.73 0 0 60 0 136.55c0 9.84 2.17 20.84 6.06 32.37 20.76 27.55 84.24 15.84 158.4-19.93zM158.47 257.49c-49.92 20.24-78.49 13.79-94.28 1.17l-.23-.18c24.44 24.38 52.3 41.53 76.73 41.53 42.78 0 101.35-51.9 129.07-132.38-15.62 29.05-49.14 64.74-111.29 89.86z"
	  }));
	};

	var Logo = function Logo(_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      color = _ref.color,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      linkProps = _ref.linkProps;
	  var classNames = styles$O["logo__size" + upperFirst$1(size)];
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    className: classNames,
	    tagName: tagName,
	    color: color,
	    inlineBlock: true
	  }, linkProps ? /*#__PURE__*/React__default['default'].createElement(Link, linkProps, /*#__PURE__*/React__default['default'].createElement(TeliaFullLogo, null)) : /*#__PURE__*/React__default['default'].createElement(TeliaFullLogo, null));
	};

	/*!
	* tabbable 5.2.1
	* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
	*/
	var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
	var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
	var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

	var getCandidates = function getCandidates(el, includeContainer, filter) {
	  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

	  if (includeContainer && matches.call(el, candidateSelector)) {
	    candidates.unshift(el);
	  }

	  candidates = candidates.filter(filter);
	  return candidates;
	};

	var isContentEditable = function isContentEditable(node) {
	  return node.contentEditable === 'true';
	};

	var getTabindex = function getTabindex(node) {
	  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

	  if (!isNaN(tabindexAttr)) {
	    return tabindexAttr;
	  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
	  // so if they don't have a tabindex attribute specifically set, assume it's 0.


	  if (isContentEditable(node)) {
	    return 0;
	  } // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
	  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
	  //  yet they are still part of the regular tab order; in FF, they get a default
	  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
	  //  order, consider their tab index to be 0.


	  if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
	    return 0;
	  }

	  return node.tabIndex;
	};

	var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
	  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
	};

	var isInput = function isInput(node) {
	  return node.tagName === 'INPUT';
	};

	var isHiddenInput = function isHiddenInput(node) {
	  return isInput(node) && node.type === 'hidden';
	};

	var isDetailsWithSummary = function isDetailsWithSummary(node) {
	  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
	    return child.tagName === 'SUMMARY';
	  });
	  return r;
	};

	var getCheckedRadio = function getCheckedRadio(nodes, form) {
	  for (var i = 0; i < nodes.length; i++) {
	    if (nodes[i].checked && nodes[i].form === form) {
	      return nodes[i];
	    }
	  }
	};

	var isTabbableRadio = function isTabbableRadio(node) {
	  if (!node.name) {
	    return true;
	  }

	  var radioScope = node.form || node.ownerDocument;

	  var queryRadios = function queryRadios(name) {
	    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
	  };

	  var radioSet;

	  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
	    radioSet = queryRadios(window.CSS.escape(node.name));
	  } else {
	    try {
	      radioSet = queryRadios(node.name);
	    } catch (err) {
	      // eslint-disable-next-line no-console
	      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
	      return false;
	    }
	  }

	  var checked = getCheckedRadio(radioSet, node.form);
	  return !checked || checked === node;
	};

	var isRadio = function isRadio(node) {
	  return isInput(node) && node.type === 'radio';
	};

	var isNonTabbableRadio = function isNonTabbableRadio(node) {
	  return isRadio(node) && !isTabbableRadio(node);
	};

	var isHidden = function isHidden(node, displayCheck) {
	  if (getComputedStyle(node).visibility === 'hidden') {
	    return true;
	  }

	  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
	  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

	  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
	    return true;
	  }

	  if (!displayCheck || displayCheck === 'full') {
	    while (node) {
	      if (getComputedStyle(node).display === 'none') {
	        return true;
	      }

	      node = node.parentElement;
	    }
	  } else if (displayCheck === 'non-zero-area') {
	    var _node$getBoundingClie = node.getBoundingClientRect(),
	        width = _node$getBoundingClie.width,
	        height = _node$getBoundingClie.height;

	    return width === 0 && height === 0;
	  }

	  return false;
	}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
	//  unless they are in the _first_ <legend> element of the top-most disabled
	//  fieldset


	var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
	  if (isInput(node) || node.tagName === 'SELECT' || node.tagName === 'TEXTAREA' || node.tagName === 'BUTTON') {
	    var parentNode = node.parentElement;

	    while (parentNode) {
	      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
	        // look for the first <legend> as an immediate child of the disabled
	        //  <fieldset>: if the node is in that legend, it'll be enabled even
	        //  though the fieldset is disabled; otherwise, the node is in a
	        //  secondary/subsequent legend, or somewhere else within the fieldset
	        //  (however deep nested) and it'll be disabled
	        for (var i = 0; i < parentNode.children.length; i++) {
	          var child = parentNode.children.item(i);

	          if (child.tagName === 'LEGEND') {
	            if (child.contains(node)) {
	              return false;
	            } // the node isn't in the first legend (in doc order), so no matter
	            //  where it is now, it'll be disabled


	            return true;
	          }
	        } // the node isn't in a legend, so no matter where it is now, it'll be disabled


	        return true;
	      }

	      parentNode = parentNode.parentElement;
	    }
	  } // else, node's tabbable/focusable state should not be affected by a fieldset's
	  //  enabled/disabled state


	  return false;
	};

	var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
	  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || // For a details element with a summary, the summary element gets the focus
	  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
	    return false;
	  }

	  return true;
	};

	var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
	  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
	    return false;
	  }

	  return true;
	};

	var tabbable = function tabbable(el, options) {
	  options = options || {};
	  var regularTabbables = [];
	  var orderedTabbables = [];
	  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
	  candidates.forEach(function (candidate, i) {
	    var candidateTabindex = getTabindex(candidate);

	    if (candidateTabindex === 0) {
	      regularTabbables.push(candidate);
	    } else {
	      orderedTabbables.push({
	        documentOrder: i,
	        tabIndex: candidateTabindex,
	        node: candidate
	      });
	    }
	  });
	  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
	    return a.node;
	  }).concat(regularTabbables);
	  return tabbableNodes;
	};

	var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

	var isFocusable = function isFocusable(node, options) {
	  options = options || {};

	  if (!node) {
	    throw new Error('No node provided');
	  }

	  if (matches.call(node, focusableCandidateSelector) === false) {
	    return false;
	  }

	  return isNodeMatchingSelectorFocusable(options, node);
	};

	/*!
	* focus-trap 6.7.1
	* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
	*/

	function ownKeys$f(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);

	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }

	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2$2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys$f(Object(source), true).forEach(function (key) {
	        _defineProperty$5(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$f(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _defineProperty$5(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var activeFocusTraps = function () {
	  var trapQueue = [];
	  return {
	    activateTrap: function activateTrap(trap) {
	      if (trapQueue.length > 0) {
	        var activeTrap = trapQueue[trapQueue.length - 1];

	        if (activeTrap !== trap) {
	          activeTrap.pause();
	        }
	      }

	      var trapIndex = trapQueue.indexOf(trap);

	      if (trapIndex === -1) {
	        trapQueue.push(trap);
	      } else {
	        // move this existing trap to the front of the queue
	        trapQueue.splice(trapIndex, 1);
	        trapQueue.push(trap);
	      }
	    },
	    deactivateTrap: function deactivateTrap(trap) {
	      var trapIndex = trapQueue.indexOf(trap);

	      if (trapIndex !== -1) {
	        trapQueue.splice(trapIndex, 1);
	      }

	      if (trapQueue.length > 0) {
	        trapQueue[trapQueue.length - 1].unpause();
	      }
	    }
	  };
	}();

	var isSelectableInput = function isSelectableInput(node) {
	  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
	};

	var isEscapeEvent = function isEscapeEvent(e) {
	  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
	};

	var isTabEvent = function isTabEvent(e) {
	  return e.key === 'Tab' || e.keyCode === 9;
	};

	var delay = function delay(fn) {
	  return setTimeout(fn, 0);
	}; // Array.find/findIndex() are not supported on IE; this replicates enough
	//  of Array.findIndex() for our needs


	var findIndex$4 = function findIndex(arr, fn) {
	  var idx = -1;
	  arr.every(function (value, i) {
	    if (fn(value)) {
	      idx = i;
	      return false; // break
	    }

	    return true; // next
	  });
	  return idx;
	};
	/**
	 * Get an option's value when it could be a plain value, or a handler that provides
	 *  the value.
	 * @param {*} value Option's value to check.
	 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
	 * @returns {*} The `value`, or the handler's returned value.
	 */


	var valueOrHandler = function valueOrHandler(value) {
	  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    params[_key - 1] = arguments[_key];
	  }

	  return typeof value === 'function' ? value.apply(void 0, params) : value;
	};

	var getActualTarget = function getActualTarget(event) {
	  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
	  //  shadow host. However, event.target.composedPath() will be an array of
	  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
	  //  outer-most (the host HTML document). If we have access to composedPath(),
	  //  then use its first element; otherwise, fall back to event.target (and
	  //  this only works for an _open_ shadow DOM; otherwise,
	  //  composedPath()[0] === event.target always).
	  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
	};

	var createFocusTrap = function createFocusTrap(elements, userOptions) {
	  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

	  var config = _objectSpread2$2({
	    returnFocusOnDeactivate: true,
	    escapeDeactivates: true,
	    delayInitialFocus: true
	  }, userOptions);

	  var state = {
	    // @type {Array<HTMLElement>}
	    containers: [],
	    // list of objects identifying the first and last tabbable nodes in all containers/groups in
	    //  the trap
	    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
	    //  is active, but the trap should never get to a state where there isn't at least one group
	    //  with at least one tabbable node in it (that would lead to an error condition that would
	    //  result in an error being thrown)
	    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
	    tabbableGroups: [],
	    nodeFocusedBeforeActivation: null,
	    mostRecentlyFocusedNode: null,
	    active: false,
	    paused: false,
	    // timer ID for when delayInitialFocus is true and initial focus in this trap
	    //  has been delayed during activation
	    delayInitialFocusTimer: undefined
	  };
	  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

	  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
	    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
	  };

	  var containersContain = function containersContain(element) {
	    return !!(element && state.containers.some(function (container) {
	      return container.contains(element);
	    }));
	  };
	  /**
	   * Gets the node for the given option, which is expected to be an option that
	   *  can be either a DOM node, a string that is a selector to get a node, `false`
	   *  (if a node is explicitly NOT given), or a function that returns any of these
	   *  values.
	   * @param {string} optionName
	   * @returns {undefined | false | HTMLElement | SVGElement} Returns
	   *  `undefined` if the option is not specified; `false` if the option
	   *  resolved to `false` (node explicitly not given); otherwise, the resolved
	   *  DOM node.
	   * @throws {Error} If the option is set, not `false`, and is not, or does not
	   *  resolve to a node.
	   */


	  var getNodeForOption = function getNodeForOption(optionName) {
	    var optionValue = config[optionName];

	    if (typeof optionValue === 'function') {
	      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        params[_key2 - 1] = arguments[_key2];
	      }

	      optionValue = optionValue.apply(void 0, params);
	    }

	    if (!optionValue) {
	      if (optionValue === undefined || optionValue === false) {
	        return optionValue;
	      } // else, empty string (invalid), null (invalid), 0 (invalid)


	      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
	    }

	    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

	    if (typeof optionValue === 'string') {
	      node = doc.querySelector(optionValue); // resolve to node, or null if fails

	      if (!node) {
	        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
	      }
	    }

	    return node;
	  };

	  var getInitialFocusNode = function getInitialFocusNode() {
	    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

	    if (node === false) {
	      return false;
	    }

	    if (node === undefined) {
	      // option not specified: use fallback options
	      if (containersContain(doc.activeElement)) {
	        node = doc.activeElement;
	      } else {
	        var firstTabbableGroup = state.tabbableGroups[0];
	        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

	        node = firstTabbableNode || getNodeForOption('fallbackFocus');
	      }
	    }

	    if (!node) {
	      throw new Error('Your focus-trap needs to have at least one focusable element');
	    }

	    return node;
	  };

	  var updateTabbableNodes = function updateTabbableNodes() {
	    state.tabbableGroups = state.containers.map(function (container) {
	      var tabbableNodes = tabbable(container);

	      if (tabbableNodes.length > 0) {
	        return {
	          container: container,
	          firstTabbableNode: tabbableNodes[0],
	          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
	        };
	      }

	      return undefined;
	    }).filter(function (group) {
	      return !!group;
	    }); // remove groups with no tabbable nodes
	    // throw if no groups have tabbable nodes and we don't have a fallback focus node either

	    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
	    ) {
	      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
	    }
	  };

	  var tryFocus = function tryFocus(node) {
	    if (node === false) {
	      return;
	    }

	    if (node === doc.activeElement) {
	      return;
	    }

	    if (!node || !node.focus) {
	      tryFocus(getInitialFocusNode());
	      return;
	    }

	    node.focus({
	      preventScroll: !!config.preventScroll
	    });
	    state.mostRecentlyFocusedNode = node;

	    if (isSelectableInput(node)) {
	      node.select();
	    }
	  };

	  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
	    var node = getNodeForOption('setReturnFocus', previousActiveElement);
	    return node ? node : node === false ? false : previousActiveElement;
	  }; // This needs to be done on mousedown and touchstart instead of click
	  // so that it precedes the focus event.


	  var checkPointerDown = function checkPointerDown(e) {
	    var target = getActualTarget(e);

	    if (containersContain(target)) {
	      // allow the click since it ocurred inside the trap
	      return;
	    }

	    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
	      // immediately deactivate the trap
	      trap.deactivate({
	        // if, on deactivation, we should return focus to the node originally-focused
	        //  when the trap was activated (or the configured `setReturnFocus` node),
	        //  then assume it's also OK to return focus to the outside node that was
	        //  just clicked, causing deactivation, as long as that node is focusable;
	        //  if it isn't focusable, then return focus to the original node focused
	        //  on activation (or the configured `setReturnFocus` node)
	        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
	        //  which will result in the outside click setting focus to the node
	        //  that was clicked, whether it's focusable or not; by setting
	        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
	        //  on activation (or the configured `setReturnFocus` node)
	        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
	      });
	      return;
	    } // This is needed for mobile devices.
	    // (If we'll only let `click` events through,
	    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


	    if (valueOrHandler(config.allowOutsideClick, e)) {
	      // allow the click outside the trap to take place
	      return;
	    } // otherwise, prevent the click


	    e.preventDefault();
	  }; // In case focus escapes the trap for some strange reason, pull it back in.


	  var checkFocusIn = function checkFocusIn(e) {
	    var target = getActualTarget(e);
	    var targetContained = containersContain(target); // In Firefox when you Tab out of an iframe the Document is briefly focused.

	    if (targetContained || target instanceof Document) {
	      if (targetContained) {
	        state.mostRecentlyFocusedNode = target;
	      }
	    } else {
	      // escaped! pull it back in to where it just left
	      e.stopImmediatePropagation();
	      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
	    }
	  }; // Hijack Tab events on the first and last focusable nodes of the trap,
	  // in order to prevent focus from escaping. If it escapes for even a
	  // moment it can end up scrolling the page and causing confusion so we
	  // kind of need to capture the action at the keydown phase.


	  var checkTab = function checkTab(e) {
	    var target = getActualTarget(e);
	    updateTabbableNodes();
	    var destinationNode = null;

	    if (state.tabbableGroups.length > 0) {
	      // make sure the target is actually contained in a group
	      // NOTE: the target may also be the container itself if it's tabbable
	      //  with tabIndex='-1' and was given initial focus
	      var containerIndex = findIndex$4(state.tabbableGroups, function (_ref) {
	        var container = _ref.container;
	        return container.contains(target);
	      });

	      if (containerIndex < 0) {
	        // target not found in any group: quite possible focus has escaped the trap,
	        //  so bring it back in to...
	        if (e.shiftKey) {
	          // ...the last node in the last group
	          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
	        } else {
	          // ...the first node in the first group
	          destinationNode = state.tabbableGroups[0].firstTabbableNode;
	        }
	      } else if (e.shiftKey) {
	        // REVERSE
	        // is the target the first tabbable node in a group?
	        var startOfGroupIndex = findIndex$4(state.tabbableGroups, function (_ref2) {
	          var firstTabbableNode = _ref2.firstTabbableNode;
	          return target === firstTabbableNode;
	        });

	        if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
	          // an exception case where the target is the container itself, in which
	          //  case, we should handle shift+tab as if focus were on the container's
	          //  first tabbable node, and go to the last tabbable node of the LAST group
	          startOfGroupIndex = containerIndex;
	        }

	        if (startOfGroupIndex >= 0) {
	          // YES: then shift+tab should go to the last tabbable node in the
	          //  previous group (and wrap around to the last tabbable node of
	          //  the LAST group if it's the first tabbable node of the FIRST group)
	          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
	          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
	          destinationNode = destinationGroup.lastTabbableNode;
	        }
	      } else {
	        // FORWARD
	        // is the target the last tabbable node in a group?
	        var lastOfGroupIndex = findIndex$4(state.tabbableGroups, function (_ref3) {
	          var lastTabbableNode = _ref3.lastTabbableNode;
	          return target === lastTabbableNode;
	        });

	        if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
	          // an exception case where the target is the container itself, in which
	          //  case, we should handle tab as if focus were on the container's
	          //  last tabbable node, and go to the first tabbable node of the FIRST group
	          lastOfGroupIndex = containerIndex;
	        }

	        if (lastOfGroupIndex >= 0) {
	          // YES: then tab should go to the first tabbable node in the next
	          //  group (and wrap around to the first tabbable node of the FIRST
	          //  group if it's the last tabbable node of the LAST group)
	          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

	          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
	          destinationNode = _destinationGroup.firstTabbableNode;
	        }
	      }
	    } else {
	      // NOTE: the fallbackFocus option does not support returning false to opt-out
	      destinationNode = getNodeForOption('fallbackFocus');
	    }

	    if (destinationNode) {
	      e.preventDefault();
	      tryFocus(destinationNode);
	    } // else, let the browser take care of [shift+]tab and move the focus

	  };

	  var checkKey = function checkKey(e) {
	    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
	      e.preventDefault();
	      trap.deactivate();
	      return;
	    }

	    if (isTabEvent(e)) {
	      checkTab(e);
	      return;
	    }
	  };

	  var checkClick = function checkClick(e) {
	    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
	      return;
	    }

	    var target = getActualTarget(e);

	    if (containersContain(target)) {
	      return;
	    }

	    if (valueOrHandler(config.allowOutsideClick, e)) {
	      return;
	    }

	    e.preventDefault();
	    e.stopImmediatePropagation();
	  }; //
	  // EVENT LISTENERS
	  //


	  var addListeners = function addListeners() {
	    if (!state.active) {
	      return;
	    } // There can be only one listening focus trap at a time


	    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
	    // that caused the focus trap activation.

	    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
	      tryFocus(getInitialFocusNode());
	    }) : tryFocus(getInitialFocusNode());
	    doc.addEventListener('focusin', checkFocusIn, true);
	    doc.addEventListener('mousedown', checkPointerDown, {
	      capture: true,
	      passive: false
	    });
	    doc.addEventListener('touchstart', checkPointerDown, {
	      capture: true,
	      passive: false
	    });
	    doc.addEventListener('click', checkClick, {
	      capture: true,
	      passive: false
	    });
	    doc.addEventListener('keydown', checkKey, {
	      capture: true,
	      passive: false
	    });
	    return trap;
	  };

	  var removeListeners = function removeListeners() {
	    if (!state.active) {
	      return;
	    }

	    doc.removeEventListener('focusin', checkFocusIn, true);
	    doc.removeEventListener('mousedown', checkPointerDown, true);
	    doc.removeEventListener('touchstart', checkPointerDown, true);
	    doc.removeEventListener('click', checkClick, true);
	    doc.removeEventListener('keydown', checkKey, true);
	    return trap;
	  }; //
	  // TRAP DEFINITION
	  //


	  trap = {
	    activate: function activate(activateOptions) {
	      if (state.active) {
	        return this;
	      }

	      var onActivate = getOption(activateOptions, 'onActivate');
	      var onPostActivate = getOption(activateOptions, 'onPostActivate');
	      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

	      if (!checkCanFocusTrap) {
	        updateTabbableNodes();
	      }

	      state.active = true;
	      state.paused = false;
	      state.nodeFocusedBeforeActivation = doc.activeElement;

	      if (onActivate) {
	        onActivate();
	      }

	      var finishActivation = function finishActivation() {
	        if (checkCanFocusTrap) {
	          updateTabbableNodes();
	        }

	        addListeners();

	        if (onPostActivate) {
	          onPostActivate();
	        }
	      };

	      if (checkCanFocusTrap) {
	        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
	        return this;
	      }

	      finishActivation();
	      return this;
	    },
	    deactivate: function deactivate(deactivateOptions) {
	      if (!state.active) {
	        return this;
	      }

	      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

	      state.delayInitialFocusTimer = undefined;
	      removeListeners();
	      state.active = false;
	      state.paused = false;
	      activeFocusTraps.deactivateTrap(trap);
	      var onDeactivate = getOption(deactivateOptions, 'onDeactivate');
	      var onPostDeactivate = getOption(deactivateOptions, 'onPostDeactivate');
	      var checkCanReturnFocus = getOption(deactivateOptions, 'checkCanReturnFocus');

	      if (onDeactivate) {
	        onDeactivate();
	      }

	      var returnFocus = getOption(deactivateOptions, 'returnFocus', 'returnFocusOnDeactivate');

	      var finishDeactivation = function finishDeactivation() {
	        delay(function () {
	          if (returnFocus) {
	            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
	          }

	          if (onPostDeactivate) {
	            onPostDeactivate();
	          }
	        });
	      };

	      if (returnFocus && checkCanReturnFocus) {
	        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
	        return this;
	      }

	      finishDeactivation();
	      return this;
	    },
	    pause: function pause() {
	      if (state.paused || !state.active) {
	        return this;
	      }

	      state.paused = true;
	      removeListeners();
	      return this;
	    },
	    unpause: function unpause() {
	      if (!state.paused || !state.active) {
	        return this;
	      }

	      state.paused = false;
	      updateTabbableNodes();
	      addListeners();
	      return this;
	    },
	    updateContainerElements: function updateContainerElements(containerElements) {
	      var elementsAsArray = [].concat(containerElements).filter(Boolean);
	      state.containers = elementsAsArray.map(function (element) {
	        return typeof element === 'string' ? doc.querySelector(element) : element;
	      });

	      if (state.active) {
	        updateTabbableNodes();
	      }

	      return this;
	    }
	  }; // initialize container elements

	  trap.updateContainerElements(elements);
	  return trap;
	};

	var focusTrap_esm = /*#__PURE__*/Object.freeze({
		__proto__: null,
		createFocusTrap: createFocusTrap
	});

	var _require = /*@__PURE__*/getAugmentedNamespace(focusTrap_esm);

	function _typeof$4(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof$4 = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof$4 = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof$4(obj);
	}

	function _classCallCheck$8(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties$1(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$8(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$1(Constructor, staticProps);
	  return Constructor;
	}

	function _inherits$8(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf$1(subClass, superClass);
	}

	function _setPrototypeOf$1(o, p) {
	  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };

	  return _setPrototypeOf$1(o, p);
	}

	function _createSuper$1(Derived) {
	  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

	  return function _createSuperInternal() {
	    var Super = _getPrototypeOf$1(Derived),
	        result;

	    if (hasNativeReflectConstruct) {
	      var NewTarget = _getPrototypeOf$1(this).constructor;

	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }

	    return _possibleConstructorReturn$8(this, result);
	  };
	}

	function _possibleConstructorReturn$8(self, call) {
	  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
	    return call;
	  }

	  return _assertThisInitialized$1(self);
	}

	function _assertThisInitialized$1(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return self;
	}

	function _isNativeReflectConstruct$1() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;

	  try {
	    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}

	function _getPrototypeOf$1(o) {
	  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf$1(o);
	}







	var createFocusTrap$1 = _require.createFocusTrap; // TODO: These issues are related to older React features which we'll likely need
	//  to fix in order to move the code forward to the next major version of React.
	//  @see https://github.com/davidtheclark/focus-trap-react/issues/77

	/* eslint-disable react/no-find-dom-node */


	var FocusTrap = /*#__PURE__*/function (_React$Component) {
	  _inherits$8(FocusTrap, _React$Component);

	  var _super = _createSuper$1(FocusTrap);

	  function FocusTrap(props) {
	    var _this;

	    _classCallCheck$8(this, FocusTrap);

	    _this = _super.call(this, props); // We need to hijack the returnFocusOnDeactivate option,
	    // because React can move focus into the element before we arrived at
	    // this lifecycle hook (e.g. with autoFocus inputs). So the component
	    // captures the previouslyFocusedElement in componentWillMount,
	    // then (optionally) returns focus to it in componentWillUnmount.

	    _this.tailoredFocusTrapOptions = {
	      returnFocusOnDeactivate: false
	    }; // because of the above, we maintain our own flag for this option, and
	    //  default it to `true` because that's focus-trap's default

	    _this.returnFocusOnDeactivate = true;
	    var focusTrapOptions = props.focusTrapOptions;

	    for (var optionName in focusTrapOptions) {
	      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
	        continue;
	      }

	      if (optionName === 'returnFocusOnDeactivate') {
	        _this.returnFocusOnDeactivate = !!focusTrapOptions[optionName];
	        continue;
	      }

	      _this.tailoredFocusTrapOptions[optionName] = focusTrapOptions[optionName];
	    } // elements from which to create the focus trap on mount; if a child is used
	    //  instead of the `containerElements` prop, we'll get the child's related
	    //  element when the trap renders and then is declared 'mounted'


	    _this.focusTrapElements = props.containerElements || []; // now we remember what the currently focused element is, not relying on focus-trap

	    _this.updatePreviousElement();

	    return _this;
	  }
	  /** Update the previously focused element with the currently focused element. */


	  _createClass$8(FocusTrap, [{
	    key: "updatePreviousElement",
	    value: function updatePreviousElement() {
	      if (typeof document !== 'undefined') {
	        this.previouslyFocusedElement = document.activeElement;
	      }
	    }
	    /** Returns focus to the element that had focus when the trap was activated. */

	  }, {
	    key: "returnFocus",
	    value: function returnFocus() {
	      if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
	        this.previouslyFocusedElement.focus();
	      }
	    }
	  }, {
	    key: "setupFocusTrap",
	    value: function setupFocusTrap() {
	      if (!this.focusTrap) {
	        var focusTrapElementDOMNodes = this.focusTrapElements.map( // NOTE: `findDOMNode()` does not support CSS selectors; it'll just return
	        //  a new text node with the text wrapped in it instead of treating the
	        //  string as a selector and resolving it to a node in the DOM
	        ReactDOM__default['default'].findDOMNode);
	        var nodesExist = focusTrapElementDOMNodes.some(Boolean);

	        if (nodesExist) {
	          // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
	          this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.tailoredFocusTrapOptions);

	          if (this.props.active) {
	            this.focusTrap.activate();
	          }

	          if (this.props.paused) {
	            this.focusTrap.pause();
	          }
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setupFocusTrap();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.focusTrap) {
	        if (prevProps.containerElements !== this.props.containerElements) {
	          this.focusTrap.updateContainerElements(this.props.containerElements);
	        }

	        if (prevProps.active && !this.props.active) {
	          // NOTE: we never let the trap return the focus since we do that ourselves
	          this.focusTrap.deactivate({
	            returnFocus: false
	          });

	          if (this.returnFocusOnDeactivate) {
	            this.returnFocus();
	          }

	          return; // un/pause does nothing on an inactive trap
	        }

	        if (!prevProps.active && this.props.active) {
	          this.updatePreviousElement();
	          this.focusTrap.activate();
	        }

	        if (prevProps.paused && !this.props.paused) {
	          this.focusTrap.unpause();
	        } else if (!prevProps.paused && this.props.paused) {
	          this.focusTrap.pause();
	        }
	      } else if (prevProps.containerElements !== this.props.containerElements) {
	        this.focusTrapElements = this.props.containerElements;
	        this.setupFocusTrap();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.focusTrap) {
	        // NOTE: we never let the trap return the focus since we do that ourselves
	        this.focusTrap.deactivate({
	          returnFocus: false
	        });
	      }

	      if (this.returnFocusOnDeactivate) {
	        this.returnFocus();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;

	      var child = this.props.children ? React__default['default'].Children.only(this.props.children) : undefined;

	      if (child) {
	        var composedRefCallback = function composedRefCallback(element) {
	          var containerElements = _this2.props.containerElements;

	          if (child) {
	            if (typeof child.ref === 'function') {
	              child.ref(element);
	            } else if (child.ref) {
	              child.ref.current = element;
	            }
	          }

	          _this2.focusTrapElements = containerElements ? containerElements : [element];
	        };

	        var childWithRef = React__default['default'].cloneElement(child, {
	          ref: composedRefCallback
	        });
	        return childWithRef;
	      }

	      return null;
	    }
	  }]);

	  return FocusTrap;
	}(React__default['default'].Component); // support server-side rendering where `Element` will not be defined


	var ElementType = typeof Element === 'undefined' ? Function : Element;
	FocusTrap.propTypes = {
	  active: propTypes.bool,
	  paused: propTypes.bool,
	  focusTrapOptions: propTypes.shape({
	    onActivate: propTypes.func,
	    onDeactivate: propTypes.func,
	    initialFocus: propTypes.oneOfType([propTypes.instanceOf(ElementType), propTypes.string, propTypes.func]),
	    fallbackFocus: propTypes.oneOfType([propTypes.instanceOf(ElementType), propTypes.string, propTypes.func]),
	    escapeDeactivates: propTypes.bool,
	    clickOutsideDeactivates: propTypes.bool,
	    returnFocusOnDeactivate: propTypes.bool,
	    setReturnFocus: propTypes.oneOfType([propTypes.instanceOf(ElementType), propTypes.string, propTypes.func]),
	    allowOutsideClick: propTypes.oneOfType([propTypes.bool, propTypes.func]),
	    preventScroll: propTypes.bool
	  }),
	  containerElements: propTypes.arrayOf(propTypes.instanceOf(ElementType)),
	  children: propTypes.oneOfType([propTypes.element, // React element
	  propTypes.instanceOf(ElementType) // DOM element
	  ]) // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
	  //  specify it here. It's expected to be set to the function returned from
	  //  require('focus-trap'), or one with a compatible interface.

	};
	FocusTrap.defaultProps = {
	  active: true,
	  paused: false,
	  focusTrapOptions: {},
	  _createFocusTrap: createFocusTrap$1
	};
	var focusTrapReact = FocusTrap;

	var styles$P = {"modalDialog":"telia-react-modalDialog","modalDialog_hiddenFocus":"telia-react-modalDialog_hiddenFocus","modalDialog_title":"telia-react-modalDialog_title","modalDialog_focustrap_inner_container":"telia-react-modalDialog_focustrap_inner_container","modalDialog_container":"telia-react-modalDialog_container","modalDialog_container_icon":"telia-react-modalDialog_container_icon","modalDialog_container_content":"telia-react-modalDialog_container_content","backdrop":"telia-react-backdrop","modalDialog_inner_container":"telia-react-modalDialog_inner_container","modalDialog_header_section":"telia-react-modalDialog_header_section","modalDialog_footer_section":"telia-react-modalDialog_footer_section","modalDialog_content_section":"telia-react-modalDialog_content_section","bodyscroll__disabled":"telia-react-bodyscroll__disabled","modalDialog_inner_container_lg":"telia-react-modalDialog_inner_container_lg"};

	var styles$Q = {"backdrop":"telia-react-backdrop","backdrop__visible":"telia-react-backdrop__visible"};

	var Backdrop = function Backdrop(_ref) {
	  var _ref2;

	  var isVisible = _ref.isVisible,
	      onCloseClick = _ref.onCloseClick;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    "data-testid": "backdrop",
	    onClick: onCloseClick,
	    className: [styles$Q.backdrop, (_ref2 = {}, _ref2[styles$Q.backdrop__visible] = isVisible, _ref2)]
	  });
	};

	var styles$R = {"prevent_scroll":"telia-react-prevent_scroll"};

	var usePreventScroll = function usePreventScroll(enabled) {
	  if (enabled === void 0) {
	    enabled = true;
	  }

	  React.useLayoutEffect(function () {
	    if (enabled) {
	      document.body.classList.add(styles$R.prevent_scroll);
	    } else {
	      document.body.classList.remove(styles$R.prevent_scroll);
	    }

	    return function () {
	      document.body.classList.remove(styles$R.prevent_scroll);
	    };
	  }, [enabled]);
	};

	var _excluded$S = ["isOpen", "title", "acceptButtonText", "closeButtonText", "acceptButtonDisabled", "closeButtonDisabled", "acceptButtonClassName", "closeButtonClassName", "onAcceptClick", "onCloseClick", "children", "size", "destructive", "closeIconAreaLabel", "noWindow"];

	var ModalDialog = function ModalDialog(_ref) {
	  var _ref2;

	  var isOpen = _ref.isOpen,
	      title = _ref.title,
	      acceptButtonText = _ref.acceptButtonText,
	      closeButtonText = _ref.closeButtonText,
	      acceptButtonDisabled = _ref.acceptButtonDisabled,
	      closeButtonDisabled = _ref.closeButtonDisabled,
	      acceptButtonClassName = _ref.acceptButtonClassName,
	      closeButtonClassName = _ref.closeButtonClassName,
	      onAcceptClick = _ref.onAcceptClick,
	      onCloseClick = _ref.onCloseClick,
	      children = _ref.children,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      destructive = _ref.destructive,
	      closeIconAreaLabel = _ref.closeIconAreaLabel,
	      noWindow = _ref.noWindow,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$S);

	  usePreventScroll(!!isOpen);
	  React.useEffect(function () {
	    var closeKeyHandler = function closeKeyHandler(event) {
	      if (event.key === 'Escape' && isOpen === true) {
	        onCloseClick && onCloseClick();
	      }
	    };

	    document.addEventListener('keydown', closeKeyHandler);
	    return function () {
	      return document.removeEventListener('keydown', closeKeyHandler);
	    };
	  }, [onCloseClick, isOpen]);
	  var innerContainerRef = noWindow || typeof window === 'undefined' ? undefined : React.useRef(document.body);
	  var ctxValue = React.useMemo(function () {
	    return {
	      getContainer: function getContainer() {
	        return innerContainerRef == null ? void 0 : innerContainerRef.current;
	      }
	    };
	  }, []);
	  return /*#__PURE__*/React__default['default'].createElement(Div, null, isOpen && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$P.modalDialog,
	    "aria-modal": "true"
	  }, /*#__PURE__*/React__default['default'].createElement(focusTrapReact, null, /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$P.modalDialog_focustrap_inner_container
	  }, /*#__PURE__*/React__default['default'].createElement(Backdrop, {
	    isVisible: true,
	    onCloseClick: onCloseClick
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$P.modalDialog_hiddenFocus,
	    tabIndex: 0
	  }), /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({}, props, {
	    className: props.className ? props.className + ' ' + styles$P.modalDialog_container : styles$P.modalDialog_container
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    borderRadius: {
	      size: 'lg'
	    },
	    boxShadow: "lg",
	    padding: {
	      bottom: 'md'
	    },
	    refElement: innerContainerRef,
	    className: [styles$P.modalDialog_inner_container, (_ref2 = {}, _ref2[styles$P.modalDialog_inner_container_lg] = size == 'lg', _ref2)]
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: styles$P.modalDialog_header_section,
	    spaceBetween: true,
	    occupyVerticalSpace: false,
	    padding: {
	      right: 'sm',
	      top: 'sm'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$P.header,
	    padding: {
	      horizontal: 'lg',
	      bottom: 'lg',
	      top: 'sm'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement("header", null, /*#__PURE__*/React__default['default'].createElement(Typography, {
	    font: "teliasans",
	    fontWeight: "medium",
	    tagName: "h2",
	    color: "black",
	    className: styles$P.modalDialog_title
	  }, title))), /*#__PURE__*/React__default['default'].createElement(Breakpoint, {
	    narrowerThan: 'md'
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    onClick: onCloseClick,
	    "area-label": closeIconAreaLabel,
	    onKeyPress: function onKeyPress(e) {
	      e.key === 'Enter' && onCloseClick && onCloseClick();
	    },
	    tabIndex: 0,
	    clickableAppearance: true,
	    className: styles$P.modalDialog_container_icon,
	    name: "close",
	    size: "sm",
	    color: "gray500"
	  })), /*#__PURE__*/React__default['default'].createElement(Breakpoint, {
	    widerThan: 'md'
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    onClick: onCloseClick,
	    onKeyPress: function onKeyPress(e) {
	      e.key === 'Enter' && onCloseClick && onCloseClick();
	    },
	    tabIndex: 0,
	    clickableAppearance: true,
	    className: ['modalDialog-icon-mobile-test', styles$P.modalDialog_container_icon],
	    hoverColor: "purple500",
	    name: "close",
	    size: "md",
	    color: "gray500"
	  }))), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$P.modalDialog_content_section
	  }, children && /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      horizontal: 'lg',
	      bottom: 'sm'
	    },
	    className: styles$P.modalDialog_container_content,
	    color: "black"
	  }, /*#__PURE__*/React__default['default'].createElement(ContainerContext.Provider, {
	    value: ctxValue
	  }, children))), (closeButtonText || acceptButtonText) && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$P.modalDialog_footer_section
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    padding: {
	      top: 'md',
	      horizontal: 'lg'
	    },
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    },
	    alignRight: true,
	    centeredVertically: true
	  }, closeButtonText && /*#__PURE__*/React__default['default'].createElement(Button, {
	    className: closeButtonClassName,
	    variant: "text",
	    onClick: onCloseClick,
	    disabled: closeButtonDisabled,
	    size: "lg"
	  }, closeButtonText), acceptButtonText && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  }), /*#__PURE__*/React__default['default'].createElement(Button, {
	    className: acceptButtonClassName,
	    size: "sm",
	    onClick: onAcceptClick,
	    variant: destructive ? 'destructive' : 'primary',
	    disabled: acceptButtonDisabled
	  }, acceptButtonText))), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    padding: {
	      top: 'md',
	      horizontal: 'md'
	    },
	    responsiveHidden: {
	      widerThan: 'xs'
	    },
	    directionColumn: true
	  }, acceptButtonText && /*#__PURE__*/React__default['default'].createElement(Button, {
	    className: acceptButtonClassName,
	    size: "sm",
	    onClick: onAcceptClick,
	    variant: destructive ? 'destructive' : 'primary',
	    disabled: acceptButtonDisabled
	  }, acceptButtonText), closeButtonText && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "sm"
	  }), /*#__PURE__*/React__default['default'].createElement(Button, {
	    className: closeButtonClassName,
	    variant: "text",
	    onClick: onCloseClick,
	    disabled: closeButtonDisabled,
	    size: "lg"
	  }, closeButtonText))))))))));
	};

	var supportedModalSizes = ['md', 'lg'];

	var _React$createContext = /*#__PURE__*/React__default['default'].createContext({}),
	    PanelTransparencyContextProvider = _React$createContext.Provider,
	    PanelTransparencyContextConsumer = _React$createContext.Consumer;

	var _excluded$T = ["className", "padding", "separateWithBorder", "children"];
	var paddingForTransparentPanel = {
	  horizontal: 'md',
	  vertical: 'zero'
	};
	var defaultPadding = {
	  size: 'md'
	};

	var PanelContent = function PanelContent(_ref) {
	  var className = _ref.className,
	      explicitPadding = _ref.padding,
	      _ref$separateWithBord = _ref.separateWithBorder,
	      separateWithBorder = _ref$separateWithBord === void 0 ? false : _ref$separateWithBord,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$T);

	  return /*#__PURE__*/React__default['default'].createElement(PanelTransparencyContextConsumer, null, function (_ref2) {
	    var _ref3;

	    var panelIsTransparent = _ref2.panelIsTransparent;
	    var padding = explicitPadding || panelIsTransparent && paddingForTransparentPanel || defaultPadding;
	    return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	      className: [className, (_ref3 = {}, _ref3[styles$D.marginSpace_panel__separateWithBorder] = separateWithBorder, _ref3)],
	      padding: padding
	    }, props), children);
	  });
	};

	var _excluded$U = ["className", "padding", "children"];

	var PanelFooter = function PanelFooter(_ref) {
	  var className = _ref.className,
	      _ref$padding = _ref.padding,
	      padding = _ref$padding === void 0 ? {
	    size: 'md'
	  } : _ref$padding,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$U);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: [styles$D.marginSpace_panel_footer, className],
	    padding: padding,
	    backgroundColor: "gray100"
	  }, props), children);
	};

	var _excluded$V = ["children", "transparent", "backgroundColor", "showOverflow", "className", "tagName"];

	var Panel = function Panel(_ref) {
	  var children = _ref.children,
	      transparent = _ref.transparent,
	      _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === void 0 ? transparent ? 'transparent' : 'white' : _ref$backgroundColor,
	      _ref$showOverflow = _ref.showOverflow,
	      showOverflow = _ref$showOverflow === void 0 ? false : _ref$showOverflow,
	      className = _ref.className,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$V);

	  return /*#__PURE__*/React__default['default'].createElement(PanelTransparencyContextProvider, {
	    value: {
	      panelIsTransparent: transparent
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: tagName,
	    backgroundColor: backgroundColor,
	    className: [styles$D.marginSpace_panel, className],
	    boxShadow: !transparent ? 'sm' : 'zero',
	    hideOverflow: !showOverflow,
	    showOverflow: showOverflow
	  }, props), children));
	};

	Panel.Content = PanelContent;
	Panel.Footer = PanelFooter;

	var styles$S = {"pageRow":"telia-react-pageRow"};

	var _excluded$W = ["children", "className", "margin", "responsiveFullWidth", "narrow", "hasPanel"];

	var PageRow = function PageRow(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      _ref$margin = _ref.margin,
	      margin = _ref$margin === void 0 ? {
	    bottom: 'lg'
	  } : _ref$margin,
	      responsiveFullWidth = _ref.responsiveFullWidth,
	      narrow = _ref.narrow,
	      _ref$hasPanel = _ref.hasPanel,
	      hasPanel = _ref$hasPanel === void 0 ? responsiveFullWidth && narrow : _ref$hasPanel,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$W);

	  return /*#__PURE__*/React__default['default'].createElement(MarginSpace, _extends_1({
	    className: [styles$S.pageRow, className],
	    margin: margin,
	    noPaddingForSmallerThanSm: responsiveFullWidth,
	    narrow: narrow
	  }, props), narrow && !hasPanel ? /*#__PURE__*/React__default['default'].createElement(Panel, {
	    transparent: true
	  }, /*#__PURE__*/React__default['default'].createElement(Panel.Content, null, children)) : children);
	};

	var _excluded$X = ["children", "narrow", "tagName"];

	var PageHeadline = function PageHeadline(_ref) {
	  var children = _ref.children,
	      narrow = _ref.narrow,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'h1' : _ref$tagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$X);

	  return /*#__PURE__*/React__default['default'].createElement(PageRow, {
	    narrow: narrow,
	    margin: false,
	    responsiveFullWidth: narrow,
	    hasPanel: false
	  }, /*#__PURE__*/React__default['default'].createElement(Headline, _extends_1({
	    tagName: tagName,
	    size: "lg"
	  }, props), children));
	};

	var styles$T = {"ingress__size_lg":"telia-react-ingress__size_lg","ingress__size_md":"telia-react-ingress__size_md","ingress__size_sm":"telia-react-ingress__size_sm"};

	var _excluded$Y = ["tagName", "size", "color", "className", "fontWeight", "children"];

	function Ingress(_ref) {
	  var tagName = _ref.tagName,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'lg' : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'gray500' : _ref$color,
	      className = _ref.className,
	      _ref$fontWeight = _ref.fontWeight,
	      fontWeight = _ref$fontWeight === void 0 ? 'medium' : _ref$fontWeight,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$Y);

	  var classNames = [styles$T["ingress__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({}, props, {
	    tagName: tagName // this circumvents some weird ts problem
	    ,
	    font: "teliasans",
	    uppercase: false,
	    color: color,
	    className: classNames,
	    fontWeight: fontWeight
	  }), children);
	}

	var supportedIngressSizes = ['lg', 'md', 'sm'];
	var supportedIngressColors = ['gray400', 'gray500', 'gray800'];

	var _excluded$Z = ["children", "narrow"];

	var PageIngress = function PageIngress(_ref) {
	  var children = _ref.children,
	      narrow = _ref.narrow,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$Z);

	  return /*#__PURE__*/React__default['default'].createElement(PageRow, {
	    narrow: narrow,
	    margin: false,
	    responsiveFullWidth: narrow,
	    hasPanel: false
	  }, /*#__PURE__*/React__default['default'].createElement(Ingress, _extends_1({
	    margin: {
	      bottom: 'sm'
	    }
	  }, props), children));
	};

	var _excluded$_ = ["children", "narrow"];

	var PageTitle = function PageTitle(_ref) {
	  var children = _ref.children,
	      narrow = _ref.narrow,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$_);

	  return /*#__PURE__*/React__default['default'].createElement(MarginSpace, {
	    narrow: narrow,
	    noPaddingForSmallerThanSm: narrow
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      horizontal: narrow ? 'md' : 'zero'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Title, _extends_1({
	    tagName: "h2",
	    size: "sm"
	  }, props), children)));
	};

	var _excluded$$ = ["children", "tagName"];

	var Page = function Page(_ref) {
	  var children = _ref.children,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$$);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: tagName,
	    occupyVerticalSpace: true
	  }, props), children);
	};

	Page.Headline = PageHeadline;
	Page.Title = PageTitle;
	Page.Ingress = PageIngress;
	Page.Row = PageRow;

	var ItemsPerPage = function ItemsPerPage(_ref) {
	  var setNumberOfItems = _ref.setNumberOfItems,
	      numberOfItemsEachPage = _ref.numberOfItemsEachPage,
	      _ref$numberOfItemsEac = _ref.numberOfItemsEachPageOptions,
	      numberOfItemsEachPageOptions = _ref$numberOfItemsEac === void 0 ? [] : _ref$numberOfItemsEac,
	      _ref$showText = _ref.showText,
	      showText = _ref$showText === void 0 ? 'Show' : _ref$showText,
	      _ref$padding = _ref.padding,
	      padding = _ref$padding === void 0 ? {
	    size: 'sm'
	  } : _ref$padding,
	      _ref$block = _ref.block,
	      block = _ref$block === void 0 ? true : _ref$block,
	      _ref$flexItem = _ref.flexItem,
	      flexItem = _ref$flexItem === void 0 ? true : _ref$flexItem,
	      _ref$primaryColor = _ref.primaryColor,
	      primaryColor = _ref$primaryColor === void 0 ? 'purple500' : _ref$primaryColor,
	      _ref$secondaryColor = _ref.secondaryColor,
	      secondaryColor = _ref$secondaryColor === void 0 ? 'black' : _ref$secondaryColor;
	  return /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    block: block,
	    flexItem: flexItem
	  }, showText, map$3(numberOfItemsEachPageOptions).call(numberOfItemsEachPageOptions, function (option, index) {
	    return /*#__PURE__*/React__default['default'].createElement(Button, {
	      style: {
	        paddingTop: 0,
	        paddingBottom: 0
	      },
	      variant: "text",
	      key: "option-" + index,
	      id: "show-" + option,
	      size: "lg",
	      padding: padding,
	      textVariantProps: {
	        color: option === numberOfItemsEachPage ? secondaryColor : primaryColor,
	        fontWeight: 'bold',
	        hoverColor: option === numberOfItemsEachPage ? primaryColor : secondaryColor
	      },
	      onClick: function onClick() {
	        return setNumberOfItems(option);
	      }
	    }, option);
	  }));
	};

	var _excluded$10 = ["number", "active", "onClick"];

	var PageNumber = function PageNumber(_ref) {
	  var number = _ref.number,
	      active = _ref.active,
	      _onClick = _ref.onClick,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$10);

	  return /*#__PURE__*/React__default['default'].createElement(Button, _extends_1({
	    style: {
	      border: 'none'
	    },
	    size: "xl",
	    textVariantProps: {
	      color: 'purple500',
	      hoverColor: 'black',
	      fontWeight: 'bold'
	    },
	    padding: {
	      horizontal: 'sm'
	    },
	    block: true,
	    disabled: !active,
	    onClick: function onClick() {
	      return _onClick && _onClick(number);
	    },
	    variant: "text"
	  }, props), number);
	};

	var _excluded$11 = ["goToPageNumber", "goToNextPage", "goToPreviousPage", "leftArrowPageNumber", "firstPage", "showLeftEllipsis", "currentPageAndAdjacentPages", "showRightEllipsis", "lastPage", "rightArrowPageNumber", "tagName"];

	var PageSelector = function PageSelector(_ref) {
	  var goToPageNumber = _ref.goToPageNumber,
	      goToNextPage = _ref.goToNextPage,
	      goToPreviousPage = _ref.goToPreviousPage,
	      leftArrowPageNumber = _ref.leftArrowPageNumber,
	      firstPage = _ref.firstPage,
	      showLeftEllipsis = _ref.showLeftEllipsis,
	      _ref$currentPageAndAd = _ref.currentPageAndAdjacentPages,
	      currentPageAndAdjacentPages = _ref$currentPageAndAd === void 0 ? [] : _ref$currentPageAndAd,
	      showRightEllipsis = _ref.showRightEllipsis,
	      lastPage = _ref.lastPage,
	      rightArrowPageNumber = _ref.rightArrowPageNumber,
	      _ref$tagName = _ref.tagName,
	      tagName = _ref$tagName === void 0 ? 'nav' : _ref$tagName,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$11);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: tagName,
	    flexItem: true
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, _extends_1({
	    tagName: "ul",
	    role: "list",
	    style: {
	      listStyle: 'none'
	    },
	    centeredVertically: true,
	    flexItem: true,
	    color: "purple500"
	  }, props), leftArrowPageNumber && /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "li",
	    key: "left-arrow-page-number"
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    clickableAppearance: true,
	    style: {
	      backgroundColor: 'transparent',
	      verticalAlign: 'middle'
	    },
	    onClick: goToPreviousPage //Our icon supports tagName, however onClick doesn't mutate with it
	    ,
	    size: "sm",
	    tagName: "button",
	    name: "chevron-left",
	    color: "purple500",
	    hoverColor: "black"
	  })), firstPage && /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "li"
	  }, /*#__PURE__*/React__default['default'].createElement(PageNumber, {
	    id: "first-page-button",
	    number: firstPage,
	    active: !!firstPage,
	    onClick: goToPageNumber
	  })), showLeftEllipsis && /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "li",
	    key: "left-ellipsis"
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    "aria-hidden": "true",
	    padding: {
	      horizontal: 'sm'
	    },
	    color: "black"
	  }, "...")), map$3(currentPageAndAdjacentPages).call(currentPageAndAdjacentPages, function (_ref2, key) {
	    var pageNumber = _ref2.pageNumber,
	        clickable = _ref2.clickable;
	    return /*#__PURE__*/React__default['default'].createElement(Element$2, {
	      tagName: "li",
	      key: key
	    }, /*#__PURE__*/React__default['default'].createElement(PageNumber, {
	      number: pageNumber,
	      active: clickable,
	      id: "page-" + pageNumber + "-button",
	      onClick: goToPageNumber
	    }));
	  }), showRightEllipsis && /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      horizontal: 'sm'
	    }
	  }, "..."), lastPage && /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "li"
	  }, /*#__PURE__*/React__default['default'].createElement(PageNumber, {
	    id: "last-page-button",
	    number: lastPage,
	    active: !!lastPage,
	    onClick: goToPageNumber
	  })), rightArrowPageNumber && /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "li",
	    key: "right-arrow-page-number"
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    clickableAppearance: true,
	    style: {
	      backgroundColor: 'white',
	      verticalAlign: 'middle'
	    },
	    onClick: goToNextPage //Our icon supports tagName, however onClick doesn't mutate with it
	    ,
	    size: "sm",
	    tagName: "button",
	    name: "chevron-right",
	    color: "purple500",
	    hoverColor: "black"
	  }))));
	};

	var _excluded$12 = ["children"];

	var Pagination = function Pagination(_ref) {
	  var children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$12);

	  return /*#__PURE__*/React__default['default'].createElement(Flex, props, children);
	};

	Pagination.ItemsPerPage = ItemsPerPage;
	Pagination.PageSelector = PageSelector;

	var styles$U = {"textArea":"telia-react-textArea","textArea__container":"telia-react-textArea__container","textArea__container_error":"telia-react-textArea__container_error","textArea__container_disabled":"telia-react-textArea__container_disabled","textArea__container_required":"telia-react-textArea__container_required"};

	var _excluded$13 = ["label", "value", "onChange", "placeholder", "disabled", "required", "errorText", "helperText", "readonly", "id", "name", "className"];

	var TextArea = function TextArea(_ref) {
	  var label = _ref.label,
	      value = _ref.value,
	      _onChange = _ref.onChange,
	      placeholder = _ref.placeholder,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      errorText = _ref.errorText,
	      helperText = _ref.helperText,
	      readonly = _ref.readonly,
	      id = _ref.id,
	      name = _ref.name,
	      className = _ref.className,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$13);

	  var inputElement = React.useRef(null);
	  var classNames = [styles$U.textArea__container];

	  if (!!errorText) {
	    classNames.push(styles$U.textArea__container_error);
	  }

	  if (!!disabled) {
	    classNames.push(styles$U.textArea__container_disabled);
	  }

	  if (!!className) {
	    classNames.push(className);
	  }

	  var resolveLabel = required ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Span, null, label, " "), /*#__PURE__*/React__default['default'].createElement(Span, {
	    className: styles$U.textArea_required
	  }, "*")) : label;

	  var handleInputFocus = function handleInputFocus() {
	    /* istanbul ignore next */
	    if (inputElement.current !== null) {
	      inputElement.current.focus();
	    }
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$U.textArea
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    block: true,
	    color: disabled ? 'gray400' : 'black'
	  }, resolveLabel), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    occupyVerticalSpace: false,
	    className: classNames,
	    borderRadius: {
	      size: 'sm'
	    },
	    padding: {
	      size: 'sm'
	    },
	    backgroundColor: disabled ? 'gray200' : 'white',
	    onClick: handleInputFocus
	  }, /*#__PURE__*/React__default['default'].createElement("textarea", _extends_1({
	    value: value,
	    placeholder: placeholder,
	    onChange: function onChange(e) {
	      return _onChange == null ? void 0 : _onChange(e, e.target.value);
	    },
	    disabled: disabled,
	    ref: inputElement,
	    id: id,
	    name: name,
	    className: "inner-textarea-test",
	    readOnly: readonly
	  }, props))), !!errorText && errorText !== ' ' && /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: errorText,
	    color: "red600"
	  }), !!helperText && /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: helperText,
	    color: "gray500"
	  }));
	};

	var aPossiblePrototype$1 = function (it) {
	  if (!isObject$2(it) && it !== null) {
	    throw TypeError("Can't set " + String(it) + ' as a prototype');
	  } return it;
	};

	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var objectSetPrototypeOf$1 = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
	    setter.call(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    anObject$1(O);
	    aPossiblePrototype$1(proto);
	    if (CORRECT_SETTER) setter.call(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);

	// makes subclassing work correct for wrapped built-ins
	var inheritIfRequired = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if (
	    // it can work only with native `setPrototypeOf`
	    objectSetPrototypeOf$1 &&
	    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	    typeof (NewTarget = dummy.constructor) == 'function' &&
	    NewTarget !== Wrapper &&
	    isObject$2(NewTargetPrototype = NewTarget.prototype) &&
	    NewTargetPrototype !== Wrapper.prototype
	  ) objectSetPrototypeOf$1($this, NewTargetPrototype);
	  return $this;
	};

	// a string of all valid unicode whitespaces
	// eslint-disable-next-line max-len
	var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var whitespace = '[' + whitespaces + ']';
	var ltrim = RegExp('^' + whitespace + whitespace + '*');
	var rtrim = RegExp(whitespace + whitespace + '*$');

	// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
	var createMethod$7 = function (TYPE) {
	  return function ($this) {
	    var string = String(requireObjectCoercible$1($this));
	    if (TYPE & 1) string = string.replace(ltrim, '');
	    if (TYPE & 2) string = string.replace(rtrim, '');
	    return string;
	  };
	};

	var stringTrim = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod$7(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod$7(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod$7(3)
	};

	var getOwnPropertyNames = objectGetOwnPropertyNames$1.f;
	var getOwnPropertyDescriptor$7 = objectGetOwnPropertyDescriptor$1.f;
	var defineProperty$e = objectDefineProperty$1.f;
	var trim = stringTrim.trim;

	var NUMBER = 'Number';
	var NativeNumber = global$2[NUMBER];
	var NumberPrototype = NativeNumber.prototype;

	// Opera ~12 has broken Object#toString
	var BROKEN_CLASSOF = classofRaw$1(objectCreate$2(NumberPrototype)) == NUMBER;

	// `ToNumber` abstract operation
	// https://tc39.es/ecma262/#sec-tonumber
	var toNumber$1 = function (argument) {
	  var it = toPrimitive$1(argument, false);
	  var first, third, radix, maxCode, digits, length, index, code;
	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = it.charCodeAt(0);
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
	        default: return +it;
	      }
	      digits = it.slice(2);
	      length = digits.length;
	      for (index = 0; index < length; index++) {
	        code = digits.charCodeAt(index);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};

	// `Number` constructor
	// https://tc39.es/ecma262/#sec-number-constructor
	if (isForced_1$1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
	  var NumberWrapper = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var dummy = this;
	    return dummy instanceof NumberWrapper
	      // check on 1..constructor(foo) case
	      && (BROKEN_CLASSOF ? fails$1(function () { NumberPrototype.valueOf.call(dummy); }) : classofRaw$1(dummy) != NUMBER)
	        ? inheritIfRequired(new NativeNumber(toNumber$1(it)), dummy, NumberWrapper) : toNumber$1(it);
	  };
	  for (var keys$f = descriptors$1 ? getOwnPropertyNames(NativeNumber) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES2015 (in case, if modules with ES2015 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
	    // ESNext
	    'fromString,range'
	  ).split(','), j = 0, key; keys$f.length > j; j++) {
	    if (has$2(NativeNumber, key = keys$f[j]) && !has$2(NumberWrapper, key)) {
	      defineProperty$e(NumberWrapper, key, getOwnPropertyDescriptor$7(NativeNumber, key));
	    }
	  }
	  NumberWrapper.prototype = NumberPrototype;
	  NumberPrototype.constructor = NumberWrapper;
	  redefine$1(global$2, NUMBER, NumberWrapper);
	}

	var ComposableTabsContext = /*#__PURE__*/React.createContext({
	  activeTab: undefined,
	  tabsId: 'telia-components-tabs',
	  onActiveTabChange: undefined
	});

	var styles$V = {"tabs_tabsContainer":"telia-react-tabs_tabsContainer","tabs_tabHeading":"telia-react-tabs_tabHeading","tabs_tabHeading__active":"telia-react-tabs_tabHeading__active","tabs_tabContent":"telia-react-tabs_tabContent"};

	var ComposableTabsListContext = /*#__PURE__*/React.createContext({
	  activatedTab: ''
	});
	var reactTo = ['ArrowLeft', 'ArrowRight', 'Home', 'End', 'Home', 'End'];
	/** ComposableTabsList is parent component of ComposableTabsTab that handles keyboard navigation context for tab buttons
	 * It should be rendered inside ComposableTabs component above ComposableTabsPanel
	 * and it should only contain ComposableTabsTab's as children */

	var ComposableTabsList = function ComposableTabsList(_ref) {
	  var className = _ref.className,
	      children = _ref.children;

	  var _useContext = React.useContext(ComposableTabsContext),
	      tabsId = _useContext.tabsId;

	  var ref = React.useRef(null);

	  var _useState = React.useState({
	    activatedTab: ''
	  }),
	      state = _useState[0],
	      setState = _useState[1];

	  var onKeyDown = React.useCallback(function (e) {
	    var _context;

	    if (!includes$6(reactTo).call(reactTo, e.key)) {
	      return;
	    }

	    var element = ref.current;

	    var tabs = concat$5(_context = []).call(_context, element.querySelectorAll("[data-tab-for=\"" + tabsId + "\"]"));

	    var index = indexOf$7(tabs).call(tabs, e.target);

	    var targetIndex;

	    if (e.key === 'ArrowRight') {
	      // next sibling or if this is last then first sibling
	      targetIndex = (index + 1) % tabs.length;
	    } else if (e.key === 'ArrowLeft') {
	      // previous sibling or if this is first then last sibling
	      targetIndex = (index - 1 + tabs.length) % tabs.length;
	    } else if (e.key === 'Home') {
	      // first sibling
	      targetIndex = 0;
	    } else {
	      // 'End' last sibling
	      targetIndex = tabs.length - 1;
	    }

	    var target = tabs[targetIndex];

	    var _target$dataset = target == null ? void 0 : target.dataset,
	        tabKey = _target$dataset.tabKey;

	    setState({
	      activatedTab: tabKey
	    });
	  }, [tabsId, setState]);
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    id: tabsId + "-tab-list",
	    className: classnames(styles$V.tabs_tabsContainer, className),
	    ref: ref,
	    onKeyDown: onKeyDown
	  }, /*#__PURE__*/React__default['default'].createElement(ComposableTabsListContext.Provider, {
	    value: state
	  }, children));
	};

	/** Component that renders single button should be rendered inside ComposableTabList component */
	var ComposableTabsTab = function ComposableTabsTab(_ref) {
	  var _classnames;

	  var tabKey = _ref.tabKey,
	      children = _ref.children;

	  var _useContext = React.useContext(ComposableTabsContext),
	      activeTab = _useContext.activeTab,
	      onActiveTabChange = _useContext.onActiveTabChange,
	      tabsId = _useContext.tabsId;

	  var tabListContext = React.useContext(ComposableTabsListContext);
	  var ref = React.useRef(null);
	  var onClick = React.useCallback(function () {
	    onActiveTabChange == null ? void 0 : onActiveTabChange(tabKey);
	  }, [onActiveTabChange, tabKey]);
	  React.useEffect(function () {
	    if (tabListContext.activatedTab === tabKey) {
	      var _ref$current;

	      onClick();
	      (_ref$current = ref.current) == null ? void 0 : _ref$current.focus();
	    }
	  }, [tabListContext]);
	  var active = activeTab === tabKey;
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    refElement: ref,
	    id: tabsId + "-tab-button-" + tabKey,
	    "data-tab-for": tabsId,
	    "data-tab-key": tabKey,
	    tagName: "button",
	    onClick: onClick,
	    tabIndex: active ? 0 : -1,
	    "aria-selected": active,
	    "aria-controls": tabsId + "-panel",
	    backgroundColor: "transparent",
	    className: classnames((_classnames = {}, _classnames[styles$V.tabs_tabHeading] = true, _classnames[styles$V.tabs_tabHeading__active] = active, _classnames)),
	    margin: {
	      right: 'sm'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Title, {
	    color: active ? 'gray800' : 'gray500',
	    block: true,
	    uppercase: true
	  }, children), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }));
	};

	/** Component that renders active tabs content.
	 * ComposableTabsPanel should be rendered inside ComposableTabs below ComposableTabsList component */

	var ComposableTabsPanel = function ComposableTabsPanel(_ref) {
	  var children = _ref.children;

	  var _useContext = React.useContext(ComposableTabsContext),
	      tabsId = _useContext.tabsId,
	      activeTab = _useContext.activeTab;

	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Divider, null), /*#__PURE__*/React__default['default'].createElement(Div, {
	    id: tabsId + "-panel",
	    tabIndex: 0,
	    className: styles$V.tabs_tabContent,
	    "aria-labelledby": tabsId + "-tab-button-" + activeTab
	  }, children));
	};

	// util for creating unique id's for components (Currently used only by ComposableTabs)
	var ComponentIdProducer = /*#__PURE__*/function () {
	  function ComponentIdProducer() {}

	  ComponentIdProducer.createStaticProducer = function createStaticProducer(_ref) {
	    var _ref$prefix = _ref.prefix,
	        prefix = _ref$prefix === void 0 ? 'telia-component' : _ref$prefix,
	        _ref$testMode = _ref.testMode,
	        testMode = _ref$testMode === void 0 ? ComponentIdProducer.testMode : _ref$testMode;
	    return function createComponentId() {
	      if (testMode) {
	        return prefix + "-" + ComponentIdProducer.numberId;
	      }

	      return prefix + "-" + ComponentIdProducer.numberId++;
	    };
	  } // Only call this method in ComponentIdProducer tests
	  ;

	  ComponentIdProducer.resetStaticProducer = function resetStaticProducer() {
	    ComponentIdProducer.numberId = 0;
	  };

	  return ComponentIdProducer;
	}();
	ComponentIdProducer.numberId = 0;
	ComponentIdProducer.testMode = "" !== undefined;

	var createTabsId = ComponentIdProducer.createStaticProducer({
	  prefix: 'telia-components-tabs'
	});
	/** ComposableTabs is context provider for ComposableTabsList, ComposableTabsTab and ComposableTabsPanel component */

	var ComposableTabs = function ComposableTabs(_ref) {
	  var children = _ref.children,
	      activeTab = _ref.activeTab,
	      onActiveTabChange = _ref.onActiveTabChange;
	  var tabsId = React.useMemo(createTabsId, []);
	  var ctxValue = React.useMemo(function () {
	    return {
	      tabsId: tabsId,
	      activeTab: activeTab,
	      onActiveTabChange: onActiveTabChange
	    };
	  }, [tabsId, onActiveTabChange, activeTab]);
	  return /*#__PURE__*/React__default['default'].createElement(ComposableTabsContext.Provider, {
	    value: ctxValue
	  }, children);
	};

	ComposableTabs.List = ComposableTabsList;
	ComposableTabs.Tab = ComposableTabsTab;
	ComposableTabs.Panel = ComposableTabsPanel;

	function extractStateFromInitiator(initiator, prevState) {
	  if (initiator instanceof Function) {
	    return initiator(prevState);
	  }

	  return initiator;
	}
	/*
	This hook is combines reduce, useMemo and useState logic, and it is primarily meant to be used when state is derived props or some other state.
	- When deps list is empty list: This hooks works 100% same as normal useState hook
	- When deps list changes, state is redefined just like with useMemo, but previous state is passed to it as argument,
	during initialization this argument is undefined
	*/


	function useDerivedState(initialState, deps) {
	  var _useState = React.useState({
	    wrapper: undefined
	  }),
	      state = _useState[0],
	      setState = _useState[1];

	  var stateRef = React.useRef();
	  React.useMemo(function () {
	    stateRef.current = state.wrapper; // this will actually be undefined on first render
	  }, [state]);
	  React.useMemo(function () {
	    stateRef.current = extractStateFromInitiator(initialState, stateRef.current);
	  }, deps);
	  var handleSetState = React.useCallback(function (nextState) {
	    var nextStateValue = extractStateFromInitiator(nextState, stateRef.current);

	    if (nextStateValue === stateRef.current) {
	      // No need to update because state is up to date
	      return;
	    }
	    /* Reacts setState does not update state if previous state is same as nextState
	     * This is why state is wrapper inside object to force component to update */


	    setState({
	      wrapper: nextStateValue
	    });
	  }, [setState]);
	  return [stateRef.current, handleSetState];
	}

	var Tabs = function Tabs(props) {
	  var _tabs$internalActiveT, _tabs$internalActiveT2;

	  var tabs = props.tabs,
	      _props$defaultActiveT = props.defaultActiveTabIndex,
	      defaultActiveTabIndex = _props$defaultActiveT === void 0 ? 0 : _props$defaultActiveT,
	      activeTabIndex = props.activeTabIndex,
	      onActiveTabIndexChange = props.onActiveTabIndexChange;
	  /* initially and when props.activeTabIndex changes this resets state */

	  var _useDerivedState = useDerivedState(activeTabIndex != null ? activeTabIndex : defaultActiveTabIndex, [activeTabIndex]),
	      internalActiveTab = _useDerivedState[0],
	      setInternalActiveTab = _useDerivedState[1];

	  var handleActiveTabChange = React.useCallback(function (tab) {
	    if (onActiveTabIndexChange) {
	      onActiveTabIndexChange(Number(tab));
	    } else {
	      setInternalActiveTab(Number(tab));
	    }
	  }, [setInternalActiveTab, onActiveTabIndexChange]);
	  return /*#__PURE__*/React__default['default'].createElement(ComposableTabs, {
	    onActiveTabChange: handleActiveTabChange,
	    activeTab: "" + internalActiveTab
	  }, /*#__PURE__*/React__default['default'].createElement(ComposableTabsList, null, map$3(tabs).call(tabs, function (item, index) {
	    return /*#__PURE__*/React__default['default'].createElement(ComposableTabsTab, {
	      key: "tab-" + index,
	      tabKey: "" + index
	    }, item.tabTitle);
	  })), /*#__PURE__*/React__default['default'].createElement(ComposableTabs.Panel, null, (_tabs$internalActiveT = (_tabs$internalActiveT2 = tabs[internalActiveTab]) == null ? void 0 : _tabs$internalActiveT2.content) != null ? _tabs$internalActiveT : null));
	};

	var floor$2 = Math.floor;

	var mergeSort = function (array, comparefn) {
	  var length = array.length;
	  var middle = floor$2(length / 2);
	  return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice(array, 0, middle), comparefn), mergeSort(arraySlice(array, middle), comparefn), comparefn);
	};

	var insertionSort = function (array, comparefn) {
	  var length = array.length;
	  var i = 1;
	  var element, j;

	  while (i < length) {
	    j = i;
	    element = array[i];

	    while (j && comparefn(array[j - 1], element) > 0) {
	      array[j] = array[--j];
	    }

	    if (j !== i++) array[j] = element;
	  }

	  return array;
	};

	var merge = function (array, left, right, comparefn) {
	  var llength = left.length;
	  var rlength = right.length;
	  var lindex = 0;
	  var rindex = 0;

	  while (lindex < llength || rindex < rlength) {
	    array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
	  }

	  return array;
	};

	var arraySort = mergeSort;

	var firefox = engineUserAgent.match(/firefox\/(\d+)/i);
	var engineFfVersion = !!firefox && +firefox[1];

	var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

	var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);
	var engineWebkitVersion = !!webkit && +webkit[1];

	var test$3 = [];
	var un$Sort = functionUncurryThis(test$3.sort);
	var push$6 = functionUncurryThis(test$3.push); // IE8-

	var FAILS_ON_UNDEFINED = fails(function () {
	  test$3.sort(undefined);
	}); // V8 bug

	var FAILS_ON_NULL = fails(function () {
	  test$3.sort(null);
	}); // Old WebKit

	var STRICT_METHOD$4 = arrayMethodIsStrict('sort');
	var STABLE_SORT = !fails(function () {
	  // feature detection can be too slow, so check engines versions
	  if (engineV8Version) return engineV8Version < 70;
	  if (engineFfVersion && engineFfVersion > 3) return;
	  if (engineIsIeOrEdge) return true;
	  if (engineWebkitVersion) return engineWebkitVersion < 603;
	  var result = '';
	  var code, chr, value, index; // generate an array with more 512 elements (Chakra and old V8 fails only in this case)

	  for (code = 65; code < 76; code++) {
	    chr = String.fromCharCode(code);

	    switch (code) {
	      case 66:
	      case 69:
	      case 70:
	      case 72:
	        value = 3;
	        break;

	      case 68:
	      case 71:
	        value = 4;
	        break;

	      default:
	        value = 2;
	    }

	    for (index = 0; index < 47; index++) {
	      test$3.push({
	        k: chr + index,
	        v: value
	      });
	    }
	  }

	  test$3.sort(function (a, b) {
	    return b.v - a.v;
	  });

	  for (index = 0; index < test$3.length; index++) {
	    chr = test$3[index].k.charAt(0);
	    if (result.charAt(result.length - 1) !== chr) result += chr;
	  }

	  return result !== 'DGBEFHACIJK';
	});
	var FORCED$3 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$4 || !STABLE_SORT;

	var getSortCompare = function (comparefn) {
	  return function (x, y) {
	    if (y === undefined) return -1;
	    if (x === undefined) return 1;
	    if (comparefn !== undefined) return +comparefn(x, y) || 0;
	    return toString$2(x) > toString$2(y) ? 1 : -1;
	  };
	}; // `Array.prototype.sort` method
	// https://tc39.es/ecma262/#sec-array.prototype.sort


	_export({
	  target: 'Array',
	  proto: true,
	  forced: FORCED$3
	}, {
	  sort: function sort(comparefn) {
	    if (comparefn !== undefined) aCallable(comparefn);
	    var array = toObject(this);
	    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);
	    var items = [];
	    var arrayLength = lengthOfArrayLike(array);
	    var itemsLength, index;

	    for (index = 0; index < arrayLength; index++) {
	      if (index in array) push$6(items, array[index]);
	    }

	    arraySort(items, getSortCompare(comparefn));
	    itemsLength = items.length;
	    index = 0;

	    while (index < itemsLength) array[index] = items[index++];

	    while (index < arrayLength) delete array[index++];

	    return array;
	  }
	});

	var sort = entryVirtual('Array').sort;

	var ArrayPrototype$d = Array.prototype;

	var sort$1 = function (it) {
	  var own = it.sort;
	  return it === ArrayPrototype$d || objectIsPrototypeOf(ArrayPrototype$d, it) && own === ArrayPrototype$d.sort ? sort : own;
	};

	var sort$2 = sort$1;

	var sort$3 = sort$2;

	var styles$W = {"phoneNumberInput":"telia-react-phoneNumberInput","optionlist":"telia-react-optionlist","countryCodeDropDown":"telia-react-countryCodeDropDown","input__container":"telia-react-input__container","phoneNumberInputBox":"telia-react-phoneNumberInputBox"};

	var _excluded$14 = ["onCountryCodeChange", "selectedCountryCode", "onNumberChange", "numberValue", "countryCodes", "placeholder", "disabled", "errorText", "helperText", "label", "required", "addPlusSign"];

	function ownKeys$g(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$3(_context = ownKeys$g(Object(source), true)).call(_context, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context2; forEach$3(_context2 = ownKeys$g(Object(source))).call(_context2, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }

	var PhoneNumberInput = function PhoneNumberInput(_ref) {
	  var onCountryCodeChange = _ref.onCountryCodeChange,
	      selectedCountryCode = _ref.selectedCountryCode,
	      onNumberChange = _ref.onNumberChange,
	      numberValue = _ref.numberValue,
	      countryCodes = _ref.countryCodes,
	      placeholder = _ref.placeholder,
	      disabled = _ref.disabled,
	      errorText = _ref.errorText,
	      helperText = _ref.helperText,
	      label = _ref.label,
	      required = _ref.required,
	      addPlusSign = _ref.addPlusSign,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$14);

	  var countryCodeWithSecondaryLabel = selectedCountryCode ? _objectSpread$b(_objectSpread$b({}, selectedCountryCode), {}, {
	    label: selectedCountryCode.countryName,
	    secondaryLabel: "" + '+'.concat(selectedCountryCode.code)
	  }) : undefined;

	  var _useState = React.useState(countryCodeWithSecondaryLabel),
	      modifiedSelectedCountryCode = _useState[0],
	      setModifiedSelection = _useState[1];

	  var _useState2 = React.useState(countryCodes),
	      originalOptions = _useState2[0],
	      setOriginalOptions = _useState2[1];

	  var modifiedCountryCodes = map$3(countryCodes).call(countryCodes, function (country) {
	    return {
	      value: country.value,
	      label: addPlusSign ? country.countryName + " +" + country.code : country.countryName + " " + country.code
	    };
	  });

	  if (modifiedCountryCodes.length > 1) {
	    sort$3(modifiedCountryCodes).call(modifiedCountryCodes, function (a, b) {
	      return a.label.localeCompare(b.label);
	    });
	  }

	  React.useEffect(function () {
	    setOriginalOptions(countryCodes);
	  }, [countryCodes]);
	  React.useEffect(function () {
	    setModifiedSelection(countryCodeWithSecondaryLabel);
	  }, [selectedCountryCode]);
	  React.useEffect(function () {
	    if (selectedCountryCode) {
	      setModifiedSelection(countryCodeWithSecondaryLabel);
	    }
	  }, []);
	  var resolveLabel = required ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Span, null, label, " "), /*#__PURE__*/React__default['default'].createElement(Span, {
	    className: styles$W.input_required
	  }, "*")) : label;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$W.phoneNumberInput
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    block: true,
	    color: disabled ? 'gray400' : 'black'
	  }, resolveLabel), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    occupyVerticalSpace: false
	  }, /*#__PURE__*/React__default['default'].createElement(Dropdown, {
	    errorText: !!errorText ? ' ' : undefined,
	    disabled: disabled,
	    selectedOption: modifiedSelectedCountryCode,
	    options: modifiedCountryCodes,
	    onChange: function onChange(event, option) {
	      return onCountryCodeChange(event, find$3(originalOptions).call(originalOptions, function (originaloOption) {
	        return originaloOption.value === option.value;
	      }));
	    },
	    className: styles$W.countryCodeDropDown,
	    showCustomLabel: true
	  }), /*#__PURE__*/React__default['default'].createElement(BaseInput, _extends_1({}, props, {
	    iconName: !!errorText ? 'error-filled' : undefined,
	    iconColor: !!errorText ? 'red600' : undefined,
	    errorText: !!errorText ? ' ' : undefined,
	    disabled: disabled,
	    value: numberValue,
	    className: styles$W.phoneNumberInputBox,
	    onChange: onNumberChange,
	    type: "tel",
	    placeholder: placeholder,
	    showCustomLabel: true
	  }))), !!errorText && errorText !== ' ' && /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: errorText,
	    color: "red600"
	  }), helperText ? /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: helperText,
	    color: "gray500"
	  }) : null);
	};

	var styles$X = {"price_gutter":"telia-react-price_gutter","price_sm_prefix":"telia-react-price_sm_prefix","price_sm_value":"telia-react-price_sm_value","price_sm_unit":"telia-react-price_sm_unit","price_sm_oldValue":"telia-react-price_sm_oldValue","price_md_prefix":"telia-react-price_md_prefix","price_md_value":"telia-react-price_md_value","price_md_unit":"telia-react-price_md_unit","price_md_oldValue":"telia-react-price_md_oldValue","price_lg_prefix":"telia-react-price_lg_prefix","price_lg_value":"telia-react-price_lg_value","price_lg_unit":"telia-react-price_lg_unit","price_lg_oldValue":"telia-react-price_lg_oldValue","price_xlg_prefix":"telia-react-price_xlg_prefix","price_xlg_value":"telia-react-price_xlg_value","price_xlg_unit":"telia-react-price_xlg_unit","price_xlg_oldValue":"telia-react-price_xlg_oldValue"};

	var _excluded$15 = ["align", "value", "unit", "unitSpecifier", "oldValue", "description", "prefix", "size", "font"];

	var Price = function Price(_ref) {
	  var _ref$align = _ref.align,
	      align = _ref$align === void 0 ? 'left' : _ref$align,
	      value = _ref.value,
	      _ref$unit = _ref.unit,
	      unit = _ref$unit === void 0 ? '€' : _ref$unit,
	      unitSpecifier = _ref.unitSpecifier,
	      oldValue = _ref.oldValue,
	      description = _ref.description,
	      prefix = _ref.prefix,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      _ref$font = _ref.font,
	      font = _ref$font === void 0 ? 'teliasansHeading' : _ref$font,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$15);

	  var resolvedUnit = unitSpecifier ? unit + "/" + unitSpecifier : unit;
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({}, props, {
	    alignTextToRight: align === 'right',
	    alignTextToCenter: align === 'center'
	  }), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    alignBottom: true,
	    alignRight: align === 'right',
	    centeredHorizontally: align === 'center'
	  }, /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    alignBaseline: true
	  }, prefix && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Typography, {
	    font: font,
	    fontWeight: font === 'teliasans' ? 'bold' : 'normal',
	    uppercase: true,
	    color: "black",
	    className: styles$X["price_" + size + "_prefix"]
	  }, prefix), font === 'teliasans' && size === 'xlg' ? /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    className: styles$X.price_gutter
	  }) : /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xxs"
	  })), /*#__PURE__*/React__default['default'].createElement(Typography, {
	    font: font,
	    fontWeight: font === 'teliasans' ? 'bold' : 'normal',
	    uppercase: true,
	    color: "black",
	    className: styles$X["price_" + size + "_value"]
	  }, value), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xxs"
	  }), /*#__PURE__*/React__default['default'].createElement(Typography, {
	    font: font,
	    fontWeight: font === 'teliasans' ? 'bold' : 'normal',
	    color: "black",
	    uppercase: true,
	    className: styles$X["price_" + size + "_unit"]
	  }, resolvedUnit), oldValue && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    className: styles$X.price_gutter
	  }), /*#__PURE__*/React__default['default'].createElement(Typography, {
	    font: font,
	    fontWeight: font === 'teliasans' ? 'bold' : 'normal',
	    uppercase: true,
	    color: "gray500",
	    strikeThrough: true,
	    className: styles$X["price_" + size + "_oldValue"]
	  }, oldValue))))), typeof description === 'string' ? /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    color: "black"
	  }, description) : description);
	};

	var supportedPriceSizes = ['sm', 'md', 'lg', 'xlg'];

	var styles$Y = {"pricingText__size_lg":"telia-react-pricingText__size_lg","pricingText__size_md":"telia-react-pricingText__size_md","pricingText__size_sm":"telia-react-pricingText__size_sm","pricingText__size_xs":"telia-react-pricingText__size_xs"};

	var _excluded$16 = ["tagName", "size", "className", "children"];

	function PricingText(_ref) {
	  var tagName = _ref.tagName,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'lg' : _ref$size,
	      className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$16);

	  var classNames = [styles$Y["pricingText__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({}, props, {
	    tagName: tagName // this circumvents some weird ts problem
	    ,
	    className: classNames,
	    font: "teliasansHeading",
	    uppercase: true
	  }), children);
	}

	var supportedPricingTextSizes = ['lg', 'md', 'sm', 'xs'];

	var styles$Z = {"quantitySelector":"telia-react-quantitySelector","quantitySelector__disabled":"telia-react-quantitySelector__disabled","quantitySelector_input":"telia-react-quantitySelector_input","quantitySelector_input__disabled":"telia-react-quantitySelector_input__disabled","quantitySelector_number":"telia-react-quantitySelector_number","quantitySelector_button":"telia-react-quantitySelector_button","quantitySelector_button__increase":"telia-react-quantitySelector_button__increase","quantitySelector_button__decrease":"telia-react-quantitySelector_button__decrease"};

	var _excluded$17 = ["minValue", "value", "maxValue", "decrease", "increase", "disabled", "className", "onInputChange", "inputLabel", "decreaseButtonLabel", "increaseButtonLabel"];

	var QuantitySelector = function QuantitySelector(_ref) {
	  var _getClassNames;

	  var _ref$minValue = _ref.minValue,
	      minValue = _ref$minValue === void 0 ? 1 : _ref$minValue,
	      value = _ref.value,
	      maxValue = _ref.maxValue,
	      decrease = _ref.decrease,
	      increase = _ref.increase,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      onInputChange = _ref.onInputChange,
	      inputLabel = _ref.inputLabel,
	      decreaseButtonLabel = _ref.decreaseButtonLabel,
	      increaseButtonLabel = _ref.increaseButtonLabel,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$17);

	  var disabledDecrease;
	  var disabledIncrease;
	  var classNames = classnames(styles$Z.quantitySelector_input, (_getClassNames = {}, _getClassNames[styles$Z.quantitySelector_input__disabled] = disabled, _getClassNames));

	  var handleEmptyInput = function handleEmptyInput(e) {
	    if (isNaN(e.target.valueAsNumber)) {
	      onInputChange && onInputChange(e, minValue);
	    }
	  };

	  var handleInput = function handleInput(e) {
	    var inputValue = e.target.valueAsNumber;

	    if (maxValue) {
	      /* istanbul ignore else */
	      if (inputValue > maxValue) {
	        inputValue = maxValue;
	      }
	    }

	    if (inputValue < minValue) {
	      inputValue = minValue;
	    }

	    onInputChange && onInputChange(e, inputValue);
	  };

	  if (minValue === 0) {
	    disabledDecrease = value === 0 ? styles$Z.quantitySelector__disabled : '';
	  } else {
	    disabledDecrease = value === 1 ? styles$Z.quantitySelector__disabled : '';
	  }

	  if (maxValue) {
	    disabledIncrease = value === maxValue ? styles$Z.quantitySelector__disabled : '';
	  }

	  if (minValue) {
	    disabledDecrease = value === minValue ? styles$Z.quantitySelector__disabled : '';
	  }

	  if (disabled) {
	    disabledIncrease = styles$Z.quantitySelector__disabled;
	    disabledDecrease = styles$Z.quantitySelector__disabled;
	  }

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    hideOverflow: true,
	    className: [styles$Z.quantitySelector, className]
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    spaceBetween: true,
	    centered: true
	  }, /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    "aria-label": decreaseButtonLabel,
	    tagName: "button",
	    tabIndex: disabled || disabledDecrease ? -1 : 0,
	    color: disabledDecrease ? 'gray400' : 'black',
	    padding: {
	      vertical: 'xs'
	    },
	    clickableAppearance: true,
	    backgroundColor: disabledDecrease ? 'gray200' : 'white',
	    onClick: disabledDecrease ? function () {} : decrease,
	    className: ['decrease-quantity-test', disabledDecrease, styles$Z.quantitySelector_button, styles$Z.quantitySelector_button__decrease]
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "minus",
	    size: "sm",
	    color: "inherit"
	  })), /*#__PURE__*/React__default['default'].createElement("input", {
	    "aria-label": inputLabel,
	    className: classNames,
	    readOnly: !onInputChange,
	    disabled: disabled || !onInputChange,
	    value: value,
	    name: "value",
	    type: "number",
	    onChange: handleInput,
	    onBlur: handleEmptyInput
	  }), /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    "aria-label": increaseButtonLabel,
	    tagName: "button",
	    tabIndex: disabled || disabledIncrease ? -1 : 0,
	    color: disabledIncrease ? 'gray400' : 'black',
	    padding: {
	      vertical: 'xs'
	    },
	    clickableAppearance: true,
	    backgroundColor: disabledIncrease ? 'gray200' : 'white',
	    onClick: disabledIncrease ? function () {} : increase,
	    className: ['increase-quantity-test', disabledIncrease, styles$Z.quantitySelector_button, styles$Z.quantitySelector_button__increase]
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "plus",
	    size: "sm",
	    color: "inherit"
	  }))));
	};

	var styles$_ = {"radioButton":"telia-react-radioButton","radioButton__disabled":"telia-react-radioButton__disabled","radioButton_fakeButton__unchecked":"telia-react-radioButton_fakeButton__unchecked","radioButton_fakeButton__error":"telia-react-radioButton_fakeButton__error","radioButton_hiddenButton":"telia-react-radioButton_hiddenButton","radioButton_fakeButton":"telia-react-radioButton_fakeButton","radioButton_fakeButton__checked":"telia-react-radioButton_fakeButton__checked","radioButton_fakeButton__disabled":"telia-react-radioButton_fakeButton__disabled","radioButton_fakeButtonIcon":"telia-react-radioButton_fakeButtonIcon","radioButton_description":"telia-react-radioButton_description"};

	var _excluded$18 = ["value", "checked", "onChange", "label", "description", "error", "name", "readOnly", "disabled", "className", "centeredHorizontally"];

	var RadioButton = function RadioButton(_ref) {
	  var _ref2, _ref3;

	  var value = _ref.value,
	      checked = _ref.checked,
	      _onChange = _ref.onChange,
	      label = _ref.label,
	      description = _ref.description,
	      error = _ref.error,
	      name = _ref.name,
	      readOnly = _ref.readOnly,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      centeredHorizontally = _ref.centeredHorizontally,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$18);

	  var disabledOrReadOnly = readOnly || disabled;
	  var classNames = [styles$_.radioButton, (_ref2 = {}, _ref2[styles$_.radioButton__disabled] = disabledOrReadOnly, _ref2), className];
	  var classNamesForHiddenButton = classnames(styles$_.radioButton_hiddenButton, 'radio-button-input-test');

	  var blur = function blur(event) {
	    event.preventDefault();
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "label",
	    className: classNames
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredHorizontally: centeredHorizontally,
	    onMouseDown: blur
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    onMouseDown: blur
	  }, /*#__PURE__*/React__default['default'].createElement("input", {
	    name: name,
	    value: value,
	    type: "radio",
	    onChange: function onChange(event) {
	      !disabledOrReadOnly && _onChange && (_onChange == null ? void 0 : _onChange(event, event.target.checked));
	    },
	    className: classNamesForHiddenButton,
	    checked: checked,
	    readOnly: readOnly,
	    tabIndex: -1,
	    disabled: disabled
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    onMouseDown: blur,
	    className: [styles$_.radioButton_fakeButton, (_ref3 = {}, _ref3[styles$_.radioButton_fakeButton__unchecked] = !checked, _ref3[styles$_.radioButton_fakeButton__checked] = !!checked, _ref3[styles$_.radioButton_fakeButton__error] = !!error, _ref3[styles$_.radioButton_fakeButton__disabled] = disabledOrReadOnly, _ref3)],
	    tabIndex: disabled ? -1 : 0,
	    onKeyPress: function onKeyPress(e) {
	      e.key === 'Enter' && !disabledOrReadOnly && (_onChange == null ? void 0 : _onChange(e, true));
	    },
	    borderRadius: {
	      size: 'rounded'
	    },
	    backgroundColor: disabledOrReadOnly ? 'gray200' : 'white'
	  }, checked && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$_.radioButton_fakeButtonIcon,
	    backgroundColor: disabledOrReadOnly ? 'gray400' : 'purple500',
	    borderRadius: {
	      size: 'rounded'
	    }
	  }))), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement("div", null, label && /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    color: disabledOrReadOnly ? 'gray400' : 'black',
	    block: true
	  }, label), description && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xxs"
	  }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    className: styles$_.radioButton_description,
	    color: error ? 'red600' : disabledOrReadOnly ? 'gray400' : 'gray500',
	    block: true
	  }, description)))));
	};

	/**
	 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
	 *
	 * The decorator may be used on classes or methods
	 * ```
	 * @autobind
	 * class FullBound {}
	 *
	 * class PartBound {
	 *   @autobind
	 *   method () {}
	 * }
	 * ```
	 */

	var lib = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = autobind;

	function autobind() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }

	  if (args.length === 1) {
	    return boundClass.apply(undefined, args);
	  } else {
	    return boundMethod.apply(undefined, args);
	  }
	}
	/**
	 * Use boundMethod to bind all methods on the target.prototype
	 */


	function boundClass(target) {
	  // (Using reflect to get all keys including symbols)
	  var keys = undefined; // Use Reflect if exists

	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    keys = Reflect.ownKeys(target.prototype);
	  } else {
	    keys = Object.getOwnPropertyNames(target.prototype); // use symbols if support is provided

	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
	    }
	  }

	  keys.forEach(function (key) {
	    // Ignore special case target method
	    if (key === 'constructor') {
	      return;
	    }

	    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding

	    if (typeof descriptor.value === 'function') {
	      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
	    }
	  });
	  return target;
	}
	/**
	 * Return a descriptor removing the value and returning a getter
	 * The getter will return a .bind version of the function
	 * and memoize the result against a symbol on the instance
	 */


	function boundMethod(target, key, descriptor) {
	  var fn = descriptor.value;

	  if (typeof fn !== 'function') {
	    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
	  } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
	  // getter for the property which is being replaced. This causes infinite
	  // recursion and an "Out of stack space" error.


	  var definingProperty = false;
	  return {
	    configurable: true,
	    get: function get() {
	      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	        return fn;
	      }

	      var boundFn = fn.bind(this);
	      definingProperty = true;
	      Object.defineProperty(this, key, {
	        value: boundFn,
	        configurable: true,
	        writable: true
	      });
	      definingProperty = false;
	      return boundFn;
	    }
	  };
	}

	module.exports = exports['default'];
	});

	var captialize_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = captialize;
	/**
	 * Captialize a string
	 * @ignore
	 * @param {string} string
	 * @return {string}
	 */

	function captialize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

	module.exports = exports["default"];
	});

	var clamp_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clamp;
	/**
	 * Clamp a value between a min and max value
	 * @ignore
	 * @param {number} value
	 * @param {number} min
	 * @param {number} max
	 * @return {number}
	 */

	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}

	module.exports = exports["default"];
	});

	var distanceTo_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = distanceTo;
	/**
	 * Calculate the distance between pointA and pointB
	 * @ignore
	 * @param {Point} pointA
	 * @param {Point} pointB
	 * @return {number} Distance
	 */

	function distanceTo(pointA, pointB) {
	  var xDiff = Math.pow(pointB.x - pointA.x, 2);
	  var yDiff = Math.pow(pointB.y - pointA.y, 2);
	  return Math.sqrt(xDiff + yDiff);
	}

	module.exports = exports["default"];
	});

	var isDefined_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDefined;
	/**
	 * Check if a value is defined
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */

	function isDefined(value) {
	  return value !== undefined && value !== null;
	}

	module.exports = exports["default"];
	});

	var isNumber_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumber;
	/**
	 * Check if a value is a number
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */

	function isNumber(value) {
	  return typeof value === 'number';
	}

	module.exports = exports['default'];
	});

	var isObject_1$2 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};

	exports.default = isObject;
	/**
	 * Check if a value is an object
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */

	function isObject(value) {
	  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}

	module.exports = exports['default'];
	});

	var length_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = length;
	/**
	 * Calculate the absolute difference between two numbers
	 * @ignore
	 * @param {number} numA
	 * @param {number} numB
	 * @return {number}
	 */

	function length(numA, numB) {
	  return Math.abs(numA - numB);
	}

	module.exports = exports["default"];
	});

	var utils$1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});



	Object.defineProperty(exports, 'captialize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(captialize_1).default;
	  }
	});



	Object.defineProperty(exports, 'clamp', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(clamp_1).default;
	  }
	});



	Object.defineProperty(exports, 'distanceTo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(distanceTo_1).default;
	  }
	});



	Object.defineProperty(exports, 'isDefined', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(isDefined_1).default;
	  }
	});



	Object.defineProperty(exports, 'isNumber', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(isNumber_1).default;
	  }
	});



	Object.defineProperty(exports, 'isObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(isObject_1$2).default;
	  }
	});



	Object.defineProperty(exports, 'length', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(length_1).default;
	  }
	});

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	});

	var _extends$4r = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var getPercentageFromPosition_1 = getPercentageFromPosition;
	var getValueFromPosition_1 = getValueFromPosition;
	var getValueFromProps_1 = getValueFromProps;
	var getPercentageFromValue_1 = getPercentageFromValue;
	var getPercentagesFromValues_1 = getPercentagesFromValues;
	var getPositionFromValue_1 = getPositionFromValue;
	var getPositionsFromValues_1 = getPositionsFromValues;
	var getPositionFromEvent_1 = getPositionFromEvent;
	var getStepValueFromValue_1 = getStepValueFromValue;


	/**
	 * Convert a point into a percentage value
	 * @ignore
	 * @param {Point} position
	 * @param {ClientRect} clientRect
	 * @return {number} Percentage value
	 */


	function getPercentageFromPosition(position, clientRect) {
	  var length = clientRect.width;
	  var sizePerc = position.x / length;
	  return sizePerc || 0;
	}
	/**
	 * Convert a point into a model value
	 * @ignore
	 * @param {Point} position
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {number}
	 */


	function getValueFromPosition(position, minValue, maxValue, clientRect) {
	  var sizePerc = getPercentageFromPosition(position, clientRect);
	  var valueDiff = maxValue - minValue;
	  return minValue + valueDiff * sizePerc;
	}
	/**
	 * Convert props into a range value
	 * @ignore
	 * @param {Object} props
	 * @param {boolean} isMultiValue
	 * @return {Range}
	 */


	function getValueFromProps(props, isMultiValue) {
	  if (isMultiValue) {
	    return _extends$4r({}, props.value);
	  }

	  return {
	    min: props.minValue,
	    max: props.value
	  };
	}
	/**
	 * Convert a model value into a percentage value
	 * @ignore
	 * @param {number} value
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @return {number}
	 */


	function getPercentageFromValue(value, minValue, maxValue) {
	  var validValue = (0, utils$1.clamp)(value, minValue, maxValue);
	  var valueDiff = maxValue - minValue;
	  var valuePerc = (validValue - minValue) / valueDiff;
	  return valuePerc || 0;
	}
	/**
	 * Convert model values into percentage values
	 * @ignore
	 * @param {Range} values
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @return {Range}
	 */


	function getPercentagesFromValues(values, minValue, maxValue) {
	  return {
	    min: getPercentageFromValue(values.min, minValue, maxValue),
	    max: getPercentageFromValue(values.max, minValue, maxValue)
	  };
	}
	/**
	 * Convert a value into a point
	 * @ignore
	 * @param {number} value
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {Point} Position
	 */


	function getPositionFromValue(value, minValue, maxValue, clientRect) {
	  var length = clientRect.width;
	  var valuePerc = getPercentageFromValue(value, minValue, maxValue);
	  var positionValue = valuePerc * length;
	  return {
	    x: positionValue,
	    y: 0
	  };
	}
	/**
	 * Convert a range of values into points
	 * @ignore
	 * @param {Range} values
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {Range}
	 */


	function getPositionsFromValues(values, minValue, maxValue, clientRect) {
	  return {
	    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
	    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
	  };
	}
	/**
	 * Convert an event into a point
	 * @ignore
	 * @param {Event} event
	 * @param {ClientRect} clientRect
	 * @return {Point}
	 */


	function getPositionFromEvent(event, clientRect) {
	  var length = clientRect.width;

	  var _ref = event.touches ? event.touches[0] : event,
	      clientX = _ref.clientX;

	  return {
	    x: (0, utils$1.clamp)(clientX - clientRect.left, 0, length),
	    y: 0
	  };
	}
	/**
	 * Convert a value into a step value
	 * @ignore
	 * @param {number} value
	 * @param {number} valuePerStep
	 * @return {number}
	 */


	function getStepValueFromValue(value, valuePerStep) {
	  return Math.round(value / valuePerStep) * valuePerStep;
	}

	var valueTransformer = /*#__PURE__*/Object.defineProperty({
		getPercentageFromPosition: getPercentageFromPosition_1,
		getValueFromPosition: getValueFromPosition_1,
		getValueFromProps: getValueFromProps_1,
		getPercentageFromValue: getPercentageFromValue_1,
		getPercentagesFromValues: getPercentagesFromValues_1,
		getPositionFromValue: getPositionFromValue_1,
		getPositionsFromValues: getPositionsFromValues_1,
		getPositionFromEvent: getPositionFromEvent_1,
		getStepValueFromValue: getStepValueFromValue_1
	}, '__esModule', {value: true});

	var defaultClassNames = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Default CSS class names
	 * @ignore
	 * @type {InputRangeClassNames}
	 */

	var DEFAULT_CLASS_NAMES = {
	  activeTrack: 'input-range__track input-range__track--active',
	  disabledInputRange: 'input-range input-range--disabled',
	  inputRange: 'input-range',
	  labelContainer: 'input-range__label-container',
	  maxLabel: 'input-range__label input-range__label--max',
	  minLabel: 'input-range__label input-range__label--min',
	  slider: 'input-range__slider',
	  sliderContainer: 'input-range__slider-container',
	  track: 'input-range__track input-range__track--background',
	  valueLabel: 'input-range__label input-range__label--value'
	};
	exports.default = DEFAULT_CLASS_NAMES;
	module.exports = exports['default'];
	});

	var label = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Label;



	var _react2 = _interopRequireDefault(React__default['default']);



	var _propTypes2 = _interopRequireDefault(propTypes);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	/**
	 * @ignore
	 * @param {Object} props
	 * @param {InputRangeClassNames} props.classNames
	 * @param {Function} props.formatLabel
	 * @param {string} props.type
	 */


	function Label(props) {
	  var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;
	  return _react2.default.createElement('span', {
	    className: props.classNames[props.type + 'Label']
	  }, _react2.default.createElement('span', {
	    className: props.classNames.labelContainer
	  }, labelValue));
	}
	/**
	 * @type {Object}
	 * @property {Function} children
	 * @property {Function} classNames
	 * @property {Function} formatLabel
	 * @property {Function} type
	 */


	Label.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	  formatLabel: _propTypes2.default.func,
	  type: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];
	});

	var rangePropType_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rangePropType;


	/**
	 * @ignore
	 * @param {Object} props - React component props
	 * @return {?Error} Return Error if validation fails
	 */


	function rangePropType(props) {
	  var maxValue = props.maxValue,
	      minValue = props.minValue;

	  if (!(0, utils$1.isNumber)(minValue) || !(0, utils$1.isNumber)(maxValue)) {
	    return new Error('"minValue" and "maxValue" must be a number');
	  }

	  if (minValue >= maxValue) {
	    return new Error('"minValue" must be smaller than "maxValue"');
	  }
	}

	module.exports = exports['default'];
	});

	var valuePropType_1 = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = valuePropType;


	/**
	 * @ignore
	 * @param {Object} props
	 * @return {?Error} Return Error if validation fails
	 */


	function valuePropType(props, propName) {
	  var maxValue = props.maxValue,
	      minValue = props.minValue;
	  var value = props[propName];

	  if (!(0, utils$1.isNumber)(value) && (!(0, utils$1.isObject)(value) || !(0, utils$1.isNumber)(value.min) || !(0, utils$1.isNumber)(value.max))) {
	    return new Error('"' + propName + '" must be a number or a range object');
	  }

	  if ((0, utils$1.isNumber)(value) && (value < minValue || value > maxValue)) {
	    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
	  }

	  if ((0, utils$1.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
	    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
	  }
	}

	module.exports = exports['default'];
	});

	var slider = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;

	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var _class;



	var _react2 = _interopRequireDefault(React__default['default']);



	var _propTypes2 = _interopRequireDefault(propTypes);



	var _autobindDecorator2 = _interopRequireDefault(lib);



	var _label2 = _interopRequireDefault(label);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}
	/**
	 * @ignore
	 */


	var Slider = (_class = function (_React$Component) {
	  _inherits(Slider, _React$Component);

	  _createClass(Slider, null, [{
	    key: 'propTypes',

	    /**
	     * Accepted propTypes of Slider
	     * @override
	     * @return {Object}
	     * @property {Function} ariaLabelledby
	     * @property {Function} ariaControls
	     * @property {Function} className
	     * @property {Function} formatLabel
	     * @property {Function} maxValue
	     * @property {Function} minValue
	     * @property {Function} onSliderDrag
	     * @property {Function} onSliderKeyDown
	     * @property {Function} percentage
	     * @property {Function} type
	     * @property {Function} value
	     */
	    get: function get() {
	      return {
	        ariaLabelledby: _propTypes2.default.string,
	        ariaControls: _propTypes2.default.string,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	        formatLabel: _propTypes2.default.func,
	        maxValue: _propTypes2.default.number,
	        minValue: _propTypes2.default.number,
	        onSliderDrag: _propTypes2.default.func.isRequired,
	        onSliderKeyDown: _propTypes2.default.func.isRequired,
	        percentage: _propTypes2.default.number.isRequired,
	        type: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired
	      };
	    }
	    /**
	     * @param {Object} props
	     * @param {string} [props.ariaLabelledby]
	     * @param {string} [props.ariaControls]
	     * @param {InputRangeClassNames} props.classNames
	     * @param {Function} [props.formatLabel]
	     * @param {number} [props.maxValue]
	     * @param {number} [props.minValue]
	     * @param {Function} props.onSliderKeyDown
	     * @param {Function} props.onSliderDrag
	     * @param {number} props.percentage
	     * @param {number} props.type
	     * @param {number} props.value
	     */

	  }]);

	  function Slider(props) {
	    _classCallCheck(this, Slider);
	    /**
	     * @private
	     * @type {?Component}
	     */


	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

	    _this.node = null;
	    return _this;
	  }
	  /**
	   * @ignore
	   * @override
	   * @return {void}
	   */


	  _createClass(Slider, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	      this.removeDocumentTouchEndListener();
	      this.removeDocumentTouchMoveListener();
	    }
	    /**
	     * @private
	     * @return {Object}
	     */

	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var perc = (this.props.percentage || 0) * 100;
	      var style = {
	        position: 'absolute',
	        left: perc + '%'
	      };
	      return style;
	    }
	    /**
	     * Listen to mousemove event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentMouseMoveListener',
	    value: function addDocumentMouseMoveListener() {
	      this.removeDocumentMouseMoveListener();
	      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
	    }
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	    /**
	     * Listen to touchmove event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentTouchMoveListener',
	    value: function addDocumentTouchMoveListener() {
	      this.removeDocumentTouchMoveListener();
	      this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
	    }
	    /**
	     * Listen to touchend event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentTouchEndListener',
	    value: function addDocumentTouchEndListener() {
	      this.removeDocumentTouchEndListener();
	      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentMouseMoveListener',
	    value: function removeDocumentMouseMoveListener() {
	      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentTouchMoveListener',
	    value: function removeDocumentTouchMoveListener() {
	      this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentTouchEndListener',
	    value: function removeDocumentTouchEndListener() {
	      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown() {
	      this.addDocumentMouseMoveListener();
	      this.addDocumentMouseUpListener();
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp() {
	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	    }
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      this.props.onSliderDrag(event, this.props.type);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart() {
	      this.addDocumentTouchEndListener();
	      this.addDocumentTouchMoveListener();
	    }
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleTouchMove',
	    value: function handleTouchMove(event) {
	      this.props.onSliderDrag(event, this.props.type);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd() {
	      this.removeDocumentTouchMoveListener();
	      this.removeDocumentTouchEndListener();
	    }
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      this.props.onSliderKeyDown(event, this.props.type);
	    }
	    /**
	     * @override
	     * @return {JSX.Element}
	     */

	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;

	      var style = this.getStyle();
	      return _react2.default.createElement('span', {
	        className: this.props.classNames.sliderContainer,
	        ref: function ref(node) {
	          _this2.node = node;
	        },
	        style: style
	      }, _react2.default.createElement(_label2.default, {
	        classNames: this.props.classNames,
	        formatLabel: this.props.formatLabel,
	        type: 'value'
	      }, this.props.value), _react2.default.createElement('div', {
	        'aria-labelledby': this.props.ariaLabelledby,
	        'aria-controls': this.props.ariaControls,
	        'aria-valuemax': this.props.maxValue,
	        'aria-valuemin': this.props.minValue,
	        'aria-valuenow': this.props.value,
	        className: this.props.classNames.slider,
	        draggable: 'false',
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleTouchStart,
	        role: 'slider',
	        tabIndex: '0'
	      }));
	    }
	  }]);

	  return Slider;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype)), _class);
	exports.default = Slider;
	module.exports = exports['default'];
	});

	var track = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;

	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var _class;



	var _react2 = _interopRequireDefault(React__default['default']);



	var _propTypes2 = _interopRequireDefault(propTypes);



	var _autobindDecorator2 = _interopRequireDefault(lib);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}
	/**
	 * @ignore
	 */


	var Track = (_class = function (_React$Component) {
	  _inherits(Track, _React$Component);

	  _createClass(Track, null, [{
	    key: 'propTypes',

	    /**
	     * @override
	     * @return {Object}
	     * @property {Function} children
	     * @property {Function} classNames
	     * @property {Boolean} draggableTrack
	     * @property {Function} onTrackDrag
	     * @property {Function} onTrackMouseDown
	     * @property {Function} percentages
	     */
	    get: function get() {
	      return {
	        children: _propTypes2.default.node.isRequired,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	        draggableTrack: _propTypes2.default.bool,
	        onTrackDrag: _propTypes2.default.func,
	        onTrackMouseDown: _propTypes2.default.func.isRequired,
	        percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
	      };
	    }
	    /**
	     * @param {Object} props
	     * @param {InputRangeClassNames} props.classNames
	     * @param {Boolean} props.draggableTrack
	     * @param {Function} props.onTrackDrag
	     * @param {Function} props.onTrackMouseDown
	     * @param {number} props.percentages
	     */

	  }]);

	  function Track(props) {
	    _classCallCheck(this, Track);
	    /**
	     * @private
	     * @type {?Component}
	     */


	    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));

	    _this.node = null;
	    _this.trackDragEvent = null;
	    return _this;
	  }
	  /**
	   * @private
	   * @return {ClientRect}
	   */


	  _createClass(Track, [{
	    key: 'getClientRect',
	    value: function getClientRect() {
	      return this.node.getBoundingClientRect();
	    }
	    /**
	     * @private
	     * @return {Object} CSS styles
	     */

	  }, {
	    key: 'getActiveTrackStyle',
	    value: function getActiveTrackStyle() {
	      var width = (this.props.percentages.max - this.props.percentages.min) * 100 + '%';
	      var left = this.props.percentages.min * 100 + '%';
	      return {
	        left: left,
	        width: width
	      };
	    }
	    /**
	     * Listen to mousemove event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentMouseMoveListener',
	    value: function addDocumentMouseMoveListener() {
	      this.removeDocumentMouseMoveListener();
	      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
	    }
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentMouseMoveListener',
	    value: function removeDocumentMouseMoveListener() {
	      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      if (!this.props.draggableTrack) {
	        return;
	      }

	      if (this.trackDragEvent !== null) {
	        this.props.onTrackDrag(event, this.trackDragEvent);
	      }

	      this.trackDragEvent = event;
	    }
	    /**
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp() {
	      if (!this.props.draggableTrack) {
	        return;
	      }

	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	      this.trackDragEvent = null;
	    }
	    /**
	     * @private
	     * @param {SyntheticEvent} event - User event
	     */

	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
	      var trackClientRect = this.getClientRect();
	      var position = {
	        x: clientX - trackClientRect.left,
	        y: 0
	      };
	      this.props.onTrackMouseDown(event, position);

	      if (this.props.draggableTrack) {
	        this.addDocumentMouseMoveListener();
	        this.addDocumentMouseUpListener();
	      }
	    }
	    /**
	     * @private
	     * @param {SyntheticEvent} event - User event
	     */

	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      event.preventDefault();
	      this.handleMouseDown(event);
	    }
	    /**
	     * @override
	     * @return {JSX.Element}
	     */

	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;

	      var activeTrackStyle = this.getActiveTrackStyle();
	      return _react2.default.createElement('div', {
	        className: this.props.classNames.track,
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleTouchStart,
	        ref: function ref(node) {
	          _this2.node = node;
	        }
	      }, _react2.default.createElement('div', {
	        style: activeTrackStyle,
	        className: this.props.classNames.activeTrack
	      }), this.props.children);
	    }
	  }]);

	  return Track;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype)), _class);
	exports.default = Track;
	module.exports = exports['default'];
	});

	var keyCodes = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @ignore */

	var DOWN_ARROW = exports.DOWN_ARROW = 40;
	/** @ignore */

	var LEFT_ARROW = exports.LEFT_ARROW = 37;
	/** @ignore */

	var RIGHT_ARROW = exports.RIGHT_ARROW = 39;
	/** @ignore */

	var UP_ARROW = exports.UP_ARROW = 38;
	});

	var inputRange = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;

	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var _class;



	var _react2 = _interopRequireDefault(React__default['default']);



	var _propTypes2 = _interopRequireDefault(propTypes);



	var _autobindDecorator2 = _interopRequireDefault(lib);



	var valueTransformer$1 = _interopRequireWildcard(valueTransformer);



	var _defaultClassNames2 = _interopRequireDefault(defaultClassNames);



	var _label2 = _interopRequireDefault(label);



	var _rangePropType2 = _interopRequireDefault(rangePropType_1);



	var _valuePropType2 = _interopRequireDefault(valuePropType_1);



	var _slider2 = _interopRequireDefault(slider);



	var _track2 = _interopRequireDefault(track);





	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj.default = obj;
	    return newObj;
	  }
	}

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}
	/**
	 * A React component that allows users to input numeric values within a range
	 * by dragging its sliders.
	 */


	var InputRange = (_class = function (_React$Component) {
	  _inherits(InputRange, _React$Component);

	  _createClass(InputRange, null, [{
	    key: 'propTypes',

	    /**
	     * @ignore
	     * @override
	     * @return {Object}
	     */
	    get: function get() {
	      return {
	        allowSameValues: _propTypes2.default.bool,
	        ariaLabelledby: _propTypes2.default.string,
	        ariaControls: _propTypes2.default.string,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
	        disabled: _propTypes2.default.bool,
	        draggableTrack: _propTypes2.default.bool,
	        formatLabel: _propTypes2.default.func,
	        maxValue: _rangePropType2.default,
	        minValue: _rangePropType2.default,
	        name: _propTypes2.default.string,
	        onChangeStart: _propTypes2.default.func,
	        onChange: _propTypes2.default.func.isRequired,
	        onChangeComplete: _propTypes2.default.func,
	        step: _propTypes2.default.number,
	        value: _valuePropType2.default
	      };
	    }
	    /**
	     * @ignore
	     * @override
	     * @return {Object}
	     */

	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        allowSameValues: false,
	        classNames: _defaultClassNames2.default,
	        disabled: false,
	        maxValue: 10,
	        minValue: 0,
	        step: 1
	      };
	    }
	    /**
	     * @param {Object} props
	     * @param {boolean} [props.allowSameValues]
	     * @param {string} [props.ariaLabelledby]
	     * @param {string} [props.ariaControls]
	     * @param {InputRangeClassNames} [props.classNames]
	     * @param {boolean} [props.disabled = false]
	     * @param {Function} [props.formatLabel]
	     * @param {number|Range} [props.maxValue = 10]
	     * @param {number|Range} [props.minValue = 0]
	     * @param {string} [props.name]
	     * @param {string} props.onChange
	     * @param {Function} [props.onChangeComplete]
	     * @param {Function} [props.onChangeStart]
	     * @param {number} [props.step = 1]
	     * @param {number|Range} props.value
	     */

	  }]);

	  function InputRange(props) {
	    _classCallCheck(this, InputRange);
	    /**
	     * @private
	     * @type {?number}
	     */


	    var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));

	    _this.startValue = null;
	    /**
	     * @private
	     * @type {?Component}
	     */

	    _this.node = null;
	    /**
	     * @private
	     * @type {?Component}
	     */

	    _this.trackNode = null;
	    /**
	     * @private
	     * @type {bool}
	     */

	    _this.isSliderDragging = false;
	    /**
	     * @private
	     * @type {?string}
	     */

	    _this.lastKeyMoved = null;
	    return _this;
	  }
	  /**
	   * @ignore
	   * @override
	   * @return {void}
	   */


	  _createClass(InputRange, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeDocumentMouseUpListener();
	      this.removeDocumentTouchEndListener();
	    }
	    /**
	     * Return the CSS class name of the component
	     * @private
	     * @return {string}
	     */

	  }, {
	    key: 'getComponentClassName',
	    value: function getComponentClassName() {
	      if (!this.props.disabled) {
	        return this.props.classNames.inputRange;
	      }

	      return this.props.classNames.disabledInputRange;
	    }
	    /**
	     * Return the bounding rect of the track
	     * @private
	     * @return {ClientRect}
	     */

	  }, {
	    key: 'getTrackClientRect',
	    value: function getTrackClientRect() {
	      return this.trackNode.getClientRect();
	    }
	    /**
	     * Return the slider key closest to a point
	     * @private
	     * @param {Point} position
	     * @return {string}
	     */

	  }, {
	    key: 'getKeyByPosition',
	    value: function getKeyByPosition(position) {
	      var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      var positions = valueTransformer$1.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

	      if (this.isMultiValue()) {
	        var distanceToMin = (0, utils$1.distanceTo)(position, positions.min);
	        var distanceToMax = (0, utils$1.distanceTo)(position, positions.max);

	        if (distanceToMin < distanceToMax) {
	          return 'min';
	        }
	      }

	      return 'max';
	    }
	    /**
	     * Return all the slider keys
	     * @private
	     * @return {string[]}
	     */

	  }, {
	    key: 'getKeys',
	    value: function getKeys() {
	      if (this.isMultiValue()) {
	        return ['min', 'max'];
	      }

	      return ['max'];
	    }
	    /**
	     * Return true if the difference between the new and the current value is
	     * greater or equal to the step amount of the component
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */

	  }, {
	    key: 'hasStepDifference',
	    value: function hasStepDifference(values) {
	      var currentValues = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      return (0, utils$1.length)(values.min, currentValues.min) >= this.props.step || (0, utils$1.length)(values.max, currentValues.max) >= this.props.step;
	    }
	    /**
	     * Return true if the component accepts a min and max value
	     * @private
	     * @return {boolean}
	     */

	  }, {
	    key: 'isMultiValue',
	    value: function isMultiValue() {
	      return (0, utils$1.isObject)(this.props.value);
	    }
	    /**
	     * Return true if the range is within the max and min value of the component
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */

	  }, {
	    key: 'isWithinRange',
	    value: function isWithinRange(values) {
	      if (this.isMultiValue()) {
	        return values.min >= this.props.minValue && values.max <= this.props.maxValue && this.props.allowSameValues ? values.min <= values.max : values.min < values.max;
	      }

	      return values.max >= this.props.minValue && values.max <= this.props.maxValue;
	    }
	    /**
	     * Return true if the new value should trigger a render
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */

	  }, {
	    key: 'shouldUpdate',
	    value: function shouldUpdate(values) {
	      return this.isWithinRange(values) && this.hasStepDifference(values);
	    }
	    /**
	     * Update the position of a slider
	     * @private
	     * @param {string} key
	     * @param {Point} position
	     * @return {void}
	     */

	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(key, position) {
	      var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      var positions = valueTransformer$1.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());
	      positions[key] = position;
	      this.lastKeyMoved = key;
	      this.updatePositions(positions);
	    }
	    /**
	     * Update the positions of multiple sliders
	     * @private
	     * @param {Object} positions
	     * @param {Point} positions.min
	     * @param {Point} positions.max
	     * @return {void}
	     */

	  }, {
	    key: 'updatePositions',
	    value: function updatePositions(positions) {
	      var values = {
	        min: valueTransformer$1.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
	        max: valueTransformer$1.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
	      };
	      var transformedValues = {
	        min: valueTransformer$1.getStepValueFromValue(values.min, this.props.step),
	        max: valueTransformer$1.getStepValueFromValue(values.max, this.props.step)
	      };
	      this.updateValues(transformedValues);
	    }
	    /**
	     * Update the value of a slider
	     * @private
	     * @param {string} key
	     * @param {number} value
	     * @return {void}
	     */

	  }, {
	    key: 'updateValue',
	    value: function updateValue(key, value) {
	      var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      values[key] = value;
	      this.updateValues(values);
	    }
	    /**
	     * Update the values of multiple sliders
	     * @private
	     * @param {Range|number} values
	     * @return {void}
	     */

	  }, {
	    key: 'updateValues',
	    value: function updateValues(values) {
	      if (!this.shouldUpdate(values)) {
	        return;
	      }

	      this.props.onChange(this.isMultiValue() ? values : values.max);
	    }
	    /**
	     * Increment the value of a slider by key name
	     * @private
	     * @param {string} key
	     * @return {void}
	     */

	  }, {
	    key: 'incrementValue',
	    value: function incrementValue(key) {
	      var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      var value = values[key] + this.props.step;
	      this.updateValue(key, value);
	    }
	    /**
	     * Decrement the value of a slider by key name
	     * @private
	     * @param {string} key
	     * @return {void}
	     */

	  }, {
	    key: 'decrementValue',
	    value: function decrementValue(key) {
	      var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      var value = values[key] - this.props.step;
	      this.updateValue(key, value);
	    }
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	    /**
	     * Listen to touchend event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'addDocumentTouchEndListener',
	    value: function addDocumentTouchEndListener() {
	      this.removeDocumentTouchEndListener();
	      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
	    }
	    /**
	     * Stop listening to mouseup event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	    /**
	     * Stop listening to touchend event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'removeDocumentTouchEndListener',
	    value: function removeDocumentTouchEndListener() {
	      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
	    }
	    /**
	     * Handle any "mousemove" event received by the slider
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {string} key
	     * @return {void}
	     */

	  }, {
	    key: 'handleSliderDrag',
	    value: function handleSliderDrag(event, key) {
	      var _this2 = this;

	      if (this.props.disabled) {
	        return;
	      }

	      var position = valueTransformer$1.getPositionFromEvent(event, this.getTrackClientRect());
	      this.isSliderDragging = true;
	      requestAnimationFrame(function () {
	        return _this2.updatePosition(key, position);
	      });
	    }
	    /**
	     * Handle any "mousemove" event received by the track
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleTrackDrag',
	    value: function handleTrackDrag(event, prevEvent) {
	      if (this.props.disabled || !this.props.draggableTrack || this.isSliderDragging) {
	        return;
	      }

	      var _props = this.props,
	          maxValue = _props.maxValue,
	          minValue = _props.minValue,
	          _props$value = _props.value,
	          max = _props$value.max,
	          min = _props$value.min;
	      var position = valueTransformer$1.getPositionFromEvent(event, this.getTrackClientRect());
	      var value = valueTransformer$1.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
	      var stepValue = valueTransformer$1.getStepValueFromValue(value, this.props.step);
	      var prevPosition = valueTransformer$1.getPositionFromEvent(prevEvent, this.getTrackClientRect());
	      var prevValue = valueTransformer$1.getValueFromPosition(prevPosition, minValue, maxValue, this.getTrackClientRect());
	      var prevStepValue = valueTransformer$1.getStepValueFromValue(prevValue, this.props.step);
	      var offset = prevStepValue - stepValue;
	      var transformedValues = {
	        min: min - offset,
	        max: max - offset
	      };
	      this.updateValues(transformedValues);
	    }
	    /**
	     * Handle any "keydown" event received by the slider
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {string} key
	     * @return {void}
	     */

	  }, {
	    key: 'handleSliderKeyDown',
	    value: function handleSliderKeyDown(event, key) {
	      if (this.props.disabled) {
	        return;
	      }

	      switch (event.keyCode) {
	        case keyCodes.LEFT_ARROW:
	        case keyCodes.DOWN_ARROW:
	          event.preventDefault();
	          this.decrementValue(key);
	          break;

	        case keyCodes.RIGHT_ARROW:
	        case keyCodes.UP_ARROW:
	          event.preventDefault();
	          this.incrementValue(key);
	          break;
	      }
	    }
	    /**
	     * Handle any "mousedown" event received by the track
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {Point} position
	     * @return {void}
	     */

	  }, {
	    key: 'handleTrackMouseDown',
	    value: function handleTrackMouseDown(event, position) {
	      if (this.props.disabled) {
	        return;
	      }

	      var _props2 = this.props,
	          maxValue = _props2.maxValue,
	          minValue = _props2.minValue,
	          _props2$value = _props2.value,
	          max = _props2$value.max,
	          min = _props2$value.min;
	      event.preventDefault();
	      var value = valueTransformer$1.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
	      var stepValue = valueTransformer$1.getStepValueFromValue(value, this.props.step);

	      if (!this.props.draggableTrack || stepValue > max || stepValue < min) {
	        this.updatePosition(this.getKeyByPosition(position), position);
	      }
	    }
	    /**
	     * Handle the start of any mouse/touch event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'handleInteractionStart',
	    value: function handleInteractionStart() {
	      if (this.props.onChangeStart) {
	        this.props.onChangeStart(this.props.value);
	      }

	      if (this.props.onChangeComplete && !(0, utils$1.isDefined)(this.startValue)) {
	        this.startValue = this.props.value;
	      }
	    }
	    /**
	     * Handle the end of any mouse/touch event
	     * @private
	     * @return {void}
	     */

	  }, {
	    key: 'handleInteractionEnd',
	    value: function handleInteractionEnd() {
	      if (this.isSliderDragging) {
	        this.isSliderDragging = false;
	      }

	      if (!this.props.onChangeComplete || !(0, utils$1.isDefined)(this.startValue)) {
	        return;
	      }

	      if (this.startValue !== this.props.value) {
	        this.props.onChangeComplete(this.props.value);
	      }

	      this.startValue = null;
	    }
	    /**
	     * Handle any "keydown" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      this.handleInteractionStart(event);
	    }
	    /**
	     * Handle any "keyup" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(event) {
	      this.handleInteractionEnd(event);
	    }
	    /**
	     * Handle any "mousedown" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      this.handleInteractionStart(event);
	      this.addDocumentMouseUpListener();
	    }
	    /**
	     * Handle any "mouseup" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     */

	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp(event) {
	      this.handleInteractionEnd(event);
	      this.removeDocumentMouseUpListener();
	    }
	    /**
	     * Handle any "touchstart" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */

	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      this.handleInteractionStart(event);
	      this.addDocumentTouchEndListener();
	    }
	    /**
	     * Handle any "touchend" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     */

	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd(event) {
	      this.handleInteractionEnd(event);
	      this.removeDocumentTouchEndListener();
	    }
	    /**
	     * Return JSX of sliders
	     * @private
	     * @return {JSX.Element}
	     */

	  }, {
	    key: 'renderSliders',
	    value: function renderSliders() {
	      var _this3 = this;

	      var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      var percentages = valueTransformer$1.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
	      var keys = this.props.allowSameValues && this.lastKeyMoved === 'min' ? this.getKeys().reverse() : this.getKeys();
	      return keys.map(function (key) {
	        var value = values[key];
	        var percentage = percentages[key];
	        var _props3 = _this3.props,
	            maxValue = _props3.maxValue,
	            minValue = _props3.minValue;

	        if (key === 'min') {
	          maxValue = values.max;
	        } else {
	          minValue = values.min;
	        }

	        var slider = _react2.default.createElement(_slider2.default, {
	          ariaLabelledby: _this3.props.ariaLabelledby,
	          ariaControls: _this3.props.ariaControls,
	          classNames: _this3.props.classNames,
	          formatLabel: _this3.props.formatLabel,
	          key: key,
	          maxValue: maxValue,
	          minValue: minValue,
	          onSliderDrag: _this3.handleSliderDrag,
	          onSliderKeyDown: _this3.handleSliderKeyDown,
	          percentage: percentage,
	          type: key,
	          value: value
	        });

	        return slider;
	      });
	    }
	    /**
	     * Return JSX of hidden inputs
	     * @private
	     * @return {JSX.Element}
	     */

	  }, {
	    key: 'renderHiddenInputs',
	    value: function renderHiddenInputs() {
	      var _this4 = this;

	      if (!this.props.name) {
	        return [];
	      }

	      var isMultiValue = this.isMultiValue();
	      var values = valueTransformer$1.getValueFromProps(this.props, isMultiValue);
	      return this.getKeys().map(function (key) {
	        var value = values[key];
	        var name = isMultiValue ? '' + _this4.props.name + (0, utils$1.captialize)(key) : _this4.props.name;
	        return _react2.default.createElement('input', {
	          key: key,
	          type: 'hidden',
	          name: name,
	          value: value
	        });
	      });
	    }
	    /**
	     * @ignore
	     * @override
	     * @return {JSX.Element}
	     */

	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;

	      var componentClassName = this.getComponentClassName();
	      var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
	      var percentages = valueTransformer$1.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
	      return _react2.default.createElement('div', {
	        'aria-disabled': this.props.disabled,
	        ref: function ref(node) {
	          _this5.node = node;
	        },
	        className: componentClassName,
	        onKeyDown: this.handleKeyDown,
	        onKeyUp: this.handleKeyUp,
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleTouchStart
	      }, _react2.default.createElement(_label2.default, {
	        classNames: this.props.classNames,
	        formatLabel: this.props.formatLabel,
	        type: 'min'
	      }, this.props.minValue), _react2.default.createElement(_track2.default, {
	        classNames: this.props.classNames,
	        draggableTrack: this.props.draggableTrack,
	        ref: function ref(trackNode) {
	          _this5.trackNode = trackNode;
	        },
	        percentages: percentages,
	        onTrackDrag: this.handleTrackDrag,
	        onTrackMouseDown: this.handleTrackMouseDown
	      }, this.renderSliders()), _react2.default.createElement(_label2.default, {
	        classNames: this.props.classNames,
	        formatLabel: this.props.formatLabel,
	        type: 'max'
	      }, this.props.maxValue), this.renderHiddenInputs());
	    }
	  }]);

	  return InputRange;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleSliderDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSliderKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype)), _class);
	exports.default = InputRange;
	module.exports = exports['default'];
	});

	var js = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});



	var _inputRange2 = _interopRequireDefault(inputRange);

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	/**
	 * @ignore
	 * @typedef {Object} ClientRect
	 * @property {number} height
	 * @property {number} left
	 * @property {number} top
	 * @property {number} width
	 */

	/**
	 * @typedef {Object} InputRangeClassNames
	 * @property {string} activeTrack
	 * @property {string} disabledInputRange
	 * @property {string} inputRange
	 * @property {string} labelContainer
	 * @property {string} maxLabel
	 * @property {string} minLabel
	 * @property {string} slider
	 * @property {string} sliderContainer
	 * @property {string} track
	 * @property {string} valueLabel
	 */

	/**
	 * @typedef {Function} LabelFormatter
	 * @param {number} value
	 * @param {string} type
	 * @return {string}
	 */

	/**
	 * @ignore
	 * @typedef {Object} Point
	 * @property {number} x
	 * @property {number} y
	 */

	/**
	 * @typedef {Object} Range
	 * @property {number} min - Min value
	 * @property {number} max - Max value
	 */


	exports.default = _inputRange2.default;
	module.exports = exports['default'];
	});

	var InputRange = /*@__PURE__*/getDefaultExportFromCjs(js);

	var styles$$ = {"inputRange":"telia-react-inputRange","inputRange__disabled":"telia-react-inputRange__disabled","inputRange_track":"telia-react-inputRange_track","inputRange_track_activeTrack":"telia-react-inputRange_track_activeTrack","inputRange_sliderContainer":"telia-react-inputRange_sliderContainer","inputRange_sliderContainer_slider":"telia-react-inputRange_sliderContainer_slider","inputRange_label":"telia-react-inputRange_label"};

	var _excluded$19 = ["disabled", "minRangeValue", "maxRangeValue", "value", "onChange", "onChangeStart", "onChangeComplete", "interval", "formatLabel", "allowSameValues", "ariaLabelledby", "ariaControls", "draggableTrack", "name", "InputRangeClassNames"];
	var defaultClassNames$1 = {
	  activeTrack: styles$$.inputRange_track_activeTrack,
	  disabledInputRange: styles$$.inputRange__disabled,
	  inputRange: styles$$.inputRange,
	  labelContainer: styles$$.inputRange_label,
	  maxLabel: styles$$.inputRange_label__max,
	  minLabel: styles$$.inputRange_label__min,
	  slider: styles$$.inputRange_sliderContainer_slider,
	  sliderContainer: styles$$.inputRange_sliderContainer,
	  track: styles$$.inputRange_track,
	  valueLabel: styles$$.inputRange_label__value
	};

	var RangeSlider = function RangeSlider(_ref) {
	  var _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
	      minRangeValue = _ref.minRangeValue,
	      maxRangeValue = _ref.maxRangeValue,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      _ref$onChangeStart = _ref.onChangeStart,
	      onChangeStart = _ref$onChangeStart === void 0 ? undefined : _ref$onChangeStart,
	      _ref$onChangeComplete = _ref.onChangeComplete,
	      onChangeComplete = _ref$onChangeComplete === void 0 ? undefined : _ref$onChangeComplete,
	      _ref$interval = _ref.interval,
	      interval = _ref$interval === void 0 ? 1 : _ref$interval,
	      _ref$formatLabel = _ref.formatLabel,
	      formatLabel = _ref$formatLabel === void 0 ? undefined : _ref$formatLabel,
	      _ref$allowSameValues = _ref.allowSameValues,
	      allowSameValues = _ref$allowSameValues === void 0 ? false : _ref$allowSameValues,
	      _ref$ariaLabelledby = _ref.ariaLabelledby,
	      ariaLabelledby = _ref$ariaLabelledby === void 0 ? undefined : _ref$ariaLabelledby,
	      _ref$ariaControls = _ref.ariaControls,
	      ariaControls = _ref$ariaControls === void 0 ? undefined : _ref$ariaControls,
	      _ref$draggableTrack = _ref.draggableTrack,
	      draggableTrack = _ref$draggableTrack === void 0 ? false : _ref$draggableTrack,
	      _ref$name = _ref.name,
	      name = _ref$name === void 0 ? undefined : _ref$name,
	      _ref$InputRangeClassN = _ref.InputRangeClassNames,
	      InputRangeClassNames = _ref$InputRangeClassN === void 0 ? defaultClassNames$1 : _ref$InputRangeClassN,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$19);

	  // The react-input-range does not correctly check if the value is under or over limits.
	  // Below code just checks that value is between the limits and in-case of violation changes value to the limit.
	  if (value.min != null) {
	    value.min = Math.max(value.min, minRangeValue);
	    value.min = Math.min(value.min, maxRangeValue);
	    value.max = Math.max(value.max, minRangeValue);
	    value.max = Math.min(value.max, maxRangeValue);
	  } else {
	    value = Math.max(value, minRangeValue);
	    value = Math.min(value, maxRangeValue);
	  } // Create own custom labels to be displayed


	  var minDisplay = value.min != null ? /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    fontWeight: 'medium',
	    style: {
	      letterSpacing: '0.5px'
	    },
	    color: disabled ? 'gray400' : 'black'
	  }, formatLabel ? formatLabel(value.min) : value.min) : null;
	  var maxDisplay = /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    fontWeight: 'medium',
	    color: disabled ? 'gray400' : 'black',
	    style: {
	      marginLeft: 'auto',
	      letterSpacing: '0.5px'
	    }
	  }, formatLabel ? formatLabel(value.max || value) : value.max || value);
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    padding: {
	      horizontal: 'xs'
	    }
	  }, props), /*#__PURE__*/React__default['default'].createElement(InputRange, {
	    classNames: InputRangeClassNames,
	    disabled: disabled,
	    minValue: minRangeValue,
	    maxValue: maxRangeValue,
	    value: value,
	    onChange: onChange,
	    onChangeStart: onChangeStart,
	    onChangeComplete: onChangeComplete,
	    step: interval,
	    formatLabel: formatLabel,
	    allowSameValues: allowSameValues,
	    ariaLabelledby: ariaLabelledby,
	    ariaControls: ariaControls,
	    draggableTrack: draggableTrack,
	    name: name
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    spaceBetween: true
	  }, minDisplay, maxDisplay));
	};

	var style$3 = {"searchInput":"telia-react-searchInput","icon":"telia-react-icon"};

	var _excluded$1a = ["className", "showCustomLabel", "value", "type"];

	var SearchInput = function SearchInput(_ref) {
	  var className = _ref.className,
	      _ref$showCustomLabel = _ref.showCustomLabel,
	      showCustomLabel = _ref$showCustomLabel === void 0 ? true : _ref$showCustomLabel,
	      value = _ref.value,
	      _ref$type = _ref.type,
	      type = _ref$type === void 0 ? 'text' : _ref$type,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1a);

	  return /*#__PURE__*/React__default['default'].createElement(BaseInput, _extends_1({}, props, {
	    label: undefined,
	    showCustomLabel: showCustomLabel,
	    iconName: "search",
	    iconColor: 'gray500',
	    type: type,
	    confirmed: false,
	    required: false,
	    errorText: undefined,
	    className: [style$3.searchInput, className],
	    value: value
	  }));
	};

	var styles$10 = {"searchInputWithScope":"telia-react-searchInputWithScope","searchInputWithScope_inputContainer":"telia-react-searchInputWithScope_inputContainer","searchInputWithScope_scopeDropdown":"telia-react-searchInputWithScope_scopeDropdown","input__container":"telia-react-input__container","searchInputWithScope_searchInput":"telia-react-searchInputWithScope_searchInput"};

	var _excluded$1b = ["className", "showLabel", "label", "disabled", "searchValue", "onSearchChange", "placeholder", "scopeOptions", "selectedScope", "onScopeChange", "searchOptions", "onSearchOptionSelect", "searchType", "onIconClick", "errorText", "helperText"];
	var SearchInputWithScope = function SearchInputWithScope(_ref) {
	  var className = _ref.className,
	      _ref$showLabel = _ref.showLabel,
	      showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel,
	      label = _ref.label,
	      disabled = _ref.disabled,
	      searchValue = _ref.searchValue,
	      onSearchChange = _ref.onSearchChange,
	      placeholder = _ref.placeholder,
	      scopeOptions = _ref.scopeOptions,
	      selectedScope = _ref.selectedScope,
	      onScopeChange = _ref.onScopeChange,
	      _ref$searchOptions = _ref.searchOptions,
	      searchOptions = _ref$searchOptions === void 0 ? [] : _ref$searchOptions,
	      onSearchOptionSelect = _ref.onSearchOptionSelect,
	      searchType = _ref.searchType,
	      onIconClick = _ref.onIconClick,
	      errorText = _ref.errorText,
	      helperText = _ref.helperText,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1b);

	  var showLabelLogic = showLabel || label;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$10.searchInputWithScope, className]
	  }, showLabelLogic && /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    block: true,
	    size: "sm",
	    color: disabled ? 'gray400' : 'black',
	    tagName: "label",
	    "data-testid": "label"
	  }, label ? label : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, "\xA0")), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  })), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: styles$10.searchInputWithScope_inputContainer,
	    occupyVerticalSpace: false
	  }, /*#__PURE__*/React__default['default'].createElement(Dropdown, {
	    className: styles$10.searchInputWithScope_scopeDropdown,
	    disabled: disabled,
	    selectedOption: selectedScope,
	    options: scopeOptions,
	    onChange: onScopeChange,
	    showCustomLabel: true,
	    errorText: !!errorText ? ' ' : undefined
	  }), /*#__PURE__*/React__default['default'].createElement(Autocomplete, _extends_1({
	    errorText: !!errorText ? ' ' : undefined
	  }, props, {
	    className: styles$10.searchInputWithScope_searchInput,
	    value: searchValue,
	    onChange: onSearchChange,
	    placeholder: placeholder,
	    disabled: disabled,
	    options: searchOptions,
	    onOptionSelect: onSearchOptionSelect,
	    type: searchType,
	    showCustomLabel: true,
	    iconName: !!errorText ? 'error-filled' : 'search',
	    iconColor: disabled ? 'gray400' : !!errorText ? 'red600' : 'gray500',
	    onIconClick: onIconClick
	  }))), !!errorText && errorText !== ' ' && /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: errorText,
	    color: "red600"
	  }), helperText ? /*#__PURE__*/React__default['default'].createElement(InputMessage, {
	    text: helperText,
	    color: "gray500"
	  }) : null);
	};

	var styles$11 = {"combobox":"telia-react-combobox","input":"telia-react-input","combobox_open":"telia-react-combobox_open","inputMessage_textContainer":"telia-react-inputMessage_textContainer","inputMessage_text":"telia-react-inputMessage_text","input__container_error":"telia-react-input__container_error","input__container_disabled":"telia-react-input__container_disabled","input__container":"telia-react-input__container","optionlist":"telia-react-optionlist"};

	var _excluded$1c = ["options", "onChange", "value", "errorText", "disabled", "className", "onOptionSelect", "onOptionClear"];

	var Combobox = function Combobox(_ref) {
	  var _options$find, _ref2, _getSelectedOption;

	  var options = _ref.options,
	      onChange = _ref.onChange,
	      value = _ref.value,
	      errorText = _ref.errorText,
	      disabled = _ref.disabled,
	      className = _ref.className,
	      onOptionSelect = _ref.onOptionSelect,
	      onOptionClear = _ref.onOptionClear,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1c);

	  var preselectedOptionId = (_options$find = find$3(options).call(options, function (option) {
	    return option.label === value;
	  })) == null ? void 0 : _options$find.value;

	  var _useState = React.useState(false),
	      open = _useState[0],
	      setOpen = _useState[1];

	  var _useState2 = React.useState(preselectedOptionId),
	      focusedOptionId = _useState2[0],
	      setFocusedOptionId = _useState2[1];

	  var _useState3 = React.useState(preselectedOptionId),
	      selectedOptionId = _useState3[0],
	      setSelectedOptionId = _useState3[1];

	  var inputElement = React.useRef(null);
	  var dropdownElement = React.useRef(null);

	  var focusOnFirstFocusableOption = function focusOnFirstFocusableOption() {
	    var firstFocusableOption = filter$3(options).call(options, function (option) {
	      return !option.disabled;
	    })[0];
	    /* istanbul ignore else */


	    if (firstFocusableOption) {
	      setFocusedOptionId(firstFocusableOption.value);
	    }
	  };

	  var getSelectedOption = function getSelectedOption() {
	    return find$3(options).call(options, function (option) {
	      return option.value === selectedOptionId;
	    });
	  };

	  var findOptionByLabel = function findOptionByLabel(label) {
	    return find$3(options).call(options, function (option) {
	      return option.label === label;
	    });
	  };

	  var selectOption = function selectOption(event, option) {
	    setSelectedOptionId(option.value);
	    setFocusedOptionId(option.value);
	    onOptionSelect && onOptionSelect(event, option);
	  };

	  if (open && preselectedOptionId && !selectedOptionId && !focusedOptionId) {
	    var optionToBeSelected = find$3(options).call(options, function (option) {
	      return option.label === value;
	    });

	    optionToBeSelected && selectOption(undefined, optionToBeSelected);
	    setOpen(false);
	  }

	  var isOpenWithSelection = function isOpenWithSelection() {
	    return open && typeof selectedOptionId !== 'undefined';
	  };

	  var openOptionsAndPreselectOption = function openOptionsAndPreselectOption(event) {
	    var selectedOption = getSelectedOption();

	    if (selectedOption) {
	      updateInputText(event, '');
	      setFocusedOptionId(selectedOption.value);
	    }

	    setOpen(true);
	  };

	  var handleComponentMouseDown = function handleComponentMouseDown(event) {
	    var _inputElement$current;

	    event.preventDefault();
	    event.stopPropagation();

	    if (open) {
	      var selectedOption = getSelectedOption();
	      setOpen(false);

	      if (selectedOption) {
	        updateInputText(event, selectedOption.label);
	      }
	    } else if (!value) {
	      openOptionsAndPreselectOption(event);
	    } else {
	      setOpen(true);
	    }

	    (_inputElement$current = inputElement.current) == null ? void 0 : _inputElement$current.focus();
	  };

	  var handleOptionListBlur = function handleOptionListBlur(event) {
	    var isFocusEvent = function isFocusEvent(e) {
	      return 'relatedTarget' in e;
	    };
	    /* This logic is related to the keyboard usability (closing on ESC) which is not supported in IE. That's why we leave IE out  */


	    event.preventDefault();
	    event.stopPropagation();
	    /* istanbul ignore next */

	    if (!isIE11) {
	      var _dropdownElement$curr;

	      if (!isFocusEvent(event) || !((_dropdownElement$curr = dropdownElement.current) != null && _dropdownElement$curr.contains(event.relatedTarget)) && open) {
	        var _inputElement$current2;

	        var selectedOption = getSelectedOption();

	        if (selectedOption) {
	          updateInputText(event, selectedOption.label);
	        }

	        setOpen(false);
	        (_inputElement$current2 = inputElement.current) == null ? void 0 : _inputElement$current2.focus();
	      }
	    }
	  };

	  var handleOptionSelect = function handleOptionSelect(event, option) {
	    var _inputElement$current3;

	    (_inputElement$current3 = inputElement.current) == null ? void 0 : _inputElement$current3.focus();
	    setOpen(false);
	    updateInputText(event, option.label);
	    selectOption(event, option);
	  };

	  var handleKeyDown = function handleKeyDown(event) {
	    if (event.key === 'Escape' && open) {
	      setOpen(false);
	    }

	    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
	      focusOnFirstFocusableOption();
	      event.preventDefault();
	      openOptionsAndPreselectOption(event);
	    }
	  };

	  var handleInputChange = function handleInputChange(event) {
	    var _event$target;

	    var inputText = (_event$target = event.target) == null ? void 0 : _event$target.value;
	    updateInputText(event, inputText);

	    if (selectedOptionId && onOptionClear) {
	      onOptionClear(event);
	    }

	    setFocusedOptionId(undefined);
	    setSelectedOptionId(undefined);
	    var optionWithMatchingLabel = findOptionByLabel(inputText);
	    /* istanbul ignore else */

	    if (optionWithMatchingLabel) {
	      selectOption(event, optionWithMatchingLabel);
	      setOpen(false);
	    } else if (!open) {
	      setOpen(true);
	    }
	  };
	  /* istanbul ignore next */


	  var handleOptionMouseDown = function handleOptionMouseDown(event) {
	    event.preventDefault();
	    event.stopPropagation();
	  };

	  var handleInputBlur = function handleInputBlur(event) {
	    /* istanbul ignore else */
	    if (open && focusedOptionId === undefined) {
	      setOpen(false);
	      updateInputText(event, value || '');
	    }
	  };

	  var updateInputText = function updateInputText(event, newValue) {
	    /* istanbul ignore else */
	    if (newValue !== value) {
	      onChange(event, newValue);
	    }
	  };

	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: classnames([styles$11.combobox, (_ref2 = {}, _ref2[styles$11.combobox_open] = open, _ref2), className]),
	    ref: dropdownElement,
	    onKeyDown: handleKeyDown,
	    onMouseDown: disabled ? undefined : handleComponentMouseDown
	  }, /*#__PURE__*/React__default['default'].createElement(BaseInput, _extends_1({}, props, {
	    disabled: disabled,
	    wrapperTabIndex: -1,
	    confirmed: false,
	    iconName: open ? 'chevron-up' : 'chevron-down',
	    iconColor: open ? 'purple500' : 'black',
	    value: isOpenWithSelection() ? (_getSelectedOption = getSelectedOption()) == null ? void 0 : _getSelectedOption.label : value,
	    readonly: disabled,
	    onChange: disabled ? undefined : handleInputChange,
	    onBlur: handleInputBlur,
	    ref: inputElement,
	    errorText: errorText && errorText === ' ' ? ' ' : errorText,
	    borderRadius: {
	      size: 'sm'
	    }
	  })), open && /*#__PURE__*/React__default['default'].createElement(OptionList, {
	    options: options,
	    onBlur: handleOptionListBlur,
	    optionOnClick: handleOptionSelect,
	    focusedOptionId: focusedOptionId,
	    onMouseDown: handleOptionMouseDown
	  }));
	};

	var styles$12 = {"step":"telia-react-step","step__selectable":"telia-react-step__selectable","step__contentInColumn":"telia-react-step__contentInColumn","step_border":"telia-react-step_border","step_border__selectable":"telia-react-step_border__selectable","step_border__alwaysBrightCompleted":"telia-react-step_border__alwaysBrightCompleted","step_border__active":"telia-react-step_border__active","step_label":"telia-react-step_label","step_label__withIcon":"telia-react-step_label__withIcon","step_label__selectable":"telia-react-step_label__selectable","step_label__alwaysBrightCompleted":"telia-react-step_label__alwaysBrightCompleted","step_label__active":"telia-react-step_label__active"};

	var Step = function Step(_ref) {
	  var _ref2, _ref3, _ref4;

	  var label = _ref.label,
	      description = _ref.description,
	      _ref$descriptionRespo = _ref.descriptionResponsiveHidden,
	      descriptionResponsiveHidden = _ref$descriptionRespo === void 0 ? {
	    thinnerThan: 'sm'
	  } : _ref$descriptionRespo,
	      _ref$stepContentToCol = _ref.stepContentToColumn,
	      stepContentToColumn = _ref$stepContentToCol === void 0 ? false : _ref$stepContentToCol,
	      active = _ref.active,
	      completed = _ref.completed,
	      selectable = _ref.selectable,
	      onSelect = _ref.onSelect,
	      completionIcon = _ref.completionIcon,
	      alwaysBrightCompleted = _ref.alwaysBrightCompleted;
	  var descriptionElement = typeof description === 'string' ? /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    color: "gray400"
	  }, description) : description;
	  var labelClasses = [styles$12.step_label, (_ref2 = {}, _ref2[styles$12.step_label__active] = active, _ref2[styles$12.step_label__selectable] = selectable, _ref2[styles$12.step_label__alwaysBrightCompleted] = alwaysBrightCompleted && completed, _ref2[styles$12.step_label__withIcon] = completionIcon, _ref2)];
	  var useCompletionIcon = completed && completionIcon;
	  completionIcon = /*#__PURE__*/React__default['default'].isValidElement(completionIcon) ? completionIcon : /*#__PURE__*/React__default['default'].createElement(Icon, {
	    className: labelClasses,
	    name: "checkmark",
	    size: "sm"
	  });
	  var tempLabel = typeof label === 'string' || typeof label === 'number' ? /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    className: labelClasses
	  }, String(label)) : /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: labelClasses
	  }, label);
	  var labelElement = useCompletionIcon ? completionIcon : tempLabel;
	  var stepClasses = [styles$12.step, (_ref3 = {}, _ref3[styles$12.step__selectable] = selectable, _ref3[styles$12.step__contentInColumn] = stepContentToColumn, _ref3)];
	  var borderClasses = [styles$12.step_border, (_ref4 = {}, _ref4[styles$12.step_border__active] = active, _ref4[styles$12.step_border__selectable] = selectable, _ref4[styles$12.step_border__alwaysBrightCompleted] = alwaysBrightCompleted && completed, _ref4)];

	  var clickHandler = function clickHandler(event) {
	    selectable && onSelect && onSelect(event);
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true,
	    className: stepClasses,
	    onClick: clickHandler
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: borderClasses
	  }, labelElement), descriptionElement && /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      horizontal: 'xs'
	    },
	    responsiveHidden: descriptionResponsiveHidden
	  }, descriptionElement));
	};

	var Steps = function Steps(_ref) {
	  var _context;

	  var selectedStepIndex = _ref.selectedStepIndex,
	      _ref$isStepActive = _ref.isStepActive,
	      isStepActive = _ref$isStepActive === void 0 ? function (index, selectedStepIndex) {
	    return index === selectedStepIndex;
	  } : _ref$isStepActive,
	      _ref$isStepCompleted = _ref.isStepCompleted,
	      isStepCompleted = _ref$isStepCompleted === void 0 ? function (index, selectedStepIndex) {
	    return index < selectedStepIndex;
	  } : _ref$isStepCompleted,
	      _ref$isStepSelectable = _ref.isStepSelectable,
	      isStepSelectable = _ref$isStepSelectable === void 0 ? function (index, selectedStepIndex) {
	    return index < selectedStepIndex;
	  } : _ref$isStepSelectable,
	      _ref$onSelect = _ref.onSelect,
	      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect,
	      centerSteps = _ref.centerSteps,
	      spaceBetweenSteps = _ref.spaceBetweenSteps,
	      completionIcon = _ref.completionIcon,
	      alwaysBrightCompleted = _ref.alwaysBrightCompleted,
	      children = _ref.children;
	  var stepCount = React__default['default'].Children.count(children);
	  selectedStepIndex = selectedStepIndex ? Math.min(stepCount - 1, selectedStepIndex) : 0;

	  var stepIndicatorElements = map$3(_context = React__default['default'].Children).call(_context, children, function (child, index) {
	    return /*#__PURE__*/React__default['default'].cloneElement(child, {
	      active: isStepActive(index, selectedStepIndex),
	      completed: isStepCompleted(index, selectedStepIndex),
	      selectable: isStepSelectable(index, selectedStepIndex),
	      onSelect: child.props.onSelect || function (event) {
	        return onSelect(event, index);
	      },
	      completionIcon: completionIcon,
	      alwaysBrightCompleted: alwaysBrightCompleted
	    });
	  });

	  return /*#__PURE__*/React__default['default'].createElement(GutterBag, {
	    contents: stepIndicatorElements,
	    centeredHorizontally: centerSteps,
	    spaceBetween: spaceBetweenSteps
	  });
	};

	function StepperItem(_ref) {
	  var children = _ref.children;

	  if (!children) {
	    return null;
	  }

	  return children;
	}

	StepperItem.propTypes = {
	  /** String, number or React component rendered inside the step component */
	  label: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.element]),

	  /** String or element that is passed as the description to the respective Step component */
	  description: propTypes.oneOfType([propTypes.string, propTypes.element]),

	  /** Control responsiveHidden prop of description container */
	  descriptionResponsiveHidden: propTypes.oneOfType([propTypes.bool, propTypes.shape({
	    thinnerThan: propTypes.oneOf(responsiveSupportedSizes),
	    widerThan: propTypes.oneOf(responsiveSupportedSizes),
	    at: propTypes.oneOf(responsiveSupportedSizes)
	  })]),

	  /** Pile description and step icon vertically */
	  stepContentToColumn: propTypes.bool,

	  /** Any number of elements that are rendered when the item is active */
	  children: propTypes.any
	};

	var _excluded$1d = ["selectedStepIndex", "isStepActive", "isStepCompleted", "isStepSelectable", "onSelect", "centerSteps", "spaceBetweenSteps", "completionIcon", "alwaysBrightCompleted", "children", "paddingSize"];

	var Stepper = function Stepper(_ref) {
	  var _context;

	  var selectedStepIndex = _ref.selectedStepIndex,
	      isStepActive = _ref.isStepActive,
	      isStepCompleted = _ref.isStepCompleted,
	      isStepSelectable = _ref.isStepSelectable,
	      onSelect = _ref.onSelect,
	      centerSteps = _ref.centerSteps,
	      spaceBetweenSteps = _ref.spaceBetweenSteps,
	      completionIcon = _ref.completionIcon,
	      alwaysBrightCompleted = _ref.alwaysBrightCompleted,
	      children = _ref.children,
	      _ref$paddingSize = _ref.paddingSize,
	      paddingSize = _ref$paddingSize === void 0 ? 'md' : _ref$paddingSize,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1d);

	  var validItems = filter$3(_context = React__default['default'].Children.toArray(children)).call(_context, function (candidate) {
	    return candidate.type === StepperItem;
	  });

	  var steps = map$3(validItems).call(validItems, function (item, index) {
	    var label = item.props.label || String(index + 1);
	    var _item$props = item.props,
	        description = _item$props.description,
	        descriptionResponsiveHidden = _item$props.descriptionResponsiveHidden,
	        stepContentToColumn = _item$props.stepContentToColumn;
	    return /*#__PURE__*/React__default['default'].createElement(Step, {
	      label: label,
	      description: description,
	      descriptionResponsiveHidden: descriptionResponsiveHidden,
	      stepContentToColumn: stepContentToColumn,
	      key: String(index)
	    });
	  });

	  var restrictedActiveIndex = Math.min(selectedStepIndex, validItems.length - 1);
	  var activeComponent = validItems[restrictedActiveIndex];
	  return /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    padding: {
	      size: paddingSize
	    }
	  }, props), /*#__PURE__*/React__default['default'].createElement(Steps, {
	    selectedStepIndex: restrictedActiveIndex,
	    isStepActive: isStepActive,
	    isStepCompleted: isStepCompleted,
	    isStepSelectable: isStepSelectable,
	    centerSteps: centerSteps,
	    spaceBetweenSteps: spaceBetweenSteps,
	    completionIcon: completionIcon,
	    alwaysBrightCompleted: alwaysBrightCompleted,
	    onSelect: onSelect
	  }, steps)), activeComponent);
	};

	Stepper.Item = StepperItem;

	var styles$13 = {"switch":"telia-react-switch","switch_label":"telia-react-switch_label","switch_hiddenCheckbox":"telia-react-switch_hiddenCheckbox","switch_track":"telia-react-switch_track","switch_handle":"telia-react-switch_handle","switch__on":"telia-react-switch__on","switch__off":"telia-react-switch__off"};

	var _excluded$1e = ["className", "isOn", "label", "description", "onChange"];

	var Switch = function Switch(_ref) {
	  var className = _ref.className,
	      isOn = _ref.isOn,
	      label = _ref.label,
	      description = _ref.description,
	      _onChange = _ref.onChange,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1e);

	  var stateClassName = isOn ? styles$13.switch__on : styles$13.switch__off;
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: [styles$13.switch, stateClassName, className]
	  }, props), /*#__PURE__*/React__default['default'].createElement("label", {
	    className: styles$13.switch_label
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement("input", {
	    className: styles$13.switch_hiddenCheckbox,
	    type: "checkbox",
	    checked: isOn,
	    onChange: function onChange() {
	      return _onChange(!isOn);
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$13.switch_track,
	    tabIndex: 0,
	    hideOverflow: true,
	    backgroundColor: isOn ? 'purple500' : 'gray400',
	    borderRadius: {
	      size: 'rounded'
	    },
	    onKeyPress: function onKeyPress(e) {
	      e.key === 'Enter' && _onChange(!isOn);
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$13.switch_handle,
	    borderRadius: {
	      size: 'rounded'
	    },
	    backgroundColor: "white"
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "sm"
	  }), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    color: "black",
	    margin: false,
	    block: true
	  }, label), description && /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    color: "gray400",
	    margin: false,
	    block: true
	  }, description)))));
	};

	var assign$4 = assign$1;

	var styles$14 = {"table_table":"telia-react-table_table","table_table__auto":"telia-react-table_table__auto","table_table__fixed":"telia-react-table_table__fixed","table_row":"telia-react-table_row","table_cell":"telia-react-table_cell","table_cell_checkbox":"telia-react-table_cell_checkbox","table_cell__breakWord":"telia-react-table_cell__breakWord","table_cell_header":"telia-react-table_cell_header","table_cell_header_checkbox_label":"telia-react-table_cell_header_checkbox_label","table_cell_heading":"telia-react-table_cell_heading","table_sort_label":"telia-react-table_sort_label","table":"telia-react-table","table_table__mobileLayout_xxxs":"telia-react-table_table__mobileLayout_xxxs","table_table__mobileLayout_xxs":"telia-react-table_table__mobileLayout_xxs","table_table__mobileLayout_xs":"telia-react-table_table__mobileLayout_xs","table_table__mobileLayout_sm":"telia-react-table_table__mobileLayout_sm","table_table__mobileLayout_md":"telia-react-table_table__mobileLayout_md","table_table__mobileLayout_lg":"telia-react-table_table__mobileLayout_lg","table_table__mobileLayout_xlg":"telia-react-table_table__mobileLayout_xlg"};

	var _excluded$1f = ["className", "children"];

	var TableRow = function TableRow(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1f);

	  var classNames = classnames(styles$14.table_row, className);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "tr",
	    className: classNames
	  }, props), children);
	};

	var _excluded$1g = ["className", "children", "type", "breakWord"];
	var TableCell = /*#__PURE__*/React__default['default'].forwardRef(function TableCell(_ref, ref) {
	  var _getClassNames, _getClassNames2;

	  var className = _ref.className,
	      children = _ref.children,
	      type = _ref.type,
	      breakWord = _ref.breakWord,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1g);

	  var classNames = classnames(styles$14.table_cell, (_getClassNames = {}, _getClassNames[styles$14.table_cell_checkbox] = type === 'checkbox', _getClassNames), (_getClassNames2 = {}, _getClassNames2[styles$14.table_cell__breakWord] = breakWord, _getClassNames2), className);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "td",
	    ref: ref,
	    className: classNames
	  }, props), children);
	});

	var _excluded$1h = ["className", "children", "sortDirection", "breakWord", "type"];
	var TableHeaderCell = /*#__PURE__*/React__default['default'].forwardRef(function TableHeaderCell(_ref, ref) {
	  var _getClassNames, _getClassNames2;

	  var className = _ref.className,
	      children = _ref.children,
	      sortDirection = _ref.sortDirection,
	      breakWord = _ref.breakWord,
	      type = _ref.type,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1h);

	  var classNames = classnames(styles$14.table_cell, styles$14.table_cell_header, (_getClassNames = {}, _getClassNames[styles$14.table_cell_checkbox] = type === 'checkbox', _getClassNames), (_getClassNames2 = {}, _getClassNames2[styles$14.table_cell__breakWord] = breakWord, _getClassNames2), className);
	  var ariaSort = null;

	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "th",
	    className: classNames,
	    "aria-sort": ariaSort,
	    ref: ref
	  }, props), children);
	});

	var _excluded$1i = ["className", "children", "breakWord"];
	var TableMobileHeadingCell = /*#__PURE__*/React__default['default'].forwardRef(function TableMobileHeadingCell(_ref, ref) {
	  var _getClassNames;

	  var className = _ref.className,
	      children = _ref.children,
	      breakWord = _ref.breakWord,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1i);

	  var classNames = classnames(styles$14.table_cell, styles$14.table_cell_heading, (_getClassNames = {}, _getClassNames[styles$14.table_cell__breakWord] = breakWord, _getClassNames), className);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "th",
	    className: classNames,
	    ref: ref
	  }, props), children);
	});

	var _excluded$1j = ["active", "children", "sortDirection", "hideSortIcon", "onClick", "className"];
	var TableSortLabel = /*#__PURE__*/React__default['default'].forwardRef(function TableSortLabel(_ref, ref) {
	  var active = _ref.active,
	      children = _ref.children,
	      _ref$sortDirection = _ref.sortDirection,
	      sortDirection = _ref$sortDirection === void 0 ? 'desc' : _ref$sortDirection,
	      hideSortIcon = _ref.hideSortIcon,
	      onClick = _ref.onClick,
	      className = _ref.className,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1j);

	  var getIconState = function getIconState() {
	    if (active) {
	      switch (sortDirection) {
	        case 'asc':
	          return 'chevron-up';

	        case 'desc':
	          return 'chevron-down';
	      }
	    }

	    return 'sorter';
	  };

	  var classNames = classnames([styles$14.table_sort_label, {
	    table_sort_label_active: active
	  }, className]);
	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "span",
	    className: classNames,
	    ref: ref,
	    onClick: onClick
	  }, props), children, !hideSortIcon && /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: getIconState(),
	    size: "sm",
	    color: active ? 'black' : 'gray500'
	  }));
	});

	var _excluded$1k = ["mobileBreakpoint", "children", "className", "layout"];
	var TableWithoutSubComponents = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
	  var _ref2, _ref3, _ref4;

	  var _ref$mobileBreakpoint = _ref.mobileBreakpoint,
	      mobileBreakpoint = _ref$mobileBreakpoint === void 0 ? 'sm' : _ref$mobileBreakpoint,
	      children = _ref.children,
	      className = _ref.className,
	      _ref$layout = _ref.layout,
	      layout = _ref$layout === void 0 ? 'auto' : _ref$layout,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1k);

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "table",
	    ref: ref
	  }, props, {
	    className: [className, styles$14.table, styles$14.table_table, (_ref2 = {}, _ref2[styles$14.table_table__auto] = layout === 'auto', _ref2), (_ref3 = {}, _ref3[styles$14.table_table__fixed] = layout === 'fixed', _ref3), (_ref4 = {}, _ref4[styles$14.table_table__mobileLayout_xxxs] = mobileBreakpoint === 'xxxs', _ref4[styles$14.table_table__mobileLayout_xxs] = mobileBreakpoint === 'xxs', _ref4[styles$14.table_table__mobileLayout_xs] = mobileBreakpoint === 'xs', _ref4[styles$14.table_table__mobileLayout_sm] = mobileBreakpoint === 'sm', _ref4[styles$14.table_table__mobileLayout_md] = mobileBreakpoint === 'md', _ref4[styles$14.table_table__mobileLayout_lg] = mobileBreakpoint === 'lg', _ref4[styles$14.table_table__mobileLayout_xlg] = mobileBreakpoint === 'xlg', _ref4)]
	  }), children);
	});

	var Table = function Table(_ref5) {
	  var props = assign$4({}, _ref5);

	  return /*#__PURE__*/React__default['default'].createElement(TableWithoutSubComponents, props);
	};

	Table.Row = TableRow;
	Table.Cell = TableCell;
	Table.HeaderCell = TableHeaderCell;
	Table.MobileHeadingCell = TableMobileHeadingCell;
	Table.SortLabel = TableSortLabel;

	var styles$15 = {"tagText__size_md":"telia-react-tagText__size_md","tagText__size_sm":"telia-react-tagText__size_sm"};

	var _excluded$1l = ["tagName", "size", "className", "children"];

	function TagText(_ref) {
	  var tagName = _ref.tagName,
	      _ref$size = _ref.size,
	      size = _ref$size === void 0 ? 'md' : _ref$size,
	      className = _ref.className,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1l);

	  var classNames = [styles$15["tagText__size_" + size.toLowerCase()], className];
	  return /*#__PURE__*/React__default['default'].createElement(Typography, _extends_1({}, props, {
	    tagName: tagName // this circumvents some weird ts problem
	    ,
	    font: "teliasans",
	    className: classNames,
	    uppercase: true,
	    fontWeight: "bold"
	  }), children);
	}

	var supportedTagTextSizes = ['md', 'sm'];

	var styles$16 = {"tag__text":"telia-react-tag__text"};

	var _excluded$1m = ["backgroundColor", "children"];

	var Tag = function Tag(_ref) {
	  var _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === void 0 ? 'red600' : _ref$backgroundColor,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1m);

	  var tagText = children || /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, "\xA0");
	  return /*#__PURE__*/React__default['default'].createElement(Span, _extends_1({}, props, {
	    backgroundColor: backgroundColor,
	    inlineBlock: true,
	    borderRadius: {
	      size: 'sm'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$16.tag__text,
	    padding: {
	      vertical: 'xxs',
	      horizontal: 'xs'
	    },
	    responsiveHidden: {
	      thinnerThan: 'sm'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(TagText, {
	    size: "md",
	    color: backgroundColor === 'orange400' ? 'orange800' : 'white',
	    block: true
	  }, tagText)), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$16.tag__text,
	    padding: {
	      vertical: 'xxxs',
	      horizontal: 'xxs'
	    },
	    responsiveHidden: {
	      widerThan: 'xs'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(TagText, {
	    color: backgroundColor === 'orange400' ? 'orange800' : 'white',
	    size: "sm",
	    block: true
	  }, tagText)));
	};

	var supportedTagColors = ['gray400', 'black', 'red600', 'purple500', 'blue600', 'orange400'];

	var styles$17 = {"progressBar":"telia-react-progressBar","progressBar_background":"telia-react-progressBar_background"};

	var _excluded$1n = ["current", "min", "max", "units", "label", "description", "color"];
	var supportedProgressBarColors = ['purple500', 'green700', 'orange500'];
	var ROUND_PRECISION = 1000;

	var getPercentage = function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  if (percentage > 100) percentage = 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	};

	var ProgressBar = function ProgressBar(_ref) {
	  var _ref$current = _ref.current,
	      current = _ref$current === void 0 ? 0 : _ref$current,
	      _ref$min = _ref.min,
	      min = _ref$min === void 0 ? 0 : _ref$min,
	      max = _ref.max,
	      units = _ref.units,
	      label = _ref.label,
	      description = _ref.description,
	      _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'purple500' : _ref$color,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1n);

	  var percentage = getPercentage(current, min, max);
	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    flexItem: {
	      sizeMultiplier: 1
	    }
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    spaceBetween: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    color: "black",
	    tagName: "span",
	    fontWeight: "bold",
	    "data-testid": "label"
	  }, label), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    color: "black"
	  }, current, " /", ' ', /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    color: "black",
	    tagName: "span",
	    fontWeight: "bold"
	  }, max, " ", units)))), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$17.progressBar_background
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    style: {
	      width: percentage + "%"
	    },
	    className: styles$17.progressBar,
	    backgroundColor: color
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    color: "black",
	    tagName: "span",
	    size: "sm"
	  }, description));
	};

	var styles$18 = {"userDropdown_container__relative":"telia-react-userDropdown_container__relative","userDropdown_container__mobileResponsive":"telia-react-userDropdown_container__mobileResponsive","userDropdown_backdrop":"telia-react-userDropdown_backdrop","userDropdown_items":"telia-react-userDropdown_items","userDropdown_items__mobileResponsive":"telia-react-userDropdown_items__mobileResponsive","userDropdown_items__nowrap":"telia-react-userDropdown_items__nowrap","userDropdown__borderBottom":"telia-react-userDropdown__borderBottom"};

	var _excluded$1o = ["iconName", "children", "onClick"];

	var UserDropdownItem = function UserDropdownItem(_ref) {
	  var iconName = _ref.iconName,
	      children = _ref.children,
	      onClick = _ref.onClick,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1o);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    padding: {
	      size: 'md'
	    },
	    clickableAppearance: true,
	    backgroundHoverColor: "gray100",
	    className: styles$18.userDropdown__borderBottom,
	    onClick: onClick
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: iconName,
	    size: "md",
	    color: "black"
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, null), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    block: true,
	    fontWeight: "medium",
	    color: "black"
	  }, children)), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }));
	};

	var _excluded$1p = ["name", "username", "children"];

	var UserDropdownAccount = function UserDropdownAccount(_ref) {
	  var name = _ref.name,
	      username = _ref.username,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1p);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    padding: {
	      size: 'md'
	    },
	    className: styles$18.userDropdown__borderBottom
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "pebble",
	    size: "md",
	    color: "purple500",
	    margin: {
	      bottom: 'sm'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, null), /*#__PURE__*/React__default['default'].createElement(Div, null, name && /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    block: true,
	    fontWeight: "medium",
	    className: "name-test",
	    color: "black"
	  }, name), username && /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "xs",
	    className: [styles$18.userDropdown_items__nowrap, 'username-test']
	  }, username), children && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(Div, null, children)))));
	};

	var _excluded$1q = ["label", "isOpen", "mobileResponsive", "children"];

	var UserDropdown = function UserDropdown(_ref) {
	  var _ref2, _ref3;

	  var label = _ref.label,
	      isOpen = _ref.isOpen,
	      mobileResponsive = _ref.mobileResponsive,
	      children = _ref.children,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1q);

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: [[styles$18.userDropdown_container__relative], (_ref2 = {}, _ref2[styles$18.userDropdown_container__mobileResponsive] = mobileResponsive, _ref2)]
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    clickableAppearance: true,
	    responsiveHidden: {
	      widerThan: 'sm'
	    },
	    margin: {
	      vertical: 'sm'
	    },
	    name: "end-user",
	    size: "md"
	  })), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    responsiveHidden: {
	      thinnerThan: 'md'
	    },
	    centeredVertically: true,
	    clickableAppearance: true,
	    margin: {
	      vertical: 'md'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "end-user",
	    size: "md"
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "sm"
	  }), label, /*#__PURE__*/React__default['default'].createElement(Gutter, null), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: !isOpen ? 'chevron-down' : 'chevron-up',
	    size: "sm",
	    color: "purple500",
	    className: "user-dropdown-arrow-icon-test"
	  })), isOpen && /*#__PURE__*/React__default['default'].createElement(Div, {
	    block: true,
	    backgroundColor: "white",
	    boxShadow: "sm",
	    className: [styles$18.userDropdown_items, (_ref3 = {}, _ref3[styles$18.userDropdown_items__mobileResponsive] = mobileResponsive, _ref3), 'dropdown-items-tests']
	  }, children));
	};

	UserDropdown.Account = UserDropdownAccount;
	UserDropdown.Item = UserDropdownItem;

	var styles$19 = {"selectionButtonGroup_button":"telia-react-selectionButtonGroup_button"};

	var _excluded$1r = ["options", "sideBySide", "narrow", "withShadow", "onClick"],
	    _excluded2$2 = ["children"];

	var SelectionButtonGroup = function SelectionButtonGroup(_ref) {
	  var options = _ref.options,
	      _ref$sideBySide = _ref.sideBySide,
	      sideBySide = _ref$sideBySide === void 0 ? options.length : _ref$sideBySide,
	      narrow = _ref.narrow,
	      withShadow = _ref.withShadow,
	      onClick = _ref.onClick,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1r);

	  var handleOnClick = function handleOnClick(event, id) {
	    var clickedOption = find$3(options).call(options, function (option) {
	      return option.id === id;
	    });

	    onClick(event, clickedOption);
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Flex, _extends_1({
	    wrapContent: true,
	    className: styles$19.selectionButtonGroup
	  }, props), map$3(options).call(options, function (option, index) {
	    var amountOfMargins = sideBySide;
	    var classNames = [styles$19.selectionButtonGroup_button];
	    option.className && classNames.push(option.className);

	    var children = option.children,
	        optionProps = objectWithoutPropertiesLoose(option, _excluded2$2);

	    return /*#__PURE__*/React__default['default'].createElement(SelectionButton, _extends_1({}, optionProps, {
	      key: index,
	      className: classNames,
	      narrow: narrow,
	      style: {
	        width: "calc((100% - " + amountOfMargins + " * 8px)/" + sideBySide + ")"
	      },
	      onClick: handleOnClick,
	      withShadow: withShadow
	    }), children);
	  }));
	};

	var styles$1a = {"pop_on_hover":"telia-react-pop_on_hover"};

	var PopOnHover = function PopOnHover(_ref) {
	  var children = _ref.children;
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1a.pop_on_hover
	  }, children);
	};

	var styles$1b = {"skeleton":"telia-react-skeleton","loading":"telia-react-loading","skeleton__height__xxs":"telia-react-skeleton__height__xxs","skeleton__height__xs":"telia-react-skeleton__height__xs","skeleton__height__sm":"telia-react-skeleton__height__sm","skeleton__height__md":"telia-react-skeleton__height__md","skeleton__height__lg":"telia-react-skeleton__height__lg","skeleton__height__xlg":"telia-react-skeleton__height__xlg","skeleton__height__xxlg":"telia-react-skeleton__height__xxlg","skeleton__width__xxs":"telia-react-skeleton__width__xxs","skeleton__width__xs":"telia-react-skeleton__width__xs","skeleton__width__sm":"telia-react-skeleton__width__sm","skeleton__width__md":"telia-react-skeleton__width__md","skeleton__width__lg":"telia-react-skeleton__width__lg","skeleton__width__xlg":"telia-react-skeleton__width__xlg","skeleton__width__xxlg":"telia-react-skeleton__width__xxlg"};

	var _excluded$1s = ["width", "widthInPercentages", "height", "heightInPercentages", "className", "borderRadius"];
	var style$4;
	var classNames$1;

	var Skeleton = function Skeleton(_ref) {
	  var _ref$width = _ref.width,
	      width = _ref$width === void 0 ? null : _ref$width,
	      _ref$widthInPercentag = _ref.widthInPercentages,
	      widthInPercentages = _ref$widthInPercentag === void 0 ? null : _ref$widthInPercentag,
	      _ref$height = _ref.height,
	      height = _ref$height === void 0 ? 50 : _ref$height,
	      _ref$heightInPercenta = _ref.heightInPercentages,
	      heightInPercentages = _ref$heightInPercenta === void 0 ? null : _ref$heightInPercenta,
	      className = _ref.className,
	      _ref$borderRadius = _ref.borderRadius,
	      borderRadius = _ref$borderRadius === void 0 ? {
	    size: 'sm'
	  } : _ref$borderRadius,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1s);

	  /* istanbul ignore next */
	  style$4 = {
	    width: width ? width + "px" : undefined,
	    height: height ? height + "px" : undefined
	  };
	  classNames$1 = [className, styles$1b.skeleton];

	  if (widthInPercentages) {
	    style$4.width = widthInPercentages + "%";
	  }

	  if (heightInPercentages) {
	    style$4.height = heightInPercentages + "%";
	  }

	  if (typeof width === 'string') {
	    classNames$1.push(styles$1b["skeleton__width__" + width]);
	    delete style$4.width;
	  }

	  if (typeof height === 'string') {
	    classNames$1.push(styles$1b["skeleton__height__" + height]);
	    delete style$4.height;
	  }

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: classNames$1,
	    style: style$4,
	    borderRadius: borderRadius
	  }, props));
	};

	var styles$1c = {"drawer":"telia-react-drawer"};

	var _excluded$1t = ["isOpen", "onCloseClick", "children", "showBackdrop", "automaticScrollPrevention"];
	var Drawer = function Drawer(_ref) {
	  var _ref$isOpen = _ref.isOpen,
	      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
	      onCloseClick = _ref.onCloseClick,
	      children = _ref.children,
	      _ref$showBackdrop = _ref.showBackdrop,
	      showBackdrop = _ref$showBackdrop === void 0 ? true : _ref$showBackdrop,
	      _ref$automaticScrollP = _ref.automaticScrollPrevention,
	      automaticScrollPrevention = _ref$automaticScrollP === void 0 ? true : _ref$automaticScrollP,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1t);

	  if (automaticScrollPrevention) {
	    usePreventScroll(isOpen && showBackdrop);
	  }

	  React.useEffect(function () {
	    var closeKeyHandler = function closeKeyHandler(_ref2) {
	      var key = _ref2.key;

	      if (key === 'Escape') {
	        onCloseClick == null ? void 0 : onCloseClick();
	      }
	    };

	    document.addEventListener('keydown', closeKeyHandler);
	    return function () {
	      document.removeEventListener('keydown', closeKeyHandler);
	    };
	  });
	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1c.drawer]
	  }, /*#__PURE__*/React__default['default'].createElement(_default, {
	    duration: 250,
	    height: isOpen ? 'auto' : 0
	  }, /*#__PURE__*/React__default['default'].createElement(Div, props, children))), /*#__PURE__*/React__default['default'].createElement(Backdrop, {
	    isVisible: showBackdrop && isOpen,
	    onCloseClick: onCloseClick
	  }));
	};

	var styles$1d = {"overflowMenu":"telia-react-overflowMenu","overflowMenu_iconWrapper":"telia-react-overflowMenu_iconWrapper","overflowMenu_content":"telia-react-overflowMenu_content","overflowMenu_content__left":"telia-react-overflowMenu_content__left","overflowMenu_content__right":"telia-react-overflowMenu_content__right"};

	var styles$1e = {"overflowMenuItem__disabled":"telia-react-overflowMenuItem__disabled","overflowMenuItem":"telia-react-overflowMenuItem"};

	var _excluded$1u = ["label", "iconName", "onClick", "variant"];
	var OverflowMenuItem = function OverflowMenuItem(_ref) {
	  var _ref2;

	  var label = _ref.label,
	      iconName = _ref.iconName,
	      onClick = _ref.onClick,
	      _ref$variant = _ref.variant,
	      variant = _ref$variant === void 0 ? 'active' : _ref$variant,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1u);

	  var onKeyDown = function onKeyDown(event) {
	    if (event.key === 'Enter' && onClick && variant !== 'disabled') {
	      onClick();
	      event.preventDefault();
	    }
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Flex, _extends_1({}, props, {
	    onClick: variant !== 'disabled' ? onClick : undefined,
	    centeredVertically: true,
	    className: ['overflow-menu-item-test', styles$1e.overflowMenuItem, (_ref2 = {}, _ref2[styles$1e.overflowMenuItem__disabled] = variant === 'disabled', _ref2)],
	    onKeyDown: onKeyDown,
	    tabIndex: onClick && variant !== 'disabled' ? 0 : undefined,
	    clickableAppearance: !!onClick,
	    padding: {
	      vertical: 'xs',
	      horizontal: 'sm'
	    },
	    backgroundColor: "white",
	    backgroundHoverColor: "gray200",
	    hoverColor: variant === 'destructive' ? 'red600' : 'black'
	  }), iconName && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: iconName,
	    size: "sm"
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  })), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, label));
	};

	var useOverflowMenu = function useOverflowMenu(menuRef, onClick, open) {
	  React.useEffect(function () {
	    var closeKeyHandler = function closeKeyHandler(_ref) {
	      var key = _ref.key;

	      if (key === 'Escape' && open) {
	        onClick == null ? void 0 : onClick();
	      }
	    };

	    var onMouseDown = function onMouseDown(event) {
	      var _menuRef$current;

	      var clickedInsideContainer = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(event.target);

	      if (clickedInsideContainer || !open) {
	        return;
	      }

	      onClick == null ? void 0 : onClick();
	    };

	    document.addEventListener('keydown', closeKeyHandler);
	    document.addEventListener('mousedown', onMouseDown);
	    return function () {
	      document.removeEventListener('keydown', closeKeyHandler);
	      document.removeEventListener('mousedown', onMouseDown);
	    };
	  });
	};

	var _excluded$1v = ["onClick", "open", "position", "children", "backgroundColor"];
	var OverflowMenu = function OverflowMenu(_ref) {
	  var _ref2, _ref3;

	  var onClick = _ref.onClick,
	      open = _ref.open,
	      _ref$position = _ref.position,
	      position = _ref$position === void 0 ? 'right' : _ref$position,
	      children = _ref.children,
	      _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1v);

	  var menuRef = React.useRef(null);

	  var onKeyDown = function onKeyDown(event) {
	    if (event.key === 'Enter' && onClick) {
	      onClick();
	      event.preventDefault();
	    }
	  };

	  useOverflowMenu(menuRef, onClick, open);
	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({}, props, {
	    className: styles$1d.overflowMenu,
	    refElement: menuRef
	  }), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: [styles$1d.overflowMenu_iconWrapper, 'overflow-menu-test'],
	    centered: true,
	    borderRadius: {
	      size: 'rounded'
	    },
	    clickableAppearance: true,
	    onKeyDown: onKeyDown,
	    tabIndex: 0,
	    onClick: onClick,
	    backgroundColor: open ? 'gray200' : backgroundColor
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "more-vertical",
	    size: "md"
	  })), open && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1d.overflowMenu_content, (_ref2 = {}, _ref2[styles$1d.overflowMenu_content__left] = position === 'left', _ref2), (_ref3 = {}, _ref3[styles$1d.overflowMenu_content__right] = position === 'right', _ref3)],
	    boxShadow: "sm"
	  }, children));
	};
	OverflowMenu.Item = OverflowMenuItem;

	// `SameValue` abstract operation
	// https://tc39.es/ecma262/#sec-samevalue
	var sameValue = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

	// @@search logic
	fixRegexpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.es/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = requireObjectCoercible$1(this);
	      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
	      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative(nativeSearch, regexp, this);
	      if (res.done) return res.value;

	      var rx = anObject$1(regexp);
	      var S = String(this);

	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regexpExecAbstract(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});

	var $some = arrayIteration.some;



	var STRICT_METHOD$5 = arrayMethodIsStrict('some'); // `Array.prototype.some` method
	// https://tc39.es/ecma262/#sec-array.prototype.some

	_export({
	  target: 'Array',
	  proto: true,
	  forced: !STRICT_METHOD$5
	}, {
	  some: function some(callbackfn
	  /* , thisArg */
	  ) {
	    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	var some = entryVirtual('Array').some;

	var ArrayPrototype$e = Array.prototype;

	var some$1 = function (it) {
	  var own = it.some;
	  return it === ArrayPrototype$e || objectIsPrototypeOf(ArrayPrototype$e, it) && own === ArrayPrototype$e.some ? some : own;
	};

	var some$2 = some$1;

	var some$3 = some$2;

	var styles$1f = {"cart":"telia-react-cart","cart_amount":"telia-react-cart_amount","cart_amountNumber":"telia-react-cart_amountNumber"};

	var Cart = function Cart(_ref) {
	  var link = _ref.link,
	      amount = _ref.amount,
	      linkAriaLabel = _ref.linkAriaLabel,
	      linkAdapter = _ref.linkAdapter,
	      _ref$openModalPopup = _ref.openModalPopup,
	      openModalPopup = _ref$openModalPopup === void 0 ? false : _ref$openModalPopup,
	      ModalContent = _ref.ModalContent,
	      ModalTitle = _ref.ModalTitle;
	  var title = ModalTitle != null ? ModalTitle : 'Ostoskorissasi on tuotteita molemmista verkkokaupoistamme';

	  var _useState = React.useState(false),
	      openModal = _useState[0],
	      setOpenModal = _useState[1];

	  var modalContentAsHTML = ModalContent != null ? ModalContent : '';

	  var openModalOnClick = function openModalOnClick() {
	    setOpenModal(true);
	    return;
	  };

	  var closeModalOnClick = function closeModalOnClick() {
	    setOpenModal(false);
	    return;
	  }; // eslint-disable-next-line no-constant-condition


	  return openModalPopup ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ModalDialog, {
	    isOpen: openModal,
	    "data-testid": "shoppingCartModal",
	    title: title,
	    onCloseClick: closeModalOnClick
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    dangerouslySetInnerHTML: {
	      __html: modalContentAsHTML
	    }
	  })), /*#__PURE__*/React__default['default'].createElement(Link, {
	    className: styles$1f.cart,
	    "aria-label": linkAriaLabel,
	    linkAdapter: linkAdapter
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    "data-testid": "shoppingCartIconWithModal",
	    name: "cart",
	    size: "lg",
	    color: "black",
	    onClick: openModalOnClick
	  }), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1f.cart_amount,
	    onClick: openModalOnClick
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "pebble",
	    size: "md",
	    color: "purple500",
	    className: styles$1f.cart_amount
	  }), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1f.cart_amountNumber
	  }, amount)))) : /*#__PURE__*/React__default['default'].createElement(Link, {
	    className: styles$1f.cart,
	    to: link,
	    "aria-label": linkAriaLabel,
	    linkAdapter: linkAdapter
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "cart",
	    size: "lg",
	    color: "black"
	  }), amount && amount > 0 ? /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1f.cart_amount
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "pebble",
	    size: "md",
	    color: "purple500",
	    className: styles$1f.cart_amount
	  }), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1f.cart_amountNumber
	  }, amount)) : null);
	};

	var styles$1g = {"topBar":"telia-react-topBar"};

	var styles$1h = {"siteLinks_siteLink":"telia-react-siteLinks_siteLink","siteLinks__forceDesktop":"telia-react-siteLinks__forceDesktop","siteLinks_siteLink__active":"telia-react-siteLinks_siteLink__active","siteLinks_link":"telia-react-siteLinks_link"};

	var SiteLink = function SiteLink(_ref) {
	  var _classnames;

	  var link = _ref.link,
	      linkAdapter = _ref.linkAdapter;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    "data-testid": "site-link",
	    key: link.text,
	    onClick: link.url ? undefined : function (event) {
	      event.preventDefault();
	      if (link.onClick) link.onClick(event);
	    },
	    className: classnames((_classnames = {}, _classnames[styles$1h.siteLinks_siteLink] = true, _classnames[styles$1h.siteLinks_siteLink__active] = link.active, _classnames))
	  }, /*#__PURE__*/React__default['default'].createElement(Link, {
	    "data-testid": "site-link-link",
	    className: styles$1h.siteLinks_link,
	    to: link.url,
	    color: link.active ? 'black' : 'gray500',
	    hoverColor: "black",
	    linkAdapter: linkAdapter
	  }, link.text));
	};

	var _excluded$1w = ["links", "desktopStylesInMobile", "className", "linkAdapter"];

	var SiteLinks = function SiteLinks(_ref) {
	  var _classnames;

	  var links = _ref.links,
	      desktopStylesInMobile = _ref.desktopStylesInMobile,
	      className = _ref.className,
	      linkAdapter = _ref.linkAdapter,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1w);

	  return /*#__PURE__*/React__default['default'].createElement(GutterBag, _extends_1({
	    showOverflow: true,
	    "data-testid": "site-links",
	    className: classnames([styles$1h.siteLinks], (_classnames = {}, _classnames[styles$1h.siteLinks__forceDesktop] = desktopStylesInMobile, _classnames), className),
	    contents: map$3(links).call(links, function (link) {
	      return /*#__PURE__*/React__default['default'].createElement(SiteLink, {
	        key: link.text,
	        link: link,
	        linkAdapter: linkAdapter
	      });
	    }),
	    spacing: {
	      horizontal: 'sm',
	      vertical: 'zero'
	    }
	  }, props));
	};

	var TopBar = function TopBar(_ref) {
	  var segments = _ref.segments,
	      languages = _ref.languages,
	      linkAdapter = _ref.linkAdapter;
	  return /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true,
	    spaceBetween: !!segments,
	    reverseDirection: !!languages && !segments,
	    className: styles$1g.topBar
	  }, segments && /*#__PURE__*/React__default['default'].createElement(SiteLinks, {
	    "data-testid": "segment-site-links",
	    links: segments,
	    linkAdapter: linkAdapter
	  }), languages && /*#__PURE__*/React__default['default'].createElement(SiteLinks, {
	    "data-testid": "language-site-links",
	    links: languages,
	    linkAdapter: linkAdapter
	  }));
	};

	var styles$1i = {"search":"telia-react-search","search_inputWrapper":"telia-react-search_inputWrapper","search_inputWrapper__active":"telia-react-search_inputWrapper__active","search_icon":"telia-react-search_icon","search_closeIcon":"telia-react-search_closeIcon","search_input":"telia-react-search_input","search_overlay":"telia-react-search_overlay","search_overlay__visible":"telia-react-search_overlay__visible"};

	/* istanbul ignore next */

	var injectScript = function injectScript(url) {
	  React.useEffect(function () {
	    var script = document.createElement('script');
	    script.src = url;
	    script.async = true;
	    document.body.appendChild(script);
	    return function () {
	      document.body.removeChild(script);
	    };
	  }, [url]);
	};

	/* istanbul ignore next */
	var addAdditionalSearchStyles = function addAdditionalSearchStyles(cssClassName) {
	  window.addsearch_settings = {
	    results_box_css_classname: cssClassName
	  };
	};

	var Search = function Search(_ref) {
	  var _classnames, _classnames2;

	  var placeholder = _ref.placeholder,
	      searchPageUrl = _ref.searchPageUrl,
	      addSearchScriptUrl = _ref.addSearchScriptUrl,
	      _ref$addSearchScriptK = _ref.addSearchScriptKey,
	      addSearchScriptKey = _ref$addSearchScriptK === void 0 ? '' : _ref$addSearchScriptK,
	      isOpen = _ref.isOpen,
	      addAdditionalSearchStyle = _ref.addAdditionalSearchStyle,
	      additionalSearchCssClasses = _ref.additionalSearchCssClasses,
	      onSearchToggle = _ref.onSearchToggle;
	  var textInput = /*#__PURE__*/React__default['default'].createRef(); // AddSearch script injection. Search will not work without it.

	  injectScript("" + addSearchScriptUrl + addSearchScriptKey);

	  if (addAdditionalSearchStyle) {
	    addAdditionalSearchStyles(additionalSearchCssClasses);
	  }

	  React.useEffect(function () {
	    if (isOpen) {
	      var _textInput$current;

	      (_textInput$current = textInput.current) == null ? void 0 : _textInput$current.focus();
	    }
	  }, [isOpen]);
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1i.search
	  }, /*#__PURE__*/React__default['default'].createElement("form", {
	    action: searchPageUrl,
	    method: "GET",
	    className: styles$1i.search_form
	  }, /*#__PURE__*/React__default['default'].createElement("div", {
	    "data-testid": "search-overlay",
	    onClick: function onClick() {
	      return onSearchToggle();
	    },
	    className: classnames((_classnames = {}, _classnames[styles$1i.search_overlay] = true, _classnames[styles$1i.search_overlay__visible] = isOpen, _classnames))
	  }), /*#__PURE__*/React__default['default'].createElement("div", {
	    "data-testid": "search",
	    className: classnames((_classnames2 = {}, _classnames2[styles$1i.search_inputWrapper] = true, _classnames2[styles$1i.search_inputWrapper__active] = isOpen, _classnames2))
	  }, /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "button",
	    "data-testid": "search-open-icon",
	    className: styles$1i.search_icon,
	    onClick: function onClick(event) {
	      !isOpen && event.preventDefault();
	      onSearchToggle();
	    },
	    tabIndex: 0
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "search",
	    size: "lg",
	    color: "black"
	  })), /*#__PURE__*/React__default['default'].createElement("input", {
	    "data-addsearch-field": true,
	    disabled: true,
	    ref: textInput,
	    autoComplete: "off",
	    className: classnames(styles$1i.search_input, 'addsearch'),
	    type: "text",
	    placeholder: placeholder,
	    tabIndex: isOpen ? 0 : -1
	  }), /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "button",
	    "data-testid": "search-close-icon",
	    className: styles$1i.search_closeIcon,
	    onClick: function onClick(event) {
	      event.preventDefault();
	      onSearchToggle();
	    },
	    tabIndex: isOpen ? 0 : -1
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "close",
	    size: "lg",
	    color: "black"
	  })))));
	};

	var styles$1j = {"login":"telia-react-login","login_heading":"telia-react-login_heading","login_tabs__container":"telia-react-login_tabs__container","login_additionalLinkContent":"telia-react-login_additionalLinkContent"};

	var Login = function Login(_ref) {
	  var headingText = _ref.headingText,
	      tabs = _ref.tabs,
	      _ref$defaultActiveTab = _ref.defaultActiveTabIndex,
	      defaultActiveTabIndex = _ref$defaultActiveTab === void 0 ? 0 : _ref$defaultActiveTab,
	      additionalLinks = _ref.additionalLinks;
	  return /*#__PURE__*/React__default['default'].createElement("div", {
	    "data-testid": "login",
	    className: styles$1j.login
	  }, /*#__PURE__*/React__default['default'].createElement(Headline, {
	    size: "md",
	    className: styles$1j.login_heading
	  }, headingText), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1j.login_tabs__container
	  }, /*#__PURE__*/React__default['default'].createElement(Tabs, {
	    defaultActiveTabIndex: defaultActiveTabIndex,
	    tabs: tabs
	  })), additionalLinks && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, map$3(additionalLinks).call(additionalLinks, function (additionalLink) {
	    return /*#__PURE__*/React__default['default'].createElement(Div, {
	      backgroundColor: "gray100",
	      key: additionalLink.label
	    }, /*#__PURE__*/React__default['default'].createElement(Divider, {
	      color: "gray300"
	    }), /*#__PURE__*/React__default['default'].createElement(Link, {
	      color: "black",
	      hoverColor: "black",
	      to: additionalLink.link,
	      "data-testid": "additional-link"
	    }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	      className: styles$1j.login_additionalLinkContent
	    }, additionalLink.icon && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon, {
	      name: additionalLink.icon,
	      size: "md",
	      color: "black"
	    }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	      size: "xs"
	    })), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	      tagName: "span"
	    }, additionalLink.label))));
	  })));
	};

	var styles$1k = {"userMenu_username":"telia-react-userMenu_username","userMenu_userloginHistory":"telia-react-userMenu_userloginHistory","userMenu_link":"telia-react-userMenu_link","userMenu_logoutButton":"telia-react-userMenu_logoutButton","userMenu_additionalLinkContent":"telia-react-userMenu_additionalLinkContent"};

	var UserMenu = function UserMenu(_ref) {
	  var username = _ref.username,
	      userloginHistoryKey = _ref.userloginHistoryKey,
	      userloginHistory = _ref.userloginHistory,
	      userloginHistoryLink = _ref.userloginHistoryLink,
	      userMenuLinks = _ref.userMenuLinks,
	      logoutButton = _ref.logoutButton,
	      additionalLinks = _ref.additionalLinks,
	      additionalLinkAlignLeft = _ref.additionalLinkAlignLeft;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1k.userMenu,
	    "data-testid": "logged-in"
	  }, /*#__PURE__*/React__default['default'].createElement(Title, {
	    color: "black",
	    block: true,
	    className: styles$1k.userMenu_username,
	    size: "xxs",
	    "data-testid": "logged-in-username"
	  }, username), userloginHistory && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "sm"
	  }), /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    className: styles$1k.userMenu_userloginHistory
	  }, userloginHistoryKey, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xxs",
	    style: {
	      minHeight: '2px'
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    size: "sm",
	    "data-testid": "logged-in-userloginHistory"
	  }, userloginHistoryLink ? /*#__PURE__*/React__default['default'].createElement(Link, {
	    block: true,
	    "data-testid": "logged-in-history-link",
	    to: userloginHistoryLink
	  }, userloginHistory) : userloginHistory)))), /*#__PURE__*/React__default['default'].createElement(Divider, {
	    color: "gray300",
	    width: 100
	  })), userMenuLinks && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "sm"
	  }), map$3(userMenuLinks).call(userMenuLinks, function (_ref2) {
	    var link = _ref2.link,
	        label = _ref2.label,
	        key = _ref2.key,
	        icon = _ref2.icon,
	        openInNewWindow = _ref2.openInNewWindow;
	    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
	      key: key ? key : label
	    }, /*#__PURE__*/React__default['default'].createElement(Link, {
	      block: true,
	      className: styles$1k.userMenu_link,
	      "data-testid": "logged-in-link",
	      to: link,
	      openInNewWindow: openInNewWindow
	    }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	      centeredVertically: true
	    }, icon && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon, {
	      name: icon,
	      color: "inherit",
	      size: "sm"
	    }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	      size: "xs"
	    })), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	      tagName: "span",
	      size: "sm"
	    }, label))), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	      size: "sm"
	    }));
	  })), /*#__PURE__*/React__default['default'].createElement(Divider, {
	    color: "gray300",
	    width: 100
	  }), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    backgroundHoverColor: "gray200",
	    className: styles$1k.userMenu_logoutButton,
	    "data-testid": "logged-in-logout-button",
	    onClick: logoutButton.onLogoutButtonClick,
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement("svg", {
	    viewBox: "0 0 64 64",
	    height: "18",
	    width: "18"
	  }, /*#__PURE__*/React__default['default'].createElement("path", {
	    fill: colors$1.black.color,
	    d: "M57.41278,33.41534,45.41406,45.41406a1.99978,1.99978,0,0,1-2.82812-2.82812L51.17151,34H24a2,2,0,0,1,0-4H51.17151l-8.58557-8.58594a1.99978,1.99978,0,0,1,2.82812-2.82812L57.41278,30.58466a2.00855,2.00855,0,0,1,.25073.30664c.03174.04748.05335.099.08057.14843a1.17162,1.17162,0,0,1,.165.39539c.01715.05786.03949.11334.05139.17334a2.00573,2.00573,0,0,1,0,.78308c-.0119.06-.03424.11548-.05139.17334a1.17162,1.17162,0,0,1-.165.39539c-.02722.04943-.04883.10095-.08057.14843A2.00855,2.00855,0,0,1,57.41278,33.41534ZM34,52H16a4.00427,4.00427,0,0,1-4-4V16a4.00427,4.00427,0,0,1,4-4H34a2,2,0,0,0,0-4H16a8.00917,8.00917,0,0,0-8,8V48a8.00917,8.00917,0,0,0,8,8H34a2,2,0,0,0,0-4Z"
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, logoutButton.logoutButtonLabel)), additionalLinks && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, map$3(additionalLinks).call(additionalLinks, function (_ref3) {
	    var label = _ref3.label,
	        link = _ref3.link,
	        icon = _ref3.icon,
	        key = _ref3.key;
	    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
	      key: key ? key : label
	    }, /*#__PURE__*/React__default['default'].createElement(Divider, {
	      color: "gray300"
	    }), /*#__PURE__*/React__default['default'].createElement(Link, {
	      color: "gray800",
	      hoverColor: "gray800",
	      to: link,
	      "data-testid": "additional-link"
	    }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	      backgroundColor: "gray100",
	      backgroundHoverColor: "gray300",
	      className: styles$1k.userMenu_additionalLinkContent,
	      centeredVertically: true
	    }, additionalLinkAlignLeft && /*#__PURE__*/React__default['default'].createElement(BodyText, {
	      tagName: "span"
	    }, label), icon && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, additionalLinkAlignLeft && /*#__PURE__*/React__default['default'].createElement(Gutter, {
	      size: "xs",
	      flexItem: true
	    }), /*#__PURE__*/React__default['default'].createElement(Icon, {
	      name: icon,
	      size: "sm",
	      color: "gray500"
	    }), !additionalLinkAlignLeft && /*#__PURE__*/React__default['default'].createElement(Gutter, {
	      size: "xs"
	    })), !additionalLinkAlignLeft && /*#__PURE__*/React__default['default'].createElement(BodyText, {
	      tagName: "span"
	    }, label))));
	  })));
	};

	var styles$1l = {"menu":"telia-react-menu","menu_item":"telia-react-menu_item","menu__level3":"telia-react-menu__level3","menu_item__selected":"telia-react-menu_item__selected","menu__level1":"telia-react-menu__level1","menu__level2":"telia-react-menu__level2","menu_item__level1":"telia-react-menu_item__level1","menu_item__level2":"telia-react-menu_item__level2","menu_item__level3":"telia-react-menu_item__level3","menu_itemButton":"telia-react-menu_itemButton","menu_itemButton__level1":"telia-react-menu_itemButton__level1","menu_itemText":"telia-react-menu_itemText","menu_itemText__level1":"telia-react-menu_itemText__level1","menu_itemText__level2":"telia-react-menu_itemText__level2","menu_itemText__level3":"telia-react-menu_itemText__level3","menu_dropdownIcon":"telia-react-menu_dropdownIcon","menu_dropdownIcon__level1":"telia-react-menu_dropdownIcon__level1","menu_dropdownIcon__level2":"telia-react-menu_dropdownIcon__level2","menu_item__active":"telia-react-menu_item__active"};

	var MenuItem = function MenuItem(_ref) {
	  var _ref2, _ref3;

	  var text = _ref.text,
	      url = _ref.url,
	      menuItems = _ref.menuItems,
	      onMenuItemClick = _ref.onMenuItemClick,
	      id = _ref.id,
	      forMobile = _ref.forMobile,
	      _ref$level = _ref.level,
	      level = _ref$level === void 0 ? 1 : _ref$level,
	      _ref$isOpen = _ref.isOpen,
	      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
	      _ref$tabbable = _ref.tabbable,
	      tabbable = _ref$tabbable === void 0 ? true : _ref$tabbable,
	      linkAdapter = _ref.linkAdapter,
	      _ref$locked = _ref.locked,
	      locked = _ref$locked === void 0 ? false : _ref$locked,
	      _ref$showLockIcon = _ref.showLockIcon,
	      showLockIcon = _ref$showLockIcon === void 0 ? true : _ref$showLockIcon,
	      menuComponent = _ref.menuComponent,
	      active = _ref.active;
	  var Menu = menuComponent;
	  var hasSubItems = !!(menuItems != null && menuItems.length);
	  var dropdownIcon = /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1l.menu_dropdownIcon, styles$1l["menu_dropdownIcon__level" + level]]
	  }, /*#__PURE__*/React__default['default'].createElement("svg", {
	    viewBox: "0 0 16 9",
	    height: "10",
	    width: "10"
	  }, /*#__PURE__*/React__default['default'].createElement("path", {
	    d: "M8.077 7.088L14.37.633c.456-.456.786-.731 1.35-.18.564.55.174.98-.282 1.437L8.903 8.424a1.168 1.168 0 0 1-1.652 0L.717 1.89C.089 1.262-.301.872.297.274c.598-.598 1.01-.097 1.466.36l6.314 6.454z"
	  })));
	  var lockShown = Boolean(locked && showLockIcon);
	  return hasSubItems ? /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1l.menu_item, styles$1l["menu_item__level" + level], (_ref2 = {}, _ref2[styles$1l.menu_item__selected] = isOpen, _ref2)],
	    "data-menu": id,
	    "data-open": "" + isOpen,
	    onClick: function onClick(event) {
	      return onMenuItemClick && onMenuItemClick(event, id, level, false, url);
	    }
	  }, forMobile ? /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    "data-testid": "menu_item_tabbable",
	    block: true,
	    tagName: "button",
	    className: [styles$1l.menu_itemButton, styles$1l["menu_itemButton__level" + level]],
	    tabIndex: tabbable ? 0 : -1
	  }, /*#__PURE__*/React__default['default'].createElement(MarginSpace, null, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1l.menu_itemText, styles$1l["menu_itemText__level" + level]]
	  }, text, dropdownIcon))) : /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    "data-testid": "menu_item_tabbable",
	    tagName: "button",
	    className: [styles$1l.menu_itemText, styles$1l["menu_itemText__level" + level], (_ref3 = {}, _ref3[styles$1l.menu_item__active] = active, _ref3)],
	    tabIndex: tabbable ? 0 : -1
	  }, text, dropdownIcon), /*#__PURE__*/React__default['default'].createElement(Menu, {
	    "data-testid": "menu",
	    menuItems: menuItems,
	    level: level + 1,
	    onMenuItemClick: onMenuItemClick,
	    forMobile: forMobile,
	    linkAdapter: linkAdapter,
	    isOpen: isOpen
	  })) : /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1l.menu_item, styles$1l["menu_item__level" + level]],
	    "data-menuitem": id,
	    onClick: function onClick(event) {
	      /* istanbul ignore else */
	      if (locked) {
	        event.preventDefault();
	        /* istanbul ignore else */

	        if (url) {
	          localStorage.setItem('redirectLockedUrl', url);
	        }
	      }

	      onMenuItemClick == null ? void 0 : onMenuItemClick(event, id, level, locked, url);
	    }
	  }, forMobile ? /*#__PURE__*/React__default['default'].createElement(Link, {
	    "data-testid": "menu_item_tabbable",
	    color: "black",
	    hoverColor: "black",
	    to: url,
	    linkAdapter: linkAdapter,
	    className: [styles$1l.menu_itemText, styles$1l["menu_itemText__level" + level]],
	    tabIndex: tabbable ? 0 : -1,
	    occupyHorizontalSpace: true
	  }, /*#__PURE__*/React__default['default'].createElement(MarginSpace, null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    spaceBetween: true,
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, text), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "lock-closed",
	    size: "sm",
	    shown: lockShown,
	    "data-testid": "menu_item_lock_icon",
	    "data-shown": "" + lockShown
	  })))) : /*#__PURE__*/React__default['default'].createElement(Link, {
	    "data-testid": "menu_item_tabbable",
	    color: "black",
	    hoverColor: "black",
	    to: url,
	    linkAdapter: linkAdapter,
	    className: [styles$1l.menu_itemText, styles$1l["menu_itemText__level" + level]],
	    tabIndex: tabbable ? 0 : -1,
	    occupyHorizontalSpace: true
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    spaceBetween: true,
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, text), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "lock-closed",
	    size: "sm",
	    shown: lockShown,
	    "data-testid": "menu_item_lock_icon",
	    "data-shown": "" + lockShown
	  }))));
	};

	var Menu = function Menu(_ref) {
	  var menuItems = _ref.menuItems,
	      onMenuItemClick = _ref.onMenuItemClick,
	      forMobile = _ref.forMobile,
	      _ref$level = _ref.level,
	      level = _ref$level === void 0 ? 1 : _ref$level,
	      linkAdapter = _ref.linkAdapter,
	      _ref$isOpen = _ref.isOpen,
	      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;
	  return menuItems ? /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: [styles$1l.menu, styles$1l["menu__level" + level]]
	  }, map$3(menuItems).call(menuItems, function (menuItem) {
	    return /*#__PURE__*/React__default['default'].createElement(MenuItem, _extends_1({
	      "data-testid": "menuItem",
	      menuComponent: Menu
	    }, menuItem, {
	      level: level,
	      key: menuItem.id,
	      onMenuItemClick: onMenuItemClick,
	      forMobile: forMobile,
	      linkAdapter: linkAdapter,
	      tabbable: isOpen || level === 1
	    }));
	  })) : null;
	};

	var styles$1m = {"navigation":"telia-react-navigation","navigation__mobileMenuOpen":"telia-react-navigation__mobileMenuOpen","navigation_mainContainer":"telia-react-navigation_mainContainer","navigation_logo":"telia-react-navigation_logo","navigation_iconMenuItem":"telia-react-navigation_iconMenuItem","navigation_containerLoginIcon":"telia-react-navigation_containerLoginIcon","navigation_containerLoginIcon__loginText":"telia-react-navigation_containerLoginIcon__loginText","navigation_userInitials":"telia-react-navigation_userInitials","navigation_hamburger":"telia-react-navigation_hamburger","navigation_hamburger__active":"telia-react-navigation_hamburger__active","navigation_mobileMenuContainer":"telia-react-navigation_mobileMenuContainer","navigation_segmentLinksContainer":"telia-react-navigation_segmentLinksContainer","navigation_segmentLinks":"telia-react-navigation_segmentLinks","navigation_languageLinks":"telia-react-navigation_languageLinks","navigation_loggedOutContainer":"telia-react-navigation_loggedOutContainer","navigation_loggedInContainer":"telia-react-navigation_loggedInContainer","navigation_loggedInDrawerContainer":"telia-react-navigation_loggedInDrawerContainer","navigation_menuContainer":"telia-react-navigation_menuContainer","navigation_menuContainer__slideHidden":"telia-react-navigation_menuContainer__slideHidden"};

	var TypeError$i = global$1.TypeError; // `FlattenIntoArray` abstract operation
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

	var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? functionBindContext(mapper, thisArg) : false;
	  var element, elementLen;

	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

	      if (depth > 0 && isArray(element)) {
	        elementLen = lengthOfArrayLike(element);
	        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError$i('Exceed the acceptable array length');
	        target[targetIndex] = element;
	      }

	      targetIndex++;
	    }

	    sourceIndex++;
	  }

	  return targetIndex;
	};

	var flattenIntoArray_1 = flattenIntoArray;

	// `Array.prototype.flatMap` method
	// https://tc39.es/ecma262/#sec-array.prototype.flatmap


	_export({
	  target: 'Array',
	  proto: true
	}, {
	  flatMap: function flatMap(callbackfn
	  /* , thisArg */
	  ) {
	    var O = toObject(this);
	    var sourceLen = lengthOfArrayLike(O);
	    var A;
	    aCallable(callbackfn);
	    A = arraySpeciesCreate(O, 0);
	    A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return A;
	  }
	});

	var flatMap = entryVirtual('Array').flatMap;

	var ArrayPrototype$f = Array.prototype;

	var flatMap$1 = function (it) {
	  var own = it.flatMap;
	  return it === ArrayPrototype$f || objectIsPrototypeOf(ArrayPrototype$f, it) && own === ArrayPrototype$f.flatMap ? flatMap : own;
	};

	var flatMap$2 = flatMap$1;

	var flatMap$3 = flatMap$2;

	function ownKeys$h(object, enumerableOnly) { var keys = keys$5(object); if (getOwnPropertySymbols$3) { var symbols = getOwnPropertySymbols$3(object); if (enumerableOnly) { symbols = filter$3(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$3(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; forEach$3(_context4 = ownKeys$h(Object(source), true)).call(_context4, function (key) { defineProperty$8(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$2) { defineProperties$1(target, getOwnPropertyDescriptors$2(source)); } else { var _context5; forEach$3(_context5 = ownKeys$h(Object(source))).call(_context5, function (key) { defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key)); }); } } return target; }

	function flattenMenuItems(menuItems) {
	  return flatMap$3(menuItems).call(menuItems, function (item) {
	    if (item.menuItems) {
	      var _context;

	      var childMenuItems = flattenMenuItems(item.menuItems);
	      return concat$5(_context = [item]).call(_context, childMenuItems);
	    } else {
	      return [item];
	    }
	  });
	} // returns list of items parents, including parentId, granparentId etc.

	function getMenuItemsParentIds(menuItemId, flatMenuItemShapes, acc) {
	  if (acc === void 0) {
	    acc = [];
	  }

	  var parent = find$3(flatMenuItemShapes).call(flatMenuItemShapes, function (it) {
	    var _it$menuItems;

	    return (_it$menuItems = it.menuItems) == null ? void 0 : some$3(_it$menuItems).call(_it$menuItems, function (item) {
	      return item.id === menuItemId;
	    });
	  });

	  if (parent) {
	    var _context2;

	    return getMenuItemsParentIds(parent.id, flatMenuItemShapes, concat$5(_context2 = []).call(_context2, acc, [parent.id]));
	  } else {
	    return acc;
	  }
	} // Copy and add 'id' and 'isOpen' to all items recursively

	function addInternalMenuItemsProperties(menuItems, openMenuItems, parentId) {
	  if (menuItems === void 0) {
	    menuItems = [];
	  }

	  return map$3(menuItems).call(menuItems, function (child, index) {
	    var _context3;

	    var id = filter$3(_context3 = [parentId, "" + index]).call(_context3, Boolean).join('_');

	    if (!child.menuItems) {
	      return _objectSpread$c(_objectSpread$c({}, child), {}, {
	        id: id
	      });
	    }

	    return _objectSpread$c(_objectSpread$c({}, child), {}, {
	      id: id,
	      isOpen: includes$6(openMenuItems).call(openMenuItems, id),
	      menuItems: addInternalMenuItemsProperties(child.menuItems, openMenuItems, id)
	    });
	  });
	}

	var desktopBreakpoints = ['md', 'lg', 'xlg', 'xxlg'];

	var Navigation = function Navigation(_ref) {
	  var _ref2, _ref3, _classnames;

	  var cart = _ref.cart,
	      logo = _ref.logo,
	      segments = _ref.segments,
	      languages = _ref.languages,
	      search = _ref.search,
	      login = _ref.login,
	      userMenu = _ref.userMenu,
	      linkAdapter = _ref.linkAdapter,
	      menuItems = _ref.menuItems,
	      loginPageUrl = _ref.loginPageUrl;

	  var _useState = React.useState([]),
	      openMenuItems = _useState[0],
	      setOpenMenuItems = _useState[1]; // derive menuItems from openMenuItems and menuItems to create menuItemShapeList


	  var menuItemShapeList = React.useMemo(function () {
	    return addInternalMenuItemsProperties(menuItems, openMenuItems);
	  }, [menuItems, openMenuItems]);

	  var loginPageUrlWithCurrentPageUrlAsRedirect = function loginPageUrlWithCurrentPageUrlAsRedirect() {
	    var currentUrl = window.location.href;
	    var redirectUrl = loginPageUrl + "?redirect=" + currentUrl;
	    return redirectUrl;
	  };

	  var flatMenuItems = React.useMemo(function () {
	    return flattenMenuItems(menuItemShapeList);
	  }, [menuItemShapeList]);

	  var _useState2 = React.useState(false),
	      loginMenuOpen = _useState2[0],
	      setLoginMenuOpen = _useState2[1];

	  var onMenuItemClick = React.useCallback(function (event, menuItemId, level, locked, url) {
	    var _menuItem$menuItems;

	    event.stopPropagation();

	    if (locked) {
	      var redirectUrl = loginPageUrl + "?redirect=" + url;
	      setLoginMenuOpen(false);
	      setMobileMenuOpen(false); // This causes problems in tests "Error: Not implemented: navigation (except hash changes)"
	      // https://stackoverflow.com/questions/54090231/how-to-fix-error-not-implemented-navigation-except-hash-changes

	      window.location.href = redirectUrl;
	      return;
	    }

	    var menuItem = find$3(flatMenuItems).call(flatMenuItems, function (it) {
	      return it.id === menuItemId;
	    });

	    if (!((_menuItem$menuItems = menuItem.menuItems) != null && _menuItem$menuItems.length)) {
	      // we assume that this menuItem is a link, so we close all menus
	      setOpenMenuItems([]);
	      return;
	    }

	    var parentIds = getMenuItemsParentIds(menuItemId, flatMenuItems); // close all menus except parents, granparents ... etc. of menuitem

	    var nextOpenMenuItems = filter$3(openMenuItems).call(openMenuItems, function (it) {
	      return includes$6(parentIds).call(parentIds, it);
	    });

	    if (!menuItem.isOpen) {
	      nextOpenMenuItems.push(menuItemId);
	    }

	    setOpenMenuItems(nextOpenMenuItems);
	  }, [flatMenuItems, openMenuItems]);
	  var anyMenuItemsOpen = React.useMemo(function () {
	    return some$3(flatMenuItems).call(flatMenuItems, function (it) {
	      return it.isOpen;
	    });
	  }, [flatMenuItems]);
	  var breakpoint = React.useContext(BreakpointProvider.Context); // TODO combine mobileMenuOpen, searchOpen and openMenuItems into a single state?

	  var _useState3 = React.useState(false),
	      mobileMenuOpen = _useState3[0],
	      setMobileMenuOpen = _useState3[1];

	  var _useState4 = React.useState(false),
	      searchOpen = _useState4[0],
	      setSearchOpen = _useState4[1];

	  React.useEffect(function () {
	    // So every time we log in or log out, the login menu will close.
	    // TODO: Use a loggedIn callback for this?
	    setLoginMenuOpen(false);
	  }, [userMenu]);
	  React.useEffect(function () {
	    // TODO: How to test stuff that initiates in desktop sizes but only has side effects in mobile sizes?
	    //       The Breakpoint component doesn't render its contents at all when when outside the breakpoint boundaries.

	    /* istanbul ignore else */
	    if (anyMenuItemsOpen) {
	      setLoginMenuOpen(false);
	      setMobileMenuOpen(true);
	    } else {
	      if (includes$6(desktopBreakpoints).call(desktopBreakpoints, breakpoint)) {
	        setMobileMenuOpen(false);
	      }
	    }
	  }, [anyMenuItemsOpen]);
	  React.useEffect(function () {
	    if (mobileMenuOpen) {
	      setLoginMenuOpen(false);
	      setSearchOpen(false);
	    } else {
	      setOpenMenuItems([]);
	    }
	  }, [mobileMenuOpen]);
	  React.useEffect(function () {
	    if (searchOpen) {
	      setLoginMenuOpen(false);
	      setMobileMenuOpen(false);
	      setOpenMenuItems([]);
	    }
	  }, [searchOpen]);
	  React.useEffect(function () {
	    if (loginMenuOpen) {
	      setSearchOpen(false);
	      setMobileMenuOpen(false);
	      setOpenMenuItems([]);
	    }
	  }, [loginMenuOpen]);
	  /* istanbul ignore next */

	  React.useEffect(function () {
	    var shouldCloseMobileMenu = includes$6(desktopBreakpoints).call(desktopBreakpoints, breakpoint) && mobileMenuOpen && !anyMenuItemsOpen;

	    if (shouldCloseMobileMenu) {
	      setMobileMenuOpen(false);
	    }
	  }, [breakpoint]);
	  var shouldPreventScroll = loginMenuOpen || mobileMenuOpen || anyMenuItemsOpen || searchOpen;
	  usePreventScroll(shouldPreventScroll);
	  var userIconOrInitials = !!userMenu ? /*#__PURE__*/React__default['default'].createElement("span", {
	    "data-testid": "open-login",
	    className: styles$1m.navigation_userInitials
	  }, userMenu.userInitials.toUpperCase()) : /*#__PURE__*/React__default['default'].createElement(Icon, {
	    "data-testid": "open-login",
	    name: "end-user",
	    size: "lg",
	    color: "black",
	    url: loginPageUrlWithCurrentPageUrlAsRedirect()
	  });
	  var closeIcon = /*#__PURE__*/React__default['default'].createElement(Icon, {
	    "data-testid": "close-login",
	    name: "close",
	    size: "lg",
	    color: "black"
	  });
	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Backdrop, {
	    "data-testid": "backdrop",
	    isVisible: loginMenuOpen || mobileMenuOpen || anyMenuItemsOpen,
	    onCloseClick: function onCloseClick() {
	      setLoginMenuOpen(false);
	      setMobileMenuOpen(false);
	      setOpenMenuItems([]);
	    }
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1m.navigation, (_ref2 = {}, _ref2[styles$1m.navigation__mobileMenuOpen] = mobileMenuOpen, _ref2)],
	    backgroundColor: "white"
	  }, /*#__PURE__*/React__default['default'].createElement(MarginSpace, null, /*#__PURE__*/React__default['default'].createElement(Breakpoint, {
	    widerThan: "md"
	  }, /*#__PURE__*/React__default['default'].createElement(TopBar, {
	    segments: segments,
	    languages: languages,
	    linkAdapter: linkAdapter
	  })), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: styles$1m.navigation_mainContainer,
	    spaceBetween: true,
	    centeredVertically: true,
	    padding: {
	      vertical: 'sm'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, null, /*#__PURE__*/React__default['default'].createElement("a", {
	    href: logo.link,
	    className: styles$1m.navigation_logo,
	    "aria-label": logo.linkAriaLabel
	  }, /*#__PURE__*/React__default['default'].createElement(Logo, {
	    color: "purple500",
	    size: "xlg"
	  })), Boolean(menuItemShapeList.length) && /*#__PURE__*/React__default['default'].createElement(Breakpoint, {
	    widerThan: "md"
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    "data-testid": "desktop-menu-items",
	    className: [styles$1m.navigation_menuContainer, (_ref3 = {}, _ref3[styles$1m.navigation_menuContainer__slideHidden] = searchOpen, _ref3)]
	  }, /*#__PURE__*/React__default['default'].createElement(Menu, {
	    "data-testid": "desktop-menu-component",
	    menuItems: menuItemShapeList,
	    onMenuItemClick: onMenuItemClick,
	    linkAdapter: linkAdapter
	  })))), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, search && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1m.navigation_iconMenuItem
	  }, /*#__PURE__*/React__default['default'].createElement(Search, _extends_1({
	    "data-testid": "search-component",
	    isOpen: searchOpen,
	    onSearchToggle: function onSearchToggle() {
	      return setSearchOpen(!searchOpen);
	    }
	  }, search))), cart && /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1m.navigation_iconMenuItem
	  }, /*#__PURE__*/React__default['default'].createElement(Cart, cart)), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1m.navigation_containerLoginIcon
	  }, /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "button",
	    "data-testid": "login-icon",
	    className: styles$1m.navigation_containerLoginIcon__loginButton,
	    margin: {
	      left: 'sm'
	    },
	    backgroundColor: "white",
	    onClick: function onClick() {
	      if (!!userMenu) {
	        setLoginMenuOpen(!loginMenuOpen);
	      }
	    }
	  }, loginMenuOpen ? closeIcon : userIconOrInitials), !userMenu && /*#__PURE__*/React__default['default'].createElement(Breakpoint, {
	    widerThan: "md"
	  }, /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "a",
	    className: styles$1m.navigation_containerLoginIcon__loginText,
	    href: loginPageUrlWithCurrentPageUrlAsRedirect(),
	    color: "black",
	    padding: {
	      left: 'xxs'
	    }
	  }, "Kirjaudu"))), /*#__PURE__*/React__default['default'].createElement(Breakpoint, {
	    narrowerThan: "md"
	  }, /*#__PURE__*/React__default['default'].createElement(Element$2, {
	    tagName: "button",
	    "data-testid": "hamburger",
	    onClick: function onClick() {
	      return setMobileMenuOpen(!mobileMenuOpen);
	    },
	    className: classnames(styles$1m.navigation_iconMenuItem, styles$1m.navigation_hamburger, (_classnames = {}, _classnames[styles$1m.navigation_hamburger__active] = mobileMenuOpen, _classnames))
	  }, /*#__PURE__*/React__default['default'].createElement("span", null), /*#__PURE__*/React__default['default'].createElement("span", null), /*#__PURE__*/React__default['default'].createElement("span", null), /*#__PURE__*/React__default['default'].createElement("span", null))))))), /*#__PURE__*/React__default['default'].createElement(Breakpoint, {
	    narrowerThan: "md"
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1m.navigation_mobileMenuContainer
	  }, /*#__PURE__*/React__default['default'].createElement(Drawer, {
	    "data-testid": "mobile-menu",
	    isOpen: mobileMenuOpen,
	    showBackdrop: false,
	    onCloseClick: function onCloseClick() {
	      return setMobileMenuOpen(false);
	    },
	    automaticScrollPrevention: false
	  }, segments && /*#__PURE__*/React__default['default'].createElement(Div, {
	    backgroundColor: "white",
	    className: styles$1m.navigation_segmentLinksContainer
	  }, /*#__PURE__*/React__default['default'].createElement(MarginSpace, null, /*#__PURE__*/React__default['default'].createElement(SiteLinks, {
	    className: styles$1m.navigation_segmentLinks,
	    "data-testid": "segment-site-links",
	    links: segments,
	    alignBottom: true,
	    linkAdapter: linkAdapter
	  }))), Boolean(menuItemShapeList.length) && /*#__PURE__*/React__default['default'].createElement(Div, {
	    "data-testid": "mobile-menu-items",
	    className: styles$1m.navigation_menuContainer
	  }, /*#__PURE__*/React__default['default'].createElement(Menu, {
	    "data-testid": "mobile-menu-component",
	    menuItems: menuItemShapeList,
	    onMenuItemClick: onMenuItemClick,
	    forMobile: true,
	    linkAdapter: linkAdapter
	  })), languages && /*#__PURE__*/React__default['default'].createElement(Div, {
	    backgroundColor: "gray200"
	  }, /*#__PURE__*/React__default['default'].createElement(MarginSpace, null, /*#__PURE__*/React__default['default'].createElement(SiteLinks, {
	    className: styles$1m.navigation_languageLinks,
	    "data-testid": "language-site-links",
	    links: languages,
	    desktopStylesInMobile: true,
	    centeredVertically: true,
	    linkAdapter: linkAdapter
	  })))))), !!userMenu ? /*#__PURE__*/React__default['default'].createElement(MarginSpace, {
	    className: styles$1m.navigation_loggedInContainer
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1m.navigation_loggedInDrawerContainer
	  }, /*#__PURE__*/React__default['default'].createElement(Drawer, {
	    backgroundColor: "white",
	    "data-testid": "logged-in-menu",
	    isOpen: loginMenuOpen,
	    showBackdrop: false,
	    onCloseClick: function onCloseClick() {
	      return setLoginMenuOpen(false);
	    },
	    automaticScrollPrevention: false
	  }, /*#__PURE__*/React__default['default'].createElement(UserMenu, {
	    username: userMenu.username,
	    userloginHistoryKey: userMenu.userloginHistoryKey,
	    userloginHistory: userMenu.userloginHistory,
	    userloginHistoryLink: userMenu.userloginHistoryLink,
	    userMenuLinks: userMenu.userMenuLinks,
	    logoutButton: {
	      logoutButtonLabel: userMenu.logoutButtonLabel,
	      onLogoutButtonClick: function onLogoutButtonClick() {
	        login.onLogout();
	        setLoginMenuOpen(false);
	      }
	    },
	    additionalLinks: userMenu.additionalLinks,
	    additionalLinkAlignLeft: userMenu.additionalLinkAlignLeft
	  })))) : /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1m.navigation_loggedOutContainer
	  }, /*#__PURE__*/React__default['default'].createElement(Drawer, {
	    "data-testid": "login-menu",
	    isOpen: loginMenuOpen,
	    showBackdrop: false,
	    onCloseClick: function onCloseClick() {
	      return setLoginMenuOpen(false);
	    },
	    automaticScrollPrevention: false
	  }, /*#__PURE__*/React__default['default'].createElement(Login, login))));
	};

	var styles$1n = {"tupasLogin_inlineNotification":"telia-react-tupasLogin_inlineNotification"};

	var TupasLogin = function TupasLogin(_ref) {
	  var loginButtonLabel = _ref.loginButtonLabel,
	      onLoginButtonClick = _ref.onLoginButtonClick,
	      description = _ref.description,
	      highlightedInfoText = _ref.highlightedInfoText;

	  var _useState = React.useState(true),
	      showInlineNotification = _useState[0],
	      setShowInlineNotification = _useState[1];

	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      vertical: 'lg'
	    }
	  }, description && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(BodyText, null, /*#__PURE__*/React__default['default'].createElement(Div, {
	    "data-testid": "tupas-login-description-text",
	    dangerouslySetInnerHTML: {
	      __html: description
	    }
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  })), /*#__PURE__*/React__default['default'].createElement(Button, {
	    "data-testid": "tupas-login-button",
	    variant: "primary",
	    onClick: function onClick() {
	      return onLoginButtonClick();
	    },
	    size: "md",
	    iconName: "chevron-right",
	    iconOnRight: true
	  }, loginButtonLabel), showInlineNotification && highlightedInfoText && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "lg"
	  }), /*#__PURE__*/React__default['default'].createElement(InlineNotification, {
	    "data-testid": "tupas-login-highlighted-info-message",
	    variant: "information",
	    closeOnClick: function closeOnClick() {
	      setShowInlineNotification(false);
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1n.tupasLogin_inlineNotification,
	    dangerouslySetInnerHTML: {
	      __html: highlightedInfoText
	    }
	  }))));
	};

	var styles$1o = {"credentialsLogin_form":"telia-react-credentialsLogin_form","credentialsLogin_passwordContainer":"telia-react-credentialsLogin_passwordContainer","credentialsLogin_passwordTooltip":"telia-react-credentialsLogin_passwordTooltip","credentialsLogin_tooltipIcon":"telia-react-credentialsLogin_tooltipIcon","credentialsLogin_iconUrlLinkContent":"telia-react-credentialsLogin_iconUrlLinkContent","credentialsLogin_inlineNotification":"telia-react-credentialsLogin_inlineNotification"};

	var CredentialsLogin = function CredentialsLogin(_ref) {
	  var description = _ref.description,
	      password = _ref.password,
	      username = _ref.username,
	      loginButton = _ref.loginButton,
	      strongAuthentication = _ref.strongAuthentication,
	      register = _ref.register,
	      errorMessage = _ref.errorMessage,
	      highlightedInfoText = _ref.highlightedInfoText;

	  var _useState = React.useState(false),
	      loading = _useState[0],
	      setLoading = _useState[1];

	  var _useState2 = React.useState(true),
	      showInlineNotification = _useState2[0],
	      setShowInlineNotification = _useState2[1];

	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      top: 'lg'
	    }
	  }, description && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(BodyText, null, /*#__PURE__*/React__default['default'].createElement(Div, {
	    "data-testid": "credentials-login-description-text",
	    dangerouslySetInnerHTML: {
	      __html: description
	    }
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  })), errorMessage && /*#__PURE__*/React__default['default'].createElement(Div, {
	    padding: {
	      bottom: 'md'
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(InlineNotification, {
	    "data-testid": "credentials-login-error-message",
	    title: errorMessage,
	    variant: "warning"
	  })), /*#__PURE__*/React__default['default'].createElement("div", {
	    className: styles$1o.credentialsLogin_form
	  }, /*#__PURE__*/React__default['default'].createElement(Input, _extends_1({}, username, {
	    "data-testid": "credentials-login-username-input",
	    value: username.value,
	    label: username.label,
	    name: "username",
	    type: "text",
	    onChange: function onChange(e) {
	      return username.onChange(e.target.value);
	    },
	    placeholder: username.label,
	    autocomplete: "off"
	  })), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  }), /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1o.credentialsLogin_passwordContainer
	  }, password.tooltip && /*#__PURE__*/React__default['default'].createElement(Tooltip$2, {
	    overlayClassName: styles$1o.credentialsLogin_passwordTooltip,
	    trigger: "click",
	    placement: "topCenter",
	    tooltipContent: /*#__PURE__*/React__default['default'].createElement(BodyText, {
	      tagName: "span",
	      size: "xs",
	      color: "white"
	    }, password.tooltip)
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    className: styles$1o.credentialsLogin_tooltipIcon,
	    name: "info",
	    size: "sm",
	    color: "purple500"
	  })), /*#__PURE__*/React__default['default'].createElement(Input, _extends_1({}, password, {
	    "data-testid": "credentials-login-password-input",
	    value: password.value,
	    name: "password",
	    label: password.label,
	    type: "password",
	    onChange: function onChange(e) {
	      return password.onChange(e.target.value);
	    },
	    placeholder: password.label,
	    autocomplete: "off"
	  }))), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "lg"
	  }), /*#__PURE__*/React__default['default'].createElement(Button, {
	    "data-testid": "credentials-login-button",
	    variant: "primary",
	    onClick: function onClick() {
	      //  TODO: There is no way to set loading to false when an error occurs for example.
	      setLoading(true);
	      loginButton.onClick();
	    },
	    size: "md",
	    iconName: "chevron-right",
	    iconOnRight: true,
	    loading: loading
	  }, loginButton.label), showInlineNotification && highlightedInfoText && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "lg"
	  }), /*#__PURE__*/React__default['default'].createElement(InlineNotification, {
	    "data-testid": "credentials-login-highlighted-info-message",
	    variant: "information",
	    closeOnClick: function closeOnClick() {
	      setShowInlineNotification(false);
	    }
	  }, /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1o.credentialsLogin_inlineNotification,
	    dangerouslySetInnerHTML: {
	      __html: highlightedInfoText
	    }
	  }))), (password.reset || strongAuthentication || register) && /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "lg"
	  }), password.reset && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Link, {
	    to: password.reset.url
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: styles$1o.credentialsLogin_iconUrlLinkContent
	  }, password.reset.url && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "lock-closed",
	    size: "md",
	    color: "black"
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  })), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, password.reset.label))), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  })), register && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Link, {
	    to: register.url
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    className: styles$1o.credentialsLogin_iconUrlLinkContent
	  }, register.url && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: "register",
	    size: "md",
	    color: "black"
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "xs"
	  })), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, register.label))), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  }))));
	};

	var floor$3 = Math.floor;
	var replace$1 = ''.replace;
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

	// https://tc39.es/ecma262/#sec-getsubstitution
	var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject$2(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }
	  return replace$1.call(replacement, symbols, function (match, ch) {
	    var capture;
	    switch (ch.charAt(0)) {
	      case '$': return '$';
	      case '&': return matched;
	      case '`': return str.slice(0, position);
	      case "'": return str.slice(tailPos);
	      case '<':
	        capture = namedCaptures[ch.slice(1, -1)];
	        break;
	      default: // \d\d?
	        var n = +ch;
	        if (n === 0) return match;
	        if (n > m) {
	          var f = floor$3(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	          return match;
	        }
	        capture = captures[n - 1];
	    }
	    return capture === undefined ? '' : capture;
	  });
	};

	var max$3 = Math.max;
	var min$5 = Math.min;

	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};

	// @@replace logic
	fixRegexpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
	  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
	  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

	  return [
	    // `String.prototype.replace` method
	    // https://tc39.es/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = requireObjectCoercible$1(this);
	      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return replacer !== undefined
	        ? replacer.call(searchValue, O, replaceValue)
	        : nativeReplace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      if (
	        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
	        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
	      ) {
	        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
	        if (res.done) return res.value;
	      }

	      var rx = anObject$1(regexp);
	      var S = String(this);

	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);

	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regexpExecAbstract(rx, S);
	        if (result === null) break;

	        results.push(result);
	        if (!global) break;

	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
	      }

	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];

	        var matched = String(result[0]);
	        var position = max$3(min$5(toInteger$1(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	});

	var styles$1p = {"productCard":"telia-react-productCard","productCard_panel":"telia-react-productCard_panel","productCard_tag":"telia-react-productCard_tag","productCard_image":"telia-react-productCard_image","productCard_imageContainer":"telia-react-productCard_imageContainer","productCard_title":"telia-react-productCard_title","productCard_rating":"telia-react-productCard_rating","smallText__size_md":"telia-react-smallText__size_md","productCard_listContent":"telia-react-productCard_listContent","productCard_description":"telia-react-productCard_description","smallText__size_sm":"telia-react-smallText__size_sm","list_item":"telia-react-list_item"};

	var styles$1q = {"cardPrice_prefix":"telia-react-cardPrice_prefix","cardPrice_priceVariation":"telia-react-cardPrice_priceVariation","cardPrice_priceValue":"telia-react-cardPrice_priceValue","cardPrice_normalPrice":"telia-react-cardPrice_normalPrice"};

	var _excluded$1x = ["loading", "value", "unit", "normalPrice", "priceVariation", "prefix"];

	var CardPrice = function CardPrice(_ref) {
	  var loading = _ref.loading,
	      value = _ref.value,
	      _ref$unit = _ref.unit,
	      unit = _ref$unit === void 0 ? '€' : _ref$unit,
	      normalPrice = _ref.normalPrice,
	      priceVariation = _ref.priceVariation,
	      prefix = _ref.prefix,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1x);

	  if (loading) {
	    return /*#__PURE__*/React__default['default'].createElement(Skeleton, {
	      width: 100,
	      height: "sm"
	    });
	  }

	  return /*#__PURE__*/React__default['default'].createElement(Element$2, _extends_1({
	    tagName: "footer"
	  }, props, {
	    className: styles$1q.cardPrice
	  }), prefix && /*#__PURE__*/React__default['default'].createElement(Typography, {
	    tagName: "div",
	    color: "black",
	    className: styles$1q.cardPrice_prefix
	  }, prefix), /*#__PURE__*/React__default['default'].createElement(Div, {
	    occupyHorizontalSpace: true
	  }, /*#__PURE__*/React__default['default'].createElement(Flex, null, /*#__PURE__*/React__default['default'].createElement(PricingText, {
	    size: "sm",
	    color: "black",
	    className: styles$1q.cardPrice_priceValue
	  }, value, " ", unit), normalPrice && /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    className: styles$1q.cardPrice_normalPrice,
	    color: "gray500"
	  }, normalPrice.prefix ? normalPrice.prefix : 'norm.', ' ', normalPrice.value, normalPrice.postfix))), typeof priceVariation === 'string' ? /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    className: styles$1q.cardPrice_priceVariation,
	    color: "black"
	  }, priceVariation) : priceVariation);
	};

	var styles$1r = {"cardInfo":"telia-react-cardInfo","smallText__size_sm":"telia-react-smallText__size_sm","cardInfo_productNumber":"telia-react-cardInfo_productNumber"};

	// Calculate HSL luminance: https://www.niwa.nu/2013/05/math-behind-colorspace-conversions-rgb-hsl/
	var calculateLuminance = function calculateLuminance(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b;
	  r /= 255;
	  g /= 255;
	  b /= 255;
	  return (Math.max(r, g, b) + Math.min(r, g, b)) / 2;
	};

	// @@match logic
	fixRegexpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.es/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = requireObjectCoercible$1(this);
	      var matcher = regexp == undefined ? undefined : regexp[MATCH];
	      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative(nativeMatch, regexp, this);
	      if (res.done) return res.value;

	      var rx = anObject$1(regexp);
	      var S = String(this);

	      if (!rx.global) return regexpExecAbstract(rx, S);

	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regexpExecAbstract(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});

	// a string of all valid unicode whitespaces
	var whitespaces$1 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var replace$2 = functionUncurryThis(''.replace);
	var whitespace$1 = '[' + whitespaces$1 + ']';
	var ltrim$1 = RegExp('^' + whitespace$1 + whitespace$1 + '*');
	var rtrim$1 = RegExp(whitespace$1 + whitespace$1 + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

	var createMethod$8 = function (TYPE) {
	  return function ($this) {
	    var string = toString$2(requireObjectCoercible($this));
	    if (TYPE & 1) string = replace$2(string, ltrim$1, '');
	    if (TYPE & 2) string = replace$2(string, rtrim$1, '');
	    return string;
	  };
	};

	var stringTrim$1 = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod$8(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod$8(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod$8(3)
	};

	var trim$1 = stringTrim$1.trim;



	var $parseInt = global$1.parseInt;
	var Symbol$5 = global$1.Symbol;
	var ITERATOR$5 = Symbol$5 && Symbol$5.iterator;
	var hex = /^[+-]?0x/i;
	var exec$1 = functionUncurryThis(hex.exec);
	var FORCED$4 = $parseInt(whitespaces$1 + '08') !== 8 || $parseInt(whitespaces$1 + '0x16') !== 22 // MS Edge 18- broken with boxed symbols
	|| ITERATOR$5 && !fails(function () {
	  $parseInt(Object(ITERATOR$5));
	}); // `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix

	var numberParseInt = FORCED$4 ? function parseInt(string, radix) {
	  var S = trim$1(toString$2(string));
	  return $parseInt(S, radix >>> 0 || (exec$1(hex, S) ? 16 : 10));
	} : $parseInt;

	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix


	_export({
	  global: true,
	  forced: parseInt != numberParseInt
	}, {
	  parseInt: numberParseInt
	});

	var _parseInt = path.parseInt;

	var _parseInt$1 = _parseInt;

	var _parseInt$2 = _parseInt$1;

	var hexToRgb = function hexToRgb(hexColor) {
	  var _context, _context2;

	  // convert short hex color to long format, #abc -> #aabbcc
	  hexColor = hexColor.replace(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i, '#$1$1$2$2$3$3');

	  var _slice$map = map$3(_context = slice$3(_context2 = hexColor.match(/#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i) || []).call(_context2, 1)).call(_context, function (color) {
	    return _parseInt$2(color, 16);
	  }),
	      _slice$map$ = _slice$map[0],
	      r = _slice$map$ === void 0 ? 0 : _slice$map$,
	      _slice$map$2 = _slice$map[1],
	      g = _slice$map$2 === void 0 ? 0 : _slice$map$2,
	      _slice$map$3 = _slice$map[2],
	      b = _slice$map$3 === void 0 ? 0 : _slice$map$3;

	  return {
	    r: r,
	    g: g,
	    b: b
	  };
	};

	var styles$1s = {"cardColorVariants_container":"telia-react-cardColorVariants_container","cardColorVariants_dot":"telia-react-cardColorVariants_dot","cardColorVariants_dot__withBorder":"telia-react-cardColorVariants_dot__withBorder"};

	var borderThreshold = calculateLuminance(hexToRgb('#eeeeee'));

	var VariantDot = function VariantDot(_ref) {
	  var _ref2;

	  var color = _ref.color;
	  var rgbColor = hexToRgb(color);
	  var showBorder = calculateLuminance(rgbColor) >= borderThreshold;
	  return /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: [styles$1s.cardColorVariants_dot, (_ref2 = {}, _ref2[styles$1s.cardColorVariants_dot__withBorder] = showBorder, _ref2)],
	    style: {
	      backgroundColor: color
	    }
	  });
	};

	var CardColorVariants = function CardColorVariants(_ref3) {
	  var colorVariants = _ref3.colorVariants;
	  var hasMany = colorVariants.length > 4;
	  var visibleVariants = hasMany ? slice$3(colorVariants).call(colorVariants, 0, 3) : colorVariants;
	  var hiddenVariantCount = colorVariants.length - visibleVariants.length;
	  return /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true,
	    className: styles$1s.cardColorVariants_container
	  }, map$3(visibleVariants).call(visibleVariants, function (colorVariant, i) {
	    return /*#__PURE__*/React__default['default'].createElement(VariantDot, {
	      key: i,
	      color: colorVariant
	    });
	  }), hasMany && /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    color: "gray500",
	    size: "sm"
	  }, "+", hiddenVariantCount)));
	};

	var _excluded$1y = ["rating", "productNumber", "colorVariants", "className"];

	var CardInfo = function CardInfo(_ref) {
	  var rating = _ref.rating,
	      productNumber = _ref.productNumber,
	      colorVariants = _ref.colorVariants,
	      className = _ref.className,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1y);

	  return /*#__PURE__*/React__default['default'].createElement(Flex, _extends_1({
	    className: [styles$1r.cardInfo, className],
	    alignBaseline: true,
	    spaceBetween: true,
	    occupyVerticalSpace: false
	  }, props), rating !== undefined && /*#__PURE__*/React__default['default'].createElement(Div, null, /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    margin: {
	      right: 'xxs'
	    },
	    name: "star",
	    color: rating ? 'orange500' : 'gray400',
	    size: "xs"
	  }), /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    className: styles$1r.cardInfo_text,
	    size: "sm",
	    color: "gray500"
	  }, rating || '-'))), colorVariants && /*#__PURE__*/React__default['default'].createElement(CardColorVariants, {
	    colorVariants: colorVariants
	  }), productNumber && !colorVariants && /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    size: "sm",
	    color: "gray500",
	    className: styles$1r.cardInfo_productNumber
	  }, productNumber));
	};

	var styles$1t = {"cardTag":"telia-react-cardTag","cardTag_text":"telia-react-cardTag_text","cardTag__hidden":"telia-react-cardTag__hidden"};

	var CardTag = function CardTag(_ref) {
	  var _ref2;

	  var _ref$color = _ref.color,
	      color = _ref$color === void 0 ? 'orange400' : _ref$color,
	      children = _ref.children,
	      hidden = _ref.hidden,
	      className = _ref.className;
	  var classNames = [styles$1t.cardTag, className, (_ref2 = {}, _ref2[styles$1t.cardTag__hidden] = hidden, _ref2)];
	  return /*#__PURE__*/React__default['default'].createElement(Span, {
	    className: classNames,
	    borderRadius: {
	      size: 'sm',
	      top: false
	    },
	    backgroundColor: color,
	    padding: {
	      vertical: 'xxxs',
	      horizontal: 'xs'
	    },
	    forceWrap: true
	  }, /*#__PURE__*/React__default['default'].createElement(Typography, {
	    font: "teliasans",
	    className: styles$1t.cardTag_text,
	    uppercase: true,
	    fontWeight: "medium",
	    color: color === 'orange400' ? 'orange800' : 'white',
	    block: true
	  }, children));
	};

	var _excluded$1z = ["titleText", "productNumber", "descriptionText", "listContent", "priceContent", "imageSrc", "imageComponent", "tagText", "tagColor", "className", "wrapper", "rating", "colorVariants"];

	var ProductCard = function ProductCard(_ref) {
	  var titleText = _ref.titleText,
	      productNumber = _ref.productNumber,
	      descriptionText = _ref.descriptionText,
	      listContent = _ref.listContent,
	      priceContent = _ref.priceContent,
	      imageSrc = _ref.imageSrc,
	      imageComponent = _ref.imageComponent,
	      tagText = _ref.tagText,
	      tagColor = _ref.tagColor,
	      className = _ref.className,
	      _ref$wrapper = _ref.wrapper,
	      Wrapper = _ref$wrapper === void 0 ? Link : _ref$wrapper,
	      rating = _ref.rating,
	      colorVariants = _ref.colorVariants,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1z);

	  return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends_1({
	    className: classnames([styles$1p.productCard, className])
	  }, props), /*#__PURE__*/React__default['default'].createElement(Panel, {
	    className: styles$1p.productCard_panel,
	    hoverBoxShadow: "md",
	    occupyHorizontalSpace: true,
	    tagName: "article"
	  }, /*#__PURE__*/React__default['default'].createElement(CardTag, {
	    color: tagColor,
	    className: styles$1p.productCard_tag,
	    hidden: !tagText
	  }, tagText != null ? tagText : ''), imageComponent ? /*#__PURE__*/React__default['default'].createElement(Div, {
	    className: styles$1p.productCard_imageContainer
	  }, imageComponent) : /*#__PURE__*/React__default['default'].createElement("img", {
	    loading: "lazy",
	    src: imageSrc,
	    alt: titleText,
	    className: styles$1p.productCard_image
	  }), /*#__PURE__*/React__default['default'].createElement(Title, {
	    block: true,
	    color: "black",
	    hideOverflow: true,
	    tagName: "h1",
	    className: styles$1p.productCard_title
	  }, titleText), (rating || productNumber || colorVariants) && /*#__PURE__*/React__default['default'].createElement(CardInfo, {
	    className: styles$1p.productCard_rating,
	    productNumber: productNumber,
	    rating: rating,
	    colorVariants: colorVariants
	  }), listContent ? /*#__PURE__*/React__default['default'].createElement(List, {
	    className: styles$1p.productCard_listContent,
	    disc: true
	  }, map$3(listContent).call(listContent, function (listItem) {
	    return /*#__PURE__*/React__default['default'].createElement(List.Item, {
	      key: listItem.replace(/[^\w\s]/gi, '').replace(/\s/gi, '-')
	    }, listItem);
	  })) : /*#__PURE__*/React__default['default'].createElement(SmallText, {
	    className: styles$1p.productCard_description,
	    tagName: "p",
	    block: true,
	    color: "black"
	  }, descriptionText), priceContent && /*#__PURE__*/React__default['default'].createElement(ProductCard.Price, priceContent)));
	};

	ProductCard.Price = CardPrice;

	var styles$1u = {"sideNavigationItem":"telia-react-sideNavigationItem","sideNavigationItem__active":"telia-react-sideNavigationItem__active","sideNavigationItem_subItems":"telia-react-sideNavigationItem_subItems","sideNavigationItem_subItems__withoutIcon":"telia-react-sideNavigationItem_subItems__withoutIcon"};

	var styles$1v = {"sideNavigationSubItem":"telia-react-sideNavigationSubItem","sideNavigationSubItem__active":"telia-react-sideNavigationSubItem__active"};

	var _excluded$1A = ["label", "active", "onClick"];

	var SideNavigationSubItem = function SideNavigationSubItem(_ref) {
	  var _ref2;

	  var label = _ref.label,
	      active = _ref.active,
	      onClick = _ref.onClick,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1A);

	  var onKeyDown = function onKeyDown(event) {
	    if (event.key === 'Enter' && onClick) {
	      onClick();
	      event.preventDefault();
	    }
	  };

	  return /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: ['side-navigation-test', styles$1v.sideNavigationSubItem, (_ref2 = {}, _ref2[styles$1v.sideNavigationSubItem__active] = active, _ref2)],
	    hoverColor: "purple500",
	    padding: {
	      size: 'xs',
	      left: 'sm'
	    },
	    margin: {
	      bottom: 'sm'
	    },
	    clickableAppearance: true,
	    tabIndex: 0,
	    onClick: onClick,
	    onKeyDown: onKeyDown
	  }, props), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span"
	  }, label));
	};

	var _excluded$1B = ["iconName", "label", "active", "onClick", "subItems", "className", "isOpen"],
	    _excluded2$3 = ["label", "active", "onClick"];

	var SideNavigationItem = function SideNavigationItem(_ref) {
	  var _ref2, _ref3;

	  var iconName = _ref.iconName,
	      label = _ref.label,
	      active = _ref.active,
	      onClick = _ref.onClick,
	      subItems = _ref.subItems,
	      className = _ref.className,
	      _ref$isOpen = _ref.isOpen,
	      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1B);

	  var onKeyDown = function onKeyDown(event) {
	    if (event.key === 'Enter' && onClick) {
	      onClick();
	      event.preventDefault();
	    }
	  };

	  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Div, _extends_1({
	    className: ['side-navigation-test', styles$1u.sideNavigationItem, (_ref2 = {}, _ref2[styles$1u.sideNavigationItem__active] = active, _ref2.className = className, _ref2)],
	    margin: {
	      bottom: 'sm'
	    },
	    hoverColor: "purple500",
	    padding: {
	      size: 'xs',
	      left: 'sm'
	    },
	    clickableAppearance: true,
	    tabIndex: 0,
	    onClick: onClick,
	    onKeyDown: onKeyDown
	  }, props), /*#__PURE__*/React__default['default'].createElement(Flex, {
	    centeredVertically: true
	  }, iconName && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Icon, {
	    size: "md",
	    name: iconName
	  }), /*#__PURE__*/React__default['default'].createElement(Gutter, {
	    size: "md"
	  })), /*#__PURE__*/React__default['default'].createElement(BodyText, {
	    tagName: "span",
	    fontWeight: "medium"
	  }, label), subItems && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Div, {
	    flexItem: true
	  }), /*#__PURE__*/React__default['default'].createElement(Icon, {
	    name: isOpen ? 'chevron-up' : 'chevron-down',
	    size: "md"
	  })))), subItems && isOpen && /*#__PURE__*/React__default['default'].createElement(Div, {
	    margin: {
	      bottom: 'sm'
	    },
	    className: [styles$1u.sideNavigationItem_subItems, (_ref3 = {}, _ref3[styles$1u.sideNavigationItem_subItems__withoutIcon] = !iconName, _ref3)]
	  }, map$3(subItems).call(subItems, function (_ref4) {
	    var label = _ref4.label,
	        subActive = _ref4.active,
	        onClick = _ref4.onClick,
	        props = objectWithoutPropertiesLoose(_ref4, _excluded2$3);

	    return /*#__PURE__*/React__default['default'].createElement(SideNavigationSubItem, _extends_1({
	      label: label,
	      active: subActive,
	      onClick: onClick
	    }, props));
	  })));
	};

	var _excluded$1C = ["navigationItems"],
	    _excluded2$4 = ["iconName", "label", "subItems", "onClick", "active"];

	var SideNavigation = function SideNavigation(_ref) {
	  var navigationItems = _ref.navigationItems,
	      props = objectWithoutPropertiesLoose(_ref, _excluded$1C);

	  return /*#__PURE__*/React__default['default'].createElement(Div, props, map$3(navigationItems).call(navigationItems, function (_ref2) {
	    var iconName = _ref2.iconName,
	        label = _ref2.label,
	        subItems = _ref2.subItems,
	        onClick = _ref2.onClick,
	        active = _ref2.active,
	        props = objectWithoutPropertiesLoose(_ref2, _excluded2$4);

	    return /*#__PURE__*/React__default['default'].createElement(SideNavigationItem, _extends_1({
	      iconName: iconName,
	      label: label,
	      onClick: onClick,
	      active: active,
	      subItems: subItems
	    }, props));
	  }));
	};

	SideNavigation.Item = SideNavigationItem;

	exports.Accordion = Accordion;
	exports.AccordionStateless = AccordionStateless;
	exports.Autocomplete = Autocomplete;
	exports.AvailabilityIndicator = AvailabilityIndicator;
	exports.Backdrop = Backdrop;
	exports.BackgroundImage = BackgroundImage;
	exports.BodyText = BodyText;
	exports.Breadcrumb = Breadcrumb;
	exports.Breakpoint = Breakpoint;
	exports.BreakpointProvider = BreakpointProvider;
	exports.Button = Button;
	exports.Checkbox = Checkbox;
	exports.CollapsibleBlock = CollapsibleBlock;
	exports.CollapsibleBlockList = CollapsibleBlockList;
	exports.ColorDot = ColorDot;
	exports.Combobox = Combobox;
	exports.ComposableTabs = ComposableTabs;
	exports.CredentialsLogin = CredentialsLogin;
	exports.DatePicker = DatePicker;
	exports.DatePickerWithRange = DatePickerWithRange;
	exports.Div = Div;
	exports.Divider = Divider;
	exports.Drawer = Drawer;
	exports.Dropdown = Dropdown;
	exports.DropdownMultiselect = DropdownMultiselect;
	exports.Element = Element$2;
	exports.FileUploader = FileUploader;
	exports.FileUploaderContainer = FileUploaderContainer;
	exports.FilterChip = FilterChip;
	exports.Flex = Flex;
	exports.Footer = Footer;
	exports.GridBag = GridBag;
	exports.GrowlNotification = GrowlNotification;
	exports.Gutter = Gutter;
	exports.GutterBag = GutterBag;
	exports.Headline = Headline;
	exports.HeroBannerLayout = HeroBannerLayout;
	exports.Icon = Icon;
	exports.Image = Image;
	exports.ImageCarousel = ImageCarousel;
	exports.Ingress = Ingress;
	exports.InlineNotification = InlineNotification;
	exports.Input = Input;
	exports.Link = Link;
	exports.LinkAdapterProvider = LinkAdapterProvider;
	exports.LinkList = LinkList;
	exports.List = List;
	exports.Loader = Loader;
	exports.Logo = Logo;
	exports.MarginSpace = MarginSpace;
	exports.ModalDialog = ModalDialog;
	exports.Navigation = Navigation;
	exports.OptionList = OptionList;
	exports.OverflowMenu = OverflowMenu;
	exports.Page = Page;
	exports.Pagination = Pagination;
	exports.Panel = Panel;
	exports.PhoneNumberInput = PhoneNumberInput;
	exports.PopOnHover = PopOnHover;
	exports.Price = Price;
	exports.PricingText = PricingText;
	exports.ProductCard = ProductCard;
	exports.ProgressBar = ProgressBar;
	exports.QuantitySelector = QuantitySelector;
	exports.RadioButton = RadioButton;
	exports.RangeSlider = RangeSlider;
	exports.SearchInput = SearchInput;
	exports.SearchInputWithScope = SearchInputWithScope;
	exports.SelectionButton = SelectionButton;
	exports.SelectionButtonGroup = SelectionButtonGroup;
	exports.SideNavigation = SideNavigation;
	exports.Skeleton = Skeleton;
	exports.SmallText = SmallText;
	exports.Span = Span;
	exports.Step = Step;
	exports.Stepper = Stepper;
	exports.Steps = Steps;
	exports.Switch = Switch;
	exports.Table = Table;
	exports.Tabs = Tabs;
	exports.Tag = Tag;
	exports.TagText = TagText;
	exports.TextArea = TextArea;
	exports.TextLink = TextLink;
	exports.Title = Title;
	exports.Tooltip = Tooltip$2;
	exports.TupasLogin = TupasLogin;
	exports.UserDropdown = UserDropdown;
	exports.backgroundColors = backgroundColors;
	exports.growlPositions = growlPositions;
	exports.growlVariants = growlVariants;
	exports.limitItems = limitItems;
	exports.mapVariant = mapVariant;
	exports.notificationVariants = notificationVariants;
	exports.placementOptions = placementOptions;
	exports.queueToFiles = queueToFiles;
	exports.responsiveSupportedSizes = responsiveSupportedSizes;
	exports.supportedBodyTextSizes = supportedBodyTextSizes;
	exports.supportedButtonSizes = supportedButtonSizes;
	exports.supportedButtonVariants = supportedButtonVariants;
	exports.supportedColors = supportedColors;
	exports.supportedDividerColors = supportedDividerColors;
	exports.supportedFontWeights = supportedFontWeights;
	exports.supportedGutterSizes = supportedGutterSizes;
	exports.supportedHeadlineColors = supportedHeadlineColors;
	exports.supportedHeadlineSizes = supportedHeadlineSizes;
	exports.supportedIconNames = supportedIconNames;
	exports.supportedIconSizes = supportedIconSizes;
	exports.supportedIngressColors = supportedIngressColors;
	exports.supportedIngressSizes = supportedIngressSizes;
	exports.supportedInputTypes = supportedInputTypes;
	exports.supportedLoaderSizes = supportedLoaderSizes;
	exports.supportedLogoSizes = supportedLogoSizes;
	exports.supportedModalSizes = supportedModalSizes;
	exports.supportedPriceSizes = supportedPriceSizes;
	exports.supportedPricingTextSizes = supportedPricingTextSizes;
	exports.supportedProgressBarColors = supportedProgressBarColors;
	exports.supportedSizes = supportedSizes;
	exports.supportedSmallTextSizes = supportedSmallTextSizes;
	exports.supportedTagColors = supportedTagColors;
	exports.supportedTagTextSizes = supportedTagTextSizes;
	exports.supportedTextLinkColors = supportedTextLinkColors;
	exports.supportedTextLinkSizes = supportedTextLinkSizes;
	exports.supportedTitleSizes = supportedTitleSizes;
	exports.triggerOptions = triggerOptions;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
